
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6807"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6807"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4UX9c", function(module, exports) {
/*$AMPERSAND_VERSION*/ 
var $9jqvh = parcelRequire("9jqvh");

var $7ttD4 = parcelRequire("7ttD4");

var $akRxj = parcelRequire("akRxj");
// instance app, can be used just by itself
// or by calling as function to pass labels
// by attaching all instances to this, we can
// avoid globals
var $394a45d57ea7d178$var$app = {
    extend: function() {
        var args = $7ttD4(arguments);
        args.unshift(this);
        return $akRxj.apply(null, args);
    },
    reset: function() {
        // clear all events
        this.off();
        // remove all but main two methods
        for(var item in this)if (item !== 'extend' && item !== 'reset') delete this[item];
        // remix events
        $9jqvh.createEmitter(this);
    }
};
$9jqvh.createEmitter($394a45d57ea7d178$var$app);
// export our singleton
module.exports = $394a45d57ea7d178$var$app;

});
parcelRegister("9jqvh", function(module, exports) {
/*$AMPERSAND_VERSION*/ 
var $2tU91 = parcelRequire("2tU91");

var $6ZxOb = parcelRequire("6ZxOb");

var $1ucn8 = parcelRequire("1ucn8");

var $akRxj = parcelRequire("akRxj");

var $3TXX4 = parcelRequire("3TXX4");
var $6c7a72730cee5098$var$slice = Array.prototype.slice;

var $9hQFq = parcelRequire("9hQFq");
var $6c7a72730cee5098$var$Events = {
    // Bind an event to a `callback` function. Passing `"all"` will bind
    // the callback to all events fired.
    on: function(name, callback, context) {
        if (!$9hQFq.eventsApi(this, 'on', name, [
            callback,
            context
        ]) || !callback) return this;
        this._events || (this._events = {});
        var events = this._events[name] || (this._events[name] = []);
        events.push({
            callback: callback,
            context: context,
            ctx: context || this
        });
        return this;
    },
    // Bind an event to only be triggered a single time. After the first time
    // the callback is invoked, it will be removed.
    once: function(name, callback, context) {
        if (!$9hQFq.eventsApi(this, 'once', name, [
            callback,
            context
        ]) || !callback) return this;
        var self = this;
        var once = $2tU91(function() {
            self.off(name, once);
            callback.apply(this, arguments);
        });
        once._callback = callback;
        return this.on(name, once, context);
    },
    // Remove one or many callbacks. If `context` is null, removes all
    // callbacks with that function. If `callback` is null, removes all
    // callbacks for the event. If `name` is null, removes all bound
    // callbacks for all events.
    off: function(name, callback, context) {
        var retain, ev, events, names, i, l, j, k;
        if (!this._events || !$9hQFq.eventsApi(this, 'off', name, [
            callback,
            context
        ])) return this;
        if (!name && !callback && !context) {
            this._events = void 0;
            return this;
        }
        names = name ? [
            name
        ] : $6ZxOb(this._events);
        for(i = 0, l = names.length; i < l; i++){
            name = names[i];
            if (events = this._events[name]) {
                this._events[name] = retain = [];
                if (callback || context) for(j = 0, k = events.length; j < k; j++){
                    ev = events[j];
                    if (callback && callback !== ev.callback && callback !== ev.callback._callback || context && context !== ev.context) retain.push(ev);
                }
                if (!retain.length) delete this._events[name];
            }
        }
        return this;
    },
    // Trigger one or many events, firing all bound callbacks. Callbacks are
    // passed the same arguments as `trigger` is, apart from the event name
    // (unless you're listening on `"all"`, which will cause your callback to
    // receive the true name of the event as the first argument).
    trigger: function(name) {
        if (!this._events) return this;
        var args = $6c7a72730cee5098$var$slice.call(arguments, 1);
        if (!$9hQFq.eventsApi(this, 'trigger', name, args)) return this;
        var events = this._events[name];
        var allEvents = this._events.all;
        if (events) $9hQFq.triggerEvents(events, args);
        if (allEvents) $9hQFq.triggerEvents(allEvents, arguments);
        return this;
    },
    // Tell this object to stop listening to either specific events ... or
    // to every object it's currently listening to.
    stopListening: function(obj, name, callback) {
        var listeningTo = this._listeningTo;
        if (!listeningTo) return this;
        var remove = !name && !callback;
        if (!callback && typeof name === 'object') callback = this;
        if (obj) (listeningTo = {})[obj._listenId] = obj;
        var self = this;
        $3TXX4(listeningTo, function(item, id) {
            item.off(name, callback, self);
            if (remove || $1ucn8(item._events)) delete self._listeningTo[id];
        });
        return this;
    },
    // extend an object with event capabilities if passed
    // or just return a new one.
    createEmitter: function(obj) {
        return $akRxj(obj || {}, $6c7a72730cee5098$var$Events);
    },
    listenTo: $9hQFq.createListenMethod('on'),
    listenToOnce: $9hQFq.createListenMethod('once'),
    listenToAndRun: function(obj, name, callback) {
        this.listenTo.apply(this, arguments);
        if (!callback && typeof name === 'object') callback = this;
        callback.apply(this);
        return this;
    }
};
// setup aliases
$6c7a72730cee5098$var$Events.bind = $6c7a72730cee5098$var$Events.on;
$6c7a72730cee5098$var$Events.unbind = $6c7a72730cee5098$var$Events.off;
$6c7a72730cee5098$var$Events.removeListener = $6c7a72730cee5098$var$Events.off;
$6c7a72730cee5098$var$Events.removeAllListeners = $6c7a72730cee5098$var$Events.off;
$6c7a72730cee5098$var$Events.emit = $6c7a72730cee5098$var$Events.trigger;
module.exports = $6c7a72730cee5098$var$Events;

});
parcelRegister("2tU91", function(module, exports) {

var $hl8V0 = parcelRequire("hl8V0");
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $1ce9d75b41fdd1e3$var$once(func) {
    return $hl8V0(2, func);
}
module.exports = $1ce9d75b41fdd1e3$var$once;

});
parcelRegister("hl8V0", function(module, exports) {

var $480y0 = parcelRequire("480y0");
/** Error message constants. */ var $c9fb50d6e2703052$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $c9fb50d6e2703052$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($c9fb50d6e2703052$var$FUNC_ERROR_TEXT);
    n = $480y0(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
module.exports = $c9fb50d6e2703052$var$before;

});
parcelRegister("480y0", function(module, exports) {

var $kkczH = parcelRequire("kkczH");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $3018557e03f45410$var$toInteger(value) {
    var result = $kkczH(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $3018557e03f45410$var$toInteger;

});
parcelRegister("kkczH", function(module, exports) {

var $5M5aK = parcelRequire("5M5aK");
/** Used as references for various `Number` constants. */ var $ecbf6e001db3f72e$var$INFINITY = 1 / 0, $ecbf6e001db3f72e$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $ecbf6e001db3f72e$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $5M5aK(value);
    if (value === $ecbf6e001db3f72e$var$INFINITY || value === -$ecbf6e001db3f72e$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $ecbf6e001db3f72e$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $ecbf6e001db3f72e$var$toFinite;

});
parcelRegister("5M5aK", function(module, exports) {

var $4tv0Z = parcelRequire("4tv0Z");

var $5DUFR = parcelRequire("5DUFR");

var $eHNuH = parcelRequire("eHNuH");
/** Used as references for various `Number` constants. */ var $43457296c992556a$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $43457296c992556a$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $43457296c992556a$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $43457296c992556a$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $43457296c992556a$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $43457296c992556a$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($eHNuH(value)) return $43457296c992556a$var$NAN;
    if ($5DUFR(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $5DUFR(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $4tv0Z(value);
    var isBinary = $43457296c992556a$var$reIsBinary.test(value);
    return isBinary || $43457296c992556a$var$reIsOctal.test(value) ? $43457296c992556a$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $43457296c992556a$var$reIsBadHex.test(value) ? $43457296c992556a$var$NAN : +value;
}
module.exports = $43457296c992556a$var$toNumber;

});
parcelRegister("4tv0Z", function(module, exports) {

var $6u0NM = parcelRequire("6u0NM");
/** Used to match leading whitespace. */ var $3421edc2b0c09a52$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $3421edc2b0c09a52$var$baseTrim(string) {
    return string ? string.slice(0, $6u0NM(string) + 1).replace($3421edc2b0c09a52$var$reTrimStart, '') : string;
}
module.exports = $3421edc2b0c09a52$var$baseTrim;

});
parcelRegister("6u0NM", function(module, exports) {
/** Used to match a single whitespace character. */ var $4b862aa282ce9d7a$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $4b862aa282ce9d7a$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $4b862aa282ce9d7a$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $4b862aa282ce9d7a$var$trimmedEndIndex;

});


parcelRegister("5DUFR", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $41bc8e99d5182c31$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $41bc8e99d5182c31$var$isObject;

});

parcelRegister("eHNuH", function(module, exports) {

var $39TZG = parcelRequire("39TZG");

var $lIKbn = parcelRequire("lIKbn");
/** `Object#toString` result references. */ var $ab4b7958a9ef0087$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ab4b7958a9ef0087$var$isSymbol(value) {
    return typeof value == 'symbol' || $lIKbn(value) && $39TZG(value) == $ab4b7958a9ef0087$var$symbolTag;
}
module.exports = $ab4b7958a9ef0087$var$isSymbol;

});
parcelRegister("39TZG", function(module, exports) {

var $7xLVY = parcelRequire("7xLVY");

var $lTUzI = parcelRequire("lTUzI");

var $dQyBe = parcelRequire("dQyBe");
/** `Object#toString` result references. */ var $24cda594e603d7a5$var$nullTag = '[object Null]', $24cda594e603d7a5$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $24cda594e603d7a5$var$symToStringTag = $7xLVY ? $7xLVY.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $24cda594e603d7a5$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $24cda594e603d7a5$var$undefinedTag : $24cda594e603d7a5$var$nullTag;
    return $24cda594e603d7a5$var$symToStringTag && $24cda594e603d7a5$var$symToStringTag in Object(value) ? $lTUzI(value) : $dQyBe(value);
}
module.exports = $24cda594e603d7a5$var$baseGetTag;

});
parcelRegister("7xLVY", function(module, exports) {

var $cZ0ro = parcelRequire("cZ0ro");
/** Built-in value references. */ var $57e0cc2e5ea59702$var$Symbol = $cZ0ro.Symbol;
module.exports = $57e0cc2e5ea59702$var$Symbol;

});
parcelRegister("cZ0ro", function(module, exports) {

var $gt8W6 = parcelRequire("gt8W6");
/** Detect free variable `self`. */ var $973b8619f394e1bd$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $973b8619f394e1bd$var$root = $gt8W6 || $973b8619f394e1bd$var$freeSelf || Function('return this')();
module.exports = $973b8619f394e1bd$var$root;

});
parcelRegister("gt8W6", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $bfd64949dec328f9$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $bfd64949dec328f9$var$freeGlobal;

});



parcelRegister("lTUzI", function(module, exports) {

var $7xLVY = parcelRequire("7xLVY");
/** Used for built-in method references. */ var $ff1a9ea4f9786670$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ff1a9ea4f9786670$var$hasOwnProperty = $ff1a9ea4f9786670$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ff1a9ea4f9786670$var$nativeObjectToString = $ff1a9ea4f9786670$var$objectProto.toString;
/** Built-in value references. */ var $ff1a9ea4f9786670$var$symToStringTag = $7xLVY ? $7xLVY.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $ff1a9ea4f9786670$var$getRawTag(value) {
    var isOwn = $ff1a9ea4f9786670$var$hasOwnProperty.call(value, $ff1a9ea4f9786670$var$symToStringTag), tag = value[$ff1a9ea4f9786670$var$symToStringTag];
    try {
        value[$ff1a9ea4f9786670$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $ff1a9ea4f9786670$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$ff1a9ea4f9786670$var$symToStringTag] = tag;
        else delete value[$ff1a9ea4f9786670$var$symToStringTag];
    }
    return result;
}
module.exports = $ff1a9ea4f9786670$var$getRawTag;

});

parcelRegister("dQyBe", function(module, exports) {
/** Used for built-in method references. */ var $a14af871a5d69800$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a14af871a5d69800$var$nativeObjectToString = $a14af871a5d69800$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $a14af871a5d69800$var$objectToString(value) {
    return $a14af871a5d69800$var$nativeObjectToString.call(value);
}
module.exports = $a14af871a5d69800$var$objectToString;

});


parcelRegister("lIKbn", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $fd0187ebb7a281f1$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $fd0187ebb7a281f1$var$isObjectLike;

});







parcelRegister("6ZxOb", function(module, exports) {

var $dyTjd = parcelRequire("dyTjd");

var $brwuN = parcelRequire("brwuN");

var $fWng1 = parcelRequire("fWng1");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $5172aa352c7bb22e$var$keys(object) {
    return $fWng1(object) ? $dyTjd(object) : $brwuN(object);
}
module.exports = $5172aa352c7bb22e$var$keys;

});
parcelRegister("dyTjd", function(module, exports) {

var $2eZrO = parcelRequire("2eZrO");

var $2NLAx = parcelRequire("2NLAx");

var $3vzLP = parcelRequire("3vzLP");

var $bX0UL = parcelRequire("bX0UL");

var $c8QtW = parcelRequire("c8QtW");

var $5EtPa = parcelRequire("5EtPa");
/** Used for built-in method references. */ var $9df95a878da78113$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9df95a878da78113$var$hasOwnProperty = $9df95a878da78113$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $9df95a878da78113$var$arrayLikeKeys(value, inherited) {
    var isArr = $3vzLP(value), isArg = !isArr && $2NLAx(value), isBuff = !isArr && !isArg && $bX0UL(value), isType = !isArr && !isArg && !isBuff && $5EtPa(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $2eZrO(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $9df95a878da78113$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $c8QtW(key, length)))) result.push(key);
    return result;
}
module.exports = $9df95a878da78113$var$arrayLikeKeys;

});
parcelRegister("2eZrO", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $1a1c8dc52f590fb5$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $1a1c8dc52f590fb5$var$baseTimes;

});

parcelRegister("2NLAx", function(module, exports) {

var $QRfuw = parcelRequire("QRfuw");

var $lIKbn = parcelRequire("lIKbn");
/** Used for built-in method references. */ var $20a5126abb56b6f3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $20a5126abb56b6f3$var$hasOwnProperty = $20a5126abb56b6f3$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $20a5126abb56b6f3$var$propertyIsEnumerable = $20a5126abb56b6f3$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $20a5126abb56b6f3$var$isArguments = $QRfuw(function() {
    return arguments;
}()) ? $QRfuw : function(value) {
    return $lIKbn(value) && $20a5126abb56b6f3$var$hasOwnProperty.call(value, 'callee') && !$20a5126abb56b6f3$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $20a5126abb56b6f3$var$isArguments;

});
parcelRegister("QRfuw", function(module, exports) {

var $39TZG = parcelRequire("39TZG");

var $lIKbn = parcelRequire("lIKbn");
/** `Object#toString` result references. */ var $09ee298ed2438977$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $09ee298ed2438977$var$baseIsArguments(value) {
    return $lIKbn(value) && $39TZG(value) == $09ee298ed2438977$var$argsTag;
}
module.exports = $09ee298ed2438977$var$baseIsArguments;

});


parcelRegister("3vzLP", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $28e0039f8f2aad88$var$isArray = Array.isArray;
module.exports = $28e0039f8f2aad88$var$isArray;

});

parcelRegister("bX0UL", function(module, exports) {

var $cZ0ro = parcelRequire("cZ0ro");

var $7D6yQ = parcelRequire("7D6yQ");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $cZ0ro.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $7D6yQ;
module.exports = isBuffer;

});
parcelRegister("7D6yQ", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $58e143d208679226$var$stubFalse() {
    return false;
}
module.exports = $58e143d208679226$var$stubFalse;

});


parcelRegister("c8QtW", function(module, exports) {
/** Used as references for various `Number` constants. */ var $8d6ef12f776527e9$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $8d6ef12f776527e9$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $8d6ef12f776527e9$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $8d6ef12f776527e9$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $8d6ef12f776527e9$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $8d6ef12f776527e9$var$isIndex;

});

parcelRegister("5EtPa", function(module, exports) {

var $7LyXm = parcelRequire("7LyXm");

var $iqpCQ = parcelRequire("iqpCQ");

var $ddmWT = parcelRequire("ddmWT");
/* Node.js helper references. */ var $41d7d2accbf38e79$var$nodeIsTypedArray = $ddmWT && $ddmWT.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $41d7d2accbf38e79$var$isTypedArray = $41d7d2accbf38e79$var$nodeIsTypedArray ? $iqpCQ($41d7d2accbf38e79$var$nodeIsTypedArray) : $7LyXm;
module.exports = $41d7d2accbf38e79$var$isTypedArray;

});
parcelRegister("7LyXm", function(module, exports) {

var $39TZG = parcelRequire("39TZG");

var $5CvfY = parcelRequire("5CvfY");

var $lIKbn = parcelRequire("lIKbn");
/** `Object#toString` result references. */ var $5a7809d2b76c544c$var$argsTag = '[object Arguments]', $5a7809d2b76c544c$var$arrayTag = '[object Array]', $5a7809d2b76c544c$var$boolTag = '[object Boolean]', $5a7809d2b76c544c$var$dateTag = '[object Date]', $5a7809d2b76c544c$var$errorTag = '[object Error]', $5a7809d2b76c544c$var$funcTag = '[object Function]', $5a7809d2b76c544c$var$mapTag = '[object Map]', $5a7809d2b76c544c$var$numberTag = '[object Number]', $5a7809d2b76c544c$var$objectTag = '[object Object]', $5a7809d2b76c544c$var$regexpTag = '[object RegExp]', $5a7809d2b76c544c$var$setTag = '[object Set]', $5a7809d2b76c544c$var$stringTag = '[object String]', $5a7809d2b76c544c$var$weakMapTag = '[object WeakMap]';
var $5a7809d2b76c544c$var$arrayBufferTag = '[object ArrayBuffer]', $5a7809d2b76c544c$var$dataViewTag = '[object DataView]', $5a7809d2b76c544c$var$float32Tag = '[object Float32Array]', $5a7809d2b76c544c$var$float64Tag = '[object Float64Array]', $5a7809d2b76c544c$var$int8Tag = '[object Int8Array]', $5a7809d2b76c544c$var$int16Tag = '[object Int16Array]', $5a7809d2b76c544c$var$int32Tag = '[object Int32Array]', $5a7809d2b76c544c$var$uint8Tag = '[object Uint8Array]', $5a7809d2b76c544c$var$uint8ClampedTag = '[object Uint8ClampedArray]', $5a7809d2b76c544c$var$uint16Tag = '[object Uint16Array]', $5a7809d2b76c544c$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $5a7809d2b76c544c$var$typedArrayTags = {};
$5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$float32Tag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$float64Tag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$int8Tag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$int16Tag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$int32Tag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$uint8Tag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$uint8ClampedTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$uint16Tag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$uint32Tag] = true;
$5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$argsTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$arrayTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$arrayBufferTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$boolTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$dataViewTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$dateTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$errorTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$funcTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$mapTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$numberTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$objectTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$regexpTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$setTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$stringTag] = $5a7809d2b76c544c$var$typedArrayTags[$5a7809d2b76c544c$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $5a7809d2b76c544c$var$baseIsTypedArray(value) {
    return $lIKbn(value) && $5CvfY(value.length) && !!$5a7809d2b76c544c$var$typedArrayTags[$39TZG(value)];
}
module.exports = $5a7809d2b76c544c$var$baseIsTypedArray;

});
parcelRegister("5CvfY", function(module, exports) {
/** Used as references for various `Number` constants. */ var $4178bf4bb4370453$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $4178bf4bb4370453$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $4178bf4bb4370453$var$MAX_SAFE_INTEGER;
}
module.exports = $4178bf4bb4370453$var$isLength;

});


parcelRegister("iqpCQ", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $d69e88601b65c938$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $d69e88601b65c938$var$baseUnary;

});

parcelRegister("ddmWT", function(module, exports) {

var $gt8W6 = parcelRequire("gt8W6");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $gt8W6.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("brwuN", function(module, exports) {

var $5DSff = parcelRequire("5DSff");

var $6Id7S = parcelRequire("6Id7S");
/** Used for built-in method references. */ var $854b6c50a5619d08$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $854b6c50a5619d08$var$hasOwnProperty = $854b6c50a5619d08$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $854b6c50a5619d08$var$baseKeys(object) {
    if (!$5DSff(object)) return $6Id7S(object);
    var result = [];
    for(var key in Object(object))if ($854b6c50a5619d08$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $854b6c50a5619d08$var$baseKeys;

});
parcelRegister("5DSff", function(module, exports) {
/** Used for built-in method references. */ var $41baac30a27e123f$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $41baac30a27e123f$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $41baac30a27e123f$var$objectProto;
    return value === proto;
}
module.exports = $41baac30a27e123f$var$isPrototype;

});

parcelRegister("6Id7S", function(module, exports) {

var $57pzX = parcelRequire("57pzX");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4e3108b78d73a379$var$nativeKeys = $57pzX(Object.keys, Object);
module.exports = $4e3108b78d73a379$var$nativeKeys;

});
parcelRegister("57pzX", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $3ba1729ef737666b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $3ba1729ef737666b$var$overArg;

});



parcelRegister("fWng1", function(module, exports) {

var $62yEr = parcelRequire("62yEr");

var $5CvfY = parcelRequire("5CvfY");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $b9ae504156bab2b3$var$isArrayLike(value) {
    return value != null && $5CvfY(value.length) && !$62yEr(value);
}
module.exports = $b9ae504156bab2b3$var$isArrayLike;

});
parcelRegister("62yEr", function(module, exports) {

var $39TZG = parcelRequire("39TZG");

var $5DUFR = parcelRequire("5DUFR");
/** `Object#toString` result references. */ var $465dcefb9d1a3e08$var$asyncTag = '[object AsyncFunction]', $465dcefb9d1a3e08$var$funcTag = '[object Function]', $465dcefb9d1a3e08$var$genTag = '[object GeneratorFunction]', $465dcefb9d1a3e08$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $465dcefb9d1a3e08$var$isFunction(value) {
    if (!$5DUFR(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $39TZG(value);
    return tag == $465dcefb9d1a3e08$var$funcTag || tag == $465dcefb9d1a3e08$var$genTag || tag == $465dcefb9d1a3e08$var$asyncTag || tag == $465dcefb9d1a3e08$var$proxyTag;
}
module.exports = $465dcefb9d1a3e08$var$isFunction;

});



parcelRegister("1ucn8", function(module, exports) {

var $brwuN = parcelRequire("brwuN");

var $d2ghx = parcelRequire("d2ghx");

var $2NLAx = parcelRequire("2NLAx");

var $3vzLP = parcelRequire("3vzLP");

var $fWng1 = parcelRequire("fWng1");

var $bX0UL = parcelRequire("bX0UL");

var $5DSff = parcelRequire("5DSff");

var $5EtPa = parcelRequire("5EtPa");
/** `Object#toString` result references. */ var $115230a1e88285b8$var$mapTag = '[object Map]', $115230a1e88285b8$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $115230a1e88285b8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $115230a1e88285b8$var$hasOwnProperty = $115230a1e88285b8$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $115230a1e88285b8$var$isEmpty(value) {
    if (value == null) return true;
    if ($fWng1(value) && ($3vzLP(value) || typeof value == 'string' || typeof value.splice == 'function' || $bX0UL(value) || $5EtPa(value) || $2NLAx(value))) return !value.length;
    var tag = $d2ghx(value);
    if (tag == $115230a1e88285b8$var$mapTag || tag == $115230a1e88285b8$var$setTag) return !value.size;
    if ($5DSff(value)) return !$brwuN(value).length;
    for(var key in value){
        if ($115230a1e88285b8$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $115230a1e88285b8$var$isEmpty;

});
parcelRegister("d2ghx", function(module, exports) {

var $2ZZzz = parcelRequire("2ZZzz");

var $2YkTl = parcelRequire("2YkTl");

var $1nnp1 = parcelRequire("1nnp1");

var $5U06H = parcelRequire("5U06H");

var $fZWIb = parcelRequire("fZWIb");

var $39TZG = parcelRequire("39TZG");

var $9WH4j = parcelRequire("9WH4j");
/** `Object#toString` result references. */ var $97d817860b7d521f$var$mapTag = '[object Map]', $97d817860b7d521f$var$objectTag = '[object Object]', $97d817860b7d521f$var$promiseTag = '[object Promise]', $97d817860b7d521f$var$setTag = '[object Set]', $97d817860b7d521f$var$weakMapTag = '[object WeakMap]';
var $97d817860b7d521f$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $97d817860b7d521f$var$dataViewCtorString = $9WH4j($2ZZzz), $97d817860b7d521f$var$mapCtorString = $9WH4j($2YkTl), $97d817860b7d521f$var$promiseCtorString = $9WH4j($1nnp1), $97d817860b7d521f$var$setCtorString = $9WH4j($5U06H), $97d817860b7d521f$var$weakMapCtorString = $9WH4j($fZWIb);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $97d817860b7d521f$var$getTag = $39TZG;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($2ZZzz && $97d817860b7d521f$var$getTag(new $2ZZzz(new ArrayBuffer(1))) != $97d817860b7d521f$var$dataViewTag || $2YkTl && $97d817860b7d521f$var$getTag(new $2YkTl) != $97d817860b7d521f$var$mapTag || $1nnp1 && $97d817860b7d521f$var$getTag($1nnp1.resolve()) != $97d817860b7d521f$var$promiseTag || $5U06H && $97d817860b7d521f$var$getTag(new $5U06H) != $97d817860b7d521f$var$setTag || $fZWIb && $97d817860b7d521f$var$getTag(new $fZWIb) != $97d817860b7d521f$var$weakMapTag) $97d817860b7d521f$var$getTag = function(value) {
    var result = $39TZG(value), Ctor = result == $97d817860b7d521f$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9WH4j(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $97d817860b7d521f$var$dataViewCtorString:
            return $97d817860b7d521f$var$dataViewTag;
        case $97d817860b7d521f$var$mapCtorString:
            return $97d817860b7d521f$var$mapTag;
        case $97d817860b7d521f$var$promiseCtorString:
            return $97d817860b7d521f$var$promiseTag;
        case $97d817860b7d521f$var$setCtorString:
            return $97d817860b7d521f$var$setTag;
        case $97d817860b7d521f$var$weakMapCtorString:
            return $97d817860b7d521f$var$weakMapTag;
    }
    return result;
};
module.exports = $97d817860b7d521f$var$getTag;

});
parcelRegister("2ZZzz", function(module, exports) {

var $6t9o5 = parcelRequire("6t9o5");

var $cZ0ro = parcelRequire("cZ0ro");
/* Built-in method references that are verified to be native. */ var $22f10a5497648614$var$DataView = $6t9o5($cZ0ro, 'DataView');
module.exports = $22f10a5497648614$var$DataView;

});
parcelRegister("6t9o5", function(module, exports) {

var $jmv8o = parcelRequire("jmv8o");

var $jP5uS = parcelRequire("jP5uS");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $4b5cbba58da14f0d$var$getNative(object, key) {
    var value = $jP5uS(object, key);
    return $jmv8o(value) ? value : undefined;
}
module.exports = $4b5cbba58da14f0d$var$getNative;

});
parcelRegister("jmv8o", function(module, exports) {

var $62yEr = parcelRequire("62yEr");

var $3ddPm = parcelRequire("3ddPm");

var $5DUFR = parcelRequire("5DUFR");

var $9WH4j = parcelRequire("9WH4j");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $e18839091d298d9b$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $e18839091d298d9b$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $e18839091d298d9b$var$funcProto = Function.prototype, $e18839091d298d9b$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $e18839091d298d9b$var$funcToString = $e18839091d298d9b$var$funcProto.toString;
/** Used to check objects for own properties. */ var $e18839091d298d9b$var$hasOwnProperty = $e18839091d298d9b$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $e18839091d298d9b$var$reIsNative = RegExp('^' + $e18839091d298d9b$var$funcToString.call($e18839091d298d9b$var$hasOwnProperty).replace($e18839091d298d9b$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $e18839091d298d9b$var$baseIsNative(value) {
    if (!$5DUFR(value) || $3ddPm(value)) return false;
    var pattern = $62yEr(value) ? $e18839091d298d9b$var$reIsNative : $e18839091d298d9b$var$reIsHostCtor;
    return pattern.test($9WH4j(value));
}
module.exports = $e18839091d298d9b$var$baseIsNative;

});
parcelRegister("3ddPm", function(module, exports) {

var $hqxKP = parcelRequire("hqxKP");
/** Used to detect methods masquerading as native. */ var $256d4fd7728fb4dc$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($hqxKP && $hqxKP.keys && $hqxKP.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $256d4fd7728fb4dc$var$isMasked(func) {
    return !!$256d4fd7728fb4dc$var$maskSrcKey && $256d4fd7728fb4dc$var$maskSrcKey in func;
}
module.exports = $256d4fd7728fb4dc$var$isMasked;

});
parcelRegister("hqxKP", function(module, exports) {

var $cZ0ro = parcelRequire("cZ0ro");
/** Used to detect overreaching core-js shims. */ var $caff0c4c3ca9204c$var$coreJsData = $cZ0ro["__core-js_shared__"];
module.exports = $caff0c4c3ca9204c$var$coreJsData;

});


parcelRegister("9WH4j", function(module, exports) {
/** Used for built-in method references. */ var $73daf05e6b097444$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $73daf05e6b097444$var$funcToString = $73daf05e6b097444$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $73daf05e6b097444$var$toSource(func) {
    if (func != null) {
        try {
            return $73daf05e6b097444$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $73daf05e6b097444$var$toSource;

});


parcelRegister("jP5uS", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e6e70b54ec14c079$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $e6e70b54ec14c079$var$getValue;

});



parcelRegister("2YkTl", function(module, exports) {

var $6t9o5 = parcelRequire("6t9o5");

var $cZ0ro = parcelRequire("cZ0ro");
/* Built-in method references that are verified to be native. */ var $22a1640251a7cae7$var$Map = $6t9o5($cZ0ro, 'Map');
module.exports = $22a1640251a7cae7$var$Map;

});

parcelRegister("1nnp1", function(module, exports) {

var $6t9o5 = parcelRequire("6t9o5");

var $cZ0ro = parcelRequire("cZ0ro");
/* Built-in method references that are verified to be native. */ var $100a17ad9f10d1e6$var$Promise = $6t9o5($cZ0ro, 'Promise');
module.exports = $100a17ad9f10d1e6$var$Promise;

});

parcelRegister("5U06H", function(module, exports) {

var $6t9o5 = parcelRequire("6t9o5");

var $cZ0ro = parcelRequire("cZ0ro");
/* Built-in method references that are verified to be native. */ var $44c243fc03cd362c$var$Set = $6t9o5($cZ0ro, 'Set');
module.exports = $44c243fc03cd362c$var$Set;

});

parcelRegister("fZWIb", function(module, exports) {

var $6t9o5 = parcelRequire("6t9o5");

var $cZ0ro = parcelRequire("cZ0ro");
/* Built-in method references that are verified to be native. */ var $ba5a186833a2dcc8$var$WeakMap = $6t9o5($cZ0ro, 'WeakMap');
module.exports = $ba5a186833a2dcc8$var$WeakMap;

});



parcelRegister("akRxj", function(module, exports) {

var $7nfqv = parcelRequire("7nfqv");

var $94d3P = parcelRequire("94d3P");

var $j1LOk = parcelRequire("j1LOk");

var $fWng1 = parcelRequire("fWng1");

var $5DSff = parcelRequire("5DSff");

var $6ZxOb = parcelRequire("6ZxOb");
/** Used for built-in method references. */ var $78654cd7b7fb5089$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $78654cd7b7fb5089$var$hasOwnProperty = $78654cd7b7fb5089$var$objectProto.hasOwnProperty;
/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */ var $78654cd7b7fb5089$var$assign = $j1LOk(function(object, source) {
    if ($5DSff(source) || $fWng1(source)) {
        $94d3P(source, $6ZxOb(source), object);
        return;
    }
    for(var key in source)if ($78654cd7b7fb5089$var$hasOwnProperty.call(source, key)) $7nfqv(object, key, source[key]);
});
module.exports = $78654cd7b7fb5089$var$assign;

});
parcelRegister("7nfqv", function(module, exports) {

var $fMxCj = parcelRequire("fMxCj");

var $68RuN = parcelRequire("68RuN");
/** Used for built-in method references. */ var $55e6a5c2bd6e77d2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $55e6a5c2bd6e77d2$var$hasOwnProperty = $55e6a5c2bd6e77d2$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $55e6a5c2bd6e77d2$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($55e6a5c2bd6e77d2$var$hasOwnProperty.call(object, key) && $68RuN(objValue, value)) || value === undefined && !(key in object)) $fMxCj(object, key, value);
}
module.exports = $55e6a5c2bd6e77d2$var$assignValue;

});
parcelRegister("fMxCj", function(module, exports) {

var $i4GPA = parcelRequire("i4GPA");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $b7d56a535d980b1b$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $i4GPA) $i4GPA(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $b7d56a535d980b1b$var$baseAssignValue;

});
parcelRegister("i4GPA", function(module, exports) {

var $6t9o5 = parcelRequire("6t9o5");
var $d289d30e8bbfeaf8$var$defineProperty = function() {
    try {
        var func = $6t9o5(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $d289d30e8bbfeaf8$var$defineProperty;

});


parcelRegister("68RuN", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $478cfc8c7ff3b36a$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $478cfc8c7ff3b36a$var$eq;

});


parcelRegister("94d3P", function(module, exports) {

var $7nfqv = parcelRequire("7nfqv");

var $fMxCj = parcelRequire("fMxCj");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $699e9e5c389e1789$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $fMxCj(object, key, newValue);
        else $7nfqv(object, key, newValue);
    }
    return object;
}
module.exports = $699e9e5c389e1789$var$copyObject;

});

parcelRegister("j1LOk", function(module, exports) {

var $3YGtA = parcelRequire("3YGtA");

var $dpoHm = parcelRequire("dpoHm");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $dda3328d346a1e06$var$createAssigner(assigner) {
    return $3YGtA(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $dpoHm(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $dda3328d346a1e06$var$createAssigner;

});
parcelRegister("3YGtA", function(module, exports) {

var $9qV0f = parcelRequire("9qV0f");

var $3qQSV = parcelRequire("3qQSV");

var $eHZN2 = parcelRequire("eHZN2");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $2e57ec9728633c60$var$baseRest(func, start) {
    return $eHZN2($3qQSV(func, start, $9qV0f), func + '');
}
module.exports = $2e57ec9728633c60$var$baseRest;

});
parcelRegister("9qV0f", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $6de2c259095b43ce$var$identity(value) {
    return value;
}
module.exports = $6de2c259095b43ce$var$identity;

});

parcelRegister("3qQSV", function(module, exports) {

var $an76h = parcelRequire("an76h");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $27fcd2a608d5505b$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $27fcd2a608d5505b$var$overRest(func, start, transform) {
    start = $27fcd2a608d5505b$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $27fcd2a608d5505b$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $an76h(func, this, otherArgs);
    };
}
module.exports = $27fcd2a608d5505b$var$overRest;

});
parcelRegister("an76h", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $78d18f5599ced536$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $78d18f5599ced536$var$apply;

});


parcelRegister("eHZN2", function(module, exports) {

var $D6VBf = parcelRequire("D6VBf");

var $967B3 = parcelRequire("967B3");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $ab5503076f717dc3$var$setToString = $967B3($D6VBf);
module.exports = $ab5503076f717dc3$var$setToString;

});
parcelRegister("D6VBf", function(module, exports) {

var $6RwOx = parcelRequire("6RwOx");

var $i4GPA = parcelRequire("i4GPA");

var $9qV0f = parcelRequire("9qV0f");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $075904652886d2bf$var$baseSetToString = !$i4GPA ? $9qV0f : function(func, string) {
    return $i4GPA(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $6RwOx(string),
        'writable': true
    });
};
module.exports = $075904652886d2bf$var$baseSetToString;

});
parcelRegister("6RwOx", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $4ff125819ce61fed$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $4ff125819ce61fed$var$constant;

});


parcelRegister("967B3", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $69fa911f6bac1e03$var$HOT_COUNT = 800, $69fa911f6bac1e03$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $69fa911f6bac1e03$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $69fa911f6bac1e03$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $69fa911f6bac1e03$var$nativeNow(), remaining = $69fa911f6bac1e03$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $69fa911f6bac1e03$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $69fa911f6bac1e03$var$shortOut;

});



parcelRegister("dpoHm", function(module, exports) {

var $68RuN = parcelRequire("68RuN");

var $fWng1 = parcelRequire("fWng1");

var $c8QtW = parcelRequire("c8QtW");

var $5DUFR = parcelRequire("5DUFR");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $9c30c4be4d321d2a$var$isIterateeCall(value, index, object) {
    if (!$5DUFR(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $fWng1(object) && $c8QtW(index, object.length) : type == 'string' && index in object) return $68RuN(object[index], value);
    return false;
}
module.exports = $9c30c4be4d321d2a$var$isIterateeCall;

});



parcelRegister("3TXX4", function(module, exports) {

var $fTNj0 = parcelRequire("fTNj0");

var $dGp9H = parcelRequire("dGp9H");

var $2GF6H = parcelRequire("2GF6H");

var $3vzLP = parcelRequire("3vzLP");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $2d7503540710569a$var$forEach(collection, iteratee) {
    var func = $3vzLP(collection) ? $fTNj0 : $dGp9H;
    return func(collection, $2GF6H(iteratee));
}
module.exports = $2d7503540710569a$var$forEach;

});
parcelRegister("fTNj0", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $b9323d2588488071$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $b9323d2588488071$var$arrayEach;

});

parcelRegister("dGp9H", function(module, exports) {

var $bmAbh = parcelRequire("bmAbh");

var $1MaRC = parcelRequire("1MaRC");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $9f62b5f52001627b$var$baseEach = $1MaRC($bmAbh);
module.exports = $9f62b5f52001627b$var$baseEach;

});
parcelRegister("bmAbh", function(module, exports) {

var $kgWvo = parcelRequire("kgWvo");

var $6ZxOb = parcelRequire("6ZxOb");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $845dd08b79123324$var$baseForOwn(object, iteratee) {
    return object && $kgWvo(object, iteratee, $6ZxOb);
}
module.exports = $845dd08b79123324$var$baseForOwn;

});
parcelRegister("kgWvo", function(module, exports) {

var $7I4uh = parcelRequire("7I4uh");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $ec22af3428075578$var$baseFor = $7I4uh();
module.exports = $ec22af3428075578$var$baseFor;

});
parcelRegister("7I4uh", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $59d01f91eece739c$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $59d01f91eece739c$var$createBaseFor;

});



parcelRegister("1MaRC", function(module, exports) {

var $fWng1 = parcelRequire("fWng1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $14b2b37a12c93e96$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$fWng1(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $14b2b37a12c93e96$var$createBaseEach;

});


parcelRegister("2GF6H", function(module, exports) {

var $9qV0f = parcelRequire("9qV0f");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $1f4f640352283695$var$castFunction(value) {
    return typeof value == 'function' ? value : $9qV0f;
}
module.exports = $1f4f640352283695$var$castFunction;

});


parcelRegister("9hQFq", function(module, exports) {

$parcel$export(module.exports, "triggerEvents", function () { return $6c2e8e2e7a948e34$export$9cc1feced64062f4; }, function (v) { return $6c2e8e2e7a948e34$export$9cc1feced64062f4 = v; });
$parcel$export(module.exports, "eventsApi", function () { return $6c2e8e2e7a948e34$export$6c42dc7468486d63; }, function (v) { return $6c2e8e2e7a948e34$export$6c42dc7468486d63 = v; });
$parcel$export(module.exports, "createListenMethod", function () { return $6c2e8e2e7a948e34$export$5a3fffa5b3b3c37e; }, function (v) { return $6c2e8e2e7a948e34$export$5a3fffa5b3b3c37e = v; });
// A difficult-to-believe, but optimized internal dispatch function for
// triggering events. Tries to keep the usual cases speedy.
var $6c2e8e2e7a948e34$export$9cc1feced64062f4;
// Implement fancy features of the Events API such as multiple event
// names `"change blur"` and jQuery-style event maps `{change: action}`
// in terms of the existing API.
var $6c2e8e2e7a948e34$export$6c42dc7468486d63;
// Inversion-of-control versions of `on` and `once`. Tell *this* object to
// listen to an event in another object ... keeping track of what it's
// listening to.
var $6c2e8e2e7a948e34$export$5a3fffa5b3b3c37e;

var $91FRf = parcelRequire("91FRf");
var $6c2e8e2e7a948e34$var$eventSplitter = /\s+/;
$6c2e8e2e7a948e34$export$9cc1feced64062f4 = function triggerEvents(events, args) {
    var ev;
    var i = -1;
    var l = events.length;
    var a1 = args[0];
    var a2 = args[1];
    var a3 = args[2];
    switch(args.length){
        case 0:
            while(++i < l)(ev = events[i]).callback.call(ev.ctx);
            return;
        case 1:
            while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1);
            return;
        case 2:
            while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1, a2);
            return;
        case 3:
            while(++i < l)(ev = events[i]).callback.call(ev.ctx, a1, a2, a3);
            return;
        default:
            while(++i < l)(ev = events[i]).callback.apply(ev.ctx, args);
            return;
    }
};
$6c2e8e2e7a948e34$export$6c42dc7468486d63 = function eventsApi(obj, action, name, rest) {
    if (!name) return true;
    // Handle event maps.
    if (typeof name === 'object') {
        for(var key in name)obj[action].apply(obj, [
            key,
            name[key]
        ].concat(rest));
        return false;
    }
    // Handle space separated event names.
    if ($6c2e8e2e7a948e34$var$eventSplitter.test(name)) {
        var names = name.split($6c2e8e2e7a948e34$var$eventSplitter);
        for(var i = 0, l = names.length; i < l; i++)obj[action].apply(obj, [
            names[i]
        ].concat(rest));
        return false;
    }
    return true;
};
$6c2e8e2e7a948e34$export$5a3fffa5b3b3c37e = function createListenMethod(implementation) {
    return function listenMethod(obj, name, callback) {
        if (!obj) throw new Error('Trying to listenTo event: \'' + name + '\' but the target object is undefined');
        var listeningTo = this._listeningTo || (this._listeningTo = {});
        var id = obj._listenId || (obj._listenId = $91FRf('l'));
        listeningTo[id] = obj;
        if (!callback && typeof name === 'object') callback = this;
        if (typeof obj[implementation] !== 'function') throw new Error('Trying to listenTo event: \'' + name + '\' on object: ' + obj.toString() + ' but it does not have an \'on\' method so is unbindable');
        obj[implementation](name, callback, this);
        return this;
    };
};

});
parcelRegister("91FRf", function(module, exports) {

var $gA8dA = parcelRequire("gA8dA");
/** Used to generate unique IDs. */ var $6924ad20bc028b9e$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $6924ad20bc028b9e$var$uniqueId(prefix) {
    var id = ++$6924ad20bc028b9e$var$idCounter;
    return $gA8dA(prefix) + id;
}
module.exports = $6924ad20bc028b9e$var$uniqueId;

});
parcelRegister("gA8dA", function(module, exports) {

var $kcfor = parcelRequire("kcfor");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $c126621ab0016b83$var$toString(value) {
    return value == null ? '' : $kcfor(value);
}
module.exports = $c126621ab0016b83$var$toString;

});
parcelRegister("kcfor", function(module, exports) {

var $7xLVY = parcelRequire("7xLVY");

var $aKSSk = parcelRequire("aKSSk");

var $3vzLP = parcelRequire("3vzLP");

var $eHNuH = parcelRequire("eHNuH");
/** Used as references for various `Number` constants. */ var $03cb5e6d1d181156$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $03cb5e6d1d181156$var$symbolProto = $7xLVY ? $7xLVY.prototype : undefined, $03cb5e6d1d181156$var$symbolToString = $03cb5e6d1d181156$var$symbolProto ? $03cb5e6d1d181156$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $03cb5e6d1d181156$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($3vzLP(value)) // Recursively convert values (susceptible to call stack limits).
    return $aKSSk(value, $03cb5e6d1d181156$var$baseToString) + '';
    if ($eHNuH(value)) return $03cb5e6d1d181156$var$symbolToString ? $03cb5e6d1d181156$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$03cb5e6d1d181156$var$INFINITY ? '-0' : result;
}
module.exports = $03cb5e6d1d181156$var$baseToString;

});
parcelRegister("aKSSk", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7d48c45af884b3ae$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $7d48c45af884b3ae$var$arrayMap;

});






parcelRegister("7ttD4", function(module, exports) {

var $7xLVY = parcelRequire("7xLVY");

var $73mnJ = parcelRequire("73mnJ");

var $d2ghx = parcelRequire("d2ghx");

var $fWng1 = parcelRequire("fWng1");

var $fyYMa = parcelRequire("fyYMa");

var $4Zp79 = parcelRequire("4Zp79");

var $ig5JO = parcelRequire("ig5JO");

var $kk6VW = parcelRequire("kk6VW");

var $9OMd3 = parcelRequire("9OMd3");

var $1H6Hi = parcelRequire("1H6Hi");
/** `Object#toString` result references. */ var $571239988dc2d583$var$mapTag = '[object Map]', $571239988dc2d583$var$setTag = '[object Set]';
/** Built-in value references. */ var $571239988dc2d583$var$symIterator = $7xLVY ? $7xLVY.iterator : undefined;
/**
 * Converts `value` to an array.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Array} Returns the converted array.
 * @example
 *
 * _.toArray({ 'a': 1, 'b': 2 });
 * // => [1, 2]
 *
 * _.toArray('abc');
 * // => ['a', 'b', 'c']
 *
 * _.toArray(1);
 * // => []
 *
 * _.toArray(null);
 * // => []
 */ function $571239988dc2d583$var$toArray(value) {
    if (!value) return [];
    if ($fWng1(value)) return $fyYMa(value) ? $9OMd3(value) : $73mnJ(value);
    if ($571239988dc2d583$var$symIterator && value[$571239988dc2d583$var$symIterator]) return $4Zp79(value[$571239988dc2d583$var$symIterator]());
    var tag = $d2ghx(value), func = tag == $571239988dc2d583$var$mapTag ? $ig5JO : tag == $571239988dc2d583$var$setTag ? $kk6VW : $1H6Hi;
    return func(value);
}
module.exports = $571239988dc2d583$var$toArray;

});
parcelRegister("73mnJ", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $522a2cc88bde9d07$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $522a2cc88bde9d07$var$copyArray;

});

parcelRegister("fyYMa", function(module, exports) {

var $39TZG = parcelRequire("39TZG");

var $3vzLP = parcelRequire("3vzLP");

var $lIKbn = parcelRequire("lIKbn");
/** `Object#toString` result references. */ var $b5492ccf6001492e$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $b5492ccf6001492e$var$isString(value) {
    return typeof value == 'string' || !$3vzLP(value) && $lIKbn(value) && $39TZG(value) == $b5492ccf6001492e$var$stringTag;
}
module.exports = $b5492ccf6001492e$var$isString;

});

parcelRegister("4Zp79", function(module, exports) {
/**
 * Converts `iterator` to an array.
 *
 * @private
 * @param {Object} iterator The iterator to convert.
 * @returns {Array} Returns the converted array.
 */ function $3a205721fd225653$var$iteratorToArray(iterator) {
    var data, result = [];
    while(!(data = iterator.next()).done)result.push(data.value);
    return result;
}
module.exports = $3a205721fd225653$var$iteratorToArray;

});

parcelRegister("ig5JO", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $d4ae2c0b446ae32e$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $d4ae2c0b446ae32e$var$mapToArray;

});

parcelRegister("kk6VW", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $ecbb0dbe17c08d82$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $ecbb0dbe17c08d82$var$setToArray;

});

parcelRegister("9OMd3", function(module, exports) {

var $dyjnU = parcelRequire("dyjnU");

var $jo5ge = parcelRequire("jo5ge");

var $9Q3tW = parcelRequire("9Q3tW");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $725e2df6bea41d8b$var$stringToArray(string) {
    return $jo5ge(string) ? $9Q3tW(string) : $dyjnU(string);
}
module.exports = $725e2df6bea41d8b$var$stringToArray;

});
parcelRegister("dyjnU", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9ddd7cb31ed9ac84$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $9ddd7cb31ed9ac84$var$asciiToArray;

});

parcelRegister("jo5ge", function(module, exports) {
/** Used to compose unicode character classes. */ var $e1d456e9ae1a3f56$var$rsAstralRange = '\\ud800-\\udfff', $e1d456e9ae1a3f56$var$rsComboMarksRange = '\\u0300-\\u036f', $e1d456e9ae1a3f56$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $e1d456e9ae1a3f56$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $e1d456e9ae1a3f56$var$rsComboRange = $e1d456e9ae1a3f56$var$rsComboMarksRange + $e1d456e9ae1a3f56$var$reComboHalfMarksRange + $e1d456e9ae1a3f56$var$rsComboSymbolsRange, $e1d456e9ae1a3f56$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $e1d456e9ae1a3f56$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $e1d456e9ae1a3f56$var$reHasUnicode = RegExp('[' + $e1d456e9ae1a3f56$var$rsZWJ + $e1d456e9ae1a3f56$var$rsAstralRange + $e1d456e9ae1a3f56$var$rsComboRange + $e1d456e9ae1a3f56$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $e1d456e9ae1a3f56$var$hasUnicode(string) {
    return $e1d456e9ae1a3f56$var$reHasUnicode.test(string);
}
module.exports = $e1d456e9ae1a3f56$var$hasUnicode;

});

parcelRegister("9Q3tW", function(module, exports) {
/** Used to compose unicode character classes. */ var $729babd8e2d1401a$var$rsAstralRange = '\\ud800-\\udfff', $729babd8e2d1401a$var$rsComboMarksRange = '\\u0300-\\u036f', $729babd8e2d1401a$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $729babd8e2d1401a$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $729babd8e2d1401a$var$rsComboRange = $729babd8e2d1401a$var$rsComboMarksRange + $729babd8e2d1401a$var$reComboHalfMarksRange + $729babd8e2d1401a$var$rsComboSymbolsRange, $729babd8e2d1401a$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $729babd8e2d1401a$var$rsAstral = '[' + $729babd8e2d1401a$var$rsAstralRange + ']', $729babd8e2d1401a$var$rsCombo = '[' + $729babd8e2d1401a$var$rsComboRange + ']', $729babd8e2d1401a$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $729babd8e2d1401a$var$rsModifier = '(?:' + $729babd8e2d1401a$var$rsCombo + '|' + $729babd8e2d1401a$var$rsFitz + ')', $729babd8e2d1401a$var$rsNonAstral = '[^' + $729babd8e2d1401a$var$rsAstralRange + ']', $729babd8e2d1401a$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $729babd8e2d1401a$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $729babd8e2d1401a$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $729babd8e2d1401a$var$reOptMod = $729babd8e2d1401a$var$rsModifier + '?', $729babd8e2d1401a$var$rsOptVar = '[' + $729babd8e2d1401a$var$rsVarRange + ']?', $729babd8e2d1401a$var$rsOptJoin = '(?:' + $729babd8e2d1401a$var$rsZWJ + '(?:' + [
    $729babd8e2d1401a$var$rsNonAstral,
    $729babd8e2d1401a$var$rsRegional,
    $729babd8e2d1401a$var$rsSurrPair
].join('|') + ')' + $729babd8e2d1401a$var$rsOptVar + $729babd8e2d1401a$var$reOptMod + ')*', $729babd8e2d1401a$var$rsSeq = $729babd8e2d1401a$var$rsOptVar + $729babd8e2d1401a$var$reOptMod + $729babd8e2d1401a$var$rsOptJoin, $729babd8e2d1401a$var$rsSymbol = '(?:' + [
    $729babd8e2d1401a$var$rsNonAstral + $729babd8e2d1401a$var$rsCombo + '?',
    $729babd8e2d1401a$var$rsCombo,
    $729babd8e2d1401a$var$rsRegional,
    $729babd8e2d1401a$var$rsSurrPair,
    $729babd8e2d1401a$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $729babd8e2d1401a$var$reUnicode = RegExp($729babd8e2d1401a$var$rsFitz + '(?=' + $729babd8e2d1401a$var$rsFitz + ')|' + $729babd8e2d1401a$var$rsSymbol + $729babd8e2d1401a$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $729babd8e2d1401a$var$unicodeToArray(string) {
    return string.match($729babd8e2d1401a$var$reUnicode) || [];
}
module.exports = $729babd8e2d1401a$var$unicodeToArray;

});


parcelRegister("1H6Hi", function(module, exports) {

var $8gZl5 = parcelRequire("8gZl5");

var $6ZxOb = parcelRequire("6ZxOb");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $13bf008d2ba1b2ab$var$values(object) {
    return object == null ? [] : $8gZl5(object, $6ZxOb(object));
}
module.exports = $13bf008d2ba1b2ab$var$values;

});
parcelRegister("8gZl5", function(module, exports) {

var $aKSSk = parcelRequire("aKSSk");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $605f65fff508b91e$var$baseValues(object, props) {
    return $aKSSk(props, function(key) {
        return object[key];
    });
}
module.exports = $605f65fff508b91e$var$baseValues;

});




parcelRegister("kAjQZ", function(module, exports) {

var $cZ0ro = parcelRequire("cZ0ro");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $cZ0ro.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("80YiL", function(module, exports) {

var $hnLMc = parcelRequire("hnLMc");

var $fWng1 = parcelRequire("fWng1");

var $fyYMa = parcelRequire("fyYMa");

var $480y0 = parcelRequire("480y0");

var $1H6Hi = parcelRequire("1H6Hi");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5d5d197b4a6b1651$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $5d5d197b4a6b1651$var$includes(collection, value, fromIndex, guard) {
    collection = $fWng1(collection) ? collection : $1H6Hi(collection);
    fromIndex = fromIndex && !guard ? $480y0(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $5d5d197b4a6b1651$var$nativeMax(length + fromIndex, 0);
    return $fyYMa(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $hnLMc(collection, value, fromIndex) > -1;
}
module.exports = $5d5d197b4a6b1651$var$includes;

});
parcelRegister("hnLMc", function(module, exports) {

var $eFIJE = parcelRequire("eFIJE");

var $5rIDf = parcelRequire("5rIDf");

var $52BQB = parcelRequire("52BQB");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ca79a50c4ff49ad9$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $52BQB(array, value, fromIndex) : $eFIJE(array, $5rIDf, fromIndex);
}
module.exports = $ca79a50c4ff49ad9$var$baseIndexOf;

});
parcelRegister("eFIJE", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $aae798810b72dc40$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $aae798810b72dc40$var$baseFindIndex;

});

parcelRegister("5rIDf", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $3f72185a37485190$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $3f72185a37485190$var$baseIsNaN;

});

parcelRegister("52BQB", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $3aba7f639ce592ae$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $3aba7f639ce592ae$var$strictIndexOf;

});



parcelRegister("jk6VI", function(module, exports) {

var $dLFV8 = parcelRequire("dLFV8");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $e11542b1a5a9dd07$var$isEqual(value, other) {
    return $dLFV8(value, other);
}
module.exports = $e11542b1a5a9dd07$var$isEqual;

});
parcelRegister("dLFV8", function(module, exports) {

var $cZo0s = parcelRequire("cZo0s");

var $lIKbn = parcelRequire("lIKbn");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $a0602eb563948248$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$lIKbn(value) && !$lIKbn(other)) return value !== value && other !== other;
    return $cZo0s(value, other, bitmask, customizer, $a0602eb563948248$var$baseIsEqual, stack);
}
module.exports = $a0602eb563948248$var$baseIsEqual;

});
parcelRegister("cZo0s", function(module, exports) {

var $2uwmO = parcelRequire("2uwmO");

var $gOxXQ = parcelRequire("gOxXQ");

var $8hf4w = parcelRequire("8hf4w");

var $bG6nA = parcelRequire("bG6nA");

var $d2ghx = parcelRequire("d2ghx");

var $3vzLP = parcelRequire("3vzLP");

var $bX0UL = parcelRequire("bX0UL");

var $5EtPa = parcelRequire("5EtPa");
/** Used to compose bitmasks for value comparisons. */ var $974dcdb35d3050a7$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $974dcdb35d3050a7$var$argsTag = '[object Arguments]', $974dcdb35d3050a7$var$arrayTag = '[object Array]', $974dcdb35d3050a7$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $974dcdb35d3050a7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $974dcdb35d3050a7$var$hasOwnProperty = $974dcdb35d3050a7$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $974dcdb35d3050a7$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $3vzLP(object), othIsArr = $3vzLP(other), objTag = objIsArr ? $974dcdb35d3050a7$var$arrayTag : $d2ghx(object), othTag = othIsArr ? $974dcdb35d3050a7$var$arrayTag : $d2ghx(other);
    objTag = objTag == $974dcdb35d3050a7$var$argsTag ? $974dcdb35d3050a7$var$objectTag : objTag;
    othTag = othTag == $974dcdb35d3050a7$var$argsTag ? $974dcdb35d3050a7$var$objectTag : othTag;
    var objIsObj = objTag == $974dcdb35d3050a7$var$objectTag, othIsObj = othTag == $974dcdb35d3050a7$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $bX0UL(object)) {
        if (!$bX0UL(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $2uwmO);
        return objIsArr || $5EtPa(object) ? $gOxXQ(object, other, bitmask, customizer, equalFunc, stack) : $8hf4w(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $974dcdb35d3050a7$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $974dcdb35d3050a7$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $974dcdb35d3050a7$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $2uwmO);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $2uwmO);
    return $bG6nA(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $974dcdb35d3050a7$var$baseIsEqualDeep;

});
parcelRegister("2uwmO", function(module, exports) {

var $b9Oyy = parcelRequire("b9Oyy");

var $2z5zg = parcelRequire("2z5zg");

var $1Z5M2 = parcelRequire("1Z5M2");

var $2j7Fs = parcelRequire("2j7Fs");

var $4BMGv = parcelRequire("4BMGv");

var $eUrES = parcelRequire("eUrES");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1d077d8407623b9b$var$Stack(entries) {
    var data = this.__data__ = new $b9Oyy(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$1d077d8407623b9b$var$Stack.prototype.clear = $2z5zg;
$1d077d8407623b9b$var$Stack.prototype['delete'] = $1Z5M2;
$1d077d8407623b9b$var$Stack.prototype.get = $2j7Fs;
$1d077d8407623b9b$var$Stack.prototype.has = $4BMGv;
$1d077d8407623b9b$var$Stack.prototype.set = $eUrES;
module.exports = $1d077d8407623b9b$var$Stack;

});
parcelRegister("b9Oyy", function(module, exports) {

var $gDGoz = parcelRequire("gDGoz");

var $8EH86 = parcelRequire("8EH86");

var $7btUR = parcelRequire("7btUR");

var $85Sps = parcelRequire("85Sps");

var $jNT9j = parcelRequire("jNT9j");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $81f7c06ce2e92d12$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$81f7c06ce2e92d12$var$ListCache.prototype.clear = $gDGoz;
$81f7c06ce2e92d12$var$ListCache.prototype['delete'] = $8EH86;
$81f7c06ce2e92d12$var$ListCache.prototype.get = $7btUR;
$81f7c06ce2e92d12$var$ListCache.prototype.has = $85Sps;
$81f7c06ce2e92d12$var$ListCache.prototype.set = $jNT9j;
module.exports = $81f7c06ce2e92d12$var$ListCache;

});
parcelRegister("gDGoz", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $c1d12cb0e2047da1$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $c1d12cb0e2047da1$var$listCacheClear;

});

parcelRegister("8EH86", function(module, exports) {

var $S5jVT = parcelRequire("S5jVT");
/** Used for built-in method references. */ var $64d383d545f705ec$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $64d383d545f705ec$var$splice = $64d383d545f705ec$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $64d383d545f705ec$var$listCacheDelete(key) {
    var data = this.__data__, index = $S5jVT(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $64d383d545f705ec$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $64d383d545f705ec$var$listCacheDelete;

});
parcelRegister("S5jVT", function(module, exports) {

var $68RuN = parcelRequire("68RuN");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $0a292bcce34735a3$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($68RuN(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $0a292bcce34735a3$var$assocIndexOf;

});


parcelRegister("7btUR", function(module, exports) {

var $S5jVT = parcelRequire("S5jVT");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $53b0c42d501956ed$var$listCacheGet(key) {
    var data = this.__data__, index = $S5jVT(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $53b0c42d501956ed$var$listCacheGet;

});

parcelRegister("85Sps", function(module, exports) {

var $S5jVT = parcelRequire("S5jVT");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $5e48fef7fbcc6b8f$var$listCacheHas(key) {
    return $S5jVT(this.__data__, key) > -1;
}
module.exports = $5e48fef7fbcc6b8f$var$listCacheHas;

});

parcelRegister("jNT9j", function(module, exports) {

var $S5jVT = parcelRequire("S5jVT");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $03b87947ef179ce3$var$listCacheSet(key, value) {
    var data = this.__data__, index = $S5jVT(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $03b87947ef179ce3$var$listCacheSet;

});


parcelRegister("2z5zg", function(module, exports) {

var $b9Oyy = parcelRequire("b9Oyy");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $1de32b4a0e30e9ee$var$stackClear() {
    this.__data__ = new $b9Oyy;
    this.size = 0;
}
module.exports = $1de32b4a0e30e9ee$var$stackClear;

});

parcelRegister("1Z5M2", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $171ff78148ae5fa7$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $171ff78148ae5fa7$var$stackDelete;

});

parcelRegister("2j7Fs", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1ae34dbe070f7c73$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $1ae34dbe070f7c73$var$stackGet;

});

parcelRegister("4BMGv", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $35b061db8178c26c$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $35b061db8178c26c$var$stackHas;

});

parcelRegister("eUrES", function(module, exports) {

var $b9Oyy = parcelRequire("b9Oyy");

var $2YkTl = parcelRequire("2YkTl");

var $5ge2x = parcelRequire("5ge2x");
/** Used as the size to enable large array optimizations. */ var $adabc002b6db4db9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $adabc002b6db4db9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $b9Oyy) {
        var pairs = data.__data__;
        if (!$2YkTl || pairs.length < $adabc002b6db4db9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $5ge2x(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $adabc002b6db4db9$var$stackSet;

});
parcelRegister("5ge2x", function(module, exports) {

var $77p3V = parcelRequire("77p3V");

var $5bZlA = parcelRequire("5bZlA");

var $kNTgS = parcelRequire("kNTgS");

var $di31A = parcelRequire("di31A");

var $gyQQg = parcelRequire("gyQQg");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $3d49566f8d6c9a26$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$3d49566f8d6c9a26$var$MapCache.prototype.clear = $77p3V;
$3d49566f8d6c9a26$var$MapCache.prototype['delete'] = $5bZlA;
$3d49566f8d6c9a26$var$MapCache.prototype.get = $kNTgS;
$3d49566f8d6c9a26$var$MapCache.prototype.has = $di31A;
$3d49566f8d6c9a26$var$MapCache.prototype.set = $gyQQg;
module.exports = $3d49566f8d6c9a26$var$MapCache;

});
parcelRegister("77p3V", function(module, exports) {

var $jKGaM = parcelRequire("jKGaM");

var $b9Oyy = parcelRequire("b9Oyy");

var $2YkTl = parcelRequire("2YkTl");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $52eca0b207d0a1f8$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $jKGaM,
        'map': new ($2YkTl || $b9Oyy),
        'string': new $jKGaM
    };
}
module.exports = $52eca0b207d0a1f8$var$mapCacheClear;

});
parcelRegister("jKGaM", function(module, exports) {

var $bhr1X = parcelRequire("bhr1X");

var $22hz1 = parcelRequire("22hz1");

var $fMhQR = parcelRequire("fMhQR");

var $ghudw = parcelRequire("ghudw");

var $69vCj = parcelRequire("69vCj");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e61306d4bac4df2b$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$e61306d4bac4df2b$var$Hash.prototype.clear = $bhr1X;
$e61306d4bac4df2b$var$Hash.prototype['delete'] = $22hz1;
$e61306d4bac4df2b$var$Hash.prototype.get = $fMhQR;
$e61306d4bac4df2b$var$Hash.prototype.has = $ghudw;
$e61306d4bac4df2b$var$Hash.prototype.set = $69vCj;
module.exports = $e61306d4bac4df2b$var$Hash;

});
parcelRegister("bhr1X", function(module, exports) {

var $2vDHg = parcelRequire("2vDHg");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $83663ff68c97cbe8$var$hashClear() {
    this.__data__ = $2vDHg ? $2vDHg(null) : {};
    this.size = 0;
}
module.exports = $83663ff68c97cbe8$var$hashClear;

});
parcelRegister("2vDHg", function(module, exports) {

var $6t9o5 = parcelRequire("6t9o5");
/* Built-in method references that are verified to be native. */ var $1d3d44fe2a4cd079$var$nativeCreate = $6t9o5(Object, 'create');
module.exports = $1d3d44fe2a4cd079$var$nativeCreate;

});


parcelRegister("22hz1", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $17b9647bfaeb78d9$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $17b9647bfaeb78d9$var$hashDelete;

});

parcelRegister("fMhQR", function(module, exports) {

var $2vDHg = parcelRequire("2vDHg");
/** Used to stand-in for `undefined` hash values. */ var $b7c92faa7730ac78$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $b7c92faa7730ac78$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b7c92faa7730ac78$var$hasOwnProperty = $b7c92faa7730ac78$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b7c92faa7730ac78$var$hashGet(key) {
    var data = this.__data__;
    if ($2vDHg) {
        var result = data[key];
        return result === $b7c92faa7730ac78$var$HASH_UNDEFINED ? undefined : result;
    }
    return $b7c92faa7730ac78$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $b7c92faa7730ac78$var$hashGet;

});

parcelRegister("ghudw", function(module, exports) {

var $2vDHg = parcelRequire("2vDHg");
/** Used for built-in method references. */ var $bda5ac5d8262c903$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bda5ac5d8262c903$var$hasOwnProperty = $bda5ac5d8262c903$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $bda5ac5d8262c903$var$hashHas(key) {
    var data = this.__data__;
    return $2vDHg ? data[key] !== undefined : $bda5ac5d8262c903$var$hasOwnProperty.call(data, key);
}
module.exports = $bda5ac5d8262c903$var$hashHas;

});

parcelRegister("69vCj", function(module, exports) {

var $2vDHg = parcelRequire("2vDHg");
/** Used to stand-in for `undefined` hash values. */ var $47ac1bd2954f96cd$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $47ac1bd2954f96cd$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $2vDHg && value === undefined ? $47ac1bd2954f96cd$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $47ac1bd2954f96cd$var$hashSet;

});



parcelRegister("5bZlA", function(module, exports) {

var $2JpXw = parcelRequire("2JpXw");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3c7d91139af74cd2$var$mapCacheDelete(key) {
    var result = $2JpXw(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $3c7d91139af74cd2$var$mapCacheDelete;

});
parcelRegister("2JpXw", function(module, exports) {

var $3phSV = parcelRequire("3phSV");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $1fd3ebab95d36ddb$var$getMapData(map, key) {
    var data = map.__data__;
    return $3phSV(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $1fd3ebab95d36ddb$var$getMapData;

});
parcelRegister("3phSV", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $27b194787b6ec354$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $27b194787b6ec354$var$isKeyable;

});



parcelRegister("kNTgS", function(module, exports) {

var $2JpXw = parcelRequire("2JpXw");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f25341f19695d7a3$var$mapCacheGet(key) {
    return $2JpXw(this, key).get(key);
}
module.exports = $f25341f19695d7a3$var$mapCacheGet;

});

parcelRegister("di31A", function(module, exports) {

var $2JpXw = parcelRequire("2JpXw");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9acf4d6e15791fcd$var$mapCacheHas(key) {
    return $2JpXw(this, key).has(key);
}
module.exports = $9acf4d6e15791fcd$var$mapCacheHas;

});

parcelRegister("gyQQg", function(module, exports) {

var $2JpXw = parcelRequire("2JpXw");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c0e8cfa5d5b764b5$var$mapCacheSet(key, value) {
    var data = $2JpXw(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $c0e8cfa5d5b764b5$var$mapCacheSet;

});




parcelRegister("gOxXQ", function(module, exports) {

var $guANY = parcelRequire("guANY");

var $hrLV4 = parcelRequire("hrLV4");

var $fSRGV = parcelRequire("fSRGV");
/** Used to compose bitmasks for value comparisons. */ var $c3dba976f4008acc$var$COMPARE_PARTIAL_FLAG = 1, $c3dba976f4008acc$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $c3dba976f4008acc$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $c3dba976f4008acc$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $c3dba976f4008acc$var$COMPARE_UNORDERED_FLAG ? new $guANY : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$hrLV4(other, function(othValue, othIndex) {
                if (!$fSRGV(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $c3dba976f4008acc$var$equalArrays;

});
parcelRegister("guANY", function(module, exports) {

var $5ge2x = parcelRequire("5ge2x");

var $32sGx = parcelRequire("32sGx");

var $caz18 = parcelRequire("caz18");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $c01bff60fa271fa1$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $5ge2x;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$c01bff60fa271fa1$var$SetCache.prototype.add = $c01bff60fa271fa1$var$SetCache.prototype.push = $32sGx;
$c01bff60fa271fa1$var$SetCache.prototype.has = $caz18;
module.exports = $c01bff60fa271fa1$var$SetCache;

});
parcelRegister("32sGx", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $2367cf49337ec652$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $2367cf49337ec652$var$setCacheAdd(value) {
    this.__data__.set(value, $2367cf49337ec652$var$HASH_UNDEFINED);
    return this;
}
module.exports = $2367cf49337ec652$var$setCacheAdd;

});

parcelRegister("caz18", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $8dc194eb1caf983e$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $8dc194eb1caf983e$var$setCacheHas;

});


parcelRegister("hrLV4", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $cb3a211ae637dc0f$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $cb3a211ae637dc0f$var$arraySome;

});

parcelRegister("fSRGV", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $b9058c267cff38f8$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $b9058c267cff38f8$var$cacheHas;

});


parcelRegister("8hf4w", function(module, exports) {

var $7xLVY = parcelRequire("7xLVY");

var $96NMI = parcelRequire("96NMI");

var $68RuN = parcelRequire("68RuN");

var $gOxXQ = parcelRequire("gOxXQ");

var $ig5JO = parcelRequire("ig5JO");

var $kk6VW = parcelRequire("kk6VW");
/** Used to compose bitmasks for value comparisons. */ var $606b9a39a96d523f$var$COMPARE_PARTIAL_FLAG = 1, $606b9a39a96d523f$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $606b9a39a96d523f$var$boolTag = '[object Boolean]', $606b9a39a96d523f$var$dateTag = '[object Date]', $606b9a39a96d523f$var$errorTag = '[object Error]', $606b9a39a96d523f$var$mapTag = '[object Map]', $606b9a39a96d523f$var$numberTag = '[object Number]', $606b9a39a96d523f$var$regexpTag = '[object RegExp]', $606b9a39a96d523f$var$setTag = '[object Set]', $606b9a39a96d523f$var$stringTag = '[object String]', $606b9a39a96d523f$var$symbolTag = '[object Symbol]';
var $606b9a39a96d523f$var$arrayBufferTag = '[object ArrayBuffer]', $606b9a39a96d523f$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $606b9a39a96d523f$var$symbolProto = $7xLVY ? $7xLVY.prototype : undefined, $606b9a39a96d523f$var$symbolValueOf = $606b9a39a96d523f$var$symbolProto ? $606b9a39a96d523f$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $606b9a39a96d523f$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $606b9a39a96d523f$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $606b9a39a96d523f$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $96NMI(object), new $96NMI(other))) return false;
            return true;
        case $606b9a39a96d523f$var$boolTag:
        case $606b9a39a96d523f$var$dateTag:
        case $606b9a39a96d523f$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $68RuN(+object, +other);
        case $606b9a39a96d523f$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $606b9a39a96d523f$var$regexpTag:
        case $606b9a39a96d523f$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $606b9a39a96d523f$var$mapTag:
            var convert = $ig5JO;
        case $606b9a39a96d523f$var$setTag:
            var isPartial = bitmask & $606b9a39a96d523f$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $kk6VW);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $606b9a39a96d523f$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $gOxXQ(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $606b9a39a96d523f$var$symbolTag:
            if ($606b9a39a96d523f$var$symbolValueOf) return $606b9a39a96d523f$var$symbolValueOf.call(object) == $606b9a39a96d523f$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $606b9a39a96d523f$var$equalByTag;

});
parcelRegister("96NMI", function(module, exports) {

var $cZ0ro = parcelRequire("cZ0ro");
/** Built-in value references. */ var $6a1b4acd3c53d75e$var$Uint8Array = $cZ0ro.Uint8Array;
module.exports = $6a1b4acd3c53d75e$var$Uint8Array;

});


parcelRegister("bG6nA", function(module, exports) {

var $bB4KE = parcelRequire("bB4KE");
/** Used to compose bitmasks for value comparisons. */ var $880890cce3af35d7$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $880890cce3af35d7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $880890cce3af35d7$var$hasOwnProperty = $880890cce3af35d7$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $880890cce3af35d7$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $880890cce3af35d7$var$COMPARE_PARTIAL_FLAG, objProps = $bB4KE(object), objLength = objProps.length, othProps = $bB4KE(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $880890cce3af35d7$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $880890cce3af35d7$var$equalObjects;

});
parcelRegister("bB4KE", function(module, exports) {

var $67Ves = parcelRequire("67Ves");

var $5laD4 = parcelRequire("5laD4");

var $6ZxOb = parcelRequire("6ZxOb");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8716d5f273dd32b5$var$getAllKeys(object) {
    return $67Ves(object, $6ZxOb, $5laD4);
}
module.exports = $8716d5f273dd32b5$var$getAllKeys;

});
parcelRegister("67Ves", function(module, exports) {

var $l3S2a = parcelRequire("l3S2a");

var $3vzLP = parcelRequire("3vzLP");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $475fcaa8b8ea06aa$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $3vzLP(object) ? result : $l3S2a(result, symbolsFunc(object));
}
module.exports = $475fcaa8b8ea06aa$var$baseGetAllKeys;

});
parcelRegister("l3S2a", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $f553cacb016081f4$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $f553cacb016081f4$var$arrayPush;

});


parcelRegister("5laD4", function(module, exports) {

var $fSlXE = parcelRequire("fSlXE");

var $92CqY = parcelRequire("92CqY");
/** Used for built-in method references. */ var $3e3728ab57c58873$var$objectProto = Object.prototype;
/** Built-in value references. */ var $3e3728ab57c58873$var$propertyIsEnumerable = $3e3728ab57c58873$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $3e3728ab57c58873$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $3e3728ab57c58873$var$getSymbols = !$3e3728ab57c58873$var$nativeGetSymbols ? $92CqY : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $fSlXE($3e3728ab57c58873$var$nativeGetSymbols(object), function(symbol) {
        return $3e3728ab57c58873$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $3e3728ab57c58873$var$getSymbols;

});
parcelRegister("fSlXE", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $b8ecef2f48871adc$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $b8ecef2f48871adc$var$arrayFilter;

});

parcelRegister("92CqY", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $69521d249bb90d55$var$stubArray() {
    return [];
}
module.exports = $69521d249bb90d55$var$stubArray;

});







parcelRegister("h5CXZ", function(module, exports) {

var $an76h = parcelRequire("an76h");

var $dGp9H = parcelRequire("dGp9H");

var $3RlGb = parcelRequire("3RlGb");

var $3YGtA = parcelRequire("3YGtA");

var $fWng1 = parcelRequire("fWng1");
/**
 * Invokes the method at `path` of each element in `collection`, returning
 * an array of the results of each invoked method. Any additional arguments
 * are provided to each invoked method. If `path` is a function, it's invoked
 * for, and `this` bound to, each element in `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array|Function|string} path The path of the method to invoke or
 *  the function invoked per iteration.
 * @param {...*} [args] The arguments to invoke each method with.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
 * // => [[1, 5, 7], [1, 2, 3]]
 *
 * _.invokeMap([123, 456], String.prototype.split, '');
 * // => [['1', '2', '3'], ['4', '5', '6']]
 */ var $c711213d2d856944$var$invokeMap = $3YGtA(function(collection, path, args) {
    var index = -1, isFunc = typeof path == 'function', result = $fWng1(collection) ? Array(collection.length) : [];
    $dGp9H(collection, function(value) {
        result[++index] = isFunc ? $an76h(path, value, args) : $3RlGb(value, path, args);
    });
    return result;
});
module.exports = $c711213d2d856944$var$invokeMap;

});
parcelRegister("3RlGb", function(module, exports) {

var $an76h = parcelRequire("an76h");

var $2n45k = parcelRequire("2n45k");

var $aMHB4 = parcelRequire("aMHB4");

var $6purz = parcelRequire("6purz");

var $gYGgF = parcelRequire("gYGgF");
/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */ function $2cf72369ae5cd3ff$var$baseInvoke(object, path, args) {
    path = $2n45k(path, object);
    object = $6purz(object, path);
    var func = object == null ? object : object[$gYGgF($aMHB4(path))];
    return func == null ? undefined : $an76h(func, object, args);
}
module.exports = $2cf72369ae5cd3ff$var$baseInvoke;

});
parcelRegister("2n45k", function(module, exports) {

var $3vzLP = parcelRequire("3vzLP");

var $3tsA1 = parcelRequire("3tsA1");

var $7j8J7 = parcelRequire("7j8J7");

var $gA8dA = parcelRequire("gA8dA");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $1ba0e5f46139b2a5$var$castPath(value, object) {
    if ($3vzLP(value)) return value;
    return $3tsA1(value, object) ? [
        value
    ] : $7j8J7($gA8dA(value));
}
module.exports = $1ba0e5f46139b2a5$var$castPath;

});
parcelRegister("3tsA1", function(module, exports) {

var $3vzLP = parcelRequire("3vzLP");

var $eHNuH = parcelRequire("eHNuH");
/** Used to match property names within property paths. */ var $287a3fefcbb32647$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $287a3fefcbb32647$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $287a3fefcbb32647$var$isKey(value, object) {
    if ($3vzLP(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $eHNuH(value)) return true;
    return $287a3fefcbb32647$var$reIsPlainProp.test(value) || !$287a3fefcbb32647$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $287a3fefcbb32647$var$isKey;

});

parcelRegister("7j8J7", function(module, exports) {

var $hFF93 = parcelRequire("hFF93");
/** Used to match property names within property paths. */ var $552113b83de1d436$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $552113b83de1d436$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $552113b83de1d436$var$stringToPath = $hFF93(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($552113b83de1d436$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($552113b83de1d436$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $552113b83de1d436$var$stringToPath;

});
parcelRegister("hFF93", function(module, exports) {

var $7F3oj = parcelRequire("7F3oj");
/** Used as the maximum memoize cache size. */ var $cdd62e90d29e4d41$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $cdd62e90d29e4d41$var$memoizeCapped(func) {
    var result = $7F3oj(func, function(key) {
        if (cache.size === $cdd62e90d29e4d41$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $cdd62e90d29e4d41$var$memoizeCapped;

});
parcelRegister("7F3oj", function(module, exports) {

var $5ge2x = parcelRequire("5ge2x");
/** Error message constants. */ var $593efe256a1afb21$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $593efe256a1afb21$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($593efe256a1afb21$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($593efe256a1afb21$var$memoize.Cache || $5ge2x);
    return memoized;
}
// Expose `MapCache`.
$593efe256a1afb21$var$memoize.Cache = $5ge2x;
module.exports = $593efe256a1afb21$var$memoize;

});




parcelRegister("aMHB4", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $7da034808db8f30c$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $7da034808db8f30c$var$last;

});

parcelRegister("6purz", function(module, exports) {

var $bgK8G = parcelRequire("bgK8G");

var $3RqdV = parcelRequire("3RqdV");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $4aacb159f6a8f899$var$parent(object, path) {
    return path.length < 2 ? object : $bgK8G(object, $3RqdV(path, 0, -1));
}
module.exports = $4aacb159f6a8f899$var$parent;

});
parcelRegister("bgK8G", function(module, exports) {

var $2n45k = parcelRequire("2n45k");

var $gYGgF = parcelRequire("gYGgF");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $8344fa94ee29e42a$var$baseGet(object, path) {
    path = $2n45k(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$gYGgF(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $8344fa94ee29e42a$var$baseGet;

});
parcelRegister("gYGgF", function(module, exports) {

var $eHNuH = parcelRequire("eHNuH");
/** Used as references for various `Number` constants. */ var $c5c3096d7a619e52$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $c5c3096d7a619e52$var$toKey(value) {
    if (typeof value == 'string' || $eHNuH(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$c5c3096d7a619e52$var$INFINITY ? '-0' : result;
}
module.exports = $c5c3096d7a619e52$var$toKey;

});


parcelRegister("3RqdV", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $2cfaa9cb9fa5f01d$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $2cfaa9cb9fa5f01d$var$baseSlice;

});




parcelRegister("l1UaK", function(module, exports) {

var $et5et = parcelRequire("et5et");

var $01eUA = parcelRequire("01eUA");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $f4f5439e08794c54$var$find = $et5et($01eUA);
module.exports = $f4f5439e08794c54$var$find;

});
parcelRegister("et5et", function(module, exports) {

var $gy2mG = parcelRequire("gy2mG");

var $fWng1 = parcelRequire("fWng1");

var $6ZxOb = parcelRequire("6ZxOb");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $a887d52fa75b8dc8$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$fWng1(collection)) {
            var iteratee = $gy2mG(predicate, 3);
            collection = $6ZxOb(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $a887d52fa75b8dc8$var$createFind;

});
parcelRegister("gy2mG", function(module, exports) {

var $bpPnp = parcelRequire("bpPnp");

var $k0jFR = parcelRequire("k0jFR");

var $9qV0f = parcelRequire("9qV0f");

var $3vzLP = parcelRequire("3vzLP");

var $i3Mlr = parcelRequire("i3Mlr");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $c0c1a7ef66f05019$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $9qV0f;
    if (typeof value == 'object') return $3vzLP(value) ? $k0jFR(value[0], value[1]) : $bpPnp(value);
    return $i3Mlr(value);
}
module.exports = $c0c1a7ef66f05019$var$baseIteratee;

});
parcelRegister("bpPnp", function(module, exports) {

var $9VSOc = parcelRequire("9VSOc");

var $6bnvc = parcelRequire("6bnvc");

var $7dXGr = parcelRequire("7dXGr");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $84f9e1d3f43c89c2$var$baseMatches(source) {
    var matchData = $6bnvc(source);
    if (matchData.length == 1 && matchData[0][2]) return $7dXGr(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $9VSOc(object, source, matchData);
    };
}
module.exports = $84f9e1d3f43c89c2$var$baseMatches;

});
parcelRegister("9VSOc", function(module, exports) {

var $2uwmO = parcelRequire("2uwmO");

var $dLFV8 = parcelRequire("dLFV8");
/** Used to compose bitmasks for value comparisons. */ var $73b3f3cd5e8c6553$var$COMPARE_PARTIAL_FLAG = 1, $73b3f3cd5e8c6553$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $73b3f3cd5e8c6553$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $2uwmO;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $dLFV8(srcValue, objValue, $73b3f3cd5e8c6553$var$COMPARE_PARTIAL_FLAG | $73b3f3cd5e8c6553$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $73b3f3cd5e8c6553$var$baseIsMatch;

});

parcelRegister("6bnvc", function(module, exports) {

var $jJSC5 = parcelRequire("jJSC5");

var $6ZxOb = parcelRequire("6ZxOb");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $48060033b8e29b53$var$getMatchData(object) {
    var result = $6ZxOb(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $jJSC5(value)
        ];
    }
    return result;
}
module.exports = $48060033b8e29b53$var$getMatchData;

});
parcelRegister("jJSC5", function(module, exports) {

var $5DUFR = parcelRequire("5DUFR");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $e5ec955849c6d734$var$isStrictComparable(value) {
    return value === value && !$5DUFR(value);
}
module.exports = $e5ec955849c6d734$var$isStrictComparable;

});


parcelRegister("7dXGr", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $54280b36dfeb07b2$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $54280b36dfeb07b2$var$matchesStrictComparable;

});


parcelRegister("k0jFR", function(module, exports) {

var $dLFV8 = parcelRequire("dLFV8");

var $NwRvq = parcelRequire("NwRvq");

var $72SqL = parcelRequire("72SqL");

var $3tsA1 = parcelRequire("3tsA1");

var $jJSC5 = parcelRequire("jJSC5");

var $7dXGr = parcelRequire("7dXGr");

var $gYGgF = parcelRequire("gYGgF");
/** Used to compose bitmasks for value comparisons. */ var $e903119817906326$var$COMPARE_PARTIAL_FLAG = 1, $e903119817906326$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $e903119817906326$var$baseMatchesProperty(path, srcValue) {
    if ($3tsA1(path) && $jJSC5(srcValue)) return $7dXGr($gYGgF(path), srcValue);
    return function(object) {
        var objValue = $NwRvq(object, path);
        return objValue === undefined && objValue === srcValue ? $72SqL(object, path) : $dLFV8(srcValue, objValue, $e903119817906326$var$COMPARE_PARTIAL_FLAG | $e903119817906326$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $e903119817906326$var$baseMatchesProperty;

});
parcelRegister("NwRvq", function(module, exports) {

var $bgK8G = parcelRequire("bgK8G");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $094e116d21259c57$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $bgK8G(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $094e116d21259c57$var$get;

});

parcelRegister("72SqL", function(module, exports) {

var $5llBg = parcelRequire("5llBg");

var $kIHN7 = parcelRequire("kIHN7");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $5212f11af76bf72f$var$hasIn(object, path) {
    return object != null && $kIHN7(object, path, $5llBg);
}
module.exports = $5212f11af76bf72f$var$hasIn;

});
parcelRegister("5llBg", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3e3fab364870db3f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $3e3fab364870db3f$var$baseHasIn;

});

parcelRegister("kIHN7", function(module, exports) {

var $2n45k = parcelRequire("2n45k");

var $2NLAx = parcelRequire("2NLAx");

var $3vzLP = parcelRequire("3vzLP");

var $c8QtW = parcelRequire("c8QtW");

var $5CvfY = parcelRequire("5CvfY");

var $gYGgF = parcelRequire("gYGgF");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $f159e2bcd4866ae1$var$hasPath(object, path, hasFunc) {
    path = $2n45k(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $gYGgF(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $5CvfY(length) && $c8QtW(key, length) && ($3vzLP(object) || $2NLAx(object));
}
module.exports = $f159e2bcd4866ae1$var$hasPath;

});



parcelRegister("i3Mlr", function(module, exports) {

var $enqiH = parcelRequire("enqiH");

var $h3Dyu = parcelRequire("h3Dyu");

var $3tsA1 = parcelRequire("3tsA1");

var $gYGgF = parcelRequire("gYGgF");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $d25e020ff22d17be$var$property(path) {
    return $3tsA1(path) ? $enqiH($gYGgF(path)) : $h3Dyu(path);
}
module.exports = $d25e020ff22d17be$var$property;

});
parcelRegister("enqiH", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $a7779d71d194c4ef$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $a7779d71d194c4ef$var$baseProperty;

});

parcelRegister("h3Dyu", function(module, exports) {

var $bgK8G = parcelRequire("bgK8G");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $c6b1665a7f1252d2$var$basePropertyDeep(path) {
    return function(object) {
        return $bgK8G(object, path);
    };
}
module.exports = $c6b1665a7f1252d2$var$basePropertyDeep;

});




parcelRegister("01eUA", function(module, exports) {

var $eFIJE = parcelRequire("eFIJE");

var $gy2mG = parcelRequire("gy2mG");

var $480y0 = parcelRequire("480y0");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $003ba949c6c4647c$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $003ba949c6c4647c$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $480y0(fromIndex);
    if (index < 0) index = $003ba949c6c4647c$var$nativeMax(length + index, 0);
    return $eFIJE(array, $gy2mG(predicate, 3), index);
}
module.exports = $003ba949c6c4647c$var$findIndex;

});


parcelRegister("4V7X5", function(module, exports) {

var $4FnQc = parcelRequire("4FnQc");

var $IWrCz = parcelRequire("IWrCz");

var $3YGtA = parcelRequire("3YGtA");

var $Gs9n2 = parcelRequire("Gs9n2");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $3952a7690c706f06$var$difference = $3YGtA(function(array, values) {
    return $Gs9n2(array) ? $4FnQc(array, $IWrCz(values, 1, $Gs9n2, true)) : [];
});
module.exports = $3952a7690c706f06$var$difference;

});
parcelRegister("4FnQc", function(module, exports) {

var $guANY = parcelRequire("guANY");

var $f9USe = parcelRequire("f9USe");

var $jzvSQ = parcelRequire("jzvSQ");

var $aKSSk = parcelRequire("aKSSk");

var $iqpCQ = parcelRequire("iqpCQ");

var $fSRGV = parcelRequire("fSRGV");
/** Used as the size to enable large array optimizations. */ var $365d7c11fee833f7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $365d7c11fee833f7$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $f9USe, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $aKSSk(values, $iqpCQ(iteratee));
    if (comparator) {
        includes = $jzvSQ;
        isCommon = false;
    } else if (values.length >= $365d7c11fee833f7$var$LARGE_ARRAY_SIZE) {
        includes = $fSRGV;
        isCommon = false;
        values = new $guANY(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $365d7c11fee833f7$var$baseDifference;

});
parcelRegister("f9USe", function(module, exports) {

var $hnLMc = parcelRequire("hnLMc");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $b093d03ba9e0e42c$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $hnLMc(array, value, 0) > -1;
}
module.exports = $b093d03ba9e0e42c$var$arrayIncludes;

});

parcelRegister("jzvSQ", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $e3fa04a1ff2538d3$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $e3fa04a1ff2538d3$var$arrayIncludesWith;

});


parcelRegister("IWrCz", function(module, exports) {

var $l3S2a = parcelRequire("l3S2a");

var $5X6mM = parcelRequire("5X6mM");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $0871720925269968$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $5X6mM);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $0871720925269968$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $l3S2a(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $0871720925269968$var$baseFlatten;

});
parcelRegister("5X6mM", function(module, exports) {

var $7xLVY = parcelRequire("7xLVY");

var $2NLAx = parcelRequire("2NLAx");

var $3vzLP = parcelRequire("3vzLP");
/** Built-in value references. */ var $455766aa2b2707ba$var$spreadableSymbol = $7xLVY ? $7xLVY.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $455766aa2b2707ba$var$isFlattenable(value) {
    return $3vzLP(value) || $2NLAx(value) || !!($455766aa2b2707ba$var$spreadableSymbol && value && value[$455766aa2b2707ba$var$spreadableSymbol]);
}
module.exports = $455766aa2b2707ba$var$isFlattenable;

});


parcelRegister("Gs9n2", function(module, exports) {

var $fWng1 = parcelRequire("fWng1");

var $lIKbn = parcelRequire("lIKbn");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $07f9c263a5ac11ca$var$isArrayLikeObject(value) {
    return $lIKbn(value) && $fWng1(value);
}
module.exports = $07f9c263a5ac11ca$var$isArrayLikeObject;

});


parcelRegister("eBZ53", function(module, exports) {

var $94D24 = parcelRequire("94D24");

var $i95Jn = parcelRequire("i95Jn");

var $gy2mG = parcelRequire("gy2mG");

var $3vzLP = parcelRequire("3vzLP");

var $dpoHm = parcelRequire("dpoHm");
/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $aa33e6bac94ac4bb$var$every(collection, predicate, guard) {
    var func = $3vzLP(collection) ? $94D24 : $i95Jn;
    if (guard && $dpoHm(collection, predicate, guard)) predicate = undefined;
    return func(collection, $gy2mG(predicate, 3));
}
module.exports = $aa33e6bac94ac4bb$var$every;

});
parcelRegister("94D24", function(module, exports) {
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $69b2c3d1f9deaf5e$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
module.exports = $69b2c3d1f9deaf5e$var$arrayEvery;

});

parcelRegister("i95Jn", function(module, exports) {

var $dGp9H = parcelRequire("dGp9H");
/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $d35d83510d8b23f4$var$baseEvery(collection, predicate) {
    var result = true;
    $dGp9H(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
module.exports = $d35d83510d8b23f4$var$baseEvery;

});


parcelRegister("9yJUW", function(module, exports) {

var $fq4u5 = parcelRequire("fq4u5");

var $dGp9H = parcelRequire("dGp9H");

var $gy2mG = parcelRequire("gy2mG");

var $gi5UF = parcelRequire("gi5UF");

var $3vzLP = parcelRequire("3vzLP");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $6f5ae849dc429a8e$var$reduce(collection, iteratee, accumulator) {
    var func = $3vzLP(collection) ? $fq4u5 : $gi5UF, initAccum = arguments.length < 3;
    return func(collection, $gy2mG(iteratee, 4), accumulator, initAccum, $dGp9H);
}
module.exports = $6f5ae849dc429a8e$var$reduce;

});
parcelRegister("fq4u5", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $b39cc330d45aa9ff$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $b39cc330d45aa9ff$var$arrayReduce;

});

parcelRegister("gi5UF", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $bdc2e9f7bb74073c$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $bdc2e9f7bb74073c$var$baseReduce;

});


parcelRegister("1NfP2", function(module, exports) {

var $IWrCz = parcelRequire("IWrCz");

var $kXvUP = parcelRequire("kXvUP");

var $3YGtA = parcelRequire("3YGtA");

var $dpoHm = parcelRequire("dpoHm");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $14e6a3feb0edf9f4$var$sortBy = $3YGtA(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $dpoHm(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $dpoHm(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $kXvUP(collection, $IWrCz(iteratees, 1), []);
});
module.exports = $14e6a3feb0edf9f4$var$sortBy;

});
parcelRegister("kXvUP", function(module, exports) {

var $aKSSk = parcelRequire("aKSSk");

var $bgK8G = parcelRequire("bgK8G");

var $gy2mG = parcelRequire("gy2mG");

var $jknZ1 = parcelRequire("jknZ1");

var $2rgi6 = parcelRequire("2rgi6");

var $iqpCQ = parcelRequire("iqpCQ");

var $i2vSV = parcelRequire("i2vSV");

var $9qV0f = parcelRequire("9qV0f");

var $3vzLP = parcelRequire("3vzLP");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $f4221315a23e3af7$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $aKSSk(iteratees, function(iteratee) {
        if ($3vzLP(iteratee)) return function(value) {
            return $bgK8G(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $9qV0f
    ];
    var index = -1;
    iteratees = $aKSSk(iteratees, $iqpCQ($gy2mG));
    var result = $jknZ1(collection, function(value, key, collection) {
        var criteria = $aKSSk(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $2rgi6(result, function(object, other) {
        return $i2vSV(object, other, orders);
    });
}
module.exports = $f4221315a23e3af7$var$baseOrderBy;

});
parcelRegister("jknZ1", function(module, exports) {

var $dGp9H = parcelRequire("dGp9H");

var $fWng1 = parcelRequire("fWng1");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e1227d21a1bace08$var$baseMap(collection, iteratee) {
    var index = -1, result = $fWng1(collection) ? Array(collection.length) : [];
    $dGp9H(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e1227d21a1bace08$var$baseMap;

});

parcelRegister("2rgi6", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $1c6abd6e680e9e7a$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $1c6abd6e680e9e7a$var$baseSortBy;

});

parcelRegister("i2vSV", function(module, exports) {

var $34Yo2 = parcelRequire("34Yo2");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $d221259680ae9ea5$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $34Yo2(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $d221259680ae9ea5$var$compareMultiple;

});
parcelRegister("34Yo2", function(module, exports) {

var $eHNuH = parcelRequire("eHNuH");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $23e09656a19fad40$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $eHNuH(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $eHNuH(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $23e09656a19fad40$var$compareAscending;

});




parcelRegister("aPdrE", function(module, exports) {
exports = module.exports = trim;
function trim(str) {
    return str.replace(/^\s*|\s*$/g, '');
}
exports.left = function(str) {
    return str.replace(/^\s*/, '');
};
exports.right = function(str) {
    return str.replace(/\s*$/, '');
};

});

parcelRegister("efEER", function(module, exports) {
/*$AMPERSAND_VERSION*/ 
var $a0MTb = parcelRequire("a0MTb");

var $U4bMO = parcelRequire("U4bMO");

var $80YiL = parcelRequire("80YiL");

var $akRxj = parcelRequire("akRxj");

var $9dKJf = parcelRequire("9dKJf");

var $hZEyn = parcelRequire("hZEyn");
module.exports = function(xhr) {
    // Throw an error when a URL is needed, and none is supplied.
    var urlError = function() {
        throw new Error('A "url" property or function must be specified');
    };
    // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
    var methodMap = {
        'create': 'POST',
        'update': 'PUT',
        'patch': 'PATCH',
        'delete': 'DELETE',
        'read': 'GET'
    };
    return function(method, model, optionsInput) {
        //Copy the options object. It's using assign instead of clonedeep as an optimization.
        //The only object we could expect in options is headers, which is safely transfered below.
        var options = $akRxj({}, optionsInput);
        var type = methodMap[method];
        var headers = {};
        // Default options, unless specified.
        $U4bMO(options || (options = {}), {
            emulateHTTP: false,
            emulateJSON: false,
            // overrideable primarily to enable testing
            xhrImplementation: xhr
        });
        // Default request options.
        var params = {
            type: type
        };
        var ajaxConfig = $a0MTb(model, 'ajaxConfig') || {};
        var key;
        // Combine generated headers with user's headers.
        if (ajaxConfig.headers) for(key in ajaxConfig.headers)headers[key.toLowerCase()] = ajaxConfig.headers[key];
        if (options.headers) {
            for(key in options.headers)headers[key.toLowerCase()] = options.headers[key];
            delete options.headers;
        }
        //ajaxConfig has to be merged into params before other options take effect, so it is in fact a 2lvl default
        $akRxj(params, ajaxConfig);
        params.headers = headers;
        // Ensure that we have a URL.
        if (!options.url) options.url = $a0MTb(model, 'url') || urlError();
        // Ensure that we have the appropriate request data.
        if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) params.json = options.attrs || model.toJSON(options);
        // If passed a data param, we add it to the URL or body depending on request type
        if (options.data && type === 'GET') {
            // make sure we've got a '?'
            options.url += $80YiL(options.url, '?') ? '&' : '?';
            options.url += $9dKJf.stringify(options.data);
            //delete `data` so `xhr` doesn't use it as a body
            delete options.data;
        }
        // For older servers, emulate JSON by encoding the request into an HTML-form.
        if (options.emulateJSON) {
            params.headers['content-type'] = 'application/x-www-form-urlencoded';
            params.body = params.json ? {
                model: params.json
            } : {};
            delete params.json;
        }
        // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
        // And an `X-HTTP-Method-Override` header.
        if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
            params.type = 'POST';
            if (options.emulateJSON) params.body._method = type;
            params.headers['x-http-method-override'] = type;
        }
        // When emulating JSON, we turn the body into a querystring.
        // We do this later to let the emulateHTTP run its course.
        if (options.emulateJSON) params.body = $9dKJf.stringify(params.body);
        // Set raw XMLHttpRequest options.
        if (ajaxConfig.xhrFields) {
            var beforeSend = ajaxConfig.beforeSend;
            params.beforeSend = function(req) {
                $akRxj(req, ajaxConfig.xhrFields);
                if (beforeSend) return beforeSend.apply(this, arguments);
            };
            params.xhrFields = ajaxConfig.xhrFields;
        }
        // Turn a jQuery.ajax formatted request into xhr compatible
        params.method = params.type;
        var ajaxSettings = $akRxj(params, options);
        // Make the request. The callback executes functions that are compatible
        // With jQuery.ajax's syntax.
        var request = options.xhrImplementation(ajaxSettings, function(err, resp, body) {
            if (err || resp.statusCode >= 400) {
                if (options.error) {
                    try {
                        body = JSON.parse(body);
                    } catch (e) {}
                    var message = err ? err.message : body || "HTTP" + resp.statusCode;
                    options.error(resp, 'error', message);
                }
            } else {
                // Parse body as JSON
                var accept = $hZEyn.fromString(params.headers.accept);
                var parseJson = accept.isValid() && accept.type === 'application' && (accept.subtype === 'json' || accept.suffix === 'json');
                if (typeof body === 'string' && (!params.headers.accept || parseJson)) try {
                    body = JSON.parse(body);
                } catch (err) {
                    if (options.error) options.error(resp, 'error', err.message);
                    if (options.always) options.always(err, resp, body);
                    return;
                }
                if (options.success) options.success(body, 'success', resp);
            }
            if (options.always) options.always(err, resp, body);
        });
        if (model) model.trigger('request', model, request, optionsInput, ajaxSettings);
        request.ajaxSettings = ajaxSettings;
        return request;
    };
};

});
parcelRegister("a0MTb", function(module, exports) {

var $2n45k = parcelRequire("2n45k");

var $62yEr = parcelRequire("62yEr");

var $gYGgF = parcelRequire("gYGgF");
/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */ function $749fd3d6e0d4572c$var$result(object, path, defaultValue) {
    path = $2n45k(path, object);
    var index = -1, length = path.length;
    // Ensure the loop is entered when path is empty.
    if (!length) {
        length = 1;
        object = undefined;
    }
    while(++index < length){
        var value = object == null ? undefined : object[$gYGgF(path[index])];
        if (value === undefined) {
            index = length;
            value = defaultValue;
        }
        object = $62yEr(value) ? value.call(object) : value;
    }
    return object;
}
module.exports = $749fd3d6e0d4572c$var$result;

});

parcelRegister("U4bMO", function(module, exports) {

var $3YGtA = parcelRequire("3YGtA");

var $68RuN = parcelRequire("68RuN");

var $dpoHm = parcelRequire("dpoHm");

var $lSgZA = parcelRequire("lSgZA");
/** Used for built-in method references. */ var $0a887af21a3e9dc6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0a887af21a3e9dc6$var$hasOwnProperty = $0a887af21a3e9dc6$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $0a887af21a3e9dc6$var$defaults = $3YGtA(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $dpoHm(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $lSgZA(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $68RuN(value, $0a887af21a3e9dc6$var$objectProto[key]) && !$0a887af21a3e9dc6$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $0a887af21a3e9dc6$var$defaults;

});
parcelRegister("lSgZA", function(module, exports) {

var $dyTjd = parcelRequire("dyTjd");

var $2B41u = parcelRequire("2B41u");

var $fWng1 = parcelRequire("fWng1");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $fecbd26acefce717$var$keysIn(object) {
    return $fWng1(object) ? $dyTjd(object, true) : $2B41u(object);
}
module.exports = $fecbd26acefce717$var$keysIn;

});
parcelRegister("2B41u", function(module, exports) {

var $5DUFR = parcelRequire("5DUFR");

var $5DSff = parcelRequire("5DSff");

var $2VczZ = parcelRequire("2VczZ");
/** Used for built-in method references. */ var $1e42285ec1b3069d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1e42285ec1b3069d$var$hasOwnProperty = $1e42285ec1b3069d$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $1e42285ec1b3069d$var$baseKeysIn(object) {
    if (!$5DUFR(object)) return $2VczZ(object);
    var isProto = $5DSff(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$1e42285ec1b3069d$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $1e42285ec1b3069d$var$baseKeysIn;

});
parcelRegister("2VczZ", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $220aa9aeb69b5507$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $220aa9aeb69b5507$var$nativeKeysIn;

});




parcelRegister("9dKJf", function(module, exports) {
'use strict';

var $eEhVN = parcelRequire("eEhVN");

var $hIpaN = parcelRequire("hIpaN");

var $6uNHz = parcelRequire("6uNHz");
module.exports = {
    formats: $6uNHz,
    parse: $hIpaN,
    stringify: $eEhVN
};

});
parcelRegister("eEhVN", function(module, exports) {
'use strict';

var $9d2Uw = parcelRequire("9d2Uw");

var $6uNHz = parcelRequire("6uNHz");
var $02c08f520280db10$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $02c08f520280db10$var$toISO = Date.prototype.toISOString;
var $02c08f520280db10$var$defaults = {
    delimiter: '&',
    encode: true,
    encoder: $9d2Uw.encode,
    encodeValuesOnly: false,
    serializeDate: function serializeDate(date) {
        return $02c08f520280db10$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $02c08f520280db10$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly) {
    var obj = object;
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix) : prefix;
        obj = '';
    }
    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || $9d2Uw.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (Array.isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (skipNulls && obj[key] === null) continue;
        if (Array.isArray(obj)) values = values.concat(stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly));
        else values = values.concat(stringify(obj[key], prefix + (allowDots ? '.' + key : '[' + key + ']'), generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly));
    }
    return values;
};
module.exports = function(object, opts) {
    var obj = object;
    var options = opts || {};
    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var delimiter = typeof options.delimiter === 'undefined' ? $02c08f520280db10$var$defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : $02c08f520280db10$var$defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : $02c08f520280db10$var$defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : $02c08f520280db10$var$defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : $02c08f520280db10$var$defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? false : options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : $02c08f520280db10$var$defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : $02c08f520280db10$var$defaults.encodeValuesOnly;
    if (typeof options.format === 'undefined') options.format = $6uNHz.default;
    else if (!Object.prototype.hasOwnProperty.call($6uNHz.formatters, options.format)) throw new TypeError('Unknown format option provided.');
    var formatter = $6uNHz.formatters[options.format];
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var arrayFormat;
    if (options.arrayFormat in $02c08f520280db10$var$arrayPrefixGenerators) arrayFormat = options.arrayFormat;
    else if ('indices' in options) arrayFormat = options.indices ? 'indices' : 'repeat';
    else arrayFormat = 'indices';
    var generateArrayPrefix = $02c08f520280db10$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (sort) objKeys.sort(sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (skipNulls && obj[key] === null) continue;
        keys = keys.concat($02c08f520280db10$var$stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode ? encoder : null, filter, sort, allowDots, serializeDate, formatter, encodeValuesOnly));
    }
    return keys.join(delimiter);
};

});
parcelRegister("9d2Uw", function(module, exports) {

$parcel$export(module.exports, "arrayToObject", function () { return $6b4795f8b2aa0487$export$d224121420685233; }, function (v) { return $6b4795f8b2aa0487$export$d224121420685233 = v; });
$parcel$export(module.exports, "merge", function () { return $6b4795f8b2aa0487$export$4950aa0f605343fb; }, function (v) { return $6b4795f8b2aa0487$export$4950aa0f605343fb = v; });
$parcel$export(module.exports, "decode", function () { return $6b4795f8b2aa0487$export$2f872c0f2117be69; }, function (v) { return $6b4795f8b2aa0487$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "encode", function () { return $6b4795f8b2aa0487$export$c564cdbbe6da493; }, function (v) { return $6b4795f8b2aa0487$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "compact", function () { return $6b4795f8b2aa0487$export$8e16b83750b44988; }, function (v) { return $6b4795f8b2aa0487$export$8e16b83750b44988 = v; });
$parcel$export(module.exports, "isRegExp", function () { return $6b4795f8b2aa0487$export$49841c62b9eff15; }, function (v) { return $6b4795f8b2aa0487$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isBuffer", function () { return $6b4795f8b2aa0487$export$a7884ebc965f8f54; }, function (v) { return $6b4795f8b2aa0487$export$a7884ebc965f8f54 = v; });
var $6b4795f8b2aa0487$export$d224121420685233;
var $6b4795f8b2aa0487$export$4950aa0f605343fb;
var $6b4795f8b2aa0487$export$2f872c0f2117be69;
var $6b4795f8b2aa0487$export$c564cdbbe6da493;
var $6b4795f8b2aa0487$export$8e16b83750b44988;
var $6b4795f8b2aa0487$export$49841c62b9eff15;
var $6b4795f8b2aa0487$export$a7884ebc965f8f54;
'use strict';
var $6b4795f8b2aa0487$var$has = Object.prototype.hasOwnProperty;
var $6b4795f8b2aa0487$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
$6b4795f8b2aa0487$export$d224121420685233 = function(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
$6b4795f8b2aa0487$export$4950aa0f605343fb = function(target, source, options) {
    if (!source) return target;
    if (typeof source !== 'object') {
        if (Array.isArray(target)) target.push(source);
        else if (typeof target === 'object') {
            if (options.plainObjects || options.allowPrototypes || !$6b4795f8b2aa0487$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) mergeTarget = $6b4795f8b2aa0487$export$d224121420685233(target, options);
    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function(item, i) {
            if ($6b4795f8b2aa0487$var$has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') target[i] = $6b4795f8b2aa0487$export$4950aa0f605343fb(target[i], item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if (Object.prototype.hasOwnProperty.call(acc, key)) acc[key] = $6b4795f8b2aa0487$export$4950aa0f605343fb(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
$6b4795f8b2aa0487$export$2f872c0f2117be69 = function(str) {
    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};
$6b4795f8b2aa0487$export$c564cdbbe6da493 = function(str) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = typeof str === 'string' ? str : String(str);
    var out = '';
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D || // -
        c === 0x2E || // .
        c === 0x5F || // _
        c === 0x7E || // ~
        c >= 0x30 && c <= 0x39 || // 0-9
        c >= 0x41 && c <= 0x5A || // a-z
        c >= 0x61 && c <= 0x7A // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $6b4795f8b2aa0487$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($6b4795f8b2aa0487$var$hexTable[0xC0 | c >> 6] + $6b4795f8b2aa0487$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($6b4795f8b2aa0487$var$hexTable[0xE0 | c >> 12] + $6b4795f8b2aa0487$var$hexTable[0x80 | c >> 6 & 0x3F] + $6b4795f8b2aa0487$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        out += $6b4795f8b2aa0487$var$hexTable[0xF0 | c >> 18] + $6b4795f8b2aa0487$var$hexTable[0x80 | c >> 12 & 0x3F] + $6b4795f8b2aa0487$var$hexTable[0x80 | c >> 6 & 0x3F] + $6b4795f8b2aa0487$var$hexTable[0x80 | c & 0x3F]; // eslint-disable-line max-len
    }
    return out;
};
$6b4795f8b2aa0487$export$8e16b83750b44988 = function(obj, references) {
    if (typeof obj !== 'object' || obj === null) return obj;
    var refs = references || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) return refs[lookup];
    refs.push(obj);
    if (Array.isArray(obj)) {
        var compacted = [];
        for(var i = 0; i < obj.length; ++i){
            if (obj[i] && typeof obj[i] === 'object') compacted.push($6b4795f8b2aa0487$export$8e16b83750b44988(obj[i], refs));
            else if (typeof obj[i] !== 'undefined') compacted.push(obj[i]);
        }
        return compacted;
    }
    var keys = Object.keys(obj);
    keys.forEach(function(key) {
        obj[key] = $6b4795f8b2aa0487$export$8e16b83750b44988(obj[key], refs);
    });
    return obj;
};
$6b4795f8b2aa0487$export$49841c62b9eff15 = function(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
$6b4795f8b2aa0487$export$a7884ebc965f8f54 = function(obj) {
    if (obj === null || typeof obj === 'undefined') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

});

parcelRegister("6uNHz", function(module, exports) {
'use strict';
var $4bac19210695b267$var$replace = String.prototype.replace;
var $4bac19210695b267$var$percentTwenties = /%20/g;
module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function(value) {
            return $4bac19210695b267$var$replace.call(value, $4bac19210695b267$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

});


parcelRegister("hIpaN", function(module, exports) {
'use strict';

var $9d2Uw = parcelRequire("9d2Uw");
var $ce5a1297a2d9d5fa$var$has = Object.prototype.hasOwnProperty;
var $ce5a1297a2d9d5fa$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    decoder: $9d2Uw.decode,
    delimiter: '&',
    depth: 5,
    parameterLimit: 1000,
    plainObjects: false,
    strictNullHandling: false
};
var $ce5a1297a2d9d5fa$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
    for(var i = 0; i < parts.length; ++i){
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos));
            val = options.decoder(part.slice(pos + 1));
        }
        if ($ce5a1297a2d9d5fa$var$has.call(obj, key)) obj[key] = [].concat(obj[key]).concat(val);
        else obj[key] = val;
    }
    return obj;
};
var $ce5a1297a2d9d5fa$var$parseObject = function parseObjectRecursive(chain, val, options) {
    if (!chain.length) return val;
    var root = chain.shift();
    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat($ce5a1297a2d9d5fa$var$parseObject(chain, val, options));
    } else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
        var index = parseInt(cleanRoot, 10);
        if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
            obj = [];
            obj[index] = $ce5a1297a2d9d5fa$var$parseObject(chain, val, options);
        } else obj[cleanRoot] = $ce5a1297a2d9d5fa$var$parseObject(chain, val, options);
    }
    return obj;
};
var $ce5a1297a2d9d5fa$var$parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects && $ce5a1297a2d9d5fa$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while((segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $ce5a1297a2d9d5fa$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push('[' + key.slice(segment.index) + ']');
    return $ce5a1297a2d9d5fa$var$parseObject(keys, val, options);
};
module.exports = function(str, opts) {
    var options = opts || {};
    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    options.delimiter = typeof options.delimiter === 'string' || $9d2Uw.isRegExp(options.delimiter) ? options.delimiter : $ce5a1297a2d9d5fa$var$defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : $ce5a1297a2d9d5fa$var$defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : $ce5a1297a2d9d5fa$var$defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : $ce5a1297a2d9d5fa$var$defaults.decoder;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : $ce5a1297a2d9d5fa$var$defaults.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : $ce5a1297a2d9d5fa$var$defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : $ce5a1297a2d9d5fa$var$defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : $ce5a1297a2d9d5fa$var$defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : $ce5a1297a2d9d5fa$var$defaults.strictNullHandling;
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === 'string' ? $ce5a1297a2d9d5fa$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $ce5a1297a2d9d5fa$var$parseKeys(key, tempObj[key], options);
        obj = $9d2Uw.merge(obj, newObj, options);
    }
    return $9d2Uw.compact(obj);
};

});


parcelRegister("hZEyn", function(module, exports) {

$parcel$export(module.exports, "fromString", function () { return $d197974408ba64bb$export$3004f64547af360e; }, function (v) { return $d197974408ba64bb$export$3004f64547af360e = v; });
/**
 * media-type
 * @author Lovell Fuller
 *
 * This code is distributed under the Apache License Version 2.0, the terms of
 * which may be found at http://www.apache.org/licenses/LICENSE-2.0.html
 */ var $d197974408ba64bb$export$3004f64547af360e;
var $d197974408ba64bb$var$MediaType = function() {
    this.type = null;
    this._setSubtypeAndSuffix(null);
    this.parameters = {};
};
$d197974408ba64bb$var$MediaType.prototype.isValid = function() {
    return this.type !== null && this.subtype !== null && this.subtype !== "example";
};
$d197974408ba64bb$var$MediaType.prototype._setSubtypeAndSuffix = function(subtype) {
    this.subtype = subtype;
    this.subtypeFacets = [];
    this.suffix = null;
    if (subtype) {
        if (subtype.indexOf("+") > -1 && subtype.substr(-1) !== "+") {
            var fixes = subtype.split("+", 2);
            this.subtype = fixes[0];
            this.subtypeFacets = fixes[0].split(".");
            this.suffix = fixes[1];
        } else this.subtypeFacets = subtype.split(".");
    }
};
$d197974408ba64bb$var$MediaType.prototype.hasSuffix = function() {
    return !!this.suffix;
};
$d197974408ba64bb$var$MediaType.prototype._firstSubtypeFacetEquals = function(str) {
    return this.subtypeFacets.length > 0 && this.subtypeFacets[0] === str;
};
$d197974408ba64bb$var$MediaType.prototype.isVendor = function() {
    return this._firstSubtypeFacetEquals("vnd");
};
$d197974408ba64bb$var$MediaType.prototype.isPersonal = function() {
    return this._firstSubtypeFacetEquals("prs");
};
$d197974408ba64bb$var$MediaType.prototype.isExperimental = function() {
    return this._firstSubtypeFacetEquals("x") || this.subtype.substring(0, 2).toLowerCase() === "x-";
};
$d197974408ba64bb$var$MediaType.prototype.asString = function() {
    var str = "";
    if (this.isValid()) {
        str = str + this.type + "/" + this.subtype;
        if (this.hasSuffix()) str = str + "+" + this.suffix;
        var parameterKeys = Object.keys(this.parameters);
        if (parameterKeys.length > 0) {
            var parameters = [];
            var that = this;
            parameterKeys.sort(function(a, b) {
                return a.localeCompare(b);
            }).forEach(function(element) {
                parameters.push(element + "=" + $d197974408ba64bb$var$wrapQuotes(that.parameters[element]));
            });
            str = str + ";" + parameters.join(";");
        }
    }
    return str;
};
var $d197974408ba64bb$var$wrapQuotes = function(str) {
    return str.indexOf(";") > -1 ? '"' + str + '"' : str;
};
var $d197974408ba64bb$var$unwrapQuotes = function(str) {
    return str.substr(0, 1) === '"' && str.substr(-1) === '"' ? str.substr(1, str.length - 2) : str;
};
var $d197974408ba64bb$var$mediaTypeMatcher = /^(application|audio|image|message|model|multipart|text|video|\*)\/([a-zA-Z0-9!#$%^&\*_\-\+{}\|'.`~]{1,127})(;.*)?$/;
var $d197974408ba64bb$var$parameterSplitter = /;(?=(?:[^\"]*\"[^\"]*\")*(?![^\"]*\"))/;
$d197974408ba64bb$export$3004f64547af360e = function(str) {
    var mediaType = new $d197974408ba64bb$var$MediaType();
    if (str) {
        var match = str.match($d197974408ba64bb$var$mediaTypeMatcher);
        if (match && !(match[1] === '*' && match[2] !== '*')) {
            mediaType.type = match[1];
            mediaType._setSubtypeAndSuffix(match[2]);
            if (match[3]) match[3].substr(1).split($d197974408ba64bb$var$parameterSplitter).forEach(function(parameter) {
                var keyAndValue = parameter.split('=', 2);
                if (keyAndValue.length === 2) mediaType.parameters[keyAndValue[0].toLowerCase().trim()] = $d197974408ba64bb$var$unwrapQuotes(keyAndValue[1].trim());
            });
        }
    }
    return mediaType;
};

});


parcelRegister("gvQO6", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $c05880f535ccd41b$export$af88d00dbe7f521; });
$parcel$export(module.exports, "indexify", function () { return $c05880f535ccd41b$export$d5f44adf6cfa48a1; });
$parcel$export(module.exports, "currency", function () { return $c05880f535ccd41b$export$f4f21ed02b0ddb8f; });
$parcel$export(module.exports, "net", function () { return $c05880f535ccd41b$export$50ac2457de2c5423; });
$parcel$export(module.exports, "vat", function () { return $c05880f535ccd41b$export$59d79bb5806aec95; });
$parcel$export(module.exports, "sum", function () { return $c05880f535ccd41b$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "byLocationSortPosition", function () { return $c05880f535ccd41b$export$9c462ef12f097c99; });
$parcel$export(module.exports, "byStockSortPosition", function () { return $c05880f535ccd41b$export$ec891147cbd65234; });
$parcel$export(module.exports, "byStockSortPositionDesc", function () { return $c05880f535ccd41b$export$27520630521404c3; });
$parcel$export(module.exports, "byStockNameAsc", function () { return $c05880f535ccd41b$export$e6e395ae666a5dd5; });
$parcel$export(module.exports, "byStockNameDesc", function () { return $c05880f535ccd41b$export$4c0c537a57fbe036; });
$parcel$export(module.exports, "byNumberAsc", function () { return $c05880f535ccd41b$export$1a8431df92a3faf9; });
$parcel$export(module.exports, "byNumberDesc", function () { return $c05880f535ccd41b$export$9ef95a752b541f28; });
$parcel$export(module.exports, "i18nUnits", function () { return $c05880f535ccd41b$export$8896d666f11c9dba; });
$parcel$export(module.exports, "i18nPackages", function () { return $c05880f535ccd41b$export$a57c528557794b29; });
$parcel$export(module.exports, "unitsLocalized", function () { return $c05880f535ccd41b$export$50cdfcf71812bb74; });
$parcel$export(module.exports, "packagesLocalized", function () { return $c05880f535ccd41b$export$e1ea11c24e7c2f5a; });
$parcel$export(module.exports, "localizedUnit", function () { return $c05880f535ccd41b$export$a404c95c1bf820d7; });
$parcel$export(module.exports, "localizedPackage", function () { return $c05880f535ccd41b$export$82a201a011c7b256; });
$parcel$export(module.exports, "localizeServingSize", function () { return $c05880f535ccd41b$export$d76ccefa476648; });
$parcel$export(module.exports, "formatCurrency", function () { return $c05880f535ccd41b$export$3dc27271f5d5c629; });
$parcel$export(module.exports, "isAdminProp", function () { return $c05880f535ccd41b$export$76f955cbdde7bfd4; });
$parcel$export(module.exports, "slugify", function () { return $c05880f535ccd41b$export$c383cdd2a518017a; });

var $4UX9c = parcelRequire("4UX9c");

var $eSA5k = parcelRequire("eSA5k");

var $fKCDk = parcelRequire("fKCDk");

var $8cget = parcelRequire("8cget");

var $5gOw1 = parcelRequire("5gOw1");

var $d0uB5 = parcelRequire("d0uB5");
const $c05880f535ccd41b$export$af88d00dbe7f521 = (0, (/*@__PURE__*/$parcel$interopDefault($fKCDk)))('booze-boy');
const $c05880f535ccd41b$var$spaces = /\s+/g;
const $c05880f535ccd41b$var$HUNDRED = new (0, (/*@__PURE__*/$parcel$interopDefault($eSA5k)))(100);
/**
 * @param {string} str
 */ function $c05880f535ccd41b$var$entumlautify(str) {
    return str.toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss');
}
function $c05880f535ccd41b$export$d5f44adf6cfa48a1(string) {
    if (typeof string !== 'string') return string;
    return (0, (/*@__PURE__*/$parcel$interopDefault($5gOw1)))(string.toLowerCase().replace($c05880f535ccd41b$var$spaces, ''));
}
function $c05880f535ccd41b$export$f4f21ed02b0ddb8f(value) {
    if (!Number.isFinite(+value) || Number.isNaN(+value)) return '';
    const amount = new (0, (/*@__PURE__*/$parcel$interopDefault($eSA5k)))(value || 0);
    return `${amount.toFixed(2).toString().replace('.', ',')} \u{20AC}`;
}
function $c05880f535ccd41b$export$50ac2457de2c5423(value, vatInput) {
    const vat = vatInput || (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent.vat;
    if (!Number.isFinite(value) || !Number.isFinite(vat)) return 0;
    const factor = $c05880f535ccd41b$var$HUNDRED.div($c05880f535ccd41b$var$HUNDRED.plus(vat));
    return +factor.times(value);
}
function $c05880f535ccd41b$export$59d79bb5806aec95(net, grossValue) {
    if (!Number.isFinite(grossValue) || !Number.isFinite(net)) return 0;
    const gross = new (0, (/*@__PURE__*/$parcel$interopDefault($eSA5k)))(grossValue);
    return +gross.minus(net);
}
function $c05880f535ccd41b$export$8a63f25cc62965f1(array, prop) {
    return +array.map((product)=>Number.isFinite(product[prop]) ? product[prop] : 0).reduce((memo, num)=>new (0, (/*@__PURE__*/$parcel$interopDefault($eSA5k)))(memo).plus(num), 0);
}
function $c05880f535ccd41b$export$9c462ef12f097c99(model) {
    // left pad with zeros to ensure proper ordering - 0001, 0002....0010
    if (Number.isFinite(model.sortPosition)) return model.sortPosition.toString().padStart(4, '0');
    if (model.type === 'delivery') return '\ufff0';
    return model.name.toLowerCase();
}
function $c05880f535ccd41b$export$ec891147cbd65234(model) {
    // left pad with zeros to ensure proper ordering - 0001, 0002....0010
    if (Number.isFinite(model.product.sortPosition)) return model.product.sortPosition.toString().padStart(4, '0');
    return model.product.name;
}
function $c05880f535ccd41b$export$27520630521404c3(one, two) {
    return two.product.sortPosition - one.product.sortPosition;
}
function $c05880f535ccd41b$export$e6e395ae666a5dd5(model) {
    return model.product.name;
}
function $c05880f535ccd41b$export$4c0c537a57fbe036(one, two) {
    if (one.product.name !== two.product.name) return one.product.name > two.product.name ? -1 : 1;
    return 0;
}
function $c05880f535ccd41b$export$1a8431df92a3faf9(key) {
    return (one, two)=>one[key] - two[key];
}
function $c05880f535ccd41b$export$9ef95a752b541f28(key) {
    return (one, two)=>two[key] - one[key];
}
function $c05880f535ccd41b$export$8896d666f11c9dba(totalUnits, product) {
    const units = Math.round(totalUnits % product.packageSize * 100) / 100;
    if (!units) return null;
    const unitName = (0, $d0uB5.packaging).get(product.unitId);
    return `${units.toString().replace('.', ',')} ${units > 1 || units < -1 ? unitName.plural : unitName.name}`;
}
function $c05880f535ccd41b$export$a57c528557794b29(totalUnits, product) {
    let packages = totalUnits / product.packageSize;
    packages = totalUnits < 0 ? Math.ceil(packages) : Math.floor(packages);
    if (!packages) return null;
    const unitName = (0, $d0uB5.packaging).get(product.packageId);
    return `${packages} ${packages > 1 || packages < -1 ? unitName.plural : unitName.name}`;
}
function $c05880f535ccd41b$export$50cdfcf71812bb74(key) {
    return {
        deps: [
            key,
            'product'
        ],
        fn () {
            return $c05880f535ccd41b$export$8896d666f11c9dba(this[key], this.product);
        }
    };
}
function $c05880f535ccd41b$export$e1ea11c24e7c2f5a(key) {
    return {
        deps: [
            key,
            'product'
        ],
        fn () {
            return $c05880f535ccd41b$export$a57c528557794b29(this[key], this.product);
        }
    };
}
function $c05880f535ccd41b$export$a404c95c1bf820d7(key) {
    return {
        deps: [
            key,
            'product'
        ],
        fn () {
            if (!this[key]) return null;
            const unitName = (0, $d0uB5.packaging).get(this.product.unitId);
            return `${this[key]} ${this[key] > 1 || this[key] < -1 ? unitName.plural : unitName.name}`;
        }
    };
}
function $c05880f535ccd41b$export$82a201a011c7b256(key) {
    return {
        deps: [
            key,
            'product'
        ],
        fn () {
            if (!this[key]) return null;
            const packageName = (0, $d0uB5.packaging).get(this.product.packageId);
            return `${this[key]} ${this[key] > 1 || this[key] < -1 ? packageName.plural : packageName.name}`;
        }
    };
}
function $c05880f535ccd41b$export$d76ccefa476648(servingSize) {
    if (servingSize < 0.1) return `${servingSize * 100}cl`;
    if (servingSize < 1) return `${servingSize * 1000}ml`;
    return `${servingSize}l`;
}
const $c05880f535ccd41b$export$3dc27271f5d5c629 = new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'symbol'
}).format;
const $c05880f535ccd41b$export$76f955cbdde7bfd4 = {
    type: 'boolean',
    setOnce: true,
    default () {
        return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.role === 'admin';
    }
};
function $c05880f535ccd41b$export$c383cdd2a518017a(prop) {
    if (typeof prop !== 'string') return prop;
    // don't decode URI components, otherwise it crashes when the string contains a %
    return (0, (/*@__PURE__*/$parcel$interopDefault($8cget)))($c05880f535ccd41b$var$entumlautify(prop), {
        decode: false
    });
}

});
parcelRegister("eSA5k", function(module, exports) {
/* big.js v3.1.3 https://github.com/MikeMcl/big.js/LICENCE */ (function(global) {
    'use strict';
    /*
  big.js v3.1.3
  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
  https://github.com/MikeMcl/big.js/
  Copyright (c) 2014 Michael Mclaughlin <M8ch88l@gmail.com>
  MIT Expat Licence
*/ /***************************** EDITABLE DEFAULTS ******************************/ // The default values below must be integers within the stated ranges.
    /*
     * The maximum number of decimal places of the results of operations
     * involving division: div and sqrt, and pow with negative exponents.
     */ var DP = 20, /*
         * The rounding mode used when rounding to the above decimal places.
         *
         * 0 Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
         * 1 To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
         * 2 To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
         * 3 Away from zero.                                  (ROUND_UP)
         */ RM = 1, // The maximum value of DP and Big.DP.
    MAX_DP = 1E6, // The maximum magnitude of the exponent argument to the pow method.
    MAX_POWER = 1E6, /*
         * The exponent value at and beneath which toString returns exponential
         * notation.
         * JavaScript's Number type: -7
         * -1000000 is the minimum recommended exponent value of a Big.
         */ E_NEG = -7, /*
         * The exponent value at and above which toString returns exponential
         * notation.
         * JavaScript's Number type: 21
         * 1000000 is the maximum recommended exponent value of a Big.
         * (This limit is not enforced or checked.)
         */ E_POS = 21, /******************************************************************************/ // The shared prototype object.
    P = {}, isValid = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Big;
    /*
     * Create and return a Big constructor.
     *
     */ function bigFactory() {
        /*
         * The Big constructor and exported function.
         * Create and return a new instance of a Big number object.
         *
         * n {number|string|Big} A numeric value.
         */ function Big(n) {
            var x = this;
            // Enable constructor usage without new.
            if (!(x instanceof Big)) return n === void 0 ? bigFactory() : new Big(n);
            // Duplicate.
            if (n instanceof Big) {
                x.s = n.s;
                x.e = n.e;
                x.c = n.c.slice();
            } else parse(x, n);
            /*
             * Retain a reference to this Big constructor, and shadow
             * Big.prototype.constructor which points to Object.
             */ x.constructor = Big;
        }
        Big.prototype = P;
        Big.DP = DP;
        Big.RM = RM;
        Big.E_NEG = E_NEG;
        Big.E_POS = E_POS;
        return Big;
    }
    // Private functions
    /*
     * Return a string representing the value of Big x in normal or exponential
     * notation to dp fixed decimal places or significant digits.
     *
     * x {Big} The Big to format.
     * dp {number} Integer, 0 to MAX_DP inclusive.
     * toE {number} 1 (toExponential), 2 (toPrecision) or undefined (toFixed).
     */ function format(x, dp, toE) {
        var Big = x.constructor, // The index (normal notation) of the digit that may be rounded up.
        i = dp - (x = new Big(x)).e, c = x.c;
        // Round?
        if (c.length > ++dp) rnd(x, i, Big.RM);
        if (!c[0]) ++i;
        else if (toE) i = dp;
        else {
            c = x.c;
            // Recalculate i as x.e may have changed if value rounded up.
            i = x.e + i + 1;
        }
        // Append zeros?
        for(; c.length < i; c.push(0));
        i = x.e;
        /*
         * toPrecision returns exponential notation if the number of
         * significant digits specified is less than the number of digits
         * necessary to represent the integer part of the value in normal
         * notation.
         */ return toE === 1 || toE && (dp <= i || i <= Big.E_NEG) ? // Exponential notation.
        (x.s < 0 && c[0] ? '-' : '') + (c.length > 1 ? c[0] + '.' + c.join('').slice(1) : c[0]) + (i < 0 ? 'e' : 'e+') + i : x.toString();
    }
    /*
     * Parse the number or string value passed to a Big constructor.
     *
     * x {Big} A Big number instance.
     * n {number|string} A numeric value.
     */ function parse(x, n) {
        var e, i, nL;
        // Minus zero?
        if (n === 0 && 1 / n < 0) n = '-0';
        else if (!isValid.test(n += '')) throwErr(NaN);
        // Determine sign.
        x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;
        // Decimal point?
        if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');
        // Exponential form?
        if ((i = n.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +n.slice(i + 1);
            n = n.substring(0, i);
        } else if (e < 0) // Integer.
        e = n.length;
        // Determine leading zeros.
        for(i = 0; n.charAt(i) == '0'; i++);
        if (i == (nL = n.length)) // Zero.
        x.c = [
            x.e = 0
        ];
        else {
            // Determine trailing zeros.
            for(; n.charAt(--nL) == '0';);
            x.e = e - i - 1;
            x.c = [];
            // Convert string to array of digits without leading/trailing zeros.
            for(e = 0; i <= nL; x.c[e++] = +n.charAt(i++));
        }
        return x;
    }
    /*
     * Round Big x to a maximum of dp decimal places using rounding mode rm.
     * Called by div, sqrt and round.
     *
     * x {Big} The Big to round.
     * dp {number} Integer, 0 to MAX_DP inclusive.
     * rm {number} 0, 1, 2 or 3 (DOWN, HALF_UP, HALF_EVEN, UP)
     * [more] {boolean} Whether the result of division was truncated.
     */ function rnd(x, dp, rm, more) {
        var u, xc = x.c, i = x.e + dp + 1;
        if (rm === 1) // xc[i] is the digit after the digit that may be rounded up.
        more = xc[i] >= 5;
        else if (rm === 2) more = xc[i] > 5 || xc[i] == 5 && (more || i < 0 || xc[i + 1] !== u || xc[i - 1] & 1);
        else if (rm === 3) more = more || xc[i] !== u || i < 0;
        else {
            more = false;
            if (rm !== 0) throwErr('!Big.RM!');
        }
        if (i < 1 || !xc[0]) {
            if (more) {
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                x.e = -dp;
                x.c = [
                    1
                ];
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        } else {
            // Remove any digits after the required decimal places.
            xc.length = i--;
            // Round up?
            if (more) // Rounding up may mean the previous digit has to be rounded up.
            for(; ++xc[i] > 9;){
                xc[i] = 0;
                if (!i--) {
                    ++x.e;
                    xc.unshift(1);
                }
            }
            // Remove trailing zeros.
            for(i = xc.length; !xc[--i]; xc.pop());
        }
        return x;
    }
    /*
     * Throw a BigError.
     *
     * message {string} The error message.
     */ function throwErr(message) {
        var err = new Error(message);
        err.name = 'BigError';
        throw err;
    }
    // Prototype/instance methods
    /*
     * Return a new Big whose value is the absolute value of this Big.
     */ P.abs = function() {
        var x = new this.constructor(this);
        x.s = 1;
        return x;
    };
    /*
     * Return
     * 1 if the value of this Big is greater than the value of Big y,
     * -1 if the value of this Big is less than the value of Big y, or
     * 0 if they have the same value.
    */ P.cmp = function(y) {
        var xNeg, x = this, xc = x.c, yc = (y = new x.constructor(y)).c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        xNeg = i < 0;
        // Compare exponents.
        if (k != l) return k > l ^ xNeg ? 1 : -1;
        i = -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(; ++i < j;){
            if (xc[i] != yc[i]) return xc[i] > yc[i] ^ xNeg ? 1 : -1;
        }
        // Compare lengths.
        return k == l ? 0 : k > l ^ xNeg ? 1 : -1;
    };
    /*
     * Return a new Big whose value is the value of this Big divided by the
     * value of Big y, rounded, if necessary, to a maximum of Big.DP decimal
     * places using rounding mode Big.RM.
     */ P.div = function(y) {
        var x = this, Big = x.constructor, // dividend
        dvd = x.c, //divisor
        dvs = (y = new Big(y)).c, s = x.s == y.s ? 1 : -1, dp = Big.DP;
        if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throwErr('!Big.DP!');
        // Either 0?
        if (!dvd[0] || !dvs[0]) {
            // If both are 0, throw NaN
            if (dvd[0] == dvs[0]) throwErr(NaN);
            // If dvs is 0, throw +-Infinity.
            if (!dvs[0]) throwErr(s / 0);
            // dvd is 0, return +-0.
            return new Big(s * 0);
        }
        var dvsL, dvsT, next, cmp, remI, u, dvsZ = dvs.slice(), dvdI = dvsL = dvs.length, dvdL = dvd.length, // remainder
        rem = dvd.slice(0, dvsL), remL = rem.length, // quotient
        q = y, qc = q.c = [], qi = 0, digits = dp + (q.e = x.e - y.e) + 1;
        q.s = s;
        s = digits < 0 ? 0 : digits;
        // Create version of divisor with leading zero.
        dvsZ.unshift(0);
        // Add zeros to make remainder as long as divisor.
        for(; remL++ < dvsL; rem.push(0));
        do {
            // 'next' is how many times the divisor goes into current remainder.
            for(next = 0; next < 10; next++){
                // Compare divisor and remainder.
                if (dvsL != (remL = rem.length)) cmp = dvsL > remL ? 1 : -1;
                else {
                    for(remI = -1, cmp = 0; ++remI < dvsL;)if (dvs[remI] != rem[remI]) {
                        cmp = dvs[remI] > rem[remI] ? 1 : -1;
                        break;
                    }
                }
                // If divisor < remainder, subtract divisor from remainder.
                if (cmp < 0) {
                    // Remainder can't be more than 1 digit longer than divisor.
                    // Equalise lengths using divisor with extra leading zero?
                    for(dvsT = remL == dvsL ? dvs : dvsZ; remL;){
                        if (rem[--remL] < dvsT[remL]) {
                            remI = remL;
                            for(; remI && !rem[--remI]; rem[remI] = 9);
                            --rem[remI];
                            rem[remL] += 10;
                        }
                        rem[remL] -= dvsT[remL];
                    }
                    for(; !rem[0]; rem.shift());
                } else break;
            }
            // Add the 'next' digit to the result array.
            qc[qi++] = cmp ? next : ++next;
            // Update the remainder.
            if (rem[0] && cmp) rem[remL] = dvd[dvdI] || 0;
            else rem = [
                dvd[dvdI]
            ];
        }while ((dvdI++ < dvdL || rem[0] !== u) && s--);
        // Leading zero? Do not remove if result is simply zero (qi == 1).
        if (!qc[0] && qi != 1) {
            // There can't be more than one zero.
            qc.shift();
            q.e--;
        }
        // Round?
        if (qi > digits) rnd(q, dp, Big.RM, rem[0] !== u);
        return q;
    };
    /*
     * Return true if the value of this Big is equal to the value of Big y,
     * otherwise returns false.
     */ P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
     * Return true if the value of this Big is greater than the value of Big y,
     * otherwise returns false.
     */ P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
     * Return true if the value of this Big is greater than or equal to the
     * value of Big y, otherwise returns false.
     */ P.gte = function(y) {
        return this.cmp(y) > -1;
    };
    /*
     * Return true if the value of this Big is less than the value of Big y,
     * otherwise returns false.
     */ P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
     * Return true if the value of this Big is less than or equal to the value
     * of Big y, otherwise returns false.
     */ P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
     * Return a new Big whose value is the value of this Big minus the value
     * of Big y.
     */ P.sub = P.minus = function(y) {
        var i, j, t, xLTy, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xc = x.c.slice(), xe = x.e, yc = y.c, ye = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) // y is non-zero? x is non-zero? Or both are zero.
        return yc[0] ? (y.s = -b, y) : new Big(xc[0] ? x : 0);
        // Determine which is the bigger number.
        // Prepend zeros to equalise exponents.
        if (a = xe - ye) {
            if (xLTy = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            for(b = a; b--; t.push(0));
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = ((xLTy = xc.length < yc.length) ? xc : yc).length;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xLTy = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xLTy) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        /*
         * Append zeros to xc if shorter. No need to add zeros to yc if shorter
         * as subtraction only needs to start at yc.length.
         */ if ((b = (j = yc.length) - (i = xc.length)) > 0) {
            for(; b--; xc[i++] = 0);
        }
        // Subtract yc from xc.
        for(b = i; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i]; xc[i] = 9);
                --xc[i];
                xc[j] += 10;
            }
            xc[j] -= yc[j];
        }
        // Remove trailing zeros.
        for(; xc[--b] === 0; xc.pop());
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] === 0;){
            xc.shift();
            --ye;
        }
        if (!xc[0]) {
            // n - n = +0
            y.s = 1;
            // Result must be zero.
            xc = [
                ye = 0
            ];
        }
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
     * Return a new Big whose value is the value of this Big modulo the
     * value of Big y.
     */ P.mod = function(y) {
        var yGTx, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        if (!y.c[0]) throwErr(NaN);
        x.s = y.s = 1;
        yGTx = y.cmp(x) == 1;
        x.s = a;
        y.s = b;
        if (yGTx) return new Big(x);
        a = Big.DP;
        b = Big.RM;
        Big.DP = Big.RM = 0;
        x = x.div(y);
        Big.DP = a;
        Big.RM = b;
        return this.minus(x.times(y));
    };
    /*
     * Return a new Big whose value is the value of this Big plus the value
     * of Big y.
     */ P.add = P.plus = function(y) {
        var t, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.minus(y);
        }
        var xe = x.e, xc = x.c, ye = y.e, yc = y.c;
        // Either zero?
        if (!xc[0] || !yc[0]) // y is non-zero? x is non-zero? Or both are zero.
        return yc[0] ? y : new Big(xc[0] ? x : a * 0);
        xc = xc.slice();
        // Prepend zeros to equalise exponents.
        // Note: Faster to use reverse then do unshifts.
        if (a = xe - ye) {
            if (a > 0) {
                ye = xe;
                t = yc;
            } else {
                a = -a;
                t = xc;
            }
            t.reverse();
            for(; a--; t.push(0));
            t.reverse();
        }
        // Point xc to the longer array.
        if (xc.length - yc.length < 0) {
            t = yc;
            yc = xc;
            xc = t;
        }
        a = yc.length;
        /*
         * Only start adding at yc.length - 1 as the further digits of xc can be
         * left as they are.
         */ for(b = 0; a;){
            b = (xc[--a] = xc[a] + yc[a] + b) / 10 | 0;
            xc[a] %= 10;
        }
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        if (b) {
            xc.unshift(b);
            ++ye;
        }
        // Remove trailing zeros.
        for(a = xc.length; xc[--a] === 0; xc.pop());
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
     * Return a Big whose value is the value of this Big raised to the power n.
     * If n is negative, round, if necessary, to a maximum of Big.DP decimal
     * places using rounding mode Big.RM.
     *
     * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
     */ P.pow = function(n) {
        var x = this, one = new x.constructor(1), y = one, isNeg = n < 0;
        if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) throwErr('!pow!');
        n = isNeg ? -n : n;
        for(;;){
            if (n & 1) y = y.times(x);
            n >>= 1;
            if (!n) break;
            x = x.times(x);
        }
        return isNeg ? one.div(y) : y;
    };
    /*
     * Return a new Big whose value is the value of this Big rounded to a
     * maximum of dp decimal places using rounding mode rm.
     * If dp is not specified, round to 0 decimal places.
     * If rm is not specified, use Big.RM.
     *
     * [dp] {number} Integer, 0 to MAX_DP inclusive.
     * [rm] 0, 1, 2 or 3 (ROUND_DOWN, ROUND_HALF_UP, ROUND_HALF_EVEN, ROUND_UP)
     */ P.round = function(dp, rm) {
        var x = this, Big = x.constructor;
        if (dp == null) dp = 0;
        else if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throwErr('!round!');
        rnd(x = new Big(x), dp, rm == null ? Big.RM : rm);
        return x;
    };
    /*
     * Return a new Big whose value is the square root of the value of this Big,
     * rounded, if necessary, to a maximum of Big.DP decimal places using
     * rounding mode Big.RM.
     */ P.sqrt = function() {
        var estimate, r, approx, x = this, Big = x.constructor, xc = x.c, i = x.s, e = x.e, half = new Big('0.5');
        // Zero?
        if (!xc[0]) return new Big(x);
        // If negative, throw NaN.
        if (i < 0) throwErr(NaN);
        // Estimate.
        i = Math.sqrt(x.toString());
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the result exponent.
        if (i === 0 || i === 1 / 0) {
            estimate = xc.join('');
            if (!(estimate.length + e & 1)) estimate += '0';
            r = new Big(Math.sqrt(estimate).toString());
            r.e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
        } else r = new Big(i.toString());
        i = r.e + (Big.DP += 4);
        // Newton-Raphson iteration.
        do {
            approx = r;
            r = half.times(approx.plus(x.div(approx)));
        }while (approx.c.slice(0, i).join('') !== r.c.slice(0, i).join(''));
        rnd(r, Big.DP -= 4, Big.RM);
        return r;
    };
    /*
     * Return a new Big whose value is the value of this Big times the value of
     * Big y.
     */ P.mul = P.times = function(y) {
        var c, x = this, Big = x.constructor, xc = x.c, yc = (y = new Big(y)).c, a = xc.length, b = yc.length, i = x.e, j = y.e;
        // Determine sign of result.
        y.s = x.s == y.s ? 1 : -1;
        // Return signed 0 if either 0.
        if (!xc[0] || !yc[0]) return new Big(y.s * 0);
        // Initialise exponent of result as x.e + y.e.
        y.e = i + j;
        // If array xc has fewer digits than yc, swap xc and yc, and lengths.
        if (a < b) {
            c = xc;
            xc = yc;
            yc = c;
            j = a;
            a = b;
            b = j;
        }
        // Initialise coefficient array of result with zeros.
        for(c = new Array(j = a + b); j--; c[j] = 0);
        // Multiply.
        // i is initially xc.length.
        for(i = b; i--;){
            b = 0;
            // a is yc.length.
            for(j = a + i; j > i;){
                // Current sum of products at this digit position, plus carry.
                b = c[j] + yc[i] * xc[j - i - 1] + b;
                c[j--] = b % 10;
                // carry
                b = b / 10 | 0;
            }
            c[j] = (c[j] + b) % 10;
        }
        // Increment result exponent if there is a final carry.
        if (b) ++y.e;
        // Remove any leading zero.
        if (!c[0]) c.shift();
        // Remove trailing zeros.
        for(i = c.length; !c[--i]; c.pop());
        y.c = c;
        return y;
    };
    /*
     * Return a string representing the value of this Big.
     * Return exponential notation if this Big has a positive exponent equal to
     * or greater than Big.E_POS, or a negative exponent equal to or less than
     * Big.E_NEG.
     */ P.toString = P.valueOf = P.toJSON = function() {
        var x = this, Big = x.constructor, e = x.e, str = x.c.join(''), strL = str.length;
        // Exponential notation?
        if (e <= Big.E_NEG || e >= Big.E_POS) str = str.charAt(0) + (strL > 1 ? '.' + str.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;
        else if (e < 0) {
            // Prepend zeros.
            for(; ++e; str = '0' + str);
            str = '0.' + str;
        // Positive exponent?
        } else if (e > 0) {
            if (++e > strL) {
                // Append zeros.
                for(e -= strL; e--; str += '0');
            } else if (e < strL) str = str.slice(0, e) + '.' + str.slice(e);
        // Exponent zero.
        } else if (strL > 1) str = str.charAt(0) + '.' + str.slice(1);
        // Avoid '-0'
        return x.s < 0 && x.c[0] ? '-' + str : str;
    };
    /*
     ***************************************************************************
     * If toExponential, toFixed, toPrecision and format are not required they
     * can safely be commented-out or deleted. No redundant code will be left.
     * format is used only by toExponential, toFixed and toPrecision.
     ***************************************************************************
     */ /*
     * Return a string representing the value of this Big in exponential
     * notation to dp fixed decimal places and rounded, if necessary, using
     * Big.RM.
     *
     * [dp] {number} Integer, 0 to MAX_DP inclusive.
     */ P.toExponential = function(dp) {
        if (dp == null) dp = this.c.length - 1;
        else if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throwErr('!toExp!');
        return format(this, dp, 1);
    };
    /*
     * Return a string representing the value of this Big in normal notation
     * to dp fixed decimal places and rounded, if necessary, using Big.RM.
     *
     * [dp] {number} Integer, 0 to MAX_DP inclusive.
     */ P.toFixed = function(dp) {
        var str, x = this, Big = x.constructor, neg = Big.E_NEG, pos = Big.E_POS;
        // Prevent the possibility of exponential notation.
        Big.E_NEG = -(Big.E_POS = 1 / 0);
        if (dp == null) str = x.toString();
        else if (dp === ~~dp && dp >= 0 && dp <= MAX_DP) {
            str = format(x, x.e + dp);
            // (-0).toFixed() is '0', but (-0.1).toFixed() is '-0'.
            // (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
            if (x.s < 0 && x.c[0] && str.indexOf('-') < 0) //E.g. -0.5 if rounded to -0 will cause toString to omit the minus sign.
            str = '-' + str;
        }
        Big.E_NEG = neg;
        Big.E_POS = pos;
        if (!str) throwErr('!toFix!');
        return str;
    };
    /*
     * Return a string representing the value of this Big rounded to sd
     * significant digits using Big.RM. Use exponential notation if sd is less
     * than the number of digits necessary to represent the integer part of the
     * value in normal notation.
     *
     * sd {number} Integer, 1 to MAX_DP inclusive.
     */ P.toPrecision = function(sd) {
        if (sd == null) return this.toString();
        else if (sd !== ~~sd || sd < 1 || sd > MAX_DP) throwErr('!toPre!');
        return format(this, sd - 1, 2);
    };
    // Export
    Big = bigFactory();
    //AMD.
    if (typeof define === 'function' && define.amd) define(function() {
        return Big;
    });
    else if (module.exports) module.exports = Big;
    else global.Big = Big;
})(module.exports);

});

parcelRegister("fKCDk", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === '%%') return;
        index++;
        if (match === '%c') // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem('debug', namespaces);
        else exports.storage.removeItem('debug');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem('debug');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    r;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("hPh2v"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return '[UnexpectedJSONParseError]: ' + error.message;
    }
};

});
parcelRegister("hPh2v", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $cfa46ac285596fe7$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("24IBg"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== 'string') // Anything else let's inspect with %O
            args.unshift('%O');
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === '%%') return '%';
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === 'function') {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, 'enabled', {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === 'function') createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, '.*?');
            if (namespaces[0] === '-') createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
            else createDebug.names.push(new RegExp('^' + namespaces + '$'));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>'-' + namespace)
        ].join(',');
        createDebug.enable('');
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === '*') return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $cfa46ac285596fe7$var$setup;

});
parcelRegister("24IBg", function(module, exports) {
/**
 * Helpers.
 */ var $182e8d26ce3ede06$var$s = 1000;
var $182e8d26ce3ede06$var$m = $182e8d26ce3ede06$var$s * 60;
var $182e8d26ce3ede06$var$h = $182e8d26ce3ede06$var$m * 60;
var $182e8d26ce3ede06$var$d = $182e8d26ce3ede06$var$h * 24;
var $182e8d26ce3ede06$var$w = $182e8d26ce3ede06$var$d * 7;
var $182e8d26ce3ede06$var$y = $182e8d26ce3ede06$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $182e8d26ce3ede06$var$parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? $182e8d26ce3ede06$var$fmtLong(val) : $182e8d26ce3ede06$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $182e8d26ce3ede06$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $182e8d26ce3ede06$var$y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * $182e8d26ce3ede06$var$w;
        case 'days':
        case 'day':
        case 'd':
            return n * $182e8d26ce3ede06$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $182e8d26ce3ede06$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $182e8d26ce3ede06$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $182e8d26ce3ede06$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $182e8d26ce3ede06$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $182e8d26ce3ede06$var$d) return Math.round(ms / $182e8d26ce3ede06$var$d) + 'd';
    if (msAbs >= $182e8d26ce3ede06$var$h) return Math.round(ms / $182e8d26ce3ede06$var$h) + 'h';
    if (msAbs >= $182e8d26ce3ede06$var$m) return Math.round(ms / $182e8d26ce3ede06$var$m) + 'm';
    if (msAbs >= $182e8d26ce3ede06$var$s) return Math.round(ms / $182e8d26ce3ede06$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $182e8d26ce3ede06$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $182e8d26ce3ede06$var$d) return $182e8d26ce3ede06$var$plural(ms, msAbs, $182e8d26ce3ede06$var$d, 'day');
    if (msAbs >= $182e8d26ce3ede06$var$h) return $182e8d26ce3ede06$var$plural(ms, msAbs, $182e8d26ce3ede06$var$h, 'hour');
    if (msAbs >= $182e8d26ce3ede06$var$m) return $182e8d26ce3ede06$var$plural(ms, msAbs, $182e8d26ce3ede06$var$m, 'minute');
    if (msAbs >= $182e8d26ce3ede06$var$s) return $182e8d26ce3ede06$var$plural(ms, msAbs, $182e8d26ce3ede06$var$s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $182e8d26ce3ede06$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

});



parcelRegister("8cget", function(module, exports) {
// replaces all whitespace with '-' and removes
// all non-url friendly characters
(function() {
    var whitespace = /\s+/g;
    function slugger(string, opts) {
        opts || (opts = {});
        var allowedCharacters = "A-Za-z0-9_ -";
        if (opts.alsoAllow) allowedCharacters = opts.alsoAllow + allowedCharacters;
        var re = new RegExp('[^' + allowedCharacters + ']', 'g');
        var maintainCase = opts.maintainCase || false;
        var replacement = opts.replacement || '-';
        var smartTrim = opts.smartTrim;
        var decode = opts.decode !== false;
        var result;
        var lucky;
        if (typeof string !== 'string') return '';
        if (!maintainCase) string = string.toLowerCase();
        if (decode) string = decodeURIComponent(string);
        result = string.trim().replace(re, '').replace(whitespace, replacement);
        if (smartTrim && result.length > smartTrim) {
            lucky = result.charAt(smartTrim) === replacement;
            result = result.slice(0, smartTrim);
            if (!lucky) result = result.slice(0, result.lastIndexOf(replacement));
        }
        return result;
    }
    module.exports = slugger;
})();

});

parcelRegister("5gOw1", function(module, exports) {
/*
 * Original author: Joder Illi
 * 
 * Copyright (c) 2010, FormBlitz AG
 * All rights reserved.
 * Implementation of the stemming algorithm from http://snowball.tartarus.org/algorithms/german/stemmer.html
 * Copyright of the algorithm is: Copyright (c) 2001, Dr Martin Porter and can be found at http://snowball.tartarus.org/license.php
 *
 * Redistribution and use in source and binary forms, with or without 
 * modification, is covered by the standard BSD license. 
 * 
 */ /*
German includes the following accented forms,
ä   ö   ü 
and a special letter, ß, equivalent to double s.
The following letters are vowels:
a   e   i   o   u   y   ä   ö   ü 
*/ module.exports = function stem(word) {
    /*
    Put u and y between vowels into upper case
    */ word = word.replace(/([aeiouyäöü])u([aeiouyäöü])/g, '$1U$2');
    word = word.replace(/([aeiouyäöü])y([aeiouyäöü])/g, '$1Y$2');
    /*
    and then do the following mapping,
    (a) replace ß with ss,
    */ word = word.replace(/ß/g, 'ss');
    /*
    R1 and R2 are first set up in the standard way (see the note on R1 and R2), but then R1 is adjusted so that the region before it contains at least 3 letters.
    R1 is the region after the first non-vowel following a vowel, or is the null region at the end of the word if there is no such non-vowel.
    R2 is the region after the first non-vowel following a vowel in R1, or is the null region at the end of the word if there is no such non-vowel. 
    */ var r1Index = word.search(/[aeiouyäöü][^aeiouyäöü]/);
    var r1 = '';
    if (r1Index != -1) {
        r1Index += 2;
        r1 = word.substring(r1Index);
    }
    var r2Index = -1;
    var r2 = '';
    if (r1Index != -1) {
        r2Index = r1.search(/[aeiouyäöü][^aeiouyäöü]/);
        if (r2Index != -1) {
            r2Index += 2;
            r2 = r1.substring(r2Index);
            r2Index += r1Index;
        } else r2 = '';
    }
    if (r1Index != -1 && r1Index < 3) {
        r1Index = 3;
        r1 = word.substring(r1Index);
    }
    /*
    Define a valid s-ending as one of b, d, f, g, h, k, l, m, n, r or t.
    Define a valid st-ending as the same list, excluding letter r.
    */ /*
    Do each of steps 1, 2 and 3.
    */ /*
    Step 1:
    Search for the longest among the following suffixes,
    (a) em   ern   er
    (b) e   en   es
    (c) s (preceded by a valid s-ending)
    */ var a1Index = word.search(/(em|ern|er)$/g);
    var b1Index = word.search(/(e|en|es)$/g);
    var c1Index = word.search(/([bdfghklmnrt]s)$/g);
    if (c1Index != -1) c1Index++;
    var index1 = 10000;
    var optionUsed1 = '';
    if (a1Index != -1 && a1Index < index1) {
        optionUsed1 = 'a';
        index1 = a1Index;
    }
    if (b1Index != -1 && b1Index < index1) {
        optionUsed1 = 'b';
        index1 = b1Index;
    }
    if (c1Index != -1 && c1Index < index1) {
        optionUsed1 = 'c';
        index1 = c1Index;
    }
    /*
    and delete if in R1. (Of course the letter of the valid s-ending is not necessarily in R1.) If an ending of group (b) is deleted, and the ending is preceded by niss, delete the final s.
    (For example, äckern -> äck, ackers -> acker, armes -> arm, bedürfnissen -> bedürfnis)
    */ if (index1 != 10000 && r1Index != -1) {
        if (index1 >= r1Index) {
            word = word.substring(0, index1);
            if (optionUsed1 == 'b') {
                if (word.search(/niss$/) != -1) word = word.substring(0, word.length - 1);
            }
        }
    }
    /*
    Step 2:
    Search for the longest among the following suffixes,
    (a) en   er   est
    (b) st (preceded by a valid st-ending, itself preceded by at least 3 letters) 
    */ var a2Index = word.search(/(en|er|est)$/g);
    var b2Index = word.search(/(.{3}[bdfghklmnt]st)$/g);
    if (b2Index != -1) b2Index += 4;
    var index2 = 10000;
    var optionUsed2 = '';
    if (a2Index != -1 && a2Index < index2) {
        optionUsed2 = 'a';
        index2 = a2Index;
    }
    if (b2Index != -1 && b2Index < index2) {
        optionUsed2 = 'b';
        index2 = b2Index;
    }
    /*
    and delete if in R1.
    (For example, derbsten -> derbst by step 1, and derbst -> derb by step 2, since b is a valid st-ending, and is preceded by just 3 letters)
    */ if (index2 != 10000 && r1Index != -1) {
        if (index2 >= r1Index) word = word.substring(0, index2);
    }
    /*
    Step 3: d-suffixes (*)
    Search for the longest among the following suffixes, and perform the action indicated.
    end   ung
        delete if in R2 
        if preceded by ig, delete if in R2 and not preceded by e
    ig   ik   isch
        delete if in R2 and not preceded by e
    lich   heit
        delete if in R2 
        if preceded by er or en, delete if in R1
    keit
        delete if in R2 
        if preceded by lich or ig, delete if in R2 
    */ var a3Index = word.search(/(end|ung)$/g);
    var b3Index = word.search(/[^e](ig|ik|isch)$/g);
    var c3Index = word.search(/(lich|heit)$/g);
    var d3Index = word.search(/(keit)$/g);
    if (b3Index != -1) b3Index++;
    var index3 = 10000;
    var optionUsed3 = '';
    if (a3Index != -1 && a3Index < index3) {
        optionUsed3 = 'a';
        index3 = a3Index;
    }
    if (b3Index != -1 && b3Index < index3) {
        optionUsed3 = 'b';
        index3 = b3Index;
    }
    if (c3Index != -1 && c3Index < index3) {
        optionUsed3 = 'c';
        index3 = c3Index;
    }
    if (d3Index != -1 && d3Index < index3) {
        optionUsed3 = 'd';
        index3 = d3Index;
    }
    if (index3 != 10000 && r2Index != -1) {
        if (index3 >= r2Index) {
            word = word.substring(0, index3);
            var optionIndex = -1;
            // var optionSubsrt = '';
            if (optionUsed3 == 'a') {
                optionIndex = word.search(/[^e](ig)$/);
                if (optionIndex != -1) {
                    optionIndex++;
                    if (optionIndex >= r2Index) word = word.substring(0, optionIndex);
                }
            } else if (optionUsed3 == 'c') {
                optionIndex = word.search(/(er|en)$/);
                if (optionIndex != -1) {
                    if (optionIndex >= r1Index) word = word.substring(0, optionIndex);
                }
            } else if (optionUsed3 == 'd') {
                optionIndex = word.search(/(lich|ig)$/);
                if (optionIndex != -1) {
                    if (optionIndex >= r2Index) word = word.substring(0, optionIndex);
                }
            }
        }
    }
    /*
    Finally,
    turn U and Y back into lower case, and remove the umlaut accent from a, o and u. 
    */ word = word.replace(/U/g, 'u');
    word = word.replace(/Y/g, 'y');
    word = word.replace(/ä/g, 'a');
    word = word.replace(/ö/g, 'o');
    word = word.replace(/ü/g, 'u');
    return word;
};

});

parcelRegister("d0uB5", function(module, exports) {

$parcel$export(module.exports, "packagesList", function () { return $9783026532e65d66$export$f986546404422c17; });
$parcel$export(module.exports, "packaging", function () { return $9783026532e65d66$export$c7602a8e796430b9; });

var $kbVTi = parcelRequire("kbVTi");

var $kw3w9 = parcelRequire("kw3w9");
const $9783026532e65d66$var$Packaging = (0, (/*@__PURE__*/$parcel$interopDefault($kbVTi))).extend({
    model: (0, (/*@__PURE__*/$parcel$interopDefault($kw3w9))).extend({
        props: {
            id: 'string',
            type: 'string',
            name: 'string',
            plural: 'string'
        }
    })
});
const $9783026532e65d66$export$f986546404422c17 = [
    {
        id: 'keg',
        type: 'package',
        name: 'Fass',
        plural: "F\xe4sser"
    },
    {
        id: 'box',
        type: 'package',
        name: 'Kiste',
        plural: 'Kisten'
    },
    {
        id: 'tray',
        type: 'package',
        name: 'Tray',
        plural: 'Trays'
    },
    {
        id: 'carton',
        type: 'package',
        name: 'Karton',
        plural: 'Kartons'
    },
    {
        id: 'bottle',
        type: 'unit',
        name: 'Flasche',
        plural: 'Flaschen'
    },
    {
        id: 'can',
        type: 'unit',
        name: 'Dose',
        plural: 'Dosen'
    }
];
const $9783026532e65d66$export$c7602a8e796430b9 = new $9783026532e65d66$var$Packaging($9783026532e65d66$export$f986546404422c17);

});
parcelRegister("kbVTi", function(module, exports) {

var $9jqvh = parcelRequire("9jqvh");

var $2c6UK = parcelRequire("2c6UK");

var $3vzLP = parcelRequire("3vzLP");

var $cpUjj = parcelRequire("cpUjj");

var $akRxj = parcelRequire("akRxj");
var $eb31bda55806a02b$var$slice = [].slice;
function $eb31bda55806a02b$var$Collection(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator) this.comparator = options.comparator;
    if (options.parent) this.parent = options.parent;
    if (!this.mainIndex) {
        var idAttribute = this.model && this.model.prototype && this.model.prototype.idAttribute;
        this.mainIndex = idAttribute || 'id';
    }
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, $akRxj({
        silent: true
    }, options));
}
$akRxj($eb31bda55806a02b$var$Collection.prototype, $9jqvh, {
    initialize: function() {},
    isModel: function(model) {
        return this.model && model instanceof this.model;
    },
    add: function(models, options) {
        return this.set(models, $akRxj({
            merge: false,
            add: true,
            remove: false
        }, options));
    },
    // overridable parse method
    parse: function(res, options) {
        return res;
    },
    // overridable serialize method
    serialize: function() {
        return this.map(function(model) {
            if (model.serialize) return model.serialize();
            else {
                var out = {};
                $akRxj(out, model);
                delete out.collection;
                return out;
            }
        });
    },
    toJSON: function() {
        return this.serialize();
    },
    set: function(models, options) {
        options = $akRxj({
            add: true,
            remove: true,
            merge: true
        }, options);
        if (options.parse) models = this.parse(models, options);
        var singular = !$3vzLP(models);
        models = singular ? models ? [
            models
        ] : [] : models.slice();
        var id, model, attrs, existing, sort, i, length;
        var at = options.at;
        var sortable = this.comparator && at == null && options.sort !== false;
        var sortAttr = 'string' === typeof this.comparator ? this.comparator : null;
        var toAdd = [], toRemove = [], modelMap = {};
        var add = options.add, merge = options.merge, remove = options.remove;
        var order = !sortable && add && remove ? [] : false;
        var targetProto = this.model && this.model.prototype || Object.prototype;
        // Turn bare objects into model references, and prevent invalid models
        // from being added.
        for(i = 0, length = models.length; i < length; i++){
            attrs = models[i] || {};
            if (this.isModel(attrs)) id = model = attrs;
            else if (targetProto.generateId) id = targetProto.generateId(attrs);
            else {
                id = attrs[this.mainIndex];
                if (id === undefined && this._isDerivedIndex(targetProto)) id = targetProto._derived[this.mainIndex].fn.call(attrs);
            }
            // If a duplicate is found, prevent it from being added and
            // optionally merge it into the existing model.
            if (existing = this.get(id)) {
                if (remove) modelMap[existing.cid || existing[this.mainIndex]] = true;
                if (merge) {
                    attrs = attrs === model ? model.attributes : attrs;
                    if (options.parse) attrs = existing.parse(attrs, options);
                    // if this is model
                    if (existing.set) {
                        existing.set(attrs, options);
                        if (sortable && !sort && existing.hasChanged(sortAttr)) sort = true;
                    } else // if not just update the properties
                    $akRxj(existing, attrs);
                }
                models[i] = existing;
            // If this is a new, valid model, push it to the `toAdd` list.
            } else if (add) {
                model = models[i] = this._prepareModel(attrs, options);
                if (!model) continue;
                toAdd.push(model);
                this._addReference(model, options);
            }
            // Do not add multiple models with the same `id`.
            model = existing || model;
            if (!model) continue;
            if (order && (model.isNew && model.isNew() || !model[this.mainIndex] || !modelMap[model.cid || model[this.mainIndex]])) order.push(model);
            modelMap[model[this.mainIndex]] = true;
        }
        // Remove nonexistent models if appropriate.
        if (remove) {
            for(i = 0, length = this.length; i < length; i++){
                model = this.models[i];
                if (!modelMap[model.cid || model[this.mainIndex]]) toRemove.push(model);
            }
            if (toRemove.length) this.remove(toRemove, options);
            // Add indexes again to make sure they were not removed above.
            for(i = 0, length = toAdd.length; i < length; i++)this._index(toAdd[i]);
        }
        // See if sorting is needed, update `length` and splice in new models.
        if (toAdd.length || order && order.length) {
            if (sortable) sort = true;
            if (at != null) for(i = 0, length = toAdd.length; i < length; i++)this.models.splice(at + i, 0, toAdd[i]);
            else {
                var orderedModels = order || toAdd;
                for(i = 0, length = orderedModels.length; i < length; i++)this.models.push(orderedModels[i]);
            }
        }
        // Silently sort the collection if appropriate.
        if (sort) this.sort({
            silent: true
        });
        // Unless silenced, it's time to fire all appropriate add/sort events.
        if (!options.silent) {
            for(i = 0, length = toAdd.length; i < length; i++){
                model = toAdd[i];
                if (model.trigger) model.trigger('add', model, this, options);
                else this.trigger('add', model, this, options);
            }
            if (sort || order && order.length) this.trigger('sort', this, options);
        }
        // Return the added (or merged) model (or models).
        return singular ? models[0] : models;
    },
    get: function(query, indexName) {
        if (query == null) return;
        var collectionMainIndex = this.mainIndex;
        var index = this._indexes[indexName || collectionMainIndex];
        return index && (index[query] || query[collectionMainIndex] !== undefined && index[query[collectionMainIndex]]) || this._indexes.cid[query] || this._indexes.cid[query.cid];
    },
    // Get the model at the given index.
    at: function(index) {
        return this.models[index];
    },
    remove: function(models, options) {
        var singular = !$3vzLP(models);
        var i, length, model, index;
        models = singular ? [
            models
        ] : $eb31bda55806a02b$var$slice.call(models);
        options || (options = {});
        for(i = 0, length = models.length; i < length; i++){
            model = models[i] = this.get(models[i]);
            if (!model) continue;
            this._deIndex(model);
            index = this.models.indexOf(model);
            this.models.splice(index, 1);
            if (!options.silent) {
                options.index = index;
                if (model.trigger) model.trigger('remove', model, this, options);
                else this.trigger('remove', model, this, options);
            }
            this._removeReference(model, options);
        }
        return singular ? models[0] : models;
    },
    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
        options || (options = {});
        for(var i = 0, length = this.models.length; i < length; i++)this._removeReference(this.models[i], options);
        options.previousModels = this.models;
        this._reset();
        models = this.add(models, $akRxj({
            silent: true
        }, options));
        if (!options.silent) this.trigger('reset', this, options);
        return models;
    },
    sort: function(options) {
        var self = this;
        if (!this.comparator) throw new Error('Cannot sort a set without a comparator');
        options || (options = {});
        if (typeof this.comparator === 'string') this.models.sort(function(left, right) {
            if (left.get) {
                left = left.get(self.comparator);
                right = right.get(self.comparator);
            } else {
                left = left[self.comparator];
                right = right[self.comparator];
            }
            if (left > right || left === void 0) return 1;
            if (left < right || right === void 0) return -1;
            return 0;
        });
        else if (this.comparator.length === 1) this.models.sort(function(left, right) {
            left = self.comparator(left);
            right = self.comparator(right);
            if (left > right || left === void 0) return 1;
            if (left < right || right === void 0) return -1;
            return 0;
        });
        else this.models.sort($cpUjj(this.comparator, this));
        if (!options.silent) this.trigger('sort', this, options);
        return this;
    },
    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
        var list = $eb31bda55806a02b$var$slice.call(this.indexes || []);
        var i = 0;
        list.push(this.mainIndex);
        list.push('cid');
        var l = list.length;
        this.models = [];
        this._indexes = {};
        for(; i < l; i++)this._indexes[list[i]] = {};
    },
    _prepareModel: function(attrs, options) {
        // if we haven't defined a constructor, skip this
        if (!this.model) return attrs;
        if (this.isModel(attrs)) {
            if (!attrs.collection) attrs.collection = this;
            return attrs;
        } else {
            options = options ? $akRxj({}, options) : {};
            options.collection = this;
            // https://github.com/jashkenas/backbone/pull/4234
            var model;
            if (this.model.prototype) model = new this.model(attrs, options);
            else // ES class methods didn't have prototype
            model = this.model(attrs, options);
            if (!model.validationError) return model;
            this.trigger('invalid', this, model.validationError, options);
            return false;
        }
    },
    _deIndex: function(model, attribute, value) {
        var indexVal;
        if (attribute !== undefined) {
            if (undefined === this._indexes[attribute]) throw new Error('Given attribute is not an index');
            delete this._indexes[attribute][value];
            return;
        }
        // Not a specific attribute
        for(var indexAttr in this._indexes){
            indexVal = model.hasOwnProperty(indexAttr) ? model[indexAttr] : model.get && model.get(indexAttr);
            delete this._indexes[indexAttr][indexVal];
        }
    },
    _index: function(model, attribute) {
        var indexVal;
        if (attribute !== undefined) {
            if (undefined === this._indexes[attribute]) throw new Error('Given attribute is not an index');
            indexVal = model[attribute] || model.get && model.get(attribute);
            if (indexVal) this._indexes[attribute][indexVal] = model;
            return;
        }
        // Not a specific attribute
        for(var indexAttr in this._indexes){
            indexVal = model.hasOwnProperty(indexAttr) ? model[indexAttr] : model.get && model.get(indexAttr);
            if (indexVal != null) this._indexes[indexAttr][indexVal] = model;
        }
    },
    _isDerivedIndex: function(proto) {
        if (!proto || typeof proto._derived !== 'object') return false;
        return Object.keys(proto._derived).indexOf(this.mainIndex) >= 0;
    },
    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
        this._index(model);
        if (!model.collection) model.collection = this;
        if (model.on) model.on('all', this._onModelEvent, this);
    },
    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
        if (this === model.collection) delete model.collection;
        this._deIndex(model);
        if (model.off) model.off('all', this._onModelEvent, this);
    },
    _onModelEvent: function(event, model, collection, options) {
        var eventName = event.split(':')[0];
        var attribute = event.split(':')[1];
        if ((eventName === 'add' || eventName === 'remove') && collection !== this) return;
        if (eventName === 'destroy') this.remove(model, options);
        if (model && eventName === 'change' && attribute && this._indexes[attribute]) {
            this._deIndex(model, attribute, model.previousAttributes()[attribute]);
            this._index(model, attribute);
        }
        this.trigger.apply(this, arguments);
    }
});
Object.defineProperties($eb31bda55806a02b$var$Collection.prototype, {
    length: {
        get: function() {
            return this.models.length;
        }
    },
    isCollection: {
        get: function() {
            return true;
        }
    }
});
var $eb31bda55806a02b$var$arrayMethods = [
    'indexOf',
    'lastIndexOf',
    'every',
    'some',
    'forEach',
    'map',
    'filter',
    'reduce',
    'reduceRight'
];
$eb31bda55806a02b$var$arrayMethods.forEach(function(method) {
    $eb31bda55806a02b$var$Collection.prototype[method] = function() {
        return this.models[method].apply(this.models, arguments);
    };
});
// alias each/forEach for maximum compatibility
$eb31bda55806a02b$var$Collection.prototype.each = $eb31bda55806a02b$var$Collection.prototype.forEach;
$eb31bda55806a02b$var$Collection.extend = $2c6UK;
module.exports = $eb31bda55806a02b$var$Collection;

});
parcelRegister("2c6UK", function(module, exports) {

var $akRxj = parcelRequire("akRxj");
/// Following code is largely pasted from Backbone.js
// Helper function to correctly set up the prototype chain, for subclasses.
// Similar to `goog.inherits`, but uses a hash of prototype properties and
// class properties to be extended.
var $199210cb24c634e1$var$extend = function(protoProps) {
    var parent = this;
    var child;
    var args = [].slice.call(arguments);
    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && protoProps.hasOwnProperty('constructor')) child = protoProps.constructor;
    else child = function() {
        return parent.apply(this, arguments);
    };
    // Add static properties to the constructor function from parent
    $akRxj(child, parent);
    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function() {
        this.constructor = child;
    };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate();
    // Mix in all prototype properties to the subclass if supplied.
    if (protoProps) {
        args.unshift(child.prototype);
        $akRxj.apply(null, args);
    }
    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;
    return child;
};
// Expose the extend function
module.exports = $199210cb24c634e1$var$extend;

});

parcelRegister("cpUjj", function(module, exports) {

var $3YGtA = parcelRequire("3YGtA");

var $IZUSH = parcelRequire("IZUSH");

var $kBMR5 = parcelRequire("kBMR5");

var $PmHWS = parcelRequire("PmHWS");
/** Used to compose bitmasks for function metadata. */ var $90a37ff0bc8149dc$var$WRAP_BIND_FLAG = 1, $90a37ff0bc8149dc$var$WRAP_PARTIAL_FLAG = 32;
/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */ var $90a37ff0bc8149dc$var$bind = $3YGtA(function(func, thisArg, partials) {
    var bitmask = $90a37ff0bc8149dc$var$WRAP_BIND_FLAG;
    if (partials.length) {
        var holders = $PmHWS(partials, $kBMR5($90a37ff0bc8149dc$var$bind));
        bitmask |= $90a37ff0bc8149dc$var$WRAP_PARTIAL_FLAG;
    }
    return $IZUSH(func, bitmask, thisArg, partials, holders);
});
// Assign default placeholders.
$90a37ff0bc8149dc$var$bind.placeholder = {};
module.exports = $90a37ff0bc8149dc$var$bind;

});
parcelRegister("IZUSH", function(module, exports) {

var $cgzDW = parcelRequire("cgzDW");

var $h1Kxc = parcelRequire("h1Kxc");

var $aqjZw = parcelRequire("aqjZw");

var $jhSuX = parcelRequire("jhSuX");

var $5eH0l = parcelRequire("5eH0l");

var $cqZAK = parcelRequire("cqZAK");

var $gSUiK = parcelRequire("gSUiK");

var $4t1R6 = parcelRequire("4t1R6");

var $cKPsB = parcelRequire("cKPsB");

var $480y0 = parcelRequire("480y0");
/** Error message constants. */ var $0874237db1fcac19$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $0874237db1fcac19$var$WRAP_BIND_FLAG = 1, $0874237db1fcac19$var$WRAP_BIND_KEY_FLAG = 2, $0874237db1fcac19$var$WRAP_CURRY_FLAG = 8, $0874237db1fcac19$var$WRAP_CURRY_RIGHT_FLAG = 16, $0874237db1fcac19$var$WRAP_PARTIAL_FLAG = 32, $0874237db1fcac19$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0874237db1fcac19$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $0874237db1fcac19$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $0874237db1fcac19$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($0874237db1fcac19$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($0874237db1fcac19$var$WRAP_PARTIAL_FLAG | $0874237db1fcac19$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $0874237db1fcac19$var$nativeMax($480y0(ary), 0);
    arity = arity === undefined ? arity : $480y0(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $0874237db1fcac19$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $cqZAK(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $gSUiK(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $0874237db1fcac19$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($0874237db1fcac19$var$WRAP_CURRY_FLAG | $0874237db1fcac19$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($0874237db1fcac19$var$WRAP_CURRY_FLAG | $0874237db1fcac19$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $0874237db1fcac19$var$WRAP_BIND_FLAG) var result = $h1Kxc(func, bitmask, thisArg);
    else if (bitmask == $0874237db1fcac19$var$WRAP_CURRY_FLAG || bitmask == $0874237db1fcac19$var$WRAP_CURRY_RIGHT_FLAG) result = $aqjZw(func, bitmask, arity);
    else if ((bitmask == $0874237db1fcac19$var$WRAP_PARTIAL_FLAG || bitmask == ($0874237db1fcac19$var$WRAP_BIND_FLAG | $0874237db1fcac19$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $5eH0l(func, bitmask, thisArg, partials);
    else result = $jhSuX.apply(undefined, newData);
    var setter = data ? $cgzDW : $4t1R6;
    return $cKPsB(setter(result, newData), func, bitmask);
}
module.exports = $0874237db1fcac19$var$createWrap;

});
parcelRegister("cgzDW", function(module, exports) {

var $9qV0f = parcelRequire("9qV0f");

var $b37Ml = parcelRequire("b37Ml");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $8ee2a0a3ff5bed30$var$baseSetData = !$b37Ml ? $9qV0f : function(func, data) {
    $b37Ml.set(func, data);
    return func;
};
module.exports = $8ee2a0a3ff5bed30$var$baseSetData;

});
parcelRegister("b37Ml", function(module, exports) {

var $fZWIb = parcelRequire("fZWIb");
/** Used to store function metadata. */ var $80b6023d18e5ad9a$var$metaMap = $fZWIb && new $fZWIb;
module.exports = $80b6023d18e5ad9a$var$metaMap;

});


parcelRegister("h1Kxc", function(module, exports) {

var $8d52G = parcelRequire("8d52G");

var $cZ0ro = parcelRequire("cZ0ro");
/** Used to compose bitmasks for function metadata. */ var $c656a06fb41c4a17$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $c656a06fb41c4a17$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $c656a06fb41c4a17$var$WRAP_BIND_FLAG, Ctor = $8d52G(func);
    function wrapper() {
        var fn = this && this !== $cZ0ro && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $c656a06fb41c4a17$var$createBind;

});
parcelRegister("8d52G", function(module, exports) {

var $3F6V9 = parcelRequire("3F6V9");

var $5DUFR = parcelRequire("5DUFR");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $5fa372eb8ddf65a6$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $3F6V9(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $5DUFR(result) ? result : thisBinding;
    };
}
module.exports = $5fa372eb8ddf65a6$var$createCtor;

});
parcelRegister("3F6V9", function(module, exports) {

var $5DUFR = parcelRequire("5DUFR");
/** Built-in value references. */ var $2aaa91bbcac8ca1e$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $2aaa91bbcac8ca1e$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$5DUFR(proto)) return {};
        if ($2aaa91bbcac8ca1e$var$objectCreate) return $2aaa91bbcac8ca1e$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $2aaa91bbcac8ca1e$var$baseCreate;

});



parcelRegister("aqjZw", function(module, exports) {

var $an76h = parcelRequire("an76h");

var $8d52G = parcelRequire("8d52G");

var $jhSuX = parcelRequire("jhSuX");

var $BVlqv = parcelRequire("BVlqv");

var $kBMR5 = parcelRequire("kBMR5");

var $PmHWS = parcelRequire("PmHWS");

var $cZ0ro = parcelRequire("cZ0ro");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $796bd6f5f8c2b30a$var$createCurry(func, bitmask, arity) {
    var Ctor = $8d52G(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $kBMR5(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $PmHWS(args, placeholder);
        length -= holders.length;
        if (length < arity) return $BVlqv(func, bitmask, $jhSuX, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $cZ0ro && this instanceof wrapper ? Ctor : func;
        return $an76h(fn, this, args);
    }
    return wrapper;
}
module.exports = $796bd6f5f8c2b30a$var$createCurry;

});
parcelRegister("jhSuX", function(module, exports) {

var $bp17P = parcelRequire("bp17P");

var $D05hs = parcelRequire("D05hs");

var $49wux = parcelRequire("49wux");

var $8d52G = parcelRequire("8d52G");

var $BVlqv = parcelRequire("BVlqv");

var $kBMR5 = parcelRequire("kBMR5");

var $ewBXg = parcelRequire("ewBXg");

var $PmHWS = parcelRequire("PmHWS");

var $cZ0ro = parcelRequire("cZ0ro");
/** Used to compose bitmasks for function metadata. */ var $e0a9e11620a5e04e$var$WRAP_BIND_FLAG = 1, $e0a9e11620a5e04e$var$WRAP_BIND_KEY_FLAG = 2, $e0a9e11620a5e04e$var$WRAP_CURRY_FLAG = 8, $e0a9e11620a5e04e$var$WRAP_CURRY_RIGHT_FLAG = 16, $e0a9e11620a5e04e$var$WRAP_ARY_FLAG = 128, $e0a9e11620a5e04e$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $e0a9e11620a5e04e$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $e0a9e11620a5e04e$var$WRAP_ARY_FLAG, isBind = bitmask & $e0a9e11620a5e04e$var$WRAP_BIND_FLAG, isBindKey = bitmask & $e0a9e11620a5e04e$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($e0a9e11620a5e04e$var$WRAP_CURRY_FLAG | $e0a9e11620a5e04e$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $e0a9e11620a5e04e$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $8d52G(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $kBMR5(wrapper), holdersCount = $49wux(args, placeholder);
        if (partials) args = $bp17P(args, partials, holders, isCurried);
        if (partialsRight) args = $D05hs(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $PmHWS(args, placeholder);
            return $BVlqv(func, bitmask, $e0a9e11620a5e04e$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $ewBXg(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $cZ0ro && this instanceof wrapper) fn = Ctor || $8d52G(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $e0a9e11620a5e04e$var$createHybrid;

});
parcelRegister("bp17P", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $84d2e6f43017bc76$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $84d2e6f43017bc76$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $84d2e6f43017bc76$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $84d2e6f43017bc76$var$composeArgs;

});

parcelRegister("D05hs", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0753b558e814c62d$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $0753b558e814c62d$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $0753b558e814c62d$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $0753b558e814c62d$var$composeArgsRight;

});

parcelRegister("49wux", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $306134d469491288$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $306134d469491288$var$countHolders;

});

parcelRegister("BVlqv", function(module, exports) {

var $dv5y9 = parcelRequire("dv5y9");

var $4t1R6 = parcelRequire("4t1R6");

var $cKPsB = parcelRequire("cKPsB");
/** Used to compose bitmasks for function metadata. */ var $071ff041b1810c69$var$WRAP_BIND_FLAG = 1, $071ff041b1810c69$var$WRAP_BIND_KEY_FLAG = 2, $071ff041b1810c69$var$WRAP_CURRY_BOUND_FLAG = 4, $071ff041b1810c69$var$WRAP_CURRY_FLAG = 8, $071ff041b1810c69$var$WRAP_PARTIAL_FLAG = 32, $071ff041b1810c69$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $071ff041b1810c69$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $071ff041b1810c69$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $071ff041b1810c69$var$WRAP_PARTIAL_FLAG : $071ff041b1810c69$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $071ff041b1810c69$var$WRAP_PARTIAL_RIGHT_FLAG : $071ff041b1810c69$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $071ff041b1810c69$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($071ff041b1810c69$var$WRAP_BIND_FLAG | $071ff041b1810c69$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($dv5y9(func)) $4t1R6(result, newData);
    result.placeholder = placeholder;
    return $cKPsB(result, func, bitmask);
}
module.exports = $071ff041b1810c69$var$createRecurry;

});
parcelRegister("dv5y9", function(module, exports) {

var $AfdEg = parcelRequire("AfdEg");

var $cqZAK = parcelRequire("cqZAK");

var $i2LjJ = parcelRequire("i2LjJ");

var $bj2v8 = parcelRequire("bj2v8");
/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */ function $9d4279b285deb722$var$isLaziable(func) {
    var funcName = $i2LjJ(func), other = $bj2v8[funcName];
    if (typeof other != 'function' || !(funcName in $AfdEg.prototype)) return false;
    if (func === other) return true;
    var data = $cqZAK(other);
    return !!data && func === data[0];
}
module.exports = $9d4279b285deb722$var$isLaziable;

});
parcelRegister("AfdEg", function(module, exports) {

var $3F6V9 = parcelRequire("3F6V9");

var $ke2JQ = parcelRequire("ke2JQ");
/** Used as references for the maximum length and index of an array. */ var $06cf2b1c6541b75c$var$MAX_ARRAY_LENGTH = 4294967295;
/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */ function $06cf2b1c6541b75c$var$LazyWrapper(value) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__dir__ = 1;
    this.__filtered__ = false;
    this.__iteratees__ = [];
    this.__takeCount__ = $06cf2b1c6541b75c$var$MAX_ARRAY_LENGTH;
    this.__views__ = [];
}
// Ensure `LazyWrapper` is an instance of `baseLodash`.
$06cf2b1c6541b75c$var$LazyWrapper.prototype = $3F6V9($ke2JQ.prototype);
$06cf2b1c6541b75c$var$LazyWrapper.prototype.constructor = $06cf2b1c6541b75c$var$LazyWrapper;
module.exports = $06cf2b1c6541b75c$var$LazyWrapper;

});
parcelRegister("ke2JQ", function(module, exports) {
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */ function $eb973d4316371920$var$baseLodash() {
// No operation performed.
}
module.exports = $eb973d4316371920$var$baseLodash;

});


parcelRegister("cqZAK", function(module, exports) {

var $b37Ml = parcelRequire("b37Ml");

var $8b7KM = parcelRequire("8b7KM");
/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */ var $90d7b0927a7da666$var$getData = !$b37Ml ? $8b7KM : function(func) {
    return $b37Ml.get(func);
};
module.exports = $90d7b0927a7da666$var$getData;

});
parcelRegister("8b7KM", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $5f455d851dd37c2a$var$noop() {
// No operation performed.
}
module.exports = $5f455d851dd37c2a$var$noop;

});


parcelRegister("i2LjJ", function(module, exports) {

var $8LxwA = parcelRequire("8LxwA");
/** Used for built-in method references. */ var $d22d1e2397797b01$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d22d1e2397797b01$var$hasOwnProperty = $d22d1e2397797b01$var$objectProto.hasOwnProperty;
/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */ function $d22d1e2397797b01$var$getFuncName(func) {
    var result = func.name + '', array = $8LxwA[result], length = $d22d1e2397797b01$var$hasOwnProperty.call($8LxwA, result) ? array.length : 0;
    while(length--){
        var data = array[length], otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) return data.name;
    }
    return result;
}
module.exports = $d22d1e2397797b01$var$getFuncName;

});
parcelRegister("8LxwA", function(module, exports) {
/** Used to lookup unminified function names. */ var $661cb7d1743cae46$var$realNames = {};
module.exports = $661cb7d1743cae46$var$realNames;

});


parcelRegister("bj2v8", function(module, exports) {

var $AfdEg = parcelRequire("AfdEg");

var $fTIty = parcelRequire("fTIty");

var $ke2JQ = parcelRequire("ke2JQ");

var $3vzLP = parcelRequire("3vzLP");

var $lIKbn = parcelRequire("lIKbn");

var $NK67n = parcelRequire("NK67n");
/** Used for built-in method references. */ var $83b368c268b91f83$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $83b368c268b91f83$var$hasOwnProperty = $83b368c268b91f83$var$objectProto.hasOwnProperty;
/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */ function $83b368c268b91f83$var$lodash(value) {
    if ($lIKbn(value) && !$3vzLP(value) && !(value instanceof $AfdEg)) {
        if (value instanceof $fTIty) return value;
        if ($83b368c268b91f83$var$hasOwnProperty.call(value, '__wrapped__')) return $NK67n(value);
    }
    return new $fTIty(value);
}
// Ensure wrappers are instances of `baseLodash`.
$83b368c268b91f83$var$lodash.prototype = $ke2JQ.prototype;
$83b368c268b91f83$var$lodash.prototype.constructor = $83b368c268b91f83$var$lodash;
module.exports = $83b368c268b91f83$var$lodash;

});
parcelRegister("fTIty", function(module, exports) {

var $3F6V9 = parcelRequire("3F6V9");

var $ke2JQ = parcelRequire("ke2JQ");
/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */ function $b92e7e07f181c089$var$LodashWrapper(value, chainAll) {
    this.__wrapped__ = value;
    this.__actions__ = [];
    this.__chain__ = !!chainAll;
    this.__index__ = 0;
    this.__values__ = undefined;
}
$b92e7e07f181c089$var$LodashWrapper.prototype = $3F6V9($ke2JQ.prototype);
$b92e7e07f181c089$var$LodashWrapper.prototype.constructor = $b92e7e07f181c089$var$LodashWrapper;
module.exports = $b92e7e07f181c089$var$LodashWrapper;

});

parcelRegister("NK67n", function(module, exports) {

var $AfdEg = parcelRequire("AfdEg");

var $fTIty = parcelRequire("fTIty");

var $73mnJ = parcelRequire("73mnJ");
/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */ function $095855c1ad5ef737$var$wrapperClone(wrapper) {
    if (wrapper instanceof $AfdEg) return wrapper.clone();
    var result = new $fTIty(wrapper.__wrapped__, wrapper.__chain__);
    result.__actions__ = $73mnJ(wrapper.__actions__);
    result.__index__ = wrapper.__index__;
    result.__values__ = wrapper.__values__;
    return result;
}
module.exports = $095855c1ad5ef737$var$wrapperClone;

});



parcelRegister("4t1R6", function(module, exports) {

var $cgzDW = parcelRequire("cgzDW");

var $967B3 = parcelRequire("967B3");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $340b4f57d1e1b6a4$var$setData = $967B3($cgzDW);
module.exports = $340b4f57d1e1b6a4$var$setData;

});

parcelRegister("cKPsB", function(module, exports) {

var $lp7uL = parcelRequire("lp7uL");

var $gv0qw = parcelRequire("gv0qw");

var $eHZN2 = parcelRequire("eHZN2");

var $lXEEx = parcelRequire("lXEEx");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $9491b2d9b97108b3$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $eHZN2(wrapper, $gv0qw(source, $lXEEx($lp7uL(source), bitmask)));
}
module.exports = $9491b2d9b97108b3$var$setWrapToString;

});
parcelRegister("lp7uL", function(module, exports) {
/** Used to match wrap detail comments. */ var $f951bf2f607a32ac$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $f951bf2f607a32ac$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $f951bf2f607a32ac$var$getWrapDetails(source) {
    var match = source.match($f951bf2f607a32ac$var$reWrapDetails);
    return match ? match[1].split($f951bf2f607a32ac$var$reSplitDetails) : [];
}
module.exports = $f951bf2f607a32ac$var$getWrapDetails;

});

parcelRegister("gv0qw", function(module, exports) {
/** Used to match wrap detail comments. */ var $c02fdf586480d590$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $c02fdf586480d590$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($c02fdf586480d590$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $c02fdf586480d590$var$insertWrapDetails;

});

parcelRegister("lXEEx", function(module, exports) {

var $fTNj0 = parcelRequire("fTNj0");

var $f9USe = parcelRequire("f9USe");
/** Used to compose bitmasks for function metadata. */ var $ffcea475bcb4f2d1$var$WRAP_BIND_FLAG = 1, $ffcea475bcb4f2d1$var$WRAP_BIND_KEY_FLAG = 2, $ffcea475bcb4f2d1$var$WRAP_CURRY_FLAG = 8, $ffcea475bcb4f2d1$var$WRAP_CURRY_RIGHT_FLAG = 16, $ffcea475bcb4f2d1$var$WRAP_PARTIAL_FLAG = 32, $ffcea475bcb4f2d1$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $ffcea475bcb4f2d1$var$WRAP_ARY_FLAG = 128, $ffcea475bcb4f2d1$var$WRAP_REARG_FLAG = 256, $ffcea475bcb4f2d1$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $ffcea475bcb4f2d1$var$wrapFlags = [
    [
        'ary',
        $ffcea475bcb4f2d1$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $ffcea475bcb4f2d1$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $ffcea475bcb4f2d1$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $ffcea475bcb4f2d1$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $ffcea475bcb4f2d1$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $ffcea475bcb4f2d1$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $ffcea475bcb4f2d1$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $ffcea475bcb4f2d1$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $ffcea475bcb4f2d1$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $ffcea475bcb4f2d1$var$updateWrapDetails(details, bitmask) {
    $fTNj0($ffcea475bcb4f2d1$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$f9USe(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $ffcea475bcb4f2d1$var$updateWrapDetails;

});



parcelRegister("kBMR5", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $f00d28f5cfb1a28c$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $f00d28f5cfb1a28c$var$getHolder;

});

parcelRegister("ewBXg", function(module, exports) {

var $73mnJ = parcelRequire("73mnJ");

var $c8QtW = parcelRequire("c8QtW");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a9317ee4641345db$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $a9317ee4641345db$var$reorder(array, indexes) {
    var arrLength = array.length, length = $a9317ee4641345db$var$nativeMin(indexes.length, arrLength), oldArray = $73mnJ(array);
    while(length--){
        var index = indexes[length];
        array[length] = $c8QtW(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $a9317ee4641345db$var$reorder;

});

parcelRegister("PmHWS", function(module, exports) {
/** Used as the internal argument placeholder. */ var $09a660d73d095c72$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $09a660d73d095c72$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $09a660d73d095c72$var$PLACEHOLDER) {
            array[index] = $09a660d73d095c72$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $09a660d73d095c72$var$replaceHolders;

});



parcelRegister("5eH0l", function(module, exports) {

var $an76h = parcelRequire("an76h");

var $8d52G = parcelRequire("8d52G");

var $cZ0ro = parcelRequire("cZ0ro");
/** Used to compose bitmasks for function metadata. */ var $3cff9e6434c92c33$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $3cff9e6434c92c33$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $3cff9e6434c92c33$var$WRAP_BIND_FLAG, Ctor = $8d52G(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $cZ0ro && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $an76h(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $3cff9e6434c92c33$var$createPartial;

});

parcelRegister("gSUiK", function(module, exports) {

var $bp17P = parcelRequire("bp17P");

var $D05hs = parcelRequire("D05hs");

var $PmHWS = parcelRequire("PmHWS");
/** Used as the internal argument placeholder. */ var $c4ad5cc32bb14f26$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $c4ad5cc32bb14f26$var$WRAP_BIND_FLAG = 1, $c4ad5cc32bb14f26$var$WRAP_BIND_KEY_FLAG = 2, $c4ad5cc32bb14f26$var$WRAP_CURRY_BOUND_FLAG = 4, $c4ad5cc32bb14f26$var$WRAP_CURRY_FLAG = 8, $c4ad5cc32bb14f26$var$WRAP_ARY_FLAG = 128, $c4ad5cc32bb14f26$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c4ad5cc32bb14f26$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $c4ad5cc32bb14f26$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($c4ad5cc32bb14f26$var$WRAP_BIND_FLAG | $c4ad5cc32bb14f26$var$WRAP_BIND_KEY_FLAG | $c4ad5cc32bb14f26$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $c4ad5cc32bb14f26$var$WRAP_ARY_FLAG && bitmask == $c4ad5cc32bb14f26$var$WRAP_CURRY_FLAG || srcBitmask == $c4ad5cc32bb14f26$var$WRAP_ARY_FLAG && bitmask == $c4ad5cc32bb14f26$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($c4ad5cc32bb14f26$var$WRAP_ARY_FLAG | $c4ad5cc32bb14f26$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $c4ad5cc32bb14f26$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $c4ad5cc32bb14f26$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $c4ad5cc32bb14f26$var$WRAP_BIND_FLAG ? 0 : $c4ad5cc32bb14f26$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $bp17P(partials, value, source[4]) : value;
        data[4] = partials ? $PmHWS(data[3], $c4ad5cc32bb14f26$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $D05hs(partials, value, source[6]) : value;
        data[6] = partials ? $PmHWS(data[5], $c4ad5cc32bb14f26$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $c4ad5cc32bb14f26$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $c4ad5cc32bb14f26$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $c4ad5cc32bb14f26$var$mergeData;

});




parcelRegister("kw3w9", function(module, exports) {
'use strict';

var $91FRf = parcelRequire("91FRf");

var $akRxj = parcelRequire("akRxj");
var $eef98657c52313c1$var$cloneObj = function(obj) {
    return $akRxj({}, obj);
};

var $18d74 = parcelRequire("18d74");

var $kxFut = parcelRequire("kxFut");

var $eC9l3 = parcelRequire("eC9l3");

var $80YiL = parcelRequire("80YiL");

var $fyYMa = parcelRequire("fyYMa");

var $5DUFR = parcelRequire("5DUFR");

var $cfVrj = parcelRequire("cfVrj");

var $62yEr = parcelRequire("62yEr");

var $jk6VI = parcelRequire("jk6VI");

var $8u49u = parcelRequire("8u49u");

var $a0MTb = parcelRequire("a0MTb");

var $9YydO = parcelRequire("9YydO");

var $9jqvh = parcelRequire("9jqvh");

var $ks7UM = parcelRequire("ks7UM");

var $eHeLE = parcelRequire("eHeLE");
var $eef98657c52313c1$var$changeRE = /^change:/;
var $eef98657c52313c1$var$noop = function() {};
function $eef98657c52313c1$var$Base(attrs, options) {
    options || (options = {});
    this.cid || (this.cid = $91FRf('state'));
    this._events = {};
    this._values = {};
    this._eventBubblingHandlerCache = {};
    this._definition = Object.create(this._definition);
    if (options.parse) attrs = this.parse(attrs, options);
    this.parent = options.parent;
    this.collection = options.collection;
    this._keyTree = new $ks7UM();
    this._initCollections();
    this._initChildren();
    this._cache = {};
    this._previousAttributes = {};
    if (attrs) this.set(attrs, $akRxj({
        silent: true,
        initial: true
    }, options));
    this._changed = {};
    if (this._derived) this._initDerived();
    if (options.init !== false) this.initialize.apply(this, arguments);
}
$akRxj($eef98657c52313c1$var$Base.prototype, $9jqvh, {
    // can be allow, ignore, reject
    extraProperties: 'ignore',
    idAttribute: 'id',
    namespaceAttribute: 'namespace',
    typeAttribute: 'modelType',
    // Stubbed out to be overwritten
    initialize: function() {
        return this;
    },
    // Get ID of model per configuration.
    // Should *always* be how ID is determined by other code.
    getId: function() {
        return this[this.idAttribute];
    },
    // Get namespace of model per configuration.
    // Should *always* be how namespace is determined by other code.
    getNamespace: function() {
        return this[this.namespaceAttribute];
    },
    // Get type of model per configuration.
    // Should *always* be how type is determined by other code.
    getType: function() {
        return this[this.typeAttribute];
    },
    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
        return this.getId() == null;
    },
    // get HTML-escaped value of attribute
    escape: function(attr) {
        return $kxFut(this.get(attr));
    },
    // Check if the model is currently in a valid state.
    isValid: function(options) {
        return this._validate({}, $akRxj(options || {}, {
            validate: true
        }));
    },
    // Parse can be used remap/restructure/rename incoming properties
    // before they are applied to attributes.
    parse: function(resp, options) {
        //jshint unused:false
        return resp;
    },
    // Serialize is the inverse of `parse` it lets you massage data
    // on the way out. Before, sending to server, for example.
    serialize: function(options) {
        var attrOpts = $akRxj({
            props: true
        }, options);
        var res = this.getAttributes(attrOpts, true);
        var setFromSerializedValue = (function(value, key) {
            res[key] = this[key].serialize();
        }).bind(this);
        $eC9l3(this._children, setFromSerializedValue);
        $eC9l3(this._collections, setFromSerializedValue);
        return res;
    },
    // Main set method used by generated setters/getters and can
    // be used directly if you need to pass options or set multiple
    // properties at once.
    set: function(key, value, options) {
        var self = this;
        var extraProperties = this.extraProperties;
        var wasChanging, changeEvents, newType, newVal, def, cast, err, attr, attrs, dataType, silent, unset, currentVal, initial, hasChanged, isEqual, onChange;
        // Handle both `"key", value` and `{key: value}` -style arguments.
        if ($5DUFR(key) || key === null) {
            attrs = key;
            options = value;
        } else {
            attrs = {};
            attrs[key] = value;
        }
        options = options || {};
        if (!this._validate(attrs, options)) return false;
        // Extract attributes and options.
        unset = options.unset;
        silent = options.silent;
        initial = options.initial;
        // Initialize change tracking.
        wasChanging = this._changing;
        this._changing = true;
        changeEvents = [];
        // if not already changing, store previous
        if (initial) this._previousAttributes = {};
        else if (!wasChanging) {
            this._previousAttributes = this.attributes;
            this._changed = {};
        }
        // For each `set` attribute...
        for(var i = 0, keys = Object.keys(attrs), len = keys.length; i < len; i++){
            attr = keys[i];
            newVal = attrs[attr];
            newType = typeof newVal;
            currentVal = this._values[attr];
            def = this._definition[attr];
            if (!def) {
                // if this is a child model or collection
                if (this._children[attr] || this._collections[attr]) {
                    if (!$5DUFR(newVal)) newVal = {};
                    this[attr].set(newVal, options);
                    continue;
                } else if (extraProperties === 'ignore') continue;
                else if (extraProperties === 'reject') throw new TypeError('No "' + attr + '" property defined on ' + (this.type || 'this') + ' model and extraProperties not set to "ignore" or "allow"');
                else if (extraProperties === 'allow') def = this._createPropertyDefinition(attr, 'any');
                else if (extraProperties) throw new TypeError('Invalid value for extraProperties: "' + extraProperties + '"');
            }
            isEqual = this._getCompareForType(def.type);
            onChange = this._getOnChangeForType(def.type);
            dataType = this._dataTypes[def.type];
            // check type if we have one
            if (dataType && dataType.set) {
                cast = dataType.set(newVal);
                newVal = cast.val;
                newType = cast.type;
            }
            // If we've defined a test, run it
            if (def.test) {
                err = def.test.call(this, newVal, newType);
                if (err) throw new TypeError('Property \'' + attr + '\' failed validation with error: ' + err);
            }
            // If we are required but undefined, throw error.
            // If we are null and are not allowing null, throw error
            // If we have a defined type and the new type doesn't match, and we are not null, throw error.
            // If we require specific value and new one is not one of them, throw error (unless it has default value or we're unsetting it with undefined).
            if (newVal === undefined && def.required) throw new TypeError('Required property \'' + attr + '\' must be of type ' + def.type + '. Tried to set ' + newVal);
            if (newVal === null && def.required && !def.allowNull) throw new TypeError('Property \'' + attr + '\' must be of type ' + def.type + ' (cannot be null). Tried to set ' + newVal);
            if (def.type && def.type !== 'any' && def.type !== newType && newVal !== null && newVal !== undefined) throw new TypeError('Property \'' + attr + '\' must be of type ' + def.type + '. Tried to set ' + newVal);
            if (def.values && !$80YiL(def.values, newVal)) {
                var defaultValue = $a0MTb(def, 'default');
                if (unset && defaultValue !== undefined) newVal = defaultValue;
                else if (!unset || unset && newVal !== undefined) throw new TypeError('Property \'' + attr + '\' must be one of values: ' + def.values.join(', ') + '. Tried to set ' + newVal);
            }
            // We know this has 'changed' if it's the initial set, so skip a potentially expensive isEqual check.
            hasChanged = initial || !isEqual(currentVal, newVal, attr);
            // enforce `setOnce` for properties if set
            if (def.setOnce && currentVal !== undefined && hasChanged) throw new TypeError('Property \'' + attr + '\' can only be set once.');
            // set/unset attributes.
            // If this is not the initial set, keep track of changed attributes
            // and push to changeEvents array so we can fire events.
            if (hasChanged) {
                // This fires no matter what, even on initial set.
                onChange(newVal, currentVal, attr);
                // If this is a change (not an initial set), mark the change.
                // Note it's impossible to unset on the initial set (it will already be unset),
                // so we only include that logic here.
                if (!initial) {
                    this._changed[attr] = newVal;
                    this._previousAttributes[attr] = currentVal;
                    if (unset) // FIXME delete is very slow. Can we get away with setting to undefined?
                    delete this._values[attr];
                    if (!silent) changeEvents.push({
                        prev: currentVal,
                        val: newVal,
                        key: attr
                    });
                }
                if (!unset) this._values[attr] = newVal;
            } else // Not changed
            // FIXME delete is very slow. Can we get away with setting to undefined?
            delete this._changed[attr];
        }
        // Fire events. This array is not populated if we are told to be silent.
        if (changeEvents.length) this._pending = true;
        changeEvents.forEach(function(change) {
            self.trigger('change:' + change.key, self, change.val, options);
        });
        // You might be wondering why there's a `while` loop here. Changes can
        // be recursively nested within `"change"` events.
        if (wasChanging) return this;
        while(this._pending){
            this._pending = false;
            this.trigger('change', this, options);
        }
        this._pending = false;
        this._changing = false;
        return this;
    },
    get: function(attr) {
        return this[attr];
    },
    // Toggle boolean properties or properties that have a `values`
    // array in its definition.
    toggle: function(property) {
        var def = this._definition[property];
        if (def.type === 'boolean') // if it's a bool, just flip it
        this[property] = !this[property];
        else if (def && def.values) // If it's a property with an array of values
        // skip to the next one looping back if at end.
        this[property] = $eHeLE(def.values, this[property]);
        else throw new TypeError('Can only toggle properties that are type `boolean` or have `values` array.');
        return this;
    },
    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
        return $eef98657c52313c1$var$cloneObj(this._previousAttributes);
    },
    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
        if (attr == null) return !!Object.keys(this._changed).length;
        if ($8u49u(this._derived, attr)) return this._derived[attr].depList.some(function(dep) {
            return this.hasChanged(dep);
        }, this);
        return $8u49u(this._changed, attr);
    },
    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
        if (!diff) return this.hasChanged() ? $eef98657c52313c1$var$cloneObj(this._changed) : false;
        var val, changed = false;
        var old = this._changing ? this._previousAttributes : this.attributes;
        var def, isEqual;
        for(var attr in diff){
            def = this._definition[attr];
            if (!def) continue;
            isEqual = this._getCompareForType(def.type);
            if (isEqual(old[attr], val = diff[attr])) continue;
            (changed || (changed = {}))[attr] = val;
        }
        return changed;
    },
    toJSON: function() {
        return this.serialize();
    },
    unset: function(attrs, options) {
        var self = this;
        attrs = Array.isArray(attrs) ? attrs : [
            attrs
        ];
        attrs.forEach(function(key) {
            var def = self._definition[key];
            if (!def) return;
            var val;
            if (def.required) {
                val = $a0MTb(def, 'default');
                return self.set(key, val, options);
            } else return self.set(key, val, $akRxj({}, options, {
                unset: true
            }));
        });
    },
    clear: function(options) {
        var self = this;
        Object.keys(this.attributes).forEach(function(key) {
            self.unset(key, options);
        });
        return this;
    },
    previous: function(attr) {
        if (attr == null || !Object.keys(this._previousAttributes).length) return null;
        return this._previousAttributes[attr];
    },
    // Get default values for a certain type
    _getDefaultForType: function(type) {
        var dataType = this._dataTypes[type];
        return dataType && dataType['default'];
    },
    // Determine which comparison algorithm to use for comparing a property
    _getCompareForType: function(type) {
        var dataType = this._dataTypes[type];
        if (dataType && dataType.compare) return dataType.compare.bind(this);
        return $jk6VI; // if no compare function is defined, use _.isEqual
    },
    _getOnChangeForType: function(type) {
        var dataType = this._dataTypes[type];
        if (dataType && dataType.onChange) return dataType.onChange.bind(this);
        return $eef98657c52313c1$var$noop;
    },
    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
        if (!options.validate || !this.validate) return true;
        attrs = $akRxj({}, this.attributes, attrs);
        var error = this.validationError = this.validate(attrs, options) || null;
        if (!error) return true;
        this.trigger('invalid', this, error, $akRxj(options || {}, {
            validationError: error
        }));
        return false;
    },
    _createPropertyDefinition: function(name, desc, isSession) {
        return $eef98657c52313c1$var$createPropertyDefinition(this, name, desc, isSession);
    },
    // just makes friendlier errors when trying to define a new model
    // only used when setting up original property definitions
    _ensureValidType: function(type) {
        return $80YiL([
            'string',
            'number',
            'boolean',
            'array',
            'object',
            'date',
            'state',
            'any'
        ].concat(Object.keys(this._dataTypes)), type) ? type : undefined;
    },
    getAttributes: function(options, raw) {
        options = $akRxj({
            session: false,
            props: false,
            derived: false
        }, options || {});
        var res = {};
        var val, def;
        for(var item in this._definition){
            def = this._definition[item];
            if (options.session && def.session || options.props && !def.session) {
                val = raw ? this._values[item] : this[item];
                if (raw && val && $62yEr(val.serialize)) val = val.serialize();
                if (typeof val === 'undefined') val = $a0MTb(def, 'default');
                if (typeof val !== 'undefined') res[item] = val;
            }
        }
        if (options.derived) for(var derivedItem in this._derived)res[derivedItem] = this[derivedItem];
        return res;
    },
    _initDerived: function() {
        var self = this;
        $eC9l3(this._derived, function(value, name) {
            var def = self._derived[name];
            def.deps = def.depList;
            var update = function() {
                var newVal = def.fn.call(self);
                if (self._cache[name] !== newVal || !def.cache) {
                    if (def.cache) self._previousAttributes[name] = self._cache[name];
                    self._cache[name] = newVal;
                    self.trigger('change:' + name, self, self._cache[name]);
                }
            };
            def.deps.forEach(function(propString) {
                self._keyTree.add(propString, update);
            });
        });
        this.on('all', function(eventName) {
            if ($eef98657c52313c1$var$changeRE.test(eventName)) self._keyTree.get(eventName.split(':')[1]).forEach(function(fn) {
                fn();
            });
        }, this);
    },
    _getDerivedProperty: function(name, flushCache) {
        // is this a derived property that is cached
        if (this._derived[name].cache) {
            //set if this is the first time, or flushCache is set
            if (flushCache || !this._cache.hasOwnProperty(name)) this._cache[name] = this._derived[name].fn.apply(this);
            return this._cache[name];
        } else return this._derived[name].fn.apply(this);
    },
    _initCollections: function() {
        var coll;
        if (!this._collections) return;
        for(coll in this._collections)this._safeSet(coll, new this._collections[coll](null, {
            parent: this
        }));
    },
    _initChildren: function() {
        var child;
        if (!this._children) return;
        for(child in this._children){
            this._safeSet(child, new this._children[child]({}, {
                parent: this
            }));
            this.listenTo(this[child], 'all', this._getCachedEventBubblingHandler(child));
        }
    },
    // Returns a bound handler for doing event bubbling while
    // adding a name to the change string.
    _getCachedEventBubblingHandler: function(propertyName) {
        if (!this._eventBubblingHandlerCache[propertyName]) this._eventBubblingHandlerCache[propertyName] = (function(name, model, newValue) {
            if ($eef98657c52313c1$var$changeRE.test(name)) this.trigger('change:' + propertyName + '.' + name.split(':')[1], model, newValue);
            else if (name === 'change') this.trigger('change', this);
        }).bind(this);
        return this._eventBubblingHandlerCache[propertyName];
    },
    // Check that all required attributes are present
    _verifyRequired: function() {
        var attrs = this.attributes; // should include session
        for(var def in this._definition){
            if (this._definition[def].required && typeof attrs[def] === 'undefined') return false;
        }
        return true;
    },
    // expose safeSet method
    _safeSet: function safeSet(property, value) {
        if (property in this) throw new Error('Encountered namespace collision while setting instance property `' + property + '`');
        this[property] = value;
        return this;
    }
});
// getter for attributes
Object.defineProperties($eef98657c52313c1$var$Base.prototype, {
    attributes: {
        get: function() {
            return this.getAttributes({
                props: true,
                session: true
            });
        }
    },
    all: {
        get: function() {
            return this.getAttributes({
                session: true,
                props: true,
                derived: true
            });
        }
    },
    isState: {
        get: function() {
            return true;
        },
        set: function() {}
    }
});
// helper for creating/storing property definitions and creating
// appropriate getters/setters
function $eef98657c52313c1$var$createPropertyDefinition(object, name, desc, isSession) {
    var def = object._definition[name] = {};
    var type, descArray;
    if ($fyYMa(desc)) {
        // grab our type if all we've got is a string
        type = object._ensureValidType(desc);
        if (type) def.type = type;
    } else {
        //Transform array of ['type', required, default] to object form
        if (Array.isArray(desc)) {
            descArray = desc;
            desc = {
                type: descArray[0],
                required: descArray[1],
                'default': descArray[2]
            };
        }
        type = object._ensureValidType(desc.type);
        if (type) def.type = type;
        if (desc.required) def.required = true;
        if (desc['default'] && typeof desc['default'] === 'object') throw new TypeError('The default value for ' + name + ' cannot be an object/array, must be a value or a function which returns a value/object/array');
        def['default'] = desc['default'];
        def.allowNull = desc.allowNull ? desc.allowNull : false;
        if (desc.setOnce) def.setOnce = true;
        if (def.required && def['default'] === undefined && !def.setOnce) def['default'] = object._getDefaultForType(type);
        def.test = desc.test;
        def.values = desc.values;
    }
    if (isSession) def.session = true;
    if (!type) {
        type = $fyYMa(desc) ? desc : desc.type;
        // TODO: start throwing a TypeError in future major versions instead of warning
        console.warn('Invalid data type of `' + type + '` for `' + name + '` property. Use one of the default types or define your own');
    }
    // define a getter/setter on the prototype
    // but they get/set on the instance
    Object.defineProperty(object, name, {
        set: function(val) {
            this.set(name, val);
        },
        get: function() {
            if (!this._values) throw Error('You may be trying to `extend` a state object with "' + name + '" which has been defined in `props` on the object being extended');
            var value = this._values[name];
            var typeDef = this._dataTypes[def.type];
            if (typeof value !== 'undefined') {
                if (typeDef && typeDef.get) value = typeDef.get(value);
                return value;
            }
            var defaultValue = $a0MTb(def, 'default');
            this._values[name] = defaultValue;
            // If we've set a defaultValue, fire a change handler effectively marking
            // its change from undefined to the default value.
            if (typeof defaultValue !== 'undefined') {
                var onChange = this._getOnChangeForType(def.type);
                onChange(defaultValue, value, name);
            }
            return defaultValue;
        }
    });
    return def;
}
// helper for creating derived property definitions
function $eef98657c52313c1$var$createDerivedProperty(modelProto, name, definition) {
    var def = modelProto._derived[name] = {
        fn: $62yEr(definition) ? definition : definition.fn,
        cache: definition.cache !== false,
        depList: definition.deps || []
    };
    // add to our shared dependency list
    def.depList.forEach(function(dep) {
        modelProto._deps[dep] = $9YydO(modelProto._deps[dep] || [], [
            name
        ]);
    });
    // defined a top-level getter for derived names
    Object.defineProperty(modelProto, name, {
        get: function() {
            return this._getDerivedProperty(name);
        },
        set: function() {
            throw new TypeError("`" + name + "` is a derived property, it can't be set directly.");
        }
    });
}
var $eef98657c52313c1$var$dataTypes = {
    string: {
        'default': function() {
            return '';
        }
    },
    date: {
        set: function(newVal) {
            var newType;
            if (newVal == null) newType = "object";
            else if (!$cfVrj(newVal)) {
                var err = null;
                var dateVal = new Date(newVal).valueOf();
                if (isNaN(dateVal)) {
                    // If the newVal cant be parsed, then try parseInt first
                    dateVal = new Date(parseInt(newVal, 10)).valueOf();
                    if (isNaN(dateVal)) err = true;
                }
                newVal = dateVal;
                newType = 'date';
                if (err) newType = typeof newVal;
            } else {
                newType = 'date';
                newVal = newVal.valueOf();
            }
            return {
                val: newVal,
                type: newType
            };
        },
        get: function(val) {
            if (val == null) return val;
            return new Date(val);
        },
        'default': function() {
            return new Date();
        }
    },
    array: {
        set: function(newVal) {
            return {
                val: newVal,
                type: Array.isArray(newVal) ? 'array' : typeof newVal
            };
        },
        'default': function() {
            return [];
        }
    },
    object: {
        set: function(newVal) {
            var newType = typeof newVal;
            // we have to have a way of supporting "missing" objects.
            // Null is an object, but setting a value to undefined
            // should work too, IMO. We just override it, in that case.
            if (newType !== 'object' && newVal === undefined) {
                newVal = null;
                newType = 'object';
            }
            return {
                val: newVal,
                type: newType
            };
        },
        'default': function() {
            return {};
        }
    },
    // the `state` data type is a bit special in that setting it should
    // also bubble events
    state: {
        set: function(newVal) {
            var isInstance = newVal instanceof $eef98657c52313c1$var$Base || newVal && newVal.isState;
            if (isInstance) return {
                val: newVal,
                type: 'state'
            };
            else return {
                val: newVal,
                type: typeof newVal
            };
        },
        compare: function(currentVal, newVal) {
            return currentVal === newVal;
        },
        onChange: function(newVal, previousVal, attributeName) {
            // if this has changed we want to also handle
            // event propagation
            if (previousVal) this.stopListening(previousVal, 'all', this._getCachedEventBubblingHandler(attributeName));
            if (newVal != null) this.listenTo(newVal, 'all', this._getCachedEventBubblingHandler(attributeName));
        }
    }
};
// the extend method used to extend prototypes, maintain inheritance chains for instanceof
// and allow for additions to the model definitions.
function $eef98657c52313c1$var$extend(protoProps) {
    /*jshint validthis:true*/ var parent = this;
    var child;
    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && protoProps.hasOwnProperty('constructor')) child = protoProps.constructor;
    else child = function() {
        return parent.apply(this, arguments);
    };
    // Add static properties to the constructor function from parent
    $akRxj(child, parent);
    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function() {
        this.constructor = child;
    };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate();
    // set prototype level objects
    child.prototype._derived = $akRxj({}, parent.prototype._derived);
    child.prototype._deps = $akRxj({}, parent.prototype._deps);
    child.prototype._definition = $akRxj({}, parent.prototype._definition);
    child.prototype._collections = $akRxj({}, parent.prototype._collections);
    child.prototype._children = $akRxj({}, parent.prototype._children);
    child.prototype._dataTypes = $akRxj({}, parent.prototype._dataTypes || $eef98657c52313c1$var$dataTypes);
    // Mix in all prototype properties to the subclass if supplied.
    if (protoProps) {
        var omitFromExtend = [
            'dataTypes',
            'props',
            'session',
            'derived',
            'collections',
            'children'
        ];
        for(var i = 0; i < arguments.length; i++){
            var def = arguments[i];
            if (def.dataTypes) $eC9l3(def.dataTypes, function(def, name) {
                child.prototype._dataTypes[name] = def;
            });
            if (def.props) $eC9l3(def.props, function(def, name) {
                $eef98657c52313c1$var$createPropertyDefinition(child.prototype, name, def);
            });
            if (def.session) $eC9l3(def.session, function(def, name) {
                $eef98657c52313c1$var$createPropertyDefinition(child.prototype, name, def, true);
            });
            if (def.derived) $eC9l3(def.derived, function(def, name) {
                $eef98657c52313c1$var$createDerivedProperty(child.prototype, name, def);
            });
            if (def.collections) $eC9l3(def.collections, function(constructor, name) {
                child.prototype._collections[name] = constructor;
            });
            if (def.children) $eC9l3(def.children, function(constructor, name) {
                child.prototype._children[name] = constructor;
            });
            $akRxj(child.prototype, $18d74(def, omitFromExtend));
        }
    }
    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;
    return child;
}
$eef98657c52313c1$var$Base.extend = $eef98657c52313c1$var$extend;
// Our main exports
module.exports = $eef98657c52313c1$var$Base;

});
parcelRegister("18d74", function(module, exports) {

var $aKSSk = parcelRequire("aKSSk");

var $3R1Uz = parcelRequire("3R1Uz");

var $4kNkS = parcelRequire("4kNkS");

var $2n45k = parcelRequire("2n45k");

var $94d3P = parcelRequire("94d3P");

var $lXALi = parcelRequire("lXALi");

var $4MPSK = parcelRequire("4MPSK");

var $gg8GB = parcelRequire("gg8GB");
/** Used to compose bitmasks for cloning. */ var $0d30b5c346d0d6f5$var$CLONE_DEEP_FLAG = 1, $0d30b5c346d0d6f5$var$CLONE_FLAT_FLAG = 2, $0d30b5c346d0d6f5$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $0d30b5c346d0d6f5$var$omit = $4MPSK(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $aKSSk(paths, function(path) {
        path = $2n45k(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $94d3P(object, $gg8GB(object), result);
    if (isDeep) result = $3R1Uz(result, $0d30b5c346d0d6f5$var$CLONE_DEEP_FLAG | $0d30b5c346d0d6f5$var$CLONE_FLAT_FLAG | $0d30b5c346d0d6f5$var$CLONE_SYMBOLS_FLAG, $lXALi);
    var length = paths.length;
    while(length--)$4kNkS(result, paths[length]);
    return result;
});
module.exports = $0d30b5c346d0d6f5$var$omit;

});
parcelRegister("3R1Uz", function(module, exports) {

var $2uwmO = parcelRequire("2uwmO");

var $fTNj0 = parcelRequire("fTNj0");

var $7nfqv = parcelRequire("7nfqv");

var $h4zVx = parcelRequire("h4zVx");

var $2kEOO = parcelRequire("2kEOO");

var $kAjQZ = parcelRequire("kAjQZ");

var $73mnJ = parcelRequire("73mnJ");

var $1KdVX = parcelRequire("1KdVX");

var $8fOs4 = parcelRequire("8fOs4");

var $bB4KE = parcelRequire("bB4KE");

var $gg8GB = parcelRequire("gg8GB");

var $d2ghx = parcelRequire("d2ghx");

var $gZG1p = parcelRequire("gZG1p");

var $lHpK5 = parcelRequire("lHpK5");

var $9St5H = parcelRequire("9St5H");

var $3vzLP = parcelRequire("3vzLP");

var $bX0UL = parcelRequire("bX0UL");

var $97iaj = parcelRequire("97iaj");

var $5DUFR = parcelRequire("5DUFR");

var $bl5l0 = parcelRequire("bl5l0");

var $6ZxOb = parcelRequire("6ZxOb");

var $lSgZA = parcelRequire("lSgZA");
/** Used to compose bitmasks for cloning. */ var $2ce7cdebdbaa6410$var$CLONE_DEEP_FLAG = 1, $2ce7cdebdbaa6410$var$CLONE_FLAT_FLAG = 2, $2ce7cdebdbaa6410$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $2ce7cdebdbaa6410$var$argsTag = '[object Arguments]', $2ce7cdebdbaa6410$var$arrayTag = '[object Array]', $2ce7cdebdbaa6410$var$boolTag = '[object Boolean]', $2ce7cdebdbaa6410$var$dateTag = '[object Date]', $2ce7cdebdbaa6410$var$errorTag = '[object Error]', $2ce7cdebdbaa6410$var$funcTag = '[object Function]', $2ce7cdebdbaa6410$var$genTag = '[object GeneratorFunction]', $2ce7cdebdbaa6410$var$mapTag = '[object Map]', $2ce7cdebdbaa6410$var$numberTag = '[object Number]', $2ce7cdebdbaa6410$var$objectTag = '[object Object]', $2ce7cdebdbaa6410$var$regexpTag = '[object RegExp]', $2ce7cdebdbaa6410$var$setTag = '[object Set]', $2ce7cdebdbaa6410$var$stringTag = '[object String]', $2ce7cdebdbaa6410$var$symbolTag = '[object Symbol]', $2ce7cdebdbaa6410$var$weakMapTag = '[object WeakMap]';
var $2ce7cdebdbaa6410$var$arrayBufferTag = '[object ArrayBuffer]', $2ce7cdebdbaa6410$var$dataViewTag = '[object DataView]', $2ce7cdebdbaa6410$var$float32Tag = '[object Float32Array]', $2ce7cdebdbaa6410$var$float64Tag = '[object Float64Array]', $2ce7cdebdbaa6410$var$int8Tag = '[object Int8Array]', $2ce7cdebdbaa6410$var$int16Tag = '[object Int16Array]', $2ce7cdebdbaa6410$var$int32Tag = '[object Int32Array]', $2ce7cdebdbaa6410$var$uint8Tag = '[object Uint8Array]', $2ce7cdebdbaa6410$var$uint8ClampedTag = '[object Uint8ClampedArray]', $2ce7cdebdbaa6410$var$uint16Tag = '[object Uint16Array]', $2ce7cdebdbaa6410$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $2ce7cdebdbaa6410$var$cloneableTags = {};
$2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$argsTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$arrayTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$arrayBufferTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$dataViewTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$boolTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$dateTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$float32Tag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$float64Tag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$int8Tag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$int16Tag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$int32Tag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$mapTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$numberTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$objectTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$regexpTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$setTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$stringTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$symbolTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$uint8Tag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$uint8ClampedTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$uint16Tag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$uint32Tag] = true;
$2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$errorTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$funcTag] = $2ce7cdebdbaa6410$var$cloneableTags[$2ce7cdebdbaa6410$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $2ce7cdebdbaa6410$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $2ce7cdebdbaa6410$var$CLONE_DEEP_FLAG, isFlat = bitmask & $2ce7cdebdbaa6410$var$CLONE_FLAT_FLAG, isFull = bitmask & $2ce7cdebdbaa6410$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$5DUFR(value)) return value;
    var isArr = $3vzLP(value);
    if (isArr) {
        result = $gZG1p(value);
        if (!isDeep) return $73mnJ(value, result);
    } else {
        var tag = $d2ghx(value), isFunc = tag == $2ce7cdebdbaa6410$var$funcTag || tag == $2ce7cdebdbaa6410$var$genTag;
        if ($bX0UL(value)) return $kAjQZ(value, isDeep);
        if (tag == $2ce7cdebdbaa6410$var$objectTag || tag == $2ce7cdebdbaa6410$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $9St5H(value);
            if (!isDeep) return isFlat ? $8fOs4(value, $2kEOO(result, value)) : $1KdVX(value, $h4zVx(result, value));
        } else {
            if (!$2ce7cdebdbaa6410$var$cloneableTags[tag]) return object ? value : {};
            result = $lHpK5(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $2uwmO);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($bl5l0(value)) value.forEach(function(subValue) {
        result.add($2ce7cdebdbaa6410$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($97iaj(value)) value.forEach(function(subValue, key) {
        result.set(key, $2ce7cdebdbaa6410$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $gg8GB : $bB4KE : isFlat ? $lSgZA : $6ZxOb;
    var props = isArr ? undefined : keysFunc(value);
    $fTNj0(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $7nfqv(result, key, $2ce7cdebdbaa6410$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $2ce7cdebdbaa6410$var$baseClone;

});
parcelRegister("h4zVx", function(module, exports) {

var $94d3P = parcelRequire("94d3P");

var $6ZxOb = parcelRequire("6ZxOb");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $033523d5c0a09f3a$var$baseAssign(object, source) {
    return object && $94d3P(source, $6ZxOb(source), object);
}
module.exports = $033523d5c0a09f3a$var$baseAssign;

});

parcelRegister("2kEOO", function(module, exports) {

var $94d3P = parcelRequire("94d3P");

var $lSgZA = parcelRequire("lSgZA");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $1b2d1cbf363c7d33$var$baseAssignIn(object, source) {
    return object && $94d3P(source, $lSgZA(source), object);
}
module.exports = $1b2d1cbf363c7d33$var$baseAssignIn;

});

parcelRegister("1KdVX", function(module, exports) {

var $94d3P = parcelRequire("94d3P");

var $5laD4 = parcelRequire("5laD4");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $1454e54eb6ac42cc$var$copySymbols(source, object) {
    return $94d3P(source, $5laD4(source), object);
}
module.exports = $1454e54eb6ac42cc$var$copySymbols;

});

parcelRegister("8fOs4", function(module, exports) {

var $94d3P = parcelRequire("94d3P");

var $5TxlI = parcelRequire("5TxlI");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $6026dc1daaab353b$var$copySymbolsIn(source, object) {
    return $94d3P(source, $5TxlI(source), object);
}
module.exports = $6026dc1daaab353b$var$copySymbolsIn;

});
parcelRegister("5TxlI", function(module, exports) {

var $l3S2a = parcelRequire("l3S2a");

var $fPCIZ = parcelRequire("fPCIZ");

var $5laD4 = parcelRequire("5laD4");

var $92CqY = parcelRequire("92CqY");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $44abf545a2b33e65$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $44abf545a2b33e65$var$getSymbolsIn = !$44abf545a2b33e65$var$nativeGetSymbols ? $92CqY : function(object) {
    var result = [];
    while(object){
        $l3S2a(result, $5laD4(object));
        object = $fPCIZ(object);
    }
    return result;
};
module.exports = $44abf545a2b33e65$var$getSymbolsIn;

});
parcelRegister("fPCIZ", function(module, exports) {

var $57pzX = parcelRequire("57pzX");
/** Built-in value references. */ var $b869a858b1a53be3$var$getPrototype = $57pzX(Object.getPrototypeOf, Object);
module.exports = $b869a858b1a53be3$var$getPrototype;

});



parcelRegister("gg8GB", function(module, exports) {

var $67Ves = parcelRequire("67Ves");

var $5TxlI = parcelRequire("5TxlI");

var $lSgZA = parcelRequire("lSgZA");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $bd64e0de083f5ced$var$getAllKeysIn(object) {
    return $67Ves(object, $lSgZA, $5TxlI);
}
module.exports = $bd64e0de083f5ced$var$getAllKeysIn;

});

parcelRegister("gZG1p", function(module, exports) {
/** Used for built-in method references. */ var $c5f2f082f3b37c71$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c5f2f082f3b37c71$var$hasOwnProperty = $c5f2f082f3b37c71$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $c5f2f082f3b37c71$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $c5f2f082f3b37c71$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $c5f2f082f3b37c71$var$initCloneArray;

});

parcelRegister("lHpK5", function(module, exports) {

var $ajFBL = parcelRequire("ajFBL");

var $gm3zc = parcelRequire("gm3zc");

var $28vR2 = parcelRequire("28vR2");

var $dFNd7 = parcelRequire("dFNd7");

var $9vbZv = parcelRequire("9vbZv");
/** `Object#toString` result references. */ var $fcc195010ef59e47$var$boolTag = '[object Boolean]', $fcc195010ef59e47$var$dateTag = '[object Date]', $fcc195010ef59e47$var$mapTag = '[object Map]', $fcc195010ef59e47$var$numberTag = '[object Number]', $fcc195010ef59e47$var$regexpTag = '[object RegExp]', $fcc195010ef59e47$var$setTag = '[object Set]', $fcc195010ef59e47$var$stringTag = '[object String]', $fcc195010ef59e47$var$symbolTag = '[object Symbol]';
var $fcc195010ef59e47$var$arrayBufferTag = '[object ArrayBuffer]', $fcc195010ef59e47$var$dataViewTag = '[object DataView]', $fcc195010ef59e47$var$float32Tag = '[object Float32Array]', $fcc195010ef59e47$var$float64Tag = '[object Float64Array]', $fcc195010ef59e47$var$int8Tag = '[object Int8Array]', $fcc195010ef59e47$var$int16Tag = '[object Int16Array]', $fcc195010ef59e47$var$int32Tag = '[object Int32Array]', $fcc195010ef59e47$var$uint8Tag = '[object Uint8Array]', $fcc195010ef59e47$var$uint8ClampedTag = '[object Uint8ClampedArray]', $fcc195010ef59e47$var$uint16Tag = '[object Uint16Array]', $fcc195010ef59e47$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $fcc195010ef59e47$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $fcc195010ef59e47$var$arrayBufferTag:
            return $ajFBL(object);
        case $fcc195010ef59e47$var$boolTag:
        case $fcc195010ef59e47$var$dateTag:
            return new Ctor(+object);
        case $fcc195010ef59e47$var$dataViewTag:
            return $gm3zc(object, isDeep);
        case $fcc195010ef59e47$var$float32Tag:
        case $fcc195010ef59e47$var$float64Tag:
        case $fcc195010ef59e47$var$int8Tag:
        case $fcc195010ef59e47$var$int16Tag:
        case $fcc195010ef59e47$var$int32Tag:
        case $fcc195010ef59e47$var$uint8Tag:
        case $fcc195010ef59e47$var$uint8ClampedTag:
        case $fcc195010ef59e47$var$uint16Tag:
        case $fcc195010ef59e47$var$uint32Tag:
            return $9vbZv(object, isDeep);
        case $fcc195010ef59e47$var$mapTag:
            return new Ctor;
        case $fcc195010ef59e47$var$numberTag:
        case $fcc195010ef59e47$var$stringTag:
            return new Ctor(object);
        case $fcc195010ef59e47$var$regexpTag:
            return $28vR2(object);
        case $fcc195010ef59e47$var$setTag:
            return new Ctor;
        case $fcc195010ef59e47$var$symbolTag:
            return $dFNd7(object);
    }
}
module.exports = $fcc195010ef59e47$var$initCloneByTag;

});
parcelRegister("ajFBL", function(module, exports) {

var $96NMI = parcelRequire("96NMI");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $782bf43c07773849$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $96NMI(result).set(new $96NMI(arrayBuffer));
    return result;
}
module.exports = $782bf43c07773849$var$cloneArrayBuffer;

});

parcelRegister("gm3zc", function(module, exports) {

var $ajFBL = parcelRequire("ajFBL");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $be8177ae7ba3da40$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $ajFBL(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $be8177ae7ba3da40$var$cloneDataView;

});

parcelRegister("28vR2", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $18e509bcabccc5d4$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $18e509bcabccc5d4$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $18e509bcabccc5d4$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $18e509bcabccc5d4$var$cloneRegExp;

});

parcelRegister("dFNd7", function(module, exports) {

var $7xLVY = parcelRequire("7xLVY");
/** Used to convert symbols to primitives and strings. */ var $9f4546e1690c0a6a$var$symbolProto = $7xLVY ? $7xLVY.prototype : undefined, $9f4546e1690c0a6a$var$symbolValueOf = $9f4546e1690c0a6a$var$symbolProto ? $9f4546e1690c0a6a$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $9f4546e1690c0a6a$var$cloneSymbol(symbol) {
    return $9f4546e1690c0a6a$var$symbolValueOf ? Object($9f4546e1690c0a6a$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $9f4546e1690c0a6a$var$cloneSymbol;

});

parcelRegister("9vbZv", function(module, exports) {

var $ajFBL = parcelRequire("ajFBL");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $6eb04f738939d003$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $ajFBL(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $6eb04f738939d003$var$cloneTypedArray;

});


parcelRegister("9St5H", function(module, exports) {

var $3F6V9 = parcelRequire("3F6V9");

var $fPCIZ = parcelRequire("fPCIZ");

var $5DSff = parcelRequire("5DSff");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $730fb910e30b6b83$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$5DSff(object) ? $3F6V9($fPCIZ(object)) : {};
}
module.exports = $730fb910e30b6b83$var$initCloneObject;

});

parcelRegister("97iaj", function(module, exports) {

var $hiLqV = parcelRequire("hiLqV");

var $iqpCQ = parcelRequire("iqpCQ");

var $ddmWT = parcelRequire("ddmWT");
/* Node.js helper references. */ var $6a32dbc8b5627ab3$var$nodeIsMap = $ddmWT && $ddmWT.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $6a32dbc8b5627ab3$var$isMap = $6a32dbc8b5627ab3$var$nodeIsMap ? $iqpCQ($6a32dbc8b5627ab3$var$nodeIsMap) : $hiLqV;
module.exports = $6a32dbc8b5627ab3$var$isMap;

});
parcelRegister("hiLqV", function(module, exports) {

var $d2ghx = parcelRequire("d2ghx");

var $lIKbn = parcelRequire("lIKbn");
/** `Object#toString` result references. */ var $c988e9621be40245$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $c988e9621be40245$var$baseIsMap(value) {
    return $lIKbn(value) && $d2ghx(value) == $c988e9621be40245$var$mapTag;
}
module.exports = $c988e9621be40245$var$baseIsMap;

});


parcelRegister("bl5l0", function(module, exports) {

var $8Rmap = parcelRequire("8Rmap");

var $iqpCQ = parcelRequire("iqpCQ");

var $ddmWT = parcelRequire("ddmWT");
/* Node.js helper references. */ var $8415cbd4230bdd74$var$nodeIsSet = $ddmWT && $ddmWT.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $8415cbd4230bdd74$var$isSet = $8415cbd4230bdd74$var$nodeIsSet ? $iqpCQ($8415cbd4230bdd74$var$nodeIsSet) : $8Rmap;
module.exports = $8415cbd4230bdd74$var$isSet;

});
parcelRegister("8Rmap", function(module, exports) {

var $d2ghx = parcelRequire("d2ghx");

var $lIKbn = parcelRequire("lIKbn");
/** `Object#toString` result references. */ var $673477d3b3fa849c$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $673477d3b3fa849c$var$baseIsSet(value) {
    return $lIKbn(value) && $d2ghx(value) == $673477d3b3fa849c$var$setTag;
}
module.exports = $673477d3b3fa849c$var$baseIsSet;

});



parcelRegister("4kNkS", function(module, exports) {

var $2n45k = parcelRequire("2n45k");

var $aMHB4 = parcelRequire("aMHB4");

var $6purz = parcelRequire("6purz");

var $gYGgF = parcelRequire("gYGgF");
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $327f4cb9ad88a08a$var$baseUnset(object, path) {
    path = $2n45k(path, object);
    object = $6purz(object, path);
    return object == null || delete object[$gYGgF($aMHB4(path))];
}
module.exports = $327f4cb9ad88a08a$var$baseUnset;

});

parcelRegister("lXALi", function(module, exports) {

var $7qtfk = parcelRequire("7qtfk");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $ffcb9fd2ec2cea8d$var$customOmitClone(value) {
    return $7qtfk(value) ? undefined : value;
}
module.exports = $ffcb9fd2ec2cea8d$var$customOmitClone;

});
parcelRegister("7qtfk", function(module, exports) {

var $39TZG = parcelRequire("39TZG");

var $fPCIZ = parcelRequire("fPCIZ");

var $lIKbn = parcelRequire("lIKbn");
/** `Object#toString` result references. */ var $5681a5d16b29cc20$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $5681a5d16b29cc20$var$funcProto = Function.prototype, $5681a5d16b29cc20$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $5681a5d16b29cc20$var$funcToString = $5681a5d16b29cc20$var$funcProto.toString;
/** Used to check objects for own properties. */ var $5681a5d16b29cc20$var$hasOwnProperty = $5681a5d16b29cc20$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $5681a5d16b29cc20$var$objectCtorString = $5681a5d16b29cc20$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $5681a5d16b29cc20$var$isPlainObject(value) {
    if (!$lIKbn(value) || $39TZG(value) != $5681a5d16b29cc20$var$objectTag) return false;
    var proto = $fPCIZ(value);
    if (proto === null) return true;
    var Ctor = $5681a5d16b29cc20$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $5681a5d16b29cc20$var$funcToString.call(Ctor) == $5681a5d16b29cc20$var$objectCtorString;
}
module.exports = $5681a5d16b29cc20$var$isPlainObject;

});


parcelRegister("4MPSK", function(module, exports) {

var $lHBuJ = parcelRequire("lHBuJ");

var $3qQSV = parcelRequire("3qQSV");

var $eHZN2 = parcelRequire("eHZN2");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $37c3e3d33ad76761$var$flatRest(func) {
    return $eHZN2($3qQSV(func, undefined, $lHBuJ), func + '');
}
module.exports = $37c3e3d33ad76761$var$flatRest;

});
parcelRegister("lHBuJ", function(module, exports) {

var $IWrCz = parcelRequire("IWrCz");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fccab2c6a7c53c40$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $IWrCz(array, 1) : [];
}
module.exports = $fccab2c6a7c53c40$var$flatten;

});



parcelRegister("kxFut", function(module, exports) {

var $k9by1 = parcelRequire("k9by1");

var $gA8dA = parcelRequire("gA8dA");
/** Used to match HTML entities and HTML characters. */ var $ef4712da6ec5b88f$var$reUnescapedHtml = /[&<>"']/g, $ef4712da6ec5b88f$var$reHasUnescapedHtml = RegExp($ef4712da6ec5b88f$var$reUnescapedHtml.source);
/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */ function $ef4712da6ec5b88f$var$escape(string) {
    string = $gA8dA(string);
    return string && $ef4712da6ec5b88f$var$reHasUnescapedHtml.test(string) ? string.replace($ef4712da6ec5b88f$var$reUnescapedHtml, $k9by1) : string;
}
module.exports = $ef4712da6ec5b88f$var$escape;

});
parcelRegister("k9by1", function(module, exports) {

var $hPHcE = parcelRequire("hPHcE");
/** Used to map characters to HTML entities. */ var $eaad9b09d907af90$var$htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};
/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */ var $eaad9b09d907af90$var$escapeHtmlChar = $hPHcE($eaad9b09d907af90$var$htmlEscapes);
module.exports = $eaad9b09d907af90$var$escapeHtmlChar;

});
parcelRegister("hPHcE", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $cfb8b652452a4f2b$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $cfb8b652452a4f2b$var$basePropertyOf;

});



parcelRegister("eC9l3", function(module, exports) {

var $bmAbh = parcelRequire("bmAbh");

var $2GF6H = parcelRequire("2GF6H");
/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $aa3bdbb93779e731$var$forOwn(object, iteratee) {
    return object && $bmAbh(object, $2GF6H(iteratee));
}
module.exports = $aa3bdbb93779e731$var$forOwn;

});

parcelRegister("cfVrj", function(module, exports) {

var $lhZYW = parcelRequire("lhZYW");

var $iqpCQ = parcelRequire("iqpCQ");

var $ddmWT = parcelRequire("ddmWT");
/* Node.js helper references. */ var $8ec3711134658c9f$var$nodeIsDate = $ddmWT && $ddmWT.isDate;
/**
 * Checks if `value` is classified as a `Date` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 * @example
 *
 * _.isDate(new Date);
 * // => true
 *
 * _.isDate('Mon April 23 2012');
 * // => false
 */ var $8ec3711134658c9f$var$isDate = $8ec3711134658c9f$var$nodeIsDate ? $iqpCQ($8ec3711134658c9f$var$nodeIsDate) : $lhZYW;
module.exports = $8ec3711134658c9f$var$isDate;

});
parcelRegister("lhZYW", function(module, exports) {

var $39TZG = parcelRequire("39TZG");

var $lIKbn = parcelRequire("lIKbn");
/** `Object#toString` result references. */ var $f7fb43cff0bd2326$var$dateTag = '[object Date]';
/**
 * The base implementation of `_.isDate` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
 */ function $f7fb43cff0bd2326$var$baseIsDate(value) {
    return $lIKbn(value) && $39TZG(value) == $f7fb43cff0bd2326$var$dateTag;
}
module.exports = $f7fb43cff0bd2326$var$baseIsDate;

});


parcelRegister("8u49u", function(module, exports) {

var $9ysZi = parcelRequire("9ysZi");

var $kIHN7 = parcelRequire("kIHN7");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $62d4589719b30a85$var$has(object, path) {
    return object != null && $kIHN7(object, path, $9ysZi);
}
module.exports = $62d4589719b30a85$var$has;

});
parcelRegister("9ysZi", function(module, exports) {
/** Used for built-in method references. */ var $6f4dc65ec03ff3b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $6f4dc65ec03ff3b5$var$hasOwnProperty = $6f4dc65ec03ff3b5$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $6f4dc65ec03ff3b5$var$baseHas(object, key) {
    return object != null && $6f4dc65ec03ff3b5$var$hasOwnProperty.call(object, key);
}
module.exports = $6f4dc65ec03ff3b5$var$baseHas;

});


parcelRegister("9YydO", function(module, exports) {

var $IWrCz = parcelRequire("IWrCz");

var $3YGtA = parcelRequire("3YGtA");

var $5BQD7 = parcelRequire("5BQD7");

var $Gs9n2 = parcelRequire("Gs9n2");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $743443628262b952$var$union = $3YGtA(function(arrays) {
    return $5BQD7($IWrCz(arrays, 1, $Gs9n2, true));
});
module.exports = $743443628262b952$var$union;

});
parcelRegister("5BQD7", function(module, exports) {

var $guANY = parcelRequire("guANY");

var $f9USe = parcelRequire("f9USe");

var $jzvSQ = parcelRequire("jzvSQ");

var $fSRGV = parcelRequire("fSRGV");

var $4yq9Y = parcelRequire("4yq9Y");

var $kk6VW = parcelRequire("kk6VW");
/** Used as the size to enable large array optimizations. */ var $41593ba42b786c8a$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $41593ba42b786c8a$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $f9USe, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $jzvSQ;
    } else if (length >= $41593ba42b786c8a$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4yq9Y(array);
        if (set) return $kk6VW(set);
        isCommon = false;
        includes = $fSRGV;
        seen = new $guANY;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $41593ba42b786c8a$var$baseUniq;

});
parcelRegister("4yq9Y", function(module, exports) {

var $5U06H = parcelRequire("5U06H");

var $8b7KM = parcelRequire("8b7KM");

var $kk6VW = parcelRequire("kk6VW");
/** Used as references for various `Number` constants. */ var $350ea13720f9f927$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $350ea13720f9f927$var$createSet = !($5U06H && 1 / $kk6VW(new $5U06H([
    ,
    -0
]))[1] == $350ea13720f9f927$var$INFINITY) ? $8b7KM : function(values) {
    return new $5U06H(values);
};
module.exports = $350ea13720f9f927$var$createSet;

});



parcelRegister("ks7UM", function(module, exports) {
var $ee3c8fe83f91b329$var$slice = Array.prototype.slice;
// our constructor
function $ee3c8fe83f91b329$var$KeyTreeStore(options) {
    options = options || {};
    if (typeof options !== 'object') throw new TypeError('Options must be an object');
    var DEFAULT_SEPARATOR = '.';
    this.storage = {};
    this.separator = options.separator || DEFAULT_SEPARATOR;
}
// add an object to the store
$ee3c8fe83f91b329$var$KeyTreeStore.prototype.add = function(keypath, obj) {
    var arr = this.storage[keypath] || (this.storage[keypath] = []);
    arr.push(obj);
};
// remove an object
$ee3c8fe83f91b329$var$KeyTreeStore.prototype.remove = function(obj) {
    var path, arr;
    for(path in this.storage){
        arr = this.storage[path];
        arr.some(function(item, index) {
            if (item === obj) {
                arr.splice(index, 1);
                return true;
            }
        });
    }
};
// get array of all all relevant functions, without keys
$ee3c8fe83f91b329$var$KeyTreeStore.prototype.get = function(keypath) {
    var res = [];
    var key;
    for(key in this.storage)if (!keypath || keypath === key || key.indexOf(keypath + this.separator) === 0) res = res.concat(this.storage[key]);
    return res;
};
// get all results that match keypath but still grouped by key
$ee3c8fe83f91b329$var$KeyTreeStore.prototype.getGrouped = function(keypath) {
    var res = {};
    var key;
    for(key in this.storage)if (!keypath || keypath === key || key.indexOf(keypath + this.separator) === 0) res[key] = $ee3c8fe83f91b329$var$slice.call(this.storage[key]);
    return res;
};
// get all results that match keypath but still grouped by key
$ee3c8fe83f91b329$var$KeyTreeStore.prototype.getAll = function(keypath) {
    var res = {};
    var key;
    for(key in this.storage)if (keypath === key || key.indexOf(keypath + this.separator) === 0) res[key] = $ee3c8fe83f91b329$var$slice.call(this.storage[key]);
    return res;
};
// run all matches with optional context
$ee3c8fe83f91b329$var$KeyTreeStore.prototype.run = function(keypath, context) {
    var args = $ee3c8fe83f91b329$var$slice.call(arguments, 2);
    this.get(keypath).forEach(function(fn) {
        fn.apply(context || this, args);
    });
};
module.exports = $ee3c8fe83f91b329$var$KeyTreeStore;

});

parcelRegister("eHeLE", function(module, exports) {
module.exports = function arrayNext(array, currentItem) {
    var len = array.length;
    var newIndex = array.indexOf(currentItem) + 1;
    if (newIndex > len - 1) newIndex = 0;
    return array[newIndex];
};

});




parcelRegister("6GIoh", function(module, exports) {

var $fMxCj = parcelRequire("fMxCj");

var $kn8rV = parcelRequire("kn8rV");
/** Used for built-in method references. */ var $4de9195b1b245a81$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4de9195b1b245a81$var$hasOwnProperty = $4de9195b1b245a81$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $4de9195b1b245a81$var$countBy = $kn8rV(function(result, value, key) {
    if ($4de9195b1b245a81$var$hasOwnProperty.call(result, key)) ++result[key];
    else $fMxCj(result, key, 1);
});
module.exports = $4de9195b1b245a81$var$countBy;

});
parcelRegister("kn8rV", function(module, exports) {

var $8kvCR = parcelRequire("8kvCR");

var $5VYta = parcelRequire("5VYta");

var $gy2mG = parcelRequire("gy2mG");

var $3vzLP = parcelRequire("3vzLP");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $ed4c828534c00a2b$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $3vzLP(collection) ? $8kvCR : $5VYta, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $gy2mG(iteratee, 2), accumulator);
    };
}
module.exports = $ed4c828534c00a2b$var$createAggregator;

});
parcelRegister("8kvCR", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $6108b9377201df11$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $6108b9377201df11$var$arrayAggregator;

});

parcelRegister("5VYta", function(module, exports) {

var $dGp9H = parcelRequire("dGp9H");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $45212e942158e660$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $dGp9H(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $45212e942158e660$var$baseAggregator;

});



parcelRegister("a5bpV", function(module, exports) {

var $3RqdV = parcelRequire("3RqdV");

var $480y0 = parcelRequire("480y0");
/**
 * Creates a slice of `array` with `n` elements dropped from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.drop([1, 2, 3]);
 * // => [2, 3]
 *
 * _.drop([1, 2, 3], 2);
 * // => [3]
 *
 * _.drop([1, 2, 3], 5);
 * // => []
 *
 * _.drop([1, 2, 3], 0);
 * // => [1, 2, 3]
 */ function $75733a335ec7400b$var$drop(array, n, guard) {
    var length = array == null ? 0 : array.length;
    if (!length) return [];
    n = guard || n === undefined ? 1 : $480y0(n);
    return $3RqdV(array, n < 0 ? 0 : n, length);
}
module.exports = $75733a335ec7400b$var$drop;

});

parcelRegister("4vJCv", function(module, exports) {

var $fSlXE = parcelRequire("fSlXE");

var $aQLJv = parcelRequire("aQLJv");

var $gy2mG = parcelRequire("gy2mG");

var $3vzLP = parcelRequire("3vzLP");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $348d71e36f000113$var$filter(collection, predicate) {
    var func = $3vzLP(collection) ? $fSlXE : $aQLJv;
    return func(collection, $gy2mG(predicate, 3));
}
module.exports = $348d71e36f000113$var$filter;

});
parcelRegister("aQLJv", function(module, exports) {

var $dGp9H = parcelRequire("dGp9H");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $7e63c97c6db38cbf$var$baseFilter(collection, predicate) {
    var result = [];
    $dGp9H(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $7e63c97c6db38cbf$var$baseFilter;

});


parcelRegister("56rtr", function(module, exports) {

var $fMxCj = parcelRequire("fMxCj");

var $kn8rV = parcelRequire("kn8rV");
/** Used for built-in method references. */ var $3b72d300db033c8a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3b72d300db033c8a$var$hasOwnProperty = $3b72d300db033c8a$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $3b72d300db033c8a$var$groupBy = $kn8rV(function(result, value, key) {
    if ($3b72d300db033c8a$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $fMxCj(result, key, [
        value
    ]);
});
module.exports = $3b72d300db033c8a$var$groupBy;

});

parcelRegister("9zKvP", function(module, exports) {

var $fMxCj = parcelRequire("fMxCj");

var $kn8rV = parcelRequire("kn8rV");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $6f8b7658e31eae2c$var$keyBy = $kn8rV(function(result, value, key) {
    $fMxCj(result, key, value);
});
module.exports = $6f8b7658e31eae2c$var$keyBy;

});

parcelRegister("fjlsM", function(module, exports) {

var $hnLMc = parcelRequire("hnLMc");

var $480y0 = parcelRequire("480y0");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b2594781ba7a288f$var$nativeMax = Math.max;
/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */ function $b2594781ba7a288f$var$indexOf(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $480y0(fromIndex);
    if (index < 0) index = $b2594781ba7a288f$var$nativeMax(length + index, 0);
    return $hnLMc(array, value, index);
}
module.exports = $b2594781ba7a288f$var$indexOf;

});

parcelRegister("ear1Q", function(module, exports) {

var $3RqdV = parcelRequire("3RqdV");
/**
 * Gets all but the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.initial([1, 2, 3]);
 * // => [1, 2]
 */ function $a506f733b9e83c86$var$initial(array) {
    var length = array == null ? 0 : array.length;
    return length ? $3RqdV(array, 0, -1) : [];
}
module.exports = $a506f733b9e83c86$var$initial;

});

parcelRegister("dO2Ta", function(module, exports) {

var $3RlGb = parcelRequire("3RlGb");

var $3YGtA = parcelRequire("3YGtA");
/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */ var $a0d22f850327e34c$var$invoke = $3YGtA($3RlGb);
module.exports = $a0d22f850327e34c$var$invoke;

});

parcelRegister("grLWU", function(module, exports) {

var $eFIJE = parcelRequire("eFIJE");

var $5rIDf = parcelRequire("5rIDf");

var $blSTX = parcelRequire("blSTX");

var $480y0 = parcelRequire("480y0");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bf945ca71d2bad61$var$nativeMax = Math.max, $bf945ca71d2bad61$var$nativeMin = Math.min;
/**
 * This method is like `_.indexOf` except that it iterates over elements of
 * `array` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.lastIndexOf([1, 2, 1, 2], 2);
 * // => 3
 *
 * // Search from the `fromIndex`.
 * _.lastIndexOf([1, 2, 1, 2], 2, 2);
 * // => 1
 */ function $bf945ca71d2bad61$var$lastIndexOf(array, value, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length;
    if (fromIndex !== undefined) {
        index = $480y0(fromIndex);
        index = index < 0 ? $bf945ca71d2bad61$var$nativeMax(length + index, 0) : $bf945ca71d2bad61$var$nativeMin(index, length - 1);
    }
    return value === value ? $blSTX(array, value, index) : $eFIJE(array, $5rIDf, index, true);
}
module.exports = $bf945ca71d2bad61$var$lastIndexOf;

});
parcelRegister("blSTX", function(module, exports) {
/**
 * A specialized version of `_.lastIndexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $843c3e2d43ace759$var$strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while(index--){
        if (array[index] === value) return index;
    }
    return index;
}
module.exports = $843c3e2d43ace759$var$strictLastIndexOf;

});


parcelRegister("9jQ0w", function(module, exports) {

var $aKSSk = parcelRequire("aKSSk");

var $gy2mG = parcelRequire("gy2mG");

var $jknZ1 = parcelRequire("jknZ1");

var $3vzLP = parcelRequire("3vzLP");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $6c8e3afcf25a207e$var$map(collection, iteratee) {
    var func = $3vzLP(collection) ? $aKSSk : $jknZ1;
    return func(collection, $gy2mG(iteratee, 3));
}
module.exports = $6c8e3afcf25a207e$var$map;

});

parcelRegister("4OlMC", function(module, exports) {

var $SiUqB = parcelRequire("SiUqB");

var $jbvmP = parcelRequire("jbvmP");

var $9qV0f = parcelRequire("9qV0f");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $380cbaa03c2098bc$var$max(array) {
    return array && array.length ? $SiUqB(array, $9qV0f, $jbvmP) : undefined;
}
module.exports = $380cbaa03c2098bc$var$max;

});
parcelRegister("SiUqB", function(module, exports) {

var $eHNuH = parcelRequire("eHNuH");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $0a33b6382f2cdfa9$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$eHNuH(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $0a33b6382f2cdfa9$var$baseExtremum;

});

parcelRegister("jbvmP", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $df7760434d226f7f$var$baseGt(value, other) {
    return value > other;
}
module.exports = $df7760434d226f7f$var$baseGt;

});


parcelRegister("cn6O8", function(module, exports) {

var $SiUqB = parcelRequire("SiUqB");

var $kNby1 = parcelRequire("kNby1");

var $9qV0f = parcelRequire("9qV0f");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $901ce9e484422b25$var$min(array) {
    return array && array.length ? $SiUqB(array, $9qV0f, $kNby1) : undefined;
}
module.exports = $901ce9e484422b25$var$min;

});
parcelRegister("kNby1", function(module, exports) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $f2315762eb6def71$var$baseLt(value, other) {
    return value < other;
}
module.exports = $f2315762eb6def71$var$baseLt;

});


parcelRegister("17Qfy", function(module, exports) {

var $kn8rV = parcelRequire("kn8rV");
/**
 * Creates an array of elements split into two groups, the first of which
 * contains elements `predicate` returns truthy for, the second of which
 * contains elements `predicate` returns falsey for. The predicate is
 * invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of grouped elements.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': false },
 *   { 'user': 'fred',    'age': 40, 'active': true },
 *   { 'user': 'pebbles', 'age': 1,  'active': false }
 * ];
 *
 * _.partition(users, function(o) { return o.active; });
 * // => objects for [['fred'], ['barney', 'pebbles']]
 *
 * // The `_.matches` iteratee shorthand.
 * _.partition(users, { 'age': 1, 'active': false });
 * // => objects for [['pebbles'], ['barney', 'fred']]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.partition(users, ['active', false]);
 * // => objects for [['barney', 'pebbles'], ['fred']]
 *
 * // The `_.property` iteratee shorthand.
 * _.partition(users, 'active');
 * // => objects for [['fred'], ['barney', 'pebbles']]
 */ var $0d1ef99ec4973716$var$partition = $kn8rV(function(result, value, key) {
    result[key ? 0 : 1].push(value);
}, function() {
    return [
        [],
        []
    ];
});
module.exports = $0d1ef99ec4973716$var$partition;

});

parcelRegister("7PNlz", function(module, exports) {

var $525B9 = parcelRequire("525B9");

var $gBMTB = parcelRequire("gBMTB");

var $gy2mG = parcelRequire("gy2mG");

var $gi5UF = parcelRequire("gi5UF");

var $3vzLP = parcelRequire("3vzLP");
/**
 * This method is like `_.reduce` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduce
 * @example
 *
 * var array = [[0, 1], [2, 3], [4, 5]];
 *
 * _.reduceRight(array, function(flattened, other) {
 *   return flattened.concat(other);
 * }, []);
 * // => [4, 5, 2, 3, 0, 1]
 */ function $5b439314428119e9$var$reduceRight(collection, iteratee, accumulator) {
    var func = $3vzLP(collection) ? $525B9 : $gi5UF, initAccum = arguments.length < 3;
    return func(collection, $gy2mG(iteratee, 4), accumulator, initAccum, $gBMTB);
}
module.exports = $5b439314428119e9$var$reduceRight;

});
parcelRegister("525B9", function(module, exports) {
/**
 * A specialized version of `_.reduceRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the last element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3aa17b53f4be330c$var$arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[--length];
    while(length--)accumulator = iteratee(accumulator, array[length], length, array);
    return accumulator;
}
module.exports = $3aa17b53f4be330c$var$arrayReduceRight;

});

parcelRegister("gBMTB", function(module, exports) {

var $fCXEk = parcelRequire("fCXEk");

var $1MaRC = parcelRequire("1MaRC");
/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $c17607bd8139c073$var$baseEachRight = $1MaRC($fCXEk, true);
module.exports = $c17607bd8139c073$var$baseEachRight;

});
parcelRegister("fCXEk", function(module, exports) {

var $gtD6F = parcelRequire("gtD6F");

var $6ZxOb = parcelRequire("6ZxOb");
/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b608acbf68f92640$var$baseForOwnRight(object, iteratee) {
    return object && $gtD6F(object, iteratee, $6ZxOb);
}
module.exports = $b608acbf68f92640$var$baseForOwnRight;

});
parcelRegister("gtD6F", function(module, exports) {

var $7I4uh = parcelRequire("7I4uh");
/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $bfedb083ddfbc870$var$baseForRight = $7I4uh(true);
module.exports = $bfedb083ddfbc870$var$baseForRight;

});




parcelRegister("aKx0i", function(module, exports) {

var $fSlXE = parcelRequire("fSlXE");

var $aQLJv = parcelRequire("aQLJv");

var $gy2mG = parcelRequire("gy2mG");

var $3vzLP = parcelRequire("3vzLP");

var $Zd1VM = parcelRequire("Zd1VM");
/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */ function $7d37cd1c590bbe9e$var$reject(collection, predicate) {
    var func = $3vzLP(collection) ? $fSlXE : $aQLJv;
    return func(collection, $Zd1VM($gy2mG(predicate, 3)));
}
module.exports = $7d37cd1c590bbe9e$var$reject;

});
parcelRegister("Zd1VM", function(module, exports) {
/** Error message constants. */ var $0b7fce2294838a58$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */ function $0b7fce2294838a58$var$negate(predicate) {
    if (typeof predicate != 'function') throw new TypeError($0b7fce2294838a58$var$FUNC_ERROR_TEXT);
    return function() {
        var args = arguments;
        switch(args.length){
            case 0:
                return !predicate.call(this);
            case 1:
                return !predicate.call(this, args[0]);
            case 2:
                return !predicate.call(this, args[0], args[1]);
            case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
    };
}
module.exports = $0b7fce2294838a58$var$negate;

});


parcelRegister("akA2O", function(module, exports) {

var $hL003 = parcelRequire("hL003");

var $1oQXO = parcelRequire("1oQXO");

var $3vzLP = parcelRequire("3vzLP");
/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */ function $7857bb52b148ba72$var$sample(collection) {
    var func = $3vzLP(collection) ? $hL003 : $1oQXO;
    return func(collection);
}
module.exports = $7857bb52b148ba72$var$sample;

});
parcelRegister("hL003", function(module, exports) {

var $fdp0J = parcelRequire("fdp0J");
/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */ function $ced6d36b8ac78cce$var$arraySample(array) {
    var length = array.length;
    return length ? array[$fdp0J(0, length - 1)] : undefined;
}
module.exports = $ced6d36b8ac78cce$var$arraySample;

});
parcelRegister("fdp0J", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b13b788f36d68a62$var$nativeFloor = Math.floor, $b13b788f36d68a62$var$nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function $b13b788f36d68a62$var$baseRandom(lower, upper) {
    return lower + $b13b788f36d68a62$var$nativeFloor($b13b788f36d68a62$var$nativeRandom() * (upper - lower + 1));
}
module.exports = $b13b788f36d68a62$var$baseRandom;

});


parcelRegister("1oQXO", function(module, exports) {

var $hL003 = parcelRequire("hL003");

var $1H6Hi = parcelRequire("1H6Hi");
/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */ function $10511dd5dfbe0419$var$baseSample(collection) {
    return $hL003($1H6Hi(collection));
}
module.exports = $10511dd5dfbe0419$var$baseSample;

});


parcelRegister("9mPJZ", function(module, exports) {

var $earID = parcelRequire("earID");

var $5hXmM = parcelRequire("5hXmM");

var $3vzLP = parcelRequire("3vzLP");
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function $6d1e4dc7b9331107$var$shuffle(collection) {
    var func = $3vzLP(collection) ? $earID : $5hXmM;
    return func(collection);
}
module.exports = $6d1e4dc7b9331107$var$shuffle;

});
parcelRegister("earID", function(module, exports) {

var $73mnJ = parcelRequire("73mnJ");

var $kg4ib = parcelRequire("kg4ib");
/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $a50780433c832f7b$var$arrayShuffle(array) {
    return $kg4ib($73mnJ(array));
}
module.exports = $a50780433c832f7b$var$arrayShuffle;

});
parcelRegister("kg4ib", function(module, exports) {

var $fdp0J = parcelRequire("fdp0J");
/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */ function $ebf8a1a458fa26dc$var$shuffleSelf(array, size) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size = size === undefined ? length : size;
    while(++index < size){
        var rand = $fdp0J(index, lastIndex), value = array[rand];
        array[rand] = array[index];
        array[index] = value;
    }
    array.length = size;
    return array;
}
module.exports = $ebf8a1a458fa26dc$var$shuffleSelf;

});


parcelRegister("5hXmM", function(module, exports) {

var $kg4ib = parcelRequire("kg4ib");

var $1H6Hi = parcelRequire("1H6Hi");
/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function $3d9c97365c9c51d7$var$baseShuffle(collection) {
    return $kg4ib($1H6Hi(collection));
}
module.exports = $3d9c97365c9c51d7$var$baseShuffle;

});


parcelRegister("hKnuB", function(module, exports) {

var $hrLV4 = parcelRequire("hrLV4");

var $gy2mG = parcelRequire("gy2mG");

var $ffBU9 = parcelRequire("ffBU9");

var $3vzLP = parcelRequire("3vzLP");

var $dpoHm = parcelRequire("dpoHm");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $ceb8f4af5d9c015f$var$some(collection, predicate, guard) {
    var func = $3vzLP(collection) ? $hrLV4 : $ffBU9;
    if (guard && $dpoHm(collection, predicate, guard)) predicate = undefined;
    return func(collection, $gy2mG(predicate, 3));
}
module.exports = $ceb8f4af5d9c015f$var$some;

});
parcelRegister("ffBU9", function(module, exports) {

var $dGp9H = parcelRequire("dGp9H");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $b1a5a8c87288903b$var$baseSome(collection, predicate) {
    var result;
    $dGp9H(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $b1a5a8c87288903b$var$baseSome;

});


parcelRegister("1OSIu", function(module, exports) {

var $3RqdV = parcelRequire("3RqdV");
/**
 * Gets all but the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.tail([1, 2, 3]);
 * // => [2, 3]
 */ function $1534e7813a1631a0$var$tail(array) {
    var length = array == null ? 0 : array.length;
    return length ? $3RqdV(array, 1, length) : [];
}
module.exports = $1534e7813a1631a0$var$tail;

});

parcelRegister("cC3BS", function(module, exports) {

var $3RqdV = parcelRequire("3RqdV");

var $480y0 = parcelRequire("480y0");
/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */ function $92ebd57d9fa303a1$var$take(array, n, guard) {
    if (!(array && array.length)) return [];
    n = guard || n === undefined ? 1 : $480y0(n);
    return $3RqdV(array, 0, n < 0 ? 0 : n);
}
module.exports = $92ebd57d9fa303a1$var$take;

});

parcelRegister("7VPYh", function(module, exports) {

var $4FnQc = parcelRequire("4FnQc");

var $3YGtA = parcelRequire("3YGtA");

var $Gs9n2 = parcelRequire("Gs9n2");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $5c662bb1d346b33f$var$without = $3YGtA(function(array, values) {
    return $Gs9n2(array) ? $4FnQc(array, values) : [];
});
module.exports = $5c662bb1d346b33f$var$without;

});

parcelRegister("86KIP", function(module, exports) {

var $lOdf9 = parcelRequire("lOdf9");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $5e73204637a3fe51$var$set(object, path, value) {
    return object == null ? object : $lOdf9(object, path, value);
}
module.exports = $5e73204637a3fe51$var$set;

});
parcelRegister("lOdf9", function(module, exports) {

var $7nfqv = parcelRequire("7nfqv");

var $2n45k = parcelRequire("2n45k");

var $c8QtW = parcelRequire("c8QtW");

var $5DUFR = parcelRequire("5DUFR");

var $gYGgF = parcelRequire("gYGgF");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $fe088a55676e2322$var$baseSet(object, path, value, customizer) {
    if (!$5DUFR(object)) return object;
    path = $2n45k(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $gYGgF(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $5DUFR(objValue) ? objValue : $c8QtW(path[index + 1]) ? [] : {};
        }
        $7nfqv(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $fe088a55676e2322$var$baseSet;

});


parcelRegister("9mgST", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d0344095ad26993$export$2e2bcd8739ae039; });
function $6d0344095ad26993$var$pug_escape(e) {
    var a = "" + e, t = $6d0344095ad26993$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $6d0344095ad26993$var$pug_match_html = /["&<>]/;
function $6d0344095ad26993$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(addon1) {
        pug_html = pug_html + "\u003Clabel\u003E\u003Cspan data-hook=\"label\"\u003E\u003C\u002Fspan\u003E\u003Cdiv class=\"input-addon\"\u003E\u003Cinput class=\"input-addon-field\" step=\"any\" min=\"0\"\u002F\u003E\u003Cspan class=\"input-addon-item\"\u003E" + $6d0344095ad26993$var$pug_escape(null == (pug_interp = addon1) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"message message-below\" data-hook=\"message-container\"\u003E\u003Cp data-hook=\"message-text\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Flabel\u003E";
    }).call(this, "addon" in locals_for_with ? locals_for_with.addon : typeof addon !== 'undefined' ? addon : undefined);
    return pug_html;
}
var $6d0344095ad26993$export$2e2bcd8739ae039 = $6d0344095ad26993$var$template;

});

parcelRegister("1LE1e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14993927e9329640$export$2e2bcd8739ae039; });
function $14993927e9329640$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $14993927e9329640$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $14993927e9329640$var$pug_escape(e) {
    var a = "" + e, t = $14993927e9329640$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $14993927e9329640$var$pug_match_html = /["&<>]/;
function $14993927e9329640$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(isFirstProduct1, model1) {
        pug_html = pug_html + "\u003Cform class=\"pure-form item-data-form\" data-hook=\"add-product-form\"\u003E\u003Cdiv class=\"arrow\"\u003E\u003C\u002Fdiv\u003E";
        if (isFirstProduct1) pug_html = pug_html + '<div class="pure-g"><div class="pure-u-1-8"></div><div class="pure-u-3-4"><h3>Willkommen zu deinem ersten Produkt.</h3><p>Hier kannst du dein erstes Produkt anlegen. Produkte k\xf6nnen sp\xe4ter durch Lieferungen zu Orten\nhinzugef\xfcgt werden oder in Transaktionen zwischen verschiedenen Orten hin- und herbewegt werden.</p><p>Keine Angst! Du kannst die Produktdaten jederzeit \xe4ndern, falls du etwas falsch eingegeben hast.</p><p class="append">Tipp: Dr\xfccke <code>ESC</code>, um diesen Dialog zu schlie\xdfen oder <code>ENTER</code>, um\ndas Produkt anzulegen. Mit <code>TAB</code> kannst du durch die Felder navigieren.\n</p></div></div>';
        pug_html = pug_html + "\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-3\"\u003E\u003Cfieldset\u003E\u003Clegend\u003EProduktdaten\u003C\u002Flegend\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-1\"\u003E\u003Cdiv data-hook=\"name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g packaging\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv data-hook=\"package-size\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv data-hook=\"volume-per-unit\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g package-format\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv data-hook=\"package-name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv data-hook=\"package-unit\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-3\"\u003E\u003Cfieldset\u003E\u003Clegend\u003EPreise\u003C\u002Flegend\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv data-hook=\"cost\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv data-hook=\"cost-unit\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv data-hook=\"price\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv data-hook=\"serving-size\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-3\"\u003E\u003Cfieldset\u003E\u003Clegend\u003Eoptional\u003C\u002Flegend\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv data-hook=\"weight-full\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv data-hook=\"weight-empty\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-1\"\u003E\u003Cdiv data-hook=\"can-spill\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-1\"\u003E\u003Cdiv data-hook=\"category-name\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-1\"\u003E\u003Cdiv data-hook=\"color\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-1\"\u003E\u003Cdiv class=\"btn-group buttons\"\u003E\u003Cbutton class=\"pure-button cancel\" type=\"reset\" title=\"Abbrechen (Esc)\" data-hook=\"cancel\"\u003E\u003Ci class=\"icon ion-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton" + (' class="button-success pure-button save" type="submit"' + $14993927e9329640$var$pug_attr("title", `${model1.editable ? 'Speichern' : "Hinzuf\xfcgen"} (Enter)`, true, false)) + "\u003E" + $14993927e9329640$var$pug_escape((pug_interp = model1.editable ? 'Speichern' : "Hinzuf\xfcgen", pug_interp)) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";
    }).call(this, "isFirstProduct" in locals_for_with ? locals_for_with.isFirstProduct : typeof isFirstProduct !== 'undefined' ? isFirstProduct : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $14993927e9329640$export$2e2bcd8739ae039 = $14993927e9329640$var$template;

});

parcelRegister("hi3Hz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c966fd2ca84e2d0f$export$2e2bcd8739ae039; });
function $c966fd2ca84e2d0f$var$pug_escape(e) {
    var a = "" + e, t = $c966fd2ca84e2d0f$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $c966fd2ca84e2d0f$var$pug_match_html = /["&<>]/;
function $c966fd2ca84e2d0f$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1, opts1) {
        pug_html = pug_html + "\u003Cdiv class=\"popover confirm-delete animated\"\u003E\u003Cdiv class=\"popover-arrow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"popover-content\"\u003E";
        if (opts1.text) pug_html = pug_html + "\u003Cdiv\u003E" + $c966fd2ca84e2d0f$var$pug_escape(null == (pug_interp = opts1.text) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
        else pug_html = pug_html + "\u003Cdiv\u003E" + $c966fd2ca84e2d0f$var$pug_escape(null == (pug_interp = opts1.name || model1.name) ? "" : pug_interp) + " wirklich l\xf6schen?</div>";
        pug_html = pug_html + "\u003Cdiv class=\"btn-group\"\u003E\u003Cbutton class=\"pure-button\" data-hook=\"cancel\"\u003EAbbrechen\u003C\u002Fbutton\u003E\u003Cbutton class=\"pure-button button-error\" data-hook=\"confirm-delete\"\u003E" + $c966fd2ca84e2d0f$var$pug_escape(null == (pug_interp = opts1.confirmButtonText || "L\xf6schen") ? "" : pug_interp) + "\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined, "opts" in locals_for_with ? locals_for_with.opts : typeof opts !== 'undefined' ? opts : undefined);
    return pug_html;
}
var $c966fd2ca84e2d0f$export$2e2bcd8739ae039 = $c966fd2ca84e2d0f$var$template;

});

parcelRegister("9iFzx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c560ad9aa355ca9$export$2e2bcd8739ae039; });
function $6c560ad9aa355ca9$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $6c560ad9aa355ca9$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $6c560ad9aa355ca9$var$pug_classes(s, r) {
    return Array.isArray(s) ? $6c560ad9aa355ca9$var$pug_classes_array(s, r) : s && "object" == typeof s ? $6c560ad9aa355ca9$var$pug_classes_object(s) : s || "";
}
function $6c560ad9aa355ca9$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $6c560ad9aa355ca9$var$pug_classes(r[g])) && (c && a[g] && (s = $6c560ad9aa355ca9$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $6c560ad9aa355ca9$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $6c560ad9aa355ca9$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $6c560ad9aa355ca9$var$pug_escape(e) {
    var a = "" + e, t = $6c560ad9aa355ca9$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $6c560ad9aa355ca9$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $6c560ad9aa355ca9$var$pug_match_html = /["&<>]/;
function $6c560ad9aa355ca9$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(classes1, icon1, name1, title1) {
        pug_html = pug_html + "\u003Cbutton" + ($6c560ad9aa355ca9$var$pug_attr("class", $6c560ad9aa355ca9$var$pug_classes([
            classes1,
            "btn-round",
            "pure-button"
        ], [
            true,
            false,
            false
        ]), false, false) + $6c560ad9aa355ca9$var$pug_attr("data-title", title1, true, false) + $6c560ad9aa355ca9$var$pug_attr("data-hook", name1, true, false)) + "\u003E\u003Ci" + $6c560ad9aa355ca9$var$pug_attr("class", $6c560ad9aa355ca9$var$pug_classes([
            icon1
        ], [
            true
        ]), false, false) + "\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E";
    }).call(this, "classes" in locals_for_with ? locals_for_with.classes : typeof classes !== 'undefined' ? classes : undefined, "icon" in locals_for_with ? locals_for_with.icon : typeof icon !== 'undefined' ? icon : undefined, "name" in locals_for_with ? locals_for_with.name : typeof name !== 'undefined' ? name : undefined, "title" in locals_for_with ? locals_for_with.title : typeof title !== 'undefined' ? title : undefined);
    return pug_html;
}
var $6c560ad9aa355ca9$export$2e2bcd8739ae039 = $6c560ad9aa355ca9$var$template;

});

parcelRegister("i2xev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d22231472a469cab$export$2e2bcd8739ae039; });
function $d22231472a469cab$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $d22231472a469cab$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $d22231472a469cab$var$pug_escape(e) {
    var a = "" + e, t = $d22231472a469cab$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $d22231472a469cab$var$pug_match_html = /["&<>]/;
function $d22231472a469cab$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        if (!model1.editable) pug_html = pug_html + "\u003Cdiv" + (" class=\"pure-g product-row\"" + $d22231472a469cab$var$pug_attr("data-id", model1.id, true, false) + " data-hook=\"subview\"") + "\u003E\u003C\u002Fdiv\u003E";
        else pug_html = pug_html + "\u003Cdiv class=\"pure-g product-row-edit\"\u003E\u003Cdiv class=\"pure-u-1\"\u003E\u003Cdiv class=\"cell\" data-hook=\"subview\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $d22231472a469cab$export$2e2bcd8739ae039 = $d22231472a469cab$var$template;

});

parcelRegister("bSNNN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a6b5e8a362ed603$export$2e2bcd8739ae039; });
function $8a6b5e8a362ed603$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $8a6b5e8a362ed603$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $8a6b5e8a362ed603$var$pug_classes(s, r) {
    return Array.isArray(s) ? $8a6b5e8a362ed603$var$pug_classes_array(s, r) : s && "object" == typeof s ? $8a6b5e8a362ed603$var$pug_classes_object(s) : s || "";
}
function $8a6b5e8a362ed603$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $8a6b5e8a362ed603$var$pug_classes(r[g])) && (c && a[g] && (s = $8a6b5e8a362ed603$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $8a6b5e8a362ed603$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $8a6b5e8a362ed603$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $8a6b5e8a362ed603$var$pug_escape(e) {
    var a = "" + e, t = $8a6b5e8a362ed603$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $8a6b5e8a362ed603$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $8a6b5e8a362ed603$var$pug_match_html = /["&<>]/;
function $8a6b5e8a362ed603$var$pug_style(r) {
    if (!r) return "";
    if ("object" == typeof r) {
        var t = "";
        for(var e in r)$8a6b5e8a362ed603$var$pug_has_own_property.call(r, e) && (t = t + e + ":" + r[e] + ";");
        return t;
    }
    return r + "";
}
function $8a6b5e8a362ed603$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(isAdmin1, model1) {
        pug_html = pug_html + "\u003Cdiv class=\"pure-u-1\"\u003E\u003Cdiv class=\"pure-u-1-24\"\u003E\u003Cdiv class=\"cell sort-position\"\u003E\u003Ci class=\"ion-drag\" data-hook=\"drag-handle\"\u003E\u003C\u002Fi\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-3-8\"\u003E\u003Cdiv class=\"cell item-name\"\u003E\u003Cspan" + (" class=\"product-color-dot\"" + $8a6b5e8a362ed603$var$pug_attr("style", $8a6b5e8a362ed603$var$pug_style(`background-color: ${model1.color}`), true, false)) + "\u003E\u003C\u002Fspan\u003E\u003Cspan\u003E" + $8a6b5e8a362ed603$var$pug_escape(null == (pug_interp = model1.name) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + $8a6b5e8a362ed603$var$pug_attr("class", $8a6b5e8a362ed603$var$pug_classes([
            isAdmin1 ? 'pure-u-1-6' : 'pure-u-1-3'
        ], [
            true
        ]), false, false) + "\u003E\u003Cdiv class=\"cell\"\u003E" + $8a6b5e8a362ed603$var$pug_escape(null == (pug_interp = model1.packageSize) ? "" : pug_interp) + " x " + $8a6b5e8a362ed603$var$pug_escape(null == (pug_interp = model1.volumePerUnit) ? "" : pug_interp) + "l\u003Cspan class=\"append\"\u003E";
        if (model1.weightFull) pug_html = pug_html + "\u003Cspan\u003Evoll " + $8a6b5e8a362ed603$var$pug_escape(null == (pug_interp = model1.weightFull) ? "" : pug_interp) + "g\u003C\u002Fspan\u003E";
        if (model1.weightFull && model1.weightEmpty) pug_html = pug_html + "\u003Cspan\u003E" + $8a6b5e8a362ed603$var$pug_escape((pug_interp = ', ', pug_interp)) + "\u003C\u002Fspan\u003E";
        if (model1.weightEmpty) pug_html = pug_html + "\u003Cspan\u003Eleer " + $8a6b5e8a362ed603$var$pug_escape(null == (pug_interp = model1.weightEmpty) ? "" : pug_interp) + "g\u003C\u002Fspan\u003E";
        pug_html = pug_html + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-8\"\u003E\u003Cdiv" + (" class=\"cell\"" + $8a6b5e8a362ed603$var$pug_attr("title", `${model1.costPerUnitLocalized} pro ${model1.unit}`, true, false)) + "\u003E" + $8a6b5e8a362ed603$var$pug_escape(null == (pug_interp = model1.costLocalized) ? "" : pug_interp) + "\u003Cspan class=\"append\"\u003Epro " + $8a6b5e8a362ed603$var$pug_escape(null == (pug_interp = model1.costUnitLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-8\"\u003E\u003Cdiv class=\"cell\"\u003E\u003Cspan" + $8a6b5e8a362ed603$var$pug_attr("title", `${model1.pricePerUnitLocalized} pro ${model1.unit}`, true, false) + "\u003E" + $8a6b5e8a362ed603$var$pug_escape(null == (pug_interp = model1.priceLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        if (model1.canSpill) pug_html = pug_html + '<i class="icon can-spill ion-ios-wineglass" data-title="Schankverlust m\xf6glich"></i>';
        pug_html = pug_html + "\u003Cspan class=\"append\"\u003Epro " + $8a6b5e8a362ed603$var$pug_escape(null == (pug_interp = model1.servingSizeLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
        if (isAdmin1) pug_html = pug_html + "\u003Cdiv class=\"pure-u-1-6\"\u003E\u003Cdiv class=\"cell action btn-group\"\u003E\u003Cbutton" + (" class=\"pure-button btn-round edit\"" + $8a6b5e8a362ed603$var$pug_attr("data-title", `${model1.name} bearbeiten...`, true, false) + " data-hook=\"edit\"") + "\u003E\u003Ci class=\"icon ion-edit\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cdiv data-hook=\"delete-button\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }).call(this, "isAdmin" in locals_for_with ? locals_for_with.isAdmin : typeof isAdmin !== 'undefined' ? isAdmin : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $8a6b5e8a362ed603$export$2e2bcd8739ae039 = $8a6b5e8a362ed603$var$template;

});

parcelRegister("kOMpA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f27e07b8d9b5cdbf$export$2e2bcd8739ae039; });
function $f27e07b8d9b5cdbf$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $f27e07b8d9b5cdbf$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $f27e07b8d9b5cdbf$var$pug_classes(s, r) {
    return Array.isArray(s) ? $f27e07b8d9b5cdbf$var$pug_classes_array(s, r) : s && "object" == typeof s ? $f27e07b8d9b5cdbf$var$pug_classes_object(s) : s || "";
}
function $f27e07b8d9b5cdbf$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $f27e07b8d9b5cdbf$var$pug_classes(r[g])) && (c && a[g] && (s = $f27e07b8d9b5cdbf$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $f27e07b8d9b5cdbf$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $f27e07b8d9b5cdbf$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $f27e07b8d9b5cdbf$var$pug_escape(e) {
    var a = "" + e, t = $f27e07b8d9b5cdbf$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $f27e07b8d9b5cdbf$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $f27e07b8d9b5cdbf$var$pug_match_html = /["&<>]/;
function $f27e07b8d9b5cdbf$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1, placeholder1) {
        pug_html = pug_html + "\u003Cform class=\"pure-form search-bar\" data-hook=\"search-form\"\u003E\u003Cdiv class=\"input-addon\"\u003E\u003Ci class=\"icon ion-ios-search-strong input-addon-item\"\u003E\u003C\u002Fi\u003E\u003Cinput" + (' class="search input-addon-field" type="text"' + $f27e07b8d9b5cdbf$var$pug_attr("placeholder", placeholder1 || "Produktname", true, false)) + "\u002F\u003E\u003Cdiv class=\"input-addon-item reset-search\" data-hook=\"reset-search\"\u003E\u003Ca" + ($f27e07b8d9b5cdbf$var$pug_attr("class", $f27e07b8d9b5cdbf$var$pug_classes([
            model1 && model1.q ? null : 'hidden'
        ], [
            true
        ]), false, false) + " href=\"#\" role=\"button\"") + "\u003E\u003Ci class=\"icon ion-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined, "placeholder" in locals_for_with ? locals_for_with.placeholder : typeof placeholder !== 'undefined' ? placeholder : undefined);
    return pug_html;
}
var $f27e07b8d9b5cdbf$export$2e2bcd8739ae039 = $f27e07b8d9b5cdbf$var$template;

});

parcelRegister("8jWPf", function(module, exports) {

$parcel$export(module.exports, "jsx", function () { return $60edba9dc6727f1b$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "jsxs", function () { return $60edba9dc6727f1b$export$34b9dba7ce09269b; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("bRFDG")).Fragment; });

var $bRFDG = parcelRequire("bRFDG");
var $60edba9dc6727f1b$var$t = /["&<]/;
function $60edba9dc6727f1b$var$n(r) {
    if (0 === r.length || !1 === $60edba9dc6727f1b$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $60edba9dc6727f1b$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $60edba9dc6727f1b$var$f = 0, $60edba9dc6727f1b$var$i = Array.isArray;
function $60edba9dc6727f1b$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$60edba9dc6727f1b$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $bRFDG.options).vnode && (0, $bRFDG.options).vnode(l), l;
}
function $60edba9dc6727f1b$export$45700d561b2268ac(r) {
    var t = $60edba9dc6727f1b$export$34b9dba7ce09269b((0, $bRFDG.Fragment), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $60edba9dc6727f1b$var$c = {}, $60edba9dc6727f1b$var$p = /[A-Z]/g;
function $60edba9dc6727f1b$export$991f6ffe102e5bac(e, t) {
    if ((0, $bRFDG.options).attr) {
        var f = (0, $bRFDG.options).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if ("ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $60edba9dc6727f1b$var$c[u] || ($60edba9dc6727f1b$var$c[u] = u.replace($60edba9dc6727f1b$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $60edba9dc6727f1b$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + i + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $60edba9dc6727f1b$var$n(t) + '"';
}
function $60edba9dc6727f1b$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($60edba9dc6727f1b$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $60edba9dc6727f1b$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $60edba9dc6727f1b$var$n("" + r);
}

});
parcelRegister("bRFDG", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $8a34f196b0092c90$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "createElement", function () { return $8a34f196b0092c90$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $8a34f196b0092c90$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $8a34f196b0092c90$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $8a34f196b0092c90$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $8a34f196b0092c90$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $8a34f196b0092c90$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $8a34f196b0092c90$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $8a34f196b0092c90$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $8a34f196b0092c90$export$fd42f52fd3ae1109; });
var $8a34f196b0092c90$var$n, $8a34f196b0092c90$export$41c562ebe57d11e2, $8a34f196b0092c90$var$u, $8a34f196b0092c90$export$a8257692ac88316c, $8a34f196b0092c90$var$i, $8a34f196b0092c90$var$r, $8a34f196b0092c90$var$o, $8a34f196b0092c90$var$e, $8a34f196b0092c90$var$f, $8a34f196b0092c90$var$c, $8a34f196b0092c90$var$s, $8a34f196b0092c90$var$a, $8a34f196b0092c90$var$h, $8a34f196b0092c90$var$p = {}, $8a34f196b0092c90$var$y = [], $8a34f196b0092c90$var$v = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $8a34f196b0092c90$var$w = Array.isArray;
function $8a34f196b0092c90$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $8a34f196b0092c90$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $8a34f196b0092c90$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $8a34f196b0092c90$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)null == e[o] && (e[o] = l.defaultProps[o]);
    return $8a34f196b0092c90$var$m(l, e, i, r, null);
}
function $8a34f196b0092c90$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$8a34f196b0092c90$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $8a34f196b0092c90$export$41c562ebe57d11e2.vnode && $8a34f196b0092c90$export$41c562ebe57d11e2.vnode(e), e;
}
function $8a34f196b0092c90$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $8a34f196b0092c90$export$ffb0004e005737fa(n) {
    return n.children;
}
function $8a34f196b0092c90$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $8a34f196b0092c90$var$S(n, l) {
    if (null == l) return n.__ ? $8a34f196b0092c90$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $8a34f196b0092c90$var$S(n) : null;
}
function $8a34f196b0092c90$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $8a34f196b0092c90$var$C(n);
    }
}
function $8a34f196b0092c90$var$M(n) {
    (!n.__d && (n.__d = !0) && $8a34f196b0092c90$var$i.push(n) && !$8a34f196b0092c90$var$$.__r++ || $8a34f196b0092c90$var$r != $8a34f196b0092c90$export$41c562ebe57d11e2.debounceRendering) && (($8a34f196b0092c90$var$r = $8a34f196b0092c90$export$41c562ebe57d11e2.debounceRendering) || $8a34f196b0092c90$var$o)($8a34f196b0092c90$var$$);
}
function $8a34f196b0092c90$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $8a34f196b0092c90$var$i.length;)$8a34f196b0092c90$var$i.length > s && $8a34f196b0092c90$var$i.sort($8a34f196b0092c90$var$e), n = $8a34f196b0092c90$var$i.shift(), s = $8a34f196b0092c90$var$i.length, n.__d && (t = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $8a34f196b0092c90$var$d({}, r)).__v = r.__v + 1, $8a34f196b0092c90$export$41c562ebe57d11e2.vnode && $8a34f196b0092c90$export$41c562ebe57d11e2.vnode(t), $8a34f196b0092c90$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $8a34f196b0092c90$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $8a34f196b0092c90$var$z(f, t, c), t.__e != o && $8a34f196b0092c90$var$C(t)));
    $8a34f196b0092c90$var$$.__r = 0;
}
function $8a34f196b0092c90$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, v, w, d, g, _ = t && t.__k || $8a34f196b0092c90$var$y, m = l.length;
    for(f = $8a34f196b0092c90$var$P(u, l, _, f, m), a = 0; a < m; a++)null != (v = u.__k[a]) && (h = -1 == v.__i ? $8a34f196b0092c90$var$p : _[v.__i] || $8a34f196b0092c90$var$p, v.__i = a, g = $8a34f196b0092c90$var$O(n, v, h, i, r, o, e, f, c, s), w = v.__e, v.ref && h.ref != v.ref && (h.ref && $8a34f196b0092c90$var$q(h.ref, null, v), s.push(v.ref, v.__c || w, v)), null == d && null != w && (d = w), 4 & v.__u || h.__k === v.__k ? f = $8a34f196b0092c90$var$A(v, f, n) : "function" == typeof v.type && void 0 !== g ? f = g : w && (f = w.nextSibling), v.__u &= -7);
    return u.__e = d, f;
}
function $8a34f196b0092c90$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? $8a34f196b0092c90$var$m(null, o, null, null, null) : $8a34f196b0092c90$var$w(o) ? $8a34f196b0092c90$var$m($8a34f196b0092c90$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? $8a34f196b0092c90$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $8a34f196b0092c90$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $8a34f196b0092c90$var$S(e)), $8a34f196b0092c90$var$B(e, e));
    return t;
}
function $8a34f196b0092c90$var$A(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $8a34f196b0092c90$var$A(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $8a34f196b0092c90$var$S(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $8a34f196b0092c90$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($8a34f196b0092c90$var$w(n) ? n.some(function(n) {
        $8a34f196b0092c90$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $8a34f196b0092c90$var$L(n, l, u, t) {
    var i, r, o = n.key, e = n.type, f = l[u];
    if (null === f && null == n.key || f && o == f.key && e == f.type && 0 == (2 & f.__u)) return u;
    if (t > (null != f && 0 == (2 & f.__u) ? 1 : 0)) for(i = u - 1, r = u + 1; i >= 0 || r < l.length;){
        if (i >= 0) {
            if ((f = l[i]) && 0 == (2 & f.__u) && o == f.key && e == f.type) return i;
            i--;
        }
        if (r < l.length) {
            if ((f = l[r]) && 0 == (2 & f.__u) && o == f.key && e == f.type) return r;
            r++;
        }
    }
    return -1;
}
function $8a34f196b0092c90$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $8a34f196b0092c90$var$v.test(l) ? u : u + "px";
}
function $8a34f196b0092c90$var$j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $8a34f196b0092c90$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $8a34f196b0092c90$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($8a34f196b0092c90$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $8a34f196b0092c90$var$c, n.addEventListener(l, r ? $8a34f196b0092c90$var$a : $8a34f196b0092c90$var$s, r)) : n.removeEventListener(l, r ? $8a34f196b0092c90$var$a : $8a34f196b0092c90$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $8a34f196b0092c90$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $8a34f196b0092c90$var$c++;
            else if (u.t < t.u) return;
            return t($8a34f196b0092c90$export$41c562ebe57d11e2.event ? $8a34f196b0092c90$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $8a34f196b0092c90$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, y, v, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $8a34f196b0092c90$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $8a34f196b0092c90$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $8a34f196b0092c90$var$D), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $8a34f196b0092c90$var$d({}, h.__s)), $8a34f196b0092c90$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), y = h.props, v = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== y && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(y, v, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $8a34f196b0092c90$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $8a34f196b0092c90$var$d($8a34f196b0092c90$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(y, v)), L = a, null != a && a.type === $8a34f196b0092c90$export$ffb0004e005737fa && null == a.key && (L = $8a34f196b0092c90$var$N(a.props.children)), f = $8a34f196b0092c90$var$I(n, $8a34f196b0092c90$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else for(T = o.length; T--;)$8a34f196b0092c90$var$g(o[T]);
        } else u.__e = t.__e, u.__k = t.__k;
        $8a34f196b0092c90$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $8a34f196b0092c90$var$V(t.__e, u, t, i, r, o, e, c, s);
    return (a = $8a34f196b0092c90$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $8a34f196b0092c90$var$z(n, u, t) {
    for(var i = 0; i < t.length; i++)$8a34f196b0092c90$var$q(t[i], t[++i], t[++i]);
    $8a34f196b0092c90$export$41c562ebe57d11e2.__c && $8a34f196b0092c90$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $8a34f196b0092c90$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $8a34f196b0092c90$var$N(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $8a34f196b0092c90$var$w(n) ? n.map($8a34f196b0092c90$var$N) : $8a34f196b0092c90$var$d({}, n);
}
function $8a34f196b0092c90$var$V(u, t, i, r, o, e, f, c, s) {
    var a, h, y, v, d, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($8a34f196b0092c90$export$41c562ebe57d11e2.__m && $8a34f196b0092c90$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $8a34f196b0092c90$var$n.call(u.childNodes), b = i.props || $8a34f196b0092c90$var$p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) y = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $8a34f196b0092c90$var$j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? v = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $8a34f196b0092c90$var$j(u, a, d, b[a], o);
        if (h) c || y && (h.__html == y.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (y && (u.innerHTML = ""), $8a34f196b0092c90$var$I("template" == t.type ? u.content : u, $8a34f196b0092c90$var$w(v) ? v : [
            v
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $8a34f196b0092c90$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$8a34f196b0092c90$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $8a34f196b0092c90$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $8a34f196b0092c90$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $8a34f196b0092c90$var$q(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $8a34f196b0092c90$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $8a34f196b0092c90$var$B(n, u, t) {
    var i, r;
    if ($8a34f196b0092c90$export$41c562ebe57d11e2.unmount && $8a34f196b0092c90$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $8a34f196b0092c90$var$q(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $8a34f196b0092c90$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $8a34f196b0092c90$var$B(i[r], u, t || "function" != typeof n.type);
    t || $8a34f196b0092c90$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $8a34f196b0092c90$var$D(n, l, u) {
    return this.constructor(n, u);
}
function $8a34f196b0092c90$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $8a34f196b0092c90$export$41c562ebe57d11e2.__ && $8a34f196b0092c90$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $8a34f196b0092c90$var$O(t, u = (!r && i || t).__k = $8a34f196b0092c90$export$c8a8987d4410bf2d($8a34f196b0092c90$export$ffb0004e005737fa, null, [
        u
    ]), o || $8a34f196b0092c90$var$p, $8a34f196b0092c90$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $8a34f196b0092c90$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $8a34f196b0092c90$var$z(e, u, f);
}
function $8a34f196b0092c90$export$fa8d919ba61d84db(n, l) {
    $8a34f196b0092c90$export$b3890eb0ae9dca99(n, l, $8a34f196b0092c90$export$fa8d919ba61d84db);
}
function $8a34f196b0092c90$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $8a34f196b0092c90$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = null == u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $8a34f196b0092c90$var$n.call(arguments, 2) : t), $8a34f196b0092c90$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $8a34f196b0092c90$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $8a34f196b0092c90$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $8a34f196b0092c90$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$8a34f196b0092c90$var$n = $8a34f196b0092c90$var$y.slice, $8a34f196b0092c90$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $8a34f196b0092c90$var$u = 0, $8a34f196b0092c90$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $8a34f196b0092c90$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $8a34f196b0092c90$var$d({}, this.state), "function" == typeof n && (n = n($8a34f196b0092c90$var$d({}, u), this.props)), n && $8a34f196b0092c90$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $8a34f196b0092c90$var$M(this));
}, $8a34f196b0092c90$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $8a34f196b0092c90$var$M(this));
}, $8a34f196b0092c90$export$16fa2f45be04daa8.prototype.render = $8a34f196b0092c90$export$ffb0004e005737fa, $8a34f196b0092c90$var$i = [], $8a34f196b0092c90$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $8a34f196b0092c90$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $8a34f196b0092c90$var$$.__r = 0, $8a34f196b0092c90$var$f = /(PointerCapture)$|Capture$/i, $8a34f196b0092c90$var$c = 0, $8a34f196b0092c90$var$s = $8a34f196b0092c90$var$F(!1), $8a34f196b0092c90$var$a = $8a34f196b0092c90$var$F(!0), $8a34f196b0092c90$var$h = 0;

});


parcelRegister("kLOUX", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $f1efb19b07e08b96$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $f1efb19b07e08b96$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $f1efb19b07e08b96$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $f1efb19b07e08b96$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $f1efb19b07e08b96$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $f1efb19b07e08b96$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $f1efb19b07e08b96$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $f1efb19b07e08b96$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $f1efb19b07e08b96$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $f1efb19b07e08b96$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useErrorBoundary", function () { return $f1efb19b07e08b96$export$c052f6604b7d51fe; });
$parcel$export(module.exports, "useId", function () { return $f1efb19b07e08b96$export$f680877a34711e37; });

var $bRFDG = parcelRequire("bRFDG");
var $f1efb19b07e08b96$var$t, $f1efb19b07e08b96$var$r, $f1efb19b07e08b96$var$u, $f1efb19b07e08b96$var$i, $f1efb19b07e08b96$var$o = 0, $f1efb19b07e08b96$var$f = [], $f1efb19b07e08b96$var$c = (0, $bRFDG.options), $f1efb19b07e08b96$var$e = $f1efb19b07e08b96$var$c.__b, $f1efb19b07e08b96$var$a = $f1efb19b07e08b96$var$c.__r, $f1efb19b07e08b96$var$v = $f1efb19b07e08b96$var$c.diffed, $f1efb19b07e08b96$var$l = $f1efb19b07e08b96$var$c.__c, $f1efb19b07e08b96$var$m = $f1efb19b07e08b96$var$c.unmount, $f1efb19b07e08b96$var$s = $f1efb19b07e08b96$var$c.__;
function $f1efb19b07e08b96$var$p(n, t) {
    $f1efb19b07e08b96$var$c.__h && $f1efb19b07e08b96$var$c.__h($f1efb19b07e08b96$var$r, n, $f1efb19b07e08b96$var$o || t), $f1efb19b07e08b96$var$o = 0;
    var u = $f1efb19b07e08b96$var$r.__H || ($f1efb19b07e08b96$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $f1efb19b07e08b96$export$60241385465d0a34(n) {
    return $f1efb19b07e08b96$var$o = 1, $f1efb19b07e08b96$export$13e3392192263954($f1efb19b07e08b96$var$D, n);
}
function $f1efb19b07e08b96$export$13e3392192263954(n, u, i) {
    var o = $f1efb19b07e08b96$var$p($f1efb19b07e08b96$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $f1efb19b07e08b96$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $f1efb19b07e08b96$var$r, !$f1efb19b07e08b96$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $f1efb19b07e08b96$var$r.__f = !0;
        var c = $f1efb19b07e08b96$var$r.shouldComponentUpdate, e = $f1efb19b07e08b96$var$r.componentWillUpdate;
        $f1efb19b07e08b96$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $f1efb19b07e08b96$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $f1efb19b07e08b96$export$6d9c69b0de29b591(n, u) {
    var i = $f1efb19b07e08b96$var$p($f1efb19b07e08b96$var$t++, 3);
    !$f1efb19b07e08b96$var$c.__s && $f1efb19b07e08b96$var$C(i.__H, u) && (i.__ = n, i.u = u, $f1efb19b07e08b96$var$r.__H.__h.push(i));
}
function $f1efb19b07e08b96$export$e5c5a5f917a5871c(n, u) {
    var i = $f1efb19b07e08b96$var$p($f1efb19b07e08b96$var$t++, 4);
    !$f1efb19b07e08b96$var$c.__s && $f1efb19b07e08b96$var$C(i.__H, u) && (i.__ = n, i.u = u, $f1efb19b07e08b96$var$r.__h.push(i));
}
function $f1efb19b07e08b96$export$b8f5890fc79d6aca(n) {
    return $f1efb19b07e08b96$var$o = 5, $f1efb19b07e08b96$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $f1efb19b07e08b96$export$d5a552a76deda3c2(n, t, r) {
    $f1efb19b07e08b96$var$o = 6, $f1efb19b07e08b96$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $f1efb19b07e08b96$export$1538c33de8887b59(n, r) {
    var u = $f1efb19b07e08b96$var$p($f1efb19b07e08b96$var$t++, 7);
    return $f1efb19b07e08b96$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $f1efb19b07e08b96$export$35808ee640e87ca7(n, t) {
    return $f1efb19b07e08b96$var$o = 8, $f1efb19b07e08b96$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $f1efb19b07e08b96$export$fae74005e78b1a27(n) {
    var u = $f1efb19b07e08b96$var$r.context[n.__c], i = $f1efb19b07e08b96$var$p($f1efb19b07e08b96$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($f1efb19b07e08b96$var$r)), u.props.value) : n.__;
}
function $f1efb19b07e08b96$export$dc8fbce3eb94dc1e(n, t) {
    $f1efb19b07e08b96$var$c.useDebugValue && $f1efb19b07e08b96$var$c.useDebugValue(t ? t(n) : n);
}
function $f1efb19b07e08b96$export$c052f6604b7d51fe(n) {
    var u = $f1efb19b07e08b96$var$p($f1efb19b07e08b96$var$t++, 10), i = $f1efb19b07e08b96$export$60241385465d0a34();
    return u.__ = n, $f1efb19b07e08b96$var$r.componentDidCatch || ($f1efb19b07e08b96$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $f1efb19b07e08b96$export$f680877a34711e37() {
    var n = $f1efb19b07e08b96$var$p($f1efb19b07e08b96$var$t++, 11);
    if (!n.__) {
        for(var u = $f1efb19b07e08b96$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $f1efb19b07e08b96$var$j() {
    for(var n; n = $f1efb19b07e08b96$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($f1efb19b07e08b96$var$z), n.__H.__h.forEach($f1efb19b07e08b96$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $f1efb19b07e08b96$var$c.__e(t, n.__v);
    }
}
$f1efb19b07e08b96$var$c.__b = function(n) {
    $f1efb19b07e08b96$var$r = null, $f1efb19b07e08b96$var$e && $f1efb19b07e08b96$var$e(n);
}, $f1efb19b07e08b96$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $f1efb19b07e08b96$var$s && $f1efb19b07e08b96$var$s(n, t);
}, $f1efb19b07e08b96$var$c.__r = function(n) {
    $f1efb19b07e08b96$var$a && $f1efb19b07e08b96$var$a(n), $f1efb19b07e08b96$var$t = 0;
    var i = ($f1efb19b07e08b96$var$r = n.__c).__H;
    i && ($f1efb19b07e08b96$var$u === $f1efb19b07e08b96$var$r ? (i.__h = [], $f1efb19b07e08b96$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.forEach($f1efb19b07e08b96$var$z), i.__h.forEach($f1efb19b07e08b96$var$B), i.__h = [], $f1efb19b07e08b96$var$t = 0)), $f1efb19b07e08b96$var$u = $f1efb19b07e08b96$var$r;
}, $f1efb19b07e08b96$var$c.diffed = function(n) {
    $f1efb19b07e08b96$var$v && $f1efb19b07e08b96$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $f1efb19b07e08b96$var$f.push(t) && $f1efb19b07e08b96$var$i === $f1efb19b07e08b96$var$c.requestAnimationFrame || (($f1efb19b07e08b96$var$i = $f1efb19b07e08b96$var$c.requestAnimationFrame) || $f1efb19b07e08b96$var$w)($f1efb19b07e08b96$var$j)), t.__H.__.forEach(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $f1efb19b07e08b96$var$u = $f1efb19b07e08b96$var$r = null;
}, $f1efb19b07e08b96$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($f1efb19b07e08b96$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $f1efb19b07e08b96$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $f1efb19b07e08b96$var$c.__e(r, n.__v);
        }
    }), $f1efb19b07e08b96$var$l && $f1efb19b07e08b96$var$l(n, t);
}, $f1efb19b07e08b96$var$c.unmount = function(n) {
    $f1efb19b07e08b96$var$m && $f1efb19b07e08b96$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $f1efb19b07e08b96$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $f1efb19b07e08b96$var$c.__e(t, r.__v));
};
var $f1efb19b07e08b96$var$k = "function" == typeof requestAnimationFrame;
function $f1efb19b07e08b96$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $f1efb19b07e08b96$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $f1efb19b07e08b96$var$k && (t = requestAnimationFrame(r));
}
function $f1efb19b07e08b96$var$z(n) {
    var t = $f1efb19b07e08b96$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $f1efb19b07e08b96$var$r = t;
}
function $f1efb19b07e08b96$var$B(n) {
    var t = $f1efb19b07e08b96$var$r;
    n.__c = n.__(), $f1efb19b07e08b96$var$r = t;
}
function $f1efb19b07e08b96$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $f1efb19b07e08b96$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});

parcelRegister("348Te", function(module, exports) {

$parcel$export(module.exports, "ModalCloseButton", function () { return $7b2773c5272096f4$export$edf9108895ba774f; });
$parcel$export(module.exports, "ModalPanel", function () { return $7b2773c5272096f4$export$80a09bd95a8fb873; });
$parcel$export(module.exports, "Modal", function () { return $7b2773c5272096f4$export$2b77a92f1a5ad772; });

var $8jWPf = parcelRequire("8jWPf");

var $8tI2z = parcelRequire("8tI2z");
var $fijwX = parcelRequire("fijwX");

var $bRFDG = parcelRequire("bRFDG");

var $jTZEy = parcelRequire("jTZEy");
function $7b2773c5272096f4$export$edf9108895ba774f({ onClick: onClick }) {
    return /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
        type: "button",
        class: $jTZEy.closeButton,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
            class: "ion-close-round"
        })
    });
}
function $7b2773c5272096f4$export$80a09bd95a8fb873({ children: children, className: className }) {
    return /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
        className: className || $jTZEy.dialogPanel,
        children: children
    });
}
function $7b2773c5272096f4$export$2b77a92f1a5ad772({ isOpen: isOpen, onClose: onClose, children: children, initialFocus: initialFocus }) {
    return /*#__PURE__*/ (0, $8jWPf.jsx)((0, $fijwX.Transition), {
        appear: true,
        show: isOpen,
        as: (0, $bRFDG.Fragment),
        children: /*#__PURE__*/ (0, $8jWPf.jsxs)((0, $8tI2z.Dialog), {
            as: "div",
            onClose: onClose,
            className: $jTZEy.dialog,
            initialFocus: initialFocus,
            children: [
                /*#__PURE__*/ (0, $8jWPf.jsx)((0, $fijwX.Transition).Child, {
                    as: (0, $bRFDG.Fragment),
                    enter: $jTZEy.backdropEnter,
                    enterFrom: $jTZEy.backdropEnterFrom,
                    enterTo: $jTZEy.backdropEnterTo,
                    leave: $jTZEy.backdropLeave,
                    leaveFrom: $jTZEy.backdropLeaveFrom,
                    leaveTo: $jTZEy.backdropLeaveTo,
                    children: /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                        className: $jTZEy.backdrop,
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $8jWPf.jsx)((0, $fijwX.Transition).Child, {
                    as: (0, $bRFDG.Fragment),
                    enter: $jTZEy.panelEnter,
                    enterFrom: $jTZEy.panelEnterFrom,
                    enterTo: $jTZEy.panelEnterTo,
                    leave: $jTZEy.panelLeave,
                    leaveFrom: $jTZEy.panelLeaveFrom,
                    leaveTo: $jTZEy.panelLeaveTo,
                    children: /*#__PURE__*/ (0, $8jWPf.jsx)((0, $8tI2z.Dialog).Panel, {
                        className: $jTZEy.wrapper,
                        children: children
                    })
                })
            ]
        })
    });
}

});
parcelRegister("8tI2z", function(module, exports) {

$parcel$export(module.exports, "Dialog", function () { return $62c331b2c2c7173d$export$3ddf2d174ce01153; });
parcelRequire("gsMHG");
var $bRFDG = parcelRequire("bRFDG");
var $gsMHG = parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $7XYnx = parcelRequire("7XYnx");

var $ex6pY = parcelRequire("ex6pY");

var $8jGWf = parcelRequire("8jGWf");

var $aUAjX = parcelRequire("aUAjX");

var $2pqNO = parcelRequire("2pqNO");

var $7yd0N = parcelRequire("7yd0N");

var $boy0b = parcelRequire("boy0b");

var $9IJj8 = parcelRequire("9IJj8");

var $bdYzg = parcelRequire("bdYzg");

var $7mq8M = parcelRequire("7mq8M");

var $6A6CF = parcelRequire("6A6CF");

var $5hRNE = parcelRequire("5hRNE");

var $7fkaP = parcelRequire("7fkaP");

var $efwez = parcelRequire("efwez");

var $6RICz = parcelRequire("6RICz");

var $6ldDn = parcelRequire("6ldDn");

var $kXStv = parcelRequire("kXStv");

var $i4ILg = parcelRequire("i4ILg");

var $dlO63 = parcelRequire("dlO63");

var $5XK7S = parcelRequire("5XK7S");
var $62c331b2c2c7173d$var$Se = ((o)=>(o[o.Open = 0] = "Open", o[o.Closed = 1] = "Closed", o))($62c331b2c2c7173d$var$Se || {}), $62c331b2c2c7173d$var$Fe = ((e)=>(e[e.SetTitleId = 0] = "SetTitleId", e))($62c331b2c2c7173d$var$Fe || {});
let $62c331b2c2c7173d$var$ke = {
    [0] (t, e) {
        return t.titleId === e.id ? t : {
            ...t,
            titleId: e.id
        };
    }
}, $62c331b2c2c7173d$var$M = (0, $bRFDG.createContext)(null);
$62c331b2c2c7173d$var$M.displayName = "DialogContext";
function $62c331b2c2c7173d$var$S(t) {
    let e = (0, $kLOUX.useContext)($62c331b2c2c7173d$var$M);
    if (e === null) {
        let o = new Error(`<${t} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(o, $62c331b2c2c7173d$var$S), o;
    }
    return e;
}
function $62c331b2c2c7173d$var$xe(t, e, o = ()=>[
        document.body
    ]) {
    (0, $dlO63.useDocumentOverflowLockedEffect)(t, e, (s)=>{
        var n;
        return {
            containers: [
                ...(n = s.containers) != null ? n : [],
                o
            ]
        };
    });
}
function $62c331b2c2c7173d$var$_e(t, e) {
    return (0, $7XYnx.match)(e.type, $62c331b2c2c7173d$var$ke, t, e);
}
let $62c331b2c2c7173d$var$Me = "div", $62c331b2c2c7173d$var$He = (0, $ex6pY.Features).RenderStrategy | (0, $ex6pY.Features).Static;
function $62c331b2c2c7173d$var$Ie(t, e) {
    let o = (0, $7yd0N.useId)(), { id: s = `headlessui-dialog-${o}`, open: n, onClose: l, initialFocus: d, __demoMode: c = !1, ...D } = t, [P, F] = (0, $kLOUX.useState)(0), i = (0, $6A6CF.useOpenClosed)();
    n === void 0 && i !== null && (n = (i & (0, $6A6CF.State).Open) === (0, $6A6CF.State).Open);
    let m = (0, $kLOUX.useRef)(null), Q = (0, $8jGWf.useSyncRefs)(m, e), y = (0, $kLOUX.useRef)(null), p = (0, $6RICz.useOwnerDocument)(m), U = t.hasOwnProperty("open") || i !== null, N = t.hasOwnProperty("onClose");
    if (!U && !N) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!U) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!N) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof n != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n}`);
    if (typeof l != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${l}`);
    let u = n ? 0 : 1, [E, Z] = (0, $kLOUX.useReducer)($62c331b2c2c7173d$var$_e, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, $bRFDG.createRef)()
    }), A = (0, $i4ILg.useEvent)(()=>l(!1)), Y = (0, $i4ILg.useEvent)((r)=>Z({
            type: 0,
            id: r
        })), k = (0, $5hRNE.useServerHandoffComplete)() ? c ? !1 : u === 0 : !1, x = P > 1, $ = (0, $kLOUX.useContext)($62c331b2c2c7173d$var$M) !== null, ee = x ? "parent" : "leaf", W = i !== null ? (i & (0, $6A6CF.State).Closing) === (0, $6A6CF.State).Closing : !1, te = (()=>$ || W ? !1 : k)(), oe = (0, $kLOUX.useCallback)(()=>{
        var r, f;
        return (f = Array.from((r = p == null ? void 0 : p.querySelectorAll("body > *")) != null ? r : []).find((a)=>a.id === "headlessui-portal-root" ? !1 : a.contains(y.current) && a instanceof HTMLElement)) != null ? f : null;
    }, [
        y
    ]);
    (0, $5XK7S.useInert)(oe, te);
    let re = (()=>x ? !0 : k)(), ne = (0, $kLOUX.useCallback)(()=>{
        var r, f;
        return (f = Array.from((r = p == null ? void 0 : p.querySelectorAll("[data-headlessui-portal]")) != null ? r : []).find((a)=>a.contains(y.current) && a instanceof HTMLElement)) != null ? f : null;
    }, [
        y
    ]);
    (0, $5XK7S.useInert)(ne, re);
    let H = (0, $i4ILg.useEvent)(()=>{
        var f, a;
        return [
            ...Array.from((f = p == null ? void 0 : p.querySelectorAll("html > *, body > *, [data-headlessui-portal]")) != null ? f : []).filter((T)=>!(T === document.body || T === document.head || !(T instanceof HTMLElement) || T.contains(y.current) || E.panelRef.current && T.contains(E.panelRef.current))),
            (a = E.panelRef.current) != null ? a : m.current
        ];
    }), le = (()=>!(!k || x))();
    (0, $efwez.useOutsideClick)(()=>H(), A, le);
    let ae = (()=>!(x || u !== 0))();
    (0, $6ldDn.useEventListener)(p == null ? void 0 : p.defaultView, "keydown", (r)=>{
        ae && (r.defaultPrevented || r.key === (0, $aUAjX.Keys).Escape && (r.preventDefault(), r.stopPropagation(), A()));
    });
    let ie = (()=>!(W || u !== 0 || $))();
    $62c331b2c2c7173d$var$xe(p, ie, H), (0, $kLOUX.useEffect)(()=>{
        if (u !== 0 || !m.current) return;
        let r = new ResizeObserver((f)=>{
            for (let a of f){
                let T = a.target.getBoundingClientRect();
                T.x === 0 && T.y === 0 && T.width === 0 && T.height === 0 && A();
            }
        });
        return r.observe(m.current), ()=>r.disconnect();
    }, [
        u,
        m,
        A
    ]);
    let [se, pe] = (0, $7mq8M.useDescriptions)(), de = (0, $kLOUX.useMemo)(()=>[
            {
                dialogState: u,
                close: A,
                setTitleId: Y
            },
            E
        ], [
        u,
        E,
        A,
        Y
    ]), J = (0, $kLOUX.useMemo)(()=>({
            open: u === 0
        }), [
        u
    ]), ue = {
        ref: Q,
        id: s,
        role: "dialog",
        "aria-modal": u === 0 ? !0 : void 0,
        "aria-labelledby": E.titleId,
        "aria-describedby": se
    };
    return (0, $gsMHG.default).createElement((0, $7fkaP.StackProvider), {
        type: "Dialog",
        enabled: u === 0,
        element: m,
        onUpdate: (0, $i4ILg.useEvent)((r, f)=>{
            f === "Dialog" && (0, $7XYnx.match)(r, {
                [(0, $7fkaP.StackMessage).Add]: ()=>F((a)=>a + 1),
                [(0, $7fkaP.StackMessage).Remove]: ()=>F((a)=>a - 1)
            });
        })
    }, (0, $gsMHG.default).createElement((0, $bdYzg.ForcePortalRoot), {
        force: !0
    }, (0, $gsMHG.default).createElement((0, $9IJj8.Portal), null, (0, $gsMHG.default).createElement($62c331b2c2c7173d$var$M.Provider, {
        value: de
    }, (0, $gsMHG.default).createElement((0, $9IJj8.Portal).Group, {
        target: m
    }, (0, $gsMHG.default).createElement((0, $bdYzg.ForcePortalRoot), {
        force: !1
    }, (0, $gsMHG.default).createElement(pe, {
        slot: J,
        name: "Dialog.Description"
    }, (0, $gsMHG.default).createElement((0, $boy0b.FocusTrap), {
        initialFocus: d,
        containers: H,
        features: k ? (0, $7XYnx.match)(ee, {
            parent: (0, $boy0b.FocusTrap).features.RestoreFocus,
            leaf: (0, $boy0b.FocusTrap).features.All & ~(0, $boy0b.FocusTrap).features.FocusLock
        }) : (0, $boy0b.FocusTrap).features.None
    }, (0, $ex6pY.render)({
        ourProps: ue,
        theirProps: D,
        slot: J,
        defaultTag: $62c331b2c2c7173d$var$Me,
        features: $62c331b2c2c7173d$var$He,
        visible: u === 0,
        name: "Dialog"
    })))))))), (0, $gsMHG.default).createElement((0, $kXStv.Hidden), {
        features: (0, $kXStv.Features).Hidden,
        ref: y
    }));
}
let $62c331b2c2c7173d$var$we = "div";
function $62c331b2c2c7173d$var$Be(t, e) {
    let o = (0, $7yd0N.useId)(), { id: s = `headlessui-dialog-overlay-${o}`, ...n } = t, [{ dialogState: l, close: d }] = $62c331b2c2c7173d$var$S("Dialog.Overlay"), c = (0, $8jGWf.useSyncRefs)(e), D = (0, $i4ILg.useEvent)((i)=>{
        if (i.target === i.currentTarget) {
            if ((0, $2pqNO.isDisabledReactIssue7711)(i.currentTarget)) return i.preventDefault();
            i.preventDefault(), i.stopPropagation(), d();
        }
    }), P = (0, $kLOUX.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $ex6pY.render)({
        ourProps: {
            ref: c,
            id: s,
            "aria-hidden": !0,
            onClick: D
        },
        theirProps: n,
        slot: P,
        defaultTag: $62c331b2c2c7173d$var$we,
        name: "Dialog.Overlay"
    });
}
let $62c331b2c2c7173d$var$Ge = "div";
function $62c331b2c2c7173d$var$Ue(t, e) {
    let o = (0, $7yd0N.useId)(), { id: s = `headlessui-dialog-backdrop-${o}`, ...n } = t, [{ dialogState: l }, d] = $62c331b2c2c7173d$var$S("Dialog.Backdrop"), c = (0, $8jGWf.useSyncRefs)(e);
    (0, $kLOUX.useEffect)(()=>{
        if (d.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        d.panelRef
    ]);
    let D = (0, $kLOUX.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $gsMHG.default).createElement((0, $bdYzg.ForcePortalRoot), {
        force: !0
    }, (0, $gsMHG.default).createElement((0, $9IJj8.Portal), null, (0, $ex6pY.render)({
        ourProps: {
            ref: c,
            id: s,
            "aria-hidden": !0
        },
        theirProps: n,
        slot: D,
        defaultTag: $62c331b2c2c7173d$var$Ge,
        name: "Dialog.Backdrop"
    })));
}
let $62c331b2c2c7173d$var$Ne = "div";
function $62c331b2c2c7173d$var$Ye(t, e) {
    let o = (0, $7yd0N.useId)(), { id: s = `headlessui-dialog-panel-${o}`, ...n } = t, [{ dialogState: l }, d] = $62c331b2c2c7173d$var$S("Dialog.Panel"), c = (0, $8jGWf.useSyncRefs)(e, d.panelRef), D = (0, $kLOUX.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]), P = (0, $i4ILg.useEvent)((i)=>{
        i.stopPropagation();
    });
    return (0, $ex6pY.render)({
        ourProps: {
            ref: c,
            id: s,
            onClick: P
        },
        theirProps: n,
        slot: D,
        defaultTag: $62c331b2c2c7173d$var$Ne,
        name: "Dialog.Panel"
    });
}
let $62c331b2c2c7173d$var$$e = "h2";
function $62c331b2c2c7173d$var$We(t, e) {
    let o = (0, $7yd0N.useId)(), { id: s = `headlessui-dialog-title-${o}`, ...n } = t, [{ dialogState: l, setTitleId: d }] = $62c331b2c2c7173d$var$S("Dialog.Title"), c = (0, $8jGWf.useSyncRefs)(e);
    (0, $kLOUX.useEffect)(()=>(d(s), ()=>d(null)), [
        s,
        d
    ]);
    let D = (0, $kLOUX.useMemo)(()=>({
            open: l === 0
        }), [
        l
    ]);
    return (0, $ex6pY.render)({
        ourProps: {
            ref: c,
            id: s
        },
        theirProps: n,
        slot: D,
        defaultTag: $62c331b2c2c7173d$var$$e,
        name: "Dialog.Title"
    });
}
let $62c331b2c2c7173d$var$Je = (0, $ex6pY.forwardRefWithAs)($62c331b2c2c7173d$var$Ie), $62c331b2c2c7173d$var$Xe = (0, $ex6pY.forwardRefWithAs)($62c331b2c2c7173d$var$Ue), $62c331b2c2c7173d$var$je = (0, $ex6pY.forwardRefWithAs)($62c331b2c2c7173d$var$Ye), $62c331b2c2c7173d$var$Ke = (0, $ex6pY.forwardRefWithAs)($62c331b2c2c7173d$var$Be), $62c331b2c2c7173d$var$Ve = (0, $ex6pY.forwardRefWithAs)($62c331b2c2c7173d$var$We), $62c331b2c2c7173d$export$3ddf2d174ce01153 = Object.assign($62c331b2c2c7173d$var$Je, {
    Backdrop: $62c331b2c2c7173d$var$Xe,
    Panel: $62c331b2c2c7173d$var$je,
    Overlay: $62c331b2c2c7173d$var$Ke,
    Title: $62c331b2c2c7173d$var$Ve,
    Description: (0, $7mq8M.Description)
});

});
parcelRegister("gsMHG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useSyncExternalStore", function () { return $bfc50a5bd9822f53$export$306c0aa65ff9ec16; });
$parcel$export(module.exports, "startTransition", function () { return $bfc50a5bd9822f53$export$7568632d0d33d16d; });
$parcel$export(module.exports, "useDeferredValue", function () { return $bfc50a5bd9822f53$export$6a7bc4e911dc01cf; });
$parcel$export(module.exports, "useTransition", function () { return $bfc50a5bd9822f53$export$7b286972b8d8ccbf; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $bfc50a5bd9822f53$export$aaabe4eda9ed9969; });
$parcel$export(module.exports, "PureComponent", function () { return $bfc50a5bd9822f53$export$221d75b3f55bb0bd; });
$parcel$export(module.exports, "memo", function () { return $bfc50a5bd9822f53$export$7c73462e0d25e514; });
$parcel$export(module.exports, "forwardRef", function () { return $bfc50a5bd9822f53$export$257a8862b851cb5b; });
$parcel$export(module.exports, "Children", function () { return $bfc50a5bd9822f53$export$dca3b0875bd9a954; });
$parcel$export(module.exports, "Suspense", function () { return $bfc50a5bd9822f53$export$74bf444e3cd11ea5; });
$parcel$export(module.exports, "lazy", function () { return $bfc50a5bd9822f53$export$488013bae63b21da; });
$parcel$export(module.exports, "SuspenseList", function () { return $bfc50a5bd9822f53$export$998bcd577473dd93; });
$parcel$export(module.exports, "createPortal", function () { return $bfc50a5bd9822f53$export$d39a5bbd09211389; });
$parcel$export(module.exports, "render", function () { return $bfc50a5bd9822f53$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $bfc50a5bd9822f53$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $bfc50a5bd9822f53$export$ae55be85d98224ed; });
$parcel$export(module.exports, "version", function () { return $bfc50a5bd9822f53$export$83d89fbfd8236492; });
$parcel$export(module.exports, "createFactory", function () { return $bfc50a5bd9822f53$export$d38cd72104c1f0e9; });
$parcel$export(module.exports, "isValidElement", function () { return $bfc50a5bd9822f53$export$a8257692ac88316c; });
$parcel$export(module.exports, "isFragment", function () { return $bfc50a5bd9822f53$export$9522e17588c12572; });
$parcel$export(module.exports, "isMemo", function () { return $bfc50a5bd9822f53$export$56885ab8b9c456ab; });
$parcel$export(module.exports, "cloneElement", function () { return $bfc50a5bd9822f53$export$e530037191fcd5d7; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $bfc50a5bd9822f53$export$502457920280e6be; });
$parcel$export(module.exports, "findDOMNode", function () { return $bfc50a5bd9822f53$export$466bfc07425424d5; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $bfc50a5bd9822f53$export$c78a37762a8d58e1; });
$parcel$export(module.exports, "flushSync", function () { return $bfc50a5bd9822f53$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "StrictMode", function () { return $bfc50a5bd9822f53$export$5f8d39834fd61797; });
$parcel$export(module.exports, "isElement", function () { return $bfc50a5bd9822f53$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "default", function () { return $bfc50a5bd9822f53$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Component", function () { return (parcelRequire("bRFDG")).Component; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("bRFDG")).Fragment; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("bRFDG")).createContext; });
$parcel$export(module.exports, "createElement", function () { return (parcelRequire("bRFDG")).createElement; });
$parcel$export(module.exports, "createRef", function () { return (parcelRequire("bRFDG")).createRef; });

var $bRFDG = parcelRequire("bRFDG");

var $kLOUX = parcelRequire("kLOUX");
function $bfc50a5bd9822f53$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $bfc50a5bd9822f53$var$E(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $bfc50a5bd9822f53$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $kLOUX.useState)({
        t: {
            __: e,
            u: t
        }
    }), u = r[0].t, o = r[1];
    return (0, $kLOUX.useLayoutEffect)(function() {
        u.__ = e, u.u = t, $bfc50a5bd9822f53$var$x(u) && o({
            t: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $kLOUX.useEffect)(function() {
        return $bfc50a5bd9822f53$var$x(u) && o({
            t: u
        }), n(function() {
            $bfc50a5bd9822f53$var$x(u) && o({
                t: u
            });
        });
    }, [
        n
    ]), e;
}
function $bfc50a5bd9822f53$var$x(n) {
    var t, e, r = n.u, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
function $bfc50a5bd9822f53$export$7568632d0d33d16d(n) {
    n();
}
function $bfc50a5bd9822f53$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $bfc50a5bd9822f53$export$7b286972b8d8ccbf() {
    return [
        !1,
        $bfc50a5bd9822f53$export$7568632d0d33d16d
    ];
}
var $bfc50a5bd9822f53$export$aaabe4eda9ed9969 = (0, $kLOUX.useLayoutEffect);
function $bfc50a5bd9822f53$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $bfc50a5bd9822f53$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $bfc50a5bd9822f53$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $bRFDG.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($bfc50a5bd9822f53$export$221d75b3f55bb0bd.prototype = new (0, $bRFDG.Component)).isPureReactComponent = !0, $bfc50a5bd9822f53$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $bfc50a5bd9822f53$var$E(this.props, n) || $bfc50a5bd9822f53$var$E(this.state, t);
};
var $bfc50a5bd9822f53$var$T = (0, $bRFDG.options).__b;
(0, $bRFDG.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $bfc50a5bd9822f53$var$T && $bfc50a5bd9822f53$var$T(n);
};
var $bfc50a5bd9822f53$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $bfc50a5bd9822f53$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $bfc50a5bd9822f53$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $bfc50a5bd9822f53$var$A, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $bfc50a5bd9822f53$var$L = function(n, t) {
    return null == n ? null : (0, $bRFDG.toChildArray)((0, $bRFDG.toChildArray)(n).map(t));
}, $bfc50a5bd9822f53$export$dca3b0875bd9a954 = {
    map: $bfc50a5bd9822f53$var$L,
    forEach: $bfc50a5bd9822f53$var$L,
    count: function(n) {
        return n ? (0, $bRFDG.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $bRFDG.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $bRFDG.toChildArray)
}, $bfc50a5bd9822f53$var$F = (0, $bRFDG.options).__e;
(0, $bRFDG.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $bfc50a5bd9822f53$var$F(n, t, e, r);
};
var $bfc50a5bd9822f53$var$U = (0, $bRFDG.options).unmount;
function $bfc50a5bd9822f53$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $bfc50a5bd9822f53$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $bfc50a5bd9822f53$var$V(n, t, e);
    })), n;
}
function $bfc50a5bd9822f53$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $bfc50a5bd9822f53$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $bfc50a5bd9822f53$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $bfc50a5bd9822f53$var$j(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $bfc50a5bd9822f53$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $bRFDG.createElement)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $bfc50a5bd9822f53$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $bRFDG.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $bfc50a5bd9822f53$var$U && $bfc50a5bd9822f53$var$U(n);
}, ($bfc50a5bd9822f53$export$74bf444e3cd11ea5.prototype = new (0, $bRFDG.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.o && (r.o = []), r.o.push(e);
    var u = $bfc50a5bd9822f53$var$j(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $bfc50a5bd9822f53$var$W(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.o.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $bfc50a5bd9822f53$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $bfc50a5bd9822f53$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $bfc50a5bd9822f53$var$V(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $bRFDG.createElement)((0, $bRFDG.Fragment), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $bRFDG.createElement)((0, $bRFDG.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $bfc50a5bd9822f53$var$H = function(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $bfc50a5bd9822f53$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $bfc50a5bd9822f53$var$Y(n) {
    var e = this, r = n.h;
    if (e.componentWillUnmount = function() {
        (0, $bRFDG.render)(null, e.v), e.v = null, e.h = null;
    }, e.h && e.h !== r && e.componentWillUnmount(), !e.v) {
        for(var u = e.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        e.h = r, e.v = {
            nodeType: 1,
            parentNode: r,
            childNodes: [],
            __k: {
                __m: u.__m
            },
            contains: function() {
                return !0;
            },
            insertBefore: function(n, t) {
                this.childNodes.push(n), e.h.insertBefore(n, t);
            },
            removeChild: function(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.h.removeChild(n);
            }
        };
    }
    (0, $bRFDG.render)((0, $bRFDG.createElement)($bfc50a5bd9822f53$var$Z, {
        context: e.context
    }, n.__v), e.v);
}
function $bfc50a5bd9822f53$export$d39a5bbd09211389(n, e) {
    var r = (0, $bRFDG.createElement)($bfc50a5bd9822f53$var$Y, {
        __v: n,
        h: e
    });
    return r.containerInfo = e, r;
}
($bfc50a5bd9822f53$export$998bcd577473dd93.prototype = new (0, $bRFDG.Component)).__a = function(n) {
    var t = this, e = $bfc50a5bd9822f53$var$j(t.__v), r = t.l.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $bfc50a5bd9822f53$var$H(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $bfc50a5bd9822f53$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var t = (0, $bRFDG.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.l.set(t[e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $bfc50a5bd9822f53$export$998bcd577473dd93.prototype.componentDidUpdate = $bfc50a5bd9822f53$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.l.forEach(function(t, e) {
        $bfc50a5bd9822f53$var$H(n, e, t);
    });
};
var $bfc50a5bd9822f53$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $bfc50a5bd9822f53$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $bfc50a5bd9822f53$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $bfc50a5bd9822f53$var$K = /[A-Z0-9]/g, $bfc50a5bd9822f53$var$Q = "undefined" != typeof document, $bfc50a5bd9822f53$var$X = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $bfc50a5bd9822f53$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $bRFDG.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $bfc50a5bd9822f53$export$fa8d919ba61d84db(n, t, e) {
    return (0, $bRFDG.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $bRFDG.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $bRFDG.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $bfc50a5bd9822f53$var$en = (0, $bRFDG.options).event;
function $bfc50a5bd9822f53$var$rn() {}
function $bfc50a5bd9822f53$var$un() {
    return this.cancelBubble;
}
function $bfc50a5bd9822f53$var$on() {
    return this.defaultPrevented;
}
(0, $bRFDG.options).event = function(n) {
    return $bfc50a5bd9822f53$var$en && (n = $bfc50a5bd9822f53$var$en(n)), n.persist = $bfc50a5bd9822f53$var$rn, n.isPropagationStopped = $bfc50a5bd9822f53$var$un, n.isDefaultPrevented = $bfc50a5bd9822f53$var$on, n.nativeEvent = n;
};
var $bfc50a5bd9822f53$var$ln, $bfc50a5bd9822f53$var$cn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $bfc50a5bd9822f53$var$fn = (0, $bRFDG.options).vnode;
(0, $bRFDG.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {}, o = -1 === e.indexOf("-");
        for(var i in t){
            var l = t[i];
            if (!("value" === i && "defaultValue" in t && null == l || $bfc50a5bd9822f53$var$Q && "children" === i && "noscript" === e || "class" === i || "className" === i)) {
                var c = i.toLowerCase();
                "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === l ? l = "" : "translate" === c && "no" === l ? l = !1 : "o" === c[0] && "n" === c[1] ? "ondoubleclick" === c ? i = "ondblclick" : "onchange" !== c || "input" !== e && "textarea" !== e || $bfc50a5bd9822f53$var$X(t.type) ? "onfocus" === c ? i = "onfocusin" : "onblur" === c ? i = "onfocusout" : $bfc50a5bd9822f53$var$J.test(i) && (i = c) : c = i = "oninput" : o && $bfc50a5bd9822f53$var$G.test(i) ? i = i.replace($bfc50a5bd9822f53$var$K, "-$&").toLowerCase() : null === l && (l = void 0), "oninput" === c && u[i = c] && (i = "oninputCapture"), u[i] = l;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $bRFDG.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $bRFDG.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $bfc50a5bd9822f53$var$cn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $bfc50a5bd9822f53$var$q, $bfc50a5bd9822f53$var$fn && $bfc50a5bd9822f53$var$fn(n);
};
var $bfc50a5bd9822f53$var$an = (0, $bRFDG.options).__r;
(0, $bRFDG.options).__r = function(n) {
    $bfc50a5bd9822f53$var$an && $bfc50a5bd9822f53$var$an(n), $bfc50a5bd9822f53$var$ln = n.__c;
};
var $bfc50a5bd9822f53$var$sn = (0, $bRFDG.options).diffed;
(0, $bRFDG.options).diffed = function(n) {
    $bfc50a5bd9822f53$var$sn && $bfc50a5bd9822f53$var$sn(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $bfc50a5bd9822f53$var$ln = null;
};
var $bfc50a5bd9822f53$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $bfc50a5bd9822f53$var$ln.__n[n.__c].props.value;
            },
            useCallback: (0, $kLOUX.useCallback),
            useContext: (0, $kLOUX.useContext),
            useDebugValue: (0, $kLOUX.useDebugValue),
            useDeferredValue: $bfc50a5bd9822f53$export$6a7bc4e911dc01cf,
            useEffect: (0, $kLOUX.useEffect),
            useId: (0, $kLOUX.useId),
            useImperativeHandle: (0, $kLOUX.useImperativeHandle),
            useInsertionEffect: $bfc50a5bd9822f53$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $kLOUX.useLayoutEffect),
            useMemo: (0, $kLOUX.useMemo),
            useReducer: (0, $kLOUX.useReducer),
            useRef: (0, $kLOUX.useRef),
            useState: (0, $kLOUX.useState),
            useSyncExternalStore: $bfc50a5bd9822f53$export$306c0aa65ff9ec16,
            useTransition: $bfc50a5bd9822f53$export$7b286972b8d8ccbf
        }
    }
}, $bfc50a5bd9822f53$export$83d89fbfd8236492 = "18.3.1";
function $bfc50a5bd9822f53$export$d38cd72104c1f0e9(n) {
    return (0, $bRFDG.createElement).bind(null, n);
}
function $bfc50a5bd9822f53$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $bfc50a5bd9822f53$var$q;
}
function $bfc50a5bd9822f53$export$9522e17588c12572(n) {
    return $bfc50a5bd9822f53$export$a8257692ac88316c(n) && n.type === (0, $bRFDG.Fragment);
}
function $bfc50a5bd9822f53$export$56885ab8b9c456ab(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function $bfc50a5bd9822f53$export$e530037191fcd5d7(n) {
    return $bfc50a5bd9822f53$export$a8257692ac88316c(n) ? (0, $bRFDG.cloneElement).apply(null, arguments) : n;
}
function $bfc50a5bd9822f53$export$502457920280e6be(n) {
    return !!n.__k && ((0, $bRFDG.render)(null, n), !0);
}
function $bfc50a5bd9822f53$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $bfc50a5bd9822f53$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $bfc50a5bd9822f53$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $bfc50a5bd9822f53$export$5f8d39834fd61797 = (0, $bRFDG.Fragment), $bfc50a5bd9822f53$export$45a5e7f76e0caa8d = $bfc50a5bd9822f53$export$a8257692ac88316c, $bfc50a5bd9822f53$export$2e2bcd8739ae039 = {
    useState: (0, $kLOUX.useState),
    useId: (0, $kLOUX.useId),
    useReducer: (0, $kLOUX.useReducer),
    useEffect: (0, $kLOUX.useEffect),
    useLayoutEffect: (0, $kLOUX.useLayoutEffect),
    useInsertionEffect: $bfc50a5bd9822f53$export$aaabe4eda9ed9969,
    useTransition: $bfc50a5bd9822f53$export$7b286972b8d8ccbf,
    useDeferredValue: $bfc50a5bd9822f53$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $bfc50a5bd9822f53$export$306c0aa65ff9ec16,
    startTransition: $bfc50a5bd9822f53$export$7568632d0d33d16d,
    useRef: (0, $kLOUX.useRef),
    useImperativeHandle: (0, $kLOUX.useImperativeHandle),
    useMemo: (0, $kLOUX.useMemo),
    useCallback: (0, $kLOUX.useCallback),
    useContext: (0, $kLOUX.useContext),
    useDebugValue: (0, $kLOUX.useDebugValue),
    version: "18.3.1",
    Children: $bfc50a5bd9822f53$export$dca3b0875bd9a954,
    render: $bfc50a5bd9822f53$export$b3890eb0ae9dca99,
    hydrate: $bfc50a5bd9822f53$export$fa8d919ba61d84db,
    unmountComponentAtNode: $bfc50a5bd9822f53$export$502457920280e6be,
    createPortal: $bfc50a5bd9822f53$export$d39a5bbd09211389,
    createElement: (0, $bRFDG.createElement),
    createContext: (0, $bRFDG.createContext),
    createFactory: $bfc50a5bd9822f53$export$d38cd72104c1f0e9,
    cloneElement: $bfc50a5bd9822f53$export$e530037191fcd5d7,
    createRef: (0, $bRFDG.createRef),
    Fragment: (0, $bRFDG.Fragment),
    isValidElement: $bfc50a5bd9822f53$export$a8257692ac88316c,
    isElement: $bfc50a5bd9822f53$export$45a5e7f76e0caa8d,
    isFragment: $bfc50a5bd9822f53$export$9522e17588c12572,
    isMemo: $bfc50a5bd9822f53$export$56885ab8b9c456ab,
    findDOMNode: $bfc50a5bd9822f53$export$466bfc07425424d5,
    Component: (0, $bRFDG.Component),
    PureComponent: $bfc50a5bd9822f53$export$221d75b3f55bb0bd,
    memo: $bfc50a5bd9822f53$export$7c73462e0d25e514,
    forwardRef: $bfc50a5bd9822f53$export$257a8862b851cb5b,
    flushSync: $bfc50a5bd9822f53$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $bfc50a5bd9822f53$export$c78a37762a8d58e1,
    StrictMode: $bfc50a5bd9822f53$export$5f8d39834fd61797,
    Suspense: $bfc50a5bd9822f53$export$74bf444e3cd11ea5,
    SuspenseList: $bfc50a5bd9822f53$export$998bcd577473dd93,
    lazy: $bfc50a5bd9822f53$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $bfc50a5bd9822f53$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $kLOUX);

});

parcelRegister("7XYnx", function(module, exports) {

$parcel$export(module.exports, "match", function () { return $5ccce109a1d5e30b$export$4659b591c19bdf3d; });
function $5ccce109a1d5e30b$export$4659b591c19bdf3d(r, n, ...a) {
    if (r in n) {
        let e = n[r];
        return typeof e == "function" ? e(...a) : e;
    }
    let t = new Error(`Tried to handle "${r}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((e)=>`"${e}"`).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, $5ccce109a1d5e30b$export$4659b591c19bdf3d), t;
}

});

parcelRegister("ex6pY", function(module, exports) {

$parcel$export(module.exports, "Features", function () { return $a9492032f89c3b21$export$617d79dae526d2cf; });
$parcel$export(module.exports, "RenderStrategy", function () { return $a9492032f89c3b21$export$80c0a745e59f7989; });
$parcel$export(module.exports, "render", function () { return $a9492032f89c3b21$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "compact", function () { return $a9492032f89c3b21$export$8e16b83750b44988; });
$parcel$export(module.exports, "forwardRefWithAs", function () { return $a9492032f89c3b21$export$e43f39796049410c; });

var $gsMHG = parcelRequire("gsMHG");
var $bRFDG = parcelRequire("bRFDG");

var $kfLTU = parcelRequire("kfLTU");

var $7XYnx = parcelRequire("7XYnx");
var $a9492032f89c3b21$export$617d79dae526d2cf = ((a)=>(a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a))($a9492032f89c3b21$export$617d79dae526d2cf || {}), $a9492032f89c3b21$export$80c0a745e59f7989 = ((e)=>(e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))($a9492032f89c3b21$export$80c0a745e59f7989 || {});
function $a9492032f89c3b21$export$b3890eb0ae9dca99({ ourProps: r, theirProps: t, slot: e, defaultTag: a, features: s, visible: n = !0, name: l }) {
    let o = $a9492032f89c3b21$var$h(t, r);
    if (n) return $a9492032f89c3b21$var$m(o, e, a, l);
    let f = s != null ? s : 0;
    if (f & 2) {
        let { static: i = !1, ...u } = o;
        if (i) return $a9492032f89c3b21$var$m(u, e, a, l);
    }
    if (f & 1) {
        let { unmount: i = !0, ...u } = o;
        return (0, $7XYnx.match)(i ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return $a9492032f89c3b21$var$m({
                    ...u,
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }, e, a, l);
            }
        });
    }
    return $a9492032f89c3b21$var$m(o, e, a, l);
}
function $a9492032f89c3b21$var$m(r, t = {}, e, a) {
    var y;
    let { as: s = e, children: n, refName: l = "ref", ...o } = $a9492032f89c3b21$var$g(r, [
        "unmount",
        "static"
    ]), f = r.ref !== void 0 ? {
        [l]: r.ref
    } : {}, i = typeof n == "function" ? n(t) : n;
    "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(t));
    let u = {};
    if (t) {
        let d = !1, c = [];
        for (let [p, F] of Object.entries(t))typeof F == "boolean" && (d = !0), F === !0 && c.push(p);
        d && (u["data-headlessui-state"] = c.join(" "));
    }
    if (s === (0, $bRFDG.Fragment) && Object.keys($a9492032f89c3b21$export$8e16b83750b44988(o)).length > 0) {
        if (!(0, $gsMHG.isValidElement)(i) || Array.isArray(i) && i.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${a} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(o).map((p)=>`  - ${p}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map((p)=>`  - ${p}`).join(`
`)
        ].join(`
`));
        let d = (0, $kfLTU.classNames)((y = i.props) == null ? void 0 : y.className, o.className), c = d ? {
            className: d
        } : {};
        return (0, $gsMHG.cloneElement)(i, Object.assign({}, $a9492032f89c3b21$var$h(i.props, $a9492032f89c3b21$export$8e16b83750b44988($a9492032f89c3b21$var$g(o, [
            "ref"
        ]))), u, f, $a9492032f89c3b21$var$O(i.ref, f.ref), c));
    }
    return (0, $bRFDG.createElement)(s, Object.assign({}, $a9492032f89c3b21$var$g(o, [
        "ref"
    ]), s !== (0, $bRFDG.Fragment) && f, s !== (0, $bRFDG.Fragment) && u), i);
}
function $a9492032f89c3b21$var$O(...r) {
    return {
        ref: r.every((t)=>t == null) ? void 0 : (t)=>{
            for (let e of r)e != null && (typeof e == "function" ? e(t) : e.current = t);
        }
    };
}
function $a9492032f89c3b21$var$h(...r) {
    var a;
    if (r.length === 0) return {};
    if (r.length === 1) return r[0];
    let t = {}, e = {};
    for (let s of r)for(let n in s)n.startsWith("on") && typeof s[n] == "function" ? ((a = e[n]) != null || (e[n] = []), e[n].push(s[n])) : t[n] = s[n];
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(e).map((s)=>[
            s,
            void 0
        ])));
    for(let s in e)Object.assign(t, {
        [s] (n, ...l) {
            let o = e[s];
            for (let f of o){
                if ((n instanceof Event || (n == null ? void 0 : n.nativeEvent) instanceof Event) && n.defaultPrevented) return;
                f(n, ...l);
            }
        }
    });
    return t;
}
function $a9492032f89c3b21$export$e43f39796049410c(r) {
    var t;
    return Object.assign((0, $gsMHG.forwardRef)(r), {
        displayName: (t = r.displayName) != null ? t : r.name
    });
}
function $a9492032f89c3b21$export$8e16b83750b44988(r) {
    let t = Object.assign({}, r);
    for(let e in t)t[e] === void 0 && delete t[e];
    return t;
}
function $a9492032f89c3b21$var$g(r, t = []) {
    let e = Object.assign({}, r);
    for (let a of t)a in e && delete e[a];
    return e;
}

});
parcelRegister("kfLTU", function(module, exports) {

$parcel$export(module.exports, "classNames", function () { return $ebea5d70a62e05ab$export$ce4ab0c55987d1ff; });
function $ebea5d70a62e05ab$export$ce4ab0c55987d1ff(...n) {
    return n.filter(Boolean).join(" ");
}

});


parcelRegister("8jGWf", function(module, exports) {

$parcel$export(module.exports, "optionalRef", function () { return $60e167c1cff37063$export$7029785b750eb74; });
$parcel$export(module.exports, "useSyncRefs", function () { return $60e167c1cff37063$export$f6a25a78204acc7e; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $i4ILg = parcelRequire("i4ILg");
let $60e167c1cff37063$var$u = Symbol();
function $60e167c1cff37063$export$7029785b750eb74(t, n = !0) {
    return Object.assign(t, {
        [$60e167c1cff37063$var$u]: n
    });
}
function $60e167c1cff37063$export$f6a25a78204acc7e(...t) {
    let n = (0, $kLOUX.useRef)(t);
    (0, $kLOUX.useEffect)(()=>{
        n.current = t;
    }, [
        t
    ]);
    let c = (0, $i4ILg.useEvent)((e)=>{
        for (let o of n.current)o != null && (typeof o == "function" ? o(e) : o.current = e);
    });
    return t.every((e)=>e == null || (e == null ? void 0 : e[$60e167c1cff37063$var$u])) ? void 0 : c;
}

});
parcelRegister("i4ILg", function(module, exports) {

$parcel$export(module.exports, "useEvent", function () { return $d28b52669b681ad2$export$90fc3a17d93f704c; });

var $gsMHG = parcelRequire("gsMHG");

var $5Y7iv = parcelRequire("5Y7iv");
let $d28b52669b681ad2$export$90fc3a17d93f704c = function(t) {
    let e = (0, $5Y7iv.useLatestValue)(t);
    return (0, $gsMHG.default).useCallback((...r)=>e.current(...r), [
        e
    ]);
};

});
parcelRegister("5Y7iv", function(module, exports) {

$parcel$export(module.exports, "useLatestValue", function () { return $4588377697e31b00$export$86c4283a11f23f95; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $frj70 = parcelRequire("frj70");
function $4588377697e31b00$export$86c4283a11f23f95(e) {
    let r = (0, $kLOUX.useRef)(e);
    return (0, $frj70.useIsoMorphicEffect)(()=>{
        r.current = e;
    }, [
        e
    ]), r;
}

});
parcelRegister("frj70", function(module, exports) {

$parcel$export(module.exports, "useIsoMorphicEffect", function () { return $b3d833dff50c3dca$export$ce5ed857c741fd71; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $g8hvJ = parcelRequire("g8hvJ");
let $b3d833dff50c3dca$export$ce5ed857c741fd71 = (e, f)=>{
    (0, $g8hvJ.env).isServer ? (0, $kLOUX.useEffect)(e, f) : (0, $kLOUX.useLayoutEffect)(e, f);
};

});
parcelRegister("g8hvJ", function(module, exports) {

$parcel$export(module.exports, "env", function () { return $bbeaf9f55e1cae9c$export$a7b6bc01c63cdfc3; });
var $bbeaf9f55e1cae9c$var$i = Object.defineProperty;
var $bbeaf9f55e1cae9c$var$d = (t, e, n)=>e in t ? $bbeaf9f55e1cae9c$var$i(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : t[e] = n;
var $bbeaf9f55e1cae9c$var$r = (t, e, n)=>($bbeaf9f55e1cae9c$var$d(t, typeof e != "symbol" ? e + "" : e, n), n);
class $bbeaf9f55e1cae9c$var$o {
    constructor(){
        $bbeaf9f55e1cae9c$var$r(this, "current", this.detect());
        $bbeaf9f55e1cae9c$var$r(this, "handoffState", "pending");
        $bbeaf9f55e1cae9c$var$r(this, "currentId", 0);
    }
    set(e) {
        this.current !== e && (this.handoffState = "pending", this.currentId = 0, this.current = e);
    }
    reset() {
        this.set(this.detect());
    }
    nextId() {
        return ++this.currentId;
    }
    get isServer() {
        return this.current === "server";
    }
    get isClient() {
        return this.current === "client";
    }
    detect() {
        return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
    }
    handoff() {
        this.handoffState === "pending" && (this.handoffState = "complete");
    }
    get isHandoffComplete() {
        return this.handoffState === "complete";
    }
}
let $bbeaf9f55e1cae9c$export$a7b6bc01c63cdfc3 = new $bbeaf9f55e1cae9c$var$o;

});





parcelRegister("aUAjX", function(module, exports) {

$parcel$export(module.exports, "Keys", function () { return $7f1b4eec4bd2e8da$export$4b0075e5ea5e1f26; });
var $7f1b4eec4bd2e8da$export$4b0075e5ea5e1f26 = ((r)=>(r.Space = " ", r.Enter = "Enter", r.Escape = "Escape", r.Backspace = "Backspace", r.Delete = "Delete", r.ArrowLeft = "ArrowLeft", r.ArrowUp = "ArrowUp", r.ArrowRight = "ArrowRight", r.ArrowDown = "ArrowDown", r.Home = "Home", r.End = "End", r.PageUp = "PageUp", r.PageDown = "PageDown", r.Tab = "Tab", r))($7f1b4eec4bd2e8da$export$4b0075e5ea5e1f26 || {});

});

parcelRegister("2pqNO", function(module, exports) {

$parcel$export(module.exports, "isDisabledReactIssue7711", function () { return $1c12b4f744d6d2fd$export$db61f031a278447c; });
function $1c12b4f744d6d2fd$export$db61f031a278447c(n) {
    let e = n.parentElement, l = null;
    for(; e && !(e instanceof HTMLFieldSetElement);)e instanceof HTMLLegendElement && (l = e), e = e.parentElement;
    let t = (e == null ? void 0 : e.getAttribute("disabled")) === "";
    return t && $1c12b4f744d6d2fd$var$i(l) ? !1 : t;
}
function $1c12b4f744d6d2fd$var$i(n) {
    if (!n) return !1;
    let e = n.previousElementSibling;
    for(; e !== null;){
        if (e instanceof HTMLLegendElement) return !1;
        e = e.previousElementSibling;
    }
    return !0;
}

});

parcelRegister("7yd0N", function(module, exports) {

$parcel$export(module.exports, "useId", function () { return $57f5cd3f42c92a8b$export$f680877a34711e37; });

var $gsMHG = parcelRequire("gsMHG");

var $frj70 = parcelRequire("frj70");

var $5hRNE = parcelRequire("5hRNE");

var $g8hvJ = parcelRequire("g8hvJ");
var $57f5cd3f42c92a8b$var$o;
let $57f5cd3f42c92a8b$export$f680877a34711e37 = ($57f5cd3f42c92a8b$var$o = (0, $gsMHG.default).useId) != null ? $57f5cd3f42c92a8b$var$o : function() {
    let n = (0, $5hRNE.useServerHandoffComplete)(), [e, u] = (0, $gsMHG.default).useState(n ? ()=>(0, $g8hvJ.env).nextId() : null);
    return (0, $frj70.useIsoMorphicEffect)(()=>{
        e === null && u((0, $g8hvJ.env).nextId());
    }, [
        e
    ]), e != null ? "" + e : void 0;
};

});
parcelRegister("5hRNE", function(module, exports) {

$parcel$export(module.exports, "useServerHandoffComplete", function () { return $3d9845cfabc397e5$export$44ab2b9f2d09b0fa; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $g8hvJ = parcelRequire("g8hvJ");
function $3d9845cfabc397e5$export$44ab2b9f2d09b0fa() {
    let [e, f] = (0, $kLOUX.useState)((0, $g8hvJ.env).isHandoffComplete);
    return e && (0, $g8hvJ.env).isHandoffComplete === !1 && f(!1), (0, $kLOUX.useEffect)(()=>{
        e !== !0 && f(!0);
    }, [
        e
    ]), (0, $kLOUX.useEffect)(()=>(0, $g8hvJ.env).handoff(), []), e;
}

});


parcelRegister("boy0b", function(module, exports) {

$parcel$export(module.exports, "FocusTrap", function () { return $84bc4fb2d1d43f22$export$34eba2437817a67b; });

var $gsMHG = parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $ex6pY = parcelRequire("ex6pY");

var $5hRNE = parcelRequire("5hRNE");

var $8jGWf = parcelRequire("8jGWf");

var $kXStv = parcelRequire("kXStv");

var $37yyp = parcelRequire("37yyp");

var $7XYnx = parcelRequire("7XYnx");

var $i4ILg = parcelRequire("i4ILg");

var $eFrTh = parcelRequire("eFrTh");

var $5iAri = parcelRequire("5iAri");

var $6RICz = parcelRequire("6RICz");

var $6ldDn = parcelRequire("6ldDn");

var $dhuMb = parcelRequire("dhuMb");

var $cLDcY = parcelRequire("cLDcY");

var $fczrW = parcelRequire("fczrW");
function $84bc4fb2d1d43f22$var$P(t) {
    if (!t) return new Set;
    if (typeof t == "function") return new Set(t());
    let n = new Set;
    for (let e of t.current)e.current instanceof HTMLElement && n.add(e.current);
    return n;
}
let $84bc4fb2d1d43f22$var$J = "div";
var $84bc4fb2d1d43f22$var$h = ((r)=>(r[r.None = 1] = "None", r[r.InitialFocus = 2] = "InitialFocus", r[r.TabLock = 4] = "TabLock", r[r.FocusLock = 8] = "FocusLock", r[r.RestoreFocus = 16] = "RestoreFocus", r[r.All = 30] = "All", r))($84bc4fb2d1d43f22$var$h || {});
function $84bc4fb2d1d43f22$var$X(t, n) {
    let e = (0, $kLOUX.useRef)(null), o = (0, $8jGWf.useSyncRefs)(e, n), { initialFocus: u, containers: i, features: r = 30, ...l } = t;
    (0, $5hRNE.useServerHandoffComplete)() || (r = 1);
    let m = (0, $6RICz.useOwnerDocument)(e);
    $84bc4fb2d1d43f22$var$Q({
        ownerDocument: m
    }, Boolean(r & 16));
    let c = $84bc4fb2d1d43f22$var$Y({
        ownerDocument: m,
        container: e,
        initialFocus: u
    }, Boolean(r & 2));
    $84bc4fb2d1d43f22$var$Z({
        ownerDocument: m,
        container: e,
        containers: i,
        previousActiveElement: c
    }, Boolean(r & 8));
    let v = (0, $eFrTh.useTabDirection)(), R = (0, $i4ILg.useEvent)((s)=>{
        let T = e.current;
        if (!T) return;
        ((B)=>B())(()=>{
            (0, $7XYnx.match)(v.current, {
                [(0, $eFrTh.Direction).Forwards]: ()=>{
                    (0, $37yyp.focusIn)(T, (0, $37yyp.Focus).First, {
                        skipElements: [
                            s.relatedTarget
                        ]
                    });
                },
                [(0, $eFrTh.Direction).Backwards]: ()=>{
                    (0, $37yyp.focusIn)(T, (0, $37yyp.Focus).Last, {
                        skipElements: [
                            s.relatedTarget
                        ]
                    });
                }
            });
        });
    }), _ = (0, $fczrW.useDisposables)(), H = (0, $kLOUX.useRef)(!1), j = {
        ref: o,
        onKeyDown (s) {
            s.key == "Tab" && (H.current = !0, _.requestAnimationFrame(()=>{
                H.current = !1;
            }));
        },
        onBlur (s) {
            let T = $84bc4fb2d1d43f22$var$P(i);
            e.current instanceof HTMLElement && T.add(e.current);
            let E = s.relatedTarget;
            E instanceof HTMLElement && E.dataset.headlessuiFocusGuard !== "true" && ($84bc4fb2d1d43f22$var$S(T, E) || (H.current ? (0, $37yyp.focusIn)(e.current, (0, $7XYnx.match)(v.current, {
                [(0, $eFrTh.Direction).Forwards]: ()=>(0, $37yyp.Focus).Next,
                [(0, $eFrTh.Direction).Backwards]: ()=>(0, $37yyp.Focus).Previous
            }) | (0, $37yyp.Focus).WrapAround, {
                relativeTo: s.target
            }) : s.target instanceof HTMLElement && (0, $37yyp.focusElement)(s.target)));
        }
    };
    return (0, $gsMHG.default).createElement((0, $gsMHG.default).Fragment, null, Boolean(r & 4) && (0, $gsMHG.default).createElement((0, $kXStv.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, $kXStv.Features).Focusable
    }), (0, $ex6pY.render)({
        ourProps: j,
        theirProps: l,
        defaultTag: $84bc4fb2d1d43f22$var$J,
        name: "FocusTrap"
    }), Boolean(r & 4) && (0, $gsMHG.default).createElement((0, $kXStv.Hidden), {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: R,
        features: (0, $kXStv.Features).Focusable
    }));
}
let $84bc4fb2d1d43f22$var$z = (0, $ex6pY.forwardRefWithAs)($84bc4fb2d1d43f22$var$X), $84bc4fb2d1d43f22$export$34eba2437817a67b = Object.assign($84bc4fb2d1d43f22$var$z, {
    features: $84bc4fb2d1d43f22$var$h
}), $84bc4fb2d1d43f22$var$a = [];
if (typeof window != "undefined" && typeof document != "undefined") {
    let t = function(n) {
        n.target instanceof HTMLElement && n.target !== document.body && $84bc4fb2d1d43f22$var$a[0] !== n.target && ($84bc4fb2d1d43f22$var$a.unshift(n.target), $84bc4fb2d1d43f22$var$a = $84bc4fb2d1d43f22$var$a.filter((e)=>e != null && e.isConnected), $84bc4fb2d1d43f22$var$a.splice(10));
    };
    var $84bc4fb2d1d43f22$var$handle = t;
    window.addEventListener("click", t, {
        capture: !0
    }), window.addEventListener("mousedown", t, {
        capture: !0
    }), window.addEventListener("focus", t, {
        capture: !0
    }), document.body.addEventListener("click", t, {
        capture: !0
    }), document.body.addEventListener("mousedown", t, {
        capture: !0
    }), document.body.addEventListener("focus", t, {
        capture: !0
    });
}
function $84bc4fb2d1d43f22$var$D(t = !0) {
    let n = (0, $kLOUX.useRef)($84bc4fb2d1d43f22$var$a.slice());
    return (0, $cLDcY.useWatch)(([e], [o])=>{
        o === !0 && e === !1 && (0, $dhuMb.microTask)(()=>{
            n.current.splice(0);
        }), o === !1 && e === !0 && (n.current = $84bc4fb2d1d43f22$var$a.slice());
    }, [
        t,
        $84bc4fb2d1d43f22$var$a,
        n
    ]), (0, $i4ILg.useEvent)(()=>{
        var e;
        return (e = n.current.find((o)=>o != null && o.isConnected)) != null ? e : null;
    });
}
function $84bc4fb2d1d43f22$var$Q({ ownerDocument: t }, n) {
    let e = $84bc4fb2d1d43f22$var$D(n);
    (0, $cLDcY.useWatch)(()=>{
        n || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && (0, $37yyp.focusElement)(e());
    }, [
        n
    ]);
    let o = (0, $kLOUX.useRef)(!1);
    (0, $kLOUX.useEffect)(()=>(o.current = !1, ()=>{
            o.current = !0, (0, $dhuMb.microTask)(()=>{
                o.current && (0, $37yyp.focusElement)(e());
            });
        }), []);
}
function $84bc4fb2d1d43f22$var$Y({ ownerDocument: t, container: n, initialFocus: e }, o) {
    let u = (0, $kLOUX.useRef)(null), i = (0, $5iAri.useIsMounted)();
    return (0, $cLDcY.useWatch)(()=>{
        if (!o) return;
        let r = n.current;
        r && (0, $dhuMb.microTask)(()=>{
            if (!i.current) return;
            let l = t == null ? void 0 : t.activeElement;
            if (e != null && e.current) {
                if ((e == null ? void 0 : e.current) === l) {
                    u.current = l;
                    return;
                }
            } else if (r.contains(l)) {
                u.current = l;
                return;
            }
            e != null && e.current ? (0, $37yyp.focusElement)(e.current) : (0, $37yyp.focusIn)(r, (0, $37yyp.Focus).First) === (0, $37yyp.FocusResult).Error && console.warn("There are no focusable elements inside the <FocusTrap />"), u.current = t == null ? void 0 : t.activeElement;
        });
    }, [
        o
    ]), u;
}
function $84bc4fb2d1d43f22$var$Z({ ownerDocument: t, container: n, containers: e, previousActiveElement: o }, u) {
    let i = (0, $5iAri.useIsMounted)();
    (0, $6ldDn.useEventListener)(t == null ? void 0 : t.defaultView, "focus", (r)=>{
        if (!u || !i.current) return;
        let l = $84bc4fb2d1d43f22$var$P(e);
        n.current instanceof HTMLElement && l.add(n.current);
        let m = o.current;
        if (!m) return;
        let c = r.target;
        c && c instanceof HTMLElement ? $84bc4fb2d1d43f22$var$S(l, c) ? (o.current = c, (0, $37yyp.focusElement)(c)) : (r.preventDefault(), r.stopPropagation(), (0, $37yyp.focusElement)(m)) : (0, $37yyp.focusElement)(o.current);
    }, !0);
}
function $84bc4fb2d1d43f22$var$S(t, n) {
    for (let e of t)if (e.contains(n)) return !0;
    return !1;
}

});
parcelRegister("kXStv", function(module, exports) {

$parcel$export(module.exports, "Features", function () { return $f43392ebd788ce3b$export$617d79dae526d2cf; });
$parcel$export(module.exports, "Hidden", function () { return $f43392ebd788ce3b$export$8dc98ba7eadeaa56; });

var $ex6pY = parcelRequire("ex6pY");
let $f43392ebd788ce3b$var$a = "div";
var $f43392ebd788ce3b$export$617d79dae526d2cf = ((e)=>(e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))($f43392ebd788ce3b$export$617d79dae526d2cf || {});
function $f43392ebd788ce3b$var$s(t, o) {
    let { features: n = 1, ...e } = t, d = {
        ref: o,
        "aria-hidden": (n & 2) === 2 ? !0 : void 0,
        style: {
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0",
            ...(n & 4) === 4 && (n & 2) !== 2 && {
                display: "none"
            }
        }
    };
    return (0, $ex6pY.render)({
        ourProps: d,
        theirProps: e,
        slot: {},
        defaultTag: $f43392ebd788ce3b$var$a,
        name: "Hidden"
    });
}
let $f43392ebd788ce3b$export$8dc98ba7eadeaa56 = (0, $ex6pY.forwardRefWithAs)($f43392ebd788ce3b$var$s);

});

parcelRegister("37yyp", function(module, exports) {

$parcel$export(module.exports, "Focus", function () { return $245cd439dbda24ce$export$807a7eae502106e7; });
$parcel$export(module.exports, "FocusResult", function () { return $245cd439dbda24ce$export$abf286375dfa6dbd; });
$parcel$export(module.exports, "FocusableMode", function () { return $245cd439dbda24ce$export$27112a34f2f8402d; });
$parcel$export(module.exports, "isFocusableElement", function () { return $245cd439dbda24ce$export$ff1ec1c740b3c8d5; });
$parcel$export(module.exports, "focusElement", function () { return $245cd439dbda24ce$export$5fed9cc43865dc7e; });
$parcel$export(module.exports, "sortByDomNode", function () { return $245cd439dbda24ce$export$20305e96f91bf103; });
$parcel$export(module.exports, "focusIn", function () { return $245cd439dbda24ce$export$82e1f4f412218a1d; });

var $lemPO = parcelRequire("lemPO");

var $7XYnx = parcelRequire("7XYnx");

var $5I2Bs = parcelRequire("5I2Bs");
let $245cd439dbda24ce$var$f = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map((e)=>`${e}:not([tabindex='-1'])`).join(",");
var $245cd439dbda24ce$export$807a7eae502106e7 = ((r)=>(r[r.First = 1] = "First", r[r.Previous = 2] = "Previous", r[r.Next = 4] = "Next", r[r.Last = 8] = "Last", r[r.WrapAround = 16] = "WrapAround", r[r.NoScroll = 32] = "NoScroll", r))($245cd439dbda24ce$export$807a7eae502106e7 || {}), $245cd439dbda24ce$export$abf286375dfa6dbd = ((o)=>(o[o.Error = 0] = "Error", o[o.Overflow = 1] = "Overflow", o[o.Success = 2] = "Success", o[o.Underflow = 3] = "Underflow", o))($245cd439dbda24ce$export$abf286375dfa6dbd || {}), $245cd439dbda24ce$var$T = ((n)=>(n[n.Previous = -1] = "Previous", n[n.Next = 1] = "Next", n))($245cd439dbda24ce$var$T || {});
function $245cd439dbda24ce$export$433aaa1f216cf32d(e = document.body) {
    return e == null ? [] : Array.from(e.querySelectorAll($245cd439dbda24ce$var$f)).sort((t, n)=>Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $245cd439dbda24ce$export$27112a34f2f8402d = ((n)=>(n[n.Strict = 0] = "Strict", n[n.Loose = 1] = "Loose", n))($245cd439dbda24ce$export$27112a34f2f8402d || {});
function $245cd439dbda24ce$export$ff1ec1c740b3c8d5(e, t = 0) {
    var n;
    return e === ((n = (0, $5I2Bs.getOwnerDocument)(e)) == null ? void 0 : n.body) ? !1 : (0, $7XYnx.match)(t, {
        [0] () {
            return e.matches($245cd439dbda24ce$var$f);
        },
        [1] () {
            let l = e;
            for(; l !== null;){
                if (l.matches($245cd439dbda24ce$var$f)) return !0;
                l = l.parentElement;
            }
            return !1;
        }
    });
}
function $245cd439dbda24ce$export$46388676ec35ab85(e) {
    let t = (0, $5I2Bs.getOwnerDocument)(e);
    (0, $lemPO.disposables)().nextFrame(()=>{
        t && !$245cd439dbda24ce$export$ff1ec1c740b3c8d5(t.activeElement, 0) && $245cd439dbda24ce$export$5fed9cc43865dc7e(e);
    });
}
function $245cd439dbda24ce$export$5fed9cc43865dc7e(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
let $245cd439dbda24ce$var$H = [
    "textarea",
    "input"
].join(",");
function $245cd439dbda24ce$var$w(e) {
    var t, n;
    return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, $245cd439dbda24ce$var$H)) != null ? n : !1;
}
function $245cd439dbda24ce$export$20305e96f91bf103(e, t = (n)=>n) {
    return e.slice().sort((n, l)=>{
        let o = t(n), i = t(l);
        if (o === null || i === null) return 0;
        let r = o.compareDocumentPosition(i);
        return r & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : r & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function $245cd439dbda24ce$export$7fb6c844b485e870(e, t) {
    return $245cd439dbda24ce$export$82e1f4f412218a1d($245cd439dbda24ce$export$433aaa1f216cf32d(), t, {
        relativeTo: e
    });
}
function $245cd439dbda24ce$export$82e1f4f412218a1d(e, t, { sorted: n = !0, relativeTo: l = null, skipElements: o = [] } = {}) {
    let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, r = Array.isArray(e) ? n ? $245cd439dbda24ce$export$20305e96f91bf103(e) : e : $245cd439dbda24ce$export$433aaa1f216cf32d(e);
    o.length > 0 && r.length > 1 && (r = r.filter((s)=>!o.includes(s))), l = l != null ? l : i.activeElement;
    let d = (()=>{
        if (t & 5) return 1;
        if (t & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), x = (()=>{
        if (t & 1) return 0;
        if (t & 2) return Math.max(0, r.indexOf(l)) - 1;
        if (t & 4) return Math.max(0, r.indexOf(l)) + 1;
        if (t & 8) return r.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    })(), p = t & 32 ? {
        preventScroll: !0
    } : {}, c = 0, a = r.length, u;
    do {
        if (c >= a || c + a <= 0) return 0;
        let s = x + c;
        if (t & 16) s = (s + a) % a;
        else {
            if (s < 0) return 3;
            if (s >= a) return 1;
        }
        u = r[s], u == null || u.focus(p), c += d;
    }while (u !== i.activeElement);
    return t & 6 && $245cd439dbda24ce$var$w(u) && u.select(), u.hasAttribute("tabindex") || u.setAttribute("tabindex", "0"), 2;
}

});
parcelRegister("lemPO", function(module, exports) {

$parcel$export(module.exports, "disposables", function () { return $f74c9e46c7e777da$export$12b26c28a05aa001; });

var $dhuMb = parcelRequire("dhuMb");
function $f74c9e46c7e777da$export$12b26c28a05aa001() {
    let n = [], r = {
        addEventListener (e, t, s, a) {
            return e.addEventListener(t, s, a), r.add(()=>e.removeEventListener(t, s, a));
        },
        requestAnimationFrame (...e) {
            let t = requestAnimationFrame(...e);
            return r.add(()=>cancelAnimationFrame(t));
        },
        nextFrame (...e) {
            return r.requestAnimationFrame(()=>r.requestAnimationFrame(...e));
        },
        setTimeout (...e) {
            let t = setTimeout(...e);
            return r.add(()=>clearTimeout(t));
        },
        microTask (...e) {
            let t = {
                current: !0
            };
            return (0, $dhuMb.microTask)(()=>{
                t.current && e[0]();
            }), r.add(()=>{
                t.current = !1;
            });
        },
        style (e, t, s) {
            let a = e.style.getPropertyValue(t);
            return Object.assign(e.style, {
                [t]: s
            }), this.add(()=>{
                Object.assign(e.style, {
                    [t]: a
                });
            });
        },
        group (e) {
            let t = $f74c9e46c7e777da$export$12b26c28a05aa001();
            return e(t), this.add(()=>t.dispose());
        },
        add (e) {
            return n.push(e), ()=>{
                let t = n.indexOf(e);
                if (t >= 0) for (let s of n.splice(t, 1))s();
            };
        },
        dispose () {
            for (let e of n.splice(0))e();
        }
    };
    return r;
}

});
parcelRegister("dhuMb", function(module, exports) {

$parcel$export(module.exports, "microTask", function () { return $9ab4bc6951c0d5c7$export$a5ff0d6a738703ca; });
function $9ab4bc6951c0d5c7$export$a5ff0d6a738703ca(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((o)=>setTimeout(()=>{
            throw o;
        }));
}

});


parcelRegister("5I2Bs", function(module, exports) {

$parcel$export(module.exports, "getOwnerDocument", function () { return $0112a15dd107070b$export$b204af158042fbac; });

var $g8hvJ = parcelRequire("g8hvJ");
function $0112a15dd107070b$export$b204af158042fbac(r) {
    return (0, $g8hvJ.env).isServer ? null : r instanceof Node ? r.ownerDocument : r != null && r.hasOwnProperty("current") && r.current instanceof Node ? r.current.ownerDocument : document;
}

});


parcelRegister("eFrTh", function(module, exports) {

$parcel$export(module.exports, "Direction", function () { return $aada8784f2c75502$export$cacd6541cfeeb6c1; });
$parcel$export(module.exports, "useTabDirection", function () { return $aada8784f2c75502$export$19b797546aece48f; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $hkXHT = parcelRequire("hkXHT");
var $aada8784f2c75502$export$cacd6541cfeeb6c1 = ((r)=>(r[r.Forwards = 0] = "Forwards", r[r.Backwards = 1] = "Backwards", r))($aada8784f2c75502$export$cacd6541cfeeb6c1 || {});
function $aada8784f2c75502$export$19b797546aece48f() {
    let e = (0, $kLOUX.useRef)(0);
    return (0, $hkXHT.useWindowEvent)("keydown", (o)=>{
        o.key === "Tab" && (e.current = o.shiftKey ? 1 : 0);
    }, !0), e;
}

});
parcelRegister("hkXHT", function(module, exports) {

$parcel$export(module.exports, "useWindowEvent", function () { return $c9f29e7bcab04909$export$ee579bb285b8d4aa; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $5Y7iv = parcelRequire("5Y7iv");
function $c9f29e7bcab04909$export$ee579bb285b8d4aa(e, r, n) {
    let o = (0, $5Y7iv.useLatestValue)(r);
    (0, $kLOUX.useEffect)(()=>{
        function t(i) {
            o.current(i);
        }
        return window.addEventListener(e, t, n), ()=>window.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}

});


parcelRegister("5iAri", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", function () { return $3dbae64474ba0a4f$export$80c2a3957bcb42ea; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $frj70 = parcelRequire("frj70");
function $3dbae64474ba0a4f$export$80c2a3957bcb42ea() {
    let e = (0, $kLOUX.useRef)(!1);
    return (0, $frj70.useIsoMorphicEffect)(()=>(e.current = !0, ()=>{
            e.current = !1;
        }), []), e;
}

});

parcelRegister("6RICz", function(module, exports) {

$parcel$export(module.exports, "useOwnerDocument", function () { return $4ffa4e28dcc7cb27$export$dd9fbcea3de0ae36; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $5I2Bs = parcelRequire("5I2Bs");
function $4ffa4e28dcc7cb27$export$dd9fbcea3de0ae36(...e) {
    return (0, $kLOUX.useMemo)(()=>(0, $5I2Bs.getOwnerDocument)(...e), [
        ...e
    ]);
}

});

parcelRegister("6ldDn", function(module, exports) {

$parcel$export(module.exports, "useEventListener", function () { return $49df47ab3826fd88$export$7080b3e976bc91ab; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $5Y7iv = parcelRequire("5Y7iv");
function $49df47ab3826fd88$export$7080b3e976bc91ab(n, e, a, t) {
    let i = (0, $5Y7iv.useLatestValue)(a);
    (0, $kLOUX.useEffect)(()=>{
        n = n != null ? n : window;
        function r(o) {
            i.current(o);
        }
        return n.addEventListener(e, r, t), ()=>n.removeEventListener(e, r, t);
    }, [
        n,
        e,
        t
    ]);
}

});

parcelRegister("cLDcY", function(module, exports) {

$parcel$export(module.exports, "useWatch", function () { return $94b849c80854a995$export$3c773aa2b84f29e0; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $i4ILg = parcelRequire("i4ILg");
function $94b849c80854a995$export$3c773aa2b84f29e0(u, t) {
    let e = (0, $kLOUX.useRef)([]), r = (0, $i4ILg.useEvent)(u);
    (0, $kLOUX.useEffect)(()=>{
        let o = [
            ...e.current
        ];
        for (let [n, a] of t.entries())if (e.current[n] !== a) {
            let l = r(t, o);
            return e.current = t, l;
        }
    }, [
        r,
        ...t
    ]);
}

});

parcelRegister("fczrW", function(module, exports) {

$parcel$export(module.exports, "useDisposables", function () { return $b113799678477ff6$export$fd183955ff4b45d9; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $lemPO = parcelRequire("lemPO");
function $b113799678477ff6$export$fd183955ff4b45d9() {
    let [e] = (0, $kLOUX.useState)((0, $lemPO.disposables));
    return (0, $kLOUX.useEffect)(()=>()=>e.dispose(), [
        e
    ]), e;
}

});


parcelRegister("9IJj8", function(module, exports) {

$parcel$export(module.exports, "Portal", function () { return $713b5e48c3a1e82a$export$602eac185826482c; });
parcelRequire("gsMHG");
var $bRFDG = parcelRequire("bRFDG");
var $gsMHG = parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $gsMHG = parcelRequire("gsMHG");

var $ex6pY = parcelRequire("ex6pY");

var $frj70 = parcelRequire("frj70");

var $bdYzg = parcelRequire("bdYzg");

var $5hRNE = parcelRequire("5hRNE");

var $8jGWf = parcelRequire("8jGWf");

var $6RICz = parcelRequire("6RICz");

var $dhuMb = parcelRequire("dhuMb");

var $g8hvJ = parcelRequire("g8hvJ");
function $713b5e48c3a1e82a$var$H(u) {
    let a = (0, $bdYzg.usePortalRoot)(), o = (0, $kLOUX.useContext)($713b5e48c3a1e82a$var$c), e = (0, $6RICz.useOwnerDocument)(u), [l, n] = (0, $kLOUX.useState)(()=>{
        if (!a && o !== null || (0, $g8hvJ.env).isServer) return null;
        let t = e == null ? void 0 : e.getElementById("headlessui-portal-root");
        if (t) return t;
        if (e === null) return null;
        let r = e.createElement("div");
        return r.setAttribute("id", "headlessui-portal-root"), e.body.appendChild(r);
    });
    return (0, $kLOUX.useEffect)(()=>{
        l !== null && (e != null && e.body.contains(l) || e == null || e.body.appendChild(l));
    }, [
        l,
        e
    ]), (0, $kLOUX.useEffect)(()=>{
        a || o !== null && n(o.current);
    }, [
        o,
        n,
        a
    ]), l;
}
let $713b5e48c3a1e82a$var$O = (0, $bRFDG.Fragment);
function $713b5e48c3a1e82a$var$_(u, a) {
    let o = u, e = (0, $kLOUX.useRef)(null), l = (0, $8jGWf.useSyncRefs)((0, $8jGWf.optionalRef)((p)=>{
        e.current = p;
    }), a), n = (0, $6RICz.useOwnerDocument)(e), t = $713b5e48c3a1e82a$var$H(e), [r] = (0, $kLOUX.useState)(()=>{
        var p;
        return (0, $g8hvJ.env).isServer ? null : (p = n == null ? void 0 : n.createElement("div")) != null ? p : null;
    }), y = (0, $5hRNE.useServerHandoffComplete)(), f = (0, $kLOUX.useRef)(!1);
    return (0, $frj70.useIsoMorphicEffect)(()=>{
        if (f.current = !1, !(!t || !r)) return t.contains(r) || (r.setAttribute("data-headlessui-portal", ""), t.appendChild(r)), ()=>{
            f.current = !0, (0, $dhuMb.microTask)(()=>{
                var p;
                f.current && (!t || !r || (r instanceof Node && t.contains(r) && t.removeChild(r), t.childNodes.length <= 0 && ((p = t.parentElement) == null || p.removeChild(t))));
            });
        };
    }, [
        t,
        r
    ]), y ? !t || !r ? null : (0, $gsMHG.createPortal)((0, $ex6pY.render)({
        ourProps: {
            ref: l
        },
        theirProps: o,
        defaultTag: $713b5e48c3a1e82a$var$O,
        name: "Portal"
    }), r) : null;
}
let $713b5e48c3a1e82a$var$F = (0, $bRFDG.Fragment), $713b5e48c3a1e82a$var$c = (0, $bRFDG.createContext)(null);
function $713b5e48c3a1e82a$var$U(u, a) {
    let { target: o, ...e } = u, n = {
        ref: (0, $8jGWf.useSyncRefs)(a)
    };
    return (0, $gsMHG.default).createElement($713b5e48c3a1e82a$var$c.Provider, {
        value: o
    }, (0, $ex6pY.render)({
        ourProps: n,
        theirProps: e,
        defaultTag: $713b5e48c3a1e82a$var$F,
        name: "Popover.Group"
    }));
}
let $713b5e48c3a1e82a$var$S = (0, $ex6pY.forwardRefWithAs)($713b5e48c3a1e82a$var$_), $713b5e48c3a1e82a$var$j = (0, $ex6pY.forwardRefWithAs)($713b5e48c3a1e82a$var$U), $713b5e48c3a1e82a$export$602eac185826482c = Object.assign($713b5e48c3a1e82a$var$S, {
    Group: $713b5e48c3a1e82a$var$j
});

});
parcelRegister("bdYzg", function(module, exports) {

$parcel$export(module.exports, "usePortalRoot", function () { return $82bfe41954c2094e$export$6ecd3efa4eebe261; });
$parcel$export(module.exports, "ForcePortalRoot", function () { return $82bfe41954c2094e$export$8f2af6644e3a3c93; });
parcelRequire("gsMHG");
var $bRFDG = parcelRequire("bRFDG");
var $gsMHG = parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");
let $82bfe41954c2094e$var$e = (0, $bRFDG.createContext)(!1);
function $82bfe41954c2094e$export$6ecd3efa4eebe261() {
    return (0, $kLOUX.useContext)($82bfe41954c2094e$var$e);
}
function $82bfe41954c2094e$export$8f2af6644e3a3c93(o) {
    return (0, $gsMHG.default).createElement($82bfe41954c2094e$var$e.Provider, {
        value: o.force
    }, o.children);
}

});


parcelRegister("7mq8M", function(module, exports) {

$parcel$export(module.exports, "useDescriptions", function () { return $55bedd73110ea26b$export$babde88292020af7; });
$parcel$export(module.exports, "Description", function () { return $55bedd73110ea26b$export$393edc798c47379d; });
parcelRequire("gsMHG");
var $bRFDG = parcelRequire("bRFDG");
var $gsMHG = parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $7yd0N = parcelRequire("7yd0N");

var $ex6pY = parcelRequire("ex6pY");

var $frj70 = parcelRequire("frj70");

var $8jGWf = parcelRequire("8jGWf");

var $i4ILg = parcelRequire("i4ILg");
let $55bedd73110ea26b$var$d = (0, $bRFDG.createContext)(null);
function $55bedd73110ea26b$var$f() {
    let r = (0, $kLOUX.useContext)($55bedd73110ea26b$var$d);
    if (r === null) {
        let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, $55bedd73110ea26b$var$f), t;
    }
    return r;
}
function $55bedd73110ea26b$export$babde88292020af7() {
    let [r, t] = (0, $kLOUX.useState)([]);
    return [
        r.length > 0 ? r.join(" ") : void 0,
        (0, $kLOUX.useMemo)(()=>function(e) {
                let i = (0, $i4ILg.useEvent)((s)=>(t((o)=>[
                            ...o,
                            s
                        ]), ()=>t((o)=>{
                            let p = o.slice(), c = p.indexOf(s);
                            return c !== -1 && p.splice(c, 1), p;
                        }))), n = (0, $kLOUX.useMemo)(()=>({
                        register: i,
                        slot: e.slot,
                        name: e.name,
                        props: e.props
                    }), [
                    i,
                    e.slot,
                    e.name,
                    e.props
                ]);
                return (0, $gsMHG.default).createElement($55bedd73110ea26b$var$d.Provider, {
                    value: n
                }, e.children);
            }, [
            t
        ])
    ];
}
let $55bedd73110ea26b$var$S = "p";
function $55bedd73110ea26b$var$h(r, t) {
    let a = (0, $7yd0N.useId)(), { id: e = `headlessui-description-${a}`, ...i } = r, n = $55bedd73110ea26b$var$f(), s = (0, $8jGWf.useSyncRefs)(t);
    (0, $frj70.useIsoMorphicEffect)(()=>n.register(e), [
        e,
        n.register
    ]);
    let o = {
        ref: s,
        ...n.props,
        id: e
    };
    return (0, $ex6pY.render)({
        ourProps: o,
        theirProps: i,
        slot: n.slot || {},
        defaultTag: $55bedd73110ea26b$var$S,
        name: n.name || "Description"
    });
}
let $55bedd73110ea26b$var$y = (0, $ex6pY.forwardRefWithAs)($55bedd73110ea26b$var$h), $55bedd73110ea26b$export$393edc798c47379d = Object.assign($55bedd73110ea26b$var$y, {});

});

parcelRegister("6A6CF", function(module, exports) {

$parcel$export(module.exports, "State", function () { return $4cab3dfea1b5cb01$export$7254cc27399e90bd; });
$parcel$export(module.exports, "useOpenClosed", function () { return $4cab3dfea1b5cb01$export$fc6fdf0ecf360e; });
$parcel$export(module.exports, "OpenClosedProvider", function () { return $4cab3dfea1b5cb01$export$2a0ed818b175f558; });
parcelRequire("gsMHG");
var $bRFDG = parcelRequire("bRFDG");
var $gsMHG = parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");
let $4cab3dfea1b5cb01$var$n = (0, $bRFDG.createContext)(null);
$4cab3dfea1b5cb01$var$n.displayName = "OpenClosedContext";
var $4cab3dfea1b5cb01$export$7254cc27399e90bd = ((e)=>(e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))($4cab3dfea1b5cb01$export$7254cc27399e90bd || {});
function $4cab3dfea1b5cb01$export$fc6fdf0ecf360e() {
    return (0, $kLOUX.useContext)($4cab3dfea1b5cb01$var$n);
}
function $4cab3dfea1b5cb01$export$2a0ed818b175f558({ value: o, children: r }) {
    return (0, $gsMHG.default).createElement($4cab3dfea1b5cb01$var$n.Provider, {
        value: o
    }, r);
}

});

parcelRegister("7fkaP", function(module, exports) {

$parcel$export(module.exports, "StackMessage", function () { return $5469952eb31bcad8$export$2dd25ef07fea092e; });
$parcel$export(module.exports, "StackProvider", function () { return $5469952eb31bcad8$export$4aac1a6640027f56; });
parcelRequire("gsMHG");
var $bRFDG = parcelRequire("bRFDG");
var $gsMHG = parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $frj70 = parcelRequire("frj70");

var $i4ILg = parcelRequire("i4ILg");
let $5469952eb31bcad8$var$a = (0, $bRFDG.createContext)(()=>{});
$5469952eb31bcad8$var$a.displayName = "StackContext";
var $5469952eb31bcad8$export$2dd25ef07fea092e = ((e)=>(e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))($5469952eb31bcad8$export$2dd25ef07fea092e || {});
function $5469952eb31bcad8$export$59510f5936c4d8c4() {
    return (0, $kLOUX.useContext)($5469952eb31bcad8$var$a);
}
function $5469952eb31bcad8$export$4aac1a6640027f56({ children: i, onUpdate: r, type: e, element: n, enabled: u }) {
    let l = $5469952eb31bcad8$export$59510f5936c4d8c4(), o = (0, $i4ILg.useEvent)((...t)=>{
        r == null || r(...t), l(...t);
    });
    return (0, $frj70.useIsoMorphicEffect)(()=>{
        let t = u === void 0 || u === !0;
        return t && o(0, e, n), ()=>{
            t && o(1, e, n);
        };
    }, [
        o,
        e,
        n,
        u
    ]), (0, $gsMHG.default).createElement($5469952eb31bcad8$var$a.Provider, {
        value: o
    }, i);
}

});

parcelRegister("efwez", function(module, exports) {

$parcel$export(module.exports, "useOutsideClick", function () { return $a5fb7867c02495be$export$71b2224f1ce5e08e; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $37yyp = parcelRequire("37yyp");

var $4Bwe5 = parcelRequire("4Bwe5");
function $a5fb7867c02495be$export$71b2224f1ce5e08e(m, E, c = !0) {
    let i = (0, $kLOUX.useRef)(!1);
    (0, $kLOUX.useEffect)(()=>{
        requestAnimationFrame(()=>{
            i.current = c;
        });
    }, [
        c
    ]);
    function f(e, o) {
        if (!i.current || e.defaultPrevented) return;
        let l = function r(t) {
            return typeof t == "function" ? r(t()) : Array.isArray(t) || t instanceof Set ? t : [
                t
            ];
        }(m), n = o(e);
        if (n !== null && n.getRootNode().contains(n)) {
            for (let r of l){
                if (r === null) continue;
                let t = r instanceof HTMLElement ? r : r.current;
                if (t != null && t.contains(n) || e.composed && e.composedPath().includes(t)) return;
            }
            return !(0, $37yyp.isFocusableElement)(n, (0, $37yyp.FocusableMode).Loose) && n.tabIndex !== -1 && e.preventDefault(), E(e, n);
        }
    }
    let u = (0, $kLOUX.useRef)(null);
    (0, $4Bwe5.useDocumentEvent)("mousedown", (e)=>{
        var o, l;
        i.current && (u.current = ((l = (o = e.composedPath) == null ? void 0 : o.call(e)) == null ? void 0 : l[0]) || e.target);
    }, !0), (0, $4Bwe5.useDocumentEvent)("click", (e)=>{
        u.current && (f(e, ()=>u.current), u.current = null);
    }, !0), (0, $4Bwe5.useDocumentEvent)("blur", (e)=>f(e, ()=>window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}

});
parcelRegister("4Bwe5", function(module, exports) {

$parcel$export(module.exports, "useDocumentEvent", function () { return $35a39d931e07af49$export$55d2b5df396a097b; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $5Y7iv = parcelRequire("5Y7iv");
function $35a39d931e07af49$export$55d2b5df396a097b(e, r, n) {
    let o = (0, $5Y7iv.useLatestValue)(r);
    (0, $kLOUX.useEffect)(()=>{
        function t(u) {
            o.current(u);
        }
        return document.addEventListener(e, t, n), ()=>document.removeEventListener(e, t, n);
    }, [
        e,
        n
    ]);
}

});


parcelRegister("dlO63", function(module, exports) {

$parcel$export(module.exports, "useDocumentOverflowLockedEffect", function () { return $9b8418a908b7a973$export$bb0ae4a42bcd9e0; });

var $frj70 = parcelRequire("frj70");

var $0ReCJ = parcelRequire("0ReCJ");

var $abnjF = parcelRequire("abnjF");
function $9b8418a908b7a973$export$bb0ae4a42bcd9e0(e, r, n) {
    let f = (0, $0ReCJ.useStore)((0, $abnjF.overflows)), o = e ? f.get(e) : void 0, i = o ? o.count > 0 : !1;
    return (0, $frj70.useIsoMorphicEffect)(()=>{
        if (!(!e || !r)) return (0, $abnjF.overflows).dispatch("PUSH", e, n), ()=>(0, $abnjF.overflows).dispatch("POP", e, n);
    }, [
        r,
        e
    ]), i;
}

});
parcelRegister("0ReCJ", function(module, exports) {

$parcel$export(module.exports, "useStore", function () { return $00294b8995dabd58$export$6ccbb43953eebf8; });

var $aK6tX = parcelRequire("aK6tX");
function $00294b8995dabd58$export$6ccbb43953eebf8(t) {
    return (0, $aK6tX.useSyncExternalStore)(t.subscribe, t.getSnapshot, t.getSnapshot);
}

});
parcelRegister("aK6tX", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $7d233a7aa40150fc$export$306c0aa65ff9ec16; });

var $gsMHG = parcelRequire("gsMHG");

var $4U3Ol = parcelRequire("4U3Ol");

var $d7qJF = parcelRequire("d7qJF");
const $7d233a7aa40150fc$var$r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", $7d233a7aa40150fc$var$s = !$7d233a7aa40150fc$var$r, $7d233a7aa40150fc$var$c = $7d233a7aa40150fc$var$s ? (0, $d7qJF.useSyncExternalStore) : (0, $4U3Ol.useSyncExternalStore), $7d233a7aa40150fc$export$306c0aa65ff9ec16 = "useSyncExternalStore" in $gsMHG ? ((n)=>n.useSyncExternalStore)($gsMHG) : $7d233a7aa40150fc$var$c;

});
parcelRegister("4U3Ol", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $391f592e6c55081a$export$306c0aa65ff9ec16; });

var $gsMHG = parcelRequire("gsMHG");
function $391f592e6c55081a$var$i(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const $391f592e6c55081a$var$d = typeof Object.is == "function" ? Object.is : $391f592e6c55081a$var$i, { useState: $391f592e6c55081a$var$u, useEffect: $391f592e6c55081a$var$h, useLayoutEffect: $391f592e6c55081a$var$f, useDebugValue: $391f592e6c55081a$var$p } = $gsMHG;
let $391f592e6c55081a$var$S = !1, $391f592e6c55081a$var$_ = !1;
function $391f592e6c55081a$export$306c0aa65ff9ec16(e, t, c) {
    const a = t(), [{ inst: n }, o] = $391f592e6c55081a$var$u({
        inst: {
            value: a,
            getSnapshot: t
        }
    });
    return $391f592e6c55081a$var$f(()=>{
        n.value = a, n.getSnapshot = t, $391f592e6c55081a$var$r(n) && o({
            inst: n
        });
    }, [
        e,
        a,
        t
    ]), $391f592e6c55081a$var$h(()=>($391f592e6c55081a$var$r(n) && o({
            inst: n
        }), e(()=>{
            $391f592e6c55081a$var$r(n) && o({
                inst: n
            });
        })), [
        e
    ]), $391f592e6c55081a$var$p(a), a;
}
function $391f592e6c55081a$var$r(e) {
    const t = e.getSnapshot, c = e.value;
    try {
        const a = t();
        return !$391f592e6c55081a$var$d(c, a);
    } catch  {
        return !0;
    }
}

});

parcelRegister("d7qJF", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $98d0aaf096a28947$export$306c0aa65ff9ec16; });
function $98d0aaf096a28947$export$306c0aa65ff9ec16(r, e, n) {
    return e();
}

});



parcelRegister("abnjF", function(module, exports) {

$parcel$export(module.exports, "overflows", function () { return $769d048f8e099359$export$a4161f418919b5aa; });

var $lemPO = parcelRequire("lemPO");

var $ipoN0 = parcelRequire("ipoN0");

var $jMbNz = parcelRequire("jMbNz");

var $jYodI = parcelRequire("jYodI");

var $jZkgr = parcelRequire("jZkgr");
function $769d048f8e099359$var$m(e) {
    let n = {};
    for (let t of e)Object.assign(n, t(n));
    return n;
}
let $769d048f8e099359$export$a4161f418919b5aa = (0, $ipoN0.createStore)(()=>new Map, {
    PUSH (e, n) {
        var o;
        let t = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: (0, $lemPO.disposables)(),
            meta: new Set
        };
        return t.count++, t.meta.add(n), this.set(e, t), this;
    },
    POP (e, n) {
        let t = this.get(e);
        return t && (t.count--, t.meta.delete(n)), this;
    },
    SCROLL_PREVENT ({ doc: e, d: n, meta: t }) {
        let o = {
            doc: e,
            d: n,
            meta: $769d048f8e099359$var$m(t)
        }, c = [
            (0, $jYodI.handleIOSLocking)(),
            (0, $jMbNz.adjustScrollbarPadding)(),
            (0, $jZkgr.preventScroll)()
        ];
        c.forEach(({ before: r })=>r == null ? void 0 : r(o)), c.forEach(({ after: r })=>r == null ? void 0 : r(o));
    },
    SCROLL_ALLOW ({ d: e }) {
        e.dispose();
    },
    TEARDOWN ({ doc: e }) {
        this.delete(e);
    }
});
$769d048f8e099359$export$a4161f418919b5aa.subscribe(()=>{
    let e = $769d048f8e099359$export$a4161f418919b5aa.getSnapshot(), n = new Map;
    for (let [t] of e)n.set(t, t.documentElement.style.overflow);
    for (let t of e.values()){
        let o = n.get(t.doc) === "hidden", c = t.count !== 0;
        (c && !o || !c && o) && $769d048f8e099359$export$a4161f418919b5aa.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && $769d048f8e099359$export$a4161f418919b5aa.dispatch("TEARDOWN", t);
    }
});

});
parcelRegister("ipoN0", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $d66dca721241d787$export$f51a9068ac82ea43; });
function $d66dca721241d787$export$f51a9068ac82ea43(o, r) {
    let t = o(), n = new Set;
    return {
        getSnapshot () {
            return t;
        },
        subscribe (e) {
            return n.add(e), ()=>n.delete(e);
        },
        dispatch (e, ...s) {
            let i = r[e].call(t, ...s);
            i && (t = i, n.forEach((c)=>c()));
        }
    };
}

});

parcelRegister("jMbNz", function(module, exports) {

$parcel$export(module.exports, "adjustScrollbarPadding", function () { return $e65ba6eeb84612ad$export$110627fb35ef9205; });
function $e65ba6eeb84612ad$export$110627fb35ef9205() {
    let o;
    return {
        before ({ doc: e }) {
            var l;
            let n = e.documentElement;
            o = ((l = e.defaultView) != null ? l : window).innerWidth - n.clientWidth;
        },
        after ({ doc: e, d: n }) {
            let t = e.documentElement, l = t.clientWidth - t.offsetWidth, r = o - l;
            n.style(t, "paddingRight", `${r}px`);
        }
    };
}

});

parcelRegister("jYodI", function(module, exports) {

$parcel$export(module.exports, "handleIOSLocking", function () { return $e8a6688e1c53f2ee$export$e3a523dfabf27286; });

var $aOCLc = parcelRequire("aOCLc");
function $e8a6688e1c53f2ee$export$e3a523dfabf27286() {
    if (!(0, $aOCLc.isIOS)()) return {};
    let o;
    return {
        before () {
            o = window.pageYOffset;
        },
        after ({ doc: r, d: l, meta: s }) {
            function i(e) {
                return s.containers.flatMap((t)=>t()).some((t)=>t.contains(e));
            }
            l.style(r.body, "marginTop", `-${o}px`), window.scrollTo(0, 0);
            let n = null;
            l.addEventListener(r, "click", (e)=>{
                if (e.target instanceof HTMLElement) try {
                    let t = e.target.closest("a");
                    if (!t) return;
                    let { hash: c } = new URL(t.href), a = r.querySelector(c);
                    a && !i(a) && (n = a);
                } catch  {}
            }, !0), l.addEventListener(r, "touchmove", (e)=>{
                e.target instanceof HTMLElement && !i(e.target) && e.preventDefault();
            }, {
                passive: !1
            }), l.add(()=>{
                window.scrollTo(0, window.pageYOffset + o), n && n.isConnected && (n.scrollIntoView({
                    block: "nearest"
                }), n = null);
            });
        }
    };
}

});
parcelRegister("aOCLc", function(module, exports) {

$parcel$export(module.exports, "isIOS", function () { return $7dfca3dda3c9556c$export$fedb369cb70207f1; });
$parcel$export(module.exports, "isMobile", function () { return $7dfca3dda3c9556c$export$d0a8044dce8ff2fc; });
function $7dfca3dda3c9556c$export$fedb369cb70207f1() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function $7dfca3dda3c9556c$export$a11b0059900ceec8() {
    return /Android/gi.test(window.navigator.userAgent);
}
function $7dfca3dda3c9556c$export$d0a8044dce8ff2fc() {
    return $7dfca3dda3c9556c$export$fedb369cb70207f1() || $7dfca3dda3c9556c$export$a11b0059900ceec8();
}

});


parcelRegister("jZkgr", function(module, exports) {

$parcel$export(module.exports, "preventScroll", function () { return $e8d36ee007cfe63b$export$d8b6ff28805e84e9; });
function $e8d36ee007cfe63b$export$d8b6ff28805e84e9() {
    return {
        before ({ doc: e, d: o }) {
            o.style(e.documentElement, "overflow", "hidden");
        }
    };
}

});



parcelRegister("5XK7S", function(module, exports) {

$parcel$export(module.exports, "useInert", function () { return $45763e21569e65d4$export$bbe4e2927a3450da; });

var $frj70 = parcelRequire("frj70");
let $45763e21569e65d4$var$u = new Map, $45763e21569e65d4$var$t = new Map;
function $45763e21569e65d4$export$bbe4e2927a3450da(r, l = !0) {
    (0, $frj70.useIsoMorphicEffect)(()=>{
        var o;
        if (!l) return;
        let e = typeof r == "function" ? r() : r.current;
        if (!e) return;
        function a() {
            var d;
            if (!e) return;
            let i = (d = $45763e21569e65d4$var$t.get(e)) != null ? d : 1;
            if (i === 1 ? $45763e21569e65d4$var$t.delete(e) : $45763e21569e65d4$var$t.set(e, i - 1), i !== 1) return;
            let n = $45763e21569e65d4$var$u.get(e);
            n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, $45763e21569e65d4$var$u.delete(e));
        }
        let f = (o = $45763e21569e65d4$var$t.get(e)) != null ? o : 0;
        return $45763e21569e65d4$var$t.set(e, f + 1), f !== 0 || ($45763e21569e65d4$var$u.set(e, {
            "aria-hidden": e.getAttribute("aria-hidden"),
            inert: e.inert
        }), e.setAttribute("aria-hidden", "true"), e.inert = !0), a;
    }, [
        r,
        l
    ]);
}

});


parcelRegister("fijwX", function(module, exports) {

$parcel$export(module.exports, "Transition", function () { return $b227afd55e8c5db7$export$be58926105124dd4; });
parcelRequire("gsMHG");
var $bRFDG = parcelRequire("bRFDG");
var $gsMHG = parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $ex6pY = parcelRequire("ex6pY");

var $6A6CF = parcelRequire("6A6CF");

var $7XYnx = parcelRequire("7XYnx");

var $5iAri = parcelRequire("5iAri");

var $frj70 = parcelRequire("frj70");

var $5Y7iv = parcelRequire("5Y7iv");

var $5hRNE = parcelRequire("5hRNE");

var $8jGWf = parcelRequire("8jGWf");

var $dxFlg = parcelRequire("dxFlg");

var $i4ILg = parcelRequire("i4ILg");

var $fczrW = parcelRequire("fczrW");

var $kfLTU = parcelRequire("kfLTU");

var $g8hvJ = parcelRequire("g8hvJ");

var $6UaE8 = parcelRequire("6UaE8");
function $b227afd55e8c5db7$var$S(n = "") {
    return n.split(" ").filter((t)=>t.trim().length > 1);
}
let $b227afd55e8c5db7$var$A = (0, $bRFDG.createContext)(null);
$b227afd55e8c5db7$var$A.displayName = "TransitionContext";
var $b227afd55e8c5db7$var$Ee = ((r)=>(r.Visible = "visible", r.Hidden = "hidden", r))($b227afd55e8c5db7$var$Ee || {});
function $b227afd55e8c5db7$var$be() {
    let n = (0, $kLOUX.useContext)($b227afd55e8c5db7$var$A);
    if (n === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return n;
}
function $b227afd55e8c5db7$var$Se() {
    let n = (0, $kLOUX.useContext)($b227afd55e8c5db7$var$I);
    if (n === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return n;
}
let $b227afd55e8c5db7$var$I = (0, $bRFDG.createContext)(null);
$b227afd55e8c5db7$var$I.displayName = "NestingContext";
function $b227afd55e8c5db7$var$_(n) {
    return "children" in n ? $b227afd55e8c5db7$var$_(n.children) : n.current.filter(({ el: t })=>t.current !== null).filter(({ state: t })=>t === "visible").length > 0;
}
function $b227afd55e8c5db7$var$ne(n, t) {
    let r = (0, $5Y7iv.useLatestValue)(n), o = (0, $kLOUX.useRef)([]), y = (0, $5iAri.useIsMounted)(), N = (0, $fczrW.useDisposables)(), p = (0, $i4ILg.useEvent)((s, e = (0, $ex6pY.RenderStrategy).Hidden)=>{
        let a = o.current.findIndex(({ el: i })=>i === s);
        a !== -1 && ((0, $7XYnx.match)(e, {
            [(0, $ex6pY.RenderStrategy).Unmount] () {
                o.current.splice(a, 1);
            },
            [(0, $ex6pY.RenderStrategy).Hidden] () {
                o.current[a].state = "hidden";
            }
        }), N.microTask(()=>{
            var i;
            !$b227afd55e8c5db7$var$_(o) && y.current && ((i = r.current) == null || i.call(r));
        }));
    }), x = (0, $i4ILg.useEvent)((s)=>{
        let e = o.current.find(({ el: a })=>a === s);
        return e ? e.state !== "visible" && (e.state = "visible") : o.current.push({
            el: s,
            state: "visible"
        }), ()=>p(s, (0, $ex6pY.RenderStrategy).Unmount);
    }), m = (0, $kLOUX.useRef)([]), c = (0, $kLOUX.useRef)(Promise.resolve()), u = (0, $kLOUX.useRef)({
        enter: [],
        leave: [],
        idle: []
    }), h = (0, $i4ILg.useEvent)((s, e, a)=>{
        m.current.splice(0), t && (t.chains.current[e] = t.chains.current[e].filter(([i])=>i !== s)), t == null || t.chains.current[e].push([
            s,
            new Promise((i)=>{
                m.current.push(i);
            })
        ]), t == null || t.chains.current[e].push([
            s,
            new Promise((i)=>{
                Promise.all(u.current[e].map(([l, T])=>T)).then(()=>i());
            })
        ]), e === "enter" ? c.current = c.current.then(()=>t == null ? void 0 : t.wait.current).then(()=>a(e)) : a(e);
    }), v = (0, $i4ILg.useEvent)((s, e, a)=>{
        Promise.all(u.current[e].splice(0).map(([i, l])=>l)).then(()=>{
            var i;
            (i = m.current.shift()) == null || i();
        }).then(()=>a(e));
    });
    return (0, $kLOUX.useMemo)(()=>({
            children: o,
            register: x,
            unregister: p,
            onStart: h,
            onStop: v,
            wait: c,
            chains: u
        }), [
        x,
        p,
        o,
        h,
        v,
        u,
        c
    ]);
}
function $b227afd55e8c5db7$var$xe() {}
let $b227afd55e8c5db7$var$Pe = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function $b227afd55e8c5db7$var$re(n) {
    var r;
    let t = {};
    for (let o of $b227afd55e8c5db7$var$Pe)t[o] = (r = n[o]) != null ? r : $b227afd55e8c5db7$var$xe;
    return t;
}
function $b227afd55e8c5db7$var$Re(n) {
    let t = (0, $kLOUX.useRef)($b227afd55e8c5db7$var$re(n));
    return (0, $kLOUX.useEffect)(()=>{
        t.current = $b227afd55e8c5db7$var$re(n);
    }, [
        n
    ]), t;
}
let $b227afd55e8c5db7$var$ye = "div", $b227afd55e8c5db7$var$ie = (0, $ex6pY.Features).RenderStrategy;
function $b227afd55e8c5db7$var$Ne(n, t) {
    let { beforeEnter: r, afterEnter: o, beforeLeave: y, afterLeave: N, enter: p, enterFrom: x, enterTo: m, entered: c, leave: u, leaveFrom: h, leaveTo: v, ...s } = n, e = (0, $kLOUX.useRef)(null), a = (0, $8jGWf.useSyncRefs)(e, t), i = s.unmount ? (0, $ex6pY.RenderStrategy).Unmount : (0, $ex6pY.RenderStrategy).Hidden, { show: l, appear: T, initial: se } = $b227afd55e8c5db7$var$be(), [g, M] = (0, $kLOUX.useState)(l ? "visible" : "hidden"), z = $b227afd55e8c5db7$var$Se(), { register: F, unregister: L } = z, U = (0, $kLOUX.useRef)(null);
    (0, $kLOUX.useEffect)(()=>F(e), [
        F,
        e
    ]), (0, $kLOUX.useEffect)(()=>{
        if (i === (0, $ex6pY.RenderStrategy).Hidden && e.current) {
            if (l && g !== "visible") {
                M("visible");
                return;
            }
            return (0, $7XYnx.match)(g, {
                ["hidden"]: ()=>L(e),
                ["visible"]: ()=>F(e)
            });
        }
    }, [
        g,
        e,
        F,
        L,
        l,
        i
    ]);
    let j = (0, $5Y7iv.useLatestValue)({
        enter: $b227afd55e8c5db7$var$S(p),
        enterFrom: $b227afd55e8c5db7$var$S(x),
        enterTo: $b227afd55e8c5db7$var$S(m),
        entered: $b227afd55e8c5db7$var$S(c),
        leave: $b227afd55e8c5db7$var$S(u),
        leaveFrom: $b227afd55e8c5db7$var$S(h),
        leaveTo: $b227afd55e8c5db7$var$S(v)
    }), w = $b227afd55e8c5db7$var$Re({
        beforeEnter: r,
        afterEnter: o,
        beforeLeave: y,
        afterLeave: N
    }), k = (0, $5hRNE.useServerHandoffComplete)();
    (0, $kLOUX.useEffect)(()=>{
        if (k && g === "visible" && e.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        e,
        g,
        k
    ]);
    let G = se && !T, ae = (()=>!k || G || U.current === l ? "idle" : l ? "enter" : "leave")(), H = (0, $6UaE8.useFlags)(0), le = (0, $i4ILg.useEvent)((C)=>(0, $7XYnx.match)(C, {
            enter: ()=>{
                H.addFlag((0, $6A6CF.State).Opening), w.current.beforeEnter();
            },
            leave: ()=>{
                H.addFlag((0, $6A6CF.State).Closing), w.current.beforeLeave();
            },
            idle: ()=>{}
        })), ue = (0, $i4ILg.useEvent)((C)=>(0, $7XYnx.match)(C, {
            enter: ()=>{
                H.removeFlag((0, $6A6CF.State).Opening), w.current.afterEnter();
            },
            leave: ()=>{
                H.removeFlag((0, $6A6CF.State).Closing), w.current.afterLeave();
            },
            idle: ()=>{}
        })), O = $b227afd55e8c5db7$var$ne(()=>{
        M("hidden"), L(e);
    }, z);
    (0, $dxFlg.useTransition)({
        container: e,
        classes: j,
        direction: ae,
        onStart: (0, $5Y7iv.useLatestValue)((C)=>{
            O.onStart(e, C, le);
        }),
        onStop: (0, $5Y7iv.useLatestValue)((C)=>{
            O.onStop(e, C, ue), C === "leave" && !$b227afd55e8c5db7$var$_(O) && (M("hidden"), L(e));
        })
    }), (0, $kLOUX.useEffect)(()=>{
        G && (i === (0, $ex6pY.RenderStrategy).Hidden ? U.current = null : U.current = l);
    }, [
        l,
        G,
        g
    ]);
    let B = s, Te = {
        ref: a
    };
    return T && l && (0, $g8hvJ.env).isServer && (B = {
        ...B,
        className: (0, $kfLTU.classNames)(s.className, ...j.current.enter, ...j.current.enterFrom)
    }), (0, $gsMHG.default).createElement($b227afd55e8c5db7$var$I.Provider, {
        value: O
    }, (0, $gsMHG.default).createElement((0, $6A6CF.OpenClosedProvider), {
        value: (0, $7XYnx.match)(g, {
            ["visible"]: (0, $6A6CF.State).Open,
            ["hidden"]: (0, $6A6CF.State).Closed
        }) | H.flags
    }, (0, $ex6pY.render)({
        ourProps: Te,
        theirProps: B,
        defaultTag: $b227afd55e8c5db7$var$ye,
        features: $b227afd55e8c5db7$var$ie,
        visible: g === "visible",
        name: "Transition.Child"
    })));
}
function $b227afd55e8c5db7$var$He(n, t) {
    let { show: r, appear: o = !1, unmount: y, ...N } = n, p = (0, $kLOUX.useRef)(null), x = (0, $8jGWf.useSyncRefs)(p, t);
    (0, $5hRNE.useServerHandoffComplete)();
    let m = (0, $6A6CF.useOpenClosed)();
    if (r === void 0 && m !== null && (r = (m & (0, $6A6CF.State).Open) === (0, $6A6CF.State).Open), ![
        !0,
        !1
    ].includes(r)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    let [c, u] = (0, $kLOUX.useState)(r ? "visible" : "hidden"), h = $b227afd55e8c5db7$var$ne(()=>{
        u("hidden");
    }), [v, s] = (0, $kLOUX.useState)(!0), e = (0, $kLOUX.useRef)([
        r
    ]);
    (0, $frj70.useIsoMorphicEffect)(()=>{
        v !== !1 && e.current[e.current.length - 1] !== r && (e.current.push(r), s(!1));
    }, [
        e,
        r
    ]);
    let a = (0, $kLOUX.useMemo)(()=>({
            show: r,
            appear: o,
            initial: v
        }), [
        r,
        o,
        v
    ]);
    (0, $kLOUX.useEffect)(()=>{
        if (r) u("visible");
        else if (!$b227afd55e8c5db7$var$_(h)) u("hidden");
        else {
            let l = p.current;
            if (!l) return;
            let T = l.getBoundingClientRect();
            T.x === 0 && T.y === 0 && T.width === 0 && T.height === 0 && u("hidden");
        }
    }, [
        r,
        h
    ]);
    let i = {
        unmount: y
    };
    return (0, $gsMHG.default).createElement($b227afd55e8c5db7$var$I.Provider, {
        value: h
    }, (0, $gsMHG.default).createElement($b227afd55e8c5db7$var$A.Provider, {
        value: a
    }, (0, $ex6pY.render)({
        ourProps: {
            ...i,
            as: (0, $bRFDG.Fragment),
            children: (0, $gsMHG.default).createElement($b227afd55e8c5db7$var$oe, {
                ref: x,
                ...i,
                ...N
            })
        },
        theirProps: {},
        defaultTag: (0, $bRFDG.Fragment),
        features: $b227afd55e8c5db7$var$ie,
        visible: c === "visible",
        name: "Transition"
    })));
}
function $b227afd55e8c5db7$var$De(n, t) {
    let r = (0, $kLOUX.useContext)($b227afd55e8c5db7$var$A) !== null, o = (0, $6A6CF.useOpenClosed)() !== null;
    return (0, $gsMHG.default).createElement((0, $gsMHG.default).Fragment, null, !r && o ? (0, $gsMHG.default).createElement($b227afd55e8c5db7$var$q, {
        ref: t,
        ...n
    }) : (0, $gsMHG.default).createElement($b227afd55e8c5db7$var$oe, {
        ref: t,
        ...n
    }));
}
let $b227afd55e8c5db7$var$q = (0, $ex6pY.forwardRefWithAs)($b227afd55e8c5db7$var$He), $b227afd55e8c5db7$var$oe = (0, $ex6pY.forwardRefWithAs)($b227afd55e8c5db7$var$Ne), $b227afd55e8c5db7$var$Fe = (0, $ex6pY.forwardRefWithAs)($b227afd55e8c5db7$var$De), $b227afd55e8c5db7$export$be58926105124dd4 = Object.assign($b227afd55e8c5db7$var$q, {
    Child: $b227afd55e8c5db7$var$Fe,
    Root: $b227afd55e8c5db7$var$q
});

});
parcelRegister("dxFlg", function(module, exports) {

$parcel$export(module.exports, "useTransition", function () { return $9dbe6d0f677b0e06$export$7b286972b8d8ccbf; });

var $l6qu4 = parcelRequire("l6qu4");

var $lemPO = parcelRequire("lemPO");

var $fczrW = parcelRequire("fczrW");

var $5iAri = parcelRequire("5iAri");

var $frj70 = parcelRequire("frj70");

var $5Y7iv = parcelRequire("5Y7iv");
function $9dbe6d0f677b0e06$export$7b286972b8d8ccbf({ container: i, direction: t, classes: o, onStart: s, onStop: u }) {
    let a = (0, $5iAri.useIsMounted)(), c = (0, $fczrW.useDisposables)(), r = (0, $5Y7iv.useLatestValue)(t);
    (0, $frj70.useIsoMorphicEffect)(()=>{
        let e = (0, $lemPO.disposables)();
        c.add(e.dispose);
        let n = i.current;
        if (n && r.current !== "idle" && a.current) return e.dispose(), s.current(r.current), e.add((0, $l6qu4.transition)(n, o.current, r.current === "enter", ()=>{
            e.dispose(), u.current(r.current);
        })), e.dispose;
    }, [
        t
    ]);
}

});
parcelRegister("l6qu4", function(module, exports) {

$parcel$export(module.exports, "transition", function () { return $f5ceb3a92bd1fedb$export$66bb15e2994e6a26; });

var $9knp9 = parcelRequire("9knp9");

var $lemPO = parcelRequire("lemPO");

var $7XYnx = parcelRequire("7XYnx");
function $f5ceb3a92bd1fedb$var$d(t, ...e) {
    t && e.length > 0 && t.classList.add(...e);
}
function $f5ceb3a92bd1fedb$var$v(t, ...e) {
    t && e.length > 0 && t.classList.remove(...e);
}
function $f5ceb3a92bd1fedb$var$F(t, e) {
    let n = (0, $lemPO.disposables)();
    if (!t) return n.dispose;
    let { transitionDuration: m, transitionDelay: o } = getComputedStyle(t), [u, p] = [
        m,
        o
    ].map((a)=>{
        let [r = 0] = a.split(",").filter(Boolean).map((i)=>i.includes("ms") ? parseFloat(i) : parseFloat(i) * 1e3).sort((i, f)=>f - i);
        return r;
    }), l = u + p;
    if (l !== 0) {
        n.group((r)=>{
            r.setTimeout(()=>{
                e(), r.dispose();
            }, l), r.addEventListener(t, "transitionrun", (i)=>{
                i.target === i.currentTarget && r.dispose();
            });
        });
        let a = n.addEventListener(t, "transitionend", (r)=>{
            r.target === r.currentTarget && (e(), a());
        });
    } else e();
    return n.add(()=>e()), n.dispose;
}
function $f5ceb3a92bd1fedb$export$66bb15e2994e6a26(t, e, n, m) {
    let o = n ? "enter" : "leave", u = (0, $lemPO.disposables)(), p = m !== void 0 ? (0, $9knp9.once)(m) : ()=>{};
    o === "enter" && (t.removeAttribute("hidden"), t.style.display = "");
    let l = (0, $7XYnx.match)(o, {
        enter: ()=>e.enter,
        leave: ()=>e.leave
    }), a = (0, $7XYnx.match)(o, {
        enter: ()=>e.enterTo,
        leave: ()=>e.leaveTo
    }), r = (0, $7XYnx.match)(o, {
        enter: ()=>e.enterFrom,
        leave: ()=>e.leaveFrom
    });
    return $f5ceb3a92bd1fedb$var$v(t, ...e.enter, ...e.enterTo, ...e.enterFrom, ...e.leave, ...e.leaveFrom, ...e.leaveTo, ...e.entered), $f5ceb3a92bd1fedb$var$d(t, ...l, ...r), u.nextFrame(()=>{
        $f5ceb3a92bd1fedb$var$v(t, ...r), $f5ceb3a92bd1fedb$var$d(t, ...a), $f5ceb3a92bd1fedb$var$F(t, ()=>($f5ceb3a92bd1fedb$var$v(t, ...l), $f5ceb3a92bd1fedb$var$d(t, ...e.entered), p()));
    }), u.dispose;
}

});
parcelRegister("9knp9", function(module, exports) {

$parcel$export(module.exports, "once", function () { return $6ca822fa51bb09fb$export$d2de3aaeafa91619; });
function $6ca822fa51bb09fb$export$d2de3aaeafa91619(r) {
    let e = {
        called: !1
    };
    return (...t)=>{
        if (!e.called) return e.called = !0, r(...t);
    };
}

});



parcelRegister("6UaE8", function(module, exports) {

$parcel$export(module.exports, "useFlags", function () { return $50703b2c0d6a8792$export$2879604e6aec4ab; });
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");
function $50703b2c0d6a8792$export$2879604e6aec4ab(g = 0) {
    let [t, l] = (0, $kLOUX.useState)(g), u = (0, $kLOUX.useCallback)((e)=>l((a)=>a | e), [
        t
    ]), n = (0, $kLOUX.useCallback)((e)=>Boolean(t & e), [
        t
    ]), o = (0, $kLOUX.useCallback)((e)=>l((a)=>a & ~e), [
        l
    ]), s = (0, $kLOUX.useCallback)((e)=>l((a)=>a ^ e), [
        l
    ]);
    return {
        flags: t,
        addFlag: u,
        hasFlag: n,
        removeFlag: o,
        toggleFlag: s
    };
}

});


parcelRegister("jTZEy", function(module, exports) {

$parcel$export(module.exports, "backdrop", function () { return $e7d2fa60f37945d1$export$48e901322468f6d5; }, function (v) { return $e7d2fa60f37945d1$export$48e901322468f6d5 = v; });
$parcel$export(module.exports, "backdropEnter", function () { return $e7d2fa60f37945d1$export$ca8e433bc0466c; }, function (v) { return $e7d2fa60f37945d1$export$ca8e433bc0466c = v; });
$parcel$export(module.exports, "backdropEnterFrom", function () { return $e7d2fa60f37945d1$export$9b8a79a07578117; }, function (v) { return $e7d2fa60f37945d1$export$9b8a79a07578117 = v; });
$parcel$export(module.exports, "backdropEnterTo", function () { return $e7d2fa60f37945d1$export$193fe24d3961fe43; }, function (v) { return $e7d2fa60f37945d1$export$193fe24d3961fe43 = v; });
$parcel$export(module.exports, "backdropLeave", function () { return $e7d2fa60f37945d1$export$f617ff663a253bf5; }, function (v) { return $e7d2fa60f37945d1$export$f617ff663a253bf5 = v; });
$parcel$export(module.exports, "backdropLeaveFrom", function () { return $e7d2fa60f37945d1$export$46403bd951c83d8; }, function (v) { return $e7d2fa60f37945d1$export$46403bd951c83d8 = v; });
$parcel$export(module.exports, "backdropLeaveTo", function () { return $e7d2fa60f37945d1$export$34243732c7cf6249; }, function (v) { return $e7d2fa60f37945d1$export$34243732c7cf6249 = v; });
$parcel$export(module.exports, "closeButton", function () { return $e7d2fa60f37945d1$export$efe229eab43a9869; }, function (v) { return $e7d2fa60f37945d1$export$efe229eab43a9869 = v; });
$parcel$export(module.exports, "dialog", function () { return $e7d2fa60f37945d1$export$518824cf31321346; }, function (v) { return $e7d2fa60f37945d1$export$518824cf31321346 = v; });
$parcel$export(module.exports, "dialogPanel", function () { return $e7d2fa60f37945d1$export$f9306679ae517c46; }, function (v) { return $e7d2fa60f37945d1$export$f9306679ae517c46 = v; });
$parcel$export(module.exports, "panelEnter", function () { return $e7d2fa60f37945d1$export$5501e2a6704b8ecc; }, function (v) { return $e7d2fa60f37945d1$export$5501e2a6704b8ecc = v; });
$parcel$export(module.exports, "panelEnterFrom", function () { return $e7d2fa60f37945d1$export$f07a71d51e2e6cb3; }, function (v) { return $e7d2fa60f37945d1$export$f07a71d51e2e6cb3 = v; });
$parcel$export(module.exports, "panelEnterTo", function () { return $e7d2fa60f37945d1$export$2629cc7b6520c639; }, function (v) { return $e7d2fa60f37945d1$export$2629cc7b6520c639 = v; });
$parcel$export(module.exports, "panelLeave", function () { return $e7d2fa60f37945d1$export$1e23203e9582b0b8; }, function (v) { return $e7d2fa60f37945d1$export$1e23203e9582b0b8 = v; });
$parcel$export(module.exports, "panelLeaveFrom", function () { return $e7d2fa60f37945d1$export$435a7349a085fbe0; }, function (v) { return $e7d2fa60f37945d1$export$435a7349a085fbe0 = v; });
$parcel$export(module.exports, "panelLeaveTo", function () { return $e7d2fa60f37945d1$export$fdf15abc0f281d29; }, function (v) { return $e7d2fa60f37945d1$export$fdf15abc0f281d29 = v; });
$parcel$export(module.exports, "wrapper", function () { return $e7d2fa60f37945d1$export$cc74dcc53cfce4eb; }, function (v) { return $e7d2fa60f37945d1$export$cc74dcc53cfce4eb = v; });
var $e7d2fa60f37945d1$export$48e901322468f6d5;
var $e7d2fa60f37945d1$export$ca8e433bc0466c;
var $e7d2fa60f37945d1$export$9b8a79a07578117;
var $e7d2fa60f37945d1$export$193fe24d3961fe43;
var $e7d2fa60f37945d1$export$f617ff663a253bf5;
var $e7d2fa60f37945d1$export$46403bd951c83d8;
var $e7d2fa60f37945d1$export$34243732c7cf6249;
var $e7d2fa60f37945d1$export$efe229eab43a9869;
var $e7d2fa60f37945d1$export$518824cf31321346;
var $e7d2fa60f37945d1$export$f9306679ae517c46;
var $e7d2fa60f37945d1$export$5501e2a6704b8ecc;
var $e7d2fa60f37945d1$export$f07a71d51e2e6cb3;
var $e7d2fa60f37945d1$export$2629cc7b6520c639;
var $e7d2fa60f37945d1$export$1e23203e9582b0b8;
var $e7d2fa60f37945d1$export$435a7349a085fbe0;
var $e7d2fa60f37945d1$export$fdf15abc0f281d29;
var $e7d2fa60f37945d1$export$cc74dcc53cfce4eb;
$e7d2fa60f37945d1$export$48e901322468f6d5 = `mKBsCW_backdrop`;
$e7d2fa60f37945d1$export$ca8e433bc0466c = `mKBsCW_backdropEnter`;
$e7d2fa60f37945d1$export$9b8a79a07578117 = `mKBsCW_backdropEnterFrom`;
$e7d2fa60f37945d1$export$193fe24d3961fe43 = `mKBsCW_backdropEnterTo`;
$e7d2fa60f37945d1$export$f617ff663a253bf5 = `mKBsCW_backdropLeave`;
$e7d2fa60f37945d1$export$46403bd951c83d8 = `mKBsCW_backdropLeaveFrom`;
$e7d2fa60f37945d1$export$34243732c7cf6249 = `mKBsCW_backdropLeaveTo`;
$e7d2fa60f37945d1$export$efe229eab43a9869 = `mKBsCW_closeButton`;
$e7d2fa60f37945d1$export$518824cf31321346 = `mKBsCW_dialog`;
$e7d2fa60f37945d1$export$f9306679ae517c46 = `mKBsCW_dialogPanel`;
$e7d2fa60f37945d1$export$5501e2a6704b8ecc = `mKBsCW_panelEnter`;
$e7d2fa60f37945d1$export$f07a71d51e2e6cb3 = `mKBsCW_panelEnterFrom`;
$e7d2fa60f37945d1$export$2629cc7b6520c639 = `mKBsCW_panelEnterTo`;
$e7d2fa60f37945d1$export$1e23203e9582b0b8 = `mKBsCW_panelLeave`;
$e7d2fa60f37945d1$export$435a7349a085fbe0 = `mKBsCW_panelLeaveFrom`;
$e7d2fa60f37945d1$export$fdf15abc0f281d29 = `mKBsCW_panelLeaveTo`;
$e7d2fa60f37945d1$export$cc74dcc53cfce4eb = `mKBsCW_wrapper`;

});


parcelRegister("1JrMM", function(module, exports) {

$parcel$export(module.exports, "PreactView", function () { return $142f8c15b75bdbb4$export$490be749fe04ee8c; });

var $8jWPf = parcelRequire("8jWPf");

var $dM6Pc = parcelRequire("dM6Pc");

var $bRFDG = parcelRequire("bRFDG");

var $04t5A = parcelRequire("04t5A");

var $h6tPy = parcelRequire("h6tPy");
const $142f8c15b75bdbb4$var$fetcher = (...args)=>(0, $h6tPy.api)(...args);
const $142f8c15b75bdbb4$export$490be749fe04ee8c = (0, (/*@__PURE__*/$parcel$interopDefault($dM6Pc))).extend({
    initialize (opts = {}) {
        if (!this.component) throw new TypeError('no preact component specified');
        this._props = opts.props || {};
        // views can be initialized with an existing element or must create their own
        if (!this.el) this.el = document.createElement('div');
    },
    remove () {
        (0, $bRFDG.render)(null, this.el);
        (0, (/*@__PURE__*/$parcel$interopDefault($dM6Pc))).prototype.remove.call(this);
        return this;
    },
    render () {
        const Component = this.component;
        (0, $bRFDG.render)(/*#__PURE__*/ (0, $8jWPf.jsx)((0, $04t5A.SWRConfig), {
            value: {
                fetcher: $142f8c15b75bdbb4$var$fetcher
            },
            children: /*#__PURE__*/ (0, $8jWPf.jsx)(Component, {
                ...this._props
            })
        }), this.el);
        return this;
    }
});

});
parcelRegister("dM6Pc", function(module, exports) {
/*$AMPERSAND_VERSION*/ 
var $kw3w9 = parcelRequire("kw3w9");

var $lEDWI = parcelRequire("lEDWI");

var $iamNK = parcelRequire("iamNK");

var $91FRf = parcelRequire("91FRf");
parcelRequire("bd3QA");

var $akRxj = parcelRequire("akRxj");
parcelRequire("3TXX4");

var $a0MTb = parcelRequire("a0MTb");

var $aMHB4 = parcelRequire("aMHB4");

var $fyYMa = parcelRequire("fyYMa");
parcelRequire("cpUjj");

var $lHBuJ = parcelRequire("lHBuJ");

var $h5CXZ = parcelRequire("h5CXZ");

var $j7xnC = parcelRequire("j7xnC");

var $FGFq0 = parcelRequire("FGFq0");

var $4wcRt = parcelRequire("4wcRt");

var $NwRvq = parcelRequire("NwRvq");
function $a0750d4fc63c389e$var$View(attrs) {
    this.cid = $91FRf('view');
    attrs || (attrs = {});
    var parent = attrs.parent;
    delete attrs.parent;
    $a0750d4fc63c389e$var$BaseState.call(this, attrs, {
        init: false,
        parent: parent
    });
    this.on('change:el', this._handleElementChange, this);
    this._upsertBindings();
    this.template = attrs.template || this.template;
    this._cache.rendered = false; // prep `rendered` derived cache immediately
    this.initialize.apply(this, arguments);
    if (this.autoRender && this.template) this.render();
}
var $a0750d4fc63c389e$var$BaseState = $kw3w9.extend({
    dataTypes: {
        element: {
            set: function(newVal) {
                return {
                    val: newVal,
                    type: newVal instanceof Element ? 'element' : typeof newVal
                };
            },
            compare: function(el1, el2) {
                return el1 === el2;
            }
        },
        collection: {
            set: function(newVal) {
                return {
                    val: newVal,
                    type: newVal && newVal.isCollection ? 'collection' : typeof newVal
                };
            },
            compare: function(currentVal, newVal) {
                return currentVal === newVal;
            }
        }
    },
    props: {
        model: 'state',
        el: 'element',
        collection: 'collection'
    },
    session: {
        _rendered: [
            'boolean',
            true,
            false
        ]
    },
    derived: {
        hasData: {
            deps: [
                'model'
            ],
            fn: function() {
                return !!this.model;
            }
        },
        rendered: {
            deps: [
                '_rendered'
            ],
            fn: function() {
                if (this._rendered) {
                    this.trigger('render', this);
                    return true;
                }
                this.trigger('remove', this);
                return false;
            }
        }
    }
});
$a0750d4fc63c389e$var$View.prototype = Object.create($a0750d4fc63c389e$var$BaseState.prototype);
var $a0750d4fc63c389e$var$queryNoElMsg = 'Query cannot be performed as this.el is not defined. Ensure that the view has been rendered.';
// Set up all inheritable properties and methods.
$akRxj($a0750d4fc63c389e$var$View.prototype, {
    // ## query
    // Get an single element based on CSS selector scoped to this.el
    // if you pass an empty string it return `this.el`.
    // If you pass an element we just return it back.
    // This lets us use `get` to handle cases where users
    // can pass a selector or an already selected element.
    query: function(selector) {
        if (!this.el) throw new Error($a0750d4fc63c389e$var$queryNoElMsg);
        if (!selector) return this.el;
        if (typeof selector === 'string') {
            if ($FGFq0(this.el, selector)) return this.el;
            return this.el.querySelector(selector) || undefined;
        }
        return selector;
    },
    // ## queryAll
    // Returns an array of elements based on CSS selector scoped to this.el
    // if you pass an empty string it return `this.el`. Also includes root
    // element.
    queryAll: function(selector) {
        if (!this.el) throw new Error($a0750d4fc63c389e$var$queryNoElMsg);
        if (!selector) return [
            this.el
        ];
        var res = [];
        if ($FGFq0(this.el, selector)) res.push(this.el);
        return res.concat(Array.prototype.slice.call(this.el.querySelectorAll(selector)));
    },
    // ## queryByHook
    // Convenience method for fetching element by it's `data-hook` attribute.
    // Also tries to match against root element.
    // Also supports matching 'one' of several space separated hooks.
    queryByHook: function(hook) {
        return this.query('[data-hook~="' + hook + '"]');
    },
    // ## queryAllByHook
    // Convenience method for fetching all elements by their's `data-hook` attribute.
    queryAllByHook: function(hook) {
        return this.queryAll('[data-hook~="' + hook + '"]');
    },
    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function() {},
    // **render** is the core function that your view can override. Its job is
    // to populate its element (`this.el`), with the appropriate HTML.
    _render: function() {
        this._upsertBindings();
        this.renderWithTemplate(this);
        this._rendered = true;
        return this;
    },
    // Removes this view by taking the element out of the DOM, and removing any
    // applicable events listeners.
    _remove: function() {
        if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
        this._rendered = false;
        this._downsertBindings();
        return this;
    },
    // Change the view's element (`this.el` property), including event
    // re-delegation.
    _handleElementChange: function(element, delegate) {
        if (this.eventManager) this.eventManager.unbind();
        this.eventManager = $j7xnC(this.el, this);
        this.delegateEvents();
        this._applyBindingsForKey();
        return this;
    },
    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function (e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    // This only works for delegate-able events: not `focus`, `blur`, and
    // not `change`, `submit`, and `reset` in Internet Explorer.
    delegateEvents: function(events) {
        if (!(events || (events = $a0MTb(this, 'events')))) return this;
        this.undelegateEvents();
        for(var key in events)this.eventManager.bind(key, events[key]);
        return this;
    },
    // Clears all callbacks previously bound to the view with `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
        this.eventManager.unbind();
        return this;
    },
    // ## registerSubview
    // Pass it a view. This can be anything with a `remove` method
    registerSubview: function(view) {
        // Storage for our subviews.
        this._subviews = this._subviews || [];
        this._subviews.push(view);
        // set the parent reference if it has not been set
        if (!view.parent) view.parent = this;
        return view;
    },
    // ## renderSubview
    // Pass it a view instance and a container element
    // to render it in. It's `remove` method will be called
    // when the parent view is destroyed.
    renderSubview: function(view, container) {
        if (typeof container === 'string') container = this.query(container);
        if (!container) container = this.el;
        this.registerSubview(view);
        view.render();
        container.appendChild(view.el);
        return view;
    },
    _applyBindingsForKey: function(name) {
        if (!this.el) return;
        var fns = this._parsedBindings.getGrouped(name);
        var item;
        for(item in fns)fns[item].forEach(function(fn) {
            fn(this.el, $NwRvq(this, item), $aMHB4(item.split('.')));
        }, this);
    },
    _initializeBindings: function() {
        if (!this.bindings) return;
        this.on('all', function(eventName) {
            if (eventName.slice(0, 7) === 'change:') this._applyBindingsForKey(eventName.split(':')[1]);
        }, this);
    },
    // ## _initializeSubviews
    // this is called at setup and grabs declared subviews
    _initializeSubviews: function() {
        if (!this.subviews) return;
        for(var item in this.subviews)this._parseSubview(this.subviews[item], item);
    },
    // ## _parseSubview
    // helper for parsing out the subview declaration and registering
    // the `waitFor` if need be.
    _parseSubview: function(subview, name) {
        //backwards compatibility with older versions, when `container` was a valid property (#114)
        if (subview.container) subview.selector = subview.container;
        var opts = this._parseSubviewOpts(subview);
        function action() {
            var el, subview;
            // if not rendered or we can't find our element, stop here.
            if (!this.el || !(el = this.query(opts.selector))) return;
            if (!opts.waitFor || $NwRvq(this, opts.waitFor)) {
                subview = this[name] = opts.prepareView.call(this, el);
                if (!subview.el) this.renderSubview(subview, el);
                else {
                    subview.render();
                    this.registerSubview(subview);
                }
                this.off('change', action);
            }
        }
        // we listen for main `change` items
        this.on('change', action, this);
    },
    // Parses the declarative subview definition.
    // You may overload this method to create your own declarative subview style.
    // You must return an object with members 'selector', 'waitFor' and 'prepareView'.
    // waitFor is trigged on the view 'change' event and so one way to extend the deferred view
    // construction is to add an additional property (props) to the view. Then setting this property
    // will satisfy the waitFor condition. You can then extend the prepareView function to pass in
    // additional data from the parent view. This can allow you to have multi-stage rendering of
    // custom data formats and to declaratively define.
    _parseSubviewOpts: function(subview) {
        var self = this;
        var opts = {
            selector: subview.selector || '[data-hook="' + subview.hook + '"]',
            waitFor: subview.waitFor || '',
            prepareView: subview.prepareView || function() {
                return new subview.constructor({
                    parent: self
                });
            }
        };
        return opts;
    },
    // Shortcut for doing everything we need to do to
    // render and fully replace current root element.
    // Either define a `template` property of your view
    // or pass in a template directly.
    // The template can either be a string or a function.
    // If it's a function it will be passed the `context`
    // argument.
    renderWithTemplate: function(context, templateArg) {
        var template = templateArg || this.template;
        if (!template) throw new Error('Template string or function needed.');
        var newDom = $fyYMa(template) ? template : template.call(this, context || this);
        if ($fyYMa(newDom)) newDom = $iamNK(newDom);
        var parent = this.el && this.el.parentNode;
        if (parent) parent.replaceChild(newDom, this.el);
        if (newDom.nodeName === '#document-fragment') throw new Error('Views can only have one root element, including comment nodes.');
        this.el = newDom;
        return this;
    },
    // ## cacheElements
    // This is a shortcut for adding reference to specific elements within your view for
    // access later. This avoids excessive DOM queries and makes it easier to update
    // your view if your template changes.
    //
    // In your `render` method. Use it like so:
    //
    //     render: function () {
    //       this.basicRender();
    //       this.cacheElements({
    //         pages: '#pages',
    //         chat: '#teamChat',
    //         nav: 'nav#views ul',
    //         me: '#me',
    //         cheatSheet: '#cheatSheet',
    //         omniBox: '#awesomeSauce'
    //       });
    //     }
    //
    // Then later you can access elements by reference like so: `this.pages`, or `this.chat`.
    cacheElements: function(hash) {
        for(var item in hash)this[item] = this.query(hash[item]);
        return this;
    },
    // ## animateRemove
    // Placeholder for if you want to do something special when they're removed.
    // For example fade it out, etc.
    // Any override here should call `.remove()` when done.
    animateRemove: function() {
        this.remove();
    },
    // ## renderCollection
    // Method for rendering a collections with individual views.
    // Just pass it the collection, and the view to use for the items in the
    // collection. The collectionView is returned.
    renderCollection: function(collection, ViewClass, container, opts) {
        var containerEl = typeof container === 'string' ? this.query(container) : container;
        var config = $akRxj({
            collection: collection,
            el: containerEl || this.el,
            view: ViewClass,
            parent: this,
            viewOptions: {
                parent: this
            }
        }, opts);
        var collectionView = new $lEDWI(config);
        collectionView.render();
        return this.registerSubview(collectionView);
    },
    _setRender: function(obj) {
        Object.defineProperty(obj, 'render', {
            get: function() {
                return this._render;
            },
            set: function(fn) {
                this._render = function() {
                    fn.apply(this, arguments);
                    this._rendered = true;
                    return this;
                };
            }
        });
    },
    _setRemove: function(obj) {
        Object.defineProperty(obj, 'remove', {
            get: function() {
                return this._remove;
            },
            set: function(fn) {
                this._remove = function() {
                    fn.apply(this, arguments);
                    this._rendered = false;
                    return this;
                };
            }
        });
    },
    _downsertBindings: function() {
        var parsedBindings = this._parsedBindings;
        if (!this.bindingsSet) return;
        if (this._subviews) {
            $h5CXZ($lHBuJ(this._subviews), 'remove');
            this._subviews = [];
        }
        this.stopListening();
        this.bindingsSet = false;
    },
    _upsertBindings: function(attrs) {
        attrs = attrs || this;
        if (this.bindingsSet) return;
        this._parsedBindings = $4wcRt(this.bindings, this);
        this._initializeBindings();
        if (attrs.el && !this.autoRender) this._handleElementChange();
        this._initializeSubviews();
        this.bindingsSet = true;
    }
});
$a0750d4fc63c389e$var$View.prototype._setRender($a0750d4fc63c389e$var$View.prototype);
$a0750d4fc63c389e$var$View.prototype._setRemove($a0750d4fc63c389e$var$View.prototype);
$a0750d4fc63c389e$var$View.extend = $a0750d4fc63c389e$var$BaseState.extend;
module.exports = $a0750d4fc63c389e$var$View;

});
parcelRegister("lEDWI", function(module, exports) {
/*$AMPERSAND_VERSION*/ 
var $akRxj = parcelRequire("akRxj");

var $h5CXZ = parcelRequire("h5CXZ");

var $bd3QA = parcelRequire("bd3QA");

var $l1UaK = parcelRequire("l1UaK");

var $4V7X5 = parcelRequire("4V7X5");

var $cpUjj = parcelRequire("cpUjj");

var $9jqvh = parcelRequire("9jqvh");

var $9MONI = parcelRequire("9MONI");
// options
var $fc3c51db4f31be59$var$options = [
    'collection',
    'el',
    'viewOptions',
    'view',
    'emptyView',
    'filter',
    'reverse',
    'parent'
];
function $fc3c51db4f31be59$var$CollectionView(spec) {
    if (!spec) throw new ReferenceError('Collection view missing required parameters: collection, el');
    if (!spec.collection) throw new ReferenceError('Collection view requires a collection');
    if (!spec.el && !this.insertSelf) throw new ReferenceError('Collection view requires an el');
    $akRxj(this, $bd3QA(spec, $fc3c51db4f31be59$var$options));
    this.views = [];
    this.listenTo(this.collection, 'add', this._addViewForModel);
    this.listenTo(this.collection, 'remove', this._removeViewForModel);
    this.listenTo(this.collection, 'sort', this._rerenderAll);
    this.listenTo(this.collection, 'refresh reset', this._reset);
}
$akRxj($fc3c51db4f31be59$var$CollectionView.prototype, $9jqvh, {
    // for view contract compliance
    render: function() {
        this._renderAll();
        return this;
    },
    remove: function() {
        $h5CXZ(this.views, 'remove');
        this.stopListening();
    },
    _getViewByModel: function(model) {
        return $l1UaK(this.views, function(view) {
            return model === view.model;
        });
    },
    _createViewForModel: function(model, renderOpts) {
        var defaultViewOptions = {
            model: model,
            collection: this.collection,
            parent: this
        };
        var view;
        if (this.view.prototype) view = new this.view($akRxj(defaultViewOptions, this.viewOptions));
        else view = this.view($akRxj(defaultViewOptions, this.viewOptions));
        this.views.push(view);
        view.renderedByParentView = true;
        view.render(renderOpts);
        return view;
    },
    _getOrCreateByModel: function(model, renderOpts) {
        return this._getViewByModel(model) || this._createViewForModel(model, renderOpts);
    },
    _addViewForModel: function(model, collection, options) {
        var matches = this.filter ? this.filter(model) : true;
        if (!matches) return;
        if (this.renderedEmptyView) {
            this._removeView(this.renderedEmptyView);
            delete this.renderedEmptyView;
        }
        var view = this._getOrCreateByModel(model, {
            containerEl: this.el
        });
        if (options && options.rerender) this._insertView(view);
        else this._insertViewAtIndex(view);
    },
    _insertViewAtIndex: function(view) {
        if (!view.insertSelf) {
            var pos = this.collection.indexOf(view.model);
            pos = this.reverse ? pos - 1 : pos + 1;
            var modelToInsertBefore = this.collection.at(pos);
            var viewToInsertBefore = this._getViewByModel(modelToInsertBefore);
            // FIX IE bug (https://developer.mozilla.org/en-US/docs/Web/API/Node.insertBefore)
            // "In Internet Explorer an undefined value as referenceElement will throw errors, while in rest of the modern browsers, this works fine."
            if (viewToInsertBefore) this.el.insertBefore(view.el, viewToInsertBefore && viewToInsertBefore.el);
            else this.el.appendChild(view.el);
        }
    },
    _insertView: function(view) {
        if (!view.insertSelf) {
            if (this.reverse && this.el.firstChild) this.el.insertBefore(view.el, this.el.firstChild);
            else this.el.appendChild(view.el);
        }
    },
    _removeViewForModel: function(model) {
        var view = this._getViewByModel(model);
        if (!view) return;
        var index = this.views.indexOf(view);
        if (index !== -1) {
            // remove it if we found it calling animateRemove
            // to give user option of gracefully destroying.
            view = this.views.splice(index, 1)[0];
            this._removeView(view);
            this._renderEmptyView();
        }
    },
    _removeView: function(view) {
        if (view.animateRemove) view.animateRemove();
        else view.remove();
    },
    _renderAll: function() {
        this.collection.each($cpUjj(this._addViewForModel, this));
        this._renderEmptyView();
    },
    _rerenderAll: function(collection, options) {
        options = options || {};
        this.collection.each($cpUjj(function(model) {
            this._addViewForModel(model, this, $akRxj(options, {
                rerender: true
            }));
        }, this));
    },
    _renderEmptyView: function() {
        if (this.views.length === 0 && this.emptyView && !this.renderedEmptyView) {
            this.renderedEmptyView = new this.emptyView({
                parent: this
            });
            this.el.appendChild(this.renderedEmptyView.render().el);
        }
    },
    _reset: function() {
        var newViews = this.collection.map($cpUjj(this._getOrCreateByModel, this));
        //Remove existing views from the ui
        var toRemove = $4V7X5(this.views, newViews);
        toRemove.forEach(this._removeView, this);
        //Rerender the full list with the new views
        this.views = newViews;
        this._rerenderAll();
        this._renderEmptyView();
    }
});
$fc3c51db4f31be59$var$CollectionView.extend = $9MONI;
module.exports = $fc3c51db4f31be59$var$CollectionView;

});
parcelRegister("bd3QA", function(module, exports) {

var $1O4PB = parcelRequire("1O4PB");

var $4MPSK = parcelRequire("4MPSK");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $8293e4968bf71da9$var$pick = $4MPSK(function(object, paths) {
    return object == null ? {} : $1O4PB(object, paths);
});
module.exports = $8293e4968bf71da9$var$pick;

});
parcelRegister("1O4PB", function(module, exports) {

var $cZ4Gn = parcelRequire("cZ4Gn");

var $72SqL = parcelRequire("72SqL");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $150e3554981c34bf$var$basePick(object, paths) {
    return $cZ4Gn(object, paths, function(value, path) {
        return $72SqL(object, path);
    });
}
module.exports = $150e3554981c34bf$var$basePick;

});
parcelRegister("cZ4Gn", function(module, exports) {

var $bgK8G = parcelRequire("bgK8G");

var $lOdf9 = parcelRequire("lOdf9");

var $2n45k = parcelRequire("2n45k");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $973ed06487cf3368$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $bgK8G(object, path);
        if (predicate(value, path)) $lOdf9(result, $2n45k(path, object), value);
    }
    return result;
}
module.exports = $973ed06487cf3368$var$basePickBy;

});



parcelRegister("9MONI", function(module, exports) {

var $akRxj = parcelRequire("akRxj");
/// Following code is largely pasted from Backbone.js
// Helper function to correctly set up the prototype chain, for subclasses.
// Similar to `goog.inherits`, but uses a hash of prototype properties and
// class properties to be extended.
var $720000b8b6c238a4$var$extend = function(protoProps) {
    var parent = this;
    var child;
    var args = [].slice.call(arguments);
    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && protoProps.hasOwnProperty('constructor')) child = protoProps.constructor;
    else child = function() {
        return parent.apply(this, arguments);
    };
    // Add static properties to the constructor function from parent
    $akRxj(child, parent);
    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function() {
        this.constructor = child;
    };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate();
    // Mix in all prototype properties to the subclass if supplied.
    if (protoProps) {
        args.unshift(child.prototype);
        $akRxj.apply(null, args);
    }
    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;
    return child;
};
// Expose the extend function
module.exports = $720000b8b6c238a4$var$extend;

});


parcelRegister("iamNK", function(module, exports) {
/**
 * Expose `parse`.
 */ module.exports = $d39ad90f6a4d899f$var$parse;
/**
 * Tests for browser support.
 */ var $d39ad90f6a4d899f$var$innerHTMLBug = false;
var $d39ad90f6a4d899f$var$bugTestDiv;
if (typeof document !== 'undefined') {
    $d39ad90f6a4d899f$var$bugTestDiv = document.createElement('div');
    // Setup
    $d39ad90f6a4d899f$var$bugTestDiv.innerHTML = '  <link/><table></table><a href="/a">a</a><input type="checkbox"/>';
    // Make sure that link elements get serialized correctly by innerHTML
    // This requires a wrapper element in IE
    $d39ad90f6a4d899f$var$innerHTMLBug = !$d39ad90f6a4d899f$var$bugTestDiv.getElementsByTagName('link').length;
    $d39ad90f6a4d899f$var$bugTestDiv = undefined;
}
/**
 * Wrap map from jquery.
 */ var $d39ad90f6a4d899f$var$map = {
    legend: [
        1,
        '<fieldset>',
        '</fieldset>'
    ],
    tr: [
        2,
        '<table><tbody>',
        '</tbody></table>'
    ],
    col: [
        2,
        '<table><tbody></tbody><colgroup>',
        '</colgroup></table>'
    ],
    // for script/link/style tags to work in IE6-8, you have to wrap
    // in a div with a non-whitespace character in front, ha!
    _default: $d39ad90f6a4d899f$var$innerHTMLBug ? [
        1,
        'X<div>',
        '</div>'
    ] : [
        0,
        '',
        ''
    ]
};
$d39ad90f6a4d899f$var$map.td = $d39ad90f6a4d899f$var$map.th = [
    3,
    '<table><tbody><tr>',
    '</tr></tbody></table>'
];
$d39ad90f6a4d899f$var$map.option = $d39ad90f6a4d899f$var$map.optgroup = [
    1,
    '<select multiple="multiple">',
    '</select>'
];
$d39ad90f6a4d899f$var$map.thead = $d39ad90f6a4d899f$var$map.tbody = $d39ad90f6a4d899f$var$map.colgroup = $d39ad90f6a4d899f$var$map.caption = $d39ad90f6a4d899f$var$map.tfoot = [
    1,
    '<table>',
    '</table>'
];
$d39ad90f6a4d899f$var$map.polyline = $d39ad90f6a4d899f$var$map.ellipse = $d39ad90f6a4d899f$var$map.polygon = $d39ad90f6a4d899f$var$map.circle = $d39ad90f6a4d899f$var$map.text = $d39ad90f6a4d899f$var$map.line = $d39ad90f6a4d899f$var$map.path = $d39ad90f6a4d899f$var$map.rect = $d39ad90f6a4d899f$var$map.g = [
    1,
    '<svg xmlns="http://www.w3.org/2000/svg" version="1.1">',
    '</svg>'
];
/**
 * Parse `html` and return a DOM Node instance, which could be a TextNode,
 * HTML DOM Node of some kind (<div> for example), or a DocumentFragment
 * instance, depending on the contents of the `html` string.
 *
 * @param {String} html - HTML string to "domify"
 * @param {Document} doc - The `document` instance to create the Node for
 * @return {DOMNode} the TextNode, DOM Node, or DocumentFragment instance
 * @api private
 */ function $d39ad90f6a4d899f$var$parse(html, doc) {
    if ('string' != typeof html) throw new TypeError('String expected');
    // default to the global `document` object
    if (!doc) doc = document;
    // tag name
    var m = /<([\w:]+)/.exec(html);
    if (!m) return doc.createTextNode(html);
    html = html.replace(/^\s+|\s+$/g, ''); // Remove leading/trailing whitespace
    var tag = m[1];
    // body support
    if (tag == 'body') {
        var el = doc.createElement('html');
        el.innerHTML = html;
        return el.removeChild(el.lastChild);
    }
    // wrap map
    var wrap = $d39ad90f6a4d899f$var$map[tag] || $d39ad90f6a4d899f$var$map._default;
    var depth = wrap[0];
    var prefix = wrap[1];
    var suffix = wrap[2];
    var el = doc.createElement('div');
    el.innerHTML = prefix + html + suffix;
    while(depth--)el = el.lastChild;
    // one element
    if (el.firstChild == el.lastChild) return el.removeChild(el.firstChild);
    // several elements
    var fragment = doc.createDocumentFragment();
    while(el.firstChild)fragment.appendChild(el.removeChild(el.firstChild));
    return fragment;
}

});

parcelRegister("j7xnC", function(module, exports) {
/**
 * Module dependencies.
 */ 
var $jdOns = parcelRequire("jdOns");

var $c2vZy = parcelRequire("c2vZy");
var $deb89058046245be$var$forceCaptureEvents = [
    'focus',
    'blur'
];
/**
 * Expose `Events`.
 */ module.exports = $deb89058046245be$var$Events;
/**
 * Initialize an `Events` with the given
 * `el` object which events will be bound to,
 * and the `obj` which will receive method calls.
 *
 * @param {Object} el
 * @param {Object} obj
 * @api public
 */ function $deb89058046245be$var$Events(el, obj) {
    if (!(this instanceof $deb89058046245be$var$Events)) return new $deb89058046245be$var$Events(el, obj);
    if (!el) throw new Error('element required');
    if (!obj) throw new Error('object required');
    this.el = el;
    this.obj = obj;
    this._events = {};
}
/**
 * Subscription helper.
 */ $deb89058046245be$var$Events.prototype.sub = function(event, method, cb) {
    this._events[event] = this._events[event] || {};
    this._events[event][method] = cb;
};
/**
 * Bind to `event` with optional `method` name.
 * When `method` is undefined it becomes `event`
 * with the "on" prefix.
 *
 * Examples:
 *
 *  Direct event handling:
 *
 *    events.bind('click') // implies "onclick"
 *    events.bind('click', 'remove')
 *    events.bind('click', 'sort', 'asc')
 *
 *  Delegated event handling:
 *
 *    events.bind('click li > a')
 *    events.bind('click li > a', 'remove')
 *    events.bind('click a.sort-ascending', 'sort', 'asc')
 *    events.bind('click a.sort-descending', 'sort', 'desc')
 *
 *  Multiple events handling:
 *
 *    events.bind({
 *      'click .remove': 'remove',
 *      'click .add': 'add'
 *    });
 *
 * @param {String|object} - object is used for multiple binding,
 *                               string for single event binding
 * @param {String|function} [arg2] - method to call (optional)
 * @param {*} [arg3] - data for single event binding (optional)
 * @return {Function} callback
 * @api public
 */ $deb89058046245be$var$Events.prototype.bind = function(arg1, arg2) {
    var bindEvent = function(event, method) {
        var e = $deb89058046245be$var$parse(event);
        var el = this.el;
        var obj = this.obj;
        var name = e.name;
        var method = method || 'on' + name;
        var args = [].slice.call(arguments, 2);
        // callback
        function cb() {
            var a = [].slice.call(arguments).concat(args);
            if (typeof method === 'function') {
                method.apply(obj, a);
                return;
            }
            if (!obj[method]) throw new Error(method + ' method is not defined');
            else obj[method].apply(obj, a);
        }
        // bind
        if (e.selector) cb = $c2vZy.bind(el, e.selector, name, cb);
        else $jdOns.bind(el, name, cb);
        // subscription for unbinding
        this.sub(name, method, cb);
        return cb;
    };
    if (typeof arg1 == 'string') bindEvent.apply(this, arguments);
    else {
        for(var key in arg1)if (arg1.hasOwnProperty(key)) bindEvent.call(this, key, arg1[key]);
    }
};
/**
 * Unbind a single binding, all bindings for `event`,
 * or all bindings within the manager.
 *
 * Examples:
 *
 *  Unbind direct handlers:
 *
 *     events.unbind('click', 'remove')
 *     events.unbind('click')
 *     events.unbind()
 *
 * Unbind delegate handlers:
 *
 *     events.unbind('click', 'remove')
 *     events.unbind('click')
 *     events.unbind()
 *
 * @param {String|Function} [event]
 * @param {String|Function} [method]
 * @api public
 */ $deb89058046245be$var$Events.prototype.unbind = function(event, method) {
    if (0 == arguments.length) return this.unbindAll();
    if (1 == arguments.length) return this.unbindAllOf(event);
    // no bindings for this event
    var bindings = this._events[event];
    var capture = $deb89058046245be$var$forceCaptureEvents.indexOf(event) !== -1;
    if (!bindings) return;
    // no bindings for this method
    var cb = bindings[method];
    if (!cb) return;
    $jdOns.unbind(this.el, event, cb, capture);
};
/**
 * Unbind all events.
 *
 * @api private
 */ $deb89058046245be$var$Events.prototype.unbindAll = function() {
    for(var event in this._events)this.unbindAllOf(event);
};
/**
 * Unbind all events for `event`.
 *
 * @param {String} event
 * @api private
 */ $deb89058046245be$var$Events.prototype.unbindAllOf = function(event) {
    var bindings = this._events[event];
    if (!bindings) return;
    for(var method in bindings)this.unbind(event, method);
};
/**
 * Parse `event`.
 *
 * @param {String} event
 * @return {Object}
 * @api private
 */ function $deb89058046245be$var$parse(event) {
    var parts = event.split(/ +/);
    return {
        name: parts.shift(),
        selector: parts.join(' ')
    };
}

});
parcelRegister("jdOns", function(module, exports) {

$parcel$export(module.exports, "bind", function () { return $dfe64f1b16e50995$export$2385a24977818dd0; }, function (v) { return $dfe64f1b16e50995$export$2385a24977818dd0 = v; });
$parcel$export(module.exports, "unbind", function () { return $dfe64f1b16e50995$export$433e98592e7124fd; }, function (v) { return $dfe64f1b16e50995$export$433e98592e7124fd = v; });
/**
 * Bind `el` event `type` to `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */ var $dfe64f1b16e50995$export$2385a24977818dd0;
/**
 * Unbind `el` event `type`'s callback `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */ var $dfe64f1b16e50995$export$433e98592e7124fd;
var $dfe64f1b16e50995$var$bind = window.addEventListener ? 'addEventListener' : 'attachEvent', $dfe64f1b16e50995$var$unbind = window.removeEventListener ? 'removeEventListener' : 'detachEvent', $dfe64f1b16e50995$var$prefix = $dfe64f1b16e50995$var$bind !== 'addEventListener' ? 'on' : '';
$dfe64f1b16e50995$export$2385a24977818dd0 = function(el, type, fn, capture) {
    el[$dfe64f1b16e50995$var$bind]($dfe64f1b16e50995$var$prefix + type, fn, capture || false);
    return fn;
};
$dfe64f1b16e50995$export$433e98592e7124fd = function(el, type, fn, capture) {
    el[$dfe64f1b16e50995$var$unbind]($dfe64f1b16e50995$var$prefix + type, fn, capture || false);
    return fn;
};

});

parcelRegister("c2vZy", function(module, exports) {

$parcel$export(module.exports, "bind", function () { return $8c3e7cdab7bd3c7d$export$2385a24977818dd0; }, function (v) { return $8c3e7cdab7bd3c7d$export$2385a24977818dd0 = v; });
/**
 * Module dependencies.
 */ var $8c3e7cdab7bd3c7d$export$2385a24977818dd0;
/**
 * Unbind event `type`'s callback `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @api public
 */ var $8c3e7cdab7bd3c7d$export$433e98592e7124fd;

var $iHZ7O = parcelRequire("iHZ7O");

var $jdOns = parcelRequire("jdOns");
/**
 * Delegate event `type` to `selector`
 * and invoke `fn(e)`. A callback function
 * is returned which may be passed to `.unbind()`.
 *
 * @param {Element} el
 * @param {String} selector
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */ // Some events don't bubble, so we want to bind to the capture phase instead
// when delegating.
var $8c3e7cdab7bd3c7d$var$forceCaptureEvents = [
    'focus',
    'blur'
];
$8c3e7cdab7bd3c7d$export$2385a24977818dd0 = function(el, selector, type, fn, capture) {
    if ($8c3e7cdab7bd3c7d$var$forceCaptureEvents.indexOf(type) !== -1) capture = true;
    return $jdOns.bind(el, type, function(e) {
        var target = e.target || e.srcElement;
        e.delegateTarget = $iHZ7O(target, selector, true, el);
        if (e.delegateTarget) fn.call(el, e);
    }, capture);
};
$8c3e7cdab7bd3c7d$export$433e98592e7124fd = function(el, type, fn, capture) {
    if ($8c3e7cdab7bd3c7d$var$forceCaptureEvents.indexOf(type) !== -1) capture = true;
    $jdOns.unbind(el, type, fn, capture);
};

});
parcelRegister("iHZ7O", function(module, exports) {

var $gou9X = parcelRequire("gou9X");
module.exports = function(element, selector, checkYoSelf) {
    var parent = checkYoSelf ? element : element.parentNode;
    while(parent && parent !== document){
        if ($gou9X(parent, selector)) return parent;
        parent = parent.parentNode;
    }
};

});
parcelRegister("gou9X", function(module, exports) {
/**
 * Element prototype.
 */ var $bef648517493989d$var$proto = Element.prototype;
/**
 * Vendor function.
 */ var $bef648517493989d$var$vendor = $bef648517493989d$var$proto.matchesSelector || $bef648517493989d$var$proto.webkitMatchesSelector || $bef648517493989d$var$proto.mozMatchesSelector || $bef648517493989d$var$proto.msMatchesSelector || $bef648517493989d$var$proto.oMatchesSelector;
/**
 * Expose `match()`.
 */ module.exports = $bef648517493989d$var$match;
/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */ function $bef648517493989d$var$match(el, selector) {
    if ($bef648517493989d$var$vendor) return $bef648517493989d$var$vendor.call(el, selector);
    var nodes = el.parentNode.querySelectorAll(selector);
    for(var i = 0; i < nodes.length; ++i){
        if (nodes[i] == el) return true;
    }
    return false;
}

});




parcelRegister("FGFq0", function(module, exports) {
'use strict';
var $07d4ed3c48c4eb2f$var$proto = typeof Element !== 'undefined' ? Element.prototype : {};
var $07d4ed3c48c4eb2f$var$vendor = $07d4ed3c48c4eb2f$var$proto.matches || $07d4ed3c48c4eb2f$var$proto.matchesSelector || $07d4ed3c48c4eb2f$var$proto.webkitMatchesSelector || $07d4ed3c48c4eb2f$var$proto.mozMatchesSelector || $07d4ed3c48c4eb2f$var$proto.msMatchesSelector || $07d4ed3c48c4eb2f$var$proto.oMatchesSelector;
module.exports = $07d4ed3c48c4eb2f$var$match;
/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */ function $07d4ed3c48c4eb2f$var$match(el, selector) {
    if (!el || el.nodeType !== 1) return false;
    if ($07d4ed3c48c4eb2f$var$vendor) return $07d4ed3c48c4eb2f$var$vendor.call(el, selector);
    var nodes = el.parentNode.querySelectorAll(selector);
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i] == el) return true;
    }
    return false;
}

});

parcelRegister("4wcRt", function(module, exports) {
/*$AMPERSAND_VERSION*/ 
var $ks7UM = parcelRequire("ks7UM");

var $eIBca = parcelRequire("eIBca");

var $FGFq0 = parcelRequire("FGFq0");

var $8VbaS = parcelRequire("8VbaS");
var $34a4209b2279ba1c$var$slice = Array.prototype.slice;
function $34a4209b2279ba1c$var$getMatches(el, selector, firstOnly) {
    if (selector === '') return [
        el
    ];
    var matches = [];
    if (!selector) return matches;
    if (firstOnly) {
        if ($FGFq0(el, selector)) return [
            el
        ];
        return el.querySelector(selector) ? [
            el.querySelector(selector)
        ] : [];
    } else {
        if ($FGFq0(el, selector)) matches.push(el);
        return matches.concat($34a4209b2279ba1c$var$slice.call(el.querySelectorAll(selector)));
    }
}
function $34a4209b2279ba1c$var$setAttributes(el, attrs) {
    for(var name in attrs)$eIBca.setAttribute(el, name, attrs[name]);
}
function $34a4209b2279ba1c$var$removeAttributes(el, attrs) {
    for(var name in attrs)$eIBca.removeAttribute(el, name);
}
function $34a4209b2279ba1c$var$makeArray(val) {
    return Array.isArray(val) ? val : [
        val
    ];
}
function $34a4209b2279ba1c$var$switchHandler(binding, el, value) {
    // the element selector to show
    var showValue = binding.cases[value];
    var firstMatchOnly = binding.firstMatchOnly;
    // hide all the other elements with a different value
    for(var item in binding.cases){
        var curValue = binding.cases[item];
        if (value !== item && curValue !== showValue) $34a4209b2279ba1c$var$getMatches(el, curValue, firstMatchOnly).forEach(function(match) {
            $eIBca.hide(match);
        });
    }
    $34a4209b2279ba1c$var$getMatches(el, showValue, firstMatchOnly).forEach(function(match) {
        $eIBca.show(match);
    });
}
function $34a4209b2279ba1c$var$getSelector(binding) {
    if (typeof binding.selector === 'string') return binding.selector;
    else if (binding.hook) return '[data-hook~="' + binding.hook + '"]';
    else return '';
}
function $34a4209b2279ba1c$var$getBindingFunc(binding, context) {
    var type = binding.type || 'text';
    var isCustomBinding = typeof type === 'function';
    var selector = $34a4209b2279ba1c$var$getSelector(binding);
    var firstMatchOnly = binding.firstMatchOnly;
    var yes = binding.yes;
    var no = binding.no;
    var hasYesNo = !!(yes || no);
    // storage variable for previous if relevant
    var previousValue;
    if (isCustomBinding) return function(el, value) {
        $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
            type.call(context, match, value, previousValue);
        });
        previousValue = value;
    };
    else if (type === 'text') return function(el, value) {
        $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
            $eIBca.text(match, value);
        });
    };
    else if (type === 'class') return function(el, value) {
        $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
            $eIBca.switchClass(match, previousValue, value);
        });
        previousValue = value;
    };
    else if (type === 'attribute') {
        if (!binding.name) throw Error('attribute bindings must have a "name"');
        return function(el, value) {
            var names = $34a4209b2279ba1c$var$makeArray(binding.name);
            $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
                names.forEach(function(name) {
                    $eIBca.setAttribute(match, name, value);
                });
            });
            previousValue = value;
        };
    } else if (type === 'value') return function(el, value) {
        $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
            if (!value && value !== 0) value = '';
            // only apply bindings if element is not currently focused
            if (document.activeElement !== match) match.value = value;
        });
        previousValue = value;
    };
    else if (type === 'booleanClass') {
        // if there's a `no` case this is actually a switch
        if (hasYesNo) {
            yes = $34a4209b2279ba1c$var$makeArray(yes || '');
            no = $34a4209b2279ba1c$var$makeArray(no || '');
            return function(el, value) {
                var prevClass = value ? no : yes;
                var newClass = value ? yes : no;
                $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
                    prevClass.forEach(function(pc) {
                        $eIBca.removeClass(match, pc);
                    });
                    newClass.forEach(function(nc) {
                        $eIBca.addClass(match, nc);
                    });
                });
            };
        } else return function(el, value, keyName) {
            var name = $34a4209b2279ba1c$var$makeArray(binding.name || keyName);
            var invert = binding.invert || false;
            value = invert ? value ? false : true : value;
            $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
                name.forEach(function(className) {
                    $eIBca[value ? 'addClass' : 'removeClass'](match, className);
                });
            });
        };
    } else if (type === 'booleanAttribute') {
        // if there are `yes` and `no` selectors, this swaps between them
        if (hasYesNo) {
            yes = $34a4209b2279ba1c$var$makeArray(yes || '');
            no = $34a4209b2279ba1c$var$makeArray(no || '');
            return function(el, value) {
                var prevAttribute = value ? no : yes;
                var newAttribute = value ? yes : no;
                $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
                    prevAttribute.forEach(function(pa) {
                        if (pa) $eIBca.removeAttribute(match, pa);
                    });
                    newAttribute.forEach(function(na) {
                        if (na) $eIBca.addAttribute(match, na);
                    });
                });
            };
        } else return function(el, value, keyName) {
            var name = $34a4209b2279ba1c$var$makeArray(binding.name || keyName);
            var invert = binding.invert || false;
            value = invert ? value ? false : true : value;
            $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
                name.forEach(function(attr) {
                    $eIBca[value ? 'addAttribute' : 'removeAttribute'](match, attr);
                });
            });
        };
    } else if (type === 'toggle') {
        var mode = binding.mode || 'display';
        var invert = binding.invert || false;
        // this doesn't require a selector since we can pass yes/no selectors
        if (hasYesNo) return function(el, value) {
            $34a4209b2279ba1c$var$getMatches(el, yes, firstMatchOnly).forEach(function(match) {
                $eIBca[value ? 'show' : 'hide'](match, mode);
            });
            $34a4209b2279ba1c$var$getMatches(el, no, firstMatchOnly).forEach(function(match) {
                $eIBca[value ? 'hide' : 'show'](match, mode);
            });
        };
        else return function(el, value) {
            value = invert ? value ? false : true : value;
            $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
                $eIBca[value ? 'show' : 'hide'](match, mode);
            });
        };
    } else if (type === 'switch') {
        if (!binding.cases) throw Error('switch bindings must have "cases"');
        return $8VbaS($34a4209b2279ba1c$var$switchHandler, binding);
    } else if (type === 'innerHTML') return function(el, value) {
        $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
            $eIBca.html(match, value);
        });
    };
    else if (type === 'switchClass') {
        if (!binding.cases) throw Error('switchClass bindings must have "cases"');
        return function(el, value, keyName) {
            var name = $34a4209b2279ba1c$var$makeArray(binding.name || keyName);
            for(var item in binding.cases)$34a4209b2279ba1c$var$getMatches(el, binding.cases[item], firstMatchOnly).forEach(function(match) {
                name.forEach(function(className) {
                    $eIBca[value === item ? 'addClass' : 'removeClass'](match, className);
                });
            });
        };
    } else if (type === 'switchAttribute') {
        if (!binding.cases) throw Error('switchAttribute bindings must have "cases"');
        return function(el, value, keyName) {
            $34a4209b2279ba1c$var$getMatches(el, selector, firstMatchOnly).forEach(function(match) {
                if (previousValue) $34a4209b2279ba1c$var$removeAttributes(match, previousValue);
                if (value in binding.cases) {
                    var attrs = binding.cases[value];
                    if (typeof attrs === 'string') {
                        attrs = {};
                        attrs[binding.name || keyName] = binding.cases[value];
                    }
                    $34a4209b2279ba1c$var$setAttributes(match, attrs);
                    previousValue = attrs;
                }
            });
        };
    } else throw new Error('no such binding type: ' + type);
}
// returns a key-tree-store of functions
// that can be applied to any element/model.
// all resulting functions should be called
// like func(el, value, lastKeyName)
module.exports = function(bindings, context) {
    var store = new $ks7UM();
    var key, current;
    for(key in bindings){
        current = bindings[key];
        if (typeof current === 'string') store.add(key, $34a4209b2279ba1c$var$getBindingFunc({
            type: 'text',
            selector: current
        }));
        else if (current.forEach) current.forEach(function(binding) {
            store.add(key, $34a4209b2279ba1c$var$getBindingFunc(binding, context));
        });
        else store.add(key, $34a4209b2279ba1c$var$getBindingFunc(current, context));
    }
    return store;
};

});
parcelRegister("eIBca", function(module, exports) {
/*$AMPERSAND_VERSION*/ var $ab7206f2df2f6baa$var$dom = module.exports = {
    text: function(el, val) {
        el.textContent = $ab7206f2df2f6baa$var$getString(val);
    },
    // optimize if we have classList
    addClass: function(el, cls) {
        cls = $ab7206f2df2f6baa$var$getString(cls);
        if (!cls) return;
        if (Array.isArray(cls)) cls.forEach(function(c) {
            $ab7206f2df2f6baa$var$dom.addClass(el, c);
        });
        else if (el.classList) el.classList.add(cls);
        else if (!$ab7206f2df2f6baa$var$hasClass(el, cls)) {
            if (el.classList) el.classList.add(cls);
            else el.className += ' ' + cls;
        }
    },
    removeClass: function(el, cls) {
        if (Array.isArray(cls)) cls.forEach(function(c) {
            $ab7206f2df2f6baa$var$dom.removeClass(el, c);
        });
        else if (el.classList) {
            cls = $ab7206f2df2f6baa$var$getString(cls);
            if (cls) el.classList.remove(cls);
        } else // may be faster to not edit unless we know we have it?
        el.className = el.className.replace(new RegExp('(^|\\b)' + cls.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    },
    hasClass: $ab7206f2df2f6baa$var$hasClass,
    switchClass: function(el, prevCls, newCls) {
        if (prevCls) this.removeClass(el, prevCls);
        this.addClass(el, newCls);
    },
    // makes sure attribute (with no content) is added
    // if exists it will be cleared of content
    addAttribute: function(el, attr) {
        // setting to empty string does same
        el.setAttribute(attr, '');
        // Some browsers won't update UI for boolean attributes unless you
        // set it directly. So we do both
        if ($ab7206f2df2f6baa$var$hasBooleanProperty(el, attr)) el[attr] = true;
    },
    // completely removes attribute
    removeAttribute: function(el, attr) {
        el.removeAttribute(attr);
        if ($ab7206f2df2f6baa$var$hasBooleanProperty(el, attr)) el[attr] = false;
    },
    // sets attribute to string value given, clearing any current value
    setAttribute: function(el, attr, value) {
        el.setAttribute(attr, $ab7206f2df2f6baa$var$getString(value));
    },
    getAttribute: function(el, attr) {
        return el.getAttribute(attr);
    },
    hasAttribute: function(el, attr) {
        return el.hasAttribute(attr);
    },
    hide: function(el, mode) {
        if (!mode) mode = 'display';
        if (!$ab7206f2df2f6baa$var$isHidden(el)) {
            $ab7206f2df2f6baa$var$storeDisplayStyle(el, mode);
            $ab7206f2df2f6baa$var$hide(el, mode);
        }
    },
    // show element
    show: function(el, mode) {
        if (!mode) mode = 'display';
        $ab7206f2df2f6baa$var$show(el, mode);
    },
    toggle: function(el, mode) {
        if (!$ab7206f2df2f6baa$var$isHidden(el)) $ab7206f2df2f6baa$var$dom.hide(el, mode);
        else $ab7206f2df2f6baa$var$dom.show(el, mode);
    },
    html: function(el, content) {
        el.innerHTML = content;
    }
};
// helpers
function $ab7206f2df2f6baa$var$getString(val) {
    if (!val && val !== 0) return '';
    else return val;
}
function $ab7206f2df2f6baa$var$hasClass(el, cls) {
    if (el.classList) return el.classList.contains(cls);
    else return new RegExp('(^| )' + cls + '( |$)', 'gi').test(el.className);
}
function $ab7206f2df2f6baa$var$hasBooleanProperty(el, prop) {
    var val = el[prop];
    return prop in el && (val === true || val === false);
}
function $ab7206f2df2f6baa$var$isHidden(el) {
    return $ab7206f2df2f6baa$var$dom.getAttribute(el, 'data-anddom-hidden') === 'true';
}
function $ab7206f2df2f6baa$var$storeDisplayStyle(el, mode) {
    $ab7206f2df2f6baa$var$dom.setAttribute(el, 'data-anddom-' + mode, el.style[mode]);
}
function $ab7206f2df2f6baa$var$show(el, mode) {
    el.style[mode] = $ab7206f2df2f6baa$var$dom.getAttribute(el, 'data-anddom-' + mode) || '';
    $ab7206f2df2f6baa$var$dom.removeAttribute(el, 'data-anddom-hidden');
}
function $ab7206f2df2f6baa$var$hide(el, mode) {
    $ab7206f2df2f6baa$var$dom.setAttribute(el, 'data-anddom-hidden', 'true');
    el.style[mode] = mode === 'visibility' ? 'hidden' : 'none';
}

});

parcelRegister("8VbaS", function(module, exports) {

var $3YGtA = parcelRequire("3YGtA");

var $IZUSH = parcelRequire("IZUSH");

var $kBMR5 = parcelRequire("kBMR5");

var $PmHWS = parcelRequire("PmHWS");
/** Used to compose bitmasks for function metadata. */ var $67ec509a1436c783$var$WRAP_PARTIAL_FLAG = 32;
/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */ var $67ec509a1436c783$var$partial = $3YGtA(function(func, partials) {
    var holders = $PmHWS(partials, $kBMR5($67ec509a1436c783$var$partial));
    return $IZUSH(func, $67ec509a1436c783$var$WRAP_PARTIAL_FLAG, undefined, partials, holders);
});
// Assign default placeholders.
$67ec509a1436c783$var$partial.placeholder = {};
module.exports = $67ec509a1436c783$var$partial;

});



parcelRegister("04t5A", function(module, exports) {

$parcel$export(module.exports, "SWRConfig", function () { return $00d6f04e5adaca89$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "default", function () { return $00d6f04e5adaca89$export$2e2bcd8739ae039; });
parcelRequire("gsMHG");
var $bRFDG = parcelRequire("bRFDG");
var $kLOUX = parcelRequire("kLOUX");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $00d6f04e5adaca89$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $00d6f04e5adaca89$var$__generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $00d6f04e5adaca89$var$noop = function() {};
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else.  Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var $00d6f04e5adaca89$var$UNDEFINED = /*#__NOINLINE__*/ $00d6f04e5adaca89$var$noop();
var $00d6f04e5adaca89$var$OBJECT = Object;
var $00d6f04e5adaca89$var$isUndefined = function(v) {
    return v === $00d6f04e5adaca89$var$UNDEFINED;
};
var $00d6f04e5adaca89$var$isFunction = function(v) {
    return typeof v == 'function';
};
var $00d6f04e5adaca89$var$mergeObjects = function(a, b) {
    return $00d6f04e5adaca89$var$OBJECT.assign({}, a, b);
};
var $00d6f04e5adaca89$var$STR_UNDEFINED = 'undefined';
// NOTE: Use function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var $00d6f04e5adaca89$var$hasWindow = function() {
    return typeof window != $00d6f04e5adaca89$var$STR_UNDEFINED;
};
var $00d6f04e5adaca89$var$hasDocument = function() {
    return typeof document != $00d6f04e5adaca89$var$STR_UNDEFINED;
};
var $00d6f04e5adaca89$var$hasRequestAnimationFrame = function() {
    return $00d6f04e5adaca89$var$hasWindow() && typeof window['requestAnimationFrame'] != $00d6f04e5adaca89$var$STR_UNDEFINED;
};
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var $00d6f04e5adaca89$var$table = new WeakMap();
// counter of the key
var $00d6f04e5adaca89$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsible.
var $00d6f04e5adaca89$var$stableHash = function(arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if ($00d6f04e5adaca89$var$OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $00d6f04e5adaca89$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$00d6f04e5adaca89$var$counter + '~';
        $00d6f04e5adaca89$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $00d6f04e5adaca89$var$stableHash(arg[index]) + ',';
            $00d6f04e5adaca89$var$table.set(arg, result);
        }
        if (constructor == $00d6f04e5adaca89$var$OBJECT) {
            // Object, sort keys.
            result = '#';
            var keys = $00d6f04e5adaca89$var$OBJECT.keys(arg).sort();
            while(!$00d6f04e5adaca89$var$isUndefined(index = keys.pop()))if (!$00d6f04e5adaca89$var$isUndefined(arg[index])) result += index + ':' + $00d6f04e5adaca89$var$stableHash(arg[index]) + ',';
            $00d6f04e5adaca89$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
/**
 * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a work around, we always assume it's online on first load, and change
 * the status upon `online` or `offline` events.
 */ var $00d6f04e5adaca89$var$online = true;
var $00d6f04e5adaca89$var$isOnline = function() {
    return $00d6f04e5adaca89$var$online;
};
var $00d6f04e5adaca89$var$hasWin = $00d6f04e5adaca89$var$hasWindow();
var $00d6f04e5adaca89$var$hasDoc = $00d6f04e5adaca89$var$hasDocument();
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var $00d6f04e5adaca89$var$onWindowEvent = $00d6f04e5adaca89$var$hasWin && window.addEventListener ? window.addEventListener.bind(window) : $00d6f04e5adaca89$var$noop;
var $00d6f04e5adaca89$var$onDocumentEvent = $00d6f04e5adaca89$var$hasDoc ? document.addEventListener.bind(document) : $00d6f04e5adaca89$var$noop;
var $00d6f04e5adaca89$var$offWindowEvent = $00d6f04e5adaca89$var$hasWin && window.removeEventListener ? window.removeEventListener.bind(window) : $00d6f04e5adaca89$var$noop;
var $00d6f04e5adaca89$var$offDocumentEvent = $00d6f04e5adaca89$var$hasDoc ? document.removeEventListener.bind(document) : $00d6f04e5adaca89$var$noop;
var $00d6f04e5adaca89$var$isVisible = function() {
    var visibilityState = $00d6f04e5adaca89$var$hasDoc && document.visibilityState;
    return $00d6f04e5adaca89$var$isUndefined(visibilityState) || visibilityState !== 'hidden';
};
var $00d6f04e5adaca89$var$initFocus = function(callback) {
    // focus revalidate
    $00d6f04e5adaca89$var$onDocumentEvent('visibilitychange', callback);
    $00d6f04e5adaca89$var$onWindowEvent('focus', callback);
    return function() {
        $00d6f04e5adaca89$var$offDocumentEvent('visibilitychange', callback);
        $00d6f04e5adaca89$var$offWindowEvent('focus', callback);
    };
};
var $00d6f04e5adaca89$var$initReconnect = function(callback) {
    // revalidate on reconnected
    var onOnline = function() {
        $00d6f04e5adaca89$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function() {
        $00d6f04e5adaca89$var$online = false;
    };
    $00d6f04e5adaca89$var$onWindowEvent('online', onOnline);
    $00d6f04e5adaca89$var$onWindowEvent('offline', onOffline);
    return function() {
        $00d6f04e5adaca89$var$offWindowEvent('online', onOnline);
        $00d6f04e5adaca89$var$offWindowEvent('offline', onOffline);
    };
};
var $00d6f04e5adaca89$var$preset = {
    isOnline: $00d6f04e5adaca89$var$isOnline,
    isVisible: $00d6f04e5adaca89$var$isVisible
};
var $00d6f04e5adaca89$var$defaultConfigOptions = {
    initFocus: $00d6f04e5adaca89$var$initFocus,
    initReconnect: $00d6f04e5adaca89$var$initReconnect
};
var $00d6f04e5adaca89$var$IS_SERVER = !$00d6f04e5adaca89$var$hasWindow() || 'Deno' in window;
// Polyfill requestAnimationFrame
var $00d6f04e5adaca89$var$rAF = function(f) {
    return $00d6f04e5adaca89$var$hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var $00d6f04e5adaca89$var$useIsomorphicLayoutEffect = $00d6f04e5adaca89$var$IS_SERVER ? (0, $kLOUX.useEffect) : (0, $kLOUX.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
var $00d6f04e5adaca89$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var $00d6f04e5adaca89$var$slowConnection = !$00d6f04e5adaca89$var$IS_SERVER && $00d6f04e5adaca89$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($00d6f04e5adaca89$var$navigatorConnection.effectiveType) || $00d6f04e5adaca89$var$navigatorConnection.saveData);
var $00d6f04e5adaca89$var$serialize = function(key) {
    if ($00d6f04e5adaca89$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    var args = [].concat(key);
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $00d6f04e5adaca89$var$stableHash(key) : '';
    var infoKey = key ? '$swr$' + key : '';
    return [
        key,
        args,
        infoKey
    ];
};
// Global state used to deduplicate requests and store listeners
var $00d6f04e5adaca89$var$SWRGlobalState = new WeakMap();
var $00d6f04e5adaca89$var$FOCUS_EVENT = 0;
var $00d6f04e5adaca89$var$RECONNECT_EVENT = 1;
var $00d6f04e5adaca89$var$MUTATE_EVENT = 2;
var $00d6f04e5adaca89$var$broadcastState = function(cache, key, data, error, isValidating, revalidate, broadcast) {
    if (broadcast === void 0) broadcast = true;
    var _a = $00d6f04e5adaca89$var$SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], FETCH = _a[3];
    var revalidators = EVENT_REVALIDATORS[key];
    var updaters = STATE_UPDATERS[key];
    // Cache was populated, update states of all hooks.
    if (broadcast && updaters) for(var i = 0; i < updaters.length; ++i)updaters[i](data, error, isValidating);
    // If we also need to revalidate, only do it for the first hook.
    if (revalidate) {
        // Invalidate the key by deleting the concurrent request markers so new
        // requests will not be deduped.
        delete FETCH[key];
        if (revalidators && revalidators[0]) return revalidators[0]($00d6f04e5adaca89$var$MUTATE_EVENT).then(function() {
            return cache.get(key);
        });
    }
    return cache.get(key);
};
// Global timestamp.
var $00d6f04e5adaca89$var$__timestamp = 0;
var $00d6f04e5adaca89$var$getTimestamp = function() {
    return ++$00d6f04e5adaca89$var$__timestamp;
};
var $00d6f04e5adaca89$var$internalMutate = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $00d6f04e5adaca89$var$__awaiter(void 0, void 0, void 0, function() {
        var cache, _key, _data, _opts, options, populateCache, revalidate, rollbackOnError, customOptimisticData, _a, key, keyInfo, _b, MUTATION, data, error, beforeMutationTs, hasCustomOptimisticData, rollbackData, optimisticData, res;
        return $00d6f04e5adaca89$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    cache = args[0], _key = args[1], _data = args[2], _opts = args[3];
                    options = typeof _opts === 'boolean' ? {
                        revalidate: _opts
                    } : _opts || {};
                    populateCache = $00d6f04e5adaca89$var$isUndefined(options.populateCache) ? true : options.populateCache;
                    revalidate = options.revalidate !== false;
                    rollbackOnError = options.rollbackOnError !== false;
                    customOptimisticData = options.optimisticData;
                    _a = $00d6f04e5adaca89$var$serialize(_key), key = _a[0], keyInfo = _a[2];
                    if (!key) return [
                        2 /*return*/ 
                    ];
                    _b = $00d6f04e5adaca89$var$SWRGlobalState.get(cache), MUTATION = _b[2];
                    // If there is no new data provided, revalidate the key with current state.
                    if (args.length < 3) // Revalidate and broadcast state.
                    return [
                        2 /*return*/ ,
                        $00d6f04e5adaca89$var$broadcastState(cache, key, cache.get(key), $00d6f04e5adaca89$var$UNDEFINED, $00d6f04e5adaca89$var$UNDEFINED, revalidate, true)
                    ];
                    data = _data;
                    beforeMutationTs = $00d6f04e5adaca89$var$getTimestamp();
                    MUTATION[key] = [
                        beforeMutationTs,
                        0
                    ];
                    hasCustomOptimisticData = !$00d6f04e5adaca89$var$isUndefined(customOptimisticData);
                    rollbackData = cache.get(key);
                    // Do optimistic data update.
                    if (hasCustomOptimisticData) {
                        optimisticData = $00d6f04e5adaca89$var$isFunction(customOptimisticData) ? customOptimisticData(rollbackData) : customOptimisticData;
                        cache.set(key, optimisticData);
                        $00d6f04e5adaca89$var$broadcastState(cache, key, optimisticData);
                    }
                    if ($00d6f04e5adaca89$var$isFunction(data)) // `data` is a function, call it passing current cache value.
                    try {
                        data = data(cache.get(key));
                    } catch (err) {
                        // If it throws an error synchronously, we shouldn't update the cache.
                        error = err;
                    }
                    if (!(data && $00d6f04e5adaca89$var$isFunction(data.then))) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        data.catch(function(err) {
                            error = err;
                        })
                    ];
                case 1:
                    // This means that the mutation is async, we need to check timestamps to
                    // avoid race conditions.
                    data = _c.sent();
                    // Check if other mutations have occurred since we've started this mutation.
                    // If there's a race we don't update cache or broadcast the change,
                    // just return the data.
                    if (beforeMutationTs !== MUTATION[key][0]) {
                        if (error) throw error;
                        return [
                            2 /*return*/ ,
                            data
                        ];
                    } else if (error && hasCustomOptimisticData && rollbackOnError) {
                        // Rollback. Always populate the cache in this case but without
                        // transforming the data.
                        populateCache = true;
                        data = rollbackData;
                        cache.set(key, rollbackData);
                    }
                    _c.label = 2;
                case 2:
                    // If we should write back the cache after request.
                    if (populateCache) {
                        if (!error) {
                            // Transform the result into data.
                            if ($00d6f04e5adaca89$var$isFunction(populateCache)) data = populateCache(data, rollbackData);
                            // Only update cached data if there's no error. Data can be `undefined` here.
                            cache.set(key, data);
                        }
                        // Always update or reset the error.
                        cache.set(keyInfo, $00d6f04e5adaca89$var$mergeObjects(cache.get(keyInfo), {
                            error: error
                        }));
                    }
                    // Reset the timestamp to mark the mutation has ended.
                    MUTATION[key][1] = $00d6f04e5adaca89$var$getTimestamp();
                    return [
                        4 /*yield*/ ,
                        $00d6f04e5adaca89$var$broadcastState(cache, key, data, error, $00d6f04e5adaca89$var$UNDEFINED, revalidate, !!populateCache)
                    ];
                case 3:
                    res = _c.sent();
                    // Throw error or return data
                    if (error) throw error;
                    return [
                        2 /*return*/ ,
                        populateCache ? res : data
                    ];
            }
        });
    });
};
var $00d6f04e5adaca89$var$revalidateAllKeys = function(revalidators, type) {
    for(var key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
var $00d6f04e5adaca89$var$initCache = function(provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that bound to
    // the cache.
    // Provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$00d6f04e5adaca89$var$SWRGlobalState.has(provider)) {
        var opts = $00d6f04e5adaca89$var$mergeObjects($00d6f04e5adaca89$var$defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS = {};
        var mutate = $00d6f04e5adaca89$var$internalMutate.bind($00d6f04e5adaca89$var$UNDEFINED, provider);
        var unmount = $00d6f04e5adaca89$var$noop;
        // Update the state if it's new, or the provider has been extended.
        $00d6f04e5adaca89$var$SWRGlobalState.set(provider, [
            EVENT_REVALIDATORS,
            {},
            {},
            {},
            mutate
        ]);
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        if (!$00d6f04e5adaca89$var$IS_SERVER) {
            // When listening to the native events for auto revalidations,
            // we intentionally put a delay (setTimeout) here to make sure they are
            // fired after immediate JavaScript executions, which can possibly be
            // React's state updates.
            // This avoids some unnecessary revalidations such as
            // https://github.com/vercel/swr/issues/1680.
            var releaseFocus_1 = opts.initFocus(setTimeout.bind($00d6f04e5adaca89$var$UNDEFINED, $00d6f04e5adaca89$var$revalidateAllKeys.bind($00d6f04e5adaca89$var$UNDEFINED, EVENT_REVALIDATORS, $00d6f04e5adaca89$var$FOCUS_EVENT)));
            var releaseReconnect_1 = opts.initReconnect(setTimeout.bind($00d6f04e5adaca89$var$UNDEFINED, $00d6f04e5adaca89$var$revalidateAllKeys.bind($00d6f04e5adaca89$var$UNDEFINED, EVENT_REVALIDATORS, $00d6f04e5adaca89$var$RECONNECT_EVENT)));
            unmount = function() {
                releaseFocus_1 && releaseFocus_1();
                releaseReconnect_1 && releaseReconnect_1();
                // When un-mounting, we need to remove the cache provider from the state
                // storage too because it's a side-effect. Otherwise when re-mounting we
                // will not re-register those event listeners.
                $00d6f04e5adaca89$var$SWRGlobalState.delete(provider);
            };
        }
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            unmount
        ];
    }
    return [
        provider,
        $00d6f04e5adaca89$var$SWRGlobalState.get(provider)[4]
    ];
};
// error retry
var $00d6f04e5adaca89$var$onErrorRetry = function(_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$00d6f04e5adaca89$var$isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
// Default cache provider
var $00d6f04e5adaca89$var$_a = $00d6f04e5adaca89$var$initCache(new Map()), $00d6f04e5adaca89$var$cache = $00d6f04e5adaca89$var$_a[0], $00d6f04e5adaca89$export$57e795267c26e600 = $00d6f04e5adaca89$var$_a[1];
// Default config
var $00d6f04e5adaca89$var$defaultConfig = $00d6f04e5adaca89$var$mergeObjects({
    // events
    onLoadingSlow: $00d6f04e5adaca89$var$noop,
    onSuccess: $00d6f04e5adaca89$var$noop,
    onError: $00d6f04e5adaca89$var$noop,
    onErrorRetry: $00d6f04e5adaca89$var$onErrorRetry,
    onDiscarded: $00d6f04e5adaca89$var$noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $00d6f04e5adaca89$var$slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $00d6f04e5adaca89$var$slowConnection ? 5000 : 3000,
    // providers
    compare: function(currentData, newData) {
        return $00d6f04e5adaca89$var$stableHash(currentData) == $00d6f04e5adaca89$var$stableHash(newData);
    },
    isPaused: function() {
        return false;
    },
    cache: $00d6f04e5adaca89$var$cache,
    mutate: $00d6f04e5adaca89$export$57e795267c26e600,
    fallback: {}
}, // use web preset by default
$00d6f04e5adaca89$var$preset);
var $00d6f04e5adaca89$var$mergeConfigs = function(a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = $00d6f04e5adaca89$var$mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $00d6f04e5adaca89$var$mergeObjects(f1, f2);
    }
    return v;
};
var $00d6f04e5adaca89$var$SWRConfigContext = (0, $bRFDG.createContext)({});
var $00d6f04e5adaca89$var$SWRConfig$1 = function(props) {
    var value = props.value;
    // Extend parent context values and middleware.
    var extendedConfig = $00d6f04e5adaca89$var$mergeConfigs((0, $kLOUX.useContext)($00d6f04e5adaca89$var$SWRConfigContext), value);
    // Should not use the inherited provider.
    var provider = value && value.provider;
    // Use a lazy initialized state to create the cache on first access.
    var cacheContext = (0, $kLOUX.useState)(function() {
        return provider ? $00d6f04e5adaca89$var$initCache(provider(extendedConfig.cache || $00d6f04e5adaca89$var$cache), value) : $00d6f04e5adaca89$var$UNDEFINED;
    })[0];
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $00d6f04e5adaca89$var$useIsomorphicLayoutEffect(function() {
        return cacheContext ? cacheContext[2] : $00d6f04e5adaca89$var$UNDEFINED;
    }, []);
    return (0, $bRFDG.createElement)($00d6f04e5adaca89$var$SWRConfigContext.Provider, $00d6f04e5adaca89$var$mergeObjects(props, {
        value: extendedConfig
    }));
};
/**
 * An implementation of state with dependency-tracking.
 */ var $00d6f04e5adaca89$var$useStateWithDeps = function(state, unmountedRef) {
    var rerender = (0, $kLOUX.useState)({})[1];
    var stateRef = (0, $kLOUX.useRef)(state);
    // If a state property (data, error or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = (0, $kLOUX.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
     * @param payload To change stateRef, pass the values explicitly to setState:
     * @example
     * ```js
     * setState({
     *   isValidating: false
     *   data: newData // set data to newData
     *   error: undefined // set error to undefined
     * })
     *
     * setState({
     *   isValidating: false
     *   data: undefined // set data to undefined
     *   error: err // set error to err
     * })
     * ```
     */ var setState = (0, $kLOUX.useCallback)(function(payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for(var _ in payload){
            var k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) shouldRerender = true;
            }
        }
        if (shouldRerender && !unmountedRef.current) rerender({});
    }, // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update the state reference.
    $00d6f04e5adaca89$var$useIsomorphicLayoutEffect(function() {
        stateRef.current = state;
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};
var $00d6f04e5adaca89$var$normalize = function(args) {
    return $00d6f04e5adaca89$var$isFunction(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
var $00d6f04e5adaca89$export$f1dc0e282d4c1c0 = function() {
    return $00d6f04e5adaca89$var$mergeObjects($00d6f04e5adaca89$var$defaultConfig, (0, $kLOUX.useContext)($00d6f04e5adaca89$var$SWRConfigContext));
};
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
var $00d6f04e5adaca89$var$withArgs = function(hook) {
    return function useSWRArgs() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // Get the default and inherited configuration.
        var fallbackConfig = $00d6f04e5adaca89$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        var _a = $00d6f04e5adaca89$var$normalize(args), key = _a[0], fn = _a[1], _config = _a[2];
        // Merge configurations.
        var config = $00d6f04e5adaca89$var$mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        var next = hook;
        var use = config.use;
        if (use) for(var i = use.length; i-- > 0;)next = use[i](next);
        return next(key, fn || config.fetcher, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
var $00d6f04e5adaca89$var$subscribeCallback = function(key, callbacks, callback) {
    var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return function() {
        var index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
var $00d6f04e5adaca89$var$WITH_DEDUPE = {
    dedupe: true
};
var $00d6f04e5adaca89$var$useSWRHandler = function(_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, fallbackData = config.fallbackData, suspense = config.suspense, revalidateOnMount = config.revalidateOnMount, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline;
    var _a = $00d6f04e5adaca89$var$SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], MUTATION = _a[2], FETCH = _a[3];
    // `key` is the identifier of the SWR `data` state, `keyInfo` holds extra
    // states such as `error` and `isValidating` inside,
    // all of them are derived from `_key`.
    // `fnArgs` is an array of arguments parsed from the key, which will be passed
    // to the fetcher.
    var _b = $00d6f04e5adaca89$var$serialize(_key), key = _b[0], fnArgs = _b[1], keyInfo = _b[2];
    // If it's the initial render of this hook.
    var initialMountedRef = (0, $kLOUX.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = (0, $kLOUX.useRef)(false);
    // Refs to keep the key and config.
    var keyRef = (0, $kLOUX.useRef)(key);
    var fetcherRef = (0, $kLOUX.useRef)(fetcher);
    var configRef = (0, $kLOUX.useRef)(config);
    var getConfig = function() {
        return configRef.current;
    };
    var isActive = function() {
        return getConfig().isVisible() && getConfig().isOnline();
    };
    var patchFetchInfo = function(info) {
        return cache.set(keyInfo, $00d6f04e5adaca89$var$mergeObjects(cache.get(keyInfo), info));
    };
    // Get the current state that SWR should return.
    var cached = cache.get(key);
    var fallback = $00d6f04e5adaca89$var$isUndefined(fallbackData) ? config.fallback[key] : fallbackData;
    var data = $00d6f04e5adaca89$var$isUndefined(cached) ? fallback : cached;
    var info = cache.get(keyInfo) || {};
    var error = info.error;
    var isInitialMount = !initialMountedRef.current;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldRevalidate = function() {
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !$00d6f04e5adaca89$var$isUndefined(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately on mount again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return $00d6f04e5adaca89$var$isUndefined(data) ? false : config.revalidateIfStale;
        // If there is no stale data, we need to revalidate on mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return $00d6f04e5adaca89$var$isUndefined(data) || config.revalidateIfStale;
    };
    // Resolve the current validating state.
    var resolveValidating = function() {
        if (!key || !fetcher) return false;
        if (info.isValidating) return true;
        // If it's not mounted yet and it should revalidate on mount, revalidate.
        return isInitialMount && shouldRevalidate();
    };
    var isValidating = resolveValidating();
    var _c = $00d6f04e5adaca89$var$useStateWithDeps({
        data: data,
        error: error,
        isValidating: isValidating
    }, unmountedRef), stateRef = _c[0], stateDependencies = _c[1], setState = _c[2];
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = (0, $kLOUX.useCallback)(function(revalidateOpts) {
        return $00d6f04e5adaca89$var$__awaiter(void 0, void 0, void 0, function() {
            var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, isCurrentKeyMounted, cleanupState, newState, finishRequestAndUpdateState, mutationInfo, err_1;
            var _a;
            return $00d6f04e5adaca89$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        currentFetcher = fetcherRef.current;
                        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return [
                            2 /*return*/ ,
                            false
                        ];
                        loading = true;
                        opts = revalidateOpts || {};
                        shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
                        isCurrentKeyMounted = function() {
                            return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
                        };
                        cleanupState = function() {
                            // Check if it's still the same request before deleting.
                            var requestInfo = FETCH[key];
                            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
                        };
                        newState = {
                            isValidating: false
                        };
                        finishRequestAndUpdateState = function() {
                            patchFetchInfo({
                                isValidating: false
                            });
                            // We can only set state if it's safe (still mounted with the same key).
                            if (isCurrentKeyMounted()) setState(newState);
                        };
                        // Start fetching. Change the `isValidating` state, update the cache.
                        patchFetchInfo({
                            isValidating: true
                        });
                        setState({
                            isValidating: true
                        });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        if (shouldStartNewRequest) {
                            // Tell all other hooks to change the `isValidating` state.
                            $00d6f04e5adaca89$var$broadcastState(cache, key, stateRef.current.data, stateRef.current.error, true);
                            // If no cache being rendered currently (it shows a blank page),
                            // we trigger the loading slow event.
                            if (config.loadingTimeout && !cache.get(key)) setTimeout(function() {
                                if (loading && isCurrentKeyMounted()) getConfig().onLoadingSlow(key, config);
                            }, config.loadingTimeout);
                            // Start the request and save the timestamp.
                            FETCH[key] = [
                                currentFetcher.apply(void 0, fnArgs),
                                $00d6f04e5adaca89$var$getTimestamp()
                            ];
                        }
                        _a = FETCH[key], newData = _a[0], startAt = _a[1];
                        return [
                            4 /*yield*/ ,
                            newData
                        ];
                    case 2:
                        newData = _b.sent();
                        if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
                        // deduplication interval.
                        setTimeout(cleanupState, config.dedupingInterval);
                        // If there're other ongoing request(s), started after the current one,
                        // we need to ignore the current one to avoid possible race conditions:
                        //   req1------------------>res1        (current one)
                        //        req2---------------->res2
                        // the request that fired later will always be kept.
                        // The timestamp maybe be `undefined` or a number
                        if (!FETCH[key] || FETCH[key][1] !== startAt) {
                            if (shouldStartNewRequest) {
                                if (isCurrentKeyMounted()) getConfig().onDiscarded(key);
                            }
                            return [
                                2 /*return*/ ,
                                false
                            ];
                        }
                        // Clear error.
                        patchFetchInfo({
                            error: $00d6f04e5adaca89$var$UNDEFINED
                        });
                        newState.error = $00d6f04e5adaca89$var$UNDEFINED;
                        mutationInfo = MUTATION[key];
                        if (!$00d6f04e5adaca89$var$isUndefined(mutationInfo) && // case 1
                        (startAt <= mutationInfo[0] || // case 2
                        startAt <= mutationInfo[1] || // case 3
                        mutationInfo[1] === 0)) {
                            finishRequestAndUpdateState();
                            if (shouldStartNewRequest) {
                                if (isCurrentKeyMounted()) getConfig().onDiscarded(key);
                            }
                            return [
                                2 /*return*/ ,
                                false
                            ];
                        }
                        // Deep compare with latest state to avoid extra re-renders.
                        // For local state, compare and assign.
                        if (!compare(stateRef.current.data, newData)) newState.data = newData;
                        else // data and newData are deeply equal
                        // it should be safe to broadcast the stale data
                        newState.data = stateRef.current.data;
                        // For global state, it's possible that the key has changed.
                        // https://github.com/vercel/swr/pull/1058
                        if (!compare(cache.get(key), newData)) cache.set(key, newData);
                        // Trigger the successful callback if it's the original request.
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) getConfig().onSuccess(newData, key, config);
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _b.sent();
                        cleanupState();
                        // Not paused, we continue handling the error. Otherwise discard it.
                        if (!getConfig().isPaused()) {
                            // Get a new error, don't use deep comparison for errors.
                            patchFetchInfo({
                                error: err_1
                            });
                            newState.error = err_1;
                            // Error event and retry logic. Only for the actual request, not
                            // deduped ones.
                            if (shouldStartNewRequest && isCurrentKeyMounted()) {
                                getConfig().onError(err_1, key, config);
                                if (typeof config.shouldRetryOnError === 'boolean' && config.shouldRetryOnError || $00d6f04e5adaca89$var$isFunction(config.shouldRetryOnError) && config.shouldRetryOnError(err_1)) // When retrying, dedupe is always enabled
                                {
                                    if (isActive()) // If it's active, stop. It will auto revalidate when refocusing
                                    // or reconnecting.
                                    getConfig().onErrorRetry(err_1, key, config, revalidate, {
                                        retryCount: (opts.retryCount || 0) + 1,
                                        dedupe: true
                                    });
                                }
                            }
                        }
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        // Mark loading as stopped.
                        loading = false;
                        // Update the current hook's state.
                        finishRequestAndUpdateState();
                        // Here is the source of the request, need to tell all other hooks to
                        // update their states.
                        if (isCurrentKeyMounted() && shouldStartNewRequest) $00d6f04e5adaca89$var$broadcastState(cache, key, newState.data, newState.error, false);
                        return [
                            2 /*return*/ ,
                            true
                        ];
                }
            });
        });
    }, // `setState` is immutable, and `eventsCallback`, `fnArgs`, `keyInfo`,
    // and `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    // Similar to the global mutate, but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var boundMutate = (0, $kLOUX.useCallback)(// By using `bind` we don't need to modify the size of the rest arguments.
    // Due to https://github.com/microsoft/TypeScript/issues/37181, we have to
    // cast it to any for now.
    $00d6f04e5adaca89$var$internalMutate.bind($00d6f04e5adaca89$var$UNDEFINED, cache, function() {
        return keyRef.current;
    }), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update fetcher and config refs.
    $00d6f04e5adaca89$var$useIsomorphicLayoutEffect(function() {
        fetcherRef.current = fetcher;
        configRef.current = config;
    });
    // After mounted or key changed.
    $00d6f04e5adaca89$var$useIsomorphicLayoutEffect(function() {
        if (!key) return;
        var keyChanged = key !== keyRef.current;
        var softRevalidate = revalidate.bind($00d6f04e5adaca89$var$UNDEFINED, $00d6f04e5adaca89$var$WITH_DEDUPE);
        // Expose state updater to global event listeners. So we can update hook's
        // internal state from the outside.
        var onStateUpdate = function(updatedData, updatedError, updatedIsValidating) {
            setState($00d6f04e5adaca89$var$mergeObjects({
                error: updatedError,
                isValidating: updatedIsValidating
            }, // Since `setState` only shallowly compares states, we do a deep
            // comparison here.
            compare(stateRef.current.data, updatedData) ? $00d6f04e5adaca89$var$UNDEFINED : {
                data: updatedData
            }));
        };
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var nextFocusRevalidatedAt = 0;
        var onRevalidate = function(type) {
            if (type == $00d6f04e5adaca89$var$FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == $00d6f04e5adaca89$var$RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == $00d6f04e5adaca89$var$MUTATE_EVENT) return revalidate();
            return;
        };
        var unsubUpdate = $00d6f04e5adaca89$var$subscribeCallback(key, STATE_UPDATERS, onStateUpdate);
        var unsubEvents = $00d6f04e5adaca89$var$subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // When `key` updates, reset the state to the initial value
        // and trigger a rerender if necessary.
        if (keyChanged) setState({
            data: data,
            error: error,
            isValidating: isValidating
        });
        // Trigger a revalidation.
        if (shouldRevalidate()) {
            if ($00d6f04e5adaca89$var$isUndefined(data) || $00d6f04e5adaca89$var$IS_SERVER) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            $00d6f04e5adaca89$var$rAF(softRevalidate);
        }
        return function() {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubUpdate();
            unsubEvents();
        };
    }, [
        key,
        revalidate
    ]);
    // Polling
    $00d6f04e5adaca89$var$useIsomorphicLayoutEffect(function() {
        var timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = $00d6f04e5adaca89$var$isFunction(refreshInterval) ? refreshInterval(data) : refreshInterval;
            // We only start next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online and not errored.
            if (!stateRef.current.error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($00d6f04e5adaca89$var$WITH_DEDUPE).then(next);
            else // Schedule next interval to check again.
            next();
        }
        next();
        return function() {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        revalidate
    ]);
    // Display debug info in React DevTools.
    (0, $kLOUX.useDebugValue)(data);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && $00d6f04e5adaca89$var$isUndefined(data) && key) {
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw $00d6f04e5adaca89$var$isUndefined(error) ? revalidate($00d6f04e5adaca89$var$WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return data;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        }
    };
};
var $00d6f04e5adaca89$export$4c7bbecdacc3ca2c = $00d6f04e5adaca89$var$OBJECT.defineProperty($00d6f04e5adaca89$var$SWRConfig$1, 'default', {
    value: $00d6f04e5adaca89$var$defaultConfig
});
var $00d6f04e5adaca89$export$dbab534a48e651ef = function(key) {
    return $00d6f04e5adaca89$var$serialize(key)[0];
};
var $00d6f04e5adaca89$export$2e2bcd8739ae039 = $00d6f04e5adaca89$var$withArgs($00d6f04e5adaca89$var$useSWRHandler);

});

parcelRegister("h6tPy", function(module, exports) {

$parcel$export(module.exports, "api", function () { return $3cdb4bdbf96db542$export$644d8ea042df96a6; });
$parcel$export(module.exports, "bulkCreateTransactions", function () { return $3cdb4bdbf96db542$export$b6db99441a7de444; });
$parcel$export(module.exports, "useCurrentEventSlug", function () { return $3cdb4bdbf96db542$export$c47d2d5eb3f18ff7; });
$parcel$export(module.exports, "useCurrentRole", function () { return $3cdb4bdbf96db542$export$28076df157fc3cf7; });
$parcel$export(module.exports, "useTransactions", function () { return $3cdb4bdbf96db542$export$4127a74fddb92b6f; });
$parcel$export(module.exports, "useLocations", function () { return $3cdb4bdbf96db542$export$8535247f55db5d21; });
$parcel$export(module.exports, "useLocationById", function () { return $3cdb4bdbf96db542$export$12e156107531de45; });

var $4UX9c = parcelRequire("4UX9c");

var $kLOUX = parcelRequire("kLOUX");

var $04t5A = parcelRequire("04t5A");
const $3cdb4bdbf96db542$export$644d8ea042df96a6 = async (endpoint, options = {})=>{
    const response = await fetch(endpoint, {
        method: options.method,
        headers: {
            'content-type': 'application/json'
        },
        body: options.body ? JSON.stringify(options.body) : undefined
    });
    if (!response.ok) {
        const errorResponse = await response.json();
        const error = new Error(errorResponse.message || response.statusText);
        // @ts-ignore
        error.statusCode = response.status;
        // @ts-ignore
        error.response = errorResponse;
        throw error;
    }
    if (response.status !== 204) return response.json();
};
function $3cdb4bdbf96db542$export$b6db99441a7de444(eventIdOrSlug, transactions) {
    return $3cdb4bdbf96db542$export$644d8ea042df96a6(`/api/events/${eventIdOrSlug}/transactions`, {
        method: 'POST',
        body: transactions
    });
}
function $3cdb4bdbf96db542$export$c47d2d5eb3f18ff7() {
    const [currentEventSlug, setCurrentEventSlug] = (0, $kLOUX.useState)(/** @type {string} */ (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent.slug);
    (0, $kLOUX.useEffect)(()=>{
        const syncSlug = ()=>{
            setCurrentEventSlug((0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent.slug);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).on('sync', syncSlug);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).off('sync', syncSlug);
        };
    }, []);
    return currentEventSlug;
}
function $3cdb4bdbf96db542$export$28076df157fc3cf7() {
    const [currentRole, setCurrentRole] = (0, $kLOUX.useState)((0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.role);
    (0, $kLOUX.useEffect)(()=>{
        const syncSlug = ()=>{
            setCurrentRole((0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.role);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).on('sync', syncSlug);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).off('sync', syncSlug);
        };
    }, []);
    return currentRole;
}
function $3cdb4bdbf96db542$export$4127a74fddb92b6f() {
    const eventSlug = $3cdb4bdbf96db542$export$c47d2d5eb3f18ff7();
    const qs = new URLSearchParams({
        state: 'transit'
    });
    qs.append('state', 'accepted');
    const response = (0, $04t5A.default)(`/api/events/${eventSlug}/transactions?${qs}`, null, {
        refreshInterval: 3000
    });
    return response;
}
function $3cdb4bdbf96db542$export$8535247f55db5d21(eventIdOrSlug) {
    const { data: locations, error: error } = (0, $04t5A.default)(`/api/events/${eventIdOrSlug}/locations`);
    const { storage: storage, bars: bars, delivery: delivery } = (0, $kLOUX.useMemo)(()=>{
        const storage = locations?.filter((location)=>location.type === 'storage' || location.type === 'crash');
        const bars = locations?.filter((location)=>location.type === 'bar');
        const delivery = locations?.find((location)=>location.type === 'delivery');
        return {
            storage: storage,
            bars: bars,
            delivery: delivery
        };
    }, [
        locations
    ]);
    return {
        error: error,
        locations: locations,
        storage: storage,
        bars: bars,
        delivery: delivery
    };
}
function $3cdb4bdbf96db542$export$12e156107531de45(locationId) {
    const eventSlug = $3cdb4bdbf96db542$export$c47d2d5eb3f18ff7();
    const response = (0, $04t5A.default)(`/api/events/${eventSlug}/locations/${locationId}`);
    return response;
}

});


parcelRegister("jeTO2", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("iVK96"))(import.meta.resolve("7JivC")),
    import("d2dLB"),
    import("2uJuO")
]).then(()=>parcelRequire('3Vu5W'));

});
parcelRegister("iVK96", function(module, exports) {
"use strict";

var $aID8g = parcelRequire("aID8g");
module.exports = $aID8g(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("aID8g", function(module, exports) {
"use strict";
var $7cdc5e4c494f5b40$var$cachedBundles = {};
var $7cdc5e4c494f5b40$var$cachedPreloads = {};
var $7cdc5e4c494f5b40$var$cachedPrefetches = {};
function $7cdc5e4c494f5b40$var$getCache(type) {
    switch(type){
        case 'preload':
            return $7cdc5e4c494f5b40$var$cachedPreloads;
        case 'prefetch':
            return $7cdc5e4c494f5b40$var$cachedPrefetches;
        default:
            return $7cdc5e4c494f5b40$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $7cdc5e4c494f5b40$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("2Ez8d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eea919ab899ac88$export$2e2bcd8739ae039; });
function $1eea919ab899ac88$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $1eea919ab899ac88$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $1eea919ab899ac88$var$pug_escape(e) {
    var a = "" + e, t = $1eea919ab899ac88$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $1eea919ab899ac88$var$pug_match_html = /["&<>]/;
function $1eea919ab899ac88$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + ("\u003Cdiv" + (" class=\"pure-g product-row\"" + $1eea919ab899ac88$var$pug_attr("data-id", model1.id, true, false)) + "\u003E\u003Cdiv class=\"pure-u-1-5 item-name\"\u003E\u003Cdiv class=\"cell\"\u003E" + $1eea919ab899ac88$var$pug_escape(null == (pug_interp = model1.name) ? "" : pug_interp));
        if (model1.canSpill) pug_html = pug_html + '<i class="icon can-spill ion-ios-wineglass" title="Schankverlust m\xf6glich"></i>';
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-5\"\u003E\u003Cdiv class=\"cell\"\u003E" + $1eea919ab899ac88$var$pug_escape(null == (pug_interp = model1.packageSize) ? "" : pug_interp) + " x " + $1eea919ab899ac88$var$pug_escape(null == (pug_interp = model1.volumePerUnit) ? "" : pug_interp) + "l\u003Cspan class=\"append\"\u003E";
        if (model1.weightFull) pug_html = pug_html + "\u003Cspan\u003Evoll " + $1eea919ab899ac88$var$pug_escape(null == (pug_interp = model1.weightFull) ? "" : pug_interp) + "g\u003C\u002Fspan\u003E";
        if (model1.weightFull && model1.weightEmpty) pug_html = pug_html + "\u003Cspan\u003E" + $1eea919ab899ac88$var$pug_escape((pug_interp = ', ', pug_interp)) + "\u003C\u002Fspan\u003E";
        if (model1.weightEmpty) pug_html = pug_html + "\u003Cspan\u003Eleer " + $1eea919ab899ac88$var$pug_escape(null == (pug_interp = model1.weightEmpty) ? "" : pug_interp) + "g\u003C\u002Fspan\u003E";
        pug_html = pug_html + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-5\"\u003E\u003Cdiv" + (" class=\"cell\"" + $1eea919ab899ac88$var$pug_attr("title", `${model1.costPerLiterLocalized}/Liter`, true, false)) + "\u003E" + $1eea919ab899ac88$var$pug_escape(null == (pug_interp = model1.costLocalized) ? "" : pug_interp) + "\u003Cspan class=\"append\"\u003Epro " + $1eea919ab899ac88$var$pug_escape(null == (pug_interp = model1.costUnitLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-5\"\u003E\u003Cdiv" + (" class=\"cell\"" + $1eea919ab899ac88$var$pug_attr("title", `${model1.pricePerLiterLocalized}/Liter`, true, false)) + "\u003E" + $1eea919ab899ac88$var$pug_escape(null == (pug_interp = model1.priceLocalized) ? "" : pug_interp) + "\u003Cspan class=\"append\"\u003Epro " + $1eea919ab899ac88$var$pug_escape(null == (pug_interp = model1.servingSizeLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-5 action\"\u003E\u003Cdiv class=\"cell\"\u003E\u003Cdiv class=\"btn-group\"\u003E\u003Cbutton" + (" class=\"pure-button btn-round\"" + $1eea919ab899ac88$var$pug_attr("title", `${model1.name} wiederherstellen...`, true, false) + " data-hook=\"restore\"") + "\u003E\u003Ci class=\"icon ion-ios-undo\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $1eea919ab899ac88$export$2e2bcd8739ae039 = $1eea919ab899ac88$var$template;

});

parcelRegister("ai8wC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77e232bb959c0b66$export$2e2bcd8739ae039; });
function $77e232bb959c0b66$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $77e232bb959c0b66$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $77e232bb959c0b66$var$pug_classes(s, r) {
    return Array.isArray(s) ? $77e232bb959c0b66$var$pug_classes_array(s, r) : s && "object" == typeof s ? $77e232bb959c0b66$var$pug_classes_object(s) : s || "";
}
function $77e232bb959c0b66$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $77e232bb959c0b66$var$pug_classes(r[g])) && (c && a[g] && (s = $77e232bb959c0b66$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $77e232bb959c0b66$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $77e232bb959c0b66$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $77e232bb959c0b66$var$pug_escape(e) {
    var a = "" + e, t = $77e232bb959c0b66$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $77e232bb959c0b66$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $77e232bb959c0b66$var$pug_match_html = /["&<>]/;
function $77e232bb959c0b66$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(exportUrl1, isAdmin1) {
        pug_html = pug_html + "\u003Cdiv class=\"product-page\"\u003E\u003Cdiv class=\"pure-g\" data-hook=\"page-header\"\u003E\u003Cdiv class=\"pure-u-1-4\"\u003E\u003Ch1\u003EProdukte\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-3-4\"\u003E\u003Cdiv class=\"flex-center\"\u003E\u003Cdiv class=\"cell\"\u003E\u003Cdiv data-hook=\"search-bar\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
        if (isAdmin1) pug_html = pug_html + '<div class="cell btn-group"><button class="btn-round pure-button add-item" data-hook="add-product" data-title="Produkt hinzuf\xfcgen"><i class="icon ion-plus"></i></button><div data-hook="import-products"></div><a' + (" class=\"btn-round pure-button\"" + $77e232bb959c0b66$var$pug_attr("href", exportUrl1, true, false) + " data-title=\"Produkte als CSV exportieren\"" + $77e232bb959c0b66$var$pug_attr("download", true, true, false) + " target=\"_blank\"") + "\u003E\u003Ci class=\"icon ion-ios-cloud-download\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"table item-list table-striped\"\u003E\u003Cheader\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-24\"\u003E\u003Cdiv class=\"cell\"\u003E#\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-3-8\"\u003E\u003Cdiv class=\"cell\"\u003EBezeichung\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + $77e232bb959c0b66$var$pug_attr("class", $77e232bb959c0b66$var$pug_classes([
            isAdmin1 ? 'pure-u-1-6' : 'pure-u-1-3'
        ], [
            true
        ]), false, false) + "\u003E\u003Cdiv class=\"cell\"\u003EVerpackung\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-8\"\u003E\u003Cdiv class=\"cell\"\u003EEinkauf\u003Cspan class=\"append\"\u003Enetto\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-8\"\u003E\u003Cdiv class=\"cell\"\u003EVerkauf\u003Cdiv class=\"span append\"\u003Ebrutto\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
        if (isAdmin1) pug_html = pug_html + "\u003Cdiv class=\"pure-u-1-6\"\u003E\u003Cdiv class=\"cell\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
        pug_html = pug_html + '</div></header><div class="tbody" data-hook="products"></div></div><div class="new-item" data-hook="new-product"></div><section class="deleted-products"><div class="pure-g"><div class="pure-u-3-4"><h2>Gel\xf6schte Produkte<small>Hier erscheinen Produkte, die gel\xf6scht, aber schon verwendet wurden.</small></h2></div></div><div class="table item-list table-striped"><header><div class="pure-g"><div' + $77e232bb959c0b66$var$pug_attr("class", $77e232bb959c0b66$var$pug_classes([
            isAdmin1 ? 'pure-u-1-5' : 'pure-u-1-4'
        ], [
            true
        ]), false, false) + "\u003E\u003Cdiv class=\"cell\"\u003EBezeichung\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + $77e232bb959c0b66$var$pug_attr("class", $77e232bb959c0b66$var$pug_classes([
            isAdmin1 ? 'pure-u-1-5' : 'pure-u-1-4'
        ], [
            true
        ]), false, false) + "\u003E\u003Cdiv class=\"cell\"\u003EVerpackung\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + $77e232bb959c0b66$var$pug_attr("class", $77e232bb959c0b66$var$pug_classes([
            isAdmin1 ? 'pure-u-1-5' : 'pure-u-1-4'
        ], [
            true
        ]), false, false) + "\u003E\u003Cdiv class=\"cell\"\u003EEinkauf\u003Cspan class=\"append\"\u003Enetto\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + $77e232bb959c0b66$var$pug_attr("class", $77e232bb959c0b66$var$pug_classes([
            isAdmin1 ? 'pure-u-1-5' : 'pure-u-1-4'
        ], [
            true
        ]), false, false) + "\u003E\u003Cdiv class=\"cell\"\u003EVerkauf\u003Cdiv class=\"span append\"\u003Ebrutto\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
        if (isAdmin1) pug_html = pug_html + "\u003Cdiv class=\"pure-1-5\"\u003E\u003Cdiv class=\"cell\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003Cdiv class=\"tbody\" data-hook=\"deleted-products\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "exportUrl" in locals_for_with ? locals_for_with.exportUrl : typeof exportUrl !== 'undefined' ? exportUrl : undefined, "isAdmin" in locals_for_with ? locals_for_with.isAdmin : typeof isAdmin !== 'undefined' ? isAdmin : undefined);
    return pug_html;
}
var $77e232bb959c0b66$export$2e2bcd8739ae039 = $77e232bb959c0b66$var$template;

});

parcelRegister("lGIqk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc9ffada4711e798$export$2e2bcd8739ae039; });
function $fc9ffada4711e798$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $fc9ffada4711e798$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $fc9ffada4711e798$var$pug_escape(e) {
    var a = "" + e, t = $fc9ffada4711e798$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $fc9ffada4711e798$var$pug_match_html = /["&<>]/;
function $fc9ffada4711e798$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(collection1, model1) {
        pug_html = pug_html + "\u003Cselect class=\"pure-input-1\" name=\"source\"\u003E\u003Coptgroup label=\"Lager\"\u003E";
        (function() {
            var $$obj = collection1.models;
            if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                var source = $$obj[pug_index0];
                if (source.type === 'storage') pug_html = pug_html + "\u003Coption" + ($fc9ffada4711e798$var$pug_attr("value", source.id, true, false) + $fc9ffada4711e798$var$pug_attr("selected", model1.sourceId === source.id, true, false)) + "\u003E" + $fc9ffada4711e798$var$pug_escape(null == (pug_interp = source.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index0 in $$obj){
                    $$l++;
                    var source = $$obj[pug_index0];
                    if (source.type === 'storage') pug_html = pug_html + "\u003Coption" + ($fc9ffada4711e798$var$pug_attr("value", source.id, true, false) + $fc9ffada4711e798$var$pug_attr("selected", model1.sourceId === source.id, true, false)) + "\u003E" + $fc9ffada4711e798$var$pug_escape(null == (pug_interp = source.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003C\u002Foptgroup\u003E\u003Coptgroup label=\"Bars\"\u003E";
        (function() {
            var $$obj = collection1.models;
            if ('number' == typeof $$obj.length) for(var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++){
                var source = $$obj[pug_index1];
                if (source.type === 'bar') pug_html = pug_html + "\u003Coption" + ($fc9ffada4711e798$var$pug_attr("value", source.id, true, false) + $fc9ffada4711e798$var$pug_attr("selected", model1.sourceId === source.id, true, false)) + "\u003E" + $fc9ffada4711e798$var$pug_escape(null == (pug_interp = source.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index1 in $$obj){
                    $$l++;
                    var source = $$obj[pug_index1];
                    if (source.type === 'bar') pug_html = pug_html + "\u003Coption" + ($fc9ffada4711e798$var$pug_attr("value", source.id, true, false) + $fc9ffada4711e798$var$pug_attr("selected", model1.sourceId === source.id, true, false)) + "\u003E" + $fc9ffada4711e798$var$pug_escape(null == (pug_interp = source.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003C\u002Foptgroup\u003E\u003C\u002Fselect\u003E";
    }).call(this, "collection" in locals_for_with ? locals_for_with.collection : typeof collection !== 'undefined' ? collection : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $fc9ffada4711e798$export$2e2bcd8739ae039 = $fc9ffada4711e798$var$template;

});

parcelRegister("hczrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c85f0cd0a34a68eb$export$2e2bcd8739ae039; });
function $c85f0cd0a34a68eb$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $c85f0cd0a34a68eb$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $c85f0cd0a34a68eb$var$pug_escape(e) {
    var a = "" + e, t = $c85f0cd0a34a68eb$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $c85f0cd0a34a68eb$var$pug_match_html = /["&<>]/;
function $c85f0cd0a34a68eb$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(collection1, model1) {
        pug_html = pug_html + "\u003Cselect class=\"pure-input-1\" name=\"target\"\u003E\u003Coption" + ($c85f0cd0a34a68eb$var$pug_attr("disabled", true, true, false) + $c85f0cd0a34a68eb$var$pug_attr("selected", !model1.targetId, true, false)) + '>Ziel w\xe4hlen...</option><optgroup label="Bars">';
        (function() {
            var $$obj = collection1.models;
            if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                var target = $$obj[pug_index0];
                if (target.type === 'bar') pug_html = pug_html + "\u003Coption" + ($c85f0cd0a34a68eb$var$pug_attr("value", target.id, true, false) + $c85f0cd0a34a68eb$var$pug_attr("selected", model1.targetId === target.id, true, false)) + "\u003E" + $c85f0cd0a34a68eb$var$pug_escape(null == (pug_interp = target.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index0 in $$obj){
                    $$l++;
                    var target = $$obj[pug_index0];
                    if (target.type === 'bar') pug_html = pug_html + "\u003Coption" + ($c85f0cd0a34a68eb$var$pug_attr("value", target.id, true, false) + $c85f0cd0a34a68eb$var$pug_attr("selected", model1.targetId === target.id, true, false)) + "\u003E" + $c85f0cd0a34a68eb$var$pug_escape(null == (pug_interp = target.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003C\u002Foptgroup\u003E\u003Coptgroup label=\"Lager\"\u003E";
        (function() {
            var $$obj = collection1.models;
            if ('number' == typeof $$obj.length) for(var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++){
                var target = $$obj[pug_index1];
                if (target.type === 'storage' || target.type === 'crash') pug_html = pug_html + "\u003Coption" + ($c85f0cd0a34a68eb$var$pug_attr("value", target.id, true, false) + $c85f0cd0a34a68eb$var$pug_attr("selected", model1.targetId === target.id, true, false)) + "\u003E" + $c85f0cd0a34a68eb$var$pug_escape(null == (pug_interp = target.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index1 in $$obj){
                    $$l++;
                    var target = $$obj[pug_index1];
                    if (target.type === 'storage' || target.type === 'crash') pug_html = pug_html + "\u003Coption" + ($c85f0cd0a34a68eb$var$pug_attr("value", target.id, true, false) + $c85f0cd0a34a68eb$var$pug_attr("selected", model1.targetId === target.id, true, false)) + "\u003E" + $c85f0cd0a34a68eb$var$pug_escape(null == (pug_interp = target.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003C\u002Foptgroup\u003E\u003C\u002Fselect\u003E";
    }).call(this, "collection" in locals_for_with ? locals_for_with.collection : typeof collection !== 'undefined' ? collection : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $c85f0cd0a34a68eb$export$2e2bcd8739ae039 = $c85f0cd0a34a68eb$var$template;

});

parcelRegister("6Ny93", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f31ce27f8fbdfde$export$2e2bcd8739ae039; });
function $4f31ce27f8fbdfde$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $4f31ce27f8fbdfde$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $4f31ce27f8fbdfde$var$pug_escape(e) {
    var a = "" + e, t = $4f31ce27f8fbdfde$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $4f31ce27f8fbdfde$var$pug_match_html = /["&<>]/;
function $4f31ce27f8fbdfde$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(formattedDate1) {
        pug_html = pug_html + "\u003Cdiv class=\"date-picker-wrapper\"\u003E\u003Cdiv class=\"input-addon\"\u003E\u003Cspan class=\"input-addon-item\"\u003E\u003Ci class=\"ion-ios-clock-outline\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003Cinput" + (' class="input-addon-field" name="date" type="datetime-local"' + $4f31ce27f8fbdfde$var$pug_attr("value", formattedDate1, true, false)) + "\u002F\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "formattedDate" in locals_for_with ? locals_for_with.formattedDate : typeof formattedDate !== 'undefined' ? formattedDate : undefined);
    return pug_html;
}
var $4f31ce27f8fbdfde$export$2e2bcd8739ae039 = $4f31ce27f8fbdfde$var$template;

});

parcelRegister("7RMJN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ba349eae7576ecb$export$2e2bcd8739ae039; });
function $5ba349eae7576ecb$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $5ba349eae7576ecb$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $5ba349eae7576ecb$var$pug_escape(e) {
    var a = "" + e, t = $5ba349eae7576ecb$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $5ba349eae7576ecb$var$pug_match_html = /["&<>]/;
function $5ba349eae7576ecb$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Ctr class=\"transaction-list-item--edit\"\u003E\u003Ctd\u003E\u003Cdiv data-hook=\"date-picker\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E";
        if (model1.source.type === 'delivery') {
            pug_html = pug_html + "\u003Cselect class=\"select-plain\" name=\"productId\"\u003E";
            (function() {
                var $$obj = model1.products.models;
                if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                    var product = $$obj[pug_index0];
                    pug_html = pug_html + "\u003Coption" + ($5ba349eae7576ecb$var$pug_attr("value", product.id, true, false) + $5ba349eae7576ecb$var$pug_attr("selected", product.id === model1.productId, true, false)) + "\u003E" + $5ba349eae7576ecb$var$pug_escape(null == (pug_interp = product.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
                else {
                    var $$l = 0;
                    for(var pug_index0 in $$obj){
                        $$l++;
                        var product = $$obj[pug_index0];
                        pug_html = pug_html + "\u003Coption" + ($5ba349eae7576ecb$var$pug_attr("value", product.id, true, false) + $5ba349eae7576ecb$var$pug_attr("selected", product.id === model1.productId, true, false)) + "\u003E" + $5ba349eae7576ecb$var$pug_escape(null == (pug_interp = product.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                    }
                }
            }).call(this);
            pug_html = pug_html + "\u003C\u002Fselect\u003E";
        } else {
            pug_html = pug_html + "\u003Cselect class=\"select-plain\" name=\"productId\"\u003E";
            (function() {
                var $$obj = model1.products.models;
                if ('number' == typeof $$obj.length) for(var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++){
                    var product = $$obj[pug_index1];
                    pug_html = pug_html + "\u003Coption" + ($5ba349eae7576ecb$var$pug_attr("value", product.id, true, false) + $5ba349eae7576ecb$var$pug_attr("selected", product.id === model1.productId, true, false)) + "\u003E" + $5ba349eae7576ecb$var$pug_escape(null == (pug_interp = product.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
                else {
                    var $$l = 0;
                    for(var pug_index1 in $$obj){
                        $$l++;
                        var product = $$obj[pug_index1];
                        pug_html = pug_html + "\u003Coption" + ($5ba349eae7576ecb$var$pug_attr("value", product.id, true, false) + $5ba349eae7576ecb$var$pug_attr("selected", product.id === model1.productId, true, false)) + "\u003E" + $5ba349eae7576ecb$var$pug_escape(null == (pug_interp = product.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                    }
                }
            }).call(this);
            pug_html = pug_html + "\u003C\u002Fselect\u003E";
        }
        pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cdiv class=\"input-units\"\u003E\u003Cinput" + (' class="pure-u-1" name="inputPackages"' + $5ba349eae7576ecb$var$pug_attr("value", model1._inputPackages || null, true, false) + " type=\"number\" min=\"0\" placeholder=\"0\"") + "\u002F\u003E\u003Cspan class=\"append\" data-hook=\"package-name\"\u003E" + $5ba349eae7576ecb$var$pug_escape(null == (pug_interp = model1.product.package) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cinput" + (' class="pure-u-1" name="inputUnits"' + $5ba349eae7576ecb$var$pug_attr("value", model1._inputUnits || null, true, false) + " type=\"number\" min=\"0\" step=\"any\" placeholder=\"0\"") + "\u002F\u003E\u003Cspan class=\"append\" data-hook=\"package-unit\"\u003E" + $5ba349eae7576ecb$var$pug_escape(null == (pug_interp = model1.product.unit) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd colspan=\"2\"\u003E\u003Cdiv data-hook=\"select-source\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv data-hook=\"select-target\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"action\"\u003E\u003Cbutton class=\"btn-round pure-button\" data-hook=\"cancel\"\u003E\u003Ci class=\"ion-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn-round pure-button button-success\" type=\"submit\" data-hook=\"save\"\u003E\u003Ci class=\"ion-checkmark\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $5ba349eae7576ecb$export$2e2bcd8739ae039 = $5ba349eae7576ecb$var$template;

});

parcelRegister("5ksgk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e14be55de89b54b$export$2e2bcd8739ae039; });
function $3e14be55de89b54b$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $3e14be55de89b54b$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $3e14be55de89b54b$var$pug_escape(e) {
    var a = "" + e, t = $3e14be55de89b54b$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $3e14be55de89b54b$var$pug_match_html = /["&<>]/;
function $3e14be55de89b54b$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(collection1, model1) {
        pug_html = pug_html + "\u003Cfieldset\u003E\u003Clabel\u003EVon\u003C\u002Flabel\u003E\u003Cselect class=\"select-plain pure-input-1\" name=\"source\"\u003E";
        (function() {
            var $$obj = collection1.models;
            if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                var source = $$obj[pug_index0];
                pug_html = pug_html + "\u003Coption" + ($3e14be55de89b54b$var$pug_attr("value", source.id, true, false) + $3e14be55de89b54b$var$pug_attr("selected", model1.sourceId === source.id, true, false)) + "\u003E" + $3e14be55de89b54b$var$pug_escape(null == (pug_interp = source.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index0 in $$obj){
                    $$l++;
                    var source = $$obj[pug_index0];
                    pug_html = pug_html + "\u003Coption" + ($3e14be55de89b54b$var$pug_attr("value", source.id, true, false) + $3e14be55de89b54b$var$pug_attr("selected", model1.sourceId === source.id, true, false)) + "\u003E" + $3e14be55de89b54b$var$pug_escape(null == (pug_interp = source.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003C\u002Fselect\u003E\u003C\u002Ffieldset\u003E";
    }).call(this, "collection" in locals_for_with ? locals_for_with.collection : typeof collection !== 'undefined' ? collection : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $3e14be55de89b54b$export$2e2bcd8739ae039 = $3e14be55de89b54b$var$template;

});

parcelRegister("fwSd6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4e3e533c9a1f688$export$2e2bcd8739ae039; });
function $b4e3e533c9a1f688$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $b4e3e533c9a1f688$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $b4e3e533c9a1f688$var$pug_escape(e) {
    var a = "" + e, t = $b4e3e533c9a1f688$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $b4e3e533c9a1f688$var$pug_match_html = /["&<>]/;
function $b4e3e533c9a1f688$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(collection1, model1) {
        pug_html = pug_html + "\u003Cfieldset\u003E\u003Clabel\u003ENach\u003C\u002Flabel\u003E\u003Cselect class=\"select-plain pure-input-1\" name=\"target\"\u003E";
        (function() {
            var $$obj = collection1.models;
            if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                var target = $$obj[pug_index0];
                pug_html = pug_html + "\u003Coption" + ($b4e3e533c9a1f688$var$pug_attr("value", target.id, true, false) + $b4e3e533c9a1f688$var$pug_attr("selected", model1.targetId === target.id, true, false)) + "\u003E" + $b4e3e533c9a1f688$var$pug_escape(null == (pug_interp = target.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index0 in $$obj){
                    $$l++;
                    var target = $$obj[pug_index0];
                    pug_html = pug_html + "\u003Coption" + ($b4e3e533c9a1f688$var$pug_attr("value", target.id, true, false) + $b4e3e533c9a1f688$var$pug_attr("selected", model1.targetId === target.id, true, false)) + "\u003E" + $b4e3e533c9a1f688$var$pug_escape(null == (pug_interp = target.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003C\u002Fselect\u003E\u003C\u002Ffieldset\u003E";
    }).call(this, "collection" in locals_for_with ? locals_for_with.collection : typeof collection !== 'undefined' ? collection : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $b4e3e533c9a1f688$export$2e2bcd8739ae039 = $b4e3e533c9a1f688$var$template;

});

parcelRegister("bRXhc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a42a00117c7030d$export$2e2bcd8739ae039; });
function $8a42a00117c7030d$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $8a42a00117c7030d$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $8a42a00117c7030d$var$pug_escape(e) {
    var a = "" + e, t = $8a42a00117c7030d$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $8a42a00117c7030d$var$pug_match_html = /["&<>]/;
function $8a42a00117c7030d$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(isAdmin1, model1) {
        pug_mixins["location-link"] = pug_interp = function(location) {
            var block = this && this.block, attributes = this && this.attributes || {};
            pug_html = pug_html + "\u003Ca" + $8a42a00117c7030d$var$pug_attr("href", location.link, true, false) + "\u003E" + $8a42a00117c7030d$var$pug_escape(null == (pug_interp = location.name) ? "" : pug_interp) + "\u003C\u002Fa\u003E";
        };
        pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E\u003Ctime" + $8a42a00117c7030d$var$pug_attr("datetime", model1.dispatchedAt.toISOString(), true, false) + "\u003E" + $8a42a00117c7030d$var$pug_escape(null == (pug_interp = model1.dispatchedAtLocalized) ? "" : pug_interp) + "\u003C\u002Ftime\u003E";
        if (model1.comment) pug_html = pug_html + "\u003Cspan class=\"comment-bubble\" data-hook=\"show-comment\"\u003E\u003Ci class=\"ion-ios-chatbubble-outline\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E";
        pug_html = pug_html + "\u003Cdiv class=\"append\"\u003E\u003Cspan\u003Evon " + $8a42a00117c7030d$var$pug_escape(null == (pug_interp = model1.user.name) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        if (model1.editedBy) pug_html = pug_html + "\u003Ci" + (' class="ion-edit" data-hook="edited"' + $8a42a00117c7030d$var$pug_attr("data-title", `Bearbeitet am ${model1.updatedAtLocalized} von ${model1.editedBy.name}`, true, false)) + "\u003E\u003C\u002Fi\u003E";
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E";
        if (model1.product.deletedAt) pug_html = pug_html + "\u003Ci" + (" class=\"is-deleted ion-trash-a\"" + $8a42a00117c7030d$var$pug_attr("title", `${model1.product.name} wurde gel\xf6scht.`, true, false)) + "\u003E\u003C\u002Fi\u003E";
        pug_html = pug_html + "\u003Cspan class=\"item-name\"\u003E" + $8a42a00117c7030d$var$pug_escape(null == (pug_interp = model1.product.name) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        if (model1.isFree) pug_html = pug_html + "\u003Cdiv class=\"append\"\u003EFreiware\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
        if (model1.packagesLocalized) pug_html = pug_html + "\u003Cspan class=\"packages\"\u003E" + $8a42a00117c7030d$var$pug_escape(null == (pug_interp = model1.packagesLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        if (model1.unitsLocalized) pug_html = pug_html + "\u003Cspan class=\"units\"\u003E" + $8a42a00117c7030d$var$pug_escape(null == (pug_interp = model1.unitsLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd class=\"transaction-list-location\"\u003E";
        pug_mixins["location-link"](model1.source);
        pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd class=\"transaction-list-location\"\u003E";
        pug_mixins["location-link"](model1.target);
        pug_html = pug_html + "\u003C\u002Ftd\u003E";
        if (isAdmin1) pug_html = pug_html + "\u003Ctd class=\"action\"\u003E\u003Cbutton class=\"btn-round pure-button\" title=\"Diese Transaktion bearbeiten...\" data-hook=\"edit\"\u003E\u003Ci class=\"ion-edit\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Ftd\u003E";
        pug_html = pug_html + "\u003C\u002Ftr\u003E";
    }).call(this, "isAdmin" in locals_for_with ? locals_for_with.isAdmin : typeof isAdmin !== 'undefined' ? isAdmin : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $8a42a00117c7030d$export$2e2bcd8739ae039 = $8a42a00117c7030d$var$template;

});

parcelRegister("5p9yL", function(module, exports) {

module.exports = exports = (parcelRequire("5XVpC"));

});
parcelRegister("5XVpC", function(module, exports) {
/**
 * An Array.prototype.slice.call(arguments) alternative
 *
 * @param {Object} args something with a length
 * @param {Number} slice
 * @param {Number} sliceEnd
 * @api public
 */ module.exports = function(args, slice, sliceEnd) {
    var ret = [];
    var len = args.length;
    if (0 === len) return ret;
    var start = slice < 0 ? Math.max(0, slice + len) : slice || 0;
    if (sliceEnd !== undefined) len = sliceEnd < 0 ? sliceEnd + len : sliceEnd;
    while(len-- > start)ret[len - start] = args[len];
    return ret;
};

});


parcelRegister("jDX6j", function(module, exports) {
/**
 * Get fn wrapped with array/object attrs recognition
 *
 * @return {Function} Target function
 */ module.exports = function(fn) {
    return function(a) {
        var args = arguments;
        if (a instanceof Array) {
            var result = new Array(a.length), slice;
            for(var i = 0; i < a.length; i++){
                slice = [];
                for(var j = 0, l = args.length, val; j < l; j++){
                    val = args[j] instanceof Array ? args[j][i] : args[j];
                    val;
                    slice.push(val);
                }
                result[i] = fn.apply(this, slice);
            }
            return result;
        } else if (typeof a === 'object') {
            var result = {}, slice;
            for(var i in a){
                slice = [];
                for(var j = 0, l = args.length, val; j < l; j++){
                    val = typeof args[j] === 'object' ? args[j][i] : args[j];
                    val;
                    slice.push(val);
                }
                result[i] = fn.apply(this, slice);
            }
            return result;
        } else return fn.apply(this, args);
    };
};

});

parcelRegister("hgusk", function(module, exports) {
/**
 * Get fn wrapped with array/object attrs recognition
 *
 * @return {Function} Target function
 */ module.exports = function(fn) {
    return function(a) {
        var args = arguments;
        if (a instanceof Array) {
            var result = new Array(a.length), slice;
            for(var i = 0; i < a.length; i++){
                slice = [];
                for(var j = 0, l = args.length, val; j < l; j++){
                    val = args[j] instanceof Array ? args[j][i] : args[j];
                    val;
                    slice.push(val);
                }
                result[i] = fn.apply(this, slice);
            }
            return result;
        } else if (typeof a === 'object') {
            var result = {}, slice;
            for(var i in a){
                slice = [];
                for(var j = 0, l = args.length, val; j < l; j++){
                    val = typeof args[j] === 'object' ? args[j][i] : args[j];
                    val;
                    slice.push(val);
                }
                result[i] = fn.apply(this, slice);
            }
            return result;
        } else return fn.apply(this, args);
    };
};

});

parcelRegister("74lK4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5259c5a62b315d7a$export$2e2bcd8739ae039; });
function $5259c5a62b315d7a$var$pug_escape(e) {
    var a = "" + e, t = $5259c5a62b315d7a$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $5259c5a62b315d7a$var$pug_match_html = /["&<>]/;
function $5259c5a62b315d7a$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Cli class=\"attribute-filter__item\"\u003E" + $5259c5a62b315d7a$var$pug_escape(null == (pug_interp = model1.name) ? "" : pug_interp) + "\u003C\u002Fli\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $5259c5a62b315d7a$export$2e2bcd8739ae039 = $5259c5a62b315d7a$var$template;

});

parcelRegister("hNMpN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cf5c917cfbc9d594$export$2e2bcd8739ae039; });
function $cf5c917cfbc9d594$var$pug_escape(e) {
    var a = "" + e, t = $cf5c917cfbc9d594$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $cf5c917cfbc9d594$var$pug_match_html = /["&<>]/;
function $cf5c917cfbc9d594$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(opts1) {
        pug_html = pug_html + "\u003Cdiv class=\"popover attribute-filter animated\"\u003E\u003Cdiv class=\"popover-arrow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"popover-content\"\u003E\u003Cdiv class=\"attribute-filter__header\"\u003E\u003Ch4\u003ENach " + $cf5c917cfbc9d594$var$pug_escape(null == (pug_interp = opts1.name) ? "" : pug_interp) + " filtern\u003C\u002Fh4\u003E\u003Ca class=\"popover-close\" href=\"#\" role=\"button\" data-hook=\"popover-close\"\u003E\u003Ci class=\"ion-close-round\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"attribute-filter__list\" data-hook=\"list\"\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "opts" in locals_for_with ? locals_for_with.opts : typeof opts !== 'undefined' ? opts : undefined);
    return pug_html;
}
var $cf5c917cfbc9d594$export$2e2bcd8739ae039 = $cf5c917cfbc9d594$var$template;

});

parcelRegister("1oZlT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10579f912553508d$export$2e2bcd8739ae039; });
function $10579f912553508d$var$pug_escape(e) {
    var a = "" + e, t = $10579f912553508d$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $10579f912553508d$var$pug_match_html = /["&<>]/;
function $10579f912553508d$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Cdiv class=\"pure-g search-state\"\u003E\u003Cdiv class=\"pure-u-1\"\u003E";
        if (model1.filtered) {
            pug_html = pug_html + "\u003Cp\u003EZeige Transaktionen";
            if (model1.product) pug_html = pug_html + ' f\xfcr <span class="badge">' + $10579f912553508d$var$pug_escape(null == (pug_interp = model1.activeProduct) ? "" : pug_interp) + "\u003Ci data-hook=\"remove-filter\" data-prop=\"product\" class=\"ion-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E";
            if (model1.source) pug_html = pug_html + " von \u003Cspan class=\"badge\"\u003E" + $10579f912553508d$var$pug_escape(null == (pug_interp = model1.activeSource) ? "" : pug_interp) + "\u003Ci data-hook=\"remove-filter\" data-prop=\"source\" class=\"ion-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E";
            if (model1.target) pug_html = pug_html + " nach \u003Cspan class=\"badge\"\u003E" + $10579f912553508d$var$pug_escape(null == (pug_interp = model1.activeTarget) ? "" : pug_interp) + "\u003Ci data-hook=\"remove-filter\" data-prop=\"target\" class=\"ion-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E";
            if (model1.start) pug_html = pug_html + " ab \u003Cspan class=\"badge\"\u003E" + $10579f912553508d$var$pug_escape(null == (pug_interp = model1.startLocalized) ? "" : pug_interp) + "\u003Ci data-hook=\"remove-filter\" data-prop=\"start\" class=\"ion-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E";
            if (model1.end) pug_html = pug_html + " bis \u003Cspan class=\"badge\"\u003E" + $10579f912553508d$var$pug_escape(null == (pug_interp = model1.endLocalized) ? "" : pug_interp) + "\u003Ci data-hook=\"remove-filter\" data-prop=\"end\" class=\"ion-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E";
            pug_html = pug_html + '.<br><a class="search-state__reset" href="#" data-hook="reset-filters"><i class="ion-close"></i>Alle Filter zur\xfccksetzen</a></p>';
        }
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $10579f912553508d$export$2e2bcd8739ae039 = $10579f912553508d$var$template;

});

parcelRegister("gVe0D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c51cd623311950d3$export$2e2bcd8739ae039; });
function $c51cd623311950d3$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(me1) {
        pug_html = pug_html + "\u003Csection class=\"transaction-page\"\u003E\u003Cheader class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-4\"\u003E\u003Ch1\u003ETransaktionen\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-3-4\"\u003E\u003Cdiv class=\"flex-center\"\u003E\u003Cdiv class=\"cell\"\u003E\u003Cdiv data-hook=\"search-bar\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E\u003Cdiv data-hook=\"slider\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv data-hook=\"search-state\"\u003E\u003C\u002Fdiv\u003E\u003Ctable class=\"pure-table table-striped\"\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Cth\u003EInfo\u003C\u002Fth\u003E\u003Cth class=\"transaction-page-column__filterable\" data-hook=\"filter-by-product\"\u003EProdukt\u003Ci class=\"ion-android-arrow-dropdown\"\u003E\u003C\u002Fi\u003E\u003C\u002Fth\u003E\u003Cth\u003EMenge\u003C\u002Fth\u003E\u003Cth class=\"transaction-page-column__filterable\" data-hook=\"filter-by-source\"\u003EVon\u003Ci class=\"ion-android-arrow-dropdown\"\u003E\u003C\u002Fi\u003E\u003C\u002Fth\u003E\u003Cth class=\"transaction-page-column__filterable\" data-hook=\"filter-by-target\"\u003ENach\u003Ci class=\"ion-android-arrow-dropdown\"\u003E\u003C\u002Fi\u003E\u003C\u002Fth\u003E";
        if (me1.role === 'admin') pug_html = pug_html + "\u003Cth\u003E\u003C\u002Fth\u003E";
        pug_html = pug_html + "\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody data-hook=\"transaction-list\"\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003Cfooter class=\"transaction-page__footer\"\u003EZeige \u003Cspan data-hook=\"displayCount\"\u003E\u003C\u002Fspan\u003E von insgesamt \u003Cspan data-hook=\"count\"\u003E\u003C\u002Fspan\u003E Transaktionen.\u003C\u002Ffooter\u003E\u003C\u002Fsection\u003E";
    }).call(this, "me" in locals_for_with ? locals_for_with.me : typeof me !== 'undefined' ? me : undefined);
    return pug_html;
}
var $c51cd623311950d3$export$2e2bcd8739ae039 = $c51cd623311950d3$var$template;

});

parcelRegister("gc6JU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bca2fea17152954d$export$2e2bcd8739ae039; });
function $bca2fea17152954d$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $bca2fea17152954d$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $bca2fea17152954d$var$pug_escape(e) {
    var a = "" + e, t = $bca2fea17152954d$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $bca2fea17152954d$var$pug_match_html = /["&<>]/;
function $bca2fea17152954d$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"create-event-form\"\u003E\u003Ch3\u003ENeues Event erstellen\u003C\u002Fh3\u003E\u003Cform class=\"pure-form pure-form-stacked\"\u003E\u003Cinput" + (" name=\"name\" type=\"text\" placeholder=\"Name\"" + $bca2fea17152954d$var$pug_attr("autofocus", true, true, false) + " autocomplete=\"off\"") + "\u002F\u003E\u003Cbutton" + (' class="pure-button pure-button-primary" type="submit"' + $bca2fea17152954d$var$pug_attr("disabled", true, true, false)) + "\u003EEvent erstellen\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $bca2fea17152954d$export$2e2bcd8739ae039 = $bca2fea17152954d$var$template;

});

parcelRegister("jedDj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dff9e66271441f0a$export$2e2bcd8739ae039; });
function $dff9e66271441f0a$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $dff9e66271441f0a$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $dff9e66271441f0a$var$pug_escape(e) {
    var a = "" + e, t = $dff9e66271441f0a$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $dff9e66271441f0a$var$pug_match_html = /["&<>]/;
function $dff9e66271441f0a$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(collection1) {
        if (collection1.size()) {
            pug_html = pug_html + '<div class="event-selector"><h3>Event ausw\xe4hlen</h3><select name="event-selector" data-hook="event-selector"><option' + ($dff9e66271441f0a$var$pug_attr("disabled", true, true, false) + $dff9e66271441f0a$var$pug_attr("selected", true, true, false)) + ">Event ausw\xe4hlen</option>";
            (function() {
                var $$obj = collection1.models;
                if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                    var event = $$obj[pug_index0];
                    pug_html = pug_html + "\u003Coption" + $dff9e66271441f0a$var$pug_attr("value", event.id, true, false) + "\u003E" + $dff9e66271441f0a$var$pug_escape(null == (pug_interp = event.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
                else {
                    var $$l = 0;
                    for(var pug_index0 in $$obj){
                        $$l++;
                        var event = $$obj[pug_index0];
                        pug_html = pug_html + "\u003Coption" + $dff9e66271441f0a$var$pug_attr("value", event.id, true, false) + "\u003E" + $dff9e66271441f0a$var$pug_escape(null == (pug_interp = event.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                    }
                }
            }).call(this);
            pug_html = pug_html + "\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E";
        } else pug_html = pug_html + "\u003Cdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "collection" in locals_for_with ? locals_for_with.collection : typeof collection !== 'undefined' ? collection : undefined);
    return pug_html;
}
var $dff9e66271441f0a$export$2e2bcd8739ae039 = $dff9e66271441f0a$var$template;

});

parcelRegister("7zo9Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $582e8a85b30f09df$export$2e2bcd8739ae039; });
function $582e8a85b30f09df$var$pug_escape(e) {
    var a = "" + e, t = $582e8a85b30f09df$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $582e8a85b30f09df$var$pug_match_html = /["&<>]/;
function $582e8a85b30f09df$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Cdiv class=\"page welcome-page\"\u003E\u003Ch1\u003EHallo " + $582e8a85b30f09df$var$pug_escape(null == (pug_interp = model1.name) ? "" : pug_interp) + '!<div class="append">Herzlich Willkommen bei BoozeBoy!</div></h1><div class="pure-g"><div class="pure-u-1-2"><p>Bevor du anfangen kannst Produkte, Lager und Bars anzulegen, solltest du\nein <abbr title="Zu einem Event geh\xf6ren Orte, Produkte, Nutzer und Transaktionen.">Event</abbr>\nerstellen oder ausw\xe4hlen.\nF\xfcr jedes Event, das du erstellst, bist du Administrator und kannst alle Informationen\neinsehen und bearbeiten sowie Nutzer hinzuf\xfcgen und entfernen.</p><p class="append">Deine Events kannst du sp\xe4ter in den <a href="/einstellungen">Einstellungen</a> verwalten.</p></div><div class="pure-u-1-2"><div data-hook="events-list"></div><div data-hook="create-event"></div></div></div></div>';
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $582e8a85b30f09df$export$2e2bcd8739ae039 = $582e8a85b30f09df$var$template;

});

parcelRegister("jVVS0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8303afa6a0a718e$export$2e2bcd8739ae039; });
function $e8303afa6a0a718e$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $e8303afa6a0a718e$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $e8303afa6a0a718e$var$pug_escape(e) {
    var a = "" + e, t = $e8303afa6a0a718e$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $e8303afa6a0a718e$var$pug_match_html = /["&<>]/;
function $e8303afa6a0a718e$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Cdiv class=\"popover confirm-delete animated\"\u003E\u003Cdiv class=\"popover-arrow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"popover-content inventory-popover\"\u003E\u003Ca" + $e8303afa6a0a718e$var$pug_attr("href", model1.inventoryUrl, true, false) + "\u003E\u003Ci class=\"icon ion-ios-paper\"\u003E\u003C\u002Fi\u003EInventuren verwalten\u003C\u002Fa\u003E\u003Ca" + $e8303afa6a0a718e$var$pug_attr("href", `${model1.inventoryUrl}/neu`, true, false) + "\u003E\u003Ci class=\"icon ion-plus\"\u003E\u003C\u002Fi\u003ENeue Inventur anlegen\u003C\u002Fa\u003E\u003Ca" + ($e8303afa6a0a718e$var$pug_attr("href", model1.exportUrl, true, false) + " target=\"_blank\"") + "\u003E\u003Ci class=\"icon ion-ios-cloud-download\"\u003E\u003C\u002Fi\u003EInventuren herunterladen\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $e8303afa6a0a718e$export$2e2bcd8739ae039 = $e8303afa6a0a718e$var$template;

});

parcelRegister("kY2Vr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43bae2e0194f104$export$2e2bcd8739ae039; });
function $f43bae2e0194f104$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $f43bae2e0194f104$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $f43bae2e0194f104$var$pug_escape(e) {
    var a = "" + e, t = $f43bae2e0194f104$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $f43bae2e0194f104$var$pug_match_html = /["&<>]/;
function $f43bae2e0194f104$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(canStartDelivery1, isAdmin1, model1) {
        pug_html = pug_html + "\u003Cdiv class=\"btn-group buttons\"\u003E\u003Cdiv data-hook=\"delete-button\"\u003E\u003C\u002Fdiv\u003E";
        if (canStartDelivery1 && !model1.isNew() && model1.type !== 'crash' && !model1.editable) pug_html = pug_html + "\u003Cbutton" + (" class=\"btn-round pure-button\"" + $f43bae2e0194f104$var$pug_attr("title", `${model1.name} best\xfccken...`, true, false) + " data-hook=\"delivery-button\"") + "\u003E\u003Ci class=\"ion-ios-cart\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E";
        if (isAdmin1 && model1.type !== 'crash' && !model1.isNew() && model1.stock.length && !model1.editable) pug_html = pug_html + "\u003Cdiv data-hook=\"inventory-button\"\u003E\u003C\u002Fdiv\u003E";
        if (model1.isNew()) pug_html = pug_html + "\u003Cbutton class=\"btn-round pure-button\" title=\"Abbrechen (Esc)\" data-hook=\"cancel\"\u003E\u003Ci class=\"ion-close-round\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton" + (' class="btn-round button-success pure-button" type="submit" title="Hinzuf\xfcgen (Enter)" data-hook="save"' + $f43bae2e0194f104$var$pug_attr("disabled", true, true, false)) + "\u003E\u003Ci class=\"ion-checkmark\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E";
        pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }).call(this, "canStartDelivery" in locals_for_with ? locals_for_with.canStartDelivery : typeof canStartDelivery !== 'undefined' ? canStartDelivery : undefined, "isAdmin" in locals_for_with ? locals_for_with.isAdmin : typeof isAdmin !== 'undefined' ? isAdmin : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $f43bae2e0194f104$export$2e2bcd8739ae039 = $f43bae2e0194f104$var$template;

});

parcelRegister("eEa8p", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("iVK96"))(import.meta.resolve("kHZdm")),
    import("d2dLB"),
    import("7ISnF")
]).then(()=>parcelRequire('2R5WZ'));

});

parcelRegister("kaUCt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb00a94663a0256d$export$2e2bcd8739ae039; });
function $eb00a94663a0256d$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $eb00a94663a0256d$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $eb00a94663a0256d$var$pug_escape(e) {
    var a = "" + e, t = $eb00a94663a0256d$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $eb00a94663a0256d$var$pug_match_html = /["&<>]/;
function $eb00a94663a0256d$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(editable1, id1, name1, placeholder1, type1) {
        pug_html = pug_html + "\u003Cheader class=\"location__header pure-g\"\u003E\u003Cdiv class=\"pure-u-2-3\"\u003E";
        if (editable1) pug_html = pug_html + "\u003Ci class=\"ion-drag drag-handle\" data-hook=\"drag-handle\" title=\"Zum Sortieren ziehen\"\u003E\u003C\u002Fi\u003E";
        pug_html = pug_html + "\u003Ch2\u003E";
        if (!name1 || editable1) {
            var placeholder1 = type1 === 'bar' ? 'Neue Bar' : 'Neues Lager';
            pug_html = pug_html + "\u003Cinput" + (' class="empty location-name" type="text"' + $eb00a94663a0256d$var$pug_attr("value", name1, true, false) + $eb00a94663a0256d$var$pug_attr("placeholder", placeholder1, true, false) + " autocomplete=\"off\" name=\"location-name\"") + "\u002F\u003E";
            if (!id1 && (type1 === 'storage' || type1 === 'crash')) pug_html = pug_html + "\u003Cform class=\"pure-form\"\u003E\u003Clabel class=\"pure-checkbox\"\u003E\u003Cinput" + (" type=\"checkbox\"" + $eb00a94663a0256d$var$pug_attr("checked", type1 === 'crash', true, false) + " data-hook=\"is-crash\"") + "\u002F\u003EBruchlager\u003C\u002Flabel\u003E\u003C\u002Fform\u003E";
        } else pug_html = pug_html + "\u003Cdiv class=\"location-name\"\u003E" + $eb00a94663a0256d$var$pug_escape(null == (pug_interp = name1) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-3\"\u003E\u003Cdiv data-hook=\"buttons\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fheader\u003E";
    }).call(this, "editable" in locals_for_with ? locals_for_with.editable : typeof editable !== 'undefined' ? editable : undefined, "id" in locals_for_with ? locals_for_with.id : typeof id !== 'undefined' ? id : undefined, "name" in locals_for_with ? locals_for_with.name : typeof name !== 'undefined' ? name : undefined, "placeholder" in locals_for_with ? locals_for_with.placeholder : typeof placeholder !== 'undefined' ? placeholder : undefined, "type" in locals_for_with ? locals_for_with.type : typeof type !== 'undefined' ? type : undefined);
    return pug_html;
}
var $eb00a94663a0256d$export$2e2bcd8739ae039 = $eb00a94663a0256d$var$template;

});

parcelRegister("2fHAc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a3eca24cea68ff3$export$2e2bcd8739ae039; });
function $1a3eca24cea68ff3$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $1a3eca24cea68ff3$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $1a3eca24cea68ff3$var$pug_escape(e) {
    var a = "" + e, t = $1a3eca24cea68ff3$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $1a3eca24cea68ff3$var$pug_match_html = /["&<>]/;
function $1a3eca24cea68ff3$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Cdiv class=\"pure-g dispatch-item\"\u003E\u003Cdiv class=\"pure-u-1\"\u003E\u003Cdiv class=\"pure-g dispatch-item-row\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E";
        if (model1.source.type === 'delivery') {
            pug_html = pug_html + "\u003Cselect class=\"pure-input-1\" name=\"productId\"\u003E";
            (function() {
                var $$obj = model1.products.sortBy('name');
                if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                    var product = $$obj[pug_index0];
                    pug_html = pug_html + "\u003Coption" + ($1a3eca24cea68ff3$var$pug_attr("value", product.id, true, false) + $1a3eca24cea68ff3$var$pug_attr("selected", product.id === model1.productId, true, false)) + "\u003E" + $1a3eca24cea68ff3$var$pug_escape(null == (pug_interp = product.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
                else {
                    var $$l = 0;
                    for(var pug_index0 in $$obj){
                        $$l++;
                        var product = $$obj[pug_index0];
                        pug_html = pug_html + "\u003Coption" + ($1a3eca24cea68ff3$var$pug_attr("value", product.id, true, false) + $1a3eca24cea68ff3$var$pug_attr("selected", product.id === model1.productId, true, false)) + "\u003E" + $1a3eca24cea68ff3$var$pug_escape(null == (pug_interp = product.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                    }
                }
            }).call(this);
            pug_html = pug_html + "\u003C\u002Fselect\u003E";
        } else {
            pug_html = pug_html + "\u003Cselect class=\"pure-input-1\" name=\"productId\"\u003E";
            (function() {
                var $$obj = model1.source.stock.sortBy(function(item) {
                    return item.product.name;
                });
                if ('number' == typeof $$obj.length) for(var pug_index1 = 0, $$l = $$obj.length; pug_index1 < $$l; pug_index1++){
                    var item = $$obj[pug_index1];
                    pug_html = pug_html + "\u003Coption" + ($1a3eca24cea68ff3$var$pug_attr("value", item.product.id, true, false) + $1a3eca24cea68ff3$var$pug_attr("selected", item.product.id === model1.productId, true, false)) + "\u003E" + $1a3eca24cea68ff3$var$pug_escape(null == (pug_interp = item.product.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
                else {
                    var $$l = 0;
                    for(var pug_index1 in $$obj){
                        $$l++;
                        var item = $$obj[pug_index1];
                        pug_html = pug_html + "\u003Coption" + ($1a3eca24cea68ff3$var$pug_attr("value", item.product.id, true, false) + $1a3eca24cea68ff3$var$pug_attr("selected", item.product.id === model1.productId, true, false)) + "\u003E" + $1a3eca24cea68ff3$var$pug_escape(null == (pug_interp = item.product.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                    }
                }
            }).call(this);
            pug_html = pug_html + "\u003C\u002Fselect\u003E";
        }
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-5-24\"\u003E\u003Cinput class=\"pure-input-1\" name=\"inputPackages\" type=\"number\" min=\"0\" placeholder=\"0\"\u002F\u003E\u003Cspan class=\"append\" data-hook=\"package-name\"\u003E" + $1a3eca24cea68ff3$var$pug_escape(null == (pug_interp = model1.product.package) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-5-24\"\u003E";
        if (model1.product.packageId !== 'keg') pug_html = pug_html + "\u003Cinput class=\"pure-input-1\" name=\"inputUnits\" type=\"number\" min=\"0\" step=\"any\" placeholder=\"0\"\u002F\u003E\u003Cspan class=\"append\" data-hook=\"package-unit\"\u003E" + $1a3eca24cea68ff3$var$pug_escape(null == (pug_interp = model1.product.unit) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-2-24\"\u003E\u003Ca class=\"dispatch-item-remove\" href=\"#\" title=\"Entfernen...\" data-hook=\"remove\" role=\"button\" tabindex=\"-1\"\u003E\u003Ci class=\"ion-ios-minus-outline\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g hidden\" data-hook=\"error-item\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv class=\"error\" data-hook=\"error-text\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $1a3eca24cea68ff3$export$2e2bcd8739ae039 = $1a3eca24cea68ff3$var$template;

});

parcelRegister("b0LoA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $804475918c8952d3$export$2e2bcd8739ae039; });
function $804475918c8952d3$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $804475918c8952d3$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $804475918c8952d3$var$pug_escape(e) {
    var a = "" + e, t = $804475918c8952d3$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $804475918c8952d3$var$pug_match_html = /["&<>]/;
function $804475918c8952d3$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Cdiv class=\"popover dispatch-view-simple animated\"\u003E\u003Cdiv class=\"popover-arrow\"\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"popover-close\" href=\"#\" role=\"button\" data-hook=\"popover-close\"\u003E\u003Ci class=\"ion-close-round\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"popover-content\"\u003E\u003Cform class=\"pure-form pure-form-stacked\"\u003E\u003Cfieldset\u003E\u003Clegend\u003E" + $804475918c8952d3$var$pug_escape(null == (pug_interp = model1.product.name) ? "" : pug_interp) + " dispatchen\u003C\u002Flegend\u003E\u003Cdiv class=\"pure-g route\"\u003E\u003Cdiv class=\"pure-u-1\"\u003E\u003Cdiv data-hook=\"select-target\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"items\" data-hook=\"products\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Ffieldset\u003E\u003Cbutton" + (' class="pure-button pure-button-primary" type="submit"' + $804475918c8952d3$var$pug_attr("disabled", true, true, false) + " data-hook=\"submit\"") + "\u003EAbschicken\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $804475918c8952d3$export$2e2bcd8739ae039 = $804475918c8952d3$var$template;

});

parcelRegister("2uo5I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d011220e389da35$export$2e2bcd8739ae039; });
function $1d011220e389da35$var$pug_escape(e) {
    var a = "" + e, t = $1d011220e389da35$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $1d011220e389da35$var$pug_match_html = /["&<>]/;
function $1d011220e389da35$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Cdiv class=\"pure-g dispatch-item\"\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-10-24\"\u003E\u003Cinput class=\"pure-input-1\" name=\"inputPackages\" type=\"number\" min=\"0\" placeholder=\"0\"\u002F\u003E\u003Cspan class=\"append\" data-hook=\"package-name\"\u003E" + $1d011220e389da35$var$pug_escape(null == (pug_interp = model1.product.package) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-4-24\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-10-24\"\u003E";
        if (model1.product.packageId !== 'keg') pug_html = pug_html + "\u003Cinput class=\"pure-input-1\" name=\"inputUnits\" type=\"number\" min=\"0\" step=\"any\" placeholder=\"0\"\u002F\u003E\u003Cspan class=\"append\" data-hook=\"package-unit\"\u003E" + $1d011220e389da35$var$pug_escape(null == (pug_interp = model1.product.unit) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g hidden\" data-hook=\"error-item\"\u003E\u003Cdiv class=\"pure-u-1\"\u003E\u003Cdiv class=\"error\" data-hook=\"error-text\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $1d011220e389da35$export$2e2bcd8739ae039 = $1d011220e389da35$var$template;

});

parcelRegister("axpyH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ac0cfe41220db50$export$2e2bcd8739ae039; });
function $7ac0cfe41220db50$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $7ac0cfe41220db50$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $7ac0cfe41220db50$var$pug_escape(e) {
    var a = "" + e, t = $7ac0cfe41220db50$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $7ac0cfe41220db50$var$pug_match_html = /["&<>]/;
function $7ac0cfe41220db50$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E";
        if (model1.product.deletedAt) pug_html = pug_html + "\u003Ci" + (" class=\"is-deleted ion-trash-a\"" + $7ac0cfe41220db50$var$pug_attr("title", `${model1.product.name} wurde gel\xf6scht.`, true, false)) + "\u003E\u003C\u002Fi\u003E";
        pug_html = pug_html + "\u003Cspan class=\"item-name\" data-hook=\"name\"\u003E" + $7ac0cfe41220db50$var$pug_escape(null == (pug_interp = model1.product.name) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"volume\"\u003E\u003Cspan class=\"packages\" data-hook=\"packages-localized\"\u003E" + $7ac0cfe41220db50$var$pug_escape(null == (pug_interp = model1.packagesLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"units\" data-hook=\"units-localized\"\u003E" + $7ac0cfe41220db50$var$pug_escape(null == (pug_interp = model1.unitsLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"action\" data-hook=\"dispatch-button\"\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $7ac0cfe41220db50$export$2e2bcd8739ae039 = $7ac0cfe41220db50$var$template;

});

parcelRegister("6Kql9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e9b788f612c1d52$export$2e2bcd8739ae039; });
function $4e9b788f612c1d52$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $4e9b788f612c1d52$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $4e9b788f612c1d52$var$pug_escape(e) {
    var a = "" + e, t = $4e9b788f612c1d52$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $4e9b788f612c1d52$var$pug_match_html = /["&<>]/;
function $4e9b788f612c1d52$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E";
        if (model1.product.deletedAt) pug_html = pug_html + "\u003Ci" + (" class=\"is-deleted ion-trash-a\"" + $4e9b788f612c1d52$var$pug_attr("title", `${model1.product.name} wurde gel\xf6scht.`, true, false)) + "\u003E\u003C\u002Fi\u003E";
        pug_html = pug_html + "\u003Cspan class=\"item-name\" data-hook=\"name\"\u003E" + $4e9b788f612c1d52$var$pug_escape(null == (pug_interp = model1.product.name) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"volume\"\u003E";
        if (model1.packagesLocalized) pug_html = pug_html + "\u003Cspan class=\"packages\" data-hook=\"packages-localized\"\u003E" + $4e9b788f612c1d52$var$pug_escape(null == (pug_interp = model1.packagesLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        if (model1.unitsLocalized) pug_html = pug_html + "\u003Cspan class=\"units\" data-hook=\"units-localized\"\u003E" + $4e9b788f612c1d52$var$pug_escape(null == (pug_interp = model1.unitsLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + $4e9b788f612c1d52$var$pug_escape(null == (pug_interp = model1.stockNetValueLocalized) ? "" : pug_interp) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $4e9b788f612c1d52$export$2e2bcd8739ae039 = $4e9b788f612c1d52$var$template;

});

parcelRegister("6sOFj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b4ca8ad1bed1aa3$export$2e2bcd8739ae039; });
function $4b4ca8ad1bed1aa3$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $4b4ca8ad1bed1aa3$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $4b4ca8ad1bed1aa3$var$pug_classes(s, r) {
    return Array.isArray(s) ? $4b4ca8ad1bed1aa3$var$pug_classes_array(s, r) : s && "object" == typeof s ? $4b4ca8ad1bed1aa3$var$pug_classes_object(s) : s || "";
}
function $4b4ca8ad1bed1aa3$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $4b4ca8ad1bed1aa3$var$pug_classes(r[g])) && (c && a[g] && (s = $4b4ca8ad1bed1aa3$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $4b4ca8ad1bed1aa3$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $4b4ca8ad1bed1aa3$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $4b4ca8ad1bed1aa3$var$pug_escape(e) {
    var a = "" + e, t = $4b4ca8ad1bed1aa3$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $4b4ca8ad1bed1aa3$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $4b4ca8ad1bed1aa3$var$pug_match_html = /["&<>]/;
function $4b4ca8ad1bed1aa3$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1, type1) {
        pug_mixins["sortableColumn"] = pug_interp = function(prop, descr) {
            var block = this && this.block, attributes = this && this.attributes || {};
            pug_html = pug_html + "\u003Cth" + ($4b4ca8ad1bed1aa3$var$pug_attr("class", $4b4ca8ad1bed1aa3$var$pug_classes([
                [
                    model1.stock.state.comparator === prop ? 'sorted' : null,
                    model1.stock.state.order
                ].join(' '),
                "sortable-column"
            ], [
                true,
                false
            ]), false, false) + $4b4ca8ad1bed1aa3$var$pug_attr("data-hook", "sort-" + prop, true, false)) + "\u003E\u003Cspan\u003E" + $4b4ca8ad1bed1aa3$var$pug_escape(null == (pug_interp = descr) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan\u003E\u003Ci class=\"ion-ios-arrow-down\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fth\u003E";
        };
        pug_html = pug_html + "\u003Csection" + (" class=\"pure-u-1 pure-u-xl-1-2 location storage\"" + $4b4ca8ad1bed1aa3$var$pug_attr("data-id", model1.id, true, false) + $4b4ca8ad1bed1aa3$var$pug_attr("id", model1.slug, true, false)) + "\u003E\u003Cdiv data-hook=\"location-header\"\u003E\u003C\u002Fdiv\u003E\u003Ctable class=\"pure-table item-list table-striped\"\u003E\u003Cthead\u003E\u003Ctr\u003E";
        if (type1 === 'crash') {
            pug_mixins["sortableColumn"]('sortPosition', '#');
            pug_mixins["sortableColumn"]('name', 'Bezeichnung');
            pug_mixins["sortableColumn"]('stock', 'Bestand');
            pug_html = pug_html + "\u003Cth\u003ESchaden\u003Cdiv class=\"span append\"\u003Enetto\u003C\u002Fdiv\u003E\u003C\u002Fth\u003E";
        } else {
            pug_mixins["sortableColumn"]('sortPosition', '#');
            pug_mixins["sortableColumn"]('name', 'Bezeichnung');
            pug_mixins["sortableColumn"]('units', 'Bestand');
            pug_html = pug_html + "\u003Cth\u003E\u003C\u002Fth\u003E";
        }
        pug_html = pug_html + "\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody data-hook=\"item-list\"\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fsection\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined, "type" in locals_for_with ? locals_for_with.type : typeof type !== 'undefined' ? type : undefined);
    return pug_html;
}
var $4b4ca8ad1bed1aa3$export$2e2bcd8739ae039 = $4b4ca8ad1bed1aa3$var$template;

});

parcelRegister("lLI8n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd9038daa023c3ab$export$2e2bcd8739ae039; });
function $fd9038daa023c3ab$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $fd9038daa023c3ab$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $fd9038daa023c3ab$var$pug_escape(e) {
    var a = "" + e, t = $fd9038daa023c3ab$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $fd9038daa023c3ab$var$pug_match_html = /["&<>]/;
function $fd9038daa023c3ab$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(isAdmin1, model1) {
        pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E";
        if (model1.product.deletedAt) pug_html = pug_html + "\u003Ci" + (" class=\"is-deleted ion-trash-a\"" + $fd9038daa023c3ab$var$pug_attr("title", `${model1.product.name} wurde gel\xf6scht.`, true, false)) + "\u003E\u003C\u002Fi\u003E";
        pug_html = pug_html + "\u003Cspan class=\"item-name\" data-hook=\"name\"\u003E" + $fd9038daa023c3ab$var$pug_escape(null == (pug_interp = model1.product.name) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        if (model1.lastInventoryId) {
            pug_html = pug_html + "\u003Cdiv class=\"append\"\u003ELetzte Inventur:&nbsp;";
            if (isAdmin1) pug_html = pug_html + "\u003Ca" + $fd9038daa023c3ab$var$pug_attr("href", `${model1.lastInventoryUrl}`, true, false) + "\u003E" + $fd9038daa023c3ab$var$pug_escape(null == (pug_interp = model1.lastInventoryTimeLocalized) ? "" : pug_interp) + "\u003C\u002Fa\u003E";
            else pug_html = pug_html + $fd9038daa023c3ab$var$pug_escape(null == (pug_interp = model1.lastInventoryTimeLocalized) ? "" : pug_interp);
            pug_html = pug_html + "\u003C\u002Fdiv\u003E";
        }
        pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd" + (' class="volume" data-hook="units"' + $fd9038daa023c3ab$var$pug_attr("title", `Seit letzter Inventur: ${model1.packagesSinceInventoryLocalized || ''} ${model1.unitsSinceInventoryLocalized || ''}`, true, false)) + "\u003E\u003Cspan class=\"packages\" data-hook=\"packages-localized\"\u003E" + $fd9038daa023c3ab$var$pug_escape(null == (pug_interp = model1.packagesLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"units\" data-hook=\"units-localized\"\u003E" + $fd9038daa023c3ab$var$pug_escape(null == (pug_interp = model1.unitsLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E";
        if (isAdmin1) pug_html = pug_html + "\u003Ctd\u003E" + $fd9038daa023c3ab$var$pug_escape(null == (pug_interp = model1.salesGrossLocalized) ? "" : pug_interp) + "\u003Cdiv class=\"append\"\u003E" + $fd9038daa023c3ab$var$pug_escape(null == (pug_interp = model1.packagesSoldLocalized) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"append\"\u003E" + $fd9038daa023c3ab$var$pug_escape(null == (pug_interp = model1.unitsSoldLocalized) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E" + $fd9038daa023c3ab$var$pug_escape(null == (pug_interp = model1.salesNetLocalized) ? "" : pug_interp) + "\u003Cdiv class=\"append\"\u003EMwst. " + $fd9038daa023c3ab$var$pug_escape(null == (pug_interp = model1.vatLocalized) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E";
        pug_html = pug_html + "\u003Ctd class=\"action\" data-hook=\"dispatch-button\"\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }).call(this, "isAdmin" in locals_for_with ? locals_for_with.isAdmin : typeof isAdmin !== 'undefined' ? isAdmin : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $fd9038daa023c3ab$export$2e2bcd8739ae039 = $fd9038daa023c3ab$var$template;

});

parcelRegister("lFWZ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc7b2e87e1f4743f$export$2e2bcd8739ae039; });
function $fc7b2e87e1f4743f$var$pug_escape(e) {
    var a = "" + e, t = $fc7b2e87e1f4743f$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $fc7b2e87e1f4743f$var$pug_match_html = /["&<>]/;
function $fc7b2e87e1f4743f$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Ctfoot\u003E\u003Ctr\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003Ctd colspan=\"2\"\u003ESumme\u003C\u002Ftd\u003E\u003Ctd\u003E" + $fc7b2e87e1f4743f$var$pug_escape(null == (pug_interp = model1.sumSalesGross) ? "" : pug_interp) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + $fc7b2e87e1f4743f$var$pug_escape(null == (pug_interp = model1.sumSalesNet) ? "" : pug_interp) + "\u003Cspan class=\"append\"\u003EMwst. " + $fc7b2e87e1f4743f$var$pug_escape(null == (pug_interp = model1.vat) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003Ctd colspan=\"2\"\u003Eabzgl. Schankverlust\u003C\u002Ftd\u003E\u003Ctd\u003E" + $fc7b2e87e1f4743f$var$pug_escape(null == (pug_interp = model1.sumSalesGrossAfterSpillage) ? "" : pug_interp) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + $fc7b2e87e1f4743f$var$pug_escape(null == (pug_interp = model1.sumSalesNetAfterSpillage) ? "" : pug_interp) + "\u003Cspan class=\"append\"\u003EMwst. " + $fc7b2e87e1f4743f$var$pug_escape(null == (pug_interp = model1.vatAfterSpillage) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003Ctd colspan=\"2\"\u003Eabzgl. Personalmarken\u003C\u002Ftd\u003E\u003Ctd\u003E" + $fc7b2e87e1f4743f$var$pug_escape(null == (pug_interp = model1.sumSalesGrossAfterSpillageWithoutTokens) ? "" : pug_interp) + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + $fc7b2e87e1f4743f$var$pug_escape(null == (pug_interp = model1.sumSalesNetAfterSpillageWithoutTokens) ? "" : pug_interp) + "\u003Cspan class=\"append\"\u003EMwst. " + $fc7b2e87e1f4743f$var$pug_escape(null == (pug_interp = model1.vatAfterSpillageWithoutTokens) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftfoot\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $fc7b2e87e1f4743f$export$2e2bcd8739ae039 = $fc7b2e87e1f4743f$var$template;

});

parcelRegister("btiHk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85a0e81f30e14764$export$2e2bcd8739ae039; });
function $85a0e81f30e14764$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $85a0e81f30e14764$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $85a0e81f30e14764$var$pug_classes(s, r) {
    return Array.isArray(s) ? $85a0e81f30e14764$var$pug_classes_array(s, r) : s && "object" == typeof s ? $85a0e81f30e14764$var$pug_classes_object(s) : s || "";
}
function $85a0e81f30e14764$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $85a0e81f30e14764$var$pug_classes(r[g])) && (c && a[g] && (s = $85a0e81f30e14764$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $85a0e81f30e14764$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $85a0e81f30e14764$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $85a0e81f30e14764$var$pug_escape(e) {
    var a = "" + e, t = $85a0e81f30e14764$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $85a0e81f30e14764$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $85a0e81f30e14764$var$pug_match_html = /["&<>]/;
function $85a0e81f30e14764$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(isAdmin1, isBarchef1, model1) {
        pug_mixins["sortableColumn"] = pug_interp = function(prop, descr) {
            var block = this && this.block, attributes = this && this.attributes || {};
            pug_html = pug_html + "\u003Cth" + ($85a0e81f30e14764$var$pug_attr("class", $85a0e81f30e14764$var$pug_classes([
                [
                    model1.stock.state.comparator === prop ? 'sorted' : null,
                    model1.stock.state.order
                ].join(' '),
                "sortable-column"
            ], [
                true,
                false
            ]), false, false) + $85a0e81f30e14764$var$pug_attr("data-hook", "sort-" + prop, true, false)) + "\u003E\u003Cspan\u003E" + $85a0e81f30e14764$var$pug_escape(null == (pug_interp = descr) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan\u003E\u003Ci class=\"ion-ios-arrow-down\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fth\u003E";
        };
        pug_html = pug_html + "\u003Csection" + ($85a0e81f30e14764$var$pug_attr("class", $85a0e81f30e14764$var$pug_classes([
            "pure-u-1",
            "location",
            "bar",
            `${!isBarchef1 ? 'pure-u-xl-1-2' : ''}`
        ], [
            false,
            false,
            false,
            true
        ]), false, false) + $85a0e81f30e14764$var$pug_attr("data-id", model1.id, true, false) + $85a0e81f30e14764$var$pug_attr("id", model1.slug, true, false)) + "\u003E\u003Cdiv data-hook=\"location-header\"\u003E\u003C\u002Fdiv\u003E\u003Ctable class=\"pure-table item-list table-striped\"\u003E\u003Cthead\u003E\u003Ctr\u003E";
        pug_mixins["sortableColumn"]('sortPosition', '#');
        pug_mixins["sortableColumn"]('name', 'Bezeichnung');
        pug_mixins["sortableColumn"]('units', 'Bestand');
        if (isAdmin1) pug_html = pug_html + "\u003Cth class=\"row-sales\"\u003EUmsatz\u003Cspan class=\"append\"\u003Ebrutto\u003C\u002Fspan\u003E\u003C\u002Fth\u003E\u003Cth class=\"row-sales\"\u003EUmsatz\u003Cspan class=\"append\"\u003Enetto\u003C\u002Fspan\u003E\u003C\u002Fth\u003E";
        pug_html = pug_html + "\u003Cth class=\"action\"\u003E\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody data-hook=\"item-list\"\u003E\u003C\u002Ftbody\u003E";
        if (isAdmin1 && model1.stock.length) pug_html = pug_html + "\u003Ctfoot data-hook=\"bar-footer\"\u003E\u003C\u002Ftfoot\u003E";
        pug_html = pug_html + "\u003C\u002Ftable\u003E\u003C\u002Fsection\u003E";
    }).call(this, "isAdmin" in locals_for_with ? locals_for_with.isAdmin : typeof isAdmin !== 'undefined' ? isAdmin : undefined, "isBarchef" in locals_for_with ? locals_for_with.isBarchef : typeof isBarchef !== 'undefined' ? isBarchef : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $85a0e81f30e14764$export$2e2bcd8739ae039 = $85a0e81f30e14764$var$template;

});

parcelRegister("cFIFy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939bf6bfa3a5d437$export$2e2bcd8739ae039; });
function $939bf6bfa3a5d437$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $939bf6bfa3a5d437$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $939bf6bfa3a5d437$var$pug_escape(e) {
    var a = "" + e, t = $939bf6bfa3a5d437$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $939bf6bfa3a5d437$var$pug_match_html = /["&<>]/;
function $939bf6bfa3a5d437$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(collection1) {
        pug_html = pug_html + "\u003Cselect class=\"select-plain quick-select\" data-hook=\"quick-select\"\u003E\u003Coption" + (" value=\"all\"" + $939bf6bfa3a5d437$var$pug_attr("selected", true, true, false)) + "\u003EAlle\u003C\u002Foption\u003E";
        (function() {
            var $$obj = collection1;
            if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                var location = $$obj[pug_index0];
                if (location.id) pug_html = pug_html + "\u003Coption" + $939bf6bfa3a5d437$var$pug_attr("value", location.id, true, false) + "\u003E" + $939bf6bfa3a5d437$var$pug_escape(null == (pug_interp = location.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index0 in $$obj){
                    $$l++;
                    var location = $$obj[pug_index0];
                    if (location.id) pug_html = pug_html + "\u003Coption" + $939bf6bfa3a5d437$var$pug_attr("value", location.id, true, false) + "\u003E" + $939bf6bfa3a5d437$var$pug_escape(null == (pug_interp = location.name) ? "" : pug_interp) + "\u003C\u002Foption\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003C\u002Fselect\u003E";
    }).call(this, "collection" in locals_for_with ? locals_for_with.collection : typeof collection !== 'undefined' ? collection : undefined);
    return pug_html;
}
var $939bf6bfa3a5d437$export$2e2bcd8739ae039 = $939bf6bfa3a5d437$var$template;

});

parcelRegister("4FZ98", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $367a6c2c4479677e$export$2e2bcd8739ae039; });
function $367a6c2c4479677e$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $367a6c2c4479677e$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $367a6c2c4479677e$var$pug_escape(e) {
    var a = "" + e, t = $367a6c2c4479677e$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $367a6c2c4479677e$var$pug_match_html = /["&<>]/;
function $367a6c2c4479677e$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(isAdmin1, isBarchef1) {
        pug_html = pug_html + "\u003Cdiv class=\"location-page lager-page\"\u003E";
        pug_mixins["location-page-header"] = pug_interp = function(title) {
            var block = this && this.block, attributes = this && this.attributes || {};
            pug_html = pug_html + "\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-4\"\u003E\u003Ch1\u003E" + $367a6c2c4479677e$var$pug_escape(null == (pug_interp = title) ? "" : pug_interp) + "\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-3-4\"\u003E\u003Cdiv class=\"flex-center\"\u003E";
            if (!isBarchef1) pug_html = pug_html + "\u003Cdiv class=\"cell\"\u003E\u003Cdiv data-hook=\"quick-select\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
            pug_html = pug_html + "\u003Cdiv class=\"cell\"\u003E\u003Cdiv data-hook=\"search-bar\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
            if (isAdmin1) pug_html = pug_html + "\u003Cdiv class=\"cell btn-group\"\u003E\u003Cbutton" + (' class="btn-round pure-button edit-location" data-hook="edit-location"' + $367a6c2c4479677e$var$pug_attr("data-title", `${title} bearbeiten`, true, false)) + "\u003E\u003Ci class=\"ion-edit\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton" + (' class="btn-round pure-button add-location" data-hook="add-location"' + $367a6c2c4479677e$var$pug_attr("data-title", `${title} hinzuf\xfcgen`, true, false)) + "\u003E\u003Ci class=\"icon ion-plus-round\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
            pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"list\" data-hook=\"new-location\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g list\" data-hook=\"location-list\"\u003E\u003C\u002Fdiv\u003E";
        };
        pug_mixins["location-page-header"]("Lager");
        pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }).call(this, "isAdmin" in locals_for_with ? locals_for_with.isAdmin : typeof isAdmin !== 'undefined' ? isAdmin : undefined, "isBarchef" in locals_for_with ? locals_for_with.isBarchef : typeof isBarchef !== 'undefined' ? isBarchef : undefined);
    return pug_html;
}
var $367a6c2c4479677e$export$2e2bcd8739ae039 = $367a6c2c4479677e$var$template;

});

parcelRegister("kPvmu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2a0e5d5cabb2ae4$export$2e2bcd8739ae039; });
function $f2a0e5d5cabb2ae4$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $f2a0e5d5cabb2ae4$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $f2a0e5d5cabb2ae4$var$pug_escape(e) {
    var a = "" + e, t = $f2a0e5d5cabb2ae4$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $f2a0e5d5cabb2ae4$var$pug_match_html = /["&<>]/;
function $f2a0e5d5cabb2ae4$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(isAdmin1, isBarchef1) {
        pug_html = pug_html + "\u003Cdiv class=\"location-page bar-page\"\u003E";
        pug_mixins["location-page-header"] = pug_interp = function(title) {
            var block = this && this.block, attributes = this && this.attributes || {};
            pug_html = pug_html + "\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-4\"\u003E\u003Ch1\u003E" + $f2a0e5d5cabb2ae4$var$pug_escape(null == (pug_interp = title) ? "" : pug_interp) + "\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-3-4\"\u003E\u003Cdiv class=\"flex-center\"\u003E";
            if (!isBarchef1) pug_html = pug_html + "\u003Cdiv class=\"cell\"\u003E\u003Cdiv data-hook=\"quick-select\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
            pug_html = pug_html + "\u003Cdiv class=\"cell\"\u003E\u003Cdiv data-hook=\"search-bar\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
            if (isAdmin1) pug_html = pug_html + "\u003Cdiv class=\"cell btn-group\"\u003E\u003Cbutton" + (' class="btn-round pure-button edit-location" data-hook="edit-location"' + $f2a0e5d5cabb2ae4$var$pug_attr("data-title", `${title} bearbeiten`, true, false)) + "\u003E\u003Ci class=\"ion-edit\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton" + (' class="btn-round pure-button add-location" data-hook="add-location"' + $f2a0e5d5cabb2ae4$var$pug_attr("data-title", `${title} hinzuf\xfcgen`, true, false)) + "\u003E\u003Ci class=\"icon ion-plus-round\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E";
            pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"list\" data-hook=\"new-location\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g list\" data-hook=\"location-list\"\u003E\u003C\u002Fdiv\u003E";
        };
        pug_mixins["location-page-header"]("Bars");
        pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }).call(this, "isAdmin" in locals_for_with ? locals_for_with.isAdmin : typeof isAdmin !== 'undefined' ? isAdmin : undefined, "isBarchef" in locals_for_with ? locals_for_with.isBarchef : typeof isBarchef !== 'undefined' ? isBarchef : undefined);
    return pug_html;
}
var $f2a0e5d5cabb2ae4$export$2e2bcd8739ae039 = $f2a0e5d5cabb2ae4$var$template;

});

parcelRegister("kQ5h0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2bcc12a3ac85a83$export$2e2bcd8739ae039; });
function $f2bcc12a3ac85a83$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $f2bcc12a3ac85a83$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $f2bcc12a3ac85a83$var$pug_escape(e) {
    var a = "" + e, t = $f2bcc12a3ac85a83$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $f2bcc12a3ac85a83$var$pug_match_html = /["&<>]/;
function $f2bcc12a3ac85a83$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(isAdmin1, model1) {
        pug_html = pug_html + "\u003Cli class=\"event pure-g\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cspan data-hook=\"name\"\u003E" + $f2bcc12a3ac85a83$var$pug_escape(null == (pug_interp = model1.name) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cdiv class=\"append\"\u003EDu bist " + $f2bcc12a3ac85a83$var$pug_escape(null == (pug_interp = model1.roleLocalized) ? "" : pug_interp) + ".\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-3\"\u003E\u003Cdiv class=\"btn-group buttons\"\u003E\u003Cbutton" + (' class="pure-button btn-round" data-hook="activate"' + $f2bcc12a3ac85a83$var$pug_attr("title", `Zu ${model1.name} wechseln...`, true, false)) + "\u003E\u003Ci class=\"ion-checkmark\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E";
        if (isAdmin1) pug_html = pug_html + "\u003Ca" + (" class=\"pure-button btn-round\"" + $f2bcc12a3ac85a83$var$pug_attr("href", `/einstellungen/${model1.id}`, true, false) + $f2bcc12a3ac85a83$var$pug_attr("title", `Einstellungen f\xfcr ${model1.name}`, true, false)) + "\u003E\u003Ci class=\"ion-ios-gear\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E";
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
    }).call(this, "isAdmin" in locals_for_with ? locals_for_with.isAdmin : typeof isAdmin !== 'undefined' ? isAdmin : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $f2bcc12a3ac85a83$export$2e2bcd8739ae039 = $f2bcc12a3ac85a83$var$template;

});

parcelRegister("5UVch", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44ee8ce0ff5f9867$export$2e2bcd8739ae039; });
function $44ee8ce0ff5f9867$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $44ee8ce0ff5f9867$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $44ee8ce0ff5f9867$var$pug_escape(e) {
    var a = "" + e, t = $44ee8ce0ff5f9867$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $44ee8ce0ff5f9867$var$pug_match_html = /["&<>]/;
function $44ee8ce0ff5f9867$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"pure-u-1\"\u003E\u003Cform class=\"pure-form pure-form-stacked pure-g\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cinput" + (" name=\"name\" type=\"text\" placeholder=\"Name...\"" + $44ee8ce0ff5f9867$var$pug_attr("autofocus", true, true, false) + " autocomplete=\"off\"") + "\u002F\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-3\"\u003E\u003Cdiv class=\"btn-group\"\u003E\u003Cbutton class=\"pure-button\" data-hook=\"cancel\"\u003E\u003Ci class=\"ion-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton" + (' class="pure-button pure-button-primary" type="submit"' + $44ee8ce0ff5f9867$var$pug_attr("disabled", true, true, false)) + "\u003EEvent erstellen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $44ee8ce0ff5f9867$export$2e2bcd8739ae039 = $44ee8ce0ff5f9867$var$template;

});

parcelRegister("bW6o6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b0a10f978a1534d$export$2e2bcd8739ae039; });
function $8b0a10f978a1534d$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $8b0a10f978a1534d$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $8b0a10f978a1534d$var$pug_escape(e) {
    var a = "" + e, t = $8b0a10f978a1534d$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $8b0a10f978a1534d$var$pug_match_html = /["&<>]/;
function $8b0a10f978a1534d$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + '<form class="pure-form pure-form-stacked password-form"><fieldset><legend>Passwort \xe4ndern</legend><label for="oldPassword">Altes Passwort</label><input type="password" name="oldPassword" autocomplete="current-password"/><label for="newPassword">Neues Passwort</label><input type="password" name="newPassword" autocomplete="new-password"/><label for="newPasswordConfirm">Neues Passwort best\xe4tigen</label><input type="password" name="newPasswordConfirm" autocomplete="new-password"/></fieldset><button' + (' class="pure-button" type="submit"' + $8b0a10f978a1534d$var$pug_attr("disabled", true, true, false) + " data-hook=\"submit\"") + '>Passwort \xe4ndern</button><div class="error" data-hook="error"></div></form>';
    return pug_html;
}
var $8b0a10f978a1534d$export$2e2bcd8739ae039 = $8b0a10f978a1534d$var$template;

});

parcelRegister("lymBd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fb0e4db0aa236330$export$2e2bcd8739ae039; });
function $fb0e4db0aa236330$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + '<div class="page settings-page"><h1>Einstellungen</h1><div class="pure-g"><div class="pure-u-1-2"><div class="pure-g"><div class="pure-u-1"><h2>Events</h2></div></div><div class="pure-g"><div class="pure-u-20-24"><div class="append">Hier kannst du Events erstellen, zwischen ihnen wechseln und, wenn du Administrator bist,\nEinstellungen \xe4ndern, andere Nutzer hinzuf\xfcgen oder das Event l\xf6schen.</div></div></div><div class="pure-g"><div class="pure-u-1"><ul class="list" data-hook="event-list"></ul><a href="#" role="button" data-hook="add">Neues Event erstellen...</a></div></div><div class="pure-g" data-hook="create-event"></div></div><div class="pure-u-1-2"><h2>Du</h2><div class="pure-g"><div class="pure-u-1"><div data-hook="username-form"></div></div></div><div class="pure-g"><div class="pure-u-1"><div data-hook="password-form"></div></div></div></div></div></div>';
    return pug_html;
}
var $fb0e4db0aa236330$export$2e2bcd8739ae039 = $fb0e4db0aa236330$var$template;

});

parcelRegister("bZdzP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b9fec5352b66911$export$2e2bcd8739ae039; });
function $8b9fec5352b66911$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(collection1) {
        pug_html = pug_html + "\u003Cdiv class=\"chart-overlay-wrapper\"\u003E\u003Cdiv class=\"chart-wrapper\"\u003E\u003Cdiv class=\"ct-chart products-chart\" data-hook=\"chart\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"chart-overlay\"\u003E\u003C\u002Fdiv\u003E";
        if (!collection1.length) pug_html = pug_html + '<div class="chart-empty-overlay">Leider sind noch keine Best\xe4nde vorhanden.</div>';
        pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }).call(this, "collection" in locals_for_with ? locals_for_with.collection : typeof collection !== 'undefined' ? collection : undefined);
    return pug_html;
}
var $8b9fec5352b66911$export$2e2bcd8739ae039 = $8b9fec5352b66911$var$template;

});

parcelRegister("h6NHq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7498c733153cdf0$export$2e2bcd8739ae039; });
function $c7498c733153cdf0$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $c7498c733153cdf0$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $c7498c733153cdf0$var$pug_escape(e) {
    var a = "" + e, t = $c7498c733153cdf0$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $c7498c733153cdf0$var$pug_match_html = /["&<>]/;
function $c7498c733153cdf0$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(bars1) {
        pug_html = pug_html + '<div class="card"><h4 class="card__header">Umsatzst\xe4rkste Bars</h4><ul class="card__list">';
        (function() {
            var $$obj = bars1;
            if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                var bar = $$obj[pug_index0];
                pug_html = pug_html + "\u003Cli class=\"card__item\"\u003E\u003Cspan class=\"card__item--name\"\u003E\u003Ca" + $c7498c733153cdf0$var$pug_attr("href", bar.link, true, false) + "\u003E" + $c7498c733153cdf0$var$pug_escape(null == (pug_interp = bar.name) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"card__item--value\"\u003E" + $c7498c733153cdf0$var$pug_escape(null == (pug_interp = bar.sumSalesGross) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index0 in $$obj){
                    $$l++;
                    var bar = $$obj[pug_index0];
                    pug_html = pug_html + "\u003Cli class=\"card__item\"\u003E\u003Cspan class=\"card__item--name\"\u003E\u003Ca" + $c7498c733153cdf0$var$pug_attr("href", bar.link, true, false) + "\u003E" + $c7498c733153cdf0$var$pug_escape(null == (pug_interp = bar.name) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"card__item--value\"\u003E" + $c7498c733153cdf0$var$pug_escape(null == (pug_interp = bar.sumSalesGross) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003Cli\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "bars" in locals_for_with ? locals_for_with.bars : typeof bars !== 'undefined' ? bars : undefined);
    return pug_html;
}
var $c7498c733153cdf0$export$2e2bcd8739ae039 = $c7498c733153cdf0$var$template;

});

parcelRegister("fEqzj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02f0c2e4b5700cd9$export$2e2bcd8739ae039; });
function $02f0c2e4b5700cd9$var$pug_escape(e) {
    var a = "" + e, t = $02f0c2e4b5700cd9$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $02f0c2e4b5700cd9$var$pug_match_html = /["&<>]/;
function $02f0c2e4b5700cd9$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(products1) {
        pug_html = pug_html + '<div class="card"><h4 class="card__header">Umsatzst\xe4rkste Produkte</h4><ul class="card__list">';
        (function() {
            var $$obj = products1;
            if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                var product = $$obj[pug_index0];
                pug_html = pug_html + "\u003Cli class=\"card__item\"\u003E\u003Cspan class=\"card__item--name\"\u003E" + $02f0c2e4b5700cd9$var$pug_escape(null == (pug_interp = product.name) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"card__item--value\"\u003E" + $02f0c2e4b5700cd9$var$pug_escape(null == (pug_interp = product.sumLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index0 in $$obj){
                    $$l++;
                    var product = $$obj[pug_index0];
                    pug_html = pug_html + "\u003Cli class=\"card__item\"\u003E\u003Cspan class=\"card__item--name\"\u003E" + $02f0c2e4b5700cd9$var$pug_escape(null == (pug_interp = product.name) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"card__item--value\"\u003E" + $02f0c2e4b5700cd9$var$pug_escape(null == (pug_interp = product.sumLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "products" in locals_for_with ? locals_for_with.products : typeof products !== 'undefined' ? products : undefined);
    return pug_html;
}
var $02f0c2e4b5700cd9$export$2e2bcd8739ae039 = $02f0c2e4b5700cd9$var$template;

});

parcelRegister("1d2Kg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0e192275dd7dc492$export$2e2bcd8739ae039; });
function $0e192275dd7dc492$var$pug_escape(e) {
    var a = "" + e, t = $0e192275dd7dc492$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $0e192275dd7dc492$var$pug_match_html = /["&<>]/;
function $0e192275dd7dc492$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Ctr\u003E\u003Ctd class=\"item-name\"\u003E" + $0e192275dd7dc492$var$pug_escape(null == (pug_interp = model1.product.name) ? "" : pug_interp) + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan class=\"packages\"\u003E" + $0e192275dd7dc492$var$pug_escape(null == (pug_interp = model1.deliveryPackagesLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"units\"\u003E" + $0e192275dd7dc492$var$pug_escape(null == (pug_interp = model1.deliveryUnitsLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        if (model1.freeware) pug_html = pug_html + "\u003Cdiv class=\"append\"\u003Edavon Freiware:\u003C\u002Fdiv\u003E\u003Cdiv class=\"append\"\u003E" + $0e192275dd7dc492$var$pug_escape(null == (pug_interp = model1.freewarePackagesLocalized) ? "" : pug_interp) + " " + $0e192275dd7dc492$var$pug_escape(null == (pug_interp = model1.freewareUnitsLocalized) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan class=\"packages\"\u003E" + $0e192275dd7dc492$var$pug_escape(null == (pug_interp = model1.packagesLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"units\"\u003E" + $0e192275dd7dc492$var$pug_escape(null == (pug_interp = model1.unitsLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan class=\"packages\"\u003E" + $0e192275dd7dc492$var$pug_escape(null == (pug_interp = model1.packagesSoldLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"units\"\u003E" + $0e192275dd7dc492$var$pug_escape(null == (pug_interp = model1.unitsSoldLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $0e192275dd7dc492$export$2e2bcd8739ae039 = $0e192275dd7dc492$var$template;

});

parcelRegister("1O1OG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $150bdea6287cf821$export$2e2bcd8739ae039; });
function $150bdea6287cf821$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $150bdea6287cf821$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $150bdea6287cf821$var$pug_classes(s, r) {
    return Array.isArray(s) ? $150bdea6287cf821$var$pug_classes_array(s, r) : s && "object" == typeof s ? $150bdea6287cf821$var$pug_classes_object(s) : s || "";
}
function $150bdea6287cf821$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $150bdea6287cf821$var$pug_classes(r[g])) && (c && a[g] && (s = $150bdea6287cf821$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $150bdea6287cf821$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $150bdea6287cf821$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $150bdea6287cf821$var$pug_escape(e) {
    var a = "" + e, t = $150bdea6287cf821$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $150bdea6287cf821$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $150bdea6287cf821$var$pug_match_html = /["&<>]/;
function $150bdea6287cf821$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(collection1) {
        pug_mixins["sortableColumn"] = pug_interp = function(prop, descr) {
            var block = this && this.block, attributes = this && this.attributes || {};
            pug_html = pug_html + "\u003Cth" + ($150bdea6287cf821$var$pug_attr("class", $150bdea6287cf821$var$pug_classes([
                [
                    collection1.state.comparator === prop ? 'sorted' : null,
                    collection1.state.order
                ].join(' '),
                "sortable-column"
            ], [
                true,
                false
            ]), false, false) + $150bdea6287cf821$var$pug_attr("data-hook", "sort-" + prop, true, false)) + "\u003E\u003Cspan\u003E" + $150bdea6287cf821$var$pug_escape(null == (pug_interp = descr) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan\u003E\u003Ci class=\"ion-ios-arrow-down\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fth\u003E";
        };
        pug_html = pug_html + "\u003Cdiv class=\"pure-u-1\"\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Ch3\u003EGesamtbestand - Details\u003C\u002Fh3\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv class=\"flex-center\"\u003E\u003Cdiv class=\"cell\"\u003E\u003Cdiv data-hook=\"search-bar\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1\"\u003E\u003Ctable class=\"pure-table table-striped\"\u003E\u003Cthead\u003E\u003Ctr\u003E";
        pug_mixins["sortableColumn"]("name", "Name");
        pug_mixins["sortableColumn"]("delivery", "Lieferung");
        pug_mixins["sortableColumn"]("units", "Bestand");
        pug_html = pug_html + "\u003Cth\u003EVerkauft\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody data-hook=\"list\"\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "collection" in locals_for_with ? locals_for_with.collection : typeof collection !== 'undefined' ? collection : undefined);
    return pug_html;
}
var $150bdea6287cf821$export$2e2bcd8739ae039 = $150bdea6287cf821$var$template;

});

parcelRegister("6zQ33", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c9e62a627e561b5$export$2e2bcd8739ae039; });
function $4c9e62a627e561b5$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(isAdmin1) {
        pug_html = pug_html + '<div class="dashboard-page"><div class="pure-g"><div class="pure-u-1-2"><h1>\xdcbersicht</h1></div></div><div class="pure-g"><div class="pure-u-1"><h2>Produkte</h2><h3>Gesamtbestand</h3><div data-hook="products"></div></div></div><div class="pure-g" data-hook="product-details"></div><div class="pure-g" data-hook="product-locations"></div><div class="pure-g"><div class="pure-u-1 link-wrap"><a role="button" href="#" data-hook="toggle-product-details">Details einblenden...</a></div></div>';
        if (isAdmin1) pug_html = pug_html + "\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1\"\u003E\u003Ch2\u003EUmsatz\u003C\u002Fh2\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-lg-1-2 pure-u-1 card__wrapper\"\u003E\u003Cdiv data-hook=\"best-bars\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-lg-1-2 pure-u-1 card__wrapper\"\u003E\u003Cdiv data-hook=\"best-products\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1\"\u003E\u003Ch2\u003ETransaktionen\u003C\u002Fh2\u003E\u003Cdiv data-hook=\"transactions\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "isAdmin" in locals_for_with ? locals_for_with.isAdmin : typeof isAdmin !== 'undefined' ? isAdmin : undefined);
    return pug_html;
}
var $4c9e62a627e561b5$export$2e2bcd8739ae039 = $4c9e62a627e561b5$var$template;

});

parcelRegister("a3kEa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $751a333936618640$export$2e2bcd8739ae039; });

var $4UX9c = parcelRequire("4UX9c");

var $bKnC7 = parcelRequire("bKnC7");

var $9c5La = parcelRequire("9c5La");

var $gvQO6 = parcelRequire("gvQO6");
function $751a333936618640$var$currency(key) {
    return {
        deps: [
            key
        ],
        fn () {
            return (0, $gvQO6.currency)(this[key]);
        }
    };
}
var $751a333936618640$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bKnC7))).extend({
    urlRoot () {
        return `/api/events/${(0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent.slug}/locations/${this.locationId}/inventories`;
    },
    props: {
        id: {
            type: 'string',
            setOnce: true
        },
        shiftEndTime: {
            type: 'date',
            required: true,
            default () {
                return new Date();
            }
        },
        amountGiven: {
            type: 'string',
            default: '0'
        },
        barChef: 'string',
        shiftName: 'string',
        tokens: [
            'number',
            true,
            0
        ],
        comment: 'string',
        locationId: [
            'string',
            true
        ],
        createdAt: 'string',
        user: 'object'
    },
    session: {
        sumSold: [
            'number',
            true,
            0
        ],
        difference: [
            'number',
            true,
            0
        ]
    },
    derived: {
        location: {
            deps: [
                'locationId'
            ],
            fn () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).locations.get(this.locationId) || {};
            }
        },
        createdAtLocalized: {
            deps: [
                'createdAt'
            ],
            fn () {
                return (0, $9c5La.DateTime).fromISO(this.createdAt).toLocaleString((0, $9c5La.DateTime).DATETIME_SHORT);
            }
        },
        shiftEndTimeLocalized: {
            deps: [
                'shiftEndTime'
            ],
            fn () {
                return (0, $9c5La.DateTime).fromJSDate(this.shiftEndTime).toLocaleString((0, $9c5La.DateTime).DATETIME_SHORT);
            }
        },
        salesWithoutTokens: {
            deps: [
                'sumSold',
                'tokensValue'
            ],
            fn () {
                return this.sumSold - this.tokensValue;
            }
        },
        salesWithoutTokensLocalized: $751a333936618640$var$currency('salesWithoutTokens'),
        differenceWithoutTokens: {
            deps: [
                'salesWithoutTokens',
                'amountGiven'
            ],
            fn () {
                return this.amountGiven - this.salesWithoutTokens;
            }
        },
        differenceWithoutTokensLocalized: $751a333936618640$var$currency('differenceWithoutTokens'),
        differenceLocalized: $751a333936618640$var$currency('difference'),
        sumSoldLocalized: $751a333936618640$var$currency('sumSold'),
        amountGivenLocalized: $751a333936618640$var$currency('amountGiven'),
        tokensValue: {
            deps: [
                'tokens'
            ],
            fn () {
                return this.tokens * (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent.tokenValue;
            }
        },
        tokensLocalized: $751a333936618640$var$currency('tokensValue'),
        isDifferenceNegative: {
            deps: [
                'differenceWithoutTokens'
            ],
            fn () {
                return this.differenceWithoutTokens < 0;
            }
        },
        isSumSoldNegative: {
            deps: [
                'sumSold'
            ],
            fn () {
                return this.sumSold < 0;
            }
        },
        _nameIndex: {
            deps: [
                'shiftName'
            ],
            fn () {
                return (0, $gvQO6.indexify)(this.shiftName) || '';
            }
        }
    },
    validate () {
        if (!this.shiftName) return 'Bitte Schichtname angeben.';
    }
});

});
parcelRegister("bKnC7", function(module, exports) {
/*$AMPERSAND_VERSION*/ 
var $kw3w9 = parcelRequire("kw3w9");

var $cekly = parcelRequire("cekly");

var $akRxj = parcelRequire("akRxj");

var $5DUFR = parcelRequire("5DUFR");

var $k42iZ = parcelRequire("k42iZ");

var $a0MTb = parcelRequire("a0MTb");
// Throw an error when a URL is needed, and none is supplied.
var $88d64ed28b576474$var$urlError = function() {
    throw new Error('A "url" property or function must be specified');
};
// Wrap an optional error callback with a fallback error event.
var $88d64ed28b576474$var$wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
        if (error) error(model, resp, options);
        model.trigger('error', model, resp, options);
    };
};
var $88d64ed28b576474$var$Model = $kw3w9.extend({
    save: function(key, val, options) {
        var attrs, method;
        // Handle both `"key", value` and `{key: value}` -style arguments.
        if (key == null || typeof key === 'object') {
            attrs = key;
            options = val;
        } else (attrs = {})[key] = val;
        options = $akRxj({
            validate: true
        }, options);
        // If we're not waiting and attributes exist, save acts as
        // `set(attr).save(null, opts)` with validation. Otherwise, check if
        // the model will be valid when the attributes, if any, are set.
        if (attrs && !options.wait) {
            if (!this.set(attrs, options)) return false;
        } else {
            if (!this._validate(attrs, options)) return false;
        }
        // After a successful server-side save, the client is (optionally)
        // updated with the server-side state.
        if (options.parse === void 0) options.parse = true;
        var model = this;
        var success = options.success;
        options.success = function(resp) {
            var serverAttrs = model.parse(resp, options);
            if (options.wait) serverAttrs = $akRxj(attrs || {}, serverAttrs);
            if ($5DUFR(serverAttrs) && !model.set(serverAttrs, options)) return false;
            if (success) success(model, resp, options);
            model.trigger('sync', model, resp, options);
        };
        $88d64ed28b576474$var$wrapError(this, options);
        method = this.isNew() ? 'create' : options.patch ? 'patch' : 'update';
        if (method === 'patch') options.attrs = attrs;
        // if we're waiting we haven't actually set our attributes yet so
        // we need to do make sure we send right data
        if (options.wait && method !== 'patch') options.attrs = $akRxj(model.serialize(), attrs);
        var sync = this.sync(method, this, options);
        // Make the request available on the options object so it can be accessed
        // further down the line by `parse`, attached listeners, etc
        // Same thing is done below for fetch and destroy
        // https://github.com/AmpersandJS/ampersand-collection-rest-mixin/commit/d32d788aaff912387eb1106f2d7ad183ec39e11a#diff-84c84703169bf5017b1bc323653acaa3R32
        options.xhr = sync;
        return sync;
    },
    // Fetch the model from the server. If the server's representation of the
    // model differs from its current attributes, they will be overridden,
    // triggering a `"change"` event.
    fetch: function(options) {
        options = options ? $k42iZ(options) : {};
        if (options.parse === void 0) options.parse = true;
        var model = this;
        var success = options.success;
        options.success = function(resp) {
            if (!model.set(model.parse(resp, options), options)) return false;
            if (success) success(model, resp, options);
            model.trigger('sync', model, resp, options);
        };
        $88d64ed28b576474$var$wrapError(this, options);
        var sync = this.sync('read', this, options);
        options.xhr = sync;
        return sync;
    },
    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
        options = options ? $k42iZ(options) : {};
        var model = this;
        var success = options.success;
        var destroy = function() {
            model.trigger('destroy', model, model.collection, options);
        };
        options.success = function(resp) {
            if (options.wait || model.isNew()) destroy();
            if (success) success(model, resp, options);
            if (!model.isNew()) model.trigger('sync', model, resp, options);
        };
        if (this.isNew()) {
            options.success();
            return false;
        }
        $88d64ed28b576474$var$wrapError(this, options);
        var sync = this.sync('delete', this, options);
        options.xhr = sync;
        if (!options.wait) destroy();
        return sync;
    },
    // Proxy `ampersand-sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
        return $cekly.apply(this, arguments);
    },
    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
        var base = $a0MTb(this, 'urlRoot') || $a0MTb(this.collection, 'url') || $88d64ed28b576474$var$urlError();
        if (this.isNew()) return base;
        return base + (base.charAt(base.length - 1) === '/' ? '' : '/') + encodeURIComponent(this.getId());
    }
});
module.exports = $88d64ed28b576474$var$Model;

});
parcelRegister("cekly", function(module, exports) {

var $2Nn60 = parcelRequire("2Nn60");

module.exports = (parcelRequire("efEER"))($2Nn60);

});
parcelRegister("2Nn60", function(module, exports) {
"use strict";

var $7rSDu = parcelRequire("7rSDu");

var $hqanA = parcelRequire("hqanA");

var $lJSgr = parcelRequire("lJSgr");

var $bolTI = parcelRequire("bolTI");
module.exports = $209212bd62bb3ca1$var$createXHR;
$209212bd62bb3ca1$var$createXHR.XMLHttpRequest = $7rSDu.XMLHttpRequest || $209212bd62bb3ca1$var$noop;
$209212bd62bb3ca1$var$createXHR.XDomainRequest = "withCredentials" in new $209212bd62bb3ca1$var$createXHR.XMLHttpRequest() ? $209212bd62bb3ca1$var$createXHR.XMLHttpRequest : $7rSDu.XDomainRequest;
$209212bd62bb3ca1$var$forEachArray([
    "get",
    "put",
    "post",
    "patch",
    "head",
    "delete"
], function(method) {
    $209212bd62bb3ca1$var$createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
        options = $209212bd62bb3ca1$var$initParams(uri, options, callback);
        options.method = method.toUpperCase();
        return $209212bd62bb3ca1$var$_createXHR(options);
    };
});
function $209212bd62bb3ca1$var$forEachArray(array, iterator) {
    for(var i = 0; i < array.length; i++)iterator(array[i]);
}
function $209212bd62bb3ca1$var$isEmpty(obj) {
    for(var i in obj){
        if (obj.hasOwnProperty(i)) return false;
    }
    return true;
}
function $209212bd62bb3ca1$var$initParams(uri, options, callback) {
    var params = uri;
    if ($hqanA(options)) {
        callback = options;
        if (typeof uri === "string") params = {
            uri: uri
        };
    } else params = $bolTI(options, {
        uri: uri
    });
    params.callback = callback;
    return params;
}
function $209212bd62bb3ca1$var$createXHR(uri, options, callback) {
    options = $209212bd62bb3ca1$var$initParams(uri, options, callback);
    return $209212bd62bb3ca1$var$_createXHR(options);
}
function $209212bd62bb3ca1$var$_createXHR(options) {
    if (typeof options.callback === "undefined") throw new Error("callback argument missing");
    var called = false;
    var callback = function cbOnce(err, response, body) {
        if (!called) {
            called = true;
            options.callback(err, response, body);
        }
    };
    function readystatechange() {
        if (xhr.readyState === 4) loadFunc();
    }
    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined;
        if (xhr.response) body = xhr.response;
        else body = xhr.responseText || $209212bd62bb3ca1$var$getXml(xhr);
        if (isJson) try {
            body = JSON.parse(body);
        } catch (e) {}
        return body;
    }
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    };
    function errorFunc(evt) {
        clearTimeout(timeoutTimer);
        if (!(evt instanceof Error)) evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
        evt.statusCode = 0;
        return callback(evt, failureResponse);
    }
    // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return;
        var status;
        clearTimeout(timeoutTimer);
        if (options.useXDR && xhr.status === undefined) //IE8 CORS GET successful response doesn't have a status field, but body is fine
        status = 200;
        else status = xhr.status === 1223 ? 204 : xhr.status;
        var response = failureResponse;
        var err = null;
        if (status !== 0) {
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            };
            if (xhr.getAllResponseHeaders) response.headers = $lJSgr(xhr.getAllResponseHeaders());
        } else err = new Error("Internal XMLHttpRequest Error");
        return callback(err, response, response.body);
    }
    var xhr = options.xhr || null;
    if (!xhr) {
        if (options.cors || options.useXDR) xhr = new $209212bd62bb3ca1$var$createXHR.XDomainRequest();
        else xhr = new $209212bd62bb3ca1$var$createXHR.XMLHttpRequest();
    }
    var key;
    var aborted;
    var uri = xhr.url = options.uri || options.url;
    var method = xhr.method = options.method || "GET";
    var body = options.body || options.data || null;
    var headers = xhr.headers = options.headers || {};
    var sync = !!options.sync;
    var isJson = false;
    var timeoutTimer;
    if ("json" in options) {
        isJson = true;
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json" //Don't override existing accept header declared by user
        );
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json" //Don't override existing accept header declared by user
            );
            body = JSON.stringify(options.json);
        }
    }
    xhr.onreadystatechange = readystatechange;
    xhr.onload = loadFunc;
    xhr.onerror = errorFunc;
    // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function() {
    // IE must die
    };
    xhr.ontimeout = errorFunc;
    xhr.open(method, uri, !sync, options.username, options.password);
    //has to be after open
    if (!sync) xhr.withCredentials = !!options.withCredentials;
    // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0) timeoutTimer = setTimeout(function() {
        aborted = true //IE9 may still call readystatechange
        ;
        xhr.abort("timeout");
        var e = new Error("XMLHttpRequest timeout");
        e.code = "ETIMEDOUT";
        errorFunc(e);
    }, options.timeout);
    if (xhr.setRequestHeader) {
        for(key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    } else if (options.headers && !$209212bd62bb3ca1$var$isEmpty(options.headers)) throw new Error("Headers cannot be set on an XDomainRequest object");
    if ("responseType" in options) xhr.responseType = options.responseType;
    if ("beforeSend" in options && typeof options.beforeSend === "function") options.beforeSend(xhr);
    xhr.send(body);
    return xhr;
}
function $209212bd62bb3ca1$var$getXml(xhr) {
    if (xhr.responseType === "document") return xhr.responseXML;
    var firefoxBugTakenEffect = xhr.status === 204 && xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
    if (xhr.responseType === "" && !firefoxBugTakenEffect) return xhr.responseXML;
    return null;
}
function $209212bd62bb3ca1$var$noop() {}

});
parcelRegister("7rSDu", function(module, exports) {
var $56c56f9a6057e764$var$win;
if (typeof window !== "undefined") $56c56f9a6057e764$var$win = window;
else if (typeof $parcel$global !== "undefined") $56c56f9a6057e764$var$win = $parcel$global;
else if (typeof self !== "undefined") $56c56f9a6057e764$var$win = self;
else $56c56f9a6057e764$var$win = {};
module.exports = $56c56f9a6057e764$var$win;

});

parcelRegister("hqanA", function(module, exports) {
module.exports = $caecea7e16e88d92$var$isFunction;
var $caecea7e16e88d92$var$toString = Object.prototype.toString;
function $caecea7e16e88d92$var$isFunction(fn) {
    var string = $caecea7e16e88d92$var$toString.call(fn);
    return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && // IE8 and below
    (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
}

});

parcelRegister("lJSgr", function(module, exports) {

var $aPdrE = parcelRequire("aPdrE");

var $eRd5J = parcelRequire("eRd5J");
var $fd37e4aaf39171a7$var$isArray = function(arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
};
module.exports = function(headers) {
    if (!headers) return {};
    var result = {};
    $eRd5J($aPdrE(headers).split('\n'), function(row) {
        var index = row.indexOf(':'), key = $aPdrE(row.slice(0, index)).toLowerCase(), value = $aPdrE(row.slice(index + 1));
        if (typeof result[key] === 'undefined') result[key] = value;
        else if ($fd37e4aaf39171a7$var$isArray(result[key])) result[key].push(value);
        else result[key] = [
            result[key],
            value
        ];
    });
    return result;
};

});
parcelRegister("eRd5J", function(module, exports) {

var $hqanA = parcelRequire("hqanA");
module.exports = $ad102b9e77bd1452$var$forEach;
var $ad102b9e77bd1452$var$toString = Object.prototype.toString;
var $ad102b9e77bd1452$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $ad102b9e77bd1452$var$forEach(list, iterator, context) {
    if (!$hqanA(iterator)) throw new TypeError('iterator must be a function');
    if (arguments.length < 3) context = this;
    if ($ad102b9e77bd1452$var$toString.call(list) === '[object Array]') $ad102b9e77bd1452$var$forEachArray(list, iterator, context);
    else if (typeof list === 'string') $ad102b9e77bd1452$var$forEachString(list, iterator, context);
    else $ad102b9e77bd1452$var$forEachObject(list, iterator, context);
}
function $ad102b9e77bd1452$var$forEachArray(array, iterator, context) {
    for(var i = 0, len = array.length; i < len; i++)if ($ad102b9e77bd1452$var$hasOwnProperty.call(array, i)) iterator.call(context, array[i], i, array);
}
function $ad102b9e77bd1452$var$forEachString(string, iterator, context) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    iterator.call(context, string.charAt(i), i, string);
}
function $ad102b9e77bd1452$var$forEachObject(object, iterator, context) {
    for(var k in object)if ($ad102b9e77bd1452$var$hasOwnProperty.call(object, k)) iterator.call(context, object[k], k, object);
}

});


parcelRegister("bolTI", function(module, exports) {
module.exports = $84b2ec02e0f2de0c$var$extend;
var $84b2ec02e0f2de0c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $84b2ec02e0f2de0c$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($84b2ec02e0f2de0c$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});



parcelRegister("k42iZ", function(module, exports) {

var $3R1Uz = parcelRequire("3R1Uz");
/** Used to compose bitmasks for cloning. */ var $e9b5f823b94e8fc6$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $e9b5f823b94e8fc6$var$clone(value) {
    return $3R1Uz(value, $e9b5f823b94e8fc6$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $e9b5f823b94e8fc6$var$clone;

});


parcelRegister("9c5La", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $6b19b3cf1ff123ca$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6b19b3cf1ff123ca$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6b19b3cf1ff123ca$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6b19b3cf1ff123ca$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6b19b3cf1ff123ca$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6b19b3cf1ff123ca$var$_extends() {
    $6b19b3cf1ff123ca$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6b19b3cf1ff123ca$var$_extends.apply(this, arguments);
}
function $6b19b3cf1ff123ca$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $6b19b3cf1ff123ca$var$_setPrototypeOf(subClass, superClass);
}
function $6b19b3cf1ff123ca$var$_getPrototypeOf(o) {
    $6b19b3cf1ff123ca$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6b19b3cf1ff123ca$var$_getPrototypeOf(o);
}
function $6b19b3cf1ff123ca$var$_setPrototypeOf(o, p) {
    $6b19b3cf1ff123ca$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6b19b3cf1ff123ca$var$_setPrototypeOf(o, p);
}
function $6b19b3cf1ff123ca$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6b19b3cf1ff123ca$var$_construct(Parent, args, Class) {
    if ($6b19b3cf1ff123ca$var$_isNativeReflectConstruct()) $6b19b3cf1ff123ca$var$_construct = Reflect.construct.bind();
    else $6b19b3cf1ff123ca$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $6b19b3cf1ff123ca$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $6b19b3cf1ff123ca$var$_construct.apply(null, arguments);
}
function $6b19b3cf1ff123ca$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $6b19b3cf1ff123ca$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $6b19b3cf1ff123ca$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$6b19b3cf1ff123ca$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $6b19b3cf1ff123ca$var$_construct(Class, arguments, $6b19b3cf1ff123ca$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $6b19b3cf1ff123ca$var$_setPrototypeOf(Wrapper, Class);
    };
    return $6b19b3cf1ff123ca$var$_wrapNativeSuper(Class);
}
function $6b19b3cf1ff123ca$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6b19b3cf1ff123ca$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6b19b3cf1ff123ca$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6b19b3cf1ff123ca$var$_arrayLikeToArray(o, minLen);
}
function $6b19b3cf1ff123ca$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6b19b3cf1ff123ca$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $6b19b3cf1ff123ca$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6b19b3cf1ff123ca$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6b19b3cf1ff123ca$var$_toPropertyKey(arg) {
    var key = $6b19b3cf1ff123ca$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $6b19b3cf1ff123ca$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($6b19b3cf1ff123ca$var$LuxonError);
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($6b19b3cf1ff123ca$var$LuxonError);
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($6b19b3cf1ff123ca$var$LuxonError);
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($6b19b3cf1ff123ca$var$LuxonError);
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($6b19b3cf1ff123ca$var$LuxonError);
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($6b19b3cf1ff123ca$var$LuxonError);
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($6b19b3cf1ff123ca$var$LuxonError);
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$n = "numeric", $6b19b3cf1ff123ca$var$s = "short", $6b19b3cf1ff123ca$var$l = "long";
var $6b19b3cf1ff123ca$var$DATE_SHORT = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$n,
    day: $6b19b3cf1ff123ca$var$n
};
var $6b19b3cf1ff123ca$var$DATE_MED = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$s,
    day: $6b19b3cf1ff123ca$var$n
};
var $6b19b3cf1ff123ca$var$DATE_MED_WITH_WEEKDAY = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$s,
    day: $6b19b3cf1ff123ca$var$n,
    weekday: $6b19b3cf1ff123ca$var$s
};
var $6b19b3cf1ff123ca$var$DATE_FULL = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$l,
    day: $6b19b3cf1ff123ca$var$n
};
var $6b19b3cf1ff123ca$var$DATE_HUGE = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$l,
    day: $6b19b3cf1ff123ca$var$n,
    weekday: $6b19b3cf1ff123ca$var$l
};
var $6b19b3cf1ff123ca$var$TIME_SIMPLE = {
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n
};
var $6b19b3cf1ff123ca$var$TIME_WITH_SECONDS = {
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    second: $6b19b3cf1ff123ca$var$n
};
var $6b19b3cf1ff123ca$var$TIME_WITH_SHORT_OFFSET = {
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    second: $6b19b3cf1ff123ca$var$n,
    timeZoneName: $6b19b3cf1ff123ca$var$s
};
var $6b19b3cf1ff123ca$var$TIME_WITH_LONG_OFFSET = {
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    second: $6b19b3cf1ff123ca$var$n,
    timeZoneName: $6b19b3cf1ff123ca$var$l
};
var $6b19b3cf1ff123ca$var$TIME_24_SIMPLE = {
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    hourCycle: "h23"
};
var $6b19b3cf1ff123ca$var$TIME_24_WITH_SECONDS = {
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    second: $6b19b3cf1ff123ca$var$n,
    hourCycle: "h23"
};
var $6b19b3cf1ff123ca$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    second: $6b19b3cf1ff123ca$var$n,
    hourCycle: "h23",
    timeZoneName: $6b19b3cf1ff123ca$var$s
};
var $6b19b3cf1ff123ca$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    second: $6b19b3cf1ff123ca$var$n,
    hourCycle: "h23",
    timeZoneName: $6b19b3cf1ff123ca$var$l
};
var $6b19b3cf1ff123ca$var$DATETIME_SHORT = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$n,
    day: $6b19b3cf1ff123ca$var$n,
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n
};
var $6b19b3cf1ff123ca$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$n,
    day: $6b19b3cf1ff123ca$var$n,
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    second: $6b19b3cf1ff123ca$var$n
};
var $6b19b3cf1ff123ca$var$DATETIME_MED = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$s,
    day: $6b19b3cf1ff123ca$var$n,
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n
};
var $6b19b3cf1ff123ca$var$DATETIME_MED_WITH_SECONDS = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$s,
    day: $6b19b3cf1ff123ca$var$n,
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    second: $6b19b3cf1ff123ca$var$n
};
var $6b19b3cf1ff123ca$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$s,
    day: $6b19b3cf1ff123ca$var$n,
    weekday: $6b19b3cf1ff123ca$var$s,
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n
};
var $6b19b3cf1ff123ca$var$DATETIME_FULL = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$l,
    day: $6b19b3cf1ff123ca$var$n,
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    timeZoneName: $6b19b3cf1ff123ca$var$s
};
var $6b19b3cf1ff123ca$var$DATETIME_FULL_WITH_SECONDS = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$l,
    day: $6b19b3cf1ff123ca$var$n,
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    second: $6b19b3cf1ff123ca$var$n,
    timeZoneName: $6b19b3cf1ff123ca$var$s
};
var $6b19b3cf1ff123ca$var$DATETIME_HUGE = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$l,
    day: $6b19b3cf1ff123ca$var$n,
    weekday: $6b19b3cf1ff123ca$var$l,
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    timeZoneName: $6b19b3cf1ff123ca$var$l
};
var $6b19b3cf1ff123ca$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $6b19b3cf1ff123ca$var$n,
    month: $6b19b3cf1ff123ca$var$l,
    day: $6b19b3cf1ff123ca$var$n,
    weekday: $6b19b3cf1ff123ca$var$l,
    hour: $6b19b3cf1ff123ca$var$n,
    minute: $6b19b3cf1ff123ca$var$n,
    second: $6b19b3cf1ff123ca$var$n,
    timeZoneName: $6b19b3cf1ff123ca$var$l
};
/**
 * @interface
 */ var $6b19b3cf1ff123ca$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $6b19b3cf1ff123ca$var$ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $6b19b3cf1ff123ca$var$ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new $6b19b3cf1ff123ca$var$ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new $6b19b3cf1ff123ca$var$ZoneIsAbstractError();
    };
    $6b19b3cf1ff123ca$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $6b19b3cf1ff123ca$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $6b19b3cf1ff123ca$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $6b19b3cf1ff123ca$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $6b19b3cf1ff123ca$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $6b19b3cf1ff123ca$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $6b19b3cf1ff123ca$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $6b19b3cf1ff123ca$var$parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $6b19b3cf1ff123ca$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    };
    $6b19b3cf1ff123ca$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($6b19b3cf1ff123ca$var$singleton$1 === null) $6b19b3cf1ff123ca$var$singleton$1 = new SystemZone();
                return $6b19b3cf1ff123ca$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($6b19b3cf1ff123ca$var$Zone);
var $6b19b3cf1ff123ca$var$dtfCache = {};
function $6b19b3cf1ff123ca$var$makeDTF(zone) {
    if (!$6b19b3cf1ff123ca$var$dtfCache[zone]) $6b19b3cf1ff123ca$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $6b19b3cf1ff123ca$var$dtfCache[zone];
}
var $6b19b3cf1ff123ca$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $6b19b3cf1ff123ca$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $6b19b3cf1ff123ca$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $6b19b3cf1ff123ca$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$6b19b3cf1ff123ca$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $6b19b3cf1ff123ca$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $6b19b3cf1ff123ca$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$6b19b3cf1ff123ca$var$ianaZoneCache[name]) $6b19b3cf1ff123ca$var$ianaZoneCache[name] = new IANAZone(name);
        return $6b19b3cf1ff123ca$var$ianaZoneCache[name];
    };
    IANAZone.resetCache = function resetCache() {
        $6b19b3cf1ff123ca$var$ianaZoneCache = {};
        $6b19b3cf1ff123ca$var$dtfCache = {};
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $6b19b3cf1ff123ca$var$parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $6b19b3cf1ff123ca$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $6b19b3cf1ff123ca$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $6b19b3cf1ff123ca$var$partsOffset(dtf, date) : $6b19b3cf1ff123ca$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $6b19b3cf1ff123ca$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    $6b19b3cf1ff123ca$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($6b19b3cf1ff123ca$var$Zone);
var $6b19b3cf1ff123ca$var$_excluded = [
    "base"
], $6b19b3cf1ff123ca$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $6b19b3cf1ff123ca$var$intlLFCache = {};
function $6b19b3cf1ff123ca$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $6b19b3cf1ff123ca$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $6b19b3cf1ff123ca$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $6b19b3cf1ff123ca$var$intlDTCache = {};
function $6b19b3cf1ff123ca$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $6b19b3cf1ff123ca$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $6b19b3cf1ff123ca$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $6b19b3cf1ff123ca$var$intlNumCache = {};
function $6b19b3cf1ff123ca$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $6b19b3cf1ff123ca$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $6b19b3cf1ff123ca$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $6b19b3cf1ff123ca$var$intlRelCache = {};
function $6b19b3cf1ff123ca$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $6b19b3cf1ff123ca$var$_objectWithoutPropertiesLoose(_opts, $6b19b3cf1ff123ca$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $6b19b3cf1ff123ca$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $6b19b3cf1ff123ca$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $6b19b3cf1ff123ca$var$sysLocaleCache = null;
function $6b19b3cf1ff123ca$var$systemLocale() {
    if ($6b19b3cf1ff123ca$var$sysLocaleCache) return $6b19b3cf1ff123ca$var$sysLocaleCache;
    else {
        $6b19b3cf1ff123ca$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $6b19b3cf1ff123ca$var$sysLocaleCache;
    }
}
function $6b19b3cf1ff123ca$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $6b19b3cf1ff123ca$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $6b19b3cf1ff123ca$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $6b19b3cf1ff123ca$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $6b19b3cf1ff123ca$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $6b19b3cf1ff123ca$var$DateTime.utc(2016, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $6b19b3cf1ff123ca$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $6b19b3cf1ff123ca$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $6b19b3cf1ff123ca$var$listStuff(loc, length, defaultOK, englishFn, intlFn) {
    var mode = loc.listingMode(defaultOK);
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $6b19b3cf1ff123ca$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $6b19b3cf1ff123ca$var$_objectWithoutPropertiesLoose(opts, $6b19b3cf1ff123ca$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $6b19b3cf1ff123ca$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $6b19b3cf1ff123ca$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $6b19b3cf1ff123ca$var$roundTo(i, 3);
            return $6b19b3cf1ff123ca$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $6b19b3cf1ff123ca$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $6b19b3cf1ff123ca$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $6b19b3cf1ff123ca$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $6b19b3cf1ff123ca$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $6b19b3cf1ff123ca$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $6b19b3cf1ff123ca$var$hasRelative()) this.rtf = $6b19b3cf1ff123ca$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $6b19b3cf1ff123ca$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $6b19b3cf1ff123ca$var$Settings.defaultLocale;
        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $6b19b3cf1ff123ca$var$systemLocale());
        var numberingSystemR = numberingSystem || $6b19b3cf1ff123ca$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $6b19b3cf1ff123ca$var$Settings.defaultOutputCalendar;
        return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $6b19b3cf1ff123ca$var$sysLocaleCache = null;
        $6b19b3cf1ff123ca$var$intlDTCache = {};
        $6b19b3cf1ff123ca$var$intlNumCache = {};
        $6b19b3cf1ff123ca$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar;
        return Locale.create(locale, numberingSystem, outputCalendar);
    };
    function Locale(locale, numbering, outputCalendar, specifiedLocale) {
        var _parseLocaleString = $6b19b3cf1ff123ca$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $6b19b3cf1ff123ca$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($6b19b3cf1ff123ca$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($6b19b3cf1ff123ca$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format, defaultOK) {
        var _this2 = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $6b19b3cf1ff123ca$var$listStuff(this, length, defaultOK, $6b19b3cf1ff123ca$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) _this2.monthsCache[formatStr][length] = $6b19b3cf1ff123ca$var$mapMonths(function(dt) {
                return _this2.extract(dt, intl, "month");
            });
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
        var _this3 = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $6b19b3cf1ff123ca$var$listStuff(this, length, defaultOK, $6b19b3cf1ff123ca$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $6b19b3cf1ff123ca$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1(defaultOK) {
        var _this4 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $6b19b3cf1ff123ca$var$listStuff(this, undefined, defaultOK, function() {
            return $6b19b3cf1ff123ca$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $6b19b3cf1ff123ca$var$DateTime.utc(2016, 11, 13, 9),
                    $6b19b3cf1ff123ca$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length, defaultOK) {
        var _this5 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $6b19b3cf1ff123ca$var$listStuff(this, length, defaultOK, $6b19b3cf1ff123ca$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $6b19b3cf1ff123ca$var$DateTime.utc(-40, 1, 1),
                $6b19b3cf1ff123ca$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $6b19b3cf1ff123ca$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $6b19b3cf1ff123ca$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $6b19b3cf1ff123ca$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $6b19b3cf1ff123ca$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $6b19b3cf1ff123ca$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $6b19b3cf1ff123ca$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $6b19b3cf1ff123ca$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $6b19b3cf1ff123ca$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($6b19b3cf1ff123ca$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $6b19b3cf1ff123ca$var$formatOffset(this.fixed, format);
    };
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    $6b19b3cf1ff123ca$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $6b19b3cf1ff123ca$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $6b19b3cf1ff123ca$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($6b19b3cf1ff123ca$var$singleton === null) $6b19b3cf1ff123ca$var$singleton = new FixedOffsetZone(0);
                return $6b19b3cf1ff123ca$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($6b19b3cf1ff123ca$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $6b19b3cf1ff123ca$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $6b19b3cf1ff123ca$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    $6b19b3cf1ff123ca$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($6b19b3cf1ff123ca$var$Zone);
/**
 * @private
 */ function $6b19b3cf1ff123ca$var$normalizeZone(input, defaultZone) {
    if ($6b19b3cf1ff123ca$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $6b19b3cf1ff123ca$var$Zone) return input;
    else if ($6b19b3cf1ff123ca$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $6b19b3cf1ff123ca$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $6b19b3cf1ff123ca$var$FixedOffsetZone.utcInstance;
        else return $6b19b3cf1ff123ca$var$FixedOffsetZone.parseSpecifier(lowered) || $6b19b3cf1ff123ca$var$IANAZone.create(input);
    } else if ($6b19b3cf1ff123ca$var$isNumber(input)) return $6b19b3cf1ff123ca$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && input.offset && typeof input.offset === "number") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $6b19b3cf1ff123ca$var$InvalidZone(input);
}
var $6b19b3cf1ff123ca$var$now = function now() {
    return Date.now();
}, $6b19b3cf1ff123ca$var$defaultZone = "system", $6b19b3cf1ff123ca$var$defaultLocale = null, $6b19b3cf1ff123ca$var$defaultNumberingSystem = null, $6b19b3cf1ff123ca$var$defaultOutputCalendar = null, $6b19b3cf1ff123ca$var$twoDigitCutoffYear = 60, $6b19b3cf1ff123ca$var$throwOnInvalid;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $6b19b3cf1ff123ca$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $6b19b3cf1ff123ca$var$Locale.resetCache();
        $6b19b3cf1ff123ca$var$IANAZone.resetCache();
    };
    $6b19b3cf1ff123ca$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $6b19b3cf1ff123ca$var$now;
            },
            set: function set(n) {
                $6b19b3cf1ff123ca$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $6b19b3cf1ff123ca$var$normalizeZone($6b19b3cf1ff123ca$var$defaultZone, $6b19b3cf1ff123ca$var$SystemZone.instance);
            },
            set: function set(zone) {
                $6b19b3cf1ff123ca$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $6b19b3cf1ff123ca$var$defaultLocale;
            },
            set: function set(locale) {
                $6b19b3cf1ff123ca$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $6b19b3cf1ff123ca$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $6b19b3cf1ff123ca$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $6b19b3cf1ff123ca$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $6b19b3cf1ff123ca$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $6b19b3cf1ff123ca$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $6b19b3cf1ff123ca$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $6b19b3cf1ff123ca$var$throwOnInvalid;
            },
            set: function set(t) {
                $6b19b3cf1ff123ca$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
/**
 * @private
 */ // TYPES
function $6b19b3cf1ff123ca$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $6b19b3cf1ff123ca$var$isNumber(o) {
    return typeof o === "number";
}
function $6b19b3cf1ff123ca$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $6b19b3cf1ff123ca$var$isString(o) {
    return typeof o === "string";
}
function $6b19b3cf1ff123ca$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $6b19b3cf1ff123ca$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $6b19b3cf1ff123ca$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $6b19b3cf1ff123ca$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $6b19b3cf1ff123ca$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $6b19b3cf1ff123ca$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
// NUMBERS AND STRINGS
function $6b19b3cf1ff123ca$var$integerBetween(thing, bottom, top) {
    return $6b19b3cf1ff123ca$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $6b19b3cf1ff123ca$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $6b19b3cf1ff123ca$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $6b19b3cf1ff123ca$var$parseInteger(string) {
    if ($6b19b3cf1ff123ca$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $6b19b3cf1ff123ca$var$parseFloating(string) {
    if ($6b19b3cf1ff123ca$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $6b19b3cf1ff123ca$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($6b19b3cf1ff123ca$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $6b19b3cf1ff123ca$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
// DATE BASICS
function $6b19b3cf1ff123ca$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $6b19b3cf1ff123ca$var$daysInYear(year) {
    return $6b19b3cf1ff123ca$var$isLeapYear(year) ? 366 : 365;
}
function $6b19b3cf1ff123ca$var$daysInMonth(year, month) {
    var modMonth = $6b19b3cf1ff123ca$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $6b19b3cf1ff123ca$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// covert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $6b19b3cf1ff123ca$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
function $6b19b3cf1ff123ca$var$weeksInWeekYear(weekYear) {
    var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $6b19b3cf1ff123ca$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $6b19b3cf1ff123ca$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $6b19b3cf1ff123ca$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $6b19b3cf1ff123ca$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $6b19b3cf1ff123ca$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $6b19b3cf1ff123ca$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $6b19b3cf1ff123ca$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($6b19b3cf1ff123ca$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $6b19b3cf1ff123ca$var$asNumber(v);
    }
    return normalized;
}
function $6b19b3cf1ff123ca$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $6b19b3cf1ff123ca$var$padStart(hours, 2) + ":" + $6b19b3cf1ff123ca$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $6b19b3cf1ff123ca$var$padStart(hours, 2) + $6b19b3cf1ff123ca$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $6b19b3cf1ff123ca$var$timeObject(obj) {
    return $6b19b3cf1ff123ca$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $6b19b3cf1ff123ca$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $6b19b3cf1ff123ca$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $6b19b3cf1ff123ca$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($6b19b3cf1ff123ca$var$monthsNarrow);
        case "short":
            return [].concat($6b19b3cf1ff123ca$var$monthsShort);
        case "long":
            return [].concat($6b19b3cf1ff123ca$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $6b19b3cf1ff123ca$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $6b19b3cf1ff123ca$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $6b19b3cf1ff123ca$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $6b19b3cf1ff123ca$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($6b19b3cf1ff123ca$var$weekdaysNarrow);
        case "short":
            return [].concat($6b19b3cf1ff123ca$var$weekdaysShort);
        case "long":
            return [].concat($6b19b3cf1ff123ca$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $6b19b3cf1ff123ca$var$meridiems = [
    "AM",
    "PM"
];
var $6b19b3cf1ff123ca$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $6b19b3cf1ff123ca$var$erasShort = [
    "BC",
    "AD"
];
var $6b19b3cf1ff123ca$var$erasNarrow = [
    "B",
    "A"
];
function $6b19b3cf1ff123ca$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($6b19b3cf1ff123ca$var$erasNarrow);
        case "short":
            return [].concat($6b19b3cf1ff123ca$var$erasShort);
        case "long":
            return [].concat($6b19b3cf1ff123ca$var$erasLong);
        default:
            return null;
    }
}
function $6b19b3cf1ff123ca$var$meridiemForDateTime(dt) {
    return $6b19b3cf1ff123ca$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $6b19b3cf1ff123ca$var$weekdayForDateTime(dt, length) {
    return $6b19b3cf1ff123ca$var$weekdays(length)[dt.weekday - 1];
}
function $6b19b3cf1ff123ca$var$monthForDateTime(dt, length) {
    return $6b19b3cf1ff123ca$var$months(length)[dt.month - 1];
}
function $6b19b3cf1ff123ca$var$eraForDateTime(dt, length) {
    return $6b19b3cf1ff123ca$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $6b19b3cf1ff123ca$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $6b19b3cf1ff123ca$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $6b19b3cf1ff123ca$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $6b19b3cf1ff123ca$var$_macroTokenToFormatOpts = {
    D: $6b19b3cf1ff123ca$var$DATE_SHORT,
    DD: $6b19b3cf1ff123ca$var$DATE_MED,
    DDD: $6b19b3cf1ff123ca$var$DATE_FULL,
    DDDD: $6b19b3cf1ff123ca$var$DATE_HUGE,
    t: $6b19b3cf1ff123ca$var$TIME_SIMPLE,
    tt: $6b19b3cf1ff123ca$var$TIME_WITH_SECONDS,
    ttt: $6b19b3cf1ff123ca$var$TIME_WITH_SHORT_OFFSET,
    tttt: $6b19b3cf1ff123ca$var$TIME_WITH_LONG_OFFSET,
    T: $6b19b3cf1ff123ca$var$TIME_24_SIMPLE,
    TT: $6b19b3cf1ff123ca$var$TIME_24_WITH_SECONDS,
    TTT: $6b19b3cf1ff123ca$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $6b19b3cf1ff123ca$var$TIME_24_WITH_LONG_OFFSET,
    f: $6b19b3cf1ff123ca$var$DATETIME_SHORT,
    ff: $6b19b3cf1ff123ca$var$DATETIME_MED,
    fff: $6b19b3cf1ff123ca$var$DATETIME_FULL,
    ffff: $6b19b3cf1ff123ca$var$DATETIME_HUGE,
    F: $6b19b3cf1ff123ca$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $6b19b3cf1ff123ca$var$DATETIME_MED_WITH_SECONDS,
    FFF: $6b19b3cf1ff123ca$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $6b19b3cf1ff123ca$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $6b19b3cf1ff123ca$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $6b19b3cf1ff123ca$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $6b19b3cf1ff123ca$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $6b19b3cf1ff123ca$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $6b19b3cf1ff123ca$var$_extends({}, this.opts, opts));
        return df.formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(interval.start, $6b19b3cf1ff123ca$var$_extends({}, this.opts, opts));
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, $6b19b3cf1ff123ca$var$_extends({}, this.opts, opts));
        return df.resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $6b19b3cf1ff123ca$var$padStart(n, p);
        var opts = $6b19b3cf1ff123ca$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $6b19b3cf1ff123ca$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $6b19b3cf1ff123ca$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $6b19b3cf1ff123ca$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $6b19b3cf1ff123ca$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $6b19b3cf1ff123ca$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $6b19b3cf1ff123ca$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
var $6b19b3cf1ff123ca$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $6b19b3cf1ff123ca$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $6b19b3cf1ff123ca$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $6b19b3cf1ff123ca$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $6b19b3cf1ff123ca$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $6b19b3cf1ff123ca$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $6b19b3cf1ff123ca$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $6b19b3cf1ff123ca$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $6b19b3cf1ff123ca$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var $6b19b3cf1ff123ca$var$isoExtendedZone = "(?:" + $6b19b3cf1ff123ca$var$offsetRegex.source + "?(?:\\[(" + $6b19b3cf1ff123ca$var$ianaRegex.source + ")\\])?)?";
var $6b19b3cf1ff123ca$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $6b19b3cf1ff123ca$var$isoTimeRegex = RegExp("" + $6b19b3cf1ff123ca$var$isoTimeBaseRegex.source + $6b19b3cf1ff123ca$var$isoExtendedZone);
var $6b19b3cf1ff123ca$var$isoTimeExtensionRegex = RegExp("(?:T" + $6b19b3cf1ff123ca$var$isoTimeRegex.source + ")?");
var $6b19b3cf1ff123ca$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $6b19b3cf1ff123ca$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $6b19b3cf1ff123ca$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $6b19b3cf1ff123ca$var$extractISOWeekData = $6b19b3cf1ff123ca$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $6b19b3cf1ff123ca$var$extractISOOrdinalData = $6b19b3cf1ff123ca$var$simpleParse("year", "ordinal");
var $6b19b3cf1ff123ca$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $6b19b3cf1ff123ca$var$sqlTimeRegex = RegExp($6b19b3cf1ff123ca$var$isoTimeBaseRegex.source + " ?(?:" + $6b19b3cf1ff123ca$var$offsetRegex.source + "|(" + $6b19b3cf1ff123ca$var$ianaRegex.source + "))?");
var $6b19b3cf1ff123ca$var$sqlTimeExtensionRegex = RegExp("(?: " + $6b19b3cf1ff123ca$var$sqlTimeRegex.source + ")?");
function $6b19b3cf1ff123ca$var$int(match, pos, fallback) {
    var m = match[pos];
    return $6b19b3cf1ff123ca$var$isUndefined(m) ? fallback : $6b19b3cf1ff123ca$var$parseInteger(m);
}
function $6b19b3cf1ff123ca$var$extractISOYmd(match, cursor) {
    var item = {
        year: $6b19b3cf1ff123ca$var$int(match, cursor),
        month: $6b19b3cf1ff123ca$var$int(match, cursor + 1, 1),
        day: $6b19b3cf1ff123ca$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $6b19b3cf1ff123ca$var$extractISOTime(match, cursor) {
    var item = {
        hours: $6b19b3cf1ff123ca$var$int(match, cursor, 0),
        minutes: $6b19b3cf1ff123ca$var$int(match, cursor + 1, 0),
        seconds: $6b19b3cf1ff123ca$var$int(match, cursor + 2, 0),
        milliseconds: $6b19b3cf1ff123ca$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $6b19b3cf1ff123ca$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $6b19b3cf1ff123ca$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $6b19b3cf1ff123ca$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $6b19b3cf1ff123ca$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $6b19b3cf1ff123ca$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $6b19b3cf1ff123ca$var$isoTimeOnly = RegExp("^T?" + $6b19b3cf1ff123ca$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $6b19b3cf1ff123ca$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $6b19b3cf1ff123ca$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($6b19b3cf1ff123ca$var$parseFloating(yearStr)),
            months: maybeNegate($6b19b3cf1ff123ca$var$parseFloating(monthStr)),
            weeks: maybeNegate($6b19b3cf1ff123ca$var$parseFloating(weekStr)),
            days: maybeNegate($6b19b3cf1ff123ca$var$parseFloating(dayStr)),
            hours: maybeNegate($6b19b3cf1ff123ca$var$parseFloating(hourStr)),
            minutes: maybeNegate($6b19b3cf1ff123ca$var$parseFloating(minuteStr)),
            seconds: maybeNegate($6b19b3cf1ff123ca$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($6b19b3cf1ff123ca$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $6b19b3cf1ff123ca$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $6b19b3cf1ff123ca$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $6b19b3cf1ff123ca$var$untruncateYear($6b19b3cf1ff123ca$var$parseInteger(yearStr)) : $6b19b3cf1ff123ca$var$parseInteger(yearStr),
        month: $6b19b3cf1ff123ca$var$monthsShort.indexOf(monthStr) + 1,
        day: $6b19b3cf1ff123ca$var$parseInteger(dayStr),
        hour: $6b19b3cf1ff123ca$var$parseInteger(hourStr),
        minute: $6b19b3cf1ff123ca$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $6b19b3cf1ff123ca$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $6b19b3cf1ff123ca$var$weekdaysLong.indexOf(weekdayStr) + 1 : $6b19b3cf1ff123ca$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $6b19b3cf1ff123ca$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $6b19b3cf1ff123ca$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $6b19b3cf1ff123ca$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $6b19b3cf1ff123ca$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $6b19b3cf1ff123ca$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $6b19b3cf1ff123ca$var$FixedOffsetZone(offset)
    ];
}
function $6b19b3cf1ff123ca$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $6b19b3cf1ff123ca$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $6b19b3cf1ff123ca$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $6b19b3cf1ff123ca$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $6b19b3cf1ff123ca$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $6b19b3cf1ff123ca$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $6b19b3cf1ff123ca$var$FixedOffsetZone.utcInstance
    ];
}
function $6b19b3cf1ff123ca$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $6b19b3cf1ff123ca$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $6b19b3cf1ff123ca$var$FixedOffsetZone.utcInstance
    ];
}
var $6b19b3cf1ff123ca$var$isoYmdWithTimeExtensionRegex = $6b19b3cf1ff123ca$var$combineRegexes($6b19b3cf1ff123ca$var$isoYmdRegex, $6b19b3cf1ff123ca$var$isoTimeExtensionRegex);
var $6b19b3cf1ff123ca$var$isoWeekWithTimeExtensionRegex = $6b19b3cf1ff123ca$var$combineRegexes($6b19b3cf1ff123ca$var$isoWeekRegex, $6b19b3cf1ff123ca$var$isoTimeExtensionRegex);
var $6b19b3cf1ff123ca$var$isoOrdinalWithTimeExtensionRegex = $6b19b3cf1ff123ca$var$combineRegexes($6b19b3cf1ff123ca$var$isoOrdinalRegex, $6b19b3cf1ff123ca$var$isoTimeExtensionRegex);
var $6b19b3cf1ff123ca$var$isoTimeCombinedRegex = $6b19b3cf1ff123ca$var$combineRegexes($6b19b3cf1ff123ca$var$isoTimeRegex);
var $6b19b3cf1ff123ca$var$extractISOYmdTimeAndOffset = $6b19b3cf1ff123ca$var$combineExtractors($6b19b3cf1ff123ca$var$extractISOYmd, $6b19b3cf1ff123ca$var$extractISOTime, $6b19b3cf1ff123ca$var$extractISOOffset, $6b19b3cf1ff123ca$var$extractIANAZone);
var $6b19b3cf1ff123ca$var$extractISOWeekTimeAndOffset = $6b19b3cf1ff123ca$var$combineExtractors($6b19b3cf1ff123ca$var$extractISOWeekData, $6b19b3cf1ff123ca$var$extractISOTime, $6b19b3cf1ff123ca$var$extractISOOffset, $6b19b3cf1ff123ca$var$extractIANAZone);
var $6b19b3cf1ff123ca$var$extractISOOrdinalDateAndTime = $6b19b3cf1ff123ca$var$combineExtractors($6b19b3cf1ff123ca$var$extractISOOrdinalData, $6b19b3cf1ff123ca$var$extractISOTime, $6b19b3cf1ff123ca$var$extractISOOffset, $6b19b3cf1ff123ca$var$extractIANAZone);
var $6b19b3cf1ff123ca$var$extractISOTimeAndOffset = $6b19b3cf1ff123ca$var$combineExtractors($6b19b3cf1ff123ca$var$extractISOTime, $6b19b3cf1ff123ca$var$extractISOOffset, $6b19b3cf1ff123ca$var$extractIANAZone);
/*
 * @private
 */ function $6b19b3cf1ff123ca$var$parseISODate(s) {
    return $6b19b3cf1ff123ca$var$parse(s, [
        $6b19b3cf1ff123ca$var$isoYmdWithTimeExtensionRegex,
        $6b19b3cf1ff123ca$var$extractISOYmdTimeAndOffset
    ], [
        $6b19b3cf1ff123ca$var$isoWeekWithTimeExtensionRegex,
        $6b19b3cf1ff123ca$var$extractISOWeekTimeAndOffset
    ], [
        $6b19b3cf1ff123ca$var$isoOrdinalWithTimeExtensionRegex,
        $6b19b3cf1ff123ca$var$extractISOOrdinalDateAndTime
    ], [
        $6b19b3cf1ff123ca$var$isoTimeCombinedRegex,
        $6b19b3cf1ff123ca$var$extractISOTimeAndOffset
    ]);
}
function $6b19b3cf1ff123ca$var$parseRFC2822Date(s) {
    return $6b19b3cf1ff123ca$var$parse($6b19b3cf1ff123ca$var$preprocessRFC2822(s), [
        $6b19b3cf1ff123ca$var$rfc2822,
        $6b19b3cf1ff123ca$var$extractRFC2822
    ]);
}
function $6b19b3cf1ff123ca$var$parseHTTPDate(s) {
    return $6b19b3cf1ff123ca$var$parse(s, [
        $6b19b3cf1ff123ca$var$rfc1123,
        $6b19b3cf1ff123ca$var$extractRFC1123Or850
    ], [
        $6b19b3cf1ff123ca$var$rfc850,
        $6b19b3cf1ff123ca$var$extractRFC1123Or850
    ], [
        $6b19b3cf1ff123ca$var$ascii,
        $6b19b3cf1ff123ca$var$extractASCII
    ]);
}
function $6b19b3cf1ff123ca$var$parseISODuration(s) {
    return $6b19b3cf1ff123ca$var$parse(s, [
        $6b19b3cf1ff123ca$var$isoDuration,
        $6b19b3cf1ff123ca$var$extractISODuration
    ]);
}
var $6b19b3cf1ff123ca$var$extractISOTimeOnly = $6b19b3cf1ff123ca$var$combineExtractors($6b19b3cf1ff123ca$var$extractISOTime);
function $6b19b3cf1ff123ca$var$parseISOTimeOnly(s) {
    return $6b19b3cf1ff123ca$var$parse(s, [
        $6b19b3cf1ff123ca$var$isoTimeOnly,
        $6b19b3cf1ff123ca$var$extractISOTimeOnly
    ]);
}
var $6b19b3cf1ff123ca$var$sqlYmdWithTimeExtensionRegex = $6b19b3cf1ff123ca$var$combineRegexes($6b19b3cf1ff123ca$var$sqlYmdRegex, $6b19b3cf1ff123ca$var$sqlTimeExtensionRegex);
var $6b19b3cf1ff123ca$var$sqlTimeCombinedRegex = $6b19b3cf1ff123ca$var$combineRegexes($6b19b3cf1ff123ca$var$sqlTimeRegex);
var $6b19b3cf1ff123ca$var$extractISOTimeOffsetAndIANAZone = $6b19b3cf1ff123ca$var$combineExtractors($6b19b3cf1ff123ca$var$extractISOTime, $6b19b3cf1ff123ca$var$extractISOOffset, $6b19b3cf1ff123ca$var$extractIANAZone);
function $6b19b3cf1ff123ca$var$parseSQL(s) {
    return $6b19b3cf1ff123ca$var$parse(s, [
        $6b19b3cf1ff123ca$var$sqlYmdWithTimeExtensionRegex,
        $6b19b3cf1ff123ca$var$extractISOYmdTimeAndOffset
    ], [
        $6b19b3cf1ff123ca$var$sqlTimeCombinedRegex,
        $6b19b3cf1ff123ca$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $6b19b3cf1ff123ca$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $6b19b3cf1ff123ca$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $6b19b3cf1ff123ca$var$casualMatrix = $6b19b3cf1ff123ca$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $6b19b3cf1ff123ca$var$lowOrderMatrix), $6b19b3cf1ff123ca$var$daysInYearAccurate = 365.2425, $6b19b3cf1ff123ca$var$daysInMonthAccurate = 30.436875, $6b19b3cf1ff123ca$var$accurateMatrix = $6b19b3cf1ff123ca$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $6b19b3cf1ff123ca$var$daysInYearAccurate / 7,
        days: $6b19b3cf1ff123ca$var$daysInYearAccurate,
        hours: $6b19b3cf1ff123ca$var$daysInYearAccurate * 24,
        minutes: $6b19b3cf1ff123ca$var$daysInYearAccurate * 1440,
        seconds: $6b19b3cf1ff123ca$var$daysInYearAccurate * 86400,
        milliseconds: $6b19b3cf1ff123ca$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $6b19b3cf1ff123ca$var$daysInYearAccurate / 28,
        days: $6b19b3cf1ff123ca$var$daysInYearAccurate / 4,
        hours: $6b19b3cf1ff123ca$var$daysInYearAccurate * 24 / 4,
        minutes: $6b19b3cf1ff123ca$var$daysInYearAccurate * 1440 / 4,
        seconds: $6b19b3cf1ff123ca$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $6b19b3cf1ff123ca$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $6b19b3cf1ff123ca$var$daysInMonthAccurate / 7,
        days: $6b19b3cf1ff123ca$var$daysInMonthAccurate,
        hours: $6b19b3cf1ff123ca$var$daysInMonthAccurate * 24,
        minutes: $6b19b3cf1ff123ca$var$daysInMonthAccurate * 1440,
        seconds: $6b19b3cf1ff123ca$var$daysInMonthAccurate * 86400,
        milliseconds: $6b19b3cf1ff123ca$var$daysInMonthAccurate * 86400000
    }
}, $6b19b3cf1ff123ca$var$lowOrderMatrix);
// units ordered by size
var $6b19b3cf1ff123ca$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $6b19b3cf1ff123ca$var$reverseUnits = $6b19b3cf1ff123ca$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $6b19b3cf1ff123ca$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $6b19b3cf1ff123ca$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $6b19b3cf1ff123ca$var$Duration(conf);
}
function $6b19b3cf1ff123ca$var$antiTrunc(n) {
    return n < 0 ? Math.floor(n) : Math.ceil(n);
}
// NB: mutates parameters
function $6b19b3cf1ff123ca$var$convert(matrix, fromMap, fromUnit, toMap, toUnit) {
    var conv = matrix[toUnit][fromUnit], raw = fromMap[fromUnit] / conv, sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]), // ok, so this is wild, but see the matrix in the tests
    added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? $6b19b3cf1ff123ca$var$antiTrunc(raw) : Math.trunc(raw);
    toMap[toUnit] += added;
    fromMap[fromUnit] -= added * conv;
}
// NB: mutates parameters
function $6b19b3cf1ff123ca$var$normalizeValues(matrix, vals) {
    $6b19b3cf1ff123ca$var$reverseUnits.reduce(function(previous, current) {
        if (!$6b19b3cf1ff123ca$var$isUndefined(vals[current])) {
            if (previous) $6b19b3cf1ff123ca$var$convert(matrix, vals, previous, vals, current);
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $6b19b3cf1ff123ca$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $6b19b3cf1ff123ca$var$Duration = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $6b19b3cf1ff123ca$var$accurateMatrix : $6b19b3cf1ff123ca$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $6b19b3cf1ff123ca$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    };
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $6b19b3cf1ff123ca$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $6b19b3cf1ff123ca$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    };
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($6b19b3cf1ff123ca$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $6b19b3cf1ff123ca$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $6b19b3cf1ff123ca$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $6b19b3cf1ff123ca$var$Invalid ? reason : new $6b19b3cf1ff123ca$var$Invalid(reason, explanation);
        if ($6b19b3cf1ff123ca$var$Settings.throwOnInvalid) throw new $6b19b3cf1ff123ca$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $6b19b3cf1ff123ca$var$InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $6b19b3cf1ff123ca$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $6b19b3cf1ff123ca$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $6b19b3cf1ff123ca$var$INVALID$2;
    };
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        var l = $6b19b3cf1ff123ca$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($6b19b3cf1ff123ca$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($6b19b3cf1ff123ca$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($6b19b3cf1ff123ca$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    };
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $6b19b3cf1ff123ca$var$_extends({}, this.values);
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $6b19b3cf1ff123ca$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $6b19b3cf1ff123ca$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts);
        var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
        var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";
        if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
            fmt += opts.format === "basic" ? "ss" : ":ss";
            if (!opts.suppressMilliseconds || value.milliseconds !== 0) fmt += ".SSS";
        }
        var str = value.toFormat(fmt);
        if (opts.includePrefix) str = "T" + str;
        return str;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto.toMillis = function toMillis() {
        return this.as("milliseconds");
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $6b19b3cf1ff123ca$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($6b19b3cf1ff123ca$var$hasOwnProperty(dur.values, k) || $6b19b3cf1ff123ca$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $6b19b3cf1ff123ca$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $6b19b3cf1ff123ca$var$asNumber(fn(this.values[k], k));
        }
        return $6b19b3cf1ff123ca$var$clone$1(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $6b19b3cf1ff123ca$var$_extends({}, this.values, $6b19b3cf1ff123ca$var$normalizeObject(values, Duration.normalizeUnit));
        return $6b19b3cf1ff123ca$var$clone$1(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $6b19b3cf1ff123ca$var$clone$1(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $6b19b3cf1ff123ca$var$normalizeValues(this.matrix, vals);
        return $6b19b3cf1ff123ca$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $6b19b3cf1ff123ca$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $6b19b3cf1ff123ca$var$clone$1(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $6b19b3cf1ff123ca$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($6b19b3cf1ff123ca$var$isNumber(vals[k])) own += vals[k];
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
                // plus anything further down the chain that should be rolled up in to this
                for(var down in vals)if ($6b19b3cf1ff123ca$var$orderedUnits$1.indexOf(down) > $6b19b3cf1ff123ca$var$orderedUnits$1.indexOf(k)) $6b19b3cf1ff123ca$var$convert(this.matrix, vals, down, built, k);
            // otherwise, keep it in the wings to boil it later
            } else if ($6b19b3cf1ff123ca$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        return $6b19b3cf1ff123ca$var$clone$1(this, {
            values: built
        }, true).normalize();
    };
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $6b19b3cf1ff123ca$var$clone$1(this, {
            values: negated
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $6b19b3cf1ff123ca$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $6b19b3cf1ff123ca$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}();
var $6b19b3cf1ff123ca$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $6b19b3cf1ff123ca$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $6b19b3cf1ff123ca$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $6b19b3cf1ff123ca$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $6b19b3cf1ff123ca$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $6b19b3cf1ff123ca$var$Interval = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $6b19b3cf1ff123ca$var$Invalid ? reason : new $6b19b3cf1ff123ca$var$Invalid(reason, explanation);
        if ($6b19b3cf1ff123ca$var$Settings.throwOnInvalid) throw new $6b19b3cf1ff123ca$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $6b19b3cf1ff123ca$var$friendlyDateTime(start), builtEnd = $6b19b3cf1ff123ca$var$friendlyDateTime(end);
        var validateError = $6b19b3cf1ff123ca$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = $6b19b3cf1ff123ca$var$Duration.fromDurationLike(duration), dt = $6b19b3cf1ff123ca$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = $6b19b3cf1ff123ca$var$Duration.fromDurationLike(duration), dt = $6b19b3cf1ff123ca$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $6b19b3cf1ff123ca$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $6b19b3cf1ff123ca$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $6b19b3cf1ff123ca$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $6b19b3cf1ff123ca$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($6b19b3cf1ff123ca$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = $6b19b3cf1ff123ca$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $6b19b3cf1ff123ca$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return $6b19b3cf1ff123ca$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $6b19b3cf1ff123ca$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $6b19b3cf1ff123ca$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $6b19b3cf1ff123ca$var$INVALID$1;
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $6b19b3cf1ff123ca$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $6b19b3cf1ff123ca$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $6b19b3cf1ff123ca$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $6b19b3cf1ff123ca$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $6b19b3cf1ff123ca$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $6b19b3cf1ff123ca$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}();
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $6b19b3cf1ff123ca$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $6b19b3cf1ff123ca$var$Settings.defaultZone;
        var proto = $6b19b3cf1ff123ca$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $6b19b3cf1ff123ca$var$IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return $6b19b3cf1ff123ca$var$normalizeZone(input, $6b19b3cf1ff123ca$var$Settings.defaultZone);
    };
    Info.months = function months(length, _temp) {
        if (length === void 0) length = "long";
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$numberingSystem = _ref.numberingSystem, numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj, _ref$outputCalendar = _ref.outputCalendar, outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
        return (locObj || $6b19b3cf1ff123ca$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp2) {
        if (length === void 0) length = "long";
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$numberingSystem = _ref2.numberingSystem, numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj, _ref2$outputCalendar = _ref2.outputCalendar, outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
        return (locObj || $6b19b3cf1ff123ca$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp3) {
        if (length === void 0) length = "long";
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$numberingSystem = _ref3.numberingSystem, numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        return (locObj || $6b19b3cf1ff123ca$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;
        return (locObj || $6b19b3cf1ff123ca$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp5) {
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale;
        return $6b19b3cf1ff123ca$var$Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp6) {
        if (length === void 0) length = "short";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale;
        return $6b19b3cf1ff123ca$var$Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        return {
            relative: $6b19b3cf1ff123ca$var$hasRelative()
        };
    };
    return Info;
}();
function $6b19b3cf1ff123ca$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($6b19b3cf1ff123ca$var$Duration.fromMillis(ms).as("days"));
}
function $6b19b3cf1ff123ca$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $6b19b3cf1ff123ca$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $6b19b3cf1ff123ca$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                results[unit]--;
                cursor = earlier.plus(results);
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $6b19b3cf1ff123ca$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $6b19b3cf1ff123ca$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $6b19b3cf1ff123ca$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $6b19b3cf1ff123ca$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $6b19b3cf1ff123ca$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $6b19b3cf1ff123ca$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $6b19b3cf1ff123ca$var$hanidecChars = $6b19b3cf1ff123ca$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $6b19b3cf1ff123ca$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($6b19b3cf1ff123ca$var$numberingSystems.hanidec) !== -1) value += $6b19b3cf1ff123ca$var$hanidecChars.indexOf(str[i]);
            else for(var key in $6b19b3cf1ff123ca$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $6b19b3cf1ff123ca$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $6b19b3cf1ff123ca$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $6b19b3cf1ff123ca$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $6b19b3cf1ff123ca$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $6b19b3cf1ff123ca$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($6b19b3cf1ff123ca$var$parseDigits(s));
        }
    };
}
var $6b19b3cf1ff123ca$var$NBSP = String.fromCharCode(160);
var $6b19b3cf1ff123ca$var$spaceOrNBSP = "[ " + $6b19b3cf1ff123ca$var$NBSP + "]";
var $6b19b3cf1ff123ca$var$spaceOrNBSPRegExp = new RegExp($6b19b3cf1ff123ca$var$spaceOrNBSP, "g");
function $6b19b3cf1ff123ca$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($6b19b3cf1ff123ca$var$spaceOrNBSPRegExp, $6b19b3cf1ff123ca$var$spaceOrNBSP);
}
function $6b19b3cf1ff123ca$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($6b19b3cf1ff123ca$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $6b19b3cf1ff123ca$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($6b19b3cf1ff123ca$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $6b19b3cf1ff123ca$var$stripInsensitivities(s) === $6b19b3cf1ff123ca$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $6b19b3cf1ff123ca$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $6b19b3cf1ff123ca$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $6b19b3cf1ff123ca$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $6b19b3cf1ff123ca$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function $6b19b3cf1ff123ca$var$unitForToken(token, loc) {
    var one = $6b19b3cf1ff123ca$var$digitRegex(loc), two = $6b19b3cf1ff123ca$var$digitRegex(loc, "{2}"), three = $6b19b3cf1ff123ca$var$digitRegex(loc, "{3}"), four = $6b19b3cf1ff123ca$var$digitRegex(loc, "{4}"), six = $6b19b3cf1ff123ca$var$digitRegex(loc, "{6}"), oneOrTwo = $6b19b3cf1ff123ca$var$digitRegex(loc, "{1,2}"), oneToThree = $6b19b3cf1ff123ca$var$digitRegex(loc, "{1,3}"), oneToSix = $6b19b3cf1ff123ca$var$digitRegex(loc, "{1,6}"), oneToNine = $6b19b3cf1ff123ca$var$digitRegex(loc, "{1,9}"), twoToFour = $6b19b3cf1ff123ca$var$digitRegex(loc, "{2,4}"), fourToSix = $6b19b3cf1ff123ca$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($6b19b3cf1ff123ca$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $6b19b3cf1ff123ca$var$oneOf(loc.eras("short", false), 0);
            case "GG":
                return $6b19b3cf1ff123ca$var$oneOf(loc.eras("long", false), 0);
            // years
            case "y":
                return $6b19b3cf1ff123ca$var$intUnit(oneToSix);
            case "yy":
                return $6b19b3cf1ff123ca$var$intUnit(twoToFour, $6b19b3cf1ff123ca$var$untruncateYear);
            case "yyyy":
                return $6b19b3cf1ff123ca$var$intUnit(four);
            case "yyyyy":
                return $6b19b3cf1ff123ca$var$intUnit(fourToSix);
            case "yyyyyy":
                return $6b19b3cf1ff123ca$var$intUnit(six);
            // months
            case "M":
                return $6b19b3cf1ff123ca$var$intUnit(oneOrTwo);
            case "MM":
                return $6b19b3cf1ff123ca$var$intUnit(two);
            case "MMM":
                return $6b19b3cf1ff123ca$var$oneOf(loc.months("short", true, false), 1);
            case "MMMM":
                return $6b19b3cf1ff123ca$var$oneOf(loc.months("long", true, false), 1);
            case "L":
                return $6b19b3cf1ff123ca$var$intUnit(oneOrTwo);
            case "LL":
                return $6b19b3cf1ff123ca$var$intUnit(two);
            case "LLL":
                return $6b19b3cf1ff123ca$var$oneOf(loc.months("short", false, false), 1);
            case "LLLL":
                return $6b19b3cf1ff123ca$var$oneOf(loc.months("long", false, false), 1);
            // dates
            case "d":
                return $6b19b3cf1ff123ca$var$intUnit(oneOrTwo);
            case "dd":
                return $6b19b3cf1ff123ca$var$intUnit(two);
            // ordinals
            case "o":
                return $6b19b3cf1ff123ca$var$intUnit(oneToThree);
            case "ooo":
                return $6b19b3cf1ff123ca$var$intUnit(three);
            // time
            case "HH":
                return $6b19b3cf1ff123ca$var$intUnit(two);
            case "H":
                return $6b19b3cf1ff123ca$var$intUnit(oneOrTwo);
            case "hh":
                return $6b19b3cf1ff123ca$var$intUnit(two);
            case "h":
                return $6b19b3cf1ff123ca$var$intUnit(oneOrTwo);
            case "mm":
                return $6b19b3cf1ff123ca$var$intUnit(two);
            case "m":
                return $6b19b3cf1ff123ca$var$intUnit(oneOrTwo);
            case "q":
                return $6b19b3cf1ff123ca$var$intUnit(oneOrTwo);
            case "qq":
                return $6b19b3cf1ff123ca$var$intUnit(two);
            case "s":
                return $6b19b3cf1ff123ca$var$intUnit(oneOrTwo);
            case "ss":
                return $6b19b3cf1ff123ca$var$intUnit(two);
            case "S":
                return $6b19b3cf1ff123ca$var$intUnit(oneToThree);
            case "SSS":
                return $6b19b3cf1ff123ca$var$intUnit(three);
            case "u":
                return $6b19b3cf1ff123ca$var$simple(oneToNine);
            case "uu":
                return $6b19b3cf1ff123ca$var$simple(oneOrTwo);
            case "uuu":
                return $6b19b3cf1ff123ca$var$intUnit(one);
            // meridiem
            case "a":
                return $6b19b3cf1ff123ca$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $6b19b3cf1ff123ca$var$intUnit(four);
            case "kk":
                return $6b19b3cf1ff123ca$var$intUnit(twoToFour, $6b19b3cf1ff123ca$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $6b19b3cf1ff123ca$var$intUnit(oneOrTwo);
            case "WW":
                return $6b19b3cf1ff123ca$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $6b19b3cf1ff123ca$var$intUnit(one);
            case "EEE":
                return $6b19b3cf1ff123ca$var$oneOf(loc.weekdays("short", false, false), 1);
            case "EEEE":
                return $6b19b3cf1ff123ca$var$oneOf(loc.weekdays("long", false, false), 1);
            case "ccc":
                return $6b19b3cf1ff123ca$var$oneOf(loc.weekdays("short", true, false), 1);
            case "cccc":
                return $6b19b3cf1ff123ca$var$oneOf(loc.weekdays("long", true, false), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $6b19b3cf1ff123ca$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $6b19b3cf1ff123ca$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $6b19b3cf1ff123ca$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $6b19b3cf1ff123ca$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $6b19b3cf1ff123ca$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $6b19b3cf1ff123ca$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour: {
        numeric: "h",
        "2-digit": "hh"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $6b19b3cf1ff123ca$var$tokenForPart(part, formatOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    var val = $6b19b3cf1ff123ca$var$partTypeStyleToTokenVal[type];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $6b19b3cf1ff123ca$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $6b19b3cf1ff123ca$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($6b19b3cf1ff123ca$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $6b19b3cf1ff123ca$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$6b19b3cf1ff123ca$var$isUndefined(matches.z)) zone = $6b19b3cf1ff123ca$var$IANAZone.create(matches.z);
    if (!$6b19b3cf1ff123ca$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $6b19b3cf1ff123ca$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$6b19b3cf1ff123ca$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$6b19b3cf1ff123ca$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$6b19b3cf1ff123ca$var$isUndefined(matches.u)) matches.S = $6b19b3cf1ff123ca$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $6b19b3cf1ff123ca$var$dummyDateTimeCache = null;
function $6b19b3cf1ff123ca$var$getDummyDateTime() {
    if (!$6b19b3cf1ff123ca$var$dummyDateTimeCache) $6b19b3cf1ff123ca$var$dummyDateTimeCache = $6b19b3cf1ff123ca$var$DateTime.fromMillis(1555555555555);
    return $6b19b3cf1ff123ca$var$dummyDateTimeCache;
}
function $6b19b3cf1ff123ca$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $6b19b3cf1ff123ca$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $6b19b3cf1ff123ca$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $6b19b3cf1ff123ca$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $6b19b3cf1ff123ca$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $6b19b3cf1ff123ca$var$explainFromTokens(locale, input, format) {
    var tokens = $6b19b3cf1ff123ca$var$expandMacroTokens($6b19b3cf1ff123ca$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $6b19b3cf1ff123ca$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $6b19b3cf1ff123ca$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $6b19b3cf1ff123ca$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $6b19b3cf1ff123ca$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
        if ($6b19b3cf1ff123ca$var$hasOwnProperty(matches, "a") && $6b19b3cf1ff123ca$var$hasOwnProperty(matches, "H")) throw new $6b19b3cf1ff123ca$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $6b19b3cf1ff123ca$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $6b19b3cf1ff123ca$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $6b19b3cf1ff123ca$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $6b19b3cf1ff123ca$var$Formatter.create(locale, formatOpts);
    var parts = formatter.formatDateTimeParts($6b19b3cf1ff123ca$var$getDummyDateTime());
    return parts.map(function(p) {
        return $6b19b3cf1ff123ca$var$tokenForPart(p, formatOpts);
    });
}
var $6b19b3cf1ff123ca$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $6b19b3cf1ff123ca$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $6b19b3cf1ff123ca$var$unitOutOfRange(unit, value) {
    return new $6b19b3cf1ff123ca$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $6b19b3cf1ff123ca$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $6b19b3cf1ff123ca$var$computeOrdinal(year, month, day) {
    return day + ($6b19b3cf1ff123ca$var$isLeapYear(year) ? $6b19b3cf1ff123ca$var$leapLadder : $6b19b3cf1ff123ca$var$nonLeapLadder)[month - 1];
}
function $6b19b3cf1ff123ca$var$uncomputeOrdinal(year, ordinal) {
    var table = $6b19b3cf1ff123ca$var$isLeapYear(year) ? $6b19b3cf1ff123ca$var$leapLadder : $6b19b3cf1ff123ca$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
/**
 * @private
 */ function $6b19b3cf1ff123ca$var$gregorianToWeek(gregObj) {
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $6b19b3cf1ff123ca$var$computeOrdinal(year, month, day), weekday = $6b19b3cf1ff123ca$var$dayOfWeek(year, month, day);
    var weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $6b19b3cf1ff123ca$var$weeksInWeekYear(weekYear);
    } else if (weekNumber > $6b19b3cf1ff123ca$var$weeksInWeekYear(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $6b19b3cf1ff123ca$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $6b19b3cf1ff123ca$var$timeObject(gregObj));
}
function $6b19b3cf1ff123ca$var$weekToGregorian(weekData) {
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $6b19b3cf1ff123ca$var$dayOfWeek(weekYear, 1, 4), yearInDays = $6b19b3cf1ff123ca$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $6b19b3cf1ff123ca$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $6b19b3cf1ff123ca$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $6b19b3cf1ff123ca$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $6b19b3cf1ff123ca$var$_extends({
        year: year,
        month: month,
        day: day
    }, $6b19b3cf1ff123ca$var$timeObject(weekData));
}
function $6b19b3cf1ff123ca$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $6b19b3cf1ff123ca$var$computeOrdinal(year, month, day);
    return $6b19b3cf1ff123ca$var$_extends({
        year: year,
        ordinal: ordinal
    }, $6b19b3cf1ff123ca$var$timeObject(gregData));
}
function $6b19b3cf1ff123ca$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $6b19b3cf1ff123ca$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $6b19b3cf1ff123ca$var$_extends({
        year: year,
        month: month,
        day: day
    }, $6b19b3cf1ff123ca$var$timeObject(ordinalData));
}
function $6b19b3cf1ff123ca$var$hasInvalidWeekData(obj) {
    var validYear = $6b19b3cf1ff123ca$var$isInteger(obj.weekYear), validWeek = $6b19b3cf1ff123ca$var$integerBetween(obj.weekNumber, 1, $6b19b3cf1ff123ca$var$weeksInWeekYear(obj.weekYear)), validWeekday = $6b19b3cf1ff123ca$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $6b19b3cf1ff123ca$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $6b19b3cf1ff123ca$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $6b19b3cf1ff123ca$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $6b19b3cf1ff123ca$var$hasInvalidOrdinalData(obj) {
    var validYear = $6b19b3cf1ff123ca$var$isInteger(obj.year), validOrdinal = $6b19b3cf1ff123ca$var$integerBetween(obj.ordinal, 1, $6b19b3cf1ff123ca$var$daysInYear(obj.year));
    if (!validYear) return $6b19b3cf1ff123ca$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $6b19b3cf1ff123ca$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $6b19b3cf1ff123ca$var$hasInvalidGregorianData(obj) {
    var validYear = $6b19b3cf1ff123ca$var$isInteger(obj.year), validMonth = $6b19b3cf1ff123ca$var$integerBetween(obj.month, 1, 12), validDay = $6b19b3cf1ff123ca$var$integerBetween(obj.day, 1, $6b19b3cf1ff123ca$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $6b19b3cf1ff123ca$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $6b19b3cf1ff123ca$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $6b19b3cf1ff123ca$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $6b19b3cf1ff123ca$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $6b19b3cf1ff123ca$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $6b19b3cf1ff123ca$var$integerBetween(minute, 0, 59), validSecond = $6b19b3cf1ff123ca$var$integerBetween(second, 0, 59), validMillisecond = $6b19b3cf1ff123ca$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $6b19b3cf1ff123ca$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $6b19b3cf1ff123ca$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $6b19b3cf1ff123ca$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $6b19b3cf1ff123ca$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
var $6b19b3cf1ff123ca$var$INVALID = "Invalid DateTime";
var $6b19b3cf1ff123ca$var$MAX_DATE = 8.64e15;
function $6b19b3cf1ff123ca$var$unsupportedZone(zone) {
    return new $6b19b3cf1ff123ca$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
}
// we cache week data on the DT object and this intermediates the cache
function $6b19b3cf1ff123ca$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $6b19b3cf1ff123ca$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $6b19b3cf1ff123ca$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $6b19b3cf1ff123ca$var$DateTime($6b19b3cf1ff123ca$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $6b19b3cf1ff123ca$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $6b19b3cf1ff123ca$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $6b19b3cf1ff123ca$var$objToTS(obj, offset, zone) {
    return $6b19b3cf1ff123ca$var$fixOffset($6b19b3cf1ff123ca$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $6b19b3cf1ff123ca$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $6b19b3cf1ff123ca$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $6b19b3cf1ff123ca$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $6b19b3cf1ff123ca$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $6b19b3cf1ff123ca$var$objToLocalTS(c);
    var _fixOffset = $6b19b3cf1ff123ca$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $6b19b3cf1ff123ca$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $6b19b3cf1ff123ca$var$DateTime.fromObject(parsed, $6b19b3cf1ff123ca$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $6b19b3cf1ff123ca$var$DateTime.invalid(new $6b19b3cf1ff123ca$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $6b19b3cf1ff123ca$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $6b19b3cf1ff123ca$var$Formatter.create($6b19b3cf1ff123ca$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $6b19b3cf1ff123ca$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $6b19b3cf1ff123ca$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $6b19b3cf1ff123ca$var$padStart(o.c.month);
        c += "-";
        c += $6b19b3cf1ff123ca$var$padStart(o.c.day);
    } else {
        c += $6b19b3cf1ff123ca$var$padStart(o.c.month);
        c += $6b19b3cf1ff123ca$var$padStart(o.c.day);
    }
    return c;
}
function $6b19b3cf1ff123ca$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    var c = $6b19b3cf1ff123ca$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $6b19b3cf1ff123ca$var$padStart(o.c.minute);
        if (o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $6b19b3cf1ff123ca$var$padStart(o.c.minute);
    if (o.c.second !== 0 || !suppressSeconds) {
        c += $6b19b3cf1ff123ca$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $6b19b3cf1ff123ca$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $6b19b3cf1ff123ca$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $6b19b3cf1ff123ca$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $6b19b3cf1ff123ca$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $6b19b3cf1ff123ca$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $6b19b3cf1ff123ca$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $6b19b3cf1ff123ca$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $6b19b3cf1ff123ca$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $6b19b3cf1ff123ca$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $6b19b3cf1ff123ca$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $6b19b3cf1ff123ca$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $6b19b3cf1ff123ca$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $6b19b3cf1ff123ca$var$InvalidUnitError(unit);
    return normalized;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $6b19b3cf1ff123ca$var$quickDT(obj, opts) {
    var zone = $6b19b3cf1ff123ca$var$normalizeZone(opts.zone, $6b19b3cf1ff123ca$var$Settings.defaultZone), loc = $6b19b3cf1ff123ca$var$Locale.fromObject(opts), tsNow = $6b19b3cf1ff123ca$var$Settings.now();
    var ts, o;
    // assume we have the higher-order units
    if (!$6b19b3cf1ff123ca$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $6b19b3cf1ff123ca$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($6b19b3cf1ff123ca$var$isUndefined(obj[u])) obj[u] = $6b19b3cf1ff123ca$var$defaultUnitValues[u];
        }
        var invalid = $6b19b3cf1ff123ca$var$hasInvalidGregorianData(obj) || $6b19b3cf1ff123ca$var$hasInvalidTimeData(obj);
        if (invalid) return $6b19b3cf1ff123ca$var$DateTime.invalid(invalid);
        var offsetProvis = zone.offset(tsNow);
        var _objToTS = $6b19b3cf1ff123ca$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = tsNow;
    return new $6b19b3cf1ff123ca$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $6b19b3cf1ff123ca$var$diffRelative(start, end, opts) {
    var round = $6b19b3cf1ff123ca$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $6b19b3cf1ff123ca$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $6b19b3cf1ff123ca$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $6b19b3cf1ff123ca$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $6b19b3cf1ff123ca$var$DateTime = /*#__PURE__*/ function() {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $6b19b3cf1ff123ca$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $6b19b3cf1ff123ca$var$Invalid("invalid input") : null) || (!zone.isValid ? $6b19b3cf1ff123ca$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $6b19b3cf1ff123ca$var$isUndefined(config.ts) ? $6b19b3cf1ff123ca$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $6b19b3cf1ff123ca$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $6b19b3cf1ff123ca$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $6b19b3cf1ff123ca$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local() {
        var _lastOpts = $6b19b3cf1ff123ca$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $6b19b3cf1ff123ca$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.utc = function utc() {
        var _lastOpts2 = $6b19b3cf1ff123ca$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $6b19b3cf1ff123ca$var$FixedOffsetZone.utcInstance;
        return $6b19b3cf1ff123ca$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $6b19b3cf1ff123ca$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $6b19b3cf1ff123ca$var$normalizeZone(options.zone, $6b19b3cf1ff123ca$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($6b19b3cf1ff123ca$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $6b19b3cf1ff123ca$var$Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$6b19b3cf1ff123ca$var$isNumber(milliseconds)) throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$6b19b3cf1ff123ca$var$MAX_DATE || milliseconds > $6b19b3cf1ff123ca$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $6b19b3cf1ff123ca$var$normalizeZone(options.zone, $6b19b3cf1ff123ca$var$Settings.defaultZone),
            loc: $6b19b3cf1ff123ca$var$Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$6b19b3cf1ff123ca$var$isNumber(seconds)) throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $6b19b3cf1ff123ca$var$normalizeZone(options.zone, $6b19b3cf1ff123ca$var$Settings.defaultZone),
            loc: $6b19b3cf1ff123ca$var$Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $6b19b3cf1ff123ca$var$normalizeZone(opts.zone, $6b19b3cf1ff123ca$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($6b19b3cf1ff123ca$var$unsupportedZone(zoneToUse));
        var tsNow = $6b19b3cf1ff123ca$var$Settings.now(), offsetProvis = !$6b19b3cf1ff123ca$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), normalized = $6b19b3cf1ff123ca$var$normalizeObject(obj, $6b19b3cf1ff123ca$var$normalizeUnit), containsOrdinal = !$6b19b3cf1ff123ca$var$isUndefined(normalized.ordinal), containsGregorYear = !$6b19b3cf1ff123ca$var$isUndefined(normalized.year), containsGregorMD = !$6b19b3cf1ff123ca$var$isUndefined(normalized.month) || !$6b19b3cf1ff123ca$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = $6b19b3cf1ff123ca$var$Locale.fromObject(opts);
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $6b19b3cf1ff123ca$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $6b19b3cf1ff123ca$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $6b19b3cf1ff123ca$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $6b19b3cf1ff123ca$var$orderedWeekUnits;
            defaultValues = $6b19b3cf1ff123ca$var$defaultWeekUnitValues;
            objNow = $6b19b3cf1ff123ca$var$gregorianToWeek(objNow);
        } else if (containsOrdinal) {
            units = $6b19b3cf1ff123ca$var$orderedOrdinalUnits;
            defaultValues = $6b19b3cf1ff123ca$var$defaultOrdinalUnitValues;
            objNow = $6b19b3cf1ff123ca$var$gregorianToOrdinal(objNow);
        } else {
            units = $6b19b3cf1ff123ca$var$orderedUnits;
            defaultValues = $6b19b3cf1ff123ca$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $6b19b3cf1ff123ca$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$6b19b3cf1ff123ca$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $6b19b3cf1ff123ca$var$hasInvalidWeekData(normalized) : containsOrdinal ? $6b19b3cf1ff123ca$var$hasInvalidOrdinalData(normalized) : $6b19b3cf1ff123ca$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $6b19b3cf1ff123ca$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $6b19b3cf1ff123ca$var$weekToGregorian(normalized) : containsOrdinal ? $6b19b3cf1ff123ca$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $6b19b3cf1ff123ca$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $6b19b3cf1ff123ca$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $6b19b3cf1ff123ca$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $6b19b3cf1ff123ca$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $6b19b3cf1ff123ca$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $6b19b3cf1ff123ca$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $6b19b3cf1ff123ca$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($6b19b3cf1ff123ca$var$isUndefined(text) || $6b19b3cf1ff123ca$var$isUndefined(fmt)) throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $6b19b3cf1ff123ca$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $6b19b3cf1ff123ca$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $6b19b3cf1ff123ca$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $6b19b3cf1ff123ca$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $6b19b3cf1ff123ca$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $6b19b3cf1ff123ca$var$Invalid ? reason : new $6b19b3cf1ff123ca$var$Invalid(reason, explanation);
        if ($6b19b3cf1ff123ca$var$Settings.throwOnInvalid) throw new $6b19b3cf1ff123ca$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    };
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $6b19b3cf1ff123ca$var$formatOptsToTokens(formatOpts, $6b19b3cf1ff123ca$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    };
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $6b19b3cf1ff123ca$var$expandMacroTokens($6b19b3cf1ff123ca$var$Formatter.parseFormat(fmt), $6b19b3cf1ff123ca$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    };
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $6b19b3cf1ff123ca$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    };
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($6b19b3cf1ff123ca$var$FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone($6b19b3cf1ff123ca$var$Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $6b19b3cf1ff123ca$var$normalizeZone(zone, $6b19b3cf1ff123ca$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($6b19b3cf1ff123ca$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $6b19b3cf1ff123ca$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $6b19b3cf1ff123ca$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $6b19b3cf1ff123ca$var$clone(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $6b19b3cf1ff123ca$var$normalizeObject(values, $6b19b3cf1ff123ca$var$normalizeUnit), settingWeekStuff = !$6b19b3cf1ff123ca$var$isUndefined(normalized.weekYear) || !$6b19b3cf1ff123ca$var$isUndefined(normalized.weekNumber) || !$6b19b3cf1ff123ca$var$isUndefined(normalized.weekday), containsOrdinal = !$6b19b3cf1ff123ca$var$isUndefined(normalized.ordinal), containsGregorYear = !$6b19b3cf1ff123ca$var$isUndefined(normalized.year), containsGregorMD = !$6b19b3cf1ff123ca$var$isUndefined(normalized.month) || !$6b19b3cf1ff123ca$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $6b19b3cf1ff123ca$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $6b19b3cf1ff123ca$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $6b19b3cf1ff123ca$var$weekToGregorian($6b19b3cf1ff123ca$var$_extends({}, $6b19b3cf1ff123ca$var$gregorianToWeek(this.c), normalized));
        else if (!$6b19b3cf1ff123ca$var$isUndefined(normalized.ordinal)) mixed = $6b19b3cf1ff123ca$var$ordinalToGregorian($6b19b3cf1ff123ca$var$_extends({}, $6b19b3cf1ff123ca$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $6b19b3cf1ff123ca$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($6b19b3cf1ff123ca$var$isUndefined(normalized.day)) mixed.day = Math.min($6b19b3cf1ff123ca$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $6b19b3cf1ff123ca$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $6b19b3cf1ff123ca$var$clone(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $6b19b3cf1ff123ca$var$Duration.fromDurationLike(duration);
        return $6b19b3cf1ff123ca$var$clone(this, $6b19b3cf1ff123ca$var$adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $6b19b3cf1ff123ca$var$Duration.fromDurationLike(duration).negate();
        return $6b19b3cf1ff123ca$var$clone(this, $6b19b3cf1ff123ca$var$adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit) {
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $6b19b3cf1ff123ca$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
    };
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $6b19b3cf1ff123ca$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $6b19b3cf1ff123ca$var$INVALID;
    };
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $6b19b3cf1ff123ca$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $6b19b3cf1ff123ca$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $6b19b3cf1ff123ca$var$INVALID;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $6b19b3cf1ff123ca$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(_temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$format = _ref4.format, format = _ref4$format === void 0 ? "extended" : _ref4$format, _ref4$suppressSeconds = _ref4.suppressSeconds, suppressSeconds = _ref4$suppressSeconds === void 0 ? false : _ref4$suppressSeconds, _ref4$suppressMillise = _ref4.suppressMilliseconds, suppressMilliseconds = _ref4$suppressMillise === void 0 ? false : _ref4$suppressMillise, _ref4$includeOffset = _ref4.includeOffset, includeOffset = _ref4$includeOffset === void 0 ? true : _ref4$includeOffset, _ref4$extendedZone = _ref4.extendedZone, extendedZone = _ref4$extendedZone === void 0 ? false : _ref4$extendedZone;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $6b19b3cf1ff123ca$var$_toISODate(this, ext);
        c += "T";
        c += $6b19b3cf1ff123ca$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    };
    _proto.toISODate = function toISODate(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format;
        if (!this.isValid) return null;
        return $6b19b3cf1ff123ca$var$_toISODate(this, format === "extended");
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $6b19b3cf1ff123ca$var$toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$suppressMillise = _ref6.suppressMilliseconds, suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise, _ref6$suppressSeconds = _ref6.suppressSeconds, suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds, _ref6$includeOffset = _ref6.includeOffset, includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset, _ref6$includePrefix = _ref6.includePrefix, includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix, _ref6$extendedZone = _ref6.extendedZone, extendedZone = _ref6$extendedZone === void 0 ? false : _ref6$extendedZone, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $6b19b3cf1ff123ca$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    };
    _proto.toRFC2822 = function toRFC2822() {
        return $6b19b3cf1ff123ca$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return $6b19b3cf1ff123ca$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $6b19b3cf1ff123ca$var$_toISODate(this, true);
    };
    _proto.toSQLTime = function toSQLTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includeZone = _ref7.includeZone, includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone, _ref7$includeOffsetSp = _ref7.includeOffsetSpace, includeOffsetSpace = _ref7$includeOffsetSp === void 0 ? true : _ref7$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $6b19b3cf1ff123ca$var$toTechFormat(this, fmt, true);
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $6b19b3cf1ff123ca$var$INVALID;
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $6b19b3cf1ff123ca$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    };
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $6b19b3cf1ff123ca$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $6b19b3cf1ff123ca$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $6b19b3cf1ff123ca$var$maybeArray(unit).map($6b19b3cf1ff123ca$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $6b19b3cf1ff123ca$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $6b19b3cf1ff123ca$var$Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $6b19b3cf1ff123ca$var$diffRelative(base, this.plus(padding), $6b19b3cf1ff123ca$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $6b19b3cf1ff123ca$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $6b19b3cf1ff123ca$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $6b19b3cf1ff123ca$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $6b19b3cf1ff123ca$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    };
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $6b19b3cf1ff123ca$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $6b19b3cf1ff123ca$var$explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    };
    $6b19b3cf1ff123ca$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $6b19b3cf1ff123ca$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $6b19b3cf1ff123ca$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $6b19b3cf1ff123ca$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $6b19b3cf1ff123ca$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $6b19b3cf1ff123ca$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $6b19b3cf1ff123ca$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $6b19b3cf1ff123ca$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $6b19b3cf1ff123ca$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $6b19b3cf1ff123ca$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $6b19b3cf1ff123ca$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $6b19b3cf1ff123ca$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $6b19b3cf1ff123ca$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $6b19b3cf1ff123ca$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $6b19b3cf1ff123ca$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $6b19b3cf1ff123ca$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $6b19b3cf1ff123ca$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $6b19b3cf1ff123ca$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $6b19b3cf1ff123ca$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $6b19b3cf1ff123ca$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $6b19b3cf1ff123ca$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $6b19b3cf1ff123ca$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}();
function $6b19b3cf1ff123ca$var$friendlyDateTime(dateTimeish) {
    if ($6b19b3cf1ff123ca$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $6b19b3cf1ff123ca$var$isNumber(dateTimeish.valueOf())) return $6b19b3cf1ff123ca$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $6b19b3cf1ff123ca$var$DateTime.fromObject(dateTimeish);
    else throw new $6b19b3cf1ff123ca$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $6b19b3cf1ff123ca$var$VERSION = "3.3.0";
module.exports.DateTime = $6b19b3cf1ff123ca$var$DateTime;
module.exports.Duration = $6b19b3cf1ff123ca$var$Duration;
module.exports.FixedOffsetZone = $6b19b3cf1ff123ca$var$FixedOffsetZone;
module.exports.IANAZone = $6b19b3cf1ff123ca$var$IANAZone;
module.exports.Info = $6b19b3cf1ff123ca$var$Info;
module.exports.Interval = $6b19b3cf1ff123ca$var$Interval;
module.exports.InvalidZone = $6b19b3cf1ff123ca$var$InvalidZone;
module.exports.Settings = $6b19b3cf1ff123ca$var$Settings;
module.exports.SystemZone = $6b19b3cf1ff123ca$var$SystemZone;
module.exports.VERSION = $6b19b3cf1ff123ca$var$VERSION;
module.exports.Zone = $6b19b3cf1ff123ca$var$Zone;

});


parcelRegister("lW2Q8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ff8137b7eb9c53a6$export$2e2bcd8739ae039; });
function $ff8137b7eb9c53a6$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $ff8137b7eb9c53a6$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $ff8137b7eb9c53a6$var$pug_classes(s, r) {
    return Array.isArray(s) ? $ff8137b7eb9c53a6$var$pug_classes_array(s, r) : s && "object" == typeof s ? $ff8137b7eb9c53a6$var$pug_classes_object(s) : s || "";
}
function $ff8137b7eb9c53a6$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $ff8137b7eb9c53a6$var$pug_classes(r[g])) && (c && a[g] && (s = $ff8137b7eb9c53a6$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $ff8137b7eb9c53a6$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $ff8137b7eb9c53a6$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $ff8137b7eb9c53a6$var$pug_escape(e) {
    var a = "" + e, t = $ff8137b7eb9c53a6$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $ff8137b7eb9c53a6$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $ff8137b7eb9c53a6$var$pug_match_html = /["&<>]/;
function $ff8137b7eb9c53a6$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(baseUrl1, model1) {
        pug_html = pug_html + ("\u003Ctr\u003E\u003Ctd\u003E\u003Ca" + $ff8137b7eb9c53a6$var$pug_attr("href", baseUrl1, true, false) + "\u003E" + $ff8137b7eb9c53a6$var$pug_escape(null == (pug_interp = model1.shiftName) ? "" : pug_interp) + "\u003C\u002Fa\u003E\u003Cdiv class=\"append\"\u003E" + $ff8137b7eb9c53a6$var$pug_escape(null == (pug_interp = model1.barChef) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E" + $ff8137b7eb9c53a6$var$pug_escape(null == (pug_interp = model1.shiftEndTimeLocalized) ? "" : pug_interp) + "\u003Cdiv class=\"append\"\u003EErstellt am " + $ff8137b7eb9c53a6$var$pug_escape(null == (pug_interp = model1.createdAtLocalized) ? "" : pug_interp) + "\u003Cbr\u003E\nvon " + $ff8137b7eb9c53a6$var$pug_escape(null == (pug_interp = model1.user.name) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd" + $ff8137b7eb9c53a6$var$pug_attr("class", $ff8137b7eb9c53a6$var$pug_classes([
            model1.sumSold < 0 ? 'error' : null
        ], [
            true
        ]), false, false) + "\u003E" + $ff8137b7eb9c53a6$var$pug_escape(null == (pug_interp = model1.sumSoldLocalized) ? "" : pug_interp));
        if (model1.tokens) pug_html = pug_html + "\u003Cdiv class=\"append\"\u003Eabzgl. " + $ff8137b7eb9c53a6$var$pug_escape(null == (pug_interp = model1.tokens) ? "" : pug_interp) + " Marken: " + $ff8137b7eb9c53a6$var$pug_escape(null == (pug_interp = model1.salesWithoutTokensLocalized) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E" + $ff8137b7eb9c53a6$var$pug_escape(null == (pug_interp = model1.amountGivenLocalized) ? "" : pug_interp) + "\u003Cdiv" + $ff8137b7eb9c53a6$var$pug_attr("class", $ff8137b7eb9c53a6$var$pug_classes([
            "append",
            model1.differenceWithoutTokens < 0 ? 'error' : null
        ], [
            false,
            true
        ]), false, false) + "\u003E" + $ff8137b7eb9c53a6$var$pug_escape(null == (pug_interp = model1.differenceWithoutTokensLocalized) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }).call(this, "baseUrl" in locals_for_with ? locals_for_with.baseUrl : typeof baseUrl !== 'undefined' ? baseUrl : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $ff8137b7eb9c53a6$export$2e2bcd8739ae039 = $ff8137b7eb9c53a6$var$template;

});

parcelRegister("gsfN1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfab82591d53b5b9$export$2e2bcd8739ae039; });
function $bfab82591d53b5b9$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $bfab82591d53b5b9$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $bfab82591d53b5b9$var$pug_escape(e) {
    var a = "" + e, t = $bfab82591d53b5b9$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $bfab82591d53b5b9$var$pug_match_html = /["&<>]/;
function $bfab82591d53b5b9$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(exportUrl1, model1) {
        pug_html = pug_html + '<div class="stock-taking-page"><div class="pure-g"><div class="pure-u-1-2"><h1>Inventuren f\xfcr ' + $bfab82591d53b5b9$var$pug_escape(null == (pug_interp = model1.name) ? "" : pug_interp) + "\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Cdiv class=\"flex-center\"\u003E\u003Cdiv class=\"cell\"\u003E\u003Cdiv data-hook=\"search-bar\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"cell btn-group\"\u003E\u003Ca" + (" class=\"btn-round pure-button\"" + $bfab82591d53b5b9$var$pug_attr("href", exportUrl1, true, false) + " title=\"Inventuren herunterladen...\" target=\"_blank\"") + "\u003E\u003Ci class=\"icon ion-ios-cloud-download\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Cbutton class=\"btn-round pure-button\" data-hook=\"create-inventory\" data-title=\"Inventur erstellen...\"\u003E\u003Ci class=\"icon ion-plus\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1\"\u003E\u003Ctable class=\"pure-table\"\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Cth\u003ESchicht\u003C\u002Fth\u003E\u003Cth\u003EDatum\u003C\u002Fth\u003E\u003Cth\u003EUmsatz\u003C\u002Fth\u003E\u003Cth\u003EBetrag erhalten\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody data-hook=\"list\"\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "exportUrl" in locals_for_with ? locals_for_with.exportUrl : typeof exportUrl !== 'undefined' ? exportUrl : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $bfab82591d53b5b9$export$2e2bcd8739ae039 = $bfab82591d53b5b9$var$template;

});

parcelRegister("hw8gc", function(module, exports) {

var $bKnC7 = parcelRequire("bKnC7");

var $4UX9c = parcelRequire("4UX9c");

var $eSA5k = parcelRequire("eSA5k");

var $b2Qdr = parcelRequire("b2Qdr");

var $gvQO6 = parcelRequire("gvQO6");
var $cc0bd523a3867d2a$require$packagesLocalized = $gvQO6.packagesLocalized;
var $cc0bd523a3867d2a$require$unitsLocalized = $gvQO6.unitsLocalized;
var $cc0bd523a3867d2a$require$localizedUnit = $gvQO6.localizedUnit;
var $cc0bd523a3867d2a$require$localizedPackage = $gvQO6.localizedPackage;
module.exports = $bKnC7.extend({
    props: {
        id: {
            type: 'string',
            setOnce: true
        },
        productId: {
            type: 'string',
            required: true
        },
        units: {
            type: 'number',
            required: true,
            default: 0
        }
    },
    collections: {
        weight: $b2Qdr
    },
    session: {
        inputPackages: [
            'number',
            false,
            0
        ],
        inputUnits: [
            'number',
            false,
            0
        ],
        stockUnits: [
            'number',
            false,
            0
        ],
        weightUnits: [
            'number',
            false,
            0
        ],
        unitsLastInventory: [
            'number',
            false,
            0
        ],
        unitsSinceInventory: [
            'number',
            false,
            0
        ],
        lastInventoryId: [
            'string'
        ],
        lastInventoryTime: [
            'date'
        ]
    },
    derived: {
        product: {
            deps: [
                'productId'
            ],
            fn () {
                return $4UX9c.products.get(this.productId);
            }
        },
        unitsSold: {
            deps: [
                'stockUnits',
                'units'
            ],
            fn () {
                return this.stockUnits - this.units;
            }
        },
        isUnitsSoldNegative: {
            deps: [
                'unitsSold'
            ],
            fn () {
                return this.unitsSold < 0;
            }
        },
        inputUnitsLocalized: $cc0bd523a3867d2a$require$localizedUnit('inputUnits'),
        inputPackagesLocalized: $cc0bd523a3867d2a$require$localizedPackage('inputPackages'),
        unitsLocalized: $cc0bd523a3867d2a$require$unitsLocalized('units'),
        packagesLocalized: $cc0bd523a3867d2a$require$packagesLocalized('units'),
        unitsSoldLocalized: $cc0bd523a3867d2a$require$unitsLocalized('unitsSold'),
        packagesSoldLocalized: $cc0bd523a3867d2a$require$packagesLocalized('unitsSold'),
        unitsLastInventoryLocalized: $cc0bd523a3867d2a$require$unitsLocalized('unitsLastInventory'),
        packagesLastInventoryLocalized: $cc0bd523a3867d2a$require$packagesLocalized('unitsLastInventory'),
        unitsSinceInventoryLocalized: $cc0bd523a3867d2a$require$unitsLocalized('unitsSinceInventory'),
        packagesSinceInventoryLocalized: $cc0bd523a3867d2a$require$packagesLocalized('unitsSinceInventory')
    },
    initialize () {
        this.listenToAndRun(this, 'change:inputPackages change:inputUnits change:weightUnits', this.onAmountChange);
        this.listenToAndRun(this.weight, 'change add remove', this.onWeightChange);
    },
    parse (res) {
        if (Array.isArray(res.weight)) res.weight = res.weight.map((weight)=>{
            return {
                value: weight,
                productId: res.productId
            };
        });
        return res;
    },
    onAmountChange () {
        this.units = this.inputPackages * this.product.packageSize + this.inputUnits + this.weightUnits;
    },
    onWeightChange () {
        if (!this.product) return null;
        if (!this.weight || !this.weight.length) {
            this.weightUnits = 0;
            return null;
        }
        this.weightUnits = +this.weight.map((weight)=>new $eSA5k(weight.value).div(this.product.weightFull)).reduce((a, b)=>a.plus(b));
    }
});

});
parcelRegister("b2Qdr", function(module, exports) {

var $bKnC7 = parcelRequire("bKnC7");

var $kbVTi = parcelRequire("kbVTi");

var $4UX9c = parcelRequire("4UX9c");
const $80a8629a2d992ce4$var$Weight = $bKnC7.extend({
    props: {
        value: [
            'number',
            false,
            0
        ]
    },
    session: {
        productId: 'string'
    },
    derived: {
        product: {
            deps: [
                'productId'
            ],
            fn () {
                return $4UX9c.products.get(this.productId);
            }
        }
    },
    serialize () {
        return this.value;
    }
});
module.exports = $kbVTi.extend({
    model: $80a8629a2d992ce4$var$Weight
});

});


parcelRegister("imxrQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5e43a2ffa1466f5$export$2e2bcd8739ae039; });
function $d5e43a2ffa1466f5$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $d5e43a2ffa1466f5$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $d5e43a2ffa1466f5$var$pug_escape(e) {
    var a = "" + e, t = $d5e43a2ffa1466f5$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $d5e43a2ffa1466f5$var$pug_match_html = /["&<>]/;
function $d5e43a2ffa1466f5$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Cform class=\"shift-end-form pure-form-stacked\"\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-3\"\u003E\u003Clabel for=\"shiftName\"\u003ESchichtname\u003C\u002Flabel\u003E\u003Cinput" + (" type=\"text\" name=\"shiftName\"" + $d5e43a2ffa1466f5$var$pug_attr("value", model1.shiftName, true, false) + $d5e43a2ffa1466f5$var$pug_attr("required", true, true, false)) + "\u002F\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-3\"\u003E\u003Clabel for=\"date\"\u003ESchichtende\u003C\u002Flabel\u003E\u003Cdiv data-hook=\"date-picker\"\u003E\u003C\u002Fdiv\u003E";
        if (!model1.isNew()) pug_html = pug_html + '<p class="append error">Achtung: Durch \xc4nderung der Schichtendzeit <em>k\xf6nnen</em> bereits eingetragene Inventurbest\xe4nde verloren gehen.</p>';
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-3\"\u003E\u003Cdiv class=\"append\"\u003EDie Schichtendzeit muss eingestellt werden, damit der Bestand zu dieser Zeit ermittelt werden kann.\nDaraus errechnet sich die verkaufte Menge und schlussendlich die Differenz zwischen erhaltenem Betrag und Umsatz.\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $d5e43a2ffa1466f5$export$2e2bcd8739ae039 = $d5e43a2ffa1466f5$var$template;

});

parcelRegister("gVm2J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c52311860e266a7c$export$2e2bcd8739ae039; });
function $c52311860e266a7c$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $c52311860e266a7c$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $c52311860e266a7c$var$pug_escape(e) {
    var a = "" + e, t = $c52311860e266a7c$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $c52311860e266a7c$var$pug_match_html = /["&<>]/;
function $c52311860e266a7c$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(isAdmin1, model1) {
        pug_html = pug_html + "\u003Cform class=\"pure-form pure-form-stacked stock-taking-meta-form\"\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-2-3\"\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-4\"\u003E\u003Clabel for=\"tokens\"\u003EPersonalmarken\u003C\u002Flabel\u003E\u003Cinput" + (" type=\"number\" name=\"tokens\" step=\"1\" min=\"0\" placeholder=\"0\"" + $c52311860e266a7c$var$pug_attr("value", model1.tokens || null, true, false)) + "\u002F\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-4\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-4\"\u003E\u003Clabel for=\"amountGiven\"\u003EBetrag erhalten\u003C\u002Flabel\u003E\u003Cdiv class=\"input-addon\"\u003E\u003Cinput" + (' class="input-addon-field" type="number" name="amountGiven" step="0.01" min="0" placeholder="0"' + $c52311860e266a7c$var$pug_attr("value", model1.amountGiven || null, true, false)) + '/><span class="input-addon-item">\u20AC</span></div></div></div>';
        if (isAdmin1) pug_html = pug_html + "\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-3-4\"\u003E\u003Cul class=\"inventory-results\"\u003E\u003Cli\u003E\u003Cspan class=\"inventory-results__operator\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__value\" data-hook=\"sum-sold\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__descr\"\u003EUmsatz\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"inventory-results__operator\"\u003E-\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__value\" data-hook=\"tokens-localized\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__descr\"\u003E\u003Cspan data-hook=\"tokens\"\u003E\u003C\u002Fspan\u003E Personalmarke" + $c52311860e266a7c$var$pug_escape((pug_interp = model1.tokens > 1 || !model1.tokens ? 'n' : '', pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"inventory-results__result\"\u003E\u003Cspan class=\"inventory-results__operator\"\u003E=\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__value\" data-hook=\"sales-without-tokens\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__descr\"\u003EUmsatz abzgl. Personalmarken\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"inventory-results__result\"\u003E\u003Cspan class=\"inventory-results__operator\"\u003E=\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__value\" data-hook=\"difference\"\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__descr\"\u003EDifferenz\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-3\"\u003E\u003Clabel for=\"barChef\"\u003EBarchef\u003C\u002Flabel\u003E\u003Cinput" + (" type=\"text\" name=\"barChef\"" + $c52311860e266a7c$var$pug_attr("value", model1.barChef, true, false)) + "\u002F\u003E\u003Clabel for=\"comment\"\u003EKommentar\u003C\u002Flabel\u003E\u003Ctextarea class=\"pure-u-1\" name=\"comment\" rows=\"3\"\u003E" + $c52311860e266a7c$var$pug_escape(null == (pug_interp = model1.comment) ? "" : pug_interp) + "\u003C\u002Ftextarea\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"buttons\"\u003E\u003Cdiv class=\"btn-group\"\u003E\u003Cbutton class=\"pure-button\" type=\"reset\" title=\"Abbrechen (Esc)\" data-hook=\"cancel\"\u003E\u003Ci class=\"icon ion-close\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Cbutton class=\"pure-button button-success\" type=\"submit\" data-hook=\"submit\"\u003EInventur speichern\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fform\u003E";
    }).call(this, "isAdmin" in locals_for_with ? locals_for_with.isAdmin : typeof isAdmin !== 'undefined' ? isAdmin : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $c52311860e266a7c$export$2e2bcd8739ae039 = $c52311860e266a7c$var$template;

});

parcelRegister("ijmVO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d54bca07c6f10efe$export$2e2bcd8739ae039; });
function $d54bca07c6f10efe$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $d54bca07c6f10efe$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $d54bca07c6f10efe$var$pug_escape(e) {
    var a = "" + e, t = $d54bca07c6f10efe$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $d54bca07c6f10efe$var$pug_match_html = /["&<>]/;
function $d54bca07c6f10efe$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Cli class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-3-4\"\u003E\u003Cdiv class=\"input-addon\"\u003E\u003Cinput" + (' class="input-addon-field" name="weight" type="number" step="1"' + $d54bca07c6f10efe$var$pug_attr("min", model1.product.weightEmpty, true, false) + $d54bca07c6f10efe$var$pug_attr("max", model1.product.weightFull, true, false) + " placeholder=\"0\"" + $d54bca07c6f10efe$var$pug_attr("value", model1.value || null, true, false)) + "\u002F\u003E\u003Cdiv class=\"input-addon-item\"\u003Eg\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-4 right\"\u003E\u003Ca href=\"#\" role=\"button\" data-hook=\"remove-weight\"\u003E\u003Ci class=\"icon ion-ios-minus-outline\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fli\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $d54bca07c6f10efe$export$2e2bcd8739ae039 = $d54bca07c6f10efe$var$template;

});

parcelRegister("cRxPS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95d4ae5351b8b947$export$2e2bcd8739ae039; });
function $95d4ae5351b8b947$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $95d4ae5351b8b947$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $95d4ae5351b8b947$var$pug_escape(e) {
    var a = "" + e, t = $95d4ae5351b8b947$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $95d4ae5351b8b947$var$pug_match_html = /["&<>]/;
function $95d4ae5351b8b947$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1, pattern1) {
        var pattern1 = "^(\\d+(\\.?|,)\\d{0,2}\\+?)*$";
        pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E\u003Cdiv class=\"item-name\"\u003E" + $95d4ae5351b8b947$var$pug_escape(null == (pug_interp = model1.product.name) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Clabel for=\"inputPackages\"\u003E" + $95d4ae5351b8b947$var$pug_escape(null == (pug_interp = model1.product.package) ? "" : pug_interp) + "\u003C\u002Flabel\u003E\u003Cinput" + (" type=\"text\" name=\"inputPackages\"" + $95d4ae5351b8b947$var$pug_attr("pattern", pattern1, true, false) + " placeholder=\"0\"" + $95d4ae5351b8b947$var$pug_attr("value", model1.inputPackages || null, true, false)) + "\u002F\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Clabel for=\"inputUnits\"\u003E" + $95d4ae5351b8b947$var$pug_escape(null == (pug_interp = model1.product.unit) ? "" : pug_interp) + "\u003C\u002Flabel\u003E\u003Cinput" + (" type=\"text\" name=\"inputUnits\"" + $95d4ae5351b8b947$var$pug_attr("pattern", pattern1, true, false) + " placeholder=\"0\"" + $95d4ae5351b8b947$var$pug_attr("value", model1.inputUnits || null, true, false)) + "\u002F\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
        if (model1.product.factor !== 1) pug_html = pug_html + "\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-1 weight\"\u003E\u003Cdiv class=\"pure-g flex\"\u003E\u003Cdiv class=\"pure-u-3-4 weight-heading\"\u003E" + $95d4ae5351b8b947$var$pug_escape(null == (pug_interp = model1.product.unit) ? "" : pug_interp) + ' nach Gewicht</div><div class="pure-u-1-4 right weight-heading"><a href="#" role="button" title="Hinzuf\xfcgen..." data-hook="add-weight"><i class="ion-ios-plus-outline"></i></a></div></div><div class="pure-g"><ul class="list pure-u-1" data-hook="weights"></ul></div></div></div>';
        pug_html = pug_html + "\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"error\" data-hook=\"error\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd data-hook=\"sales\"\u003E\u003Cdiv data-hook=\"packages-sold\"\u003E" + $95d4ae5351b8b947$var$pug_escape(null == (pug_interp = model1.packagesSoldLocalized) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003Cdiv data-hook=\"units-sold\"\u003E" + $95d4ae5351b8b947$var$pug_escape(null == (pug_interp = model1.unitsSoldLocalized) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined, "pattern" in locals_for_with ? locals_for_with.pattern : typeof pattern !== 'undefined' ? pattern : undefined);
    return pug_html;
}
var $95d4ae5351b8b947$export$2e2bcd8739ae039 = $95d4ae5351b8b947$var$template;

});

parcelRegister("2CfSU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e7b73bb88e218e6$export$2e2bcd8739ae039; });
function $1e7b73bb88e218e6$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cform class=\"pure-form pure-form-stacked\"\u003E\u003Ctable class=\"pure-table table-striped\"\u003E\u003Cthead\u003E\u003Ctr\u003E\u003Cth\u003EProdukt\u003C\u002Fth\u003E\u003Cth\u003EBestand\u003C\u002Fth\u003E\u003Cth\u003EVerkauft\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody data-hook=\"item-list\"\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003C\u002Fform\u003E";
    return pug_html;
}
var $1e7b73bb88e218e6$export$2e2bcd8739ae039 = $1e7b73bb88e218e6$var$template;

});

parcelRegister("5TwzC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44ab5b3e4e4b5afc$export$2e2bcd8739ae039; });
function $44ab5b3e4e4b5afc$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $44ab5b3e4e4b5afc$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $44ab5b3e4e4b5afc$var$pug_escape(e) {
    var a = "" + e, t = $44ab5b3e4e4b5afc$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $44ab5b3e4e4b5afc$var$pug_match_html = /["&<>]/;
function $44ab5b3e4e4b5afc$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(backUrl1, location1, model1) {
        pug_html = pug_html + "\u003Cdiv class=\"stock-taking\"\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1-2\"\u003E\u003Ch1\u003E\u003Ca" + (" class=\"btn-back\"" + $44ab5b3e4e4b5afc$var$pug_attr("href", backUrl1, true, false)) + "\u003E\u003Ci class=\"ion-ios-arrow-back\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Cspan\u003EInventur " + $44ab5b3e4e4b5afc$var$pug_escape(null == (pug_interp = location1.name) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fh1\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Csection class=\"stock-taking-section\"\u003E\u003Ch2 class=\"stock-taking-section-header\"\u003E\u003Cspan\u003ESchicht\u003C\u002Fspan\u003E";
        if (model1.isNew()) pug_html = pug_html + '<button class="pure-button" data-hook="prefill">Erstbest\xfcckung</button>';
        pug_html = pug_html + "\u003C\u002Fh2\u003E\u003Cdiv data-hook=\"shift-end-form\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"stock-taking-section\"\u003E\u003Ch2 class=\"stock-taking-section-header\"\u003E\u003Cspan\u003EBestand\u003C\u002Fspan\u003E\u003Cdiv data-hook=\"filters\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fh2\u003E\u003Cdiv data-hook=\"entry-form\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003Csection class=\"stock-taking-section\"\u003E\u003Ch2 class=\"stock-taking-section-header\"\u003EWeitere Informationen\u003C\u002Fh2\u003E\u003Cdiv data-hook=\"meta-form\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fsection\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "backUrl" in locals_for_with ? locals_for_with.backUrl : typeof backUrl !== 'undefined' ? backUrl : undefined, "location" in locals_for_with ? locals_for_with.location : typeof location !== 'undefined' ? location : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $44ab5b3e4e4b5afc$export$2e2bcd8739ae039 = $44ab5b3e4e4b5afc$var$template;

});

parcelRegister("i2SG2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d232d39cd96b6941$export$2e2bcd8739ae039; });
function $d232d39cd96b6941$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $d232d39cd96b6941$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $d232d39cd96b6941$var$pug_classes(s, r) {
    return Array.isArray(s) ? $d232d39cd96b6941$var$pug_classes_array(s, r) : s && "object" == typeof s ? $d232d39cd96b6941$var$pug_classes_object(s) : s || "";
}
function $d232d39cd96b6941$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $d232d39cd96b6941$var$pug_classes(r[g])) && (c && a[g] && (s = $d232d39cd96b6941$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $d232d39cd96b6941$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $d232d39cd96b6941$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $d232d39cd96b6941$var$pug_escape(e) {
    var a = "" + e, t = $d232d39cd96b6941$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $d232d39cd96b6941$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $d232d39cd96b6941$var$pug_match_html = /["&<>]/;
function $d232d39cd96b6941$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1, transactionsLink1) {
        pug_html = pug_html + "\u003Ctr\u003E\u003Ctd\u003E\u003Cdiv class=\"item-name\"\u003E" + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = model1.product.name) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd\u003E";
        if (model1.lastInventoryId) pug_html = pug_html + "\u003Cspan class=\"packages\"\u003E" + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = model1.packagesLastInventoryLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"units\"\u003E" + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = model1.unitsLastInventoryLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
        else pug_html = pug_html + "\u003Cspan class=\"append\"\u003ENoch keine Inventur\u003C\u002Fspan\u003E";
        pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E";
        if (model1.unitsSinceInventory) pug_html = pug_html + "\u003Ca" + $d232d39cd96b6941$var$pug_attr("href", transactionsLink1, true, false) + "\u003E\u003Cspan class=\"packages\"\u003E" + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = model1.packagesSinceInventoryLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"units\"\u003E" + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = model1.unitsSinceInventoryLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
        else pug_html = pug_html + "\u003Cdiv class=\"append\"\u003EKeine Nachlieferung\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Ftd\u003E\u003Ctd\u003E\u003Cspan class=\"packages\"\u003E" + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = model1.inputPackagesLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"units\"\u003E" + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = model1.inputUnitsLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cdiv class=\"append\"\u003E";
        (function() {
            var $$obj = model1.weight.models;
            if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                var weight = $$obj[pug_index0];
                pug_html = pug_html + "\u003Cspan\u003E+ " + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = model1.product.unit) ? "" : pug_interp) + ": " + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = weight.value) ? "" : pug_interp) + "g\u003C\u002Fspan\u003E";
            }
            else {
                var $$l = 0;
                for(var pug_index0 in $$obj){
                    $$l++;
                    var weight = $$obj[pug_index0];
                    pug_html = pug_html + "\u003Cspan\u003E+ " + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = model1.product.unit) ? "" : pug_interp) + ": " + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = weight.value) ? "" : pug_interp) + "g\u003C\u002Fspan\u003E";
                }
            }
        }).call(this);
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd" + $d232d39cd96b6941$var$pug_attr("class", $d232d39cd96b6941$var$pug_classes([
            model1.unitsSold < 0 ? 'error' : null
        ], [
            true
        ]), false, false) + "\u003E\u003Cspan class=\"packages\"\u003E" + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = model1.packagesSoldLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"units\"\u003E" + $d232d39cd96b6941$var$pug_escape(null == (pug_interp = model1.unitsSoldLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined, "transactionsLink" in locals_for_with ? locals_for_with.transactionsLink : typeof transactionsLink !== 'undefined' ? transactionsLink : undefined);
    return pug_html;
}
var $d232d39cd96b6941$export$2e2bcd8739ae039 = $d232d39cd96b6941$var$template;

});

parcelRegister("dA8je", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e35152a53f723f3$export$2e2bcd8739ae039; });
function $9e35152a53f723f3$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $9e35152a53f723f3$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $9e35152a53f723f3$var$pug_classes(s, r) {
    return Array.isArray(s) ? $9e35152a53f723f3$var$pug_classes_array(s, r) : s && "object" == typeof s ? $9e35152a53f723f3$var$pug_classes_object(s) : s || "";
}
function $9e35152a53f723f3$var$pug_classes_array(r, a) {
    for(var s, e = "", u = "", c = Array.isArray(a), g = 0; g < r.length; g++)(s = $9e35152a53f723f3$var$pug_classes(r[g])) && (c && a[g] && (s = $9e35152a53f723f3$var$pug_escape(s)), e = e + u + s, u = " ");
    return e;
}
function $9e35152a53f723f3$var$pug_classes_object(r) {
    var a = "", n = "";
    for(var o in r)o && r[o] && $9e35152a53f723f3$var$pug_has_own_property.call(r, o) && (a = a + n + o, n = " ");
    return a;
}
function $9e35152a53f723f3$var$pug_escape(e) {
    var a = "" + e, t = $9e35152a53f723f3$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $9e35152a53f723f3$var$pug_has_own_property = Object.prototype.hasOwnProperty;
var $9e35152a53f723f3$var$pug_match_html = /["&<>]/;
function $9e35152a53f723f3$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(backUrl1, editUrl1, exportUrl1, lines1, location1, model1) {
        pug_html = pug_html + "\u003Cdiv class=\"stock-taking-page stock-taking-page__details\"\u003E\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-3-4\"\u003E\u003Ch1\u003E\u003Ca" + (" class=\"btn-back\"" + $9e35152a53f723f3$var$pug_attr("href", backUrl1, true, false)) + "\u003E\u003Ci class=\"ion-ios-arrow-back\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Cspan\u003E" + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = model1.shiftName || 'Schicht') ? "" : pug_interp) + " " + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = location1.name) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Fh1\u003E\u003Cdiv class=\"append\"\u003ESchichtende: " + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = model1.shiftEndTimeLocalized) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-4\"\u003E\u003Cdiv class=\"buttons btn-group\"\u003E\u003Ca" + (" class=\"btn-round pure-button\"" + $9e35152a53f723f3$var$pug_attr("href", exportUrl1, true, false) + " title=\"Inventur herunterladen...\" target=\"_blank\"") + "\u003E\u003Ci class=\"icon ion-ios-cloud-download\"\u003E\u003C\u002Fi\u003E\u003C\u002Fa\u003E\u003Ca" + (" class=\"btn-round pure-button\"" + $9e35152a53f723f3$var$pug_attr("href", editUrl1, true, false) + " data-title=\"Inventur bearbeiten...\"") + '><i class="icon ion-edit"></i></a><div data-hook="delete"></div></div></div></div><div class="pure-g"><div class="pure-u-1"><h2 class="stock-taking-section-header"><span>Best\xe4nde</span><div data-hook="search-bar"></div></h2></div></div><div class="pure-g"><div class="pure-u-1"><table class="pure-table table-striped"><thead><tr><th>Produkt</th><th>Anfangsbestand</th><th>Nachlieferung</th><th>Endbestand</th><th>Verkauf</th></tr></thead><tbody data-hook="item-list"></tbody></table></div></div><div class="pure-g"><div class="pure-u-1"><h2 class="stock-taking-section-header">Informationen</h2></div></div><div class="pure-g"><div class="pure-u-2-3"><h3>Umsatz</h3><div class="pure-u-3-4"><ul class="inventory-results"><li><span class="inventory-results__operator"></span><span' + $9e35152a53f723f3$var$pug_attr("class", $9e35152a53f723f3$var$pug_classes([
            "inventory-results__value",
            model1.sumSold < 0 ? 'error' : null
        ], [
            false,
            true
        ]), false, false) + "\u003E" + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = model1.sumSoldLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__descr\"\u003EUmsatz\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"inventory-results__operator\"\u003E-\u003C\u002Fspan\u003E\u003Cspan" + $9e35152a53f723f3$var$pug_attr("class", $9e35152a53f723f3$var$pug_classes([
            "inventory-results__value",
            model1.tokens < 0 ? 'error' : null
        ], [
            false,
            true
        ]), false, false) + "\u003E" + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = model1.tokensLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__descr\"\u003E" + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = model1.tokens) ? "" : pug_interp) + " Personalmarke" + $9e35152a53f723f3$var$pug_escape((pug_interp = model1.tokens > 1 || !model1.tokens ? 'n' : '', pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"inventory-results__result\"\u003E\u003Cspan class=\"inventory-results__operator\"\u003E=\u003C\u002Fspan\u003E\u003Cspan" + $9e35152a53f723f3$var$pug_attr("class", $9e35152a53f723f3$var$pug_classes([
            "inventory-results__value",
            model1.salesWithoutTokens < 0 ? 'error' : null
        ], [
            false,
            true
        ]), false, false) + "\u003E" + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = model1.salesWithoutTokensLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__descr\"\u003EUmsatz abzgl. Personalmarken\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-3-4\"\u003E\u003Cul class=\"inventory-results\"\u003E\u003Cli\u003E\u003Cspan class=\"inventory-results__operator\"\u003E\u003C\u002Fspan\u003E\u003Cspan" + $9e35152a53f723f3$var$pug_attr("class", $9e35152a53f723f3$var$pug_classes([
            "inventory-results__value",
            model1.amountGiven < 0 ? 'error' : null
        ], [
            false,
            true
        ]), false, false) + "\u003E" + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = model1.amountGivenLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__descr\"\u003EBetrag erhalten\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"inventory-results__operator\"\u003E-\u003C\u002Fspan\u003E\u003Cspan" + $9e35152a53f723f3$var$pug_attr("class", $9e35152a53f723f3$var$pug_classes([
            "inventory-results__value",
            model1.salesWithoutTokens < 0 ? 'error' : null
        ], [
            false,
            true
        ]), false, false) + "\u003E" + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = model1.salesWithoutTokensLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__descr\"\u003EUmsatz abzgl. Personalmarken\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"inventory-results__result\"\u003E\u003Cspan class=\"inventory-results__operator\"\u003E=\u003C\u002Fspan\u003E\u003Cspan" + $9e35152a53f723f3$var$pug_attr("class", $9e35152a53f723f3$var$pug_classes([
            "inventory-results__value",
            model1.differenceWithoutTokens < 0 ? 'error' : null
        ], [
            false,
            true
        ]), false, false) + "\u003E" + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = model1.differenceWithoutTokensLocalized) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"inventory-results__descr\"\u003EDifferenz\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pure-u-1-3\"\u003E\u003Ch3\u003EKommentar\u003C\u002Fh3\u003E\u003Cdiv class=\"comment-field-wrap\"\u003E\u003Cdiv class=\"arrow\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"comment-field\"\u003E";
        if (model1.comment) {
            var lines1 = model1.comment.split('\n');
            (function() {
                var $$obj = lines1;
                if ('number' == typeof $$obj.length) for(var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++){
                    var line = $$obj[pug_index0];
                    pug_html = pug_html + "\u003Cspan\u003E" + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = line) ? "" : pug_interp) + " \u003Cbr\u003E\u003C\u002Fspan\u003E";
                }
                else {
                    var $$l = 0;
                    for(var pug_index0 in $$obj){
                        $$l++;
                        var line = $$obj[pug_index0];
                        pug_html = pug_html + "\u003Cspan\u003E" + $9e35152a53f723f3$var$pug_escape(null == (pug_interp = line) ? "" : pug_interp) + " \u003Cbr\u003E\u003C\u002Fspan\u003E";
                    }
                }
            }).call(this);
        } else pug_html = pug_html + "\u003Cdiv class=\"append\"\u003EKein Kommentar hinterlegt.\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }).call(this, "backUrl" in locals_for_with ? locals_for_with.backUrl : typeof backUrl !== 'undefined' ? backUrl : undefined, "editUrl" in locals_for_with ? locals_for_with.editUrl : typeof editUrl !== 'undefined' ? editUrl : undefined, "exportUrl" in locals_for_with ? locals_for_with.exportUrl : typeof exportUrl !== 'undefined' ? exportUrl : undefined, "lines" in locals_for_with ? locals_for_with.lines : typeof lines !== 'undefined' ? lines : undefined, "location" in locals_for_with ? locals_for_with.location : typeof location !== 'undefined' ? location : undefined, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $9e35152a53f723f3$export$2e2bcd8739ae039 = $9e35152a53f723f3$var$template;

});

parcelRegister("c87Yy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d4c6b2c2e4a1d99$export$2e2bcd8739ae039; });
function $8d4c6b2c2e4a1d99$var$pug_escape(e) {
    var a = "" + e, t = $8d4c6b2c2e4a1d99$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $8d4c6b2c2e4a1d99$var$pug_match_html = /["&<>]/;
function $8d4c6b2c2e4a1d99$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(path1) {
        pug_html = pug_html + "\u003Cdiv class=\"page not-found-page\"\u003E\u003Ch1\u003EEs gibt ein Problem :-(\u003C\u002Fh1\u003E\u003Cp\u003ETut mir leid, aber \u003Ccode\u003E\u002F" + $8d4c6b2c2e4a1d99$var$pug_escape(null == (pug_interp = path1) ? "" : pug_interp) + "</code> kann ich nicht f\xfcr dich \xf6ffnen.</p></div>";
    }).call(this, "path" in locals_for_with ? locals_for_with.path : typeof path !== 'undefined' ? path : undefined);
    return pug_html;
}
var $8d4c6b2c2e4a1d99$export$2e2bcd8739ae039 = $8d4c6b2c2e4a1d99$var$template;

});

parcelRegister("aCsQD", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("iVK96"))(import.meta.resolve("f99QM")),
    import("96HWl")
]).then(()=>parcelRequire('9nga5'));

});

parcelRegister("jDUXD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4cdd814712933fb$export$2e2bcd8739ae039; });
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $e4cdd814712933fb$var$isArray(value) {
    return !Array.isArray ? $e4cdd814712933fb$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $e4cdd814712933fb$var$INFINITY = 1 / 0;
function $e4cdd814712933fb$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$e4cdd814712933fb$var$INFINITY ? '-0' : result;
}
function $e4cdd814712933fb$var$toString(value) {
    return value == null ? '' : $e4cdd814712933fb$var$baseToString(value);
}
function $e4cdd814712933fb$var$isString(value) {
    return typeof value === 'string';
}
function $e4cdd814712933fb$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $e4cdd814712933fb$var$isBoolean(value) {
    return value === true || value === false || $e4cdd814712933fb$var$isObjectLike(value) && $e4cdd814712933fb$var$getTag(value) == '[object Boolean]';
}
function $e4cdd814712933fb$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $e4cdd814712933fb$var$isObjectLike(value) {
    return $e4cdd814712933fb$var$isObject(value) && value !== null;
}
function $e4cdd814712933fb$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $e4cdd814712933fb$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $e4cdd814712933fb$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $e4cdd814712933fb$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $e4cdd814712933fb$var$LOGICAL_SEARCH_UNAVAILABLE = 'Logical search is not available';
const $e4cdd814712933fb$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $e4cdd814712933fb$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $e4cdd814712933fb$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $e4cdd814712933fb$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $e4cdd814712933fb$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $e4cdd814712933fb$var$hasOwn = Object.prototype.hasOwnProperty;
class $e4cdd814712933fb$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $e4cdd814712933fb$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $e4cdd814712933fb$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($e4cdd814712933fb$var$isString(key) || $e4cdd814712933fb$var$isArray(key)) {
        src = key;
        path = $e4cdd814712933fb$var$createKeyPath(key);
        id = $e4cdd814712933fb$var$createKeyId(key);
    } else {
        if (!$e4cdd814712933fb$var$hasOwn.call(key, 'name')) throw new Error($e4cdd814712933fb$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($e4cdd814712933fb$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($e4cdd814712933fb$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $e4cdd814712933fb$var$createKeyPath(name);
        id = $e4cdd814712933fb$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $e4cdd814712933fb$var$createKeyPath(key) {
    return $e4cdd814712933fb$var$isArray(key) ? key : key.split('.');
}
function $e4cdd814712933fb$var$createKeyId(key) {
    return $e4cdd814712933fb$var$isArray(key) ? key.join('.') : key;
}
function $e4cdd814712933fb$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$e4cdd814712933fb$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$e4cdd814712933fb$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($e4cdd814712933fb$var$isString(value) || $e4cdd814712933fb$var$isNumber(value) || $e4cdd814712933fb$var$isBoolean(value))) list.push($e4cdd814712933fb$var$toString(value));
            else if ($e4cdd814712933fb$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $e4cdd814712933fb$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $e4cdd814712933fb$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $e4cdd814712933fb$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $e4cdd814712933fb$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $e4cdd814712933fb$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $e4cdd814712933fb$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $e4cdd814712933fb$var$Config = {
    ...$e4cdd814712933fb$var$BasicOptions,
    ...$e4cdd814712933fb$var$MatchOptions,
    ...$e4cdd814712933fb$var$FuzzyOptions,
    ...$e4cdd814712933fb$var$AdvancedOptions
};
const $e4cdd814712933fb$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $e4cdd814712933fb$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($e4cdd814712933fb$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $e4cdd814712933fb$var$FuseIndex {
    constructor({ getFn: getFn = $e4cdd814712933fb$var$Config.getFn, fieldNormWeight: fieldNormWeight = $e4cdd814712933fb$var$Config.fieldNormWeight } = {}){
        this.norm = $e4cdd814712933fb$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($e4cdd814712933fb$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($e4cdd814712933fb$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$e4cdd814712933fb$var$isDefined(doc) || $e4cdd814712933fb$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$e4cdd814712933fb$var$isDefined(value)) return;
            if ($e4cdd814712933fb$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$e4cdd814712933fb$var$isDefined(value)) continue;
                    if ($e4cdd814712933fb$var$isString(value) && !$e4cdd814712933fb$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($e4cdd814712933fb$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($e4cdd814712933fb$var$isString(value) && !$e4cdd814712933fb$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $e4cdd814712933fb$var$createIndex(keys, docs, { getFn: getFn = $e4cdd814712933fb$var$Config.getFn, fieldNormWeight: fieldNormWeight = $e4cdd814712933fb$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $e4cdd814712933fb$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($e4cdd814712933fb$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $e4cdd814712933fb$var$parseIndex(data, { getFn: getFn = $e4cdd814712933fb$var$Config.getFn, fieldNormWeight: fieldNormWeight = $e4cdd814712933fb$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $e4cdd814712933fb$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $e4cdd814712933fb$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $e4cdd814712933fb$var$Config.distance, ignoreLocation: ignoreLocation = $e4cdd814712933fb$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $e4cdd814712933fb$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $e4cdd814712933fb$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $e4cdd814712933fb$var$MAX_BITS = 32;
function $e4cdd814712933fb$var$search(text, pattern, patternAlphabet, { location: location = $e4cdd814712933fb$var$Config.location, distance: distance = $e4cdd814712933fb$var$Config.distance, threshold: threshold = $e4cdd814712933fb$var$Config.threshold, findAllMatches: findAllMatches = $e4cdd814712933fb$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $e4cdd814712933fb$var$Config.minMatchCharLength, includeMatches: includeMatches = $e4cdd814712933fb$var$Config.includeMatches, ignoreLocation: ignoreLocation = $e4cdd814712933fb$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $e4cdd814712933fb$var$MAX_BITS) throw new Error($e4cdd814712933fb$var$PATTERN_LENGTH_TOO_LARGE($e4cdd814712933fb$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $e4cdd814712933fb$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $e4cdd814712933fb$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $e4cdd814712933fb$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $e4cdd814712933fb$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $e4cdd814712933fb$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $e4cdd814712933fb$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $e4cdd814712933fb$var$BitapSearch {
    constructor(pattern, { location: location = $e4cdd814712933fb$var$Config.location, threshold: threshold = $e4cdd814712933fb$var$Config.threshold, distance: distance = $e4cdd814712933fb$var$Config.distance, includeMatches: includeMatches = $e4cdd814712933fb$var$Config.includeMatches, findAllMatches: findAllMatches = $e4cdd814712933fb$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $e4cdd814712933fb$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $e4cdd814712933fb$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $e4cdd814712933fb$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $e4cdd814712933fb$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $e4cdd814712933fb$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $e4cdd814712933fb$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $e4cdd814712933fb$var$MAX_BITS), i);
                i += $e4cdd814712933fb$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $e4cdd814712933fb$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $e4cdd814712933fb$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
const $e4cdd814712933fb$var$registeredSearchers = [];
function $e4cdd814712933fb$var$createSearcher(pattern, options) {
    for(let i = 0, len = $e4cdd814712933fb$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $e4cdd814712933fb$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $e4cdd814712933fb$var$BitapSearch(pattern, options);
}
const $e4cdd814712933fb$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $e4cdd814712933fb$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $e4cdd814712933fb$var$isExpression = (query)=>!!(query[$e4cdd814712933fb$var$LogicalOperator.AND] || query[$e4cdd814712933fb$var$LogicalOperator.OR]);
const $e4cdd814712933fb$var$isPath = (query)=>!!query[$e4cdd814712933fb$var$KeyType.PATH];
const $e4cdd814712933fb$var$isLeaf = (query)=>!$e4cdd814712933fb$var$isArray(query) && $e4cdd814712933fb$var$isObject(query) && !$e4cdd814712933fb$var$isExpression(query);
const $e4cdd814712933fb$var$convertToExplicit = (query)=>({
        [$e4cdd814712933fb$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $e4cdd814712933fb$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $e4cdd814712933fb$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$e4cdd814712933fb$var$isExpression(query)) return next($e4cdd814712933fb$var$convertToExplicit(query));
        if ($e4cdd814712933fb$var$isLeaf(query)) {
            const key = isQueryPath ? query[$e4cdd814712933fb$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$e4cdd814712933fb$var$KeyType.PATTERN] : query[key];
            if (!$e4cdd814712933fb$var$isString(pattern)) throw new Error($e4cdd814712933fb$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $e4cdd814712933fb$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $e4cdd814712933fb$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($e4cdd814712933fb$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$e4cdd814712933fb$var$isExpression(query)) query = $e4cdd814712933fb$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $e4cdd814712933fb$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $e4cdd814712933fb$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $e4cdd814712933fb$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$e4cdd814712933fb$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$e4cdd814712933fb$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $e4cdd814712933fb$var$transformScore(result, data) {
    data.score = result.score;
}
function $e4cdd814712933fb$var$format(results, docs, { includeMatches: includeMatches = $e4cdd814712933fb$var$Config.includeMatches, includeScore: includeScore = $e4cdd814712933fb$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($e4cdd814712933fb$var$transformMatches);
    if (includeScore) transformers.push($e4cdd814712933fb$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $e4cdd814712933fb$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$e4cdd814712933fb$var$Config,
            ...options
        };
        if (this.options.useExtendedSearch && true) throw new Error($e4cdd814712933fb$var$EXTENDED_SEARCH_UNAVAILABLE);
        this._keyStore = new $e4cdd814712933fb$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $e4cdd814712933fb$var$FuseIndex)) throw new Error($e4cdd814712933fb$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $e4cdd814712933fb$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$e4cdd814712933fb$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $e4cdd814712933fb$var$isString(query) ? $e4cdd814712933fb$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $e4cdd814712933fb$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($e4cdd814712933fb$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $e4cdd814712933fb$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $e4cdd814712933fb$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$e4cdd814712933fb$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        throw new Error($e4cdd814712933fb$var$LOGICAL_SEARCH_UNAVAILABLE);
    }
    _searchObjectList(query) {
        const searcher = $e4cdd814712933fb$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$e4cdd814712933fb$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$e4cdd814712933fb$var$isDefined(value)) return [];
        let matches = [];
        if ($e4cdd814712933fb$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$e4cdd814712933fb$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$e4cdd814712933fb$export$2e2bcd8739ae039.version = '6.6.2';
$e4cdd814712933fb$export$2e2bcd8739ae039.createIndex = $e4cdd814712933fb$var$createIndex;
$e4cdd814712933fb$export$2e2bcd8739ae039.parseIndex = $e4cdd814712933fb$var$parseIndex;
$e4cdd814712933fb$export$2e2bcd8739ae039.config = $e4cdd814712933fb$var$Config;
$e4cdd814712933fb$export$2e2bcd8739ae039.parseQuery = $e4cdd814712933fb$var$parse;

});

parcelRegister("2lFhQ", function(module, exports) {

$parcel$export(module.exports, "TextButton", function () { return $f36cf4482136cdaa$export$652b5b0d951b8801; });

var $8jWPf = parcelRequire("8jWPf");

var $d5emt = parcelRequire("d5emt");
function $f36cf4482136cdaa$export$652b5b0d951b8801({ onClick: onClick, children: children, variant: variant }) {
    return /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
        type: "button",
        class: variant === 'error' ? $d5emt.textButtonError : $d5emt.textButton,
        onClick: onClick,
        children: children
    });
}

});
parcelRegister("d5emt", function(module, exports) {

$parcel$export(module.exports, "textButton", function () { return $9866e1e456583866$export$9254cd51d610f2d2; }, function (v) { return $9866e1e456583866$export$9254cd51d610f2d2 = v; });
$parcel$export(module.exports, "textButtonError", function () { return $9866e1e456583866$export$8e3be3c8774c469e; }, function (v) { return $9866e1e456583866$export$8e3be3c8774c469e = v; });
var $9866e1e456583866$export$9254cd51d610f2d2;
var $9866e1e456583866$export$8e3be3c8774c469e;
$9866e1e456583866$export$9254cd51d610f2d2 = `p5RAHa_textButton`;
$9866e1e456583866$export$8e3be3c8774c469e = `p5RAHa_textButtonError ${$9866e1e456583866$export$9254cd51d610f2d2}`;

});


parcelRegister("7PP8M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b44f748eee8af83$export$2e2bcd8739ae039; });
function $5b44f748eee8af83$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $5b44f748eee8af83$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $5b44f748eee8af83$var$pug_escape(e) {
    var a = "" + e, t = $5b44f748eee8af83$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $5b44f748eee8af83$var$pug_match_html = /["&<>]/;
function $5b44f748eee8af83$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(model1) {
        pug_html = pug_html + "\u003Cnav class=\"sidebar\"\u003E\u003Cdiv data-hook=\"dispatch-button-placeholder\"\u003E\u003C\u002Fdiv\u003E";
        if (model1.role !== 'bar') pug_html = pug_html + '<a class="toggleable" href="/" data-title="\xdcbersicht"><i class="icon ion-stats-bars"></i><div class="label">\xdcbersicht</div></a>';
        pug_html = pug_html + "\u003Ca" + (' class="toggleable" href="/bars"' + $5b44f748eee8af83$var$pug_attr("data-title", `${model1.role === 'bar' ? 'Meine Bar' : 'Bars'}`, true, false)) + "\u003E\u003Ci class=\"icon ion-ios-wineglass\"\u003E\u003C\u002Fi\u003E";
        if (model1.role === 'bar') pug_html = pug_html + "\u003Cdiv class=\"label\"\u003EMeine Bar\u003C\u002Fdiv\u003E";
        else pug_html = pug_html + "\u003Cdiv class=\"label\"\u003EBars\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Fa\u003E";
        if (model1.role !== 'bar') pug_html = pug_html + "\u003Ca class=\"toggleable\" href=\"\u002Flager\" data-title=\"Lager\"\u003E\u003Ci class=\"icon ion-ios-box\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"label\"\u003ELager\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"toggleable\" href=\"\u002Ftransaktionen\" data-title=\"Transaktionen\"\u003E\u003Ci class=\"icon ion-clipboard\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"label\"\u003ETransaktionen\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"toggleable\" href=\"\u002Fprodukte\" data-title=\"Produkte\"\u003E\u003Ci class=\"icon ion-cube\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"label\"\u003EProdukte\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E";
        pug_html = pug_html + "\u003Cdiv class=\"bottom\"\u003E\u003Cdiv data-hook=\"taskboard-toggle\"\u003E\u003C\u002Fdiv\u003E\u003Ca class=\"mobile-only\" href=\"\u002Ftaskboard\" data-title=\"Taskboard anzeigen\"\u003E\u003Ci class=\"icon ion-clipboard\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"label\"\u003ETaskboard\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca href=\"\u002Feinstellungen\" data-title=\"Einstellungen\"\u003E\u003Ci class=\"icon ion-ios-gear\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"label\"\u003EEinstellungen\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Ca class=\"logout\" href=\"\u002Flogout\" data-title=\"Abmelden...\"\u003E\u003Ci class=\"icon ion-log-out\"\u003E\u003C\u002Fi\u003E\u003Cdiv class=\"label\"\u003EAbmelden\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003Cdiv class=\"sync-indicator\" data-hook=\"sync-indicator\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fnav\u003E";
    }).call(this, "model" in locals_for_with ? locals_for_with.model : typeof model !== 'undefined' ? model : undefined);
    return pug_html;
}
var $5b44f748eee8af83$export$2e2bcd8739ae039 = $5b44f748eee8af83$var$template;

});

parcelRegister("iQ95b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db7420ebde81df74$export$2e2bcd8739ae039; });
function $db7420ebde81df74$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"app-view\"\u003E\u003Cdiv data-hook=\"sidebar\"\u003E\u003C\u002Fdiv\u003E\u003Cmain role=\"main\"\u003E\u003C\u002Fmain\u003E\u003Cdiv data-hook=\"transit-bar\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $db7420ebde81df74$export$2e2bcd8739ae039 = $db7420ebde81df74$var$template;

});

parcelRegister("1ghuY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0eb4dbe7aef6f6ec$export$2e2bcd8739ae039; });
function $0eb4dbe7aef6f6ec$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $0eb4dbe7aef6f6ec$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $0eb4dbe7aef6f6ec$var$pug_escape(e) {
    var a = "" + e, t = $0eb4dbe7aef6f6ec$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $0eb4dbe7aef6f6ec$var$pug_match_html = /["&<>]/;
function $0eb4dbe7aef6f6ec$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"auth-flip-view front\"\u003E\u003Cform class=\"pure-form pure-form-stacked login-form\"\u003E\u003Cfieldset\u003E\u003Clegend\u003EAnmelden\u003C\u002Flegend\u003E\u003Clabel for=\"username\"\u003EBenutzername\u003C\u002Flabel\u003E\u003Cinput" + (' class="pure-u-1" name="username" type="text" placeholder="Name" data-hook="username"' + $0eb4dbe7aef6f6ec$var$pug_attr("autofocus", true, true, false) + " autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\"") + "\u002F\u003E\u003Clabel for=\"password\"\u003EPasswort\u003C\u002Flabel\u003E\u003Cinput class=\"pure-u-1\" type=\"password\" name=\"password\" placeholder=\"Passwort\" data-hook=\"password\" autocomplete=\"current-password\"\u002F\u003E\u003C\u002Ffieldset\u003E\u003Cbutton" + (' class="pure-button pure-button-primary" type="submit"' + $0eb4dbe7aef6f6ec$var$pug_attr("disabled", true, true, false)) + "\u003EAnmelden\u003C\u002Fbutton\u003E\u003Cp class=\"note\"\u003E...oder \u003Ca href=\"\u002Fsignup\", data-hook=\"flip\"\u003Eneuen Benutzer anlegen.\u003C\u002Fa\u003E\u003C\u002Fp\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $0eb4dbe7aef6f6ec$export$2e2bcd8739ae039 = $0eb4dbe7aef6f6ec$var$template;

});

parcelRegister("adc34", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76f476e30802cad2$export$2e2bcd8739ae039; });
function $76f476e30802cad2$var$pug_attr(t, e, n, r) {
    if (!1 === e || null == e || !e && ("class" === t || "style" === t)) return "";
    if (!0 === e) return " " + (r ? t : t + '="' + t + '"');
    var f = typeof e;
    return "object" !== f && "function" !== f || "function" != typeof e.toJSON || (e = e.toJSON()), "string" == typeof e || (e = JSON.stringify(e), n || -1 === e.indexOf('"')) ? (n && (e = $76f476e30802cad2$var$pug_escape(e)), " " + t + '="' + e + '"') : " " + t + "='" + e.replace(/'/g, "&#39;") + "'";
}
function $76f476e30802cad2$var$pug_escape(e) {
    var a = "" + e, t = $76f476e30802cad2$var$pug_match_html.exec(a);
    if (!t) return e;
    var r, c, n, s = "";
    for(r = t.index, c = 0; r < a.length; r++){
        switch(a.charCodeAt(r)){
            case 34:
                n = "&quot;";
                break;
            case 38:
                n = "&amp;";
                break;
            case 60:
                n = "&lt;";
                break;
            case 62:
                n = "&gt;";
                break;
            default:
                continue;
        }
        c !== r && (s += a.substring(c, r)), c = r + 1, s += n;
    }
    return c !== r ? s + a.substring(c, r) : s;
}
var $76f476e30802cad2$var$pug_match_html = /["&<>]/;
function $76f476e30802cad2$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"auth-flip-view back\"\u003E\u003Cform class=\"pure-form pure-form-stacked signup-form\"\u003E\u003Cfieldset\u003E\u003Clegend\u003ENeuen Benutzer anlegen\u003C\u002Flegend\u003E\u003Clabel for=\"username\"\u003EBenutzername\u003C\u002Flabel\u003E\u003Cinput class=\"pure-u-1\" name=\"username\" type=\"text\" placeholder=\"Name\" data-hook=\"username\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\"\u002F\u003E\u003Clabel for=\"password\"\u003EPasswort\u003C\u002Flabel\u003E\u003Cinput class=\"pure-u-1\" type=\"password\" name=\"password\" placeholder=\"Passwort\" data-hook=\"password\"\u002F\u003E\u003C\u002Ffieldset\u003E\u003Cbutton" + (' class="pure-button pure-button-primary" type="submit"' + $76f476e30802cad2$var$pug_attr("disabled", true, true, false)) + "\u003EAnlegen\u003C\u002Fbutton\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $76f476e30802cad2$export$2e2bcd8739ae039 = $76f476e30802cad2$var$template;

});

parcelRegister("6F4FQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d9a329052f3b77f$export$2e2bcd8739ae039; });
function $4d9a329052f3b77f$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"auth-page animated\"\u003E\u003Cdiv class=\"auth-container animated\"\u003E\u003Cbutton class=\"btn-back btn-round\" data-hook=\"flip\"\u003E\u003Ci class=\"icon ion-ios-arrow-back\"\u003E\u003C\u002Fi\u003E\u003C\u002Fbutton\u003E\u003Ch1\u003EHallo!\u003C\u002Fh1\u003E\u003Cdiv class=\"auth-wrap animated\"\u003E\u003Cdiv class=\"auth-flip\"\u003E\u003Cdiv data-hook=\"login-form\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv data-hook=\"signup-form\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $4d9a329052f3b77f$export$2e2bcd8739ae039 = $4d9a329052f3b77f$var$template;

});

// Must be the first import

var $4UX9c = parcelRequire("4UX9c");
var $1a78df6965cbbfa3$exports = {};
'use strict';
$1a78df6965cbbfa3$exports = $1a78df6965cbbfa3$var$isMobile;
$1a78df6965cbbfa3$exports.isMobile = $1a78df6965cbbfa3$var$isMobile;
$1a78df6965cbbfa3$exports.default = $1a78df6965cbbfa3$var$isMobile;
const $1a78df6965cbbfa3$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $1a78df6965cbbfa3$var$notMobileRE = /CrOS/;
const $1a78df6965cbbfa3$var$tabletRE = /android|ipad|playbook|silk/i;
function $1a78df6965cbbfa3$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') ua = ua.headers['user-agent'];
    if (typeof ua !== 'string') return false;
    let result = $1a78df6965cbbfa3$var$mobileRE.test(ua) && !$1a78df6965cbbfa3$var$notMobileRE.test(ua) || !!opts.tablet && $1a78df6965cbbfa3$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf('Macintosh') !== -1 && ua.indexOf('Safari') !== -1) result = true;
    return result;
}


var $adb0503b084cff6f$require$isMobile = $1a78df6965cbbfa3$exports.default;
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $9b342122f068002c$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $e33c76202c032506$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $5e6f83b9b79b6324$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $e33c76202c032506$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $5e6f83b9b79b6324$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $e33c76202c032506$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $5e6f83b9b79b6324$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $e33c76202c032506$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $70bf311aba1341ca$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(element) || !(0, $9b342122f068002c$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $70bf311aba1341ca$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(element) || !(0, $9b342122f068002c$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $70bf311aba1341ca$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $70bf311aba1341ca$var$applyStyles,
    effect: $70bf311aba1341ca$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $88c23c8a4a5b2a6f$export$8960430cfd85939f = Math.max;
var $88c23c8a4a5b2a6f$export$96ec731ed4dcb222 = Math.min;
var $88c23c8a4a5b2a6f$export$2077e0241d6afd3c = Math.round;


function $6e283a17cd63e534$export$2e2bcd8739ae039(element, includeScale) {
    if (includeScale === void 0) includeScale = false;
    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if ((0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(element) && includeScale) {
        var offsetHeight = element.offsetHeight;
        var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
        // Fallback to 1 in case both values are `0`
        if (offsetWidth > 0) scaleX = (0, $88c23c8a4a5b2a6f$export$2077e0241d6afd3c)(rect.width) / offsetWidth || 1;
        if (offsetHeight > 0) scaleY = (0, $88c23c8a4a5b2a6f$export$2077e0241d6afd3c)(rect.height) / offsetHeight || 1;
    }
    return {
        width: rect.width / scaleX,
        height: rect.height / scaleY,
        top: rect.top / scaleY,
        right: rect.right / scaleX,
        bottom: rect.bottom / scaleY,
        left: rect.left / scaleX,
        x: rect.left / scaleX,
        y: rect.top / scaleY
    };
}



function $210427f4deede664$export$2e2bcd8739ae039(node) {
    var win = (0, $e33c76202c032506$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $845223b8862f0d0e$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $4722de47ab44c72a$export$2e2bcd8739ae039(node) {
    if (node === (0, $e33c76202c032506$export$2e2bcd8739ae039)(node) || !(0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(node)) return (0, $210427f4deede664$export$2e2bcd8739ae039)(node);
    else return (0, $845223b8862f0d0e$export$2e2bcd8739ae039)(node);
}






function $365d1c6041a06ca4$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $5e6f83b9b79b6324$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $b582b21684353abb$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $6e283a17cd63e534$export$2e2bcd8739ae039)((0, $365d1c6041a06ca4$export$2e2bcd8739ae039)(element)).left + (0, $210427f4deede664$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $8e19826974e26cb7$export$2e2bcd8739ae039(element) {
    return (0, $e33c76202c032506$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $034ff6d64f3c51eb$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $8e19826974e26cb7$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $764bab28da985192$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $88c23c8a4a5b2a6f$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $88c23c8a4a5b2a6f$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $764bab28da985192$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(offsetParent) && $764bab28da985192$var$isElementScaled(offsetParent);
    var documentElement = (0, $365d1c6041a06ca4$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $6e283a17cd63e534$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $9b342122f068002c$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $034ff6d64f3c51eb$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $4722de47ab44c72a$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $6e283a17cd63e534$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $b582b21684353abb$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $2add3ba4eb5a14c0$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $6e283a17cd63e534$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $1bdab8fcaddb25a1$export$2e2bcd8739ae039(element) {
    if ((0, $9b342122f068002c$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $5e6f83b9b79b6324$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $365d1c6041a06ca4$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $bc6a10a4b5f338b1$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $9b342122f068002c$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(node) && (0, $034ff6d64f3c51eb$export$2e2bcd8739ae039)(node)) return node;
    return $bc6a10a4b5f338b1$export$2e2bcd8739ae039((0, $1bdab8fcaddb25a1$export$2e2bcd8739ae039)(node));
}





function $ace42ab97837ee27$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $bc6a10a4b5f338b1$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $e33c76202c032506$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $034ff6d64f3c51eb$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($ace42ab97837ee27$export$2e2bcd8739ae039((0, $1bdab8fcaddb25a1$export$2e2bcd8739ae039)(target)));
}







function $d9eec3b75d308b1e$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $9b342122f068002c$export$2e2bcd8739ae039)(element)) >= 0;
}



function $f103467d733a40e5$var$getTrueOffsetParent(element) {
    if (!(0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $8e19826974e26cb7$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $f103467d733a40e5$var$getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
    var isIE = navigator.userAgent.indexOf('Trident') !== -1;
    if (isIE && (0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $8e19826974e26cb7$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $1bdab8fcaddb25a1$export$2e2bcd8739ae039)(element);
    if ((0, $5e6f83b9b79b6324$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $9b342122f068002c$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $8e19826974e26cb7$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $f103467d733a40e5$export$2e2bcd8739ae039(element) {
    var window = (0, $e33c76202c032506$export$2e2bcd8739ae039)(element);
    var offsetParent = $f103467d733a40e5$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $d9eec3b75d308b1e$export$2e2bcd8739ae039)(offsetParent) && (0, $8e19826974e26cb7$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $f103467d733a40e5$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $9b342122f068002c$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $9b342122f068002c$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $8e19826974e26cb7$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $f103467d733a40e5$var$getContainingBlock(element) || window;
}



var $138d2a96a982e905$export$1e95b668f3b82d = 'top';
var $138d2a96a982e905$export$40e543e69a8b3fbb = 'bottom';
var $138d2a96a982e905$export$79ffe56a765070d2 = 'right';
var $138d2a96a982e905$export$eabcd2c8791e7bf4 = 'left';
var $138d2a96a982e905$export$dfb5619354ba860 = 'auto';
var $138d2a96a982e905$export$aec2ce47c367b8c3 = [
    $138d2a96a982e905$export$1e95b668f3b82d,
    $138d2a96a982e905$export$40e543e69a8b3fbb,
    $138d2a96a982e905$export$79ffe56a765070d2,
    $138d2a96a982e905$export$eabcd2c8791e7bf4
];
var $138d2a96a982e905$export$b3571188c770cc5a = 'start';
var $138d2a96a982e905$export$bd5df0f255a350f8 = 'end';
var $138d2a96a982e905$export$390fd549c5303b4d = 'clippingParents';
var $138d2a96a982e905$export$d7b7311ec04a3e8f = 'viewport';
var $138d2a96a982e905$export$ae5ab1c730825774 = 'popper';
var $138d2a96a982e905$export$ca50aac9f3ba507f = 'reference';
var $138d2a96a982e905$export$368f9a87e87fa4e1 = /*#__PURE__*/ $138d2a96a982e905$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $138d2a96a982e905$export$b3571188c770cc5a,
        placement + "-" + $138d2a96a982e905$export$bd5df0f255a350f8
    ]);
}, []);
var $138d2a96a982e905$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($138d2a96a982e905$export$aec2ce47c367b8c3, [
    $138d2a96a982e905$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $138d2a96a982e905$export$b3571188c770cc5a,
        placement + "-" + $138d2a96a982e905$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $138d2a96a982e905$export$421679a7c3d56e = 'beforeRead';
var $138d2a96a982e905$export$aafa59e2e03f2942 = 'read';
var $138d2a96a982e905$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $138d2a96a982e905$export$c65e99957a05207c = 'beforeMain';
var $138d2a96a982e905$export$f22da7240b7add18 = 'main';
var $138d2a96a982e905$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $138d2a96a982e905$export$8d4d2d70e7d46032 = 'beforeWrite';
var $138d2a96a982e905$export$68d8715fc104d294 = 'write';
var $138d2a96a982e905$export$70a6e5159acce2e6 = 'afterWrite';
var $138d2a96a982e905$export$d087d3878fdf71d5 = [
    $138d2a96a982e905$export$421679a7c3d56e,
    $138d2a96a982e905$export$aafa59e2e03f2942,
    $138d2a96a982e905$export$6964f6c886723980,
    $138d2a96a982e905$export$c65e99957a05207c,
    $138d2a96a982e905$export$f22da7240b7add18,
    $138d2a96a982e905$export$bab79516f2d662fe,
    $138d2a96a982e905$export$8d4d2d70e7d46032,
    $138d2a96a982e905$export$68d8715fc104d294,
    $138d2a96a982e905$export$70a6e5159acce2e6
];


function $d46f06bd53020364$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $d46f06bd53020364$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $d46f06bd53020364$var$order(modifiers); // order based on phase
    return (0, $138d2a96a982e905$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $2533f87846704075$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}





function $1a339f2d25d68179$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}





var $a30e0d857023d451$var$INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var $a30e0d857023d451$var$INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var $a30e0d857023d451$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $a30e0d857023d451$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $a30e0d857023d451$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $a30e0d857023d451$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $a30e0d857023d451$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $5e6f83b9b79b6324$export$45a5e7f76e0caa8d)(reference) ? (0, $ace42ab97837ee27$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $ace42ab97837ee27$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $ace42ab97837ee27$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $d46f06bd53020364$export$2e2bcd8739ae039)((0, $1a339f2d25d68179$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }); // Validate the provided modifiers so that the consumer will get warned
                var modifiers, flipModifier, _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft;
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$a30e0d857023d451$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $764bab28da985192$export$2e2bcd8739ae039)(reference, (0, $f103467d733a40e5$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $2add3ba4eb5a14c0$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                var __debug_loops__ = 0;
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $2533f87846704075$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$a30e0d857023d451$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref3) {
                var name = _ref3.name, _ref3$options = _ref3.options, options = _ref3$options === void 0 ? {} : _ref3$options, effect = _ref3.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $a30e0d857023d451$export$8f7491d57c8f97a9 = /*#__PURE__*/ $a30e0d857023d451$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $64d7376378d60a66$var$passive = {
    passive: true
};
function $64d7376378d60a66$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $e33c76202c032506$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $64d7376378d60a66$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $64d7376378d60a66$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $64d7376378d60a66$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $64d7376378d60a66$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $64d7376378d60a66$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $64d7376378d60a66$var$effect,
    data: {}
};



function $4b8837b2cb23a37a$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $76a87ea7c3c26f96$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $2f7a1314b31ae0a3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $22f68c328792de32$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $4b8837b2cb23a37a$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $76a87ea7c3c26f96$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $138d2a96a982e905$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $138d2a96a982e905$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $138d2a96a982e905$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $138d2a96a982e905$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $2f7a1314b31ae0a3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $138d2a96a982e905$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $138d2a96a982e905$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $76fbebeb11c3aca2$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $22f68c328792de32$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $76fbebeb11c3aca2$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $76fbebeb11c3aca2$var$popperOffsets,
    data: {}
};










var $0db6ddb345da4024$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $0db6ddb345da4024$var$roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $88c23c8a4a5b2a6f$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $88c23c8a4a5b2a6f$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $0db6ddb345da4024$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $138d2a96a982e905$export$eabcd2c8791e7bf4);
    var sideY = (0, $138d2a96a982e905$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $f103467d733a40e5$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $e33c76202c032506$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $365d1c6041a06ca4$export$2e2bcd8739ae039)(popper);
            if ((0, $8e19826974e26cb7$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $138d2a96a982e905$export$1e95b668f3b82d) || (placement === (0, $138d2a96a982e905$export$eabcd2c8791e7bf4) || placement === (0, $138d2a96a982e905$export$79ffe56a765070d2)) && variation === (0, $138d2a96a982e905$export$bd5df0f255a350f8)) {
            sideY = (0, $138d2a96a982e905$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $138d2a96a982e905$export$eabcd2c8791e7bf4) || (placement === (0, $138d2a96a982e905$export$1e95b668f3b82d) || placement === (0, $138d2a96a982e905$export$40e543e69a8b3fbb)) && variation === (0, $138d2a96a982e905$export$bd5df0f255a350f8)) {
            sideX = (0, $138d2a96a982e905$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $0db6ddb345da4024$var$unsetSides);
    var _ref4 = roundOffsets === true ? $0db6ddb345da4024$var$roundOffsetsByDPR({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $0db6ddb345da4024$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var transitionProperty;
    var commonStyles = {
        placement: (0, $4b8837b2cb23a37a$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $76a87ea7c3c26f96$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $0db6ddb345da4024$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $0db6ddb345da4024$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0db6ddb345da4024$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $0db6ddb345da4024$var$computeStyles,
    data: {}
};





function $f4a8ebec1f197065$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $4b8837b2cb23a37a$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $138d2a96a982e905$export$eabcd2c8791e7bf4),
        (0, $138d2a96a982e905$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $138d2a96a982e905$export$eabcd2c8791e7bf4),
        (0, $138d2a96a982e905$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f4a8ebec1f197065$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $138d2a96a982e905$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $f4a8ebec1f197065$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f4a8ebec1f197065$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f4a8ebec1f197065$var$offset
};


var $7a1b46f26c68eb18$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $7a1b46f26c68eb18$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $7a1b46f26c68eb18$var$hash[matched];
    });
}



var $9b9d778575d2e591$var$hash = {
    start: 'end',
    end: 'start'
};
function $9b9d778575d2e591$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $9b9d778575d2e591$var$hash[matched];
    });
}






function $8cce986e2bfdd40e$export$2e2bcd8739ae039(element) {
    var win = (0, $e33c76202c032506$export$2e2bcd8739ae039)(element);
    var html = (0, $365d1c6041a06ca4$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
    // can be obscured underneath it.
    // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
    // if it isn't open, so if this isn't available, the popper will be detected
    // to overflow the bottom of the screen too early.
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
        // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
        // errors due to floating point numbers, so we need to check precision.
        // Safari returns a number <= 0, usually < -1 when pinch-zoomed
        // Feature detection fails in mobile emulation mode in Chrome.
        // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
        // 0.001
        // Fallback here: "Not Safari" userAgent
        if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $b582b21684353abb$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $5687f88394f5e7f2$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $365d1c6041a06ca4$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $210427f4deede664$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $88c23c8a4a5b2a6f$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $88c23c8a4a5b2a6f$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $b582b21684353abb$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $8e19826974e26cb7$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $88c23c8a4a5b2a6f$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $141b9ec14c83e2e2$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $5e6f83b9b79b6324$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $4f33f154858212f4$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $b71215d88b3f33f8$var$getInnerBoundingClientRect(element) {
    var rect = (0, $6e283a17cd63e534$export$2e2bcd8739ae039)(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $b71215d88b3f33f8$var$getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === (0, $138d2a96a982e905$export$d7b7311ec04a3e8f) ? (0, $4f33f154858212f4$export$2e2bcd8739ae039)((0, $8cce986e2bfdd40e$export$2e2bcd8739ae039)(element)) : (0, $5e6f83b9b79b6324$export$45a5e7f76e0caa8d)(clippingParent) ? $b71215d88b3f33f8$var$getInnerBoundingClientRect(clippingParent) : (0, $4f33f154858212f4$export$2e2bcd8739ae039)((0, $5687f88394f5e7f2$export$2e2bcd8739ae039)((0, $365d1c6041a06ca4$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $b71215d88b3f33f8$var$getClippingParents(element) {
    var clippingParents = (0, $ace42ab97837ee27$export$2e2bcd8739ae039)((0, $1bdab8fcaddb25a1$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $8e19826974e26cb7$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $5e6f83b9b79b6324$export$1b3bfaa9684536aa)(element) ? (0, $f103467d733a40e5$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $5e6f83b9b79b6324$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $5e6f83b9b79b6324$export$45a5e7f76e0caa8d)(clippingParent) && (0, $141b9ec14c83e2e2$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $9b342122f068002c$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $b71215d88b3f33f8$export$2e2bcd8739ae039(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === 'clippingParents' ? $b71215d88b3f33f8$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $b71215d88b3f33f8$var$getClientRectFromMixedType(element, clippingParent);
        accRect.top = (0, $88c23c8a4a5b2a6f$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $88c23c8a4a5b2a6f$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $88c23c8a4a5b2a6f$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $88c23c8a4a5b2a6f$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $b71215d88b3f33f8$var$getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $fd69e114f87eae5d$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $03dfd5d8a1865eae$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $fd69e114f87eae5d$export$2e2bcd8739ae039)(), paddingObject);
}


function $66449a25b689acb2$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $345c5e5e3be99ab5$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $138d2a96a982e905$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $138d2a96a982e905$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $138d2a96a982e905$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $03dfd5d8a1865eae$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $66449a25b689acb2$export$2e2bcd8739ae039)(padding, (0, $138d2a96a982e905$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $138d2a96a982e905$export$ae5ab1c730825774) ? (0, $138d2a96a982e905$export$ca50aac9f3ba507f) : (0, $138d2a96a982e905$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $b71215d88b3f33f8$export$2e2bcd8739ae039)((0, $5e6f83b9b79b6324$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $365d1c6041a06ca4$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = (0, $6e283a17cd63e534$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $22f68c328792de32$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $4f33f154858212f4$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $138d2a96a982e905$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $138d2a96a982e905$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $138d2a96a982e905$export$79ffe56a765070d2),
                (0, $138d2a96a982e905$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $138d2a96a982e905$export$1e95b668f3b82d),
                (0, $138d2a96a982e905$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $46ccfd847a988ecb$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $138d2a96a982e905$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $76a87ea7c3c26f96$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $138d2a96a982e905$export$368f9a87e87fa4e1) : (0, $138d2a96a982e905$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $76a87ea7c3c26f96$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $138d2a96a982e905$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $345c5e5e3be99ab5$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $4b8837b2cb23a37a$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $96d9a0fbeb450590$var$getExpandedFallbackPlacements(placement) {
    if ((0, $4b8837b2cb23a37a$export$2e2bcd8739ae039)(placement) === (0, $138d2a96a982e905$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $7a1b46f26c68eb18$export$2e2bcd8739ae039)(placement);
    return [
        (0, $9b9d778575d2e591$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $9b9d778575d2e591$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $96d9a0fbeb450590$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $4b8837b2cb23a37a$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $7a1b46f26c68eb18$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $96d9a0fbeb450590$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $4b8837b2cb23a37a$export$2e2bcd8739ae039)(placement) === (0, $138d2a96a982e905$export$dfb5619354ba860) ? (0, $46ccfd847a988ecb$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $4b8837b2cb23a37a$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $76a87ea7c3c26f96$export$2e2bcd8739ae039)(placement) === (0, $138d2a96a982e905$export$b3571188c770cc5a);
        var isVertical = [
            (0, $138d2a96a982e905$export$1e95b668f3b82d),
            (0, $138d2a96a982e905$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $345c5e5e3be99ab5$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $138d2a96a982e905$export$79ffe56a765070d2) : (0, $138d2a96a982e905$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $138d2a96a982e905$export$40e543e69a8b3fbb) : (0, $138d2a96a982e905$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $7a1b46f26c68eb18$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $7a1b46f26c68eb18$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $96d9a0fbeb450590$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $96d9a0fbeb450590$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $d54c2088324c33ff$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $30e597f1dbd371fc$export$f28d906d67a997f3(min, value, max) {
    return (0, $88c23c8a4a5b2a6f$export$8960430cfd85939f)(min, (0, $88c23c8a4a5b2a6f$export$96ec731ed4dcb222)(value, max));
}
function $30e597f1dbd371fc$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $30e597f1dbd371fc$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $d41ae2c950abbadd$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $345c5e5e3be99ab5$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $4b8837b2cb23a37a$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $76a87ea7c3c26f96$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $2f7a1314b31ae0a3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d54c2088324c33ff$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $138d2a96a982e905$export$1e95b668f3b82d) : (0, $138d2a96a982e905$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $138d2a96a982e905$export$40e543e69a8b3fbb) : (0, $138d2a96a982e905$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $138d2a96a982e905$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $138d2a96a982e905$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $2add3ba4eb5a14c0$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $fd69e114f87eae5d$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $30e597f1dbd371fc$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $f103467d733a40e5$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $30e597f1dbd371fc$export$f28d906d67a997f3)(tether ? (0, $88c23c8a4a5b2a6f$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $88c23c8a4a5b2a6f$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $138d2a96a982e905$export$1e95b668f3b82d) : (0, $138d2a96a982e905$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $138d2a96a982e905$export$40e543e69a8b3fbb) : (0, $138d2a96a982e905$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $138d2a96a982e905$export$1e95b668f3b82d),
            (0, $138d2a96a982e905$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $30e597f1dbd371fc$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $30e597f1dbd371fc$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d41ae2c950abbadd$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $d41ae2c950abbadd$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};












var $377e824ca00b9c7c$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $03dfd5d8a1865eae$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $66449a25b689acb2$export$2e2bcd8739ae039)(padding, (0, $138d2a96a982e905$export$aec2ce47c367b8c3)));
};
function $377e824ca00b9c7c$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $4b8837b2cb23a37a$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $2f7a1314b31ae0a3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $138d2a96a982e905$export$eabcd2c8791e7bf4),
        (0, $138d2a96a982e905$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $377e824ca00b9c7c$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $2add3ba4eb5a14c0$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $138d2a96a982e905$export$1e95b668f3b82d) : (0, $138d2a96a982e905$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $138d2a96a982e905$export$40e543e69a8b3fbb) : (0, $138d2a96a982e905$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $f103467d733a40e5$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $30e597f1dbd371fc$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $377e824ca00b9c7c$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $141b9ec14c83e2e2$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $377e824ca00b9c7c$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $377e824ca00b9c7c$var$arrow,
    effect: $377e824ca00b9c7c$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $18081ddc12d2273e$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $18081ddc12d2273e$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $138d2a96a982e905$export$1e95b668f3b82d),
        (0, $138d2a96a982e905$export$79ffe56a765070d2),
        (0, $138d2a96a982e905$export$40e543e69a8b3fbb),
        (0, $138d2a96a982e905$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $18081ddc12d2273e$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $345c5e5e3be99ab5$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $345c5e5e3be99ab5$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $18081ddc12d2273e$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $18081ddc12d2273e$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $18081ddc12d2273e$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $18081ddc12d2273e$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $18081ddc12d2273e$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $18081ddc12d2273e$var$hide
};




var $0e1f36e14a2c1c95$export$d34966752335dd47 = [
    (0, $64d7376378d60a66$export$2e2bcd8739ae039),
    (0, $76fbebeb11c3aca2$export$2e2bcd8739ae039),
    (0, $0db6ddb345da4024$export$2e2bcd8739ae039),
    (0, $70bf311aba1341ca$export$2e2bcd8739ae039),
    (0, $f4a8ebec1f197065$export$2e2bcd8739ae039),
    (0, $96d9a0fbeb450590$export$2e2bcd8739ae039),
    (0, $d41ae2c950abbadd$export$2e2bcd8739ae039),
    (0, $377e824ca00b9c7c$export$2e2bcd8739ae039),
    (0, $18081ddc12d2273e$export$2e2bcd8739ae039)
];
var $0e1f36e14a2c1c95$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $a30e0d857023d451$export$ed5e13716264f202)({
    defaultModifiers: $0e1f36e14a2c1c95$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $6445619a88c9e457$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $6445619a88c9e457$var$BOX_CLASS = "tippy-box";
var $6445619a88c9e457$var$CONTENT_CLASS = "tippy-content";
var $6445619a88c9e457$var$BACKDROP_CLASS = "tippy-backdrop";
var $6445619a88c9e457$var$ARROW_CLASS = "tippy-arrow";
var $6445619a88c9e457$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $6445619a88c9e457$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $6445619a88c9e457$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $6445619a88c9e457$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $6445619a88c9e457$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $6445619a88c9e457$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $6445619a88c9e457$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $6445619a88c9e457$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $6445619a88c9e457$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $6445619a88c9e457$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $6445619a88c9e457$var$normalizeToArray(value) {
    return [].concat(value);
}
function $6445619a88c9e457$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $6445619a88c9e457$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $6445619a88c9e457$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $6445619a88c9e457$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $6445619a88c9e457$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $6445619a88c9e457$var$div() {
    return document.createElement('div');
}
function $6445619a88c9e457$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $6445619a88c9e457$var$isType(value, type);
    });
}
function $6445619a88c9e457$var$isNodeList(value) {
    return $6445619a88c9e457$var$isType(value, 'NodeList');
}
function $6445619a88c9e457$var$isMouseEvent(value) {
    return $6445619a88c9e457$var$isType(value, 'MouseEvent');
}
function $6445619a88c9e457$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $6445619a88c9e457$var$getArrayOfElements(value) {
    if ($6445619a88c9e457$var$isElement(value)) return [
        value
    ];
    if ($6445619a88c9e457$var$isNodeList(value)) return $6445619a88c9e457$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $6445619a88c9e457$var$arrayFrom(document.querySelectorAll(value));
}
function $6445619a88c9e457$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $6445619a88c9e457$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $6445619a88c9e457$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $6445619a88c9e457$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $6445619a88c9e457$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $6445619a88c9e457$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $6445619a88c9e457$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $6445619a88c9e457$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $6445619a88c9e457$var$currentInput = {
    isTouch: false
};
var $6445619a88c9e457$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $6445619a88c9e457$var$onDocumentTouchStart() {
    if ($6445619a88c9e457$var$currentInput.isTouch) return;
    $6445619a88c9e457$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $6445619a88c9e457$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $6445619a88c9e457$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $6445619a88c9e457$var$lastMouseMoveTime < 20) {
        $6445619a88c9e457$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $6445619a88c9e457$var$onDocumentMouseMove);
    }
    $6445619a88c9e457$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $6445619a88c9e457$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($6445619a88c9e457$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $6445619a88c9e457$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $6445619a88c9e457$var$onDocumentTouchStart, $6445619a88c9e457$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $6445619a88c9e457$var$onWindowBlur);
}
var $6445619a88c9e457$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $6445619a88c9e457$var$isIE11 = $6445619a88c9e457$var$isBrowser ? !!window.msCrypto : false;
function $6445619a88c9e457$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $6445619a88c9e457$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $6445619a88c9e457$var$getDevMessage(message) {
    return $6445619a88c9e457$var$clean("\n  %ctippy.js\n\n  %c" + $6445619a88c9e457$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $6445619a88c9e457$var$getFormattedMessage(message) {
    return [
        $6445619a88c9e457$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $6445619a88c9e457$var$visitedMessages;
function $6445619a88c9e457$var$resetVisitedMessages() {
    $6445619a88c9e457$var$visitedMessages = new Set();
}
function $6445619a88c9e457$var$warnWhen(condition, message) {
    if (condition && !$6445619a88c9e457$var$visitedMessages.has(message)) {
        var _console;
        $6445619a88c9e457$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $6445619a88c9e457$var$getFormattedMessage(message));
    }
}
function $6445619a88c9e457$var$errorWhen(condition, message) {
    if (condition && !$6445619a88c9e457$var$visitedMessages.has(message)) {
        var _console2;
        $6445619a88c9e457$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $6445619a88c9e457$var$getFormattedMessage(message));
    }
}
function $6445619a88c9e457$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $6445619a88c9e457$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $6445619a88c9e457$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $6445619a88c9e457$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $6445619a88c9e457$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $6445619a88c9e457$var$defaultProps = Object.assign({
    appendTo: $6445619a88c9e457$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $6445619a88c9e457$var$pluginProps, $6445619a88c9e457$var$renderProps);
var $6445619a88c9e457$var$defaultKeys = Object.keys($6445619a88c9e457$var$defaultProps);
var $6445619a88c9e457$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $6445619a88c9e457$var$defaultProps[key] = partialProps[key];
    });
};
function $6445619a88c9e457$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $6445619a88c9e457$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $6445619a88c9e457$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($6445619a88c9e457$var$getExtendedPassedProps(Object.assign({}, $6445619a88c9e457$var$defaultProps, {
        plugins: plugins
    }))) : $6445619a88c9e457$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $6445619a88c9e457$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $6445619a88c9e457$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $6445619a88c9e457$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $6445619a88c9e457$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $6445619a88c9e457$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $6445619a88c9e457$var$removeProperties($6445619a88c9e457$var$defaultProps, Object.keys($6445619a88c9e457$var$pluginProps));
        var didPassUnknownProp = !$6445619a88c9e457$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $6445619a88c9e457$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $6445619a88c9e457$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $6445619a88c9e457$var$dangerouslySetInnerHTML(element, html) {
    element[$6445619a88c9e457$var$innerHTML()] = html;
}
function $6445619a88c9e457$var$createArrowElement(value) {
    var arrow = $6445619a88c9e457$var$div();
    if (value === true) arrow.className = $6445619a88c9e457$var$ARROW_CLASS;
    else {
        arrow.className = $6445619a88c9e457$var$SVG_ARROW_CLASS;
        if ($6445619a88c9e457$var$isElement(value)) arrow.appendChild(value);
        else $6445619a88c9e457$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $6445619a88c9e457$var$setContent(content, props) {
    if ($6445619a88c9e457$var$isElement(props.content)) {
        $6445619a88c9e457$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $6445619a88c9e457$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $6445619a88c9e457$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $6445619a88c9e457$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($6445619a88c9e457$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($6445619a88c9e457$var$ARROW_CLASS) || node.classList.contains($6445619a88c9e457$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($6445619a88c9e457$var$BACKDROP_CLASS);
        })
    };
}
function $6445619a88c9e457$var$render(instance) {
    var popper = $6445619a88c9e457$var$div();
    var box = $6445619a88c9e457$var$div();
    box.className = $6445619a88c9e457$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $6445619a88c9e457$var$div();
    content.className = $6445619a88c9e457$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $6445619a88c9e457$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $6445619a88c9e457$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $6445619a88c9e457$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($6445619a88c9e457$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($6445619a88c9e457$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$6445619a88c9e457$var$render.$$tippy = true;
var $6445619a88c9e457$var$idCounter = 1;
var $6445619a88c9e457$var$mouseMoveListeners = []; // Used by `hideAll()`
var $6445619a88c9e457$var$mountedInstances = [];
function $6445619a88c9e457$var$createTippy(reference, passedProps) {
    var props = $6445619a88c9e457$var$evaluateProps(reference, Object.assign({}, $6445619a88c9e457$var$defaultProps, $6445619a88c9e457$var$getExtendedPassedProps($6445619a88c9e457$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $6445619a88c9e457$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $6445619a88c9e457$var$idCounter++;
    var popperInstance = null;
    var plugins = $6445619a88c9e457$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $6445619a88c9e457$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $6445619a88c9e457$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $6445619a88c9e457$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $6445619a88c9e457$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $6445619a88c9e457$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $6445619a88c9e457$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $6445619a88c9e457$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $6445619a88c9e457$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $6445619a88c9e457$var$mouseMoveListeners = $6445619a88c9e457$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($6445619a88c9e457$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $6445619a88c9e457$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($6445619a88c9e457$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $6445619a88c9e457$var$actualContains(el, actualTarget);
        })) {
            if ($6445619a88c9e457$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $6445619a88c9e457$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $6445619a88c9e457$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $6445619a88c9e457$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $6445619a88c9e457$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $6445619a88c9e457$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $6445619a88c9e457$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $6445619a88c9e457$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $6445619a88c9e457$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $6445619a88c9e457$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $6445619a88c9e457$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $6445619a88c9e457$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($6445619a88c9e457$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $6445619a88c9e457$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $6445619a88c9e457$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($6445619a88c9e457$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $6445619a88c9e457$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $6445619a88c9e457$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $0e1f36e14a2c1c95$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $6445619a88c9e457$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $6445619a88c9e457$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $6445619a88c9e457$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($6445619a88c9e457$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $6445619a88c9e457$var$evaluateProps(reference, Object.assign({}, prevProps, $6445619a88c9e457$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $6445619a88c9e457$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $6445619a88c9e457$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $6445619a88c9e457$var$currentInput.isTouch && !instance.props.touch;
        var duration = $6445619a88c9e457$var$getValueAtIndexOrReturn(instance.props.duration, 0, $6445619a88c9e457$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $6445619a88c9e457$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $6445619a88c9e457$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $6445619a88c9e457$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $6445619a88c9e457$var$pushIfUnique($6445619a88c9e457$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $6445619a88c9e457$var$getValueAtIndexOrReturn(instance.props.duration, 1, $6445619a88c9e457$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $6445619a88c9e457$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $6445619a88c9e457$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $6445619a88c9e457$var$pushIfUnique($6445619a88c9e457$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $6445619a88c9e457$var$mountedInstances = $6445619a88c9e457$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $6445619a88c9e457$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $6445619a88c9e457$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $6445619a88c9e457$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $6445619a88c9e457$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $6445619a88c9e457$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $6445619a88c9e457$var$isElement(targets) ? instances[0] : instances;
}
$6445619a88c9e457$var$tippy.defaultProps = $6445619a88c9e457$var$defaultProps;
$6445619a88c9e457$var$tippy.setDefaultProps = $6445619a88c9e457$var$setDefaultProps;
$6445619a88c9e457$var$tippy.currentInput = $6445619a88c9e457$var$currentInput;
var $6445619a88c9e457$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $6445619a88c9e457$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $6445619a88c9e457$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $6445619a88c9e457$var$applyStylesModifier = Object.assign({}, (0, $70bf311aba1341ca$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $6445619a88c9e457$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $6445619a88c9e457$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $6445619a88c9e457$var$tippy($6445619a88c9e457$var$div(), Object.assign({}, $6445619a88c9e457$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $6445619a88c9e457$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $6445619a88c9e457$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $6445619a88c9e457$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $6445619a88c9e457$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $6445619a88c9e457$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $6445619a88c9e457$var$tippy(targets, parentProps);
    var normalizedReturnValue = $6445619a88c9e457$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $6445619a88c9e457$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($6445619a88c9e457$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $6445619a88c9e457$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $6445619a88c9e457$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $6445619a88c9e457$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $6445619a88c9e457$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $6445619a88c9e457$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $6445619a88c9e457$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $6445619a88c9e457$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $6445619a88c9e457$var$createBackdropElement() {
    var backdrop = $6445619a88c9e457$var$div();
    backdrop.className = $6445619a88c9e457$var$BACKDROP_CLASS;
    $6445619a88c9e457$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $6445619a88c9e457$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $6445619a88c9e457$var$activeInstances = [];
function $6445619a88c9e457$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $6445619a88c9e457$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $6445619a88c9e457$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $6445619a88c9e457$var$storeMouseCoords);
}
function $6445619a88c9e457$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $6445619a88c9e457$var$storeMouseCoords);
}
var $6445619a88c9e457$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $6445619a88c9e457$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $6445619a88c9e457$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $6445619a88c9e457$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $6445619a88c9e457$var$activeInstances = $6445619a88c9e457$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($6445619a88c9e457$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $6445619a88c9e457$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($6445619a88c9e457$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($6445619a88c9e457$var$isMouseEvent(event)) $6445619a88c9e457$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $6445619a88c9e457$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $6445619a88c9e457$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $6445619a88c9e457$var$getInlineBoundingClientRect($6445619a88c9e457$var$getBasePlacement(placement), reference.getBoundingClientRect(), $6445619a88c9e457$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($6445619a88c9e457$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($6445619a88c9e457$var$isMouseEvent(event)) {
                    var rects = $6445619a88c9e457$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $6445619a88c9e457$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $6445619a88c9e457$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $6445619a88c9e457$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $6445619a88c9e457$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $6445619a88c9e457$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$6445619a88c9e457$var$tippy.setDefaultProps({
    render: $6445619a88c9e457$var$render
});
var $6445619a88c9e457$export$2e2bcd8739ae039 = $6445619a88c9e457$var$tippy;


var $adb0503b084cff6f$require$tippy = $6445619a88c9e457$export$2e2bcd8739ae039;
var $215b1ea15fcc90c0$exports = {};
var $c2965853847685d5$exports = {};
/*$AMPERSAND_VERSION*/ var $a6b68015b45689de$exports = {};

var $akRxj = parcelRequire("akRxj");
/// Following code is largely pasted from Backbone.js
// Helper function to correctly set up the prototype chain, for subclasses.
// Similar to `goog.inherits`, but uses a hash of prototype properties and
// class properties to be extended.
var $a6b68015b45689de$var$extend = function(protoProps) {
    var parent = this;
    var child;
    var args = [].slice.call(arguments);
    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && protoProps.hasOwnProperty('constructor')) child = protoProps.constructor;
    else child = function() {
        return parent.apply(this, arguments);
    };
    // Add static properties to the constructor function from parent
    $akRxj(child, parent);
    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function() {
        this.constructor = child;
    };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate();
    // Mix in all prototype properties to the subclass if supplied.
    if (protoProps) {
        args.unshift(child.prototype);
        $akRxj.apply(null, args);
    }
    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;
    return child;
};
// Expose the extend function
$a6b68015b45689de$exports = $a6b68015b45689de$var$extend;



var $9jqvh = parcelRequire("9jqvh");

var $akRxj = parcelRequire("akRxj");
var $e09954f828e6eee2$exports = {};
var $9f66bb04a58acf45$exports = {};

var $39TZG = parcelRequire("39TZG");

var $lIKbn = parcelRequire("lIKbn");
/** `Object#toString` result references. */ var $9f66bb04a58acf45$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $9f66bb04a58acf45$var$baseIsRegExp(value) {
    return $lIKbn(value) && $39TZG(value) == $9f66bb04a58acf45$var$regexpTag;
}
$9f66bb04a58acf45$exports = $9f66bb04a58acf45$var$baseIsRegExp;



var $iqpCQ = parcelRequire("iqpCQ");

var $ddmWT = parcelRequire("ddmWT");
/* Node.js helper references. */ var $e09954f828e6eee2$var$nodeIsRegExp = $ddmWT && $ddmWT.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $e09954f828e6eee2$var$isRegExp = $e09954f828e6eee2$var$nodeIsRegExp ? $iqpCQ($e09954f828e6eee2$var$nodeIsRegExp) : $9f66bb04a58acf45$exports;
$e09954f828e6eee2$exports = $e09954f828e6eee2$var$isRegExp;



var $62yEr = parcelRequire("62yEr");

var $a0MTb = parcelRequire("a0MTb");
var $871cdfa96c7e9544$exports = {};

var $9jqvh = parcelRequire("9jqvh");

var $akRxj = parcelRequire("akRxj");

var $cpUjj = parcelRequire("cpUjj");
// Handles cross-browser history management, based on either
// [pushState](http://diveintohtml5.info/history.html) and real URLs, or
// [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
// and URL fragments. If the browser supports neither.
var $871cdfa96c7e9544$var$History = function() {
    this.handlers = [];
    this.checkUrl = $cpUjj(this.checkUrl, this);
    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
        this.location = window.location;
        this.history = window.history;
    }
};
// Cached regex for stripping a leading hash/slash and trailing space.
var $871cdfa96c7e9544$var$routeStripper = /^[#\/]|\s+$/g;
// Cached regex for stripping leading and trailing slashes.
var $871cdfa96c7e9544$var$rootStripper = /^\/+|\/+$/g;
// Cached regex for stripping urls of hash.
var $871cdfa96c7e9544$var$pathStripper = /#.*$/;
// Has the history handling already been started?
$871cdfa96c7e9544$var$History.started = false;
// Set up all inheritable **Backbone.History** properties and methods.
$akRxj($871cdfa96c7e9544$var$History.prototype, $9jqvh, {
    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,
    // Are we at the app root?
    atRoot: function() {
        var path = this.location.pathname.replace(/[^\/]$/, '$&/');
        return path === this.root && !this.location.search;
    },
    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window1) {
        var match = (window1 || this).location.href.match(/#(.*)$/);
        return match ? match[1] : '';
    },
    // Get the pathname and search params, without the root.
    getPath: function() {
        var path = decodeURI(this.location.pathname + this.location.search);
        var root = this.root.slice(0, -1);
        if (!path.indexOf(root)) path = path.slice(root.length);
        return path.slice(1);
    },
    // Get the cross-browser normalized URL fragment from the path or hash.
    getFragment: function(fragment) {
        if (fragment == null) {
            if (this._hasPushState || !this._wantsHashChange) fragment = this.getPath();
            else fragment = this.getHash();
        }
        return fragment.replace($871cdfa96c7e9544$var$routeStripper, '');
    },
    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
        if ($871cdfa96c7e9544$var$History.started) throw new Error("Backbone.history has already been started");
        $871cdfa96c7e9544$var$History.started = true;
        // Figure out the initial configuration.
        // Is pushState desired ... is it available?
        this.options = $akRxj({
            root: '/',
            pushState: true
        }, this.options, options);
        this.root = this.options.root;
        this._wantsHashChange = this.options.hashChange !== false;
        this._hasHashChange = 'onhashchange' in window;
        this._wantsPushState = !!this.options.pushState;
        this._hasPushState = !!(this.options.pushState && this.history && this.history.pushState);
        this.fragment = this.getFragment();
        // Add a cross-platform `addEventListener` shim for older browsers.
        var addEventListener = window.addEventListener;
        // Normalize root to always include a leading and trailing slash.
        this.root = ('/' + this.root + '/').replace($871cdfa96c7e9544$var$rootStripper, '/');
        // Depending on whether we're using pushState or hashes, and whether
        // 'onhashchange' is supported, determine how we check the URL state.
        if (this._hasPushState) addEventListener('popstate', this.checkUrl, false);
        else if (this._wantsHashChange && this._hasHashChange) addEventListener('hashchange', this.checkUrl, false);
        else if (this._wantsHashChange) this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
        // Transition from hashChange to pushState or vice versa if both are
        // requested.
        if (this._wantsHashChange && this._wantsPushState) {
            // If we've started off with a route from a `pushState`-enabled
            // browser, but we're currently in a browser that doesn't support it...
            if (!this._hasPushState && !this.atRoot()) {
                this.location.replace(this.root + '#' + this.getPath());
                // Return immediately as browser will do redirect to new url
                return true;
            // Or if we've started out with a hash-based route, but we're currently
            // in a browser where it could be `pushState`-based instead...
            } else if (this._hasPushState && this.atRoot()) this.navigate(this.getHash(), {
                replace: true
            });
        }
        if (!this.options.silent) return this.loadUrl();
    },
    // Returns the value of History.started. Allows an app or units tests to
    // check whether or not the router has been started with
    // router.history.started(); otherwise the started flag is inaccessible
    started: function() {
        return $871cdfa96c7e9544$var$History.started;
    },
    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
        // Add a cross-platform `removeEventListener` shim for older browsers.
        var removeEventListener = window.removeEventListener;
        // Remove window listeners.
        if (this._hasPushState) removeEventListener('popstate', this.checkUrl, false);
        else if (this._wantsHashChange && this._hasHashChange) removeEventListener('hashchange', this.checkUrl, false);
        // Some environments will throw when clearing an undefined interval.
        if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
        $871cdfa96c7e9544$var$History.started = false;
    },
    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
        this.handlers.unshift({
            route: route,
            callback: callback
        });
    },
    urlChanged: function() {
        var current = this.getFragment();
        if (current === this.fragment) return false;
        return true;
    },
    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`.
    checkUrl: function(e) {
        this.urlChanged() && this.loadUrl();
    },
    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
        fragment = this.fragment = this.getFragment(fragment);
        return this.handlers.some(function(handler) {
            if (handler.route.test(fragment)) {
                handler.callback(fragment);
                return true;
            }
        });
    },
    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: false` if you wish to have the
    // route callback not be fired (sometimes desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
        if (!$871cdfa96c7e9544$var$History.started) return false;
        options = $akRxj({
            trigger: true
        }, options);
        var url = this.root + (fragment = this.getFragment(fragment || ''));
        // Strip the hash and decode for matching.
        fragment = decodeURI(fragment.replace($871cdfa96c7e9544$var$pathStripper, ''));
        if (this.fragment === fragment) return;
        this.fragment = fragment;
        // Don't include a trailing slash on the root.
        if (fragment === '' && url !== '/') url = url.slice(0, -1);
        // If pushState is available, we use it to set the fragment as a real URL.
        if (this._hasPushState) this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);
        else if (this._wantsHashChange) this._updateHash(this.location, fragment, options.replace);
        else return this.location.assign(url);
        if (options.trigger) return this.loadUrl(fragment);
    },
    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
        if (replace) {
            var href = location.href.replace(/(javascript:|#).*$/, '');
            location.replace(href + '#' + fragment);
        } else // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
    }
});
$871cdfa96c7e9544$exports = new $871cdfa96c7e9544$var$History();


// Routers map faux-URLs to actions, and fire events when routes are
// matched. Creating a new one sets its `routes` hash, if not set statically.
var $c2965853847685d5$var$Router = $c2965853847685d5$exports = function(options) {
    options || (options = {});
    this.history = options.history || $871cdfa96c7e9544$exports;
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
};
// Cached regular expressions for matching named param parts and splatted
// parts of route strings.
var $c2965853847685d5$var$optionalParam = /\((.*?)\)/g;
var $c2965853847685d5$var$namedParam = /(\(\?)?:\w+/g;
var $c2965853847685d5$var$splatParam = /\*\w+/g;
var $c2965853847685d5$var$escapeRegExp = /[\-{}\[\]+?.,\\\^$|#\s]/g;
// Set up all inheritable **Backbone.Router** properties and methods.
$akRxj($c2965853847685d5$var$Router.prototype, $9jqvh, {
    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function() {},
    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function (query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
        if (!$e09954f828e6eee2$exports(route)) route = this._routeToRegExp(route);
        if ($62yEr(name)) {
            callback = name;
            name = '';
        }
        if (!callback) callback = this[name];
        var router = this;
        this.history.route(route, function(fragment) {
            var args = router._extractParameters(route, fragment);
            if (router.execute(callback, args, name) !== false) {
                router.trigger.apply(router, [
                    'route:' + name
                ].concat(args));
                router.trigger('route', name, args);
                router.history.trigger('route', router, name, args);
            }
        });
        return this;
    },
    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args, name) {
        if (callback) callback.apply(this, args);
    },
    // Simple proxy to `ampHistory` to save a fragment into the history.
    navigate: function(fragment, options) {
        this.history.navigate(fragment, options);
        return this;
    },
    // Reload the current route as if it was navigated to from somewhere
    // else
    reload: function() {
        this.history.loadUrl(this.history.fragment);
        return this;
    },
    // Helper for doing `internal` redirects without adding to history
    // and thereby breaking backbutton functionality.
    redirectTo: function(newUrl) {
        this.navigate(newUrl, {
            replace: true
        });
    },
    // Bind all defined routes to `history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
        if (!this.routes) return;
        this.routes = $a0MTb(this, 'routes');
        var route, routes = Object.keys(this.routes);
        while((route = routes.pop()) != null)this.route(route, this.routes[route]);
    },
    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
        route = route.replace($c2965853847685d5$var$escapeRegExp, '\\$&').replace($c2965853847685d5$var$optionalParam, '(?:$1)?').replace($c2965853847685d5$var$namedParam, function(match, optional) {
            return optional ? match : '([^/?]+)';
        }).replace($c2965853847685d5$var$splatParam, '([^?]*?)');
        return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },
    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
        var encodedParams = route.exec(fragment).slice(1);
        var searchParm = encodedParams.pop();
        function decodeOrNull(p) {
            return p ? decodeURIComponent(p) : null;
        }
        var params = encodedParams.map(decodeOrNull);
        searchParm && params.push(searchParm);
        return params;
    }
});
$c2965853847685d5$var$Router.extend = $a6b68015b45689de$exports;



var $4UX9c = parcelRequire("4UX9c");
var $13d2dd924a971d28$exports = {};

var $4UX9c = parcelRequire("4UX9c");
/**!
 * Sortable 1.15.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $96c85404d21524b4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $96c85404d21524b4$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $96c85404d21524b4$var$ownKeys(Object(source), true).forEach(function(key) {
            $96c85404d21524b4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $96c85404d21524b4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $96c85404d21524b4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $96c85404d21524b4$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $96c85404d21524b4$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $96c85404d21524b4$var$_typeof(obj);
}
function $96c85404d21524b4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $96c85404d21524b4$var$_extends() {
    $96c85404d21524b4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $96c85404d21524b4$var$_extends.apply(this, arguments);
}
function $96c85404d21524b4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $96c85404d21524b4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $96c85404d21524b4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $96c85404d21524b4$var$_toConsumableArray(arr) {
    return $96c85404d21524b4$var$_arrayWithoutHoles(arr) || $96c85404d21524b4$var$_iterableToArray(arr) || $96c85404d21524b4$var$_unsupportedIterableToArray(arr) || $96c85404d21524b4$var$_nonIterableSpread();
}
function $96c85404d21524b4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $96c85404d21524b4$var$_arrayLikeToArray(arr);
}
function $96c85404d21524b4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $96c85404d21524b4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $96c85404d21524b4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $96c85404d21524b4$var$_arrayLikeToArray(o, minLen);
}
function $96c85404d21524b4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $96c85404d21524b4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $96c85404d21524b4$var$version = "1.15.0";
function $96c85404d21524b4$var$userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $96c85404d21524b4$var$IE11OrLess = $96c85404d21524b4$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $96c85404d21524b4$var$Edge = $96c85404d21524b4$var$userAgent(/Edge/i);
var $96c85404d21524b4$var$FireFox = $96c85404d21524b4$var$userAgent(/firefox/i);
var $96c85404d21524b4$var$Safari = $96c85404d21524b4$var$userAgent(/safari/i) && !$96c85404d21524b4$var$userAgent(/chrome/i) && !$96c85404d21524b4$var$userAgent(/android/i);
var $96c85404d21524b4$var$IOS = $96c85404d21524b4$var$userAgent(/iP(ad|od|hone)/i);
var $96c85404d21524b4$var$ChromeForAndroid = $96c85404d21524b4$var$userAgent(/chrome/i) && $96c85404d21524b4$var$userAgent(/android/i);
var $96c85404d21524b4$var$captureMode = {
    capture: false,
    passive: false
};
function $96c85404d21524b4$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$96c85404d21524b4$var$IE11OrLess && $96c85404d21524b4$var$captureMode);
}
function $96c85404d21524b4$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$96c85404d21524b4$var$IE11OrLess && $96c85404d21524b4$var$captureMode);
}
function $96c85404d21524b4$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $96c85404d21524b4$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $96c85404d21524b4$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && $96c85404d21524b4$var$matches(el, selector) : $96c85404d21524b4$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $96c85404d21524b4$var$getParentOrHost(el));
    }
    return null;
}
var $96c85404d21524b4$var$R_SPACE = /\s+/g;
function $96c85404d21524b4$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? 'add' : 'remove'](name);
        else {
            var className = (' ' + el.className + ' ').replace($96c85404d21524b4$var$R_SPACE, ' ').replace(' ' + name + ' ', ' ');
            el.className = (className + (state ? ' ' + name : '')).replace($96c85404d21524b4$var$R_SPACE, ' ');
        }
    }
}
function $96c85404d21524b4$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, '');
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf('webkit') === -1) prop = '-webkit-' + prop;
            style[prop] = val + (typeof val === 'string' ? '' : 'px');
        }
    }
}
function $96c85404d21524b4$var$matrix(el, selfOnly) {
    var appliedTransforms = '';
    if (typeof el === 'string') appliedTransforms = el;
    else do {
        var transform = $96c85404d21524b4$var$css(el, 'transform');
        if (transform && transform !== 'none') appliedTransforms = transform + ' ' + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $96c85404d21524b4$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $96c85404d21524b4$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $96c85404d21524b4$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $96c85404d21524b4$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$96c85404d21524b4$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($96c85404d21524b4$var$css(container, 'transform') !== 'none' || relativeToNonStaticParent && $96c85404d21524b4$var$css(container, 'position') !== 'static')) {
                var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($96c85404d21524b4$var$css(container, 'border-top-width'));
                left -= containerRect.left + parseInt($96c85404d21524b4$var$css(container, 'border-left-width'));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $96c85404d21524b4$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $96c85404d21524b4$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $96c85404d21524b4$var$getParentAutoScrollElement(el, true), elSideVal = $96c85404d21524b4$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $96c85404d21524b4$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === 'top' || parentSide === 'left') visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $96c85404d21524b4$var$getWindowScrollingElement()) break;
        parent = $96c85404d21524b4$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $96c85404d21524b4$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== 'none' && children[i] !== $96c85404d21524b4$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $96c85404d21524b4$export$31b3ca70d8f57423.dragged) && $96c85404d21524b4$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $96c85404d21524b4$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $96c85404d21524b4$export$31b3ca70d8f57423.ghost || $96c85404d21524b4$var$css(last, 'display') === 'none' || selector && !$96c85404d21524b4$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $96c85404d21524b4$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== $96c85404d21524b4$export$31b3ca70d8f57423.clone && (!selector || $96c85404d21524b4$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $96c85404d21524b4$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $96c85404d21524b4$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $96c85404d21524b4$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $96c85404d21524b4$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $96c85404d21524b4$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $96c85404d21524b4$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $96c85404d21524b4$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
            if (!elem.getBoundingClientRect || elem === document.body) return $96c85404d21524b4$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $96c85404d21524b4$var$getWindowScrollingElement();
}
function $96c85404d21524b4$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $96c85404d21524b4$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $96c85404d21524b4$var$_throttleTimeout;
function $96c85404d21524b4$var$throttle(callback, ms) {
    return function() {
        if (!$96c85404d21524b4$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $96c85404d21524b4$var$_throttleTimeout = setTimeout(function() {
                $96c85404d21524b4$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $96c85404d21524b4$var$cancelThrottle() {
    clearTimeout($96c85404d21524b4$var$_throttleTimeout);
    $96c85404d21524b4$var$_throttleTimeout = void 0;
}
function $96c85404d21524b4$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $96c85404d21524b4$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $96c85404d21524b4$var$setRect(el, rect) {
    $96c85404d21524b4$var$css(el, 'position', 'absolute');
    $96c85404d21524b4$var$css(el, 'top', rect.top);
    $96c85404d21524b4$var$css(el, 'left', rect.left);
    $96c85404d21524b4$var$css(el, 'width', rect.width);
    $96c85404d21524b4$var$css(el, 'height', rect.height);
}
function $96c85404d21524b4$var$unsetRect(el) {
    $96c85404d21524b4$var$css(el, 'position', '');
    $96c85404d21524b4$var$css(el, 'top', '');
    $96c85404d21524b4$var$css(el, 'left', '');
    $96c85404d21524b4$var$css(el, 'width', '');
    $96c85404d21524b4$var$css(el, 'height', '');
}
var $96c85404d21524b4$var$expando = 'Sortable' + new Date().getTime();
function $96c85404d21524b4$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($96c85404d21524b4$var$css(child, 'display') === 'none' || child === $96c85404d21524b4$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $96c85404d21524b4$var$getRect(child)
                });
                var fromRect = $96c85404d21524b4$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $96c85404d21524b4$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($96c85404d21524b4$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === 'function') callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $96c85404d21524b4$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $96c85404d21524b4$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($96c85404d21524b4$var$isRectEqual(prevFromRect, toRect) && !$96c85404d21524b4$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $96c85404d21524b4$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                } // if fromRect != toRect: animate
                if (!$96c85404d21524b4$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === 'function') callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === 'function') callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $96c85404d21524b4$var$css(target, 'transition', '');
                $96c85404d21524b4$var$css(target, 'transform', '');
                var elMatrix = $96c85404d21524b4$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $96c85404d21524b4$var$css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                this.forRepaintDummy = $96c85404d21524b4$var$repaint(target); // repaint
                $96c85404d21524b4$var$css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                $96c85404d21524b4$var$css(target, 'transform', 'translate3d(0,0,0)');
                typeof target.animated === 'number' && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $96c85404d21524b4$var$css(target, 'transition', '');
                    $96c85404d21524b4$var$css(target, 'transform', '');
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $96c85404d21524b4$var$repaint(target) {
    return target.offsetWidth;
}
function $96c85404d21524b4$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $96c85404d21524b4$var$plugins = [];
var $96c85404d21524b4$var$defaults = {
    initializeByDefault: true
};
var $96c85404d21524b4$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $96c85404d21524b4$var$defaults)if ($96c85404d21524b4$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $96c85404d21524b4$var$defaults[option];
        $96c85404d21524b4$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $96c85404d21524b4$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + 'Global';
        $96c85404d21524b4$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($96c85404d21524b4$var$_objectSpread2({
                sortable: sortable
            }, evt));
             // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($96c85404d21524b4$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $96c85404d21524b4$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized; // Add default options from plugin
            $96c85404d21524b4$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== 'undefined') sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $96c85404d21524b4$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== 'function') return;
            $96c85404d21524b4$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $96c85404d21524b4$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $96c85404d21524b4$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$96c85404d21524b4$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature
    if (window.CustomEvent && !$96c85404d21524b4$var$IE11OrLess && !$96c85404d21524b4$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $96c85404d21524b4$var$_objectSpread2($96c85404d21524b4$var$_objectSpread2({}, extraEventProperties), $96c85404d21524b4$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $96c85404d21524b4$var$_excluded = [
    "evt"
];
var $96c85404d21524b4$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $96c85404d21524b4$var$_objectWithoutProperties(_ref, $96c85404d21524b4$var$_excluded);
    $96c85404d21524b4$var$PluginManager.pluginEvent.bind($96c85404d21524b4$export$31b3ca70d8f57423)(eventName, sortable, $96c85404d21524b4$var$_objectSpread2({
        dragEl: $96c85404d21524b4$var$dragEl,
        parentEl: $96c85404d21524b4$var$parentEl,
        ghostEl: $96c85404d21524b4$var$ghostEl,
        rootEl: $96c85404d21524b4$var$rootEl,
        nextEl: $96c85404d21524b4$var$nextEl,
        lastDownEl: $96c85404d21524b4$var$lastDownEl,
        cloneEl: $96c85404d21524b4$var$cloneEl,
        cloneHidden: $96c85404d21524b4$var$cloneHidden,
        dragStarted: $96c85404d21524b4$var$moved,
        putSortable: $96c85404d21524b4$var$putSortable,
        activeSortable: $96c85404d21524b4$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $96c85404d21524b4$var$oldIndex,
        oldDraggableIndex: $96c85404d21524b4$var$oldDraggableIndex,
        newIndex: $96c85404d21524b4$var$newIndex,
        newDraggableIndex: $96c85404d21524b4$var$newDraggableIndex,
        hideGhostForTarget: $96c85404d21524b4$var$_hideGhostForTarget,
        unhideGhostForTarget: $96c85404d21524b4$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $96c85404d21524b4$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $96c85404d21524b4$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $96c85404d21524b4$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $96c85404d21524b4$var$_dispatchEvent(info) {
    $96c85404d21524b4$var$dispatchEvent($96c85404d21524b4$var$_objectSpread2({
        putSortable: $96c85404d21524b4$var$putSortable,
        cloneEl: $96c85404d21524b4$var$cloneEl,
        targetEl: $96c85404d21524b4$var$dragEl,
        rootEl: $96c85404d21524b4$var$rootEl,
        oldIndex: $96c85404d21524b4$var$oldIndex,
        oldDraggableIndex: $96c85404d21524b4$var$oldDraggableIndex,
        newIndex: $96c85404d21524b4$var$newIndex,
        newDraggableIndex: $96c85404d21524b4$var$newDraggableIndex
    }, info));
}
var $96c85404d21524b4$var$dragEl, $96c85404d21524b4$var$parentEl, $96c85404d21524b4$var$ghostEl, $96c85404d21524b4$var$rootEl, $96c85404d21524b4$var$nextEl, $96c85404d21524b4$var$lastDownEl, $96c85404d21524b4$var$cloneEl, $96c85404d21524b4$var$cloneHidden, $96c85404d21524b4$var$oldIndex, $96c85404d21524b4$var$newIndex, $96c85404d21524b4$var$oldDraggableIndex, $96c85404d21524b4$var$newDraggableIndex, $96c85404d21524b4$var$activeGroup, $96c85404d21524b4$var$putSortable, $96c85404d21524b4$var$awaitingDragStarted = false, $96c85404d21524b4$var$ignoreNextClick = false, $96c85404d21524b4$var$sortables = [], $96c85404d21524b4$var$tapEvt, $96c85404d21524b4$var$touchEvt, $96c85404d21524b4$var$lastDx, $96c85404d21524b4$var$lastDy, $96c85404d21524b4$var$tapDistanceLeft, $96c85404d21524b4$var$tapDistanceTop, $96c85404d21524b4$var$moved, $96c85404d21524b4$var$lastTarget, $96c85404d21524b4$var$lastDirection, $96c85404d21524b4$var$pastFirstInvertThresh = false, $96c85404d21524b4$var$isCircumstantialInvert = false, $96c85404d21524b4$var$targetMoveDistance, // For positioning ghost absolutely
$96c85404d21524b4$var$ghostRelativeParent, $96c85404d21524b4$var$ghostRelativeParentInitialScroll = [], // (left, top)
$96c85404d21524b4$var$_silent = false, $96c85404d21524b4$var$savedInputChecked = [];
/** @const */ var $96c85404d21524b4$var$documentExists = typeof document !== 'undefined', $96c85404d21524b4$var$PositionGhostAbsolutely = $96c85404d21524b4$var$IOS, $96c85404d21524b4$var$CSSFloatProperty = $96c85404d21524b4$var$Edge || $96c85404d21524b4$var$IE11OrLess ? 'cssFloat' : 'float', // This will not pass for IE9, because IE9 DnD only works on anchors
$96c85404d21524b4$var$supportDraggable = $96c85404d21524b4$var$documentExists && !$96c85404d21524b4$var$ChromeForAndroid && !$96c85404d21524b4$var$IOS && 'draggable' in document.createElement('div'), $96c85404d21524b4$var$supportCssPointerEvents = function() {
    if (!$96c85404d21524b4$var$documentExists) return; // false when <= IE11
    if ($96c85404d21524b4$var$IE11OrLess) return false;
    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
}(), $96c85404d21524b4$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $96c85404d21524b4$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $96c85404d21524b4$var$getChild(el, 0, options), child2 = $96c85404d21524b4$var$getChild(el, 1, options), firstChildCSS = child1 && $96c85404d21524b4$var$css(child1), secondChildCSS = child2 && $96c85404d21524b4$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $96c85404d21524b4$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $96c85404d21524b4$var$getRect(child2).width;
    if (elCSS.display === 'flex') return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    if (elCSS.display === 'grid') return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
        var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
        return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }
    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[$96c85404d21524b4$var$CSSFloatProperty] === 'none' || child2 && elCSS[$96c85404d21524b4$var$CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
}, $96c85404d21524b4$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */ $96c85404d21524b4$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $96c85404d21524b4$var$sortables.some(function(sortable) {
        var threshold = sortable[$96c85404d21524b4$var$expando].options.emptyInsertThreshold;
        if (!threshold || $96c85404d21524b4$var$lastChild(sortable)) return;
        var rect = $96c85404d21524b4$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $96c85404d21524b4$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === 'clone') return value;
            else if (typeof value === 'function') return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $96c85404d21524b4$var$_typeof(originalGroup) != 'object') originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $96c85404d21524b4$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$96c85404d21524b4$var$supportCssPointerEvents && $96c85404d21524b4$var$ghostEl) $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'display', 'none');
}, $96c85404d21524b4$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$96c85404d21524b4$var$supportCssPointerEvents && $96c85404d21524b4$var$ghostEl) $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'display', '');
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($96c85404d21524b4$var$documentExists && !$96c85404d21524b4$var$ChromeForAndroid) document.addEventListener('click', function(evt) {
    if ($96c85404d21524b4$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $96c85404d21524b4$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $96c85404d21524b4$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($96c85404d21524b4$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $96c85404d21524b4$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$96c85404d21524b4$var$expando]._onDragOver(event);
        }
    }
};
var $96c85404d21524b4$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($96c85404d21524b4$var$dragEl) $96c85404d21524b4$var$dragEl.parentNode[$96c85404d21524b4$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $96c85404d21524b4$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $96c85404d21524b4$var$_extends({}, options); // Export instance
    el[$96c85404d21524b4$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $96c85404d21524b4$var$_detectDirection(el, this.options);
        },
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        ignore: 'a, img',
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData('Text', dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: 'data-id',
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: 'sortable-fallback',
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $96c85404d21524b4$export$31b3ca70d8f57423.supportPointer !== false && 'PointerEvent' in window && !$96c85404d21524b4$var$Safari,
        emptyInsertThreshold: 5
    };
    $96c85404d21524b4$var$PluginManager.initializePlugins(this, el, defaults); // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $96c85404d21524b4$var$_prepareGroup(options); // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
     // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $96c85404d21524b4$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
     // Bind events
    if (options.supportPointer) $96c85404d21524b4$var$on(el, 'pointerdown', this._onTapStart);
    else {
        $96c85404d21524b4$var$on(el, 'mousedown', this._onTapStart);
        $96c85404d21524b4$var$on(el, 'touchstart', this._onTapStart);
    }
    if (this.nativeDraggable) {
        $96c85404d21524b4$var$on(el, 'dragover', this);
        $96c85404d21524b4$var$on(el, 'dragenter', this);
    }
    $96c85404d21524b4$var$sortables.push(this.el); // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager
    $96c85404d21524b4$var$_extends(this, $96c85404d21524b4$var$AnimationStateManager());
}
$96c85404d21524b4$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $96c85404d21524b4$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $96c85404d21524b4$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, $96c85404d21524b4$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $96c85404d21524b4$var$_saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($96c85404d21524b4$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
         // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
         // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $96c85404d21524b4$var$Safari && target && target.tagName.toUpperCase() === 'SELECT') return;
        target = $96c85404d21524b4$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($96c85404d21524b4$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
         // Get the index of the dragged element within its parent
        $96c85404d21524b4$var$oldIndex = $96c85404d21524b4$var$index(target);
        $96c85404d21524b4$var$oldDraggableIndex = $96c85404d21524b4$var$index(target, options.draggable); // Check filter
        if (typeof filter === 'function') {
            if (filter.call(this, evt, target, this)) {
                $96c85404d21524b4$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: 'filter',
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $96c85404d21524b4$var$pluginEvent('filter', _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(',').some(function(criteria) {
                criteria = $96c85404d21524b4$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $96c85404d21524b4$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: 'filter',
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $96c85404d21524b4$var$pluginEvent('filter', _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$96c85404d21524b4$var$closest(originalTarget, options.handle, el, false)) return;
         // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$96c85404d21524b4$var$dragEl && target.parentNode === el) {
            var dragRect = $96c85404d21524b4$var$getRect(target);
            $96c85404d21524b4$var$rootEl = el;
            $96c85404d21524b4$var$dragEl = target;
            $96c85404d21524b4$var$parentEl = $96c85404d21524b4$var$dragEl.parentNode;
            $96c85404d21524b4$var$nextEl = $96c85404d21524b4$var$dragEl.nextSibling;
            $96c85404d21524b4$var$lastDownEl = target;
            $96c85404d21524b4$var$activeGroup = options.group;
            $96c85404d21524b4$export$31b3ca70d8f57423.dragged = $96c85404d21524b4$var$dragEl;
            $96c85404d21524b4$var$tapEvt = {
                target: $96c85404d21524b4$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $96c85404d21524b4$var$tapDistanceLeft = $96c85404d21524b4$var$tapEvt.clientX - dragRect.left;
            $96c85404d21524b4$var$tapDistanceTop = $96c85404d21524b4$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $96c85404d21524b4$var$dragEl.style['will-change'] = 'all';
            dragStartFn = function dragStartFn() {
                $96c85404d21524b4$var$pluginEvent('delayEnded', _this, {
                    evt: evt
                });
                if ($96c85404d21524b4$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                } // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$96c85404d21524b4$var$FireFox && _this.nativeDraggable) $96c85404d21524b4$var$dragEl.draggable = true;
                 // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch); // Drag start event
                $96c85404d21524b4$var$_dispatchEvent({
                    sortable: _this,
                    name: 'choose',
                    originalEvent: evt
                }); // Chosen item
                $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$dragEl, options.chosenClass, true);
            }; // Disable "draggable"
            options.ignore.split(',').forEach(function(criteria) {
                $96c85404d21524b4$var$find($96c85404d21524b4$var$dragEl, criteria.trim(), $96c85404d21524b4$var$_disableDraggable);
            });
            $96c85404d21524b4$var$on(ownerDocument, 'dragover', $96c85404d21524b4$var$nearestEmptyInsertDetectEvent);
            $96c85404d21524b4$var$on(ownerDocument, 'mousemove', $96c85404d21524b4$var$nearestEmptyInsertDetectEvent);
            $96c85404d21524b4$var$on(ownerDocument, 'touchmove', $96c85404d21524b4$var$nearestEmptyInsertDetectEvent);
            $96c85404d21524b4$var$on(ownerDocument, 'mouseup', _this._onDrop);
            $96c85404d21524b4$var$on(ownerDocument, 'touchend', _this._onDrop);
            $96c85404d21524b4$var$on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)
            if ($96c85404d21524b4$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $96c85404d21524b4$var$dragEl.draggable = true;
            }
            $96c85404d21524b4$var$pluginEvent('delayStart', this, {
                evt: evt
            }); // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($96c85404d21524b4$var$Edge || $96c85404d21524b4$var$IE11OrLess))) {
                if ($96c85404d21524b4$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                } // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $96c85404d21524b4$var$on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                $96c85404d21524b4$var$on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                $96c85404d21524b4$var$on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                $96c85404d21524b4$var$on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                $96c85404d21524b4$var$on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                options.supportPointer && $96c85404d21524b4$var$on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $96c85404d21524b4$var$dragEl && $96c85404d21524b4$var$_disableDraggable($96c85404d21524b4$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $96c85404d21524b4$var$off(ownerDocument, 'mouseup', this._disableDelayedDrag);
        $96c85404d21524b4$var$off(ownerDocument, 'touchend', this._disableDelayedDrag);
        $96c85404d21524b4$var$off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
        $96c85404d21524b4$var$off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
        $96c85404d21524b4$var$off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
        $96c85404d21524b4$var$off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == 'touch' && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $96c85404d21524b4$var$on(document, 'pointermove', this._onTouchMove);
            else if (touch) $96c85404d21524b4$var$on(document, 'touchmove', this._onTouchMove);
            else $96c85404d21524b4$var$on(document, 'mousemove', this._onTouchMove);
        } else {
            $96c85404d21524b4$var$on($96c85404d21524b4$var$dragEl, 'dragend', this);
            $96c85404d21524b4$var$on($96c85404d21524b4$var$rootEl, 'dragstart', this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $96c85404d21524b4$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $96c85404d21524b4$var$awaitingDragStarted = false;
        if ($96c85404d21524b4$var$rootEl && $96c85404d21524b4$var$dragEl) {
            $96c85404d21524b4$var$pluginEvent('dragStarted', this, {
                evt: evt
            });
            if (this.nativeDraggable) $96c85404d21524b4$var$on(document, 'dragover', $96c85404d21524b4$var$_checkOutsideTargetEl);
            var options = this.options; // Apply effect
            !fallback && $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$dragEl, options.dragClass, false);
            $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$dragEl, options.ghostClass, true);
            $96c85404d21524b4$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost(); // Drag start event
            $96c85404d21524b4$var$_dispatchEvent({
                sortable: this,
                name: 'start',
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($96c85404d21524b4$var$touchEvt) {
            this._lastX = $96c85404d21524b4$var$touchEvt.clientX;
            this._lastY = $96c85404d21524b4$var$touchEvt.clientY;
            $96c85404d21524b4$var$_hideGhostForTarget();
            var target = document.elementFromPoint($96c85404d21524b4$var$touchEvt.clientX, $96c85404d21524b4$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($96c85404d21524b4$var$touchEvt.clientX, $96c85404d21524b4$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $96c85404d21524b4$var$dragEl.parentNode[$96c85404d21524b4$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$96c85404d21524b4$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$96c85404d21524b4$var$expando]._onDragOver({
                        clientX: $96c85404d21524b4$var$touchEvt.clientX,
                        clientY: $96c85404d21524b4$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $96c85404d21524b4$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($96c85404d21524b4$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $96c85404d21524b4$var$ghostEl && $96c85404d21524b4$var$matrix($96c85404d21524b4$var$ghostEl, true), scaleX = $96c85404d21524b4$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $96c85404d21524b4$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $96c85404d21524b4$var$PositionGhostAbsolutely && $96c85404d21524b4$var$ghostRelativeParent && $96c85404d21524b4$var$getRelativeScrollOffset($96c85404d21524b4$var$ghostRelativeParent), dx = (touch.clientX - $96c85404d21524b4$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $96c85404d21524b4$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $96c85404d21524b4$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $96c85404d21524b4$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging
            if (!$96c85404d21524b4$export$31b3ca70d8f57423.active && !$96c85404d21524b4$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($96c85404d21524b4$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($96c85404d21524b4$var$lastDx || 0);
                    ghostMatrix.f += dy - ($96c85404d21524b4$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'webkitTransform', cssMatrix);
                $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'mozTransform', cssMatrix);
                $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'msTransform', cssMatrix);
                $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'transform', cssMatrix);
                $96c85404d21524b4$var$lastDx = dx;
                $96c85404d21524b4$var$lastDy = dy;
                $96c85404d21524b4$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$96c85404d21524b4$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $96c85404d21524b4$var$rootEl, rect = $96c85404d21524b4$var$getRect($96c85404d21524b4$var$dragEl, true, $96c85404d21524b4$var$PositionGhostAbsolutely, true, container), options = this.options; // Position absolutely
            if ($96c85404d21524b4$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $96c85404d21524b4$var$ghostRelativeParent = container;
                while($96c85404d21524b4$var$css($96c85404d21524b4$var$ghostRelativeParent, 'position') === 'static' && $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostRelativeParent, 'transform') === 'none' && $96c85404d21524b4$var$ghostRelativeParent !== document)$96c85404d21524b4$var$ghostRelativeParent = $96c85404d21524b4$var$ghostRelativeParent.parentNode;
                if ($96c85404d21524b4$var$ghostRelativeParent !== document.body && $96c85404d21524b4$var$ghostRelativeParent !== document.documentElement) {
                    if ($96c85404d21524b4$var$ghostRelativeParent === document) $96c85404d21524b4$var$ghostRelativeParent = $96c85404d21524b4$var$getWindowScrollingElement();
                    rect.top += $96c85404d21524b4$var$ghostRelativeParent.scrollTop;
                    rect.left += $96c85404d21524b4$var$ghostRelativeParent.scrollLeft;
                } else $96c85404d21524b4$var$ghostRelativeParent = $96c85404d21524b4$var$getWindowScrollingElement();
                $96c85404d21524b4$var$ghostRelativeParentInitialScroll = $96c85404d21524b4$var$getRelativeScrollOffset($96c85404d21524b4$var$ghostRelativeParent);
            }
            $96c85404d21524b4$var$ghostEl = $96c85404d21524b4$var$dragEl.cloneNode(true);
            $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$ghostEl, options.ghostClass, false);
            $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$ghostEl, options.fallbackClass, true);
            $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$ghostEl, options.dragClass, true);
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'transition', '');
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'transform', '');
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'box-sizing', 'border-box');
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'margin', 0);
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'top', rect.top);
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'left', rect.left);
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'width', rect.width);
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'height', rect.height);
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'opacity', '0.8');
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'position', $96c85404d21524b4$var$PositionGhostAbsolutely ? 'absolute' : 'fixed');
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'zIndex', '100000');
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'pointerEvents', 'none');
            $96c85404d21524b4$export$31b3ca70d8f57423.ghost = $96c85404d21524b4$var$ghostEl;
            container.appendChild($96c85404d21524b4$var$ghostEl); // Set transform-origin
            $96c85404d21524b4$var$css($96c85404d21524b4$var$ghostEl, 'transform-origin', $96c85404d21524b4$var$tapDistanceLeft / parseInt($96c85404d21524b4$var$ghostEl.style.width) * 100 + '% ' + $96c85404d21524b4$var$tapDistanceTop / parseInt($96c85404d21524b4$var$ghostEl.style.height) * 100 + '%');
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $96c85404d21524b4$var$pluginEvent('dragStart', this, {
            evt: evt
        });
        if ($96c85404d21524b4$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $96c85404d21524b4$var$pluginEvent('setupClone', this);
        if (!$96c85404d21524b4$export$31b3ca70d8f57423.eventCanceled) {
            $96c85404d21524b4$var$cloneEl = $96c85404d21524b4$var$clone($96c85404d21524b4$var$dragEl);
            $96c85404d21524b4$var$cloneEl.removeAttribute("id");
            $96c85404d21524b4$var$cloneEl.draggable = false;
            $96c85404d21524b4$var$cloneEl.style['will-change'] = '';
            this._hideClone();
            $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$cloneEl, this.options.chosenClass, false);
            $96c85404d21524b4$export$31b3ca70d8f57423.clone = $96c85404d21524b4$var$cloneEl;
        } // #1143: IFrame support workaround
        _this.cloneId = $96c85404d21524b4$var$_nextTick(function() {
            $96c85404d21524b4$var$pluginEvent('clone', _this);
            if ($96c85404d21524b4$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $96c85404d21524b4$var$rootEl.insertBefore($96c85404d21524b4$var$cloneEl, $96c85404d21524b4$var$dragEl);
            _this._hideClone();
            $96c85404d21524b4$var$_dispatchEvent({
                sortable: _this,
                name: 'clone'
            });
        });
        !fallback && $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$dragEl, options.dragClass, true); // Set proper drop events
        if (fallback) {
            $96c85404d21524b4$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $96c85404d21524b4$var$off(document, 'mouseup', _this._onDrop);
            $96c85404d21524b4$var$off(document, 'touchend', _this._onDrop);
            $96c85404d21524b4$var$off(document, 'touchcancel', _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = 'move';
                options.setData && options.setData.call(_this, dataTransfer, $96c85404d21524b4$var$dragEl);
            }
            $96c85404d21524b4$var$on(document, 'drop', _this); // #1276 fix:
            $96c85404d21524b4$var$css($96c85404d21524b4$var$dragEl, 'transform', 'translateZ(0)');
        }
        $96c85404d21524b4$var$awaitingDragStarted = true;
        _this._dragStartId = $96c85404d21524b4$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $96c85404d21524b4$var$on(document, 'selectstart', _this);
        $96c85404d21524b4$var$moved = true;
        if ($96c85404d21524b4$var$Safari) $96c85404d21524b4$var$css(document.body, 'user-select', 'none');
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $96c85404d21524b4$export$31b3ca70d8f57423.active, isOwner = $96c85404d21524b4$var$activeGroup === group, canSort = options.sort, fromSortable = $96c85404d21524b4$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($96c85404d21524b4$var$_silent) return;
        function dragOverEvent(name, extra) {
            $96c85404d21524b4$var$pluginEvent(name, _this, $96c85404d21524b4$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? 'vertical' : 'horizontal',
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $96c85404d21524b4$var$_onMove($96c85404d21524b4$var$rootEl, el, $96c85404d21524b4$var$dragEl, dragRect, target, $96c85404d21524b4$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        } // Capture animation state
        function capture() {
            dragOverEvent('dragOverAnimationCapture');
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        } // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent('dragOverCompleted', {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$dragEl, $96c85404d21524b4$var$putSortable ? $96c85404d21524b4$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$dragEl, options.ghostClass, true);
                }
                if ($96c85404d21524b4$var$putSortable !== _this && _this !== $96c85404d21524b4$export$31b3ca70d8f57423.active) $96c85404d21524b4$var$putSortable = _this;
                else if (_this === $96c85404d21524b4$export$31b3ca70d8f57423.active && $96c85404d21524b4$var$putSortable) $96c85404d21524b4$var$putSortable = null;
                 // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent('dragOverAnimationComplete');
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            } // Null lastTarget if it is not inside a previously swapped element
            if (target === $96c85404d21524b4$var$dragEl && !$96c85404d21524b4$var$dragEl.animated || target === el && !target.animated) $96c85404d21524b4$var$lastTarget = null;
             // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $96c85404d21524b4$var$dragEl.parentNode[$96c85404d21524b4$var$expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted
                !insertion && $96c85404d21524b4$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        } // Call when dragEl has been inserted
        function changed() {
            $96c85404d21524b4$var$newIndex = $96c85404d21524b4$var$index($96c85404d21524b4$var$dragEl);
            $96c85404d21524b4$var$newDraggableIndex = $96c85404d21524b4$var$index($96c85404d21524b4$var$dragEl, options.draggable);
            $96c85404d21524b4$var$_dispatchEvent({
                sortable: _this,
                name: 'change',
                toEl: el,
                newIndex: $96c85404d21524b4$var$newIndex,
                newDraggableIndex: $96c85404d21524b4$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $96c85404d21524b4$var$closest(target, options.draggable, el, true);
        dragOverEvent('dragOver');
        if ($96c85404d21524b4$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($96c85404d21524b4$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $96c85404d21524b4$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $96c85404d21524b4$var$parentEl !== $96c85404d21524b4$var$rootEl // Reverting item into the original list
        ) : $96c85404d21524b4$var$putSortable === this || (this.lastPutMode = $96c85404d21524b4$var$activeGroup.checkPull(this, activeSortable, $96c85404d21524b4$var$dragEl, evt)) && group.checkPut(this, activeSortable, $96c85404d21524b4$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === 'vertical';
            dragRect = $96c85404d21524b4$var$getRect($96c85404d21524b4$var$dragEl);
            dragOverEvent('dragOverValid');
            if ($96c85404d21524b4$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $96c85404d21524b4$var$parentEl = $96c85404d21524b4$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent('revert');
                if (!$96c85404d21524b4$export$31b3ca70d8f57423.eventCanceled) {
                    if ($96c85404d21524b4$var$nextEl) $96c85404d21524b4$var$rootEl.insertBefore($96c85404d21524b4$var$dragEl, $96c85404d21524b4$var$nextEl);
                    else $96c85404d21524b4$var$rootEl.appendChild($96c85404d21524b4$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $96c85404d21524b4$var$lastChild(el, options.draggable);
            if (!elLastChild || $96c85404d21524b4$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $96c85404d21524b4$var$dragEl) return completed(false);
                 // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $96c85404d21524b4$var$getRect(target);
                if ($96c85404d21524b4$var$_onMove($96c85404d21524b4$var$rootEl, el, $96c85404d21524b4$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($96c85404d21524b4$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($96c85404d21524b4$var$dragEl);
                    $96c85404d21524b4$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $96c85404d21524b4$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $96c85404d21524b4$var$getChild(el, 0, options, true);
                if (firstChild === $96c85404d21524b4$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $96c85404d21524b4$var$getRect(target);
                if ($96c85404d21524b4$var$_onMove($96c85404d21524b4$var$rootEl, el, $96c85404d21524b4$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($96c85404d21524b4$var$dragEl, firstChild);
                    $96c85404d21524b4$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $96c85404d21524b4$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $96c85404d21524b4$var$dragEl.parentNode !== el, differentRowCol = !$96c85404d21524b4$var$_dragElInRowColumn($96c85404d21524b4$var$dragEl.animated && $96c85404d21524b4$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? 'top' : 'left', scrolledPastTop = $96c85404d21524b4$var$isScrolledPast(target, 'top', 'top') || $96c85404d21524b4$var$isScrolledPast($96c85404d21524b4$var$dragEl, 'top', 'top'), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($96c85404d21524b4$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $96c85404d21524b4$var$pastFirstInvertThresh = false;
                    $96c85404d21524b4$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $96c85404d21524b4$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $96c85404d21524b4$var$isCircumstantialInvert, $96c85404d21524b4$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $96c85404d21524b4$var$index($96c85404d21524b4$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $96c85404d21524b4$var$parentEl.children[dragIndex];
                    }while (sibling && ($96c85404d21524b4$var$css(sibling, 'display') === 'none' || sibling === $96c85404d21524b4$var$ghostEl));
                } // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $96c85404d21524b4$var$lastTarget = target;
                $96c85404d21524b4$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $96c85404d21524b4$var$_onMove($96c85404d21524b4$var$rootEl, el, $96c85404d21524b4$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $96c85404d21524b4$var$_silent = true;
                    setTimeout($96c85404d21524b4$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($96c85404d21524b4$var$dragEl);
                    else target.parentNode.insertBefore($96c85404d21524b4$var$dragEl, after ? nextSibling : target);
                     // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $96c85404d21524b4$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $96c85404d21524b4$var$parentEl = $96c85404d21524b4$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$96c85404d21524b4$var$isCircumstantialInvert) $96c85404d21524b4$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $96c85404d21524b4$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($96c85404d21524b4$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $96c85404d21524b4$var$off(document, 'mousemove', this._onTouchMove);
        $96c85404d21524b4$var$off(document, 'touchmove', this._onTouchMove);
        $96c85404d21524b4$var$off(document, 'pointermove', this._onTouchMove);
        $96c85404d21524b4$var$off(document, 'dragover', $96c85404d21524b4$var$nearestEmptyInsertDetectEvent);
        $96c85404d21524b4$var$off(document, 'mousemove', $96c85404d21524b4$var$nearestEmptyInsertDetectEvent);
        $96c85404d21524b4$var$off(document, 'touchmove', $96c85404d21524b4$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $96c85404d21524b4$var$off(ownerDocument, 'mouseup', this._onDrop);
        $96c85404d21524b4$var$off(ownerDocument, 'touchend', this._onDrop);
        $96c85404d21524b4$var$off(ownerDocument, 'pointerup', this._onDrop);
        $96c85404d21524b4$var$off(ownerDocument, 'touchcancel', this._onDrop);
        $96c85404d21524b4$var$off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options; // Get the index of the dragged element within its parent
        $96c85404d21524b4$var$newIndex = $96c85404d21524b4$var$index($96c85404d21524b4$var$dragEl);
        $96c85404d21524b4$var$newDraggableIndex = $96c85404d21524b4$var$index($96c85404d21524b4$var$dragEl, options.draggable);
        $96c85404d21524b4$var$pluginEvent('drop', this, {
            evt: evt
        });
        $96c85404d21524b4$var$parentEl = $96c85404d21524b4$var$dragEl && $96c85404d21524b4$var$dragEl.parentNode; // Get again after plugin event
        $96c85404d21524b4$var$newIndex = $96c85404d21524b4$var$index($96c85404d21524b4$var$dragEl);
        $96c85404d21524b4$var$newDraggableIndex = $96c85404d21524b4$var$index($96c85404d21524b4$var$dragEl, options.draggable);
        if ($96c85404d21524b4$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $96c85404d21524b4$var$awaitingDragStarted = false;
        $96c85404d21524b4$var$isCircumstantialInvert = false;
        $96c85404d21524b4$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $96c85404d21524b4$var$_cancelNextTick(this.cloneId);
        $96c85404d21524b4$var$_cancelNextTick(this._dragStartId); // Unbind events
        if (this.nativeDraggable) {
            $96c85404d21524b4$var$off(document, 'drop', this);
            $96c85404d21524b4$var$off(el, 'dragstart', this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($96c85404d21524b4$var$Safari) $96c85404d21524b4$var$css(document.body, 'user-select', '');
        $96c85404d21524b4$var$css($96c85404d21524b4$var$dragEl, 'transform', '');
        if (evt) {
            if ($96c85404d21524b4$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $96c85404d21524b4$var$ghostEl && $96c85404d21524b4$var$ghostEl.parentNode && $96c85404d21524b4$var$ghostEl.parentNode.removeChild($96c85404d21524b4$var$ghostEl);
            if ($96c85404d21524b4$var$rootEl === $96c85404d21524b4$var$parentEl || $96c85404d21524b4$var$putSortable && $96c85404d21524b4$var$putSortable.lastPutMode !== 'clone') // Remove clone(s)
            $96c85404d21524b4$var$cloneEl && $96c85404d21524b4$var$cloneEl.parentNode && $96c85404d21524b4$var$cloneEl.parentNode.removeChild($96c85404d21524b4$var$cloneEl);
            if ($96c85404d21524b4$var$dragEl) {
                if (this.nativeDraggable) $96c85404d21524b4$var$off($96c85404d21524b4$var$dragEl, 'dragend', this);
                $96c85404d21524b4$var$_disableDraggable($96c85404d21524b4$var$dragEl);
                $96c85404d21524b4$var$dragEl.style['will-change'] = ''; // Remove classes
                // ghostClass is added in dragStarted
                if ($96c85404d21524b4$var$moved && !$96c85404d21524b4$var$awaitingDragStarted) $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$dragEl, $96c85404d21524b4$var$putSortable ? $96c85404d21524b4$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$dragEl, this.options.chosenClass, false); // Drag stop event
                $96c85404d21524b4$var$_dispatchEvent({
                    sortable: this,
                    name: 'unchoose',
                    toEl: $96c85404d21524b4$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($96c85404d21524b4$var$rootEl !== $96c85404d21524b4$var$parentEl) {
                    if ($96c85404d21524b4$var$newIndex >= 0) {
                        // Add event
                        $96c85404d21524b4$var$_dispatchEvent({
                            rootEl: $96c85404d21524b4$var$parentEl,
                            name: 'add',
                            toEl: $96c85404d21524b4$var$parentEl,
                            fromEl: $96c85404d21524b4$var$rootEl,
                            originalEvent: evt
                        }); // Remove event
                        $96c85404d21524b4$var$_dispatchEvent({
                            sortable: this,
                            name: 'remove',
                            toEl: $96c85404d21524b4$var$parentEl,
                            originalEvent: evt
                        }); // drag from one list and drop into another
                        $96c85404d21524b4$var$_dispatchEvent({
                            rootEl: $96c85404d21524b4$var$parentEl,
                            name: 'sort',
                            toEl: $96c85404d21524b4$var$parentEl,
                            fromEl: $96c85404d21524b4$var$rootEl,
                            originalEvent: evt
                        });
                        $96c85404d21524b4$var$_dispatchEvent({
                            sortable: this,
                            name: 'sort',
                            toEl: $96c85404d21524b4$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $96c85404d21524b4$var$putSortable && $96c85404d21524b4$var$putSortable.save();
                } else {
                    if ($96c85404d21524b4$var$newIndex !== $96c85404d21524b4$var$oldIndex) {
                        if ($96c85404d21524b4$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $96c85404d21524b4$var$_dispatchEvent({
                                sortable: this,
                                name: 'update',
                                toEl: $96c85404d21524b4$var$parentEl,
                                originalEvent: evt
                            });
                            $96c85404d21524b4$var$_dispatchEvent({
                                sortable: this,
                                name: 'sort',
                                toEl: $96c85404d21524b4$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($96c85404d21524b4$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($96c85404d21524b4$var$newIndex == null || $96c85404d21524b4$var$newIndex === -1) {
                        $96c85404d21524b4$var$newIndex = $96c85404d21524b4$var$oldIndex;
                        $96c85404d21524b4$var$newDraggableIndex = $96c85404d21524b4$var$oldDraggableIndex;
                    }
                    $96c85404d21524b4$var$_dispatchEvent({
                        sortable: this,
                        name: 'end',
                        toEl: $96c85404d21524b4$var$parentEl,
                        originalEvent: evt
                    }); // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $96c85404d21524b4$var$pluginEvent('nulling', this);
        $96c85404d21524b4$var$rootEl = $96c85404d21524b4$var$dragEl = $96c85404d21524b4$var$parentEl = $96c85404d21524b4$var$ghostEl = $96c85404d21524b4$var$nextEl = $96c85404d21524b4$var$cloneEl = $96c85404d21524b4$var$lastDownEl = $96c85404d21524b4$var$cloneHidden = $96c85404d21524b4$var$tapEvt = $96c85404d21524b4$var$touchEvt = $96c85404d21524b4$var$moved = $96c85404d21524b4$var$newIndex = $96c85404d21524b4$var$newDraggableIndex = $96c85404d21524b4$var$oldIndex = $96c85404d21524b4$var$oldDraggableIndex = $96c85404d21524b4$var$lastTarget = $96c85404d21524b4$var$lastDirection = $96c85404d21524b4$var$putSortable = $96c85404d21524b4$var$activeGroup = $96c85404d21524b4$export$31b3ca70d8f57423.dragged = $96c85404d21524b4$export$31b3ca70d8f57423.ghost = $96c85404d21524b4$export$31b3ca70d8f57423.clone = $96c85404d21524b4$export$31b3ca70d8f57423.active = null;
        $96c85404d21524b4$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $96c85404d21524b4$var$savedInputChecked.length = $96c85404d21524b4$var$lastDx = $96c85404d21524b4$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case 'drop':
            case 'dragend':
                this._onDrop(evt);
                break;
            case 'dragenter':
            case 'dragover':
                if ($96c85404d21524b4$var$dragEl) {
                    this._onDragOver(evt);
                    $96c85404d21524b4$var$_globalDragOver(evt);
                }
                break;
            case 'selectstart':
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($96c85404d21524b4$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $96c85404d21524b4$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($96c85404d21524b4$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $96c85404d21524b4$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $96c85404d21524b4$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== 'undefined') options[name] = modifiedValue;
            else options[name] = value;
            if (name === 'group') $96c85404d21524b4$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $96c85404d21524b4$var$pluginEvent('destroy', this);
        var el = this.el;
        el[$96c85404d21524b4$var$expando] = null;
        $96c85404d21524b4$var$off(el, 'mousedown', this._onTapStart);
        $96c85404d21524b4$var$off(el, 'touchstart', this._onTapStart);
        $96c85404d21524b4$var$off(el, 'pointerdown', this._onTapStart);
        if (this.nativeDraggable) {
            $96c85404d21524b4$var$off(el, 'dragover', this);
            $96c85404d21524b4$var$off(el, 'dragenter', this);
        } // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function(el) {
            el.removeAttribute('draggable');
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $96c85404d21524b4$var$sortables.splice($96c85404d21524b4$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$96c85404d21524b4$var$cloneHidden) {
            $96c85404d21524b4$var$pluginEvent('hideClone', this);
            if ($96c85404d21524b4$export$31b3ca70d8f57423.eventCanceled) return;
            $96c85404d21524b4$var$css($96c85404d21524b4$var$cloneEl, 'display', 'none');
            if (this.options.removeCloneOnHide && $96c85404d21524b4$var$cloneEl.parentNode) $96c85404d21524b4$var$cloneEl.parentNode.removeChild($96c85404d21524b4$var$cloneEl);
            $96c85404d21524b4$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== 'clone') {
            this._hideClone();
            return;
        }
        if ($96c85404d21524b4$var$cloneHidden) {
            $96c85404d21524b4$var$pluginEvent('showClone', this);
            if ($96c85404d21524b4$export$31b3ca70d8f57423.eventCanceled) return; // show clone at dragEl or original position
            if ($96c85404d21524b4$var$dragEl.parentNode == $96c85404d21524b4$var$rootEl && !this.options.group.revertClone) $96c85404d21524b4$var$rootEl.insertBefore($96c85404d21524b4$var$cloneEl, $96c85404d21524b4$var$dragEl);
            else if ($96c85404d21524b4$var$nextEl) $96c85404d21524b4$var$rootEl.insertBefore($96c85404d21524b4$var$cloneEl, $96c85404d21524b4$var$nextEl);
            else $96c85404d21524b4$var$rootEl.appendChild($96c85404d21524b4$var$cloneEl);
            if (this.options.group.revertClone) this.animate($96c85404d21524b4$var$dragEl, $96c85404d21524b4$var$cloneEl);
            $96c85404d21524b4$var$css($96c85404d21524b4$var$cloneEl, 'display', '');
            $96c85404d21524b4$var$cloneHidden = false;
        }
    }
};
function $96c85404d21524b4$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = 'move';
    evt.cancelable && evt.preventDefault();
}
function $96c85404d21524b4$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$96c85404d21524b4$var$expando], onMoveFn = sortable.options.onMove, retVal; // Support for new CustomEvent feature
    if (window.CustomEvent && !$96c85404d21524b4$var$IE11OrLess && !$96c85404d21524b4$var$Edge) evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent('move', true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $96c85404d21524b4$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $96c85404d21524b4$var$_disableDraggable(el) {
    el.draggable = false;
}
function $96c85404d21524b4$var$_unsilent() {
    $96c85404d21524b4$var$_silent = false;
}
function $96c85404d21524b4$var$_ghostIsFirst(evt, vertical, sortable) {
    var rect = $96c85404d21524b4$var$getRect($96c85404d21524b4$var$getChild(sortable.el, 0, sortable.options, true));
    var spacer = 10;
    return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}
function $96c85404d21524b4$var$_ghostIsLast(evt, vertical, sortable) {
    var rect = $96c85404d21524b4$var$getRect($96c85404d21524b4$var$lastChild(sortable.el, sortable.options.draggable));
    var spacer = 10;
    return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function $96c85404d21524b4$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $96c85404d21524b4$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$96c85404d21524b4$var$pastFirstInvertThresh && ($96c85404d21524b4$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $96c85404d21524b4$var$pastFirstInvertThresh = true;
            if (!$96c85404d21524b4$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($96c85404d21524b4$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $96c85404d21524b4$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $96c85404d21524b4$var$targetMoveDistance) return -$96c85404d21524b4$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $96c85404d21524b4$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $96c85404d21524b4$var$_getInsertDirection(target) {
    if ($96c85404d21524b4$var$index($96c85404d21524b4$var$dragEl) < $96c85404d21524b4$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $96c85404d21524b4$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $96c85404d21524b4$var$_saveInputCheckedState(root) {
    $96c85404d21524b4$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $96c85404d21524b4$var$savedInputChecked.push(el);
    }
}
function $96c85404d21524b4$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $96c85404d21524b4$var$_cancelNextTick(id) {
    return clearTimeout(id);
} // Fixed #973:
if ($96c85404d21524b4$var$documentExists) $96c85404d21524b4$var$on(document, 'touchmove', function(evt) {
    if (($96c85404d21524b4$export$31b3ca70d8f57423.active || $96c85404d21524b4$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
 // Export utils
$96c85404d21524b4$export$31b3ca70d8f57423.utils = {
    on: $96c85404d21524b4$var$on,
    off: $96c85404d21524b4$var$off,
    css: $96c85404d21524b4$var$css,
    find: $96c85404d21524b4$var$find,
    is: function is(el, selector) {
        return !!$96c85404d21524b4$var$closest(el, selector, el, false);
    },
    extend: $96c85404d21524b4$var$extend,
    throttle: $96c85404d21524b4$var$throttle,
    closest: $96c85404d21524b4$var$closest,
    toggleClass: $96c85404d21524b4$var$toggleClass,
    clone: $96c85404d21524b4$var$clone,
    index: $96c85404d21524b4$var$index,
    nextTick: $96c85404d21524b4$var$_nextTick,
    cancelNextTick: $96c85404d21524b4$var$_cancelNextTick,
    detectDirection: $96c85404d21524b4$var$_detectDirection,
    getChild: $96c85404d21524b4$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $96c85404d21524b4$export$31b3ca70d8f57423.get = function(element) {
    return element[$96c85404d21524b4$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $96c85404d21524b4$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $96c85404d21524b4$export$31b3ca70d8f57423.utils = $96c85404d21524b4$var$_objectSpread2($96c85404d21524b4$var$_objectSpread2({}, $96c85404d21524b4$export$31b3ca70d8f57423.utils), plugin.utils);
        $96c85404d21524b4$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $96c85404d21524b4$export$31b3ca70d8f57423.create = function(el, options) {
    return new $96c85404d21524b4$export$31b3ca70d8f57423(el, options);
}; // Export
$96c85404d21524b4$export$31b3ca70d8f57423.version = $96c85404d21524b4$var$version;
var $96c85404d21524b4$var$autoScrolls = [], $96c85404d21524b4$var$scrollEl, $96c85404d21524b4$var$scrollRootEl, $96c85404d21524b4$var$scrolling = false, $96c85404d21524b4$var$lastAutoScrollX, $96c85404d21524b4$var$lastAutoScrollY, $96c85404d21524b4$var$touchEvt$1, $96c85404d21524b4$var$pointerElemChangedInterval;
function $96c85404d21524b4$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        }; // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $96c85404d21524b4$var$on(document, 'dragover', this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $96c85404d21524b4$var$on(document, 'pointermove', this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $96c85404d21524b4$var$on(document, 'touchmove', this._handleFallbackAutoScroll);
                else $96c85404d21524b4$var$on(document, 'mousemove', this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $96c85404d21524b4$var$off(document, 'dragover', this._handleAutoScroll);
            else {
                $96c85404d21524b4$var$off(document, 'pointermove', this._handleFallbackAutoScroll);
                $96c85404d21524b4$var$off(document, 'touchmove', this._handleFallbackAutoScroll);
                $96c85404d21524b4$var$off(document, 'mousemove', this._handleFallbackAutoScroll);
            }
            $96c85404d21524b4$var$clearPointerElemChangedInterval();
            $96c85404d21524b4$var$clearAutoScrolls();
            $96c85404d21524b4$var$cancelThrottle();
        },
        nulling: function nulling() {
            $96c85404d21524b4$var$touchEvt$1 = $96c85404d21524b4$var$scrollRootEl = $96c85404d21524b4$var$scrollEl = $96c85404d21524b4$var$scrolling = $96c85404d21524b4$var$pointerElemChangedInterval = $96c85404d21524b4$var$lastAutoScrollX = $96c85404d21524b4$var$lastAutoScrollY = null;
            $96c85404d21524b4$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $96c85404d21524b4$var$touchEvt$1 = evt; // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $96c85404d21524b4$var$Edge || $96c85404d21524b4$var$IE11OrLess || $96c85404d21524b4$var$Safari) {
                $96c85404d21524b4$var$autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change
                var ogElemScroller = $96c85404d21524b4$var$getParentAutoScrollElement(elem, true);
                if ($96c85404d21524b4$var$scrolling && (!$96c85404d21524b4$var$pointerElemChangedInterval || x !== $96c85404d21524b4$var$lastAutoScrollX || y !== $96c85404d21524b4$var$lastAutoScrollY)) {
                    $96c85404d21524b4$var$pointerElemChangedInterval && $96c85404d21524b4$var$clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour
                    $96c85404d21524b4$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $96c85404d21524b4$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $96c85404d21524b4$var$clearAutoScrolls();
                        }
                        $96c85404d21524b4$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $96c85404d21524b4$var$lastAutoScrollX = x;
                    $96c85404d21524b4$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $96c85404d21524b4$var$getParentAutoScrollElement(elem, true) === $96c85404d21524b4$var$getWindowScrollingElement()) {
                    $96c85404d21524b4$var$clearAutoScrolls();
                    return;
                }
                $96c85404d21524b4$var$autoScroll(evt, this.options, $96c85404d21524b4$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $96c85404d21524b4$var$_extends(AutoScroll, {
        pluginName: 'scroll',
        initializeByDefault: true
    });
}
function $96c85404d21524b4$var$clearAutoScrolls() {
    $96c85404d21524b4$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $96c85404d21524b4$var$autoScrolls = [];
}
function $96c85404d21524b4$var$clearPointerElemChangedInterval() {
    clearInterval($96c85404d21524b4$var$pointerElemChangedInterval);
}
var $96c85404d21524b4$var$autoScroll = $96c85404d21524b4$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $96c85404d21524b4$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn; // New scroll root, set scrollEl
    if ($96c85404d21524b4$var$scrollRootEl !== rootEl) {
        $96c85404d21524b4$var$scrollRootEl = rootEl;
        $96c85404d21524b4$var$clearAutoScrolls();
        $96c85404d21524b4$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($96c85404d21524b4$var$scrollEl === true) $96c85404d21524b4$var$scrollEl = $96c85404d21524b4$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $96c85404d21524b4$var$scrollEl;
    do {
        var el = currentParent, rect = $96c85404d21524b4$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $96c85404d21524b4$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$96c85404d21524b4$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$96c85404d21524b4$var$autoScrolls[i]) $96c85404d21524b4$var$autoScrolls[i] = {};
        }
        if ($96c85404d21524b4$var$autoScrolls[layersOut].vx != vx || $96c85404d21524b4$var$autoScrolls[layersOut].vy != vy || $96c85404d21524b4$var$autoScrolls[layersOut].el !== el) {
            $96c85404d21524b4$var$autoScrolls[layersOut].el = el;
            $96c85404d21524b4$var$autoScrolls[layersOut].vx = vx;
            $96c85404d21524b4$var$autoScrolls[layersOut].vy = vy;
            clearInterval($96c85404d21524b4$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $96c85404d21524b4$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $96c85404d21524b4$export$31b3ca70d8f57423.active._onTouchMove($96c85404d21524b4$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $96c85404d21524b4$var$autoScrolls[this.layer].vy ? $96c85404d21524b4$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $96c85404d21524b4$var$autoScrolls[this.layer].vx ? $96c85404d21524b4$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === 'function') {
                        if (scrollCustomFn.call($96c85404d21524b4$export$31b3ca70d8f57423.dragged.parentNode[$96c85404d21524b4$var$expando], scrollOffsetX, scrollOffsetY, evt, $96c85404d21524b4$var$touchEvt$1, $96c85404d21524b4$var$autoScrolls[this.layer].el) !== 'continue') return;
                    }
                    $96c85404d21524b4$var$scrollBy($96c85404d21524b4$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $96c85404d21524b4$var$getParentAutoScrollElement(currentParent, false)));
    $96c85404d21524b4$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $96c85404d21524b4$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent('spill');
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $96c85404d21524b4$var$Revert() {}
$96c85404d21524b4$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $96c85404d21524b4$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $96c85404d21524b4$var$drop
};
$96c85404d21524b4$var$_extends($96c85404d21524b4$var$Revert, {
    pluginName: 'revertOnSpill'
});
function $96c85404d21524b4$var$Remove() {}
$96c85404d21524b4$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $96c85404d21524b4$var$drop
};
$96c85404d21524b4$var$_extends($96c85404d21524b4$var$Remove, {
    pluginName: 'removeOnSpill'
});
var $96c85404d21524b4$var$lastSwapEl;
function $96c85404d21524b4$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: 'sortable-swap-highlight'
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $96c85404d21524b4$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $96c85404d21524b4$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $96c85404d21524b4$var$toggleClass(target, options.swapClass, true);
                    $96c85404d21524b4$var$lastSwapEl = target;
                } else $96c85404d21524b4$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $96c85404d21524b4$var$lastSwapEl) $96c85404d21524b4$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $96c85404d21524b4$var$lastSwapEl && $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$lastSwapEl, options.swapClass, false);
            if ($96c85404d21524b4$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $96c85404d21524b4$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $96c85404d21524b4$var$swapNodes(dragEl, $96c85404d21524b4$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $96c85404d21524b4$var$lastSwapEl = null;
        }
    };
    return $96c85404d21524b4$var$_extends(Swap, {
        pluginName: 'swap',
        eventProperties: function eventProperties() {
            return {
                swapItem: $96c85404d21524b4$var$lastSwapEl
            };
        }
    });
}
function $96c85404d21524b4$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $96c85404d21524b4$var$index(n1);
    i2 = $96c85404d21524b4$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $96c85404d21524b4$var$multiDragElements = [], $96c85404d21524b4$var$multiDragClones = [], $96c85404d21524b4$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$96c85404d21524b4$var$multiDragSortable, $96c85404d21524b4$var$initialFolding = false, // Initial multi-drag fold when drag started
$96c85404d21524b4$var$folding = false, // Folding any other time
$96c85404d21524b4$var$dragStarted = false, $96c85404d21524b4$var$dragEl$1, $96c85404d21524b4$var$clonesFromRect, $96c85404d21524b4$var$clonesHidden;
function $96c85404d21524b4$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $96c85404d21524b4$var$on(document, 'pointerup', this._deselectMultiDrag);
            else {
                $96c85404d21524b4$var$on(document, 'mouseup', this._deselectMultiDrag);
                $96c85404d21524b4$var$on(document, 'touchend', this._deselectMultiDrag);
            }
        }
        $96c85404d21524b4$var$on(document, 'keydown', this._checkKeyDown);
        $96c85404d21524b4$var$on(document, 'keyup', this._checkKeyUp);
        this.defaults = {
            selectedClass: 'sortable-selected',
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = '';
                if ($96c85404d21524b4$var$multiDragElements.length && $96c85404d21524b4$var$multiDragSortable === sortable) $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? '' : ', ') + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData('Text', data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $96c85404d21524b4$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$96c85404d21524b4$var$multiDragElements.indexOf($96c85404d21524b4$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $96c85404d21524b4$var$multiDragElements.length; i++){
                $96c85404d21524b4$var$multiDragClones.push($96c85404d21524b4$var$clone($96c85404d21524b4$var$multiDragElements[i]));
                $96c85404d21524b4$var$multiDragClones[i].sortableIndex = $96c85404d21524b4$var$multiDragElements[i].sortableIndex;
                $96c85404d21524b4$var$multiDragClones[i].draggable = false;
                $96c85404d21524b4$var$multiDragClones[i].style['will-change'] = '';
                $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$multiDragClones[i], this.options.selectedClass, false);
                $96c85404d21524b4$var$multiDragElements[i] === $96c85404d21524b4$var$dragEl$1 && $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($96c85404d21524b4$var$multiDragElements.length && $96c85404d21524b4$var$multiDragSortable === sortable) {
                    $96c85404d21524b4$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent('clone');
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $96c85404d21524b4$var$insertMultiDragClones(false, rootEl);
            $96c85404d21524b4$var$multiDragClones.forEach(function(clone) {
                $96c85404d21524b4$var$css(clone, 'display', '');
            });
            cloneNowShown();
            $96c85404d21524b4$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $96c85404d21524b4$var$multiDragClones.forEach(function(clone) {
                $96c85404d21524b4$var$css(clone, 'display', 'none');
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $96c85404d21524b4$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $96c85404d21524b4$var$multiDragSortable) $96c85404d21524b4$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $96c85404d21524b4$var$index(multiDragElement);
            }); // Sort multi-drag elements
            $96c85404d21524b4$var$multiDragElements = $96c85404d21524b4$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $96c85404d21524b4$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $96c85404d21524b4$var$dragEl$1) return;
                        $96c85404d21524b4$var$css(multiDragElement, 'position', 'absolute');
                    });
                    var dragRect = $96c85404d21524b4$var$getRect($96c85404d21524b4$var$dragEl$1, false, true, true);
                    $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $96c85404d21524b4$var$dragEl$1) return;
                        $96c85404d21524b4$var$setRect(multiDragElement, dragRect);
                    });
                    $96c85404d21524b4$var$folding = true;
                    $96c85404d21524b4$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $96c85404d21524b4$var$folding = false;
                $96c85404d21524b4$var$initialFolding = false;
                if (_this2.options.animation) $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                    $96c85404d21524b4$var$unsetRect(multiDragElement);
                });
                 // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $96c85404d21524b4$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($96c85404d21524b4$var$folding && ~$96c85404d21524b4$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($96c85404d21524b4$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $96c85404d21524b4$var$folding ? $96c85404d21524b4$var$getRect(multiDragElement) : dragRect
                    });
                    $96c85404d21524b4$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $96c85404d21524b4$var$folding = false;
                $96c85404d21524b4$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $96c85404d21524b4$var$initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $96c85404d21524b4$var$multiDragElements.length > 1 && ($96c85404d21524b4$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $96c85404d21524b4$var$getRect($96c85404d21524b4$var$dragEl$1, false, true, true);
                    $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $96c85404d21524b4$var$dragEl$1) return;
                        $96c85404d21524b4$var$setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $96c85404d21524b4$var$folding = true;
                } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$96c85404d21524b4$var$folding) $96c85404d21524b4$var$removeMultiDragElements();
                    if ($96c85404d21524b4$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $96c85404d21524b4$var$clonesHidden;
                        activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$96c85404d21524b4$var$clonesHidden && clonesHiddenBefore) $96c85404d21524b4$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $96c85404d21524b4$var$clonesFromRect
                            });
                            clone.fromRect = $96c85404d21524b4$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $96c85404d21524b4$var$clonesFromRect = $96c85404d21524b4$var$_extends({}, dragRect);
                var dragMatrix = $96c85404d21524b4$var$matrix($96c85404d21524b4$var$dragEl$1, true);
                $96c85404d21524b4$var$clonesFromRect.top -= dragMatrix.f;
                $96c85404d21524b4$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($96c85404d21524b4$var$folding) {
                $96c85404d21524b4$var$folding = false;
                $96c85404d21524b4$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children; // Multi-drag selection
            if (!$96c85404d21524b4$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $96c85404d21524b4$var$toggleClass($96c85404d21524b4$var$dragEl$1, options.selectedClass, !~$96c85404d21524b4$var$multiDragElements.indexOf($96c85404d21524b4$var$dragEl$1));
                if (!~$96c85404d21524b4$var$multiDragElements.indexOf($96c85404d21524b4$var$dragEl$1)) {
                    $96c85404d21524b4$var$multiDragElements.push($96c85404d21524b4$var$dragEl$1);
                    $96c85404d21524b4$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'select',
                        targetEl: $96c85404d21524b4$var$dragEl$1,
                        originalEvent: evt
                    }); // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $96c85404d21524b4$var$lastMultiDragSelect && sortable.el.contains($96c85404d21524b4$var$lastMultiDragSelect)) {
                        var lastIndex = $96c85404d21524b4$var$index($96c85404d21524b4$var$lastMultiDragSelect), currentIndex = $96c85404d21524b4$var$index($96c85404d21524b4$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$96c85404d21524b4$var$multiDragElements.indexOf(children[i])) continue;
                                $96c85404d21524b4$var$toggleClass(children[i], options.selectedClass, true);
                                $96c85404d21524b4$var$multiDragElements.push(children[i]);
                                $96c85404d21524b4$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: 'select',
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $96c85404d21524b4$var$lastMultiDragSelect = $96c85404d21524b4$var$dragEl$1;
                    $96c85404d21524b4$var$multiDragSortable = toSortable;
                } else {
                    $96c85404d21524b4$var$multiDragElements.splice($96c85404d21524b4$var$multiDragElements.indexOf($96c85404d21524b4$var$dragEl$1), 1);
                    $96c85404d21524b4$var$lastMultiDragSelect = null;
                    $96c85404d21524b4$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'deselect',
                        targetEl: $96c85404d21524b4$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            } // Multi-drag drop
            if ($96c85404d21524b4$var$dragStarted && this.isMultiDrag) {
                $96c85404d21524b4$var$folding = false; // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$96c85404d21524b4$var$expando].options.sort || parentEl !== rootEl) && $96c85404d21524b4$var$multiDragElements.length > 1) {
                    var dragRect = $96c85404d21524b4$var$getRect($96c85404d21524b4$var$dragEl$1), multiDragIndex = $96c85404d21524b4$var$index($96c85404d21524b4$var$dragEl$1, ':not(.' + this.options.selectedClass + ')');
                    if (!$96c85404d21524b4$var$initialFolding && options.animation) $96c85404d21524b4$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$96c85404d21524b4$var$initialFolding) {
                        if (options.animation) {
                            $96c85404d21524b4$var$dragEl$1.fromRect = dragRect;
                            $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $96c85404d21524b4$var$dragEl$1) {
                                    var rect = $96c85404d21524b4$var$folding ? $96c85404d21524b4$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect; // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $96c85404d21524b4$var$removeMultiDragElements();
                        $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        }); // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $96c85404d21524b4$var$index($96c85404d21524b4$var$dragEl$1)) {
                            var update = false;
                            $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $96c85404d21524b4$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) dispatchSortableEvent('update');
                        }
                    } // Must be done after capturing individual rects (scroll bar)
                    $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                        $96c85404d21524b4$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $96c85404d21524b4$var$multiDragSortable = toSortable;
            } // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') $96c85404d21524b4$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $96c85404d21524b4$var$dragStarted = false;
            $96c85404d21524b4$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $96c85404d21524b4$var$off(document, 'pointerup', this._deselectMultiDrag);
            $96c85404d21524b4$var$off(document, 'mouseup', this._deselectMultiDrag);
            $96c85404d21524b4$var$off(document, 'touchend', this._deselectMultiDrag);
            $96c85404d21524b4$var$off(document, 'keydown', this._checkKeyDown);
            $96c85404d21524b4$var$off(document, 'keyup', this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $96c85404d21524b4$var$dragStarted !== "undefined" && $96c85404d21524b4$var$dragStarted) return; // Only deselect if selection is in this sortable
            if ($96c85404d21524b4$var$multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable
            if (evt && $96c85404d21524b4$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($96c85404d21524b4$var$multiDragElements.length){
                var el = $96c85404d21524b4$var$multiDragElements[0];
                $96c85404d21524b4$var$toggleClass(el, this.options.selectedClass, false);
                $96c85404d21524b4$var$multiDragElements.shift();
                $96c85404d21524b4$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: 'deselect',
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $96c85404d21524b4$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: 'multiDrag',
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$96c85404d21524b4$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$96c85404d21524b4$var$multiDragElements.indexOf(el)) return;
                if ($96c85404d21524b4$var$multiDragSortable && $96c85404d21524b4$var$multiDragSortable !== sortable) {
                    $96c85404d21524b4$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $96c85404d21524b4$var$multiDragSortable = sortable;
                }
                $96c85404d21524b4$var$toggleClass(el, sortable.options.selectedClass, true);
                $96c85404d21524b4$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$96c85404d21524b4$var$expando], index = $96c85404d21524b4$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $96c85404d21524b4$var$toggleClass(el, sortable.options.selectedClass, false);
                $96c85404d21524b4$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                }); // multiDragElements will already be sorted if folding
                var newIndex;
                if ($96c85404d21524b4$var$folding && multiDragElement !== $96c85404d21524b4$var$dragEl$1) newIndex = -1;
                else if ($96c85404d21524b4$var$folding) newIndex = $96c85404d21524b4$var$index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
                else newIndex = $96c85404d21524b4$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $96c85404d21524b4$var$_toConsumableArray($96c85404d21524b4$var$multiDragElements),
                clones: [].concat($96c85404d21524b4$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === 'ctrl') key = 'Control';
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $96c85404d21524b4$var$insertMultiDragElements(clonesInserted, rootEl) {
    $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $96c85404d21524b4$var$insertMultiDragClones(elementsInserted, rootEl) {
    $96c85404d21524b4$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $96c85404d21524b4$var$removeMultiDragElements() {
    $96c85404d21524b4$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $96c85404d21524b4$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$96c85404d21524b4$export$31b3ca70d8f57423.mount(new $96c85404d21524b4$var$AutoScrollPlugin());
$96c85404d21524b4$export$31b3ca70d8f57423.mount($96c85404d21524b4$var$Remove, $96c85404d21524b4$var$Revert);
var $96c85404d21524b4$export$2e2bcd8739ae039 = $96c85404d21524b4$export$31b3ca70d8f57423;


var $13d2dd924a971d28$require$Sortable = $96c85404d21524b4$export$2e2bcd8739ae039;

var $dM6Pc = parcelRequire("dM6Pc");
var $83a891297e5a5907$exports = {};
/*$AMPERSAND_VERSION*/ 
var $80YiL = parcelRequire("80YiL");

var $4V7X5 = parcelRequire("4V7X5");

var $cpUjj = parcelRequire("cpUjj");

var $3TXX4 = parcelRequire("3TXX4");

var $eBZ53 = parcelRequire("eBZ53");

var $akRxj = parcelRequire("akRxj");

var $3vzLP = parcelRequire("3vzLP");

var $jk6VI = parcelRequire("jk6VI");

var $6ZxOb = parcelRequire("6ZxOb");

var $9yJUW = parcelRequire("9yJUW");

var $1NfP2 = parcelRequire("1NfP2");
var $321ad2314454d663$exports = {};

var $gy2mG = parcelRequire("gy2mG");
var $176ae26e8155b4eb$exports = {};

var $eHNuH = parcelRequire("eHNuH");
/** Used as references for the maximum length and index of an array. */ var $176ae26e8155b4eb$var$MAX_ARRAY_LENGTH = 4294967295, $176ae26e8155b4eb$var$MAX_ARRAY_INDEX = $176ae26e8155b4eb$var$MAX_ARRAY_LENGTH - 1;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $176ae26e8155b4eb$var$nativeFloor = Math.floor, $176ae26e8155b4eb$var$nativeMin = Math.min;
/**
 * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
 * which invokes `iteratee` for `value` and each element of `array` to compute
 * their sort ranking. The iteratee is invoked with one argument; (value).
 *
 * @private
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} iteratee The iteratee invoked per element.
 * @param {boolean} [retHighest] Specify returning the highest qualified index.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 */ function $176ae26e8155b4eb$var$baseSortedIndexBy(array, value, iteratee, retHighest) {
    var low = 0, high = array == null ? 0 : array.length;
    if (high === 0) return 0;
    value = iteratee(value);
    var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = $eHNuH(value), valIsUndefined = value === undefined;
    while(low < high){
        var mid = $176ae26e8155b4eb$var$nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = $eHNuH(computed);
        if (valIsNaN) var setLow = retHighest || othIsReflexive;
        else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
        else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        else if (othIsNull || othIsSymbol) setLow = false;
        else setLow = retHighest ? computed <= value : computed < value;
        if (setLow) low = mid + 1;
        else high = mid;
    }
    return $176ae26e8155b4eb$var$nativeMin(high, $176ae26e8155b4eb$var$MAX_ARRAY_INDEX);
}
$176ae26e8155b4eb$exports = $176ae26e8155b4eb$var$baseSortedIndexBy;


/**
 * This method is like `_.sortedIndex` except that it accepts `iteratee`
 * which is invoked for `value` and each element of `array` to compute their
 * sort ranking. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The sorted array to inspect.
 * @param {*} value The value to evaluate.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the index at which `value` should be inserted
 *  into `array`.
 * @example
 *
 * var objects = [{ 'x': 4 }, { 'x': 5 }];
 *
 * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
 * // => 0
 */ function $321ad2314454d663$var$sortedIndexBy(array, value, iteratee) {
    return $176ae26e8155b4eb$exports(array, value, $gy2mG(iteratee, 2));
}
$321ad2314454d663$exports = $321ad2314454d663$var$sortedIndexBy;



var $9YydO = parcelRequire("9YydO");
var $f8b64f0bffafa4ba$exports = {};

var $akRxj = parcelRequire("akRxj");
/// Following code is largely pasted from Backbone.js
// Helper function to correctly set up the prototype chain, for subclasses.
// Similar to `goog.inherits`, but uses a hash of prototype properties and
// class properties to be extended.
var $f8b64f0bffafa4ba$var$extend = function(protoProps) {
    var parent = this;
    var child;
    var args = [].slice.call(arguments);
    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent's constructor.
    if (protoProps && protoProps.hasOwnProperty('constructor')) child = protoProps.constructor;
    else child = function() {
        return parent.apply(this, arguments);
    };
    // Add static properties to the constructor function from parent
    $akRxj(child, parent);
    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function.
    var Surrogate = function() {
        this.constructor = child;
    };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate();
    // Mix in all prototype properties to the subclass if supplied.
    if (protoProps) {
        args.unshift(child.prototype);
        $akRxj.apply(null, args);
    }
    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;
    return child;
};
// Expose the extend function
$f8b64f0bffafa4ba$exports = $f8b64f0bffafa4ba$var$extend;



var $9jqvh = parcelRequire("9jqvh");
var $83a891297e5a5907$var$slice = Array.prototype.slice;
function $83a891297e5a5907$var$FilteredCollection(collection, spec) {
    this.collection = collection;
    this.indexes = collection.indexes || [];
    this._indexes = {};
    this._resetIndexes(this._indexes);
    this.mainIndex = collection.mainIndex;
    this.models = []; //Our filtered, models
    this.configure(spec || {}, true);
    this.listenTo(this.collection, 'all', this._onCollectionEvent);
}
$akRxj($83a891297e5a5907$var$FilteredCollection.prototype, $9jqvh, {
    // Public API
    // add a filter function directly
    addFilter: function(filter) {
        this.swapFilters([
            filter
        ], []);
    },
    // remove filter function directly
    removeFilter: function(filter) {
        this.swapFilters([], [
            filter
        ]);
    },
    // clears filters fires events for each add/remove
    clearFilters: function() {
        this._resetFilters();
        this._runFilters();
    },
    // Swap out a set of old filters with a set of
    // new filters
    swapFilters: function(newFilters, oldFilters) {
        var self = this;
        if (!oldFilters) oldFilters = this._filters;
        else if (!$3vzLP(oldFilters)) oldFilters = [
            oldFilters
        ];
        if (!newFilters) newFilters = [];
        else if (!$3vzLP(newFilters)) newFilters = [
            newFilters
        ];
        oldFilters.forEach(function(filter) {
            self._removeFilter(filter);
        });
        newFilters.forEach(function(filter) {
            self._addFilter(filter);
        });
        this._runFilters();
    },
    // Update config with potentially new filters/where/etc
    configure: function(opts, clear) {
        if (clear) this._resetFilters(clear);
        this._parseSpec(opts);
        if (clear) this._runFilters();
    },
    // gets a model at a given index
    at: function(index) {
        return this.models[index];
    },
    // proxy `get` method to the underlying collection
    get: function(query, indexName) {
        var model = this.collection.get(query, indexName);
        if (model && $80YiL(this.models, model)) return model;
    },
    // clear all filters, reset everything
    reset: function() {
        this.configure({}, true);
    },
    // Internal API
    // try to get a model by index
    _indexedGet: function(query, indexName) {
        if (!query) return;
        var index = this._indexes[indexName || this.mainIndex];
        return index[query] || index[query[this.mainIndex]] || this._indexes.cid[query] || this._indexes.cid[query.cid];
    },
    _parseSpec: function(spec) {
        if (spec.watched) this._watch(spec.watched);
        //this.comparator = this.collection.comparator;
        if (spec.comparator) this.comparator = spec.comparator;
        if (spec.where) {
            $3TXX4(spec.where, $cpUjj(function(value, item) {
                this._addFilter(function(model) {
                    return (model.get ? model.get(item) : model[item]) === value;
                });
            }, this));
            // also make sure we watch all `where` keys
            this._watch($6ZxOb(spec.where));
        }
        if (spec.filter) this._addFilter(spec.filter);
        if (spec.filters) spec.filters.forEach(this._addFilter, this);
    },
    // internal method registering new filter function
    _addFilter: function(filter) {
        this._filters.push(filter);
    },
    // remove filter if found
    _removeFilter: function(filter) {
        var index = this._filters.indexOf(filter);
        if (index !== -1) this._filters.splice(index, 1);
    },
    // just reset filters, no model changes
    _resetFilters: function(resetComparator) {
        this._filters = [];
        this._watched = [];
        if (resetComparator) this.comparator = undefined;
    },
    // adds a property or array of properties to watch, ensures uniquness.
    _watch: function(items) {
        this._watched = $9YydO(this._watched, items);
    },
    // removes a watched property
    _unwatch: function(item) {
        this._watched = $4V7X5(this._watched, $3vzLP(item) ? item : [
            item
        ]);
    },
    _sortModels: function(newModels, comparator) {
        comparator = comparator || this.comparator || this.collection.comparator;
        if (comparator) {
            if (typeof comparator === 'string' || comparator.length === 1) newModels = $1NfP2(newModels, comparator);
            else // lodash sortBy does not allow for traditional a, b comparisons
            newModels = newModels.sort(comparator);
        } else // This only happens when parent got a .set with options.at defined
        this._runFilters();
        return newModels;
    },
    //Add a model to this filtered collection that has already passed the filters
    _addModel: function(model, options, eventName) {
        var newModels = $83a891297e5a5907$var$slice.call(this.models);
        var comparator = this.comparator || this.collection.comparator;
        //Whether or not we are to expect a sort event from our collection later
        var sortable = eventName === 'add' && this.collection.comparator && options.at == null && options.sort !== false;
        if (!sortable) {
            var index = $321ad2314454d663$exports(newModels, model, comparator);
            newModels.splice(index, 0, model);
        } else {
            newModels.push(model);
            if (options.at) newModels = this._sortModels(newModels);
        }
        this.models = newModels;
        this._addIndex(this._indexes, model);
        if (this.comparator && !sortable) this.trigger('sort', this);
    },
    //Remove a model if it's in this filtered collection
    _removeModel: function(model) {
        var newModels = $83a891297e5a5907$var$slice.call(this.models);
        var modelIndex = newModels.indexOf(model);
        if (modelIndex > -1) {
            newModels.splice(modelIndex, 1);
            this.models = newModels;
            this._removeIndex(this._indexes, model);
            return true;
        }
        return false;
    },
    //Test if a model passes our filters
    _testModel: function(model) {
        if (this._filters.length === 0) return true;
        return $eBZ53(this._filters, function(filter) {
            return filter(model);
        });
    },
    _addIndex: function(newIndexes, model) {
        for(var name in this._indexes){
            var indexVal = model[name] || model.get && model.get(name);
            if (indexVal) newIndexes[name][indexVal] = model;
        }
    },
    _removeIndex: function(newIndexes, model) {
        for(var name in this._indexes)delete this._indexes[name][model[name] || model.get && model.get(name)];
    },
    _resetIndexes: function(newIndexes) {
        var list = $83a891297e5a5907$var$slice.call(this.indexes);
        list.push(this.mainIndex);
        list.push('cid');
        for(var i = 0; i < list.length; i++)newIndexes[list[i]] = {};
    },
    // Re-run the filters on all our parent's models
    _runFilters: function() {
        // make a copy of the array for comparisons
        var existingModels = $83a891297e5a5907$var$slice.call(this.models);
        var rootModels = $83a891297e5a5907$var$slice.call(this.collection.models);
        var newIndexes = {};
        var newModels, toAdd, toRemove;
        this._resetIndexes(newIndexes);
        // reduce base model set by applying filters
        if (this._filters.length) newModels = $9yJUW(this._filters, function(startingArray, filterFunc) {
            return startingArray.filter(filterFunc);
        }, rootModels);
        else newModels = $83a891297e5a5907$var$slice.call(rootModels);
        // sort it
        if (this.comparator) newModels = this._sortModels(newModels, this.comparator);
        newModels.forEach(function(model) {
            this._addIndex(newIndexes, model);
        }, this);
        // Cache a reference to the full filtered set to allow this._filtered.length. Ref: #6
        if (rootModels.length) {
            this._filtered = newModels;
            this._indexes = newIndexes;
        } else {
            this._filtered = [];
            this._resetIndexes(this._indexes);
        }
        // now we've got our new models time to compare
        toAdd = $4V7X5(newModels, existingModels);
        toRemove = $4V7X5(existingModels, newModels);
        // save 'em
        this.models = newModels;
        $3TXX4(toRemove, $cpUjj(function(model) {
            this.trigger('remove', model, this);
        }, this));
        $3TXX4(toAdd, $cpUjj(function(model) {
            this.trigger('add', model, this);
        }, this));
        // unless we have the same models in same order trigger `sort`
        if (!$jk6VI(existingModels, newModels) && this.comparator) this.trigger('sort', this);
    },
    _onCollectionEvent: function(event, model, that, options) {
        /*jshint -W030 */ options || (options = {});
        var accepted;
        var eventName = event.split(':')[0];
        var propName = event.split(':')[1];
        var action = event;
        var alreadyHave = this._indexedGet(model);
        //Whether or not we are to expect a sort event from our collection later
        var sortable = this.collection.comparator && options.at == null && options.sort !== false;
        var add = options.add;
        var remove = options.remove;
        var ordered = !sortable && add && remove;
        if (propName !== undefined && propName === this.comparator || $80YiL(this._watched, propName)) {
            accepted = this._testModel(model);
            if (!alreadyHave && accepted) action = 'add';
            else if (alreadyHave && !accepted) action = 'remove';
        } else if (action === 'add') {
            if (!this._testModel(model) || alreadyHave) action = 'ignore';
        } else if (eventName === 'change' && !alreadyHave) //Don't trigger change events that are not from this collection
        action = 'ignore';
        // action has now passed the filters
        if (action === 'reset') return this._runFilters();
        if (action === 'add') {
            if (this.models.length === 0) this._runFilters();
            else {
                this._addModel(model, options, event);
                this.trigger('add', model, this);
            }
            return;
        }
        if (action === 'remove') {
            if (this._removeModel(model)) this.trigger('remove', model, this);
            return;
        }
        if (action !== 'ignore') this.trigger.apply(this, arguments);
        //If we were asked to sort, or we aren't gonna get a sort later and had a sortable property change
        if (action === 'sort' || propName && !sortable && $80YiL([
            this.comparator,
            this.collection.comparator
        ].concat(this._watched), propName)) {
            if (ordered && model.isNew) return; //We'll get a sort later
            this.models = this._sortModels(this.models);
            if (this.comparator && action !== 'sort') this.trigger('sort', this);
        }
    }
});
Object.defineProperty($83a891297e5a5907$var$FilteredCollection.prototype, 'length', {
    get: function() {
        return this.models.length;
    }
});
Object.defineProperty($83a891297e5a5907$var$FilteredCollection.prototype, 'isCollection', {
    get: function() {
        return true;
    }
});
var $83a891297e5a5907$var$arrayMethods = [
    'indexOf',
    'lastIndexOf',
    'every',
    'some',
    'forEach',
    'map',
    'filter',
    'reduce',
    'reduceRight'
];
$83a891297e5a5907$var$arrayMethods.forEach(function(method) {
    $83a891297e5a5907$var$FilteredCollection.prototype[method] = function() {
        return this.models[method].apply(this.models, arguments);
    };
});
// alias each/forEach for maximum compatibility
$83a891297e5a5907$var$FilteredCollection.prototype.each = $83a891297e5a5907$var$FilteredCollection.prototype.forEach;
// methods to copy from parent
var $83a891297e5a5907$var$collectionMethods = [
    'serialize',
    'toJSON'
];
$83a891297e5a5907$var$collectionMethods.forEach(function(method) {
    $83a891297e5a5907$var$FilteredCollection.prototype[method] = function() {
        return this.collection[method].apply(this, arguments);
    };
});
$83a891297e5a5907$var$FilteredCollection.extend = $f8b64f0bffafa4ba$exports;
$83a891297e5a5907$exports = $83a891297e5a5907$var$FilteredCollection;



var $13d2dd924a971d28$require$tippy = $6445619a88c9e457$export$2e2bcd8739ae039;
var $36dc365827ae47b5$exports = {};

var $4UX9c = parcelRequire("4UX9c");
var $3c27fa7da8048484$exports = {};

var $4UX9c = parcelRequire("4UX9c");

var $bKnC7 = parcelRequire("bKnC7");

var $gvQO6 = parcelRequire("gvQO6");

var $d0uB5 = parcelRequire("d0uB5");
var $3c27fa7da8048484$require$packaging = $d0uB5.packaging;
function $3c27fa7da8048484$var$gtZero(val) {
    if (val < 0) return 'Must be greater than 0';
}
function $3c27fa7da8048484$var$currency(key) {
    return {
        deps: [
            key
        ],
        fn () {
            return $gvQO6.currency(this[key]);
        }
    };
}
$3c27fa7da8048484$exports = $bKnC7.extend({
    urlRoot () {
        return `/api/events/${$4UX9c.me.currentEvent.slug}/products`;
    },
    initialize (data, options) {
        const opts = options || {};
    },
    props: {
        id: {
            type: 'string',
            setOnce: true
        },
        deletedAt: [
            'date'
        ],
        name: [
            'string',
            true
        ],
        packageId: [
            'string',
            true
        ],
        packageSize: {
            type: 'number'
        },
        unitId: [
            'string',
            true
        ],
        costUnit: {
            type: 'string',
            required: true,
            values: [
                'package',
                'unit'
            ]
        },
        volumePerUnit: [
            'number',
            true
        ],
        weightEmpty: [
            'number',
            false
        ],
        weightFull: [
            'number',
            false
        ],
        servingSize: [
            'number',
            true
        ],
        canSpill: [
            'boolean'
        ],
        // monetary properties in €
        cost: {
            type: 'string',
            required: true,
            test: $3c27fa7da8048484$var$gtZero
        },
        price: {
            type: 'string',
            required: true,
            test: $3c27fa7da8048484$var$gtZero
        },
        sortPosition: [
            'number',
            false
        ],
        factor: [
            'number',
            true,
            1
        ],
        costPerUnit: [
            'number'
        ],
        pricePerUnit: [
            'number'
        ],
        categoryName: [
            'string'
        ],
        color: [
            'string'
        ]
    },
    session: {
        editable: [
            'boolean',
            true,
            false
        ]
    },
    derived: {
        slug: {
            deps: [
                'name'
            ],
            fn () {
                return $gvQO6.slugify(this.name);
            }
        },
        costLocalized: $3c27fa7da8048484$var$currency('cost'),
        priceLocalized: $3c27fa7da8048484$var$currency('price'),
        costPerUnitLocalized: $3c27fa7da8048484$var$currency('costPerUnit'),
        pricePerUnitLocalized: $3c27fa7da8048484$var$currency('pricePerUnit'),
        servingSizeLocalized: {
            deps: [
                'servingSize'
            ],
            fn () {
                return $gvQO6.localizeServingSize(this.servingSize);
            }
        },
        package: {
            deps: [
                'packageId'
            ],
            fn () {
                return $3c27fa7da8048484$require$packaging.get(this.packageId)?.name;
            }
        },
        unit: {
            deps: [
                'unitId'
            ],
            fn () {
                return $3c27fa7da8048484$require$packaging.get(this.unitId)?.name;
            }
        },
        costUnitId: {
            deps: [
                'costUnit',
                'packageId',
                'unitId'
            ],
            fn () {
                const pkg = $3c27fa7da8048484$require$packaging.get(this[`${this.costUnit}Id`]) || {};
                return pkg.id || this.costUnit;
            }
        },
        costUnitLocalized: {
            deps: [
                'costUnit',
                'packageId',
                'unitId'
            ],
            fn () {
                const pkg = $3c27fa7da8048484$require$packaging.get(this[`${this.costUnit}Id`]) || {};
                return pkg.name || this.costUnit;
            }
        },
        _nameIndex: {
            deps: [
                'name'
            ],
            fn () {
                return $gvQO6.indexify(this.name);
            }
        }
    }
});


var $8dd5675b2fc15f09$exports = {};
var $d09b7d770c5b7340$exports = {};
/*$AMPERSAND_VERSION*/ 
var $kbVTi = parcelRequire("kbVTi");
var $e86b6aeabe2abebf$exports = {};
/*$AMPERSAND_VERSION*/ 
var $62yEr = parcelRequire("62yEr");































var $e86b6aeabe2abebf$var$_ = {
    countBy: (parcelRequire("6GIoh")),
    difference: (parcelRequire("4V7X5")),
    drop: (parcelRequire("a5bpV")),
    each: (parcelRequire("3TXX4")),
    every: (parcelRequire("eBZ53")),
    filter: (parcelRequire("4vJCv")),
    find: (parcelRequire("l1UaK")),
    forEach: (parcelRequire("3TXX4")),
    groupBy: (parcelRequire("56rtr")),
    includes: (parcelRequire("80YiL")),
    keyBy: (parcelRequire("9zKvP")),
    indexOf: (parcelRequire("fjlsM")),
    initial: (parcelRequire("ear1Q")),
    invoke: (parcelRequire("dO2Ta")),
    invokeMap: (parcelRequire("h5CXZ")),
    isEmpty: (parcelRequire("1ucn8")),
    lastIndexOf: (parcelRequire("grLWU")),
    map: (parcelRequire("9jQ0w")),
    max: (parcelRequire("4OlMC")),
    min: (parcelRequire("cn6O8")),
    partition: (parcelRequire("17Qfy")),
    reduce: (parcelRequire("9yJUW")),
    reduceRight: (parcelRequire("7PNlz")),
    reject: (parcelRequire("aKx0i")),
    sample: (parcelRequire("akA2O")),
    shuffle: (parcelRequire("9mPJZ")),
    some: (parcelRequire("hKnuB")),
    sortBy: (parcelRequire("1NfP2")),
    tail: (parcelRequire("1OSIu")),
    take: (parcelRequire("cC3BS")),
    without: (parcelRequire("7VPYh"))
};
var $e86b6aeabe2abebf$var$slice = [].slice;
var $e86b6aeabe2abebf$var$mixins = {};
// lodash methods that we want to implement on the Collection.
var $e86b6aeabe2abebf$var$methods = [
    'forEach',
    'each',
    'map',
    'reduce',
    'reduceRight',
    'find',
    'filter',
    'reject',
    'every',
    'some',
    'includes',
    'invoke',
    'invokeMap',
    'max',
    'min',
    'take',
    'initial',
    'tail',
    'drop',
    'without',
    'difference',
    'indexOf',
    'shuffle',
    'lastIndexOf',
    'isEmpty',
    'sample',
    'partition'
];
// Mix in each lodash method as a proxy to `Collection#models`.
$e86b6aeabe2abebf$var$_.each($e86b6aeabe2abebf$var$methods, function(method) {
    if (!$e86b6aeabe2abebf$var$_[method]) return;
    $e86b6aeabe2abebf$var$mixins[method] = function() {
        var args = $e86b6aeabe2abebf$var$slice.call(arguments);
        args.unshift(this.models);
        return $e86b6aeabe2abebf$var$_[method].apply($e86b6aeabe2abebf$var$_, args);
    };
});
// lodash methods that take a property name as an argument.
var $e86b6aeabe2abebf$var$attributeMethods = [
    'groupBy',
    'countBy',
    'sortBy',
    'keyBy'
];
// Use attributes instead of properties.
$e86b6aeabe2abebf$var$_.each($e86b6aeabe2abebf$var$attributeMethods, function(method) {
    if (!$e86b6aeabe2abebf$var$_[method]) return;
    $e86b6aeabe2abebf$var$mixins[method] = function(value, context) {
        var iterator = $62yEr(value) ? value : function(model) {
            return model.get ? model.get(value) : model[value];
        };
        return $e86b6aeabe2abebf$var$_[method](this.models, iterator, context);
    };
});
// Return models with matching attributes. Useful for simple cases of
// `filter`.
$e86b6aeabe2abebf$var$mixins.where = function(attrs, first) {
    if ($e86b6aeabe2abebf$var$_.isEmpty(attrs)) return first ? void 0 : [];
    return this[first ? 'find' : 'filter'](function(model) {
        var value;
        for(var key in attrs){
            value = model.get ? model.get(key) : model[key];
            if (attrs[key] !== value) return false;
        }
        return true;
    });
};
// Return the first model with matching attributes. Useful for simple cases
// of `find`.
$e86b6aeabe2abebf$var$mixins.findWhere = function(attrs) {
    return this.where(attrs, true);
};
// Plucks an attribute from each model in the collection.
$e86b6aeabe2abebf$var$mixins.pluck = function(attr) {
    return $e86b6aeabe2abebf$var$_.invokeMap(this.models, 'get', attr);
};
// We implement the following trivial methods ourselves.
// Gets first model
$e86b6aeabe2abebf$var$mixins.first = function() {
    return this.models[0];
};
// Gets last model
$e86b6aeabe2abebf$var$mixins.last = function() {
    return this.models[this.models.length - 1];
};
// Gets size of collection
$e86b6aeabe2abebf$var$mixins.size = function() {
    return this.models.length;
};
$e86b6aeabe2abebf$exports = $e86b6aeabe2abebf$var$mixins;


var $784fc5f8d1ffcb85$exports = {};
/*$AMPERSAND_VERSION*/ 
var $cekly = parcelRequire("cekly");

var $akRxj = parcelRequire("akRxj");
$784fc5f8d1ffcb85$exports = {
    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
        options = options ? $akRxj({}, options) : {};
        if (options.parse === void 0) options.parse = true;
        var self = this;
        var success = options.success;
        options.success = function(resp) {
            var method = options.reset ? 'reset' : 'set';
            if (options.set !== false) self[method](resp, options);
            if (success) success(self, resp, options);
            if (options.set !== false) self.trigger('sync', self, resp, options);
        };
        // Wrap an optional error callback with a fallback error event.
        var error = options.error;
        options.error = function(resp) {
            if (error) error(self, resp, options);
            self.trigger('error', self, resp, options);
        };
        var request = this.sync('read', this, options);
        // Make the request available on the options object so it can be accessed
        // further down the line by `parse`, sync listeners, etc
        // https://github.com/AmpersandJS/ampersand-collection-rest-mixin/commit/d32d788aaff912387eb1106f2d7ad183ec39e11a#diff-84c84703169bf5017b1bc323653acaa3R32
        options.xhr = request;
        return request;
    },
    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
        options = options ? $akRxj({}, options) : {};
        if (!(model = this._prepareModel(model, options))) return false;
        if (!options.wait) this.add(model, options);
        var self = this;
        var success = options.success;
        options.success = function(model, resp) {
            if (options.wait) self.add(model, options);
            if (success) success(model, resp, options);
        };
        model.save(null, options);
        return model;
    },
    sync: function() {
        return $cekly.apply(this, arguments);
    },
    // Get or fetch a model by Id.
    getOrFetch: function(id, options, cb) {
        if (arguments.length !== 3) {
            cb = options;
            options = {};
        }
        var self = this;
        var model = this.get(id);
        if (model) return window.setTimeout(cb.bind(null, null, model), 0);
        if (options.all) {
            //preserve original `options.always`
            var always = options.always;
            options.always = function(err, resp, body) {
                if (always) always(err, resp, body);
                if (!cb) return;
                var model = self.get(id);
                var err2 = model ? null : new Error('not found');
                cb(err2, model);
            };
            return this.fetch(options);
        } else return this.fetchById(id, options, cb);
    },
    // fetchById: fetches a model and adds it to
    // collection when fetched.
    fetchById: function(id, options, cb) {
        if (arguments.length !== 3) {
            cb = options;
            options = {};
        }
        var self = this;
        var idObj = {};
        idObj[this.mainIndex] = id;
        var model = new this.model(idObj, {
            collection: this
        });
        //preserve original `options.success`
        var success = options.success;
        options.success = function(resp) {
            model = self.add(model);
            if (success) success(self, resp, options);
            if (cb) cb(null, model);
        };
        //preserve original `options.error`
        var error = options.error;
        options.error = function(collection, resp) {
            delete model.collection;
            if (error) error(collection, resp, options);
            if (cb) {
                var err = new Error(resp.rawRequest.statusText);
                err.status = resp.rawRequest.status;
                cb(err);
            }
        };
        return model.fetch(options);
    }
};


$d09b7d770c5b7340$exports = $kbVTi.extend($e86b6aeabe2abebf$exports, $784fc5f8d1ffcb85$exports);


var $5f39f54866b377cb$exports = {};
var $13ac1d05927214ea$exports = {};
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $13ac1d05927214ea$var$numberTag = '[object Number]';
/** Used for built-in method references. */ var $13ac1d05927214ea$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $13ac1d05927214ea$var$objectToString = $13ac1d05927214ea$var$objectProto.toString;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $13ac1d05927214ea$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $13ac1d05927214ea$var$isNumber(value) {
    return typeof value == 'number' || $13ac1d05927214ea$var$isObjectLike(value) && $13ac1d05927214ea$var$objectToString.call(value) == $13ac1d05927214ea$var$numberTag;
}
$13ac1d05927214ea$exports = $13ac1d05927214ea$var$isNumber;


var $f452de0b3d54356f$exports = {};
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $f452de0b3d54356f$var$stringTag = '[object String]';
/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */ function $f452de0b3d54356f$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/** Used for native method references. */ var $f452de0b3d54356f$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
 * of values.
 */ var $f452de0b3d54356f$var$objToString = $f452de0b3d54356f$var$objectProto.toString;
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $f452de0b3d54356f$var$isString(value) {
    return typeof value == 'string' || $f452de0b3d54356f$var$isObjectLike(value) && $f452de0b3d54356f$var$objToString.call(value) == $f452de0b3d54356f$var$stringTag;
}
$f452de0b3d54356f$exports = $f452de0b3d54356f$var$isString;


var $fbb00ea283c7a5e0$exports = {};
/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $e8481a496d08667f$exports = {};
/**
 * lodash 3.7.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * The base implementation of `get` without support for string paths
 * and default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path of the property to get.
 * @param {string} [pathKey] The key representation of path.
 * @returns {*} Returns the resolved value.
 */ function $e8481a496d08667f$var$baseGet(object, path, pathKey) {
    if (object == null) return;
    if (pathKey !== undefined && pathKey in $e8481a496d08667f$var$toObject(object)) path = [
        pathKey
    ];
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[path[index++]];
    return index && index == length ? object : undefined;
}
/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */ function $e8481a496d08667f$var$toObject(value) {
    return $e8481a496d08667f$var$isObject(value) ? value : Object(value);
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $e8481a496d08667f$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
$e8481a496d08667f$exports = $e8481a496d08667f$var$baseGet;


var $3df45213ea6498a6$exports = {};
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $3df45213ea6498a6$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    start = start == null ? 0 : +start || 0;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end === undefined || end > length ? length : +end || 0;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$3df45213ea6498a6$exports = $3df45213ea6498a6$var$baseSlice;


var $9c1721fd5597e5c0$exports = {};
/**
 * lodash 3.8.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $0611481e9234e9f1$exports = {};
/**
 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $0611481e9234e9f1$var$arrayTag = '[object Array]', $0611481e9234e9f1$var$funcTag = '[object Function]';
/** Used to detect host constructors (Safari > 5). */ var $0611481e9234e9f1$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */ function $0611481e9234e9f1$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/** Used for native method references. */ var $0611481e9234e9f1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0611481e9234e9f1$var$fnToString = Function.prototype.toString;
/** Used to check objects for own properties. */ var $0611481e9234e9f1$var$hasOwnProperty = $0611481e9234e9f1$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0611481e9234e9f1$var$objToString = $0611481e9234e9f1$var$objectProto.toString;
/** Used to detect if a method is native. */ var $0611481e9234e9f1$var$reIsNative = RegExp('^' + $0611481e9234e9f1$var$fnToString.call($0611481e9234e9f1$var$hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/* Native method references for those with the same name as other `lodash` methods. */ var $0611481e9234e9f1$var$nativeIsArray = $0611481e9234e9f1$var$getNative(Array, 'isArray');
/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */ var $0611481e9234e9f1$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $0611481e9234e9f1$var$getNative(object, key) {
    var value = object == null ? undefined : object[key];
    return $0611481e9234e9f1$var$isNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */ function $0611481e9234e9f1$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $0611481e9234e9f1$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */ var $0611481e9234e9f1$var$isArray = $0611481e9234e9f1$var$nativeIsArray || function(value) {
    return $0611481e9234e9f1$var$isObjectLike(value) && $0611481e9234e9f1$var$isLength(value.length) && $0611481e9234e9f1$var$objToString.call(value) == $0611481e9234e9f1$var$arrayTag;
};
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $0611481e9234e9f1$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in older versions of Chrome and Safari which return 'function' for regexes
    // and Safari 8 equivalents which return 'object' for typed array constructors.
    return $0611481e9234e9f1$var$isObject(value) && $0611481e9234e9f1$var$objToString.call(value) == $0611481e9234e9f1$var$funcTag;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $0611481e9234e9f1$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */ function $0611481e9234e9f1$var$isNative(value) {
    if (value == null) return false;
    if ($0611481e9234e9f1$var$isFunction(value)) return $0611481e9234e9f1$var$reIsNative.test($0611481e9234e9f1$var$fnToString.call(value));
    return $0611481e9234e9f1$var$isObjectLike(value) && $0611481e9234e9f1$var$reIsHostCtor.test(value);
}
$0611481e9234e9f1$exports = $0611481e9234e9f1$var$isArray;


/** Used to match property names within property paths. */ var $9c1721fd5597e5c0$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
/** Used to match backslashes in property paths. */ var $9c1721fd5597e5c0$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `value` to a string if it's not one. An empty string is returned
 * for `null` or `undefined` values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $9c1721fd5597e5c0$var$baseToString(value) {
    return value == null ? '' : value + '';
}
/**
 * Converts `value` to property path array if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Array} Returns the property path array.
 */ function $9c1721fd5597e5c0$var$toPath(value) {
    if ($0611481e9234e9f1$exports(value)) return value;
    var result = [];
    $9c1721fd5597e5c0$var$baseToString(value).replace($9c1721fd5597e5c0$var$rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace($9c1721fd5597e5c0$var$reEscapeChar, '$1') : number || match);
    });
    return result;
}
$9c1721fd5597e5c0$exports = $9c1721fd5597e5c0$var$toPath;



var $b1c4987e2902b373$exports = {};
/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $b1c4987e2902b373$var$funcTag = '[object Function]', $b1c4987e2902b373$var$genTag = '[object GeneratorFunction]';
/** Used for built-in method references. */ var $b1c4987e2902b373$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b1c4987e2902b373$var$objectToString = $b1c4987e2902b373$var$objectProto.toString;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $b1c4987e2902b373$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8 which returns 'object' for typed array constructors, and
    // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
    var tag = $b1c4987e2902b373$var$isObject(value) ? $b1c4987e2902b373$var$objectToString.call(value) : '';
    return tag == $b1c4987e2902b373$var$funcTag || tag == $b1c4987e2902b373$var$genTag;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b1c4987e2902b373$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
$b1c4987e2902b373$exports = $b1c4987e2902b373$var$isFunction;


/** Used to match property names within property paths. */ var $fbb00ea283c7a5e0$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/, $fbb00ea283c7a5e0$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $fbb00ea283c7a5e0$var$isKey(value, object) {
    var type = typeof value;
    if (type == 'string' && $fbb00ea283c7a5e0$var$reIsPlainProp.test(value) || type == 'number') return true;
    if ($0611481e9234e9f1$exports(value)) return false;
    var result = !$fbb00ea283c7a5e0$var$reIsDeepProp.test(value);
    return result || object != null && value in $fbb00ea283c7a5e0$var$toObject(object);
}
/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */ function $fbb00ea283c7a5e0$var$toObject(value) {
    return $fbb00ea283c7a5e0$var$isObject(value) ? value : Object(value);
}
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $fbb00ea283c7a5e0$var$last(array) {
    var length = array ? array.length : 0;
    return length ? array[length - 1] : undefined;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $fbb00ea283c7a5e0$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * This method is like `_.get` except that if the resolved value is a function
 * it is invoked with the `this` binding of its parent object and its result
 * is returned.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a.b.c', 'default');
 * // => 'default'
 *
 * _.result(object, 'a.b.c', _.constant('default'));
 * // => 'default'
 */ function $fbb00ea283c7a5e0$var$result(object, path, defaultValue) {
    var result = object == null ? undefined : object[path];
    if (result === undefined) {
        if (object != null && !$fbb00ea283c7a5e0$var$isKey(path, object)) {
            path = $9c1721fd5597e5c0$exports(path);
            object = path.length == 1 ? object : $e8481a496d08667f$exports(object, $3df45213ea6498a6$exports(path, 0, -1));
            result = object == null ? undefined : object[$fbb00ea283c7a5e0$var$last(path)];
        }
        result = result === undefined ? defaultValue : result;
    }
    return $b1c4987e2902b373$exports(result) ? result.call(object) : result;
}
$fbb00ea283c7a5e0$exports = $fbb00ea283c7a5e0$var$result;


var $a2ad38c1cf728df8$exports = {};
/**
 * lodash 3.3.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $a89d1045ab8dc89f$exports = {};
/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $a89d1045ab8dc89f$var$arrayCopy(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$a89d1045ab8dc89f$exports = $a89d1045ab8dc89f$var$arrayCopy;


var $71ccf38adc301a4e$exports = {};
/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A specialized version of `_.forEach` for arrays without support for callback
 * shorthands or `this` binding.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $71ccf38adc301a4e$var$arrayEach(array, iteratee) {
    var index = -1, length = array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$71ccf38adc301a4e$exports = $71ccf38adc301a4e$var$arrayEach;


var $beeeca3f1d16ff15$exports = {};
/**
 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $95f97bcd9fa9c4c5$exports = {};
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A specialized version of `baseCallback` which only supports `this` binding
 * and specifying the number of arguments to provide to `func`.
 *
 * @private
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {number} [argCount] The number of arguments to provide to `func`.
 * @returns {Function} Returns the callback.
 */ function $95f97bcd9fa9c4c5$var$bindCallback(func, thisArg, argCount) {
    if (typeof func != 'function') return $95f97bcd9fa9c4c5$var$identity;
    if (thisArg === undefined) return func;
    switch(argCount){
        case 1:
            return function(value) {
                return func.call(thisArg, value);
            };
        case 3:
            return function(value, index, collection) {
                return func.call(thisArg, value, index, collection);
            };
        case 4:
            return function(accumulator, value, index, collection) {
                return func.call(thisArg, accumulator, value, index, collection);
            };
        case 5:
            return function(value, other, key, object, source) {
                return func.call(thisArg, value, other, key, object, source);
            };
    }
    return function() {
        return func.apply(thisArg, arguments);
    };
}
/**
 * This method returns the first argument provided to it.
 *
 * @static
 * @memberOf _
 * @category Utility
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.identity(object) === object;
 * // => true
 */ function $95f97bcd9fa9c4c5$var$identity(value) {
    return value;
}
$95f97bcd9fa9c4c5$exports = $95f97bcd9fa9c4c5$var$bindCallback;


var $21a4e6d4959e41f7$exports = {};
/**
 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** Used to detect unsigned integer values. */ var $21a4e6d4959e41f7$var$reIsUint = /^\d+$/;
/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */ var $21a4e6d4959e41f7$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */ function $21a4e6d4959e41f7$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */ var $21a4e6d4959e41f7$var$getLength = $21a4e6d4959e41f7$var$baseProperty('length');
/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */ function $21a4e6d4959e41f7$var$isArrayLike(value) {
    return value != null && $21a4e6d4959e41f7$var$isLength($21a4e6d4959e41f7$var$getLength(value));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $21a4e6d4959e41f7$var$isIndex(value, length) {
    value = typeof value == 'number' || $21a4e6d4959e41f7$var$reIsUint.test(value) ? +value : -1;
    length = length == null ? $21a4e6d4959e41f7$var$MAX_SAFE_INTEGER : length;
    return value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if the provided arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
 */ function $21a4e6d4959e41f7$var$isIterateeCall(value, index, object) {
    if (!$21a4e6d4959e41f7$var$isObject(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $21a4e6d4959e41f7$var$isArrayLike(object) && $21a4e6d4959e41f7$var$isIndex(index, object.length) : type == 'string' && index in object) {
        var other = object[index];
        return value === value ? value === other : other !== other;
    }
    return false;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */ function $21a4e6d4959e41f7$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $21a4e6d4959e41f7$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $21a4e6d4959e41f7$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
$21a4e6d4959e41f7$exports = $21a4e6d4959e41f7$var$isIterateeCall;


var $7b6ba76c8e13c5cd$exports = {};
/**
 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $7b6ba76c8e13c5cd$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Native method references for those with the same name as other `lodash` methods. */ var $7b6ba76c8e13c5cd$var$nativeMax = Math.max;
/**
 * Creates a function that invokes `func` with the `this` binding of the
 * created function and arguments from `start` and beyond provided as an array.
 *
 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
 *
 * @static
 * @memberOf _
 * @category Function
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var say = _.restParam(function(what, names) {
 *   return what + ' ' + _.initial(names).join(', ') +
 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
 * });
 *
 * say('hello', 'fred', 'barney', 'pebbles');
 * // => 'hello fred, barney, & pebbles'
 */ function $7b6ba76c8e13c5cd$var$restParam(func, start) {
    if (typeof func != 'function') throw new TypeError($7b6ba76c8e13c5cd$var$FUNC_ERROR_TEXT);
    start = $7b6ba76c8e13c5cd$var$nativeMax(start === undefined ? func.length - 1 : +start || 0, 0);
    return function() {
        var args = arguments, index = -1, length = $7b6ba76c8e13c5cd$var$nativeMax(args.length - start, 0), rest = Array(length);
        while(++index < length)rest[index] = args[start + index];
        switch(start){
            case 0:
                return func.call(this, rest);
            case 1:
                return func.call(this, args[0], rest);
            case 2:
                return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
    };
}
$7b6ba76c8e13c5cd$exports = $7b6ba76c8e13c5cd$var$restParam;


/**
 * Creates a function that assigns properties of source object(s) to a given
 * destination object.
 *
 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $beeeca3f1d16ff15$var$createAssigner(assigner) {
    return $7b6ba76c8e13c5cd$exports(function(object, sources) {
        var index = -1, length = object == null ? 0 : sources.length, customizer = length > 2 ? sources[length - 2] : undefined, guard = length > 2 ? sources[2] : undefined, thisArg = length > 1 ? sources[length - 1] : undefined;
        if (typeof customizer == 'function') {
            customizer = $95f97bcd9fa9c4c5$exports(customizer, thisArg, 5);
            length -= 2;
        } else {
            customizer = typeof thisArg == 'function' ? thisArg : undefined;
            length -= customizer ? 1 : 0;
        }
        if (guard && $21a4e6d4959e41f7$exports(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, customizer);
        }
        return object;
    });
}
$beeeca3f1d16ff15$exports = $beeeca3f1d16ff15$var$createAssigner;


var $cd44055f04d62b68$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $cd44055f04d62b68$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $cd44055f04d62b68$var$argsTag = '[object Arguments]', $cd44055f04d62b68$var$funcTag = '[object Function]', $cd44055f04d62b68$var$genTag = '[object GeneratorFunction]';
/** Used for built-in method references. */ var $cd44055f04d62b68$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cd44055f04d62b68$var$hasOwnProperty = $cd44055f04d62b68$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cd44055f04d62b68$var$objectToString = $cd44055f04d62b68$var$objectProto.toString;
/** Built-in value references. */ var $cd44055f04d62b68$var$propertyIsEnumerable = $cd44055f04d62b68$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $cd44055f04d62b68$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $cd44055f04d62b68$var$isArrayLikeObject(value) && $cd44055f04d62b68$var$hasOwnProperty.call(value, 'callee') && (!$cd44055f04d62b68$var$propertyIsEnumerable.call(value, 'callee') || $cd44055f04d62b68$var$objectToString.call(value) == $cd44055f04d62b68$var$argsTag);
}
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $cd44055f04d62b68$var$isArrayLike(value) {
    return value != null && $cd44055f04d62b68$var$isLength(value.length) && !$cd44055f04d62b68$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $cd44055f04d62b68$var$isArrayLikeObject(value) {
    return $cd44055f04d62b68$var$isObjectLike(value) && $cd44055f04d62b68$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $cd44055f04d62b68$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $cd44055f04d62b68$var$isObject(value) ? $cd44055f04d62b68$var$objectToString.call(value) : '';
    return tag == $cd44055f04d62b68$var$funcTag || tag == $cd44055f04d62b68$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $cd44055f04d62b68$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $cd44055f04d62b68$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cd44055f04d62b68$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $cd44055f04d62b68$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
$cd44055f04d62b68$exports = $cd44055f04d62b68$var$isArguments;



var $dd9fd9f3ea1f69ba$exports = {};
/**
 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $862fb07b5e727e2b$exports = {};
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $862fb07b5e727e2b$var$baseFor = $862fb07b5e727e2b$var$createBaseFor();
/**
 * Creates a base function for methods like `_.forIn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $862fb07b5e727e2b$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$862fb07b5e727e2b$exports = $862fb07b5e727e2b$var$baseFor;



var $8d9a6dadfc067bbf$exports = {};
/**
 * lodash 3.0.8 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ 

/** Used to detect unsigned integer values. */ var $8d9a6dadfc067bbf$var$reIsUint = /^\d+$/;
/** Used for native method references. */ var $8d9a6dadfc067bbf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8d9a6dadfc067bbf$var$hasOwnProperty = $8d9a6dadfc067bbf$var$objectProto.hasOwnProperty;
/**
 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
 * of an array-like value.
 */ var $8d9a6dadfc067bbf$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $8d9a6dadfc067bbf$var$isIndex(value, length) {
    value = typeof value == 'number' || $8d9a6dadfc067bbf$var$reIsUint.test(value) ? +value : -1;
    length = length == null ? $8d9a6dadfc067bbf$var$MAX_SAFE_INTEGER : length;
    return value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */ function $8d9a6dadfc067bbf$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $8d9a6dadfc067bbf$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $8d9a6dadfc067bbf$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8d9a6dadfc067bbf$var$keysIn(object) {
    if (object == null) return [];
    if (!$8d9a6dadfc067bbf$var$isObject(object)) object = Object(object);
    var length = object.length;
    length = length && $8d9a6dadfc067bbf$var$isLength(length) && ($0611481e9234e9f1$exports(object) || $cd44055f04d62b68$exports(object)) && length || 0;
    var Ctor = object.constructor, index = -1, isProto = typeof Ctor == 'function' && Ctor.prototype === object, result = Array(length), skipIndexes = length > 0;
    while(++index < length)result[index] = index + '';
    for(var key in object)if (!(skipIndexes && $8d9a6dadfc067bbf$var$isIndex(key, length)) && !(key == 'constructor' && (isProto || !$8d9a6dadfc067bbf$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$8d9a6dadfc067bbf$exports = $8d9a6dadfc067bbf$var$keysIn;


/** `Object#toString` result references. */ var $dd9fd9f3ea1f69ba$var$objectTag = '[object Object]';
/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */ function $dd9fd9f3ea1f69ba$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/** Used for native method references. */ var $dd9fd9f3ea1f69ba$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dd9fd9f3ea1f69ba$var$hasOwnProperty = $dd9fd9f3ea1f69ba$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dd9fd9f3ea1f69ba$var$objToString = $dd9fd9f3ea1f69ba$var$objectProto.toString;
/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $dd9fd9f3ea1f69ba$var$baseForIn(object, iteratee) {
    return $862fb07b5e727e2b$exports(object, iteratee, $8d9a6dadfc067bbf$exports);
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * **Note:** This method assumes objects created by the `Object` constructor
 * have no inherited enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $dd9fd9f3ea1f69ba$var$isPlainObject(value) {
    var Ctor;
    // Exit early for non `Object` objects.
    if (!($dd9fd9f3ea1f69ba$var$isObjectLike(value) && $dd9fd9f3ea1f69ba$var$objToString.call(value) == $dd9fd9f3ea1f69ba$var$objectTag && !$cd44055f04d62b68$exports(value)) || !$dd9fd9f3ea1f69ba$var$hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor))) return false;
    // IE < 9 iterates inherited properties before own properties. If the first
    // iterated property is an object's own property then there are no inherited
    // enumerable properties.
    var result;
    // In most environments an object's own properties are iterated before
    // its inherited properties. If the last iterated property is an object's
    // own property then there are no inherited enumerable properties.
    $dd9fd9f3ea1f69ba$var$baseForIn(value, function(subValue, key) {
        result = key;
    });
    return result === undefined || $dd9fd9f3ea1f69ba$var$hasOwnProperty.call(value, result);
}
$dd9fd9f3ea1f69ba$exports = $dd9fd9f3ea1f69ba$var$isPlainObject;


var $df4404c8574c64cc$exports = {};
/**
 * lodash 3.0.6 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $df4404c8574c64cc$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $df4404c8574c64cc$var$argsTag = '[object Arguments]', $df4404c8574c64cc$var$arrayTag = '[object Array]', $df4404c8574c64cc$var$boolTag = '[object Boolean]', $df4404c8574c64cc$var$dateTag = '[object Date]', $df4404c8574c64cc$var$errorTag = '[object Error]', $df4404c8574c64cc$var$funcTag = '[object Function]', $df4404c8574c64cc$var$mapTag = '[object Map]', $df4404c8574c64cc$var$numberTag = '[object Number]', $df4404c8574c64cc$var$objectTag = '[object Object]', $df4404c8574c64cc$var$regexpTag = '[object RegExp]', $df4404c8574c64cc$var$setTag = '[object Set]', $df4404c8574c64cc$var$stringTag = '[object String]', $df4404c8574c64cc$var$weakMapTag = '[object WeakMap]';
var $df4404c8574c64cc$var$arrayBufferTag = '[object ArrayBuffer]', $df4404c8574c64cc$var$dataViewTag = '[object DataView]', $df4404c8574c64cc$var$float32Tag = '[object Float32Array]', $df4404c8574c64cc$var$float64Tag = '[object Float64Array]', $df4404c8574c64cc$var$int8Tag = '[object Int8Array]', $df4404c8574c64cc$var$int16Tag = '[object Int16Array]', $df4404c8574c64cc$var$int32Tag = '[object Int32Array]', $df4404c8574c64cc$var$uint8Tag = '[object Uint8Array]', $df4404c8574c64cc$var$uint8ClampedTag = '[object Uint8ClampedArray]', $df4404c8574c64cc$var$uint16Tag = '[object Uint16Array]', $df4404c8574c64cc$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $df4404c8574c64cc$var$typedArrayTags = {};
$df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$float32Tag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$float64Tag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$int8Tag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$int16Tag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$int32Tag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$uint8Tag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$uint8ClampedTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$uint16Tag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$uint32Tag] = true;
$df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$argsTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$arrayTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$arrayBufferTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$boolTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$dataViewTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$dateTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$errorTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$funcTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$mapTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$numberTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$objectTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$regexpTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$setTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$stringTag] = $df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$weakMapTag] = false;
/** Used for built-in method references. */ var $df4404c8574c64cc$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $df4404c8574c64cc$var$objectToString = $df4404c8574c64cc$var$objectProto.toString;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length,
 *  else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $df4404c8574c64cc$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $df4404c8574c64cc$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $df4404c8574c64cc$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified,
 *  else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ function $df4404c8574c64cc$var$isTypedArray(value) {
    return $df4404c8574c64cc$var$isObjectLike(value) && $df4404c8574c64cc$var$isLength(value.length) && !!$df4404c8574c64cc$var$typedArrayTags[$df4404c8574c64cc$var$objectToString.call(value)];
}
$df4404c8574c64cc$exports = $df4404c8574c64cc$var$isTypedArray;


var $8b5e112983c46a2f$exports = {};
/**
 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $61fec335b57f4fa4$exports = {};
/**
 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $61fec335b57f4fa4$var$funcTag = '[object Function]';
/** Used to detect host constructors (Safari > 5). */ var $61fec335b57f4fa4$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */ function $61fec335b57f4fa4$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/** Used for native method references. */ var $61fec335b57f4fa4$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $61fec335b57f4fa4$var$fnToString = Function.prototype.toString;
/** Used to check objects for own properties. */ var $61fec335b57f4fa4$var$hasOwnProperty = $61fec335b57f4fa4$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $61fec335b57f4fa4$var$objToString = $61fec335b57f4fa4$var$objectProto.toString;
/** Used to detect if a method is native. */ var $61fec335b57f4fa4$var$reIsNative = RegExp('^' + $61fec335b57f4fa4$var$fnToString.call($61fec335b57f4fa4$var$hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $61fec335b57f4fa4$var$getNative(object, key) {
    var value = object == null ? undefined : object[key];
    return $61fec335b57f4fa4$var$isNative(value) ? value : undefined;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $61fec335b57f4fa4$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in older versions of Chrome and Safari which return 'function' for regexes
    // and Safari 8 equivalents which return 'object' for typed array constructors.
    return $61fec335b57f4fa4$var$isObject(value) && $61fec335b57f4fa4$var$objToString.call(value) == $61fec335b57f4fa4$var$funcTag;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $61fec335b57f4fa4$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */ function $61fec335b57f4fa4$var$isNative(value) {
    if (value == null) return false;
    if ($61fec335b57f4fa4$var$isFunction(value)) return $61fec335b57f4fa4$var$reIsNative.test($61fec335b57f4fa4$var$fnToString.call(value));
    return $61fec335b57f4fa4$var$isObjectLike(value) && $61fec335b57f4fa4$var$reIsHostCtor.test(value);
}
$61fec335b57f4fa4$exports = $61fec335b57f4fa4$var$getNative;




/** Used to detect unsigned integer values. */ var $8b5e112983c46a2f$var$reIsUint = /^\d+$/;
/** Used for native method references. */ var $8b5e112983c46a2f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8b5e112983c46a2f$var$hasOwnProperty = $8b5e112983c46a2f$var$objectProto.hasOwnProperty;
/* Native method references for those with the same name as other `lodash` methods. */ var $8b5e112983c46a2f$var$nativeKeys = $61fec335b57f4fa4$exports(Object, 'keys');
/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */ var $8b5e112983c46a2f$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */ function $8b5e112983c46a2f$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */ var $8b5e112983c46a2f$var$getLength = $8b5e112983c46a2f$var$baseProperty('length');
/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */ function $8b5e112983c46a2f$var$isArrayLike(value) {
    return value != null && $8b5e112983c46a2f$var$isLength($8b5e112983c46a2f$var$getLength(value));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $8b5e112983c46a2f$var$isIndex(value, length) {
    value = typeof value == 'number' || $8b5e112983c46a2f$var$reIsUint.test(value) ? +value : -1;
    length = length == null ? $8b5e112983c46a2f$var$MAX_SAFE_INTEGER : length;
    return value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */ function $8b5e112983c46a2f$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $8b5e112983c46a2f$var$MAX_SAFE_INTEGER;
}
/**
 * A fallback implementation of `Object.keys` which creates an array of the
 * own enumerable property names of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8b5e112983c46a2f$var$shimKeys(object) {
    var props = $8b5e112983c46a2f$var$keysIn(object), propsLength = props.length, length = propsLength && object.length;
    var allowIndexes = !!length && $8b5e112983c46a2f$var$isLength(length) && ($0611481e9234e9f1$exports(object) || $cd44055f04d62b68$exports(object));
    var index = -1, result = [];
    while(++index < propsLength){
        var key = props[index];
        if (allowIndexes && $8b5e112983c46a2f$var$isIndex(key, length) || $8b5e112983c46a2f$var$hasOwnProperty.call(object, key)) result.push(key);
    }
    return result;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $8b5e112983c46a2f$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ var $8b5e112983c46a2f$var$keys = !$8b5e112983c46a2f$var$nativeKeys ? $8b5e112983c46a2f$var$shimKeys : function(object) {
    var Ctor = object == null ? undefined : object.constructor;
    if (typeof Ctor == 'function' && Ctor.prototype === object || typeof object != 'function' && $8b5e112983c46a2f$var$isArrayLike(object)) return $8b5e112983c46a2f$var$shimKeys(object);
    return $8b5e112983c46a2f$var$isObject(object) ? $8b5e112983c46a2f$var$nativeKeys(object) : [];
};
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8b5e112983c46a2f$var$keysIn(object) {
    if (object == null) return [];
    if (!$8b5e112983c46a2f$var$isObject(object)) object = Object(object);
    var length = object.length;
    length = length && $8b5e112983c46a2f$var$isLength(length) && ($0611481e9234e9f1$exports(object) || $cd44055f04d62b68$exports(object)) && length || 0;
    var Ctor = object.constructor, index = -1, isProto = typeof Ctor == 'function' && Ctor.prototype === object, result = Array(length), skipIndexes = length > 0;
    while(++index < length)result[index] = index + '';
    for(var key in object)if (!(skipIndexes && $8b5e112983c46a2f$var$isIndex(key, length)) && !(key == 'constructor' && (isProto || !$8b5e112983c46a2f$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$8b5e112983c46a2f$exports = $8b5e112983c46a2f$var$keys;


var $7d1b3d7e1e30ec2a$exports = {};
/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $b0bdef0902d65b48$exports = {};
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property names to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @returns {Object} Returns `object`.
 */ function $b0bdef0902d65b48$var$baseCopy(source, props, object) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        object[key] = source[key];
    }
    return object;
}
$b0bdef0902d65b48$exports = $b0bdef0902d65b48$var$baseCopy;



/**
 * Converts `value` to a plain object flattening inherited enumerable
 * properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $7d1b3d7e1e30ec2a$var$toPlainObject(value) {
    return $b0bdef0902d65b48$exports(value, $8d9a6dadfc067bbf$exports(value));
}
$7d1b3d7e1e30ec2a$exports = $7d1b3d7e1e30ec2a$var$toPlainObject;


/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */ function $a2ad38c1cf728df8$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */ var $a2ad38c1cf728df8$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * The base implementation of `_.merge` without support for argument juggling,
 * multiple sources, and `this` binding `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Array} [stackA=[]] Tracks traversed source objects.
 * @param {Array} [stackB=[]] Associates values with source counterparts.
 * @returns {Object} Returns `object`.
 */ function $a2ad38c1cf728df8$var$baseMerge(object, source, customizer, stackA, stackB) {
    if (!$a2ad38c1cf728df8$var$isObject(object)) return object;
    var isSrcArr = $a2ad38c1cf728df8$var$isArrayLike(source) && ($0611481e9234e9f1$exports(source) || $df4404c8574c64cc$exports(source)), props = isSrcArr ? undefined : $8b5e112983c46a2f$exports(source);
    $71ccf38adc301a4e$exports(props || source, function(srcValue, key) {
        if (props) {
            key = srcValue;
            srcValue = source[key];
        }
        if ($a2ad38c1cf728df8$var$isObjectLike(srcValue)) {
            stackA || (stackA = []);
            stackB || (stackB = []);
            $a2ad38c1cf728df8$var$baseMergeDeep(object, source, key, $a2ad38c1cf728df8$var$baseMerge, customizer, stackA, stackB);
        } else {
            var value = object[key], result = customizer ? customizer(value, srcValue, key, object, source) : undefined, isCommon = result === undefined;
            if (isCommon) result = srcValue;
            if ((result !== undefined || isSrcArr && !(key in object)) && (isCommon || (result === result ? result !== value : value === value))) object[key] = result;
        }
    });
    return object;
}
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Array} [stackA=[]] Tracks traversed source objects.
 * @param {Array} [stackB=[]] Associates values with source counterparts.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a2ad38c1cf728df8$var$baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
    var length = stackA.length, srcValue = source[key];
    while(length--)if (stackA[length] == srcValue) {
        object[key] = stackB[length];
        return;
    }
    var value = object[key], result = customizer ? customizer(value, srcValue, key, object, source) : undefined, isCommon = result === undefined;
    if (isCommon) {
        result = srcValue;
        if ($a2ad38c1cf728df8$var$isArrayLike(srcValue) && ($0611481e9234e9f1$exports(srcValue) || $df4404c8574c64cc$exports(srcValue))) result = $0611481e9234e9f1$exports(value) ? value : $a2ad38c1cf728df8$var$isArrayLike(value) ? $a89d1045ab8dc89f$exports(value) : [];
        else if ($dd9fd9f3ea1f69ba$exports(srcValue) || $cd44055f04d62b68$exports(srcValue)) result = $cd44055f04d62b68$exports(value) ? $7d1b3d7e1e30ec2a$exports(value) : $dd9fd9f3ea1f69ba$exports(value) ? value : {};
        else isCommon = false;
    }
    // Add the source value to the stack of traversed objects and associate
    // it with its merged value.
    stackA.push(srcValue);
    stackB.push(result);
    if (isCommon) // Recursively merge objects and arrays (susceptible to call stack limits).
    object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
    else if (result === result ? result !== value : value === value) object[key] = result;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */ function $a2ad38c1cf728df8$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */ var $a2ad38c1cf728df8$var$getLength = $a2ad38c1cf728df8$var$baseProperty('length');
/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */ function $a2ad38c1cf728df8$var$isArrayLike(value) {
    return value != null && $a2ad38c1cf728df8$var$isLength($a2ad38c1cf728df8$var$getLength(value));
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */ function $a2ad38c1cf728df8$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $a2ad38c1cf728df8$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $a2ad38c1cf728df8$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Recursively merges own enumerable properties of the source object(s), that
 * don't resolve to `undefined` into the destination object. Subsequent sources
 * overwrite property assignments of previous sources. If `customizer` is
 * provided it is invoked to produce the merged values of the destination and
 * source properties. If `customizer` returns `undefined` merging is handled
 * by the method instead. The `customizer` is bound to `thisArg` and invoked
 * with five arguments: (objectValue, sourceValue, key, object, source).
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {*} [thisArg] The `this` binding of `customizer`.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var users = {
 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
 * };
 *
 * var ages = {
 *   'data': [{ 'age': 36 }, { 'age': 40 }]
 * };
 *
 * _.merge(users, ages);
 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
 *
 * // using a customizer callback
 * var object = {
 *   'fruits': ['apple'],
 *   'vegetables': ['beet']
 * };
 *
 * var other = {
 *   'fruits': ['banana'],
 *   'vegetables': ['carrot']
 * };
 *
 * _.merge(object, other, function(a, b) {
 *   if (_.isArray(a)) {
 *     return a.concat(b);
 *   }
 * });
 * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
 */ var $a2ad38c1cf728df8$var$merge = $beeeca3f1d16ff15$exports($a2ad38c1cf728df8$var$baseMerge);
$a2ad38c1cf728df8$exports = $a2ad38c1cf728df8$var$merge;


var $ea67b08bc435fd34$exports = {};
/**
 * lodash 3.1.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ var $1a1b04e9f429c236$exports = {};
/**
 * lodash 3.1.4 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ 

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */ function $1a1b04e9f429c236$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */ var $1a1b04e9f429c236$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $1a1b04e9f429c236$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * The base implementation of `_.flatten` with added support for restricting
 * flattening and specifying the start index.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {boolean} [isDeep] Specify a deep flatten.
 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $1a1b04e9f429c236$var$baseFlatten(array, isDeep, isStrict, result) {
    result || (result = []);
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index];
        if ($1a1b04e9f429c236$var$isObjectLike(value) && $1a1b04e9f429c236$var$isArrayLike(value) && (isStrict || $0611481e9234e9f1$exports(value) || $cd44055f04d62b68$exports(value))) {
            if (isDeep) // Recursively flatten arrays (susceptible to call stack limits).
            $1a1b04e9f429c236$var$baseFlatten(value, isDeep, isStrict, result);
            else $1a1b04e9f429c236$var$arrayPush(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */ function $1a1b04e9f429c236$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */ var $1a1b04e9f429c236$var$getLength = $1a1b04e9f429c236$var$baseProperty('length');
/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */ function $1a1b04e9f429c236$var$isArrayLike(value) {
    return value != null && $1a1b04e9f429c236$var$isLength($1a1b04e9f429c236$var$getLength(value));
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */ function $1a1b04e9f429c236$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $1a1b04e9f429c236$var$MAX_SAFE_INTEGER;
}
$1a1b04e9f429c236$exports = $1a1b04e9f429c236$var$baseFlatten;



var $d9601e93a4b111b2$exports = {};
/**
 * lodash 3.0.2 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A specialized version of `_.pick` which picks `object` properties specified
 * by `props`.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property names to pick.
 * @returns {Object} Returns the new object.
 */ function $d9601e93a4b111b2$var$pickByArray(object, props) {
    object = $d9601e93a4b111b2$var$toObject(object);
    var index = -1, length = props.length, result = {};
    while(++index < length){
        var key = props[index];
        if (key in object) result[key] = object[key];
    }
    return result;
}
/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */ function $d9601e93a4b111b2$var$toObject(value) {
    return $d9601e93a4b111b2$var$isObject(value) ? value : Object(value);
}
/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */ function $d9601e93a4b111b2$var$isObject(value) {
    // Avoid a V8 JIT bug in Chrome 19-20.
    // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
$d9601e93a4b111b2$exports = $d9601e93a4b111b2$var$pickByArray;


var $5a5106ce517fce7a$exports = {};
/**
 * lodash 3.0.0 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern modularize exports="npm" -o ./`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.7.0 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ 

/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $5a5106ce517fce7a$var$baseForIn(object, iteratee) {
    return $862fb07b5e727e2b$exports(object, iteratee, $8d9a6dadfc067bbf$exports);
}
/**
 * A specialized version of `_.pick` that picks `object` properties `predicate`
 * returns truthy for.
 *
 * @private
 * @param {Object} object The source object.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Object} Returns the new object.
 */ function $5a5106ce517fce7a$var$pickByCallback(object, predicate) {
    var result = {};
    $5a5106ce517fce7a$var$baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) result[key] = value;
    });
    return result;
}
$5a5106ce517fce7a$exports = $5a5106ce517fce7a$var$pickByCallback;



/**
 * Creates an object composed of the picked `object` properties. Property
 * names may be specified as individual arguments or as arrays of property
 * names. If `predicate` is provided it is invoked for each property of `object`
 * picking the properties `predicate` returns truthy for. The predicate is
 * bound to `thisArg` and invoked with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {Function|...(string|string[])} [predicate] The function invoked per
 *  iteration or property names to pick, specified as individual property
 *  names or arrays of property names.
 * @param {*} [thisArg] The `this` binding of `predicate`.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'user': 'fred', 'age': 40 };
 *
 * _.pick(object, 'user');
 * // => { 'user': 'fred' }
 *
 * _.pick(object, _.isString);
 * // => { 'user': 'fred' }
 */ var $ea67b08bc435fd34$var$pick = $7b6ba76c8e13c5cd$exports(function(object, props) {
    if (object == null) return {};
    return typeof props[0] == 'function' ? $5a5106ce517fce7a$exports(object, $95f97bcd9fa9c4c5$exports(props[0], props[1], 3)) : $d9601e93a4b111b2$exports(object, $1a1b04e9f429c236$exports(props));
});
$ea67b08bc435fd34$exports = $ea67b08bc435fd34$var$pick;


var $e4f6bbd7154a320f$exports = {};
// simple abstraction to provide consistent API
// for localStorage with support for time to live
// and time to stale settings.

var $e4f6bbd7154a320f$var$storage = typeof window !== 'undefined' && window.localStorage;
$e4f6bbd7154a320f$exports = {
    support: function() {
        return !!$e4f6bbd7154a320f$var$storage;
    },
    clear: function(key) {
        if (!$e4f6bbd7154a320f$var$storage) return;
        delete $e4f6bbd7154a320f$var$storage[key];
    },
    write: function(key, data, opts) {
        if (!$e4f6bbd7154a320f$var$storage) return;
        $e4f6bbd7154a320f$var$storage[key] = JSON.stringify({
            time: Date.now(),
            data: data
        });
    },
    read: function(key, opts) {
        if (!$e4f6bbd7154a320f$var$storage) return {
            data: null,
            stale: false
        };
        if (!opts) opts = {};
        if (!$13ac1d05927214ea$exports(opts.ttl)) opts.ttl = Infinity;
        if (!$13ac1d05927214ea$exports(opts.tts)) opts.tts = opts.ttl;
        try {
            var parsed = JSON.parse($e4f6bbd7154a320f$var$storage[key]);
            var now = Date.now();
            // if it's expired, delete it
            if (now - parsed.time > opts.ttl) {
                delete $e4f6bbd7154a320f$var$storage[key];
                return {
                    data: null,
                    stale: false
                };
            }
            // if it's stale, return it, but specify
            // that it's stale
            if (opts.tts && now - parsed.time > opts.tts) return {
                data: parsed.data,
                stale: true
            };
            // just return it
            return {
                data: parsed.data,
                stale: false
            };
        } catch (e) {
            return {
                data: null,
                stale: false
            };
        }
    }
};


$5f39f54866b377cb$exports = {
    initStorage: function(opts) {
        if (!$e4f6bbd7154a320f$exports.support()) return;
        // allow options to be passed in when configured
        if (opts) $a2ad38c1cf728df8$exports(this, $ea67b08bc435fd34$exports(opts, [
            'storageKey',
            'ttl',
            'tts'
        ]));
        if (this.storageKey == null || !$13ac1d05927214ea$exports(this.ttl)) throw Error('Must have `storageKey` and `ttl` options set');
        if (!$13ac1d05927214ea$exports(this.tts)) this.tts = this.ttl;
        this.readFromStorage();
    },
    writeToStorage: function() {
        if (!$e4f6bbd7154a320f$exports.support()) return;
        $e4f6bbd7154a320f$exports.write($fbb00ea283c7a5e0$exports(this, 'storageKey'), this.serializeToStorage());
    },
    serializeToStorage: function() {
        return this.toJSON();
    },
    parseFromStorage: function(data) {
        return data;
    },
    readFromStorage: function() {
        if (!$e4f6bbd7154a320f$exports.support()) return false;
        var retrieved = $e4f6bbd7154a320f$exports.read($fbb00ea283c7a5e0$exports(this, 'storageKey'), {
            ttl: this.ttl,
            tts: this.tts
        });
        if (!retrieved.data) {
            this.deferTrigger('empty');
            return false;
        }
        this.set(this.parseFromStorage(retrieved.data));
        if (retrieved.stale) this.deferTrigger('stale');
        return true;
    },
    deferTrigger: function(event) {
        // we do this so host object can call
        // `initStorage` before registering `stale`
        // handler (looks more sane as user)
        var self = this;
        setTimeout(function() {
            self.trigger(event);
        }, 0);
    }
};


var $e13398f725c810aa$exports = {};
function $e13398f725c810aa$var$calc(m) {
    return function(n) {
        return Math.round(n * m);
    };
}
$e13398f725c810aa$exports = {
    seconds: $e13398f725c810aa$var$calc(1e3),
    minutes: $e13398f725c810aa$var$calc(6e4),
    hours: $e13398f725c810aa$var$calc(36e5),
    days: $e13398f725c810aa$var$calc(864e5),
    weeks: $e13398f725c810aa$var$calc(6048e5),
    months: $e13398f725c810aa$var$calc(26298e5),
    years: $e13398f725c810aa$var$calc(315576e5)
};



var $a0MTb = parcelRequire("a0MTb");

var $gvQO6 = parcelRequire("gvQO6");
var $8dd5675b2fc15f09$require$logger = $gvQO6.logger;
$8dd5675b2fc15f09$exports = $d09b7d770c5b7340$exports.extend($5f39f54866b377cb$exports, {
    // cache options
    ttl: $e13398f725c810aa$exports.years(1),
    tts: $e13398f725c810aa$exports.seconds(1),
    initialize () {
        this.initStorage();
        this.on('stale empty', ()=>this.fetch({
                reset: true
            }), this);
        this.on('change sync', this.writeToStorage, this);
    },
    initStorage () {
        this.log = $8dd5675b2fc15f09$require$logger.extend(`cache:${$a0MTb(this, 'storageKey')}`);
        this.log('init', this.ttl, this.tts);
        $5f39f54866b377cb$exports.initStorage.apply(this);
    },
    serializeToStorage () {
        this.log('serialize');
        return this.toJSON();
    },
    parseFromStorage (data) {
        this.log('hit');
        return data;
    }
});



var $gvQO6 = parcelRequire("gvQO6");
var $36dc365827ae47b5$require$indexify = $gvQO6.indexify;
$36dc365827ae47b5$exports = $8dd5675b2fc15f09$exports.extend({
    url () {
        return `/api/events/${$4UX9c.me.currentEvent.slug}/products`;
    },
    model: $3c27fa7da8048484$exports,
    // cache options
    storageKey () {
        return `${$4UX9c.me.currentEvent.slug}-products`;
    },
    props: {
        filtered: [
            'boolean',
            true,
            false
        ]
    },
    initialize (data, opts = {
        cache: true
    }) {
        if (opts.cache) $8dd5675b2fc15f09$exports.prototype.initialize.apply(this);
        // listen to remote changes
        this.listenTo($4UX9c.changes, 'products', this.onChange);
    },
    onChange (change) {
        if (change.type === 'insert' || change.type === 'update') this.set(change.row, {
            remove: false
        });
        if (change.type === 'delete') this.remove(change.id);
    },
    comparator (a, b) {
        if (Number.isFinite(a.sortPosition) && Number.isFinite(b.sortPosition)) {
            const diff = a.sortPosition - b.sortPosition;
            if (diff) return diff;
        }
        if (a.name !== b.name) return a.name < b.name ? -1 : 1;
        return 0;
    },
    byName (searchTerm) {
        let term;
        if (searchTerm.toLowerCase().trim() === 'schankverlust') term = searchTerm.toLowerCase().trim();
        else term = $36dc365827ae47b5$require$indexify(searchTerm);
        // save unfiltered models for later
        if (!this.filtered) this._originalModels = this.models;
        // reset search
        if (!term) {
            this.reset(this._originalModels);
            this.filtered = false;
            return;
        }
        if (term.length < 2) return;
        // filter original models
        let filtered;
        if (term === 'schankverlust') filtered = this._originalModels.filter((product)=>product.canSpill);
        else filtered = this._originalModels.filter((product)=>product._nameIndex.indexOf(term) > -1);
        this.reset(filtered);
        this.filtered = true;
    }
});


var $95c38e113312ad56$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $95c38e113312ad56$require$tippy = $6445619a88c9e457$export$2e2bcd8739ae039;

var $4UX9c = parcelRequire("4UX9c");
var $a6cd3e4de05c0e1f$exports = {};
var $291c2c9ad289f711$exports = {};
/*$AMPERSAND_VERSION*/ 
var $dM6Pc = parcelRequire("dM6Pc");

var $86KIP = parcelRequire("86KIP");

var $62yEr = parcelRequire("62yEr");

var $a0MTb = parcelRequire("a0MTb");
$291c2c9ad289f711$exports = $dM6Pc.extend({
    session: {
        valid: [
            'boolean',
            false,
            false
        ]
    },
    derived: {
        data: {
            fn: function() {
                var res = {};
                for(var key in this._fieldViews)if (this._fieldViews.hasOwnProperty(key)) {
                    // If field name ends with '[]', don't interpret
                    // as verbose form field...
                    if (key.match(/\[\]$/)) res[key] = this._fieldViews[key].value;
                    else $86KIP(res, key, this._fieldViews[key].value);
                }
                return this.clean(res);
            },
            cache: false
        }
    },
    initialize: function(opts) {
        opts = opts || {};
        this.el = opts.el;
        this.fieldContainerEl = opts.fieldContainerEl;
        this.validCallback = opts.validCallback || this.validCallback;
        this.submitCallback = opts.submitCallback || this.submitCallback;
        this.clean = opts.clean || this.clean || function(res) {
            return res;
        };
        if (opts.model) this.model = opts.model;
        this.preventDefault = opts.preventDefault === false ? false : true;
        this.autoAppend = opts.autoAppend === false ? false : true;
        // storage for our fields
        this._fieldViews = {};
        this._fieldViewsArray = [];
        // add all our fields
        ($a0MTb(opts, 'fields') || $a0MTb(this, 'fields') || []).forEach(this.addField, this);
        if (opts.autoRender) {
            this.autoRender = opts.autoRender;
            // &-view requires this.template && this.autoRender to be truthy in
            // order to autoRender. template doesn't apply to &-form-view, but
            // we manually flip the bit to honor autoRender
            this.template = opts.template || this.template || true;
        }
        if (opts.values) this._startingValues = opts.values;
        if (this.validCallback) this.on('change:valid', function(view, validBool) {
            this.validCallback(validBool);
        });
        if (this.submitCallback) this.on('submit', this.submitCallback);
    },
    addField: function(fieldView) {
        this._fieldViews[fieldView.name] = fieldView;
        this._fieldViewsArray.push(fieldView);
        return this;
    },
    removeField: function(name, strict) {
        var field = this.getField(name, strict);
        if (field) {
            field.remove();
            delete this._fieldViews[name];
            this._fieldViewsArray.splice(this._fieldViewsArray.indexOf(field), 1);
        }
    },
    getField: function(name, strict) {
        var field = this._fieldViews[name];
        if (!field && strict) throw new ReferenceError('field name  "' + name + '" not found');
        return field;
    },
    setValues: function(data) {
        for(var name in data)if (data.hasOwnProperty(name)) this.setValue(name, data[name]);
    },
    checkValid: function() {
        this.valid = this._fieldViewsArray.every(function(field) {
            return field.valid;
        });
        return this.valid;
    },
    beforeSubmit: function() {
        this._fieldViewsArray.forEach(function(field) {
            if (field.beforeSubmit) field.beforeSubmit();
        });
    },
    update: function(field) {
        this.trigger('change:' + field.name, field);
        // if this one's good check 'em all
        if (field.valid) this.checkValid();
        else this.valid = false;
    },
    remove: function() {
        this.el.removeEventListener('submit', this.handleSubmit, false);
        this._fieldViewsArray.forEach(function(field) {
            field.remove();
        });
        return $dM6Pc.prototype.remove.call(this);
    },
    handleSubmit: function(e) {
        this.beforeSubmit();
        this.checkValid();
        if (!this.valid) {
            e.preventDefault();
            return false;
        }
        if (this.preventDefault) {
            e.preventDefault();
            this.trigger('submit', this.data);
            return false;
        }
    },
    reset: function() {
        this._fieldViewsArray.forEach(function(field) {
            if ($62yEr(field.reset)) field.reset();
        });
    },
    clear: function() {
        this._fieldViewsArray.forEach(function(field) {
            if ($62yEr(field.clear)) field.clear();
        });
    },
    render: function() {
        if (this.rendered) return;
        if (!this.el) this.el = document.createElement('form');
        if (this.autoAppend) this.fieldContainerEl = this.query(this.fieldContainerEl || '[data-hook~=field-container]') || this.el;
        this._fieldViewsArray.forEach(function renderEachField(fV) {
            this.renderField(fV, true);
        }, this);
        if (this._startingValues) {
            // setValues is ideally executed at initialize, with no persistent
            // memory consumption inside ampersand-form-view, however, some
            // fieldViews don't permit `setValue(...)` unless the field view
            // itself is rendered.  thus, cache init values into _startingValues
            // and update all values after each field is rendered
            this.setValues(this._startingValues);
            delete this._startingValues;
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.el.addEventListener('submit', this.handleSubmit, false);
        // force `change:valid` to be triggered when `valid === false` post-render,
        // despite `valid` not having changed from its default pre-render value of `false`
        this.set('valid', null, {
            silent: true
        });
        this.checkValid();
    },
    renderField: function(fieldView, renderInProgress) {
        if (!this.rendered && !renderInProgress) return this;
        fieldView.parent = this;
        fieldView.render();
        if (this.autoAppend) this.fieldContainerEl.appendChild(fieldView.el);
    },
    getValue: function(name) {
        var field = this.getField(name, true);
        return field.value;
    },
    setValue: function(name, value) {
        var field = this.getField(name, true);
        field.setValue(value);
        return this;
    },
    // deprecated
    getData: function() {
        console.warn('deprecation warning: ampersand-form-view `.getData()` replaced by `.data`');
        return this.data;
    }
});


var $0c390e1cb9c9e371$exports = {};
/*$AMPERSAND_VERSION*/ 
var $dM6Pc = parcelRequire("dM6Pc");

var $eIBca = parcelRequire("eIBca");

var $FGFq0 = parcelRequire("FGFq0");
var $0c390e1cb9c9e371$var$slice = Array.prototype.slice;
function $0c390e1cb9c9e371$var$getMatches(el, selector) {
    if (selector === '') return [
        el
    ];
    var matches = [];
    if ($FGFq0(el, selector)) matches.push(el);
    return matches.concat($0c390e1cb9c9e371$var$slice.call(el.querySelectorAll(selector)));
}
$0c390e1cb9c9e371$exports = $dM6Pc.extend({
    template: [
        '<label>',
        '<span data-hook="label"></span>',
        '<input class="form-input">',
        '<div data-hook="message-container" class="message message-below message-error">',
        '<p data-hook="message-text"></p>',
        '</div>',
        '</label>'
    ].join(''),
    bindings: {
        'name': {
            type: 'attribute',
            selector: 'input, textarea',
            name: 'name'
        },
        'tabindex': {
            type: 'attribute',
            selector: 'input, textarea',
            name: 'tabindex'
        },
        'label': [
            {
                hook: 'label'
            },
            {
                type: 'toggle',
                hook: 'label'
            }
        ],
        'message': {
            type: 'text',
            hook: 'message-text'
        },
        'showMessage': {
            type: 'toggle',
            hook: 'message-container'
        },
        'placeholder': {
            type: 'attribute',
            selector: 'input, textarea',
            name: 'placeholder'
        },
        'readonly': {
            type: 'booleanAttribute',
            name: 'readonly',
            selector: 'input, textarea'
        },
        'autofocus': {
            type: 'booleanAttribute',
            name: 'autofocus',
            selector: 'input, textarea'
        }
    },
    initialize: function(spec) {
        spec || (spec = {});
        this.tests = this.tests || spec.tests || [];
        this.on('change:type', this.handleTypeChange, this);
        this.handleChange = this.handleChange.bind(this);
        this.handleInputChanged = this.handleInputChanged.bind(this);
        var value = !spec.value && spec.value !== 0 ? '' : spec.value;
        this.startingValue = value;
        this.inputValue = value;
        this.on('change:valid change:value', this.reportToParent, this);
        this.on('change:validityClass', this.validityClassChanged, this);
        if (spec.autoRender) this.autoRender = spec.autoRender;
        if (spec.template) this.template = spec.template;
        if (spec.beforeSubmit) this.beforeSubmit = spec.beforeSubmit;
    },
    render: function() {
        this.renderWithTemplate();
        this.input = this.query('input') || this.query('textarea');
        // switches out input for textarea if that's what we want
        this.handleTypeChange();
        this.initInputBindings();
        // Skip validation on initial setValue
        // if the field is not required
        this.setValue(this.inputValue, !this.required);
        return this;
    },
    props: {
        inputValue: 'any',
        startingValue: 'any',
        name: 'string',
        type: [
            'string',
            true,
            'text'
        ],
        placeholder: [
            'string',
            true,
            ''
        ],
        label: [
            'string',
            true,
            ''
        ],
        required: [
            'boolean',
            true,
            true
        ],
        directlyEdited: [
            'boolean',
            true,
            false
        ],
        readonly: [
            'boolean',
            true,
            false
        ],
        autofocus: [
            'boolean',
            true,
            false
        ],
        shouldValidate: [
            'boolean',
            true,
            false
        ],
        message: [
            'string',
            true,
            ''
        ],
        requiredMessage: [
            'string',
            true,
            'This field is required.'
        ],
        validClass: [
            'string',
            true,
            'input-valid'
        ],
        invalidClass: [
            'string',
            true,
            'input-invalid'
        ],
        validityClassSelector: [
            'string',
            true,
            'input, textarea'
        ],
        tabindex: [
            'number',
            true,
            0
        ]
    },
    derived: {
        value: {
            deps: [
                'inputValue'
            ],
            fn: function() {
                return this.inputValue;
            }
        },
        valid: {
            cache: false,
            deps: [
                'inputValue'
            ],
            fn: function() {
                return !this.runTests();
            }
        },
        showMessage: {
            deps: [
                'message',
                'shouldValidate'
            ],
            fn: function() {
                return this.shouldValidate && this.message;
            }
        },
        changed: {
            deps: [
                'inputValue',
                'startingValue'
            ],
            fn: function() {
                return this.inputValue !== this.startingValue;
            }
        },
        validityClass: {
            deps: [
                'valid',
                'validClass',
                'invalidClass',
                'shouldValidate'
            ],
            fn: function() {
                if (!this.shouldValidate) return '';
                else return this.valid ? this.validClass : this.invalidClass;
            }
        }
    },
    setValue: function(value, skipValidation) {
        if (!this.input) {
            this.inputValue = value;
            return;
        }
        if (!value && value !== 0) this.input.value = '';
        else this.input.value = value.toString();
        this.inputValue = this.clean(this.input.value);
        if (!skipValidation && !this.getErrorMessage()) this.shouldValidate = true;
        else if (skipValidation) this.shouldValidate = false;
    },
    getErrorMessage: function() {
        var message = '';
        if (this.required && this.value === '') return this.requiredMessage;
        else {
            (this.tests || []).some(function(test) {
                message = test.call(this, this.value) || '';
                return message;
            }, this);
            return message;
        }
    },
    handleTypeChange: function() {
        if (this.type === 'textarea' && this.input.tagName.toLowerCase() !== 'textarea') {
            var parent = this.input.parentNode;
            var textarea = document.createElement('textarea');
            parent.replaceChild(textarea, this.input);
            this.input = textarea;
            this._applyBindingsForKey('');
        } else this.input.type = this.type;
    },
    clean: function(val) {
        return this.type === 'number' ? Number(val) : val.trim();
    },
    //`input` event handler
    handleInputChanged: function() {
        if (document.activeElement === this.input) this.directlyEdited = true;
        this.inputValue = this.clean(this.input.value);
    },
    //`change` event handler
    handleChange: function() {
        if (this.inputValue && this.changed) this.shouldValidate = true;
        this.runTests();
    },
    beforeSubmit: function() {
        // catch undetected input changes that were not caught due to lack of
        // browser event firing see:
        // https://github.com/AmpersandJS/ampersand-input-view/issues/2
        this.inputValue = this.clean(this.input.value);
        // at the point where we've tried
        // to submit, we want to validate
        // everything from now on.
        this.shouldValidate = true;
        this.runTests();
    },
    runTests: function() {
        var message = this.getErrorMessage();
        if (!message && this.inputValue && this.changed) // if it's ever been valid,
        // we want to validate from now
        // on.
        this.shouldValidate = true;
        this.message = message;
        return message;
    },
    initInputBindings: function() {
        this.input.addEventListener('input', this.handleInputChanged, false);
        this.input.addEventListener('change', this.handleChange, false);
    },
    remove: function() {
        this.input.removeEventListener('input', this.handleInputChanged, false);
        this.input.removeEventListener('change', this.handleChange, false);
        $dM6Pc.prototype.remove.apply(this, arguments);
    },
    reset: function() {
        this.setValue(this.startingValue, true); //Skip validation just like on initial render
    },
    clear: function() {
        this.setValue('', true);
    },
    validityClassChanged: function(view, newClass) {
        var oldClass = view.previousAttributes().validityClass;
        $0c390e1cb9c9e371$var$getMatches(this.el, this.validityClassSelector).forEach(function(match) {
            $eIBca.switchClass(match, oldClass, newClass);
        });
    },
    reportToParent: function() {
        if (this.parent) this.parent.update(this);
    }
});


var $ed2dbb7b906d1283$exports = {};
/* $AMPERSAND_VERSION */ 
var $iamNK = parcelRequire("iamNK");

var $eIBca = parcelRequire("eIBca");

var $FGFq0 = parcelRequire("FGFq0");

var $dM6Pc = parcelRequire("dM6Pc");
var $ed2dbb7b906d1283$var$createOption = function(value, text, disabled) {
    var node = document.createElement('option');
    //Set to empty-string if undefined or null, but not if 0, false, etc
    if (value === null || value === undefined) value = '';
    if (disabled) node.disabled = true;
    node.textContent = text;
    node.value = value;
    return node;
};
var $ed2dbb7b906d1283$var$createOptgroup = function(text) {
    var node = document.createElement('optgroup');
    node.label = text;
    return node;
};
$ed2dbb7b906d1283$exports = $dM6Pc.extend({
    //Replaceable with anything with label, message-container, message-text data-hooks and a <select>
    template: [
        '<label class="select">',
        '<span data-hook="label"></span>',
        '<select></select>',
        '<span data-hook="message-container" class="message message-below message-error">',
        '<p data-hook="message-text"></p>',
        '</span>',
        '</label>'
    ].join('\n'),
    initialize: function(opts) {
        opts = opts || {};
        if (typeof opts.name !== 'string') throw new Error('SelectView requires a name property.');
        this.name = opts.name;
        if (opts.groupOptions) {
            if (opts.options) throw new Error('Don\'t provide ampersand-select-view with both options and groupOptions properties, as option will be generated with values from groupOptions.');
            // Create the options array from the groupOptions property, containing
            // only the values that will result in an <option> element
            this.groupOptions = opts.groupOptions;
            opts.options = [];
            opts.groupOptions.forEach((function(optgroup) {
                optgroup.options.forEach((function(option) {
                    opts.options.push(option);
                }).bind(this));
            }).bind(this));
        }
        if (!Array.isArray(opts.options) && !opts.options.isCollection) throw new Error('SelectView requires select options.');
        this.options = opts.options;
        if (this.options.isCollection) {
            this.idAttribute = opts.idAttribute || this.options.mainIndex || 'id';
            this.textAttribute = opts.textAttribute || 'text';
            this.disabledAttribute = opts.disabledAttribute;
        }
        this.el = opts.el;
        this.label = opts.label || '';
        this.parent = opts.parent || this.parent;
        if (opts.template) this.template = opts.template;
        this.unselectedText = opts.unselectedText;
        this.startingValue = opts.value;
        this.yieldModel = opts.yieldModel === false ? false : true;
        this.tabindex = opts.tabindex || '0';
        this.eagerValidate = opts.eagerValidate;
        this.required = opts.required || false;
        this.validClass = opts.validClass || 'input-valid';
        this.invalidClass = opts.invalidClass || 'input-invalid';
        if (opts.requiredMessage === undefined) this.requiredMessage = 'Selection required';
        else this.requiredMessage = opts.requiredMessage;
        this.onChange = this.onChange.bind(this);
        this.startingValue = this.setValue(opts.value, this.eagerValidate ? false : true, true);
        if (opts.beforeSubmit) this.beforeSubmit = opts.beforeSubmit;
        if (opts.autoRender) this.autoRender = opts.autoRender;
    },
    render: function() {
        var elDom, labelEl;
        if (this.rendered) return;
        elDom = $iamNK(this.template);
        if (!this.el) this.el = elDom;
        else this.el.appendChild(elDom);
        labelEl = this.el.querySelector('[data-hook~=label]');
        if (labelEl) {
            labelEl.textContent = this.label;
            this.label = labelEl;
        } else delete this.label;
        if (this.el.tagName === 'SELECT') this.select = this.el;
        else this.select = this.el.querySelector('select');
        if (!this.select) throw new Error('no select found in template');
        if ($FGFq0(this.el, 'select')) this.select = this.el;
        if (this.select) this.select.setAttribute('name', this.name);
        if (this.select) this.select.setAttribute('tabindex', this.tabindex);
        this.bindDOMEvents();
        this.renderOptions();
        this.updateSelectedOption();
        if (this.options.isCollection) this.options.on('add remove reset', (function() {
            var setValueFirstModel = (function() {
                if (!this.options.length) return;
                if (this.yieldModel) this.setValue(this.options.models[0]);
                else this.setValue(this.options.models[0][this.idAttribute]);
            }).bind(this);
            this.renderOptions();
            if (this.hasOptionByValue(this.value)) this.updateSelectedOption();
            else setValueFirstModel();
        }).bind(this));
        this.validate(this.eagerValidate ? false : true, true);
        return this;
    },
    onChange: function() {
        var value = this.select.options[this.select.selectedIndex].value;
        if (this.options.isCollection && this.yieldModel) value = this.getModelForId(value);
        this.setValue(value);
    },
    /**
     * Finds a model in the options collection provided an ID
     * @param  {any} id
     * @return {State}
     * @throws {RangeError} If model not found
     */ getModelForId: function(id) {
        return this.options.filter((function(model) {
            // intentionally coerce for '1' == 1
            return model[this.idAttribute] == id;
        }).bind(this))[0];
    },
    bindDOMEvents: function() {
        this.select.addEventListener('change', this.onChange, false);
    },
    renderOptions: function() {
        if (!this.select) return;
        this.select.innerHTML = '';
        if (this.unselectedText !== undefined) this.select.appendChild($ed2dbb7b906d1283$var$createOption(null, this.unselectedText));
        if (this.groupOptions) this.groupOptions.forEach((function(optgroup) {
            // this.groupOptions is an array of Objects representing <optgroup> elements
            var optGroupElement = $ed2dbb7b906d1283$var$createOptgroup(optgroup.groupName);
            // Loop over the <options> from that <optgroup>
            optgroup.options.forEach((function(option) {
                // Add the <option>s to the <optgroup>
                optGroupElement.appendChild($ed2dbb7b906d1283$var$createOption(this.getOptionValue(option), this.getOptionText(option), this.getOptionDisabled(option)));
            }).bind(this));
            // Add the <optgroup> to the <select>
            this.select.appendChild(optGroupElement);
        }).bind(this));
        else this.options.forEach((function(option) {
            // Create and add the <option> to the <select>
            this.select.appendChild($ed2dbb7b906d1283$var$createOption(this.getOptionValue(option), this.getOptionText(option), this.getOptionDisabled(option)));
        }).bind(this));
    },
    /**
     * Updates the <select> control to set the select option when the option
     * has changed programatically (i.e. not through direct user selection)
     * @return {SelectView} this
     * @throws {Error} If no option exists for this.value
     */ updateSelectedOption: function() {
        var lookupValue = this.value;
        if (lookupValue === null || lookupValue === undefined || lookupValue === '') {
            if (this.unselectedText !== undefined || !this.startingValue && !this.rendered) {
                this.select.selectedIndex = 0;
                return this;
            } else if (!this.options.length && this.value === null) return this;
        }
        // Pull out the id if it's a model
        if (this.options.isCollection && this.yieldModel) lookupValue = lookupValue && lookupValue[this.idAttribute];
        if (lookupValue || lookupValue === 0 || lookupValue === null) {
            if (lookupValue === null) lookupValue = ''; // DOM sees only '' empty value
            for(var i = this.select.options.length; i--; i)if (this.select.options[i].value == lookupValue) {
                this.select.selectedIndex = i;
                return this;
            }
        }
        // failed to match any
        throw new Error('no option exists for value: ' + lookupValue);
    },
    remove: function() {
        if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
        this.el.removeEventListener('change', this.onChange, false);
    },
    /**
     * Sets control to unselectedText option, or user specified option with `null`
     * value
     * @return {SelectView} this
     */ clear: function() {
        this.setValue(null, true);
        return this;
    },
    /**
     * Sets the selected option and view value to the original option value provided
     * during construction
     * @return {SelectView} this
     */ reset: function() {
        return this.setValue(this.startingValue, true);
    },
    setValue: function(value, skipValidationMessage, init) {
        var option, model, nullValid;
        // enforce the <select> control to contain only a singular falsy
        // value (excluding 0), because browsers will set the select.value
        // in each case to be the empty string
        if (value === null || value === undefined || value === '') {
            this.value = null;
            // test if null is a valid option
            if (this.unselectedText !== undefined) nullValid = true;
            else nullValid = this.hasOptionByValue(null);
            // empty value requested to be set.  This may be because the field is just
            // initializing.  If initializing and `null` isn't in the honored option set
            // set the select to the 0-th index
            if (init && this.options.length && !nullValid) {
                // no initial value passed, set initial value to first item in set
                if (this.options.isCollection) {
                    model = this.options.models[0];
                    this.value = this.yieldModel ? model : model[this.idAttribute];
                } else if (Array.isArray(this.options[0])) this.value = this.options[0][0];
                else this.value = this.options[0];
            }
        } else {
            // Ensure corresponding option exists before assigning value
            option = this.getOptionByValue(value);
            this.value = Array.isArray(option) ? option[0] : option;
        }
        this.validate(skipValidationMessage);
        if (this.select) this.updateSelectedOption();
        if (this.parent && typeof this.parent.update === 'function') this.parent.update(this);
        return this.value;
    },
    validate: function(skipValidationMessage) {
        if (!this.required) {
            // selected option always known to be in option set,
            // thus field is always valid if not required
            this.valid = true;
            if (this.select) this.toggleMessage(skipValidationMessage);
            return this.valid;
        }
        if (this.required && !this.value && this.value !== 0) {
            this.valid = false;
            if (this.select) this.toggleMessage(skipValidationMessage, this.requiredMessage);
        } else {
            this.valid = true;
            if (this.select) this.toggleMessage(skipValidationMessage);
        }
        return this.valid;
    },
    /**
     * Called by FormView on submit
     * @return {SelectView} this
     */ beforeSubmit: function() {
        if (this.select) this.setValue(this.select.options[this.select.selectedIndex].value);
    },
    /**
     * Gets the option corresponding to provided value.
     * @param  {*} string, state, or model
     * @return {*} string, array, state, or model
     */ getOptionByValue: function(value) {
        var model;
        if (this.options.isCollection) {
            // find value in collection, error if no model found
            if (this.options.indexOf(value) === -1) model = this.getModelForId(value);
            else model = value;
            if (!model) throw new Error('model or model idAttribute not found in options collection');
            return this.yieldModel ? model : model[this.idAttribute];
        } else if (Array.isArray(this.options)) {
            // find value value in options array
            // find option, formatted [['val', 'text'], ...]
            if (this.options.length && Array.isArray(this.options[0])) for(var i = this.options.length - 1; i >= 0; i--){
                if (this.options[i][0] == value) return this.options[i];
            }
            // find option, formatted ['valAndText', ...] format
            if (this.options.length && this.options.indexOf(value) !== -1) return value;
            throw new Error('value not in set of provided options');
        }
        throw new Error('select option set invalid');
    },
    /**
     * Tests if option set has an option corresponding to the provided value
     * @param  {*} value
     * @return {Boolean}
     */ hasOptionByValue: function(value) {
        try {
            this.getOptionByValue(value);
            return true;
        } catch (err) {
            return false;
        }
    },
    getOptionValue: function(option) {
        if (Array.isArray(option)) return option[0];
        if (this.options.isCollection) return option[this.idAttribute];
        return option;
    },
    getOptionText: function(option) {
        if (Array.isArray(option)) return option[1];
        if (this.options.isCollection) {
            if (this.textAttribute && option[this.textAttribute] !== undefined) return option[this.textAttribute];
        }
        return option;
    },
    getOptionDisabled: function(option) {
        if (Array.isArray(option)) return option[2];
        if (this.options.isCollection && this.disabledAttribute) return option[this.disabledAttribute];
        return false;
    },
    toggleMessage: function(hide, message) {
        var mContainer = this.el.querySelector('[data-hook~=message-container]'), mText = this.el.querySelector('[data-hook~=message-text]');
        if (!mContainer || !mText) return;
        if (hide) {
            $eIBca.hide(mContainer);
            mText.textContent = '';
            $eIBca.removeClass(this.el, this.validClass);
            $eIBca.removeClass(this.el, this.invalidClass);
            return;
        }
        if (message) {
            $eIBca.show(mContainer);
            mText.textContent = message;
            $eIBca.addClass(this.el, this.invalidClass);
            $eIBca.removeClass(this.el, this.validClass);
        } else {
            $eIBca.hide(mContainer);
            mText.textContent = '';
            $eIBca.addClass(this.el, this.validClass);
            $eIBca.removeClass(this.el, this.invalidClass);
        }
    }
});


var $54cad1cfad6d386c$exports = {};
/*$AMPERSAND_VERSION*/ 
var $dM6Pc = parcelRequire("dM6Pc");

var $eIBca = parcelRequire("eIBca");
function $54cad1cfad6d386c$var$defaultTemplate() {
    return [
        '<label class="checkbox">',
        '<input type="checkbox"><span data-hook="label"></span>',
        '<div data-hook="message-container" class="message message-below message-error">',
        '<p data-hook="message-text"></p>',
        '</div>',
        '</label>'
    ].join('');
}
$54cad1cfad6d386c$exports = $dM6Pc.extend({
    template: $54cad1cfad6d386c$var$defaultTemplate,
    initialize: function(opts) {
        if (!opts || !opts.name) throw new Error('must pass in a name');
        // settings
        this.el = opts.el;
        this.name = opts.name;
        this.startingValue = !!opts.value;
        this.value = this.startingValue;
        this.label = opts.label || opts.name;
        this.required = typeof opts.required === 'boolean' ? opts.required : false;
        this.disabled = typeof opts.disabled === 'boolean' ? opts.disabled : false;
        this.validClass = opts.validClass || 'input-valid';
        this.invalidClass = opts.invalidClass || 'input-invalid';
        this.requiredMessage = opts.requiredMessage || 'This box must be checked.';
        this.parent = opts.parent || this.parent;
        this.autoRender = opts.autoRender;
        if (opts.template) this.template = opts.template;
        this.beforeSubmit = opts.beforeSubmit || this.beforeSubmit;
        this.setValue(this.value);
    },
    clear: function() {
        return this.setValue(false);
    },
    reset: function() {
        return this.setValue(this.startingValue);
    },
    remove: function() {
        if (this.input) this.input.removeEventListener('change', this.handleInputEvent, false);
        $dM6Pc.prototype.remove.call(this);
    },
    render: function() {
        this.renderWithTemplate(this);
        this.input = this.el.querySelector('input');
        this.labelEl = this.el.querySelector('[data-hook~=label]');
        this.messageContainer = this.el.querySelector('[data-hook~=message-container]');
        this.messageEl = this.el.querySelector('[data-hook~=message-text]');
        // bind event handlers
        this.handleInputEvent = this.handleInputEvent.bind(this);
        // add our event handlers
        this.input.addEventListener('change', this.handleInputEvent, false);
        this.setMessage(this.message);
        this.input.checked = !!this.value;
        this.input.disabled = this.disabled;
        this.input.name = this.name;
        this.labelEl.textContent = this.label;
    },
    // handle input events and show appropriate errors
    handleInputEvent: function() {
        // track whether user has edited directly
        if (document.activeElement === this.input) this.directlyEdited = true;
        this.value = this.input ? this.input.checked : this.value;
        this.test();
        if (this.parent && this.parent.update) this.parent.update(this);
    },
    // set the error message if exists
    // hides the message container entirely otherwise
    setMessage: function(message) {
        var input = this.input;
        if (!input) return;
        this.message = message;
        // there is an error
        if (message && this.shouldValidate) {
            this.messageContainer.style.display = 'block';
            this.messageEl.textContent = message;
            $eIBca.addClass(input, this.invalidClass);
            $eIBca.removeClass(input, this.validClass);
        } else {
            this.messageContainer.style.display = 'none';
            if (this.shouldValidate && this.editedDirectly) {
                $eIBca.addClass(input, this.validClass);
                $eIBca.removeClass(input, this.invalidClass);
            }
        }
    },
    setValue: function(value) {
        if (this.input) this.input.checked = !!value;
        return this.handleInputEvent();
    },
    beforeSubmit: function() {
        this.shouldValidate = true;
        return this.handleInputEvent();
    },
    test: function() {
        var valid = !this.required || !!this.value;
        if (valid) this.shouldValidate = true;
        this.valid = valid;
        if (this.shouldValidate && !valid) this.setMessage(this.requiredMessage);
        else this.setMessage('');
        return valid;
    }
});




var $d0uB5 = parcelRequire("d0uB5");
var $a6cd3e4de05c0e1f$require$packaging = $d0uB5.packaging;
const $a6cd3e4de05c0e1f$var$units = new $83a891297e5a5907$exports($a6cd3e4de05c0e1f$require$packaging, {
    where: {
        type: 'unit'
    },
    comparator: 'name'
});
const $a6cd3e4de05c0e1f$var$packages = new $83a891297e5a5907$exports($a6cd3e4de05c0e1f$require$packaging, {
    where: {
        type: 'package'
    },
    comparator: 'name'
});

const $a6cd3e4de05c0e1f$var$InputAddonView = $0c390e1cb9c9e371$exports.extend({
    props: {
        addon: [
            'string',
            true
        ],
        type: [
            'string',
            true,
            'number'
        ],
        placeholder: [
            'string',
            true,
            '0'
        ],
        requiredMessage: [
            'string',
            true,
            'Pflichtfeld.'
        ],
        validityClassSelector: [
            'string',
            true,
            'label'
        ]
    },
    template: (parcelRequire("9mgST")).default
});
const $a6cd3e4de05c0e1f$var$MoneyInputView = $a6cd3e4de05c0e1f$var$InputAddonView.extend({
    derived: {
        value: {
            deps: [
                'inputValue'
            ],
            fn () {
                return `${this.inputValue}`;
            }
        }
    }
});
function $a6cd3e4de05c0e1f$var$gtZero(val) {
    if (val <= 0) return "Muss gr\xf6\xdfer als 0 sein.";
}
$a6cd3e4de05c0e1f$exports = $291c2c9ad289f711$exports.extend({
    validCallback (valid) {
        if (!this.submitBtn) this.submitBtn = this.el.querySelector('[type=submit]');
        this.submitBtn.disabled = !valid;
    },
    fields () {
        return [
            new $0c390e1cb9c9e371$exports({
                parent: this,
                validityClassSelector: 'label',
                el: this.el.querySelector('[data-hook=name]'),
                name: 'name',
                value: this.model.name,
                label: 'Bezeichnung',
                required: true,
                requiredMessage: 'Pflichtfeld'
            }),
            new $0c390e1cb9c9e371$exports({
                parent: this,
                validityClassSelector: 'label',
                el: this.el.querySelector('[data-hook=package-size]'),
                name: 'packageSize',
                value: this.model.packageSize,
                label: 'Verpackung',
                type: 'number',
                placeholder: '0',
                required: true,
                requiredMessage: 'Pflichtfeld',
                tests: [
                    $a6cd3e4de05c0e1f$var$gtZero
                ]
            }),
            new $a6cd3e4de05c0e1f$var$InputAddonView({
                parent: this,
                el: this.el.querySelector('[data-hook=volume-per-unit]'),
                name: 'volumePerUnit',
                value: this.model.volumePerUnit,
                addon: 'l',
                label: 'Inhalt',
                tests: [
                    $a6cd3e4de05c0e1f$var$gtZero
                ]
            }),
            new $ed2dbb7b906d1283$exports({
                parent: this,
                name: 'packageId',
                label: '',
                required: true,
                el: this.el.querySelector('[data-hook=package-name]'),
                options: $a6cd3e4de05c0e1f$var$packages,
                value: this.model.packageId || $a6cd3e4de05c0e1f$var$packages.get('box'),
                idAttribute: 'id',
                textAttribute: 'name',
                disabledAttribute: 'disabled',
                yieldModel: false
            }),
            new $ed2dbb7b906d1283$exports({
                parent: this,
                name: 'unitId',
                label: '',
                required: true,
                el: this.el.querySelector('[data-hook=package-unit]'),
                options: $a6cd3e4de05c0e1f$var$units,
                value: this.model.unitId || $a6cd3e4de05c0e1f$var$units.get('bottle'),
                idAttribute: 'id',
                textAttribute: 'name',
                disabledAttribute: 'disabled',
                yieldModel: false
            }),
            new $a6cd3e4de05c0e1f$var$MoneyInputView({
                parent: this,
                el: this.el.querySelector('[data-hook=cost]'),
                name: 'cost',
                value: this.model.cost && (+this.model.cost).toFixed(2),
                label: 'Einkauf (netto)',
                addon: "\u20AC",
                tests: [
                    $a6cd3e4de05c0e1f$var$gtZero
                ]
            }),
            new $ed2dbb7b906d1283$exports({
                parent: this,
                name: 'costUnit',
                label: 'pro',
                required: true,
                el: this.el.querySelector('[data-hook=cost-unit]'),
                options: $a6cd3e4de05c0e1f$require$packaging,
                value: this.model.costUnitId || $a6cd3e4de05c0e1f$require$packaging.get('box'),
                idAttribute: 'id',
                textAttribute: 'name',
                disabledAttribute: 'disabled',
                yieldModel: true,
                beforeSubmit () {
                    this.value = this.value.type;
                }
            }),
            new $a6cd3e4de05c0e1f$var$MoneyInputView({
                parent: this,
                el: this.el.querySelector('[data-hook=price]'),
                name: 'price',
                value: this.model.price && (+this.model.price).toFixed(2),
                label: 'Verkauf (brutto)',
                addon: "\u20AC",
                tests: [
                    $a6cd3e4de05c0e1f$var$gtZero
                ]
            }),
            new $a6cd3e4de05c0e1f$var$InputAddonView({
                parent: this,
                el: this.el.querySelector('[data-hook=serving-size]'),
                name: 'servingSize',
                value: this.model.servingSize,
                label: 'pro',
                addon: 'l',
                tests: [
                    $a6cd3e4de05c0e1f$var$gtZero
                ]
            }),
            new $a6cd3e4de05c0e1f$var$InputAddonView({
                parent: this,
                el: this.el.querySelector('[data-hook=weight-full]'),
                name: 'weightFull',
                value: this.model.weightFull,
                label: 'Gewicht voll',
                addon: 'g',
                required: false
            }),
            new $a6cd3e4de05c0e1f$var$InputAddonView({
                parent: this,
                el: this.el.querySelector('[data-hook=weight-empty]'),
                name: 'weightEmpty',
                value: this.model.weightEmpty,
                label: 'Gewicht leer',
                addon: 'g',
                required: false
            }),
            new $54cad1cfad6d386c$exports({
                parent: this,
                value: this.model.canSpill || false,
                el: this.el.querySelector('[data-hook=can-spill]'),
                name: 'canSpill',
                label: 'Schankverlust einrechnen'
            }),
            new $0c390e1cb9c9e371$exports({
                parent: this,
                validityClassSelector: 'label',
                el: this.el.querySelector('[data-hook=category-name]'),
                name: 'categoryName',
                value: this.model.categoryName,
                label: 'Kategorie',
                required: false
            }),
            new $0c390e1cb9c9e371$exports({
                parent: this,
                validityClassSelector: 'label',
                el: this.el.querySelector('[data-hook=color]'),
                name: 'color',
                value: this.model.color,
                label: 'Farbe',
                type: 'text',
                required: false
            })
        ];
    }
});


const $95c38e113312ad56$var$ESC_KEY = 27;

$95c38e113312ad56$exports = $dM6Pc.extend({
    template: (parcelRequire("1LE1e")).default,
    events: {
        'keyup input': 'keyup',
        'click [data-hook=cancel]': 'onCancel',
        'focus [name=packageSize]': 'onFocusIn',
        'blur [name=packageSize]': 'onFocusOut',
        'focus [name=volumePerUnit]': 'onFocusIn',
        'blur [name=volumePerUnit]': 'onFocusOut'
    },
    derived: {
        isFirstProduct: {
            cache: false,
            fn () {
                if (!this.parent) return false;
                return this.parent.collection.length === 0;
            }
        }
    },
    initialize () {
        this.listenTo(this.model, 'sync', this.onSync);
    },
    /**
   * @param {FocusEvent} evt
   */ onFocusIn (evt) {
        if (evt.target.value) return;
        if (evt.target.name === 'packageSize') this.tooltip = $95c38e113312ad56$require$tippy(evt.target, {
            trigger: 'manuel',
            content: 'Wieviele Einheiten sind in einem Gebinde?'
        });
        if (evt.target.name === 'volumePerUnit') this.tooltip = $95c38e113312ad56$require$tippy(evt.target, {
            trigger: 'manuel',
            content: 'Wieviel Liter sind in einer Einheit?'
        });
        this.tooltip.show();
    },
    onFocusOut () {
        if (this.tooltip) this.tooltip.destroy();
    },
    onCancel () {
        this.remove();
        if (!this.model.editable && this.parent) this.parent.hasNew = false;
        this.model.editable = false;
    },
    onSync () {
        this.remove();
        // for new products reset state
        if (!this.model.editable && this.parent) {
            this.parent.hasNew = false;
            this.parent.addProduct();
        }
        this.model.editable = false;
    },
    /*
    DOM Event Handlers
   */ keyup (evt) {
        if (evt.which === $95c38e113312ad56$var$ESC_KEY) return this.onSync();
        const el = evt.target;
        // hide if the user typed something
        if (el.value && (el.name === 'packageSize' || el.name === 'volumePerUnit')) this.onFocusOut();
    },
    render () {
        this.renderWithTemplate();
        this.form = new $a6cd3e4de05c0e1f$exports({
            model: this.model,
            autoRender: true,
            autoAppend: false,
            el: this.queryByHook('add-product-form'),
            submitCallback (obj) {
                this.model.set(obj);
                // save in the global collection, so we don't have to rely on the changes feed
                $4UX9c.products.create(this.model, {
                    wait: true
                });
            }
        });
        // registering the form view as a subview
        this.registerSubview(this.form);
        // focus name field and scroll into view
        window.requestAnimationFrame(()=>{
            const form = /** @type {HTMLFormElement} */ this.el;
            form.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
            this.query('input[name=name]').focus();
        });
    }
});


var $fe9e2270b384e4c6$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $fe9e2270b384e4c6$require$tippy = $6445619a88c9e457$export$2e2bcd8739ae039;

var $4UX9c = parcelRequire("4UX9c");

var $3c03021769421268$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");
var $789b1b5a0ac36af1$exports = {};

var $iamNK = parcelRequire("iamNK");

var $4UX9c = parcelRequire("4UX9c");
const $789b1b5a0ac36af1$var$popover = {};
$789b1b5a0ac36af1$exports = $789b1b5a0ac36af1$var$popover;
function $789b1b5a0ac36af1$var$offset(box, doc) {
    const body = doc.body || doc.getElementsByTagName('body')[0];
    const docEl = doc.documentElement || body.parentNode;
    const clientTop = docEl.clientTop || body.clientTop || 0;
    const clientLeft = docEl.clientLeft || body.clientLeft || 0;
    const scrollTop = window.pageYOffset || docEl.scrollTop;
    const scrollLeft = window.pageXOffset || docEl.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
$789b1b5a0ac36af1$var$popover.render = function(opts = {
    show: true
}) {
    this.el = $iamNK(this.template(this));
    // append to the app view so we get proper link handling
    $4UX9c.view.el.appendChild(this.el);
    this.opts.position = this.opts.position || 'right';
    this.position(this.opts.position);
    this._listenOnResize();
    this.closeButton = this.el.querySelector('[data-hook=popover-close]');
    if (this.closeButton) this.closeButton.addEventListener('click', this.remove.bind(this), false);
    if (opts.show) this.el.classList.add(opts.className || 'open');
    this.trigger('shown');
    return this;
};
$789b1b5a0ac36af1$var$popover.remove = function(event) {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    // this.button = null
    if (this.el.parentNode) this.el.parentNode.removeChild(this.el);
    this.trigger('removed');
    // remove all event listeners
    this.off();
    this.stopListening();
    // this.button.removeEventListener('click', this.remove, false)
    if (this.closeButton) {
        this.closeButton.removeEventListener('click', this.remove.bind(this), false);
        this.closeButton = null;
    }
    window.removeEventListener('resize', this._resizeListener, false);
};
/**
 * Attach popover to element `el`
 * @param {String|Element} el
 * @api public
 */ $789b1b5a0ac36af1$var$popover.setButton = function(element) {
    const el = typeof element === 'string' ? document.querySelector(element) : element;
    this.button = el;
    this.buttonCoords = this.button.getBoundingClientRect();
    // this.button.addEventListener('click', this.remove.bind(this), false)
    return this;
};
$789b1b5a0ac36af1$var$popover.position = function(pos) {
    let x;
    let y;
    this.el.classList.add(`popover-${pos}`);
    this._rect = this.el.getBoundingClientRect();
    const to = $789b1b5a0ac36af1$var$offset(this.buttonCoords, document);
    if (pos === 'top' || pos === 'bottom') {
        x = this._calculateX();
        y = pos === 'top' ? to.top - this._rect.height : to.top + this.buttonCoords.height;
        this.el.style[this.opts.align || 'left'] = `${Math.round(x)}px`;
        this.el.style.top = `${Math.round(y)}px`;
        // position arrow accordingly
        this._positionArrow('left', this.el.getBoundingClientRect().left);
    }
    if (pos === 'right' || pos === 'left') {
        x = pos === 'right' ? to.left + this.buttonCoords.width : to.left - this._rect.width;
        y = this._calculateY();
        this.el.style.left = `${Math.round(x)}px`;
        this.el.style.top = `${Math.round(y)}px`;
        // position arrow accordingly
        this._positionArrow('top', y);
    }
    return this;
};
$789b1b5a0ac36af1$var$popover._listenOnResize = function() {
    this._resizeListener = ()=>{
        this.buttonCoords = this.button.getBoundingClientRect();
        this.position(this.opts.position);
    };
    window.addEventListener('resize', this._resizeListener, false);
};
$789b1b5a0ac36af1$var$popover._positionArrow = function(direction, offset) {
    const arrow = this.el.querySelector('.popover-arrow');
    if (!arrow) return;
    const size = direction === 'top' ? 'height' : 'width';
    const pos = this.buttonCoords[direction] + this.buttonCoords[size] / 2 - offset;
    arrow.style[direction] = `${Math.round(pos)}px`;
};
$789b1b5a0ac36af1$var$popover._calculateY = function() {
    if (!this._rect) this._rect = this.el.getBoundingClientRect();
    const height = this._rect.height;
    // center relative to the button
    let top = this.buttonCoords.top + (this.buttonCoords.height - height) / 2;
    this._autoAlign(top);
    if (this.opts.align === 'top') top = this.buttonCoords.top;
    return top;
};
$789b1b5a0ac36af1$var$popover._calculateX = function() {
    if (!this._rect) this._rect = this.el.getBoundingClientRect();
    const width = this._rect.width;
    // center relative to the button
    let x = this.buttonCoords.left + (this.buttonCoords.width - width) / 2;
    this._autoAlign(x);
    if (this.opts.align === 'left') x = this.buttonCoords.left;
    if (this.opts.align === 'right') x = window.innerWidth - (this.buttonCoords.left + this.buttonCoords.width);
    return x;
};
$789b1b5a0ac36af1$var$popover._autoAlign = function(v) {
    if (!this._rect) this._rect = this.el.getBoundingClientRect();
    const width = this._rect.width;
    const pos = this.opts.position;
    const isVertical = pos === 'top' || pos === 'bottom';
    if (isVertical && v + width > window.innerWidth) this.opts.align = 'right';
    if (isVertical && v < 0) this.opts.align = 'left';
    if (!isVertical && v < 0) this.opts.align = 'top';
    // this.opts.align = 'bottom'
    return this;
};



/**
 * Confirm Removal Popover
 */ $3c03021769421268$exports = $dM6Pc.extend($789b1b5a0ac36af1$exports, {
    template: (parcelRequire("hi3Hz")).default,
    events: {
        'click [data-hook=confirm-delete]': 'confirm',
        'click [data-hook=cancel]': 'remove'
    },
    initialize (opts) {
        this.setButton(opts.button);
        this.opts = opts;
        this.model.once('sync', this.remove, this);
    },
    confirm () {
        this.model.destroy();
    },
    render (...args) {
        $789b1b5a0ac36af1$exports.render.apply(this, args);
        return this;
    }
});


var $d23b55c707a7112e$exports = {};

var $akRxj = parcelRequire("akRxj");

var $bd3QA = parcelRequire("bd3QA");

var $dM6Pc = parcelRequire("dM6Pc");

var $4UX9c = parcelRequire("4UX9c");

$d23b55c707a7112e$exports = $dM6Pc.extend({
    template: (parcelRequire("9iFzx")).default,
    events: {
        click: 'onClick'
    },
    props: {
        showPopover: [
            'boolean',
            true,
            false
        ],
        online: [
            'boolean',
            true,
            false
        ]
    },
    bindings: {
        online: {
            type: 'booleanAttribute',
            no: 'disabled',
            yes: ''
        }
    },
    initialize (opts) {
        $akRxj(this, $bd3QA(opts, 'classes', 'icon', 'title', 'Popover', 'popoverOpts', 'name', 'template'));
        this.on('change:showPopover', this.togglePopover, this);
        this.listenToAndRun($4UX9c.changes, 'change:online', ()=>{
            this.online = $4UX9c.changes.online;
        });
    },
    onClick (event) {
        event.preventDefault();
        this.toggle('showPopover');
    },
    remove () {
        $dM6Pc.prototype.remove.call(this);
        this.Popover = null;
        this.popoverOpts = null;
        return this;
    },
    togglePopover () {
        if (this.showPopover) {
            this.popover = new this.Popover($akRxj({}, this.popoverOpts || {}, {
                button: this.el
            }));
            this.popover.render();
            this.popover.once('removed', function() {
                this.set('showPopover', false, {
                    silent: true
                });
            }, this);
            this.registerSubview(this.popover);
        } else this.popover.remove();
    }
});



var $gvQO6 = parcelRequire("gvQO6");
var $fe9e2270b384e4c6$require$isAdminProp = $gvQO6.isAdminProp;

$fe9e2270b384e4c6$exports = $dM6Pc.extend({
    template: (parcelRequire("i2xev")).default,
    initialize () {
        this.listenTo(this.model, 'change:editable', this.render);
    },
    render () {
        if (this.subview) this.subview.remove();
        this.renderWithTemplate(this);
        if (this.model.editable) this.subview = new $95c38e113312ad56$exports({
            model: this.model
        });
        else this.subview = new $fe9e2270b384e4c6$var$Row({
            model: this.model
        });
        this.renderSubview(this.subview, '[data-hook="subview"]');
        return this;
    }
});

const $fe9e2270b384e4c6$var$Row = $dM6Pc.extend({
    template: (parcelRequire("bSNNN")).default,
    events: {
        'click [data-hook=edit]': 'edit'
    },
    subviews: {
        deleteButton: {
            hook: 'delete-button',
            prepareView (el) {
                return new $d23b55c707a7112e$exports({
                    el: el,
                    icon: 'ion-trash-a',
                    title: `${this.model.name} l\xf6schen...`,
                    classes: 'button-error',
                    Popover: $3c03021769421268$exports,
                    popoverOpts: {
                        model: this.model,
                        position: 'bottom'
                    }
                });
            }
        }
    },
    props: {
        isAdmin: $fe9e2270b384e4c6$require$isAdminProp
    },
    edit () {
        this.model.editable = true;
    },
    remove () {
        if (this.tooltips) for (const tip of this.tooltips)tip.destroy();
        return $dM6Pc.prototype.remove.call(this);
    },
    render () {
        this.renderWithTemplate(this);
        // add tooltips to the buttons
        if (!$4UX9c.isMobile) this.tooltips = $fe9e2270b384e4c6$require$tippy(this.queryAll('[data-title]'));
        return this;
    }
});


var $faf64da9e05fa3b7$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");
var $bb95e3b1ebc1adf7$exports = {};

var $5DUFR = parcelRequire("5DUFR");
var $78a8fc7dfc35a8a8$exports = {};

var $cZ0ro = parcelRequire("cZ0ro");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $78a8fc7dfc35a8a8$var$now = function() {
    return $cZ0ro.Date.now();
};
$78a8fc7dfc35a8a8$exports = $78a8fc7dfc35a8a8$var$now;



var $5M5aK = parcelRequire("5M5aK");
/** Error message constants. */ var $bb95e3b1ebc1adf7$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $bb95e3b1ebc1adf7$var$nativeMax = Math.max, $bb95e3b1ebc1adf7$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $bb95e3b1ebc1adf7$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($bb95e3b1ebc1adf7$var$FUNC_ERROR_TEXT);
    wait = $5M5aK(wait) || 0;
    if ($5DUFR(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $bb95e3b1ebc1adf7$var$nativeMax($5M5aK(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $bb95e3b1ebc1adf7$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $78a8fc7dfc35a8a8$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($78a8fc7dfc35a8a8$exports());
    }
    function debounced() {
        var time = $78a8fc7dfc35a8a8$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$bb95e3b1ebc1adf7$exports = $bb95e3b1ebc1adf7$var$debounce;


const $faf64da9e05fa3b7$var$ESC_KEY = 27;

$faf64da9e05fa3b7$exports = $dM6Pc.extend({
    template: (parcelRequire("kOMpA")).default,
    events: {
        'click [data-hook=reset-search]': 'onReset',
        submit: 'onSubmit',
        'keyup [data-hook=search-form]': 'onKeyup'
    },
    // if an (optional) model with an initial "q" prop is passed
    // we bind it to the input
    bindings: {
        'model.q': {
            type: 'value',
            selector: 'input'
        }
    },
    initialize (opts) {
        this.placeholder = opts.placeholder;
    },
    onSubmit (evt) {
        evt.preventDefault();
    },
    onReset (event) {
        event.preventDefault();
        this.searchInput.value = '';
        this.search('');
    },
    onKeyup: $bb95e3b1ebc1adf7$exports(function(event) {
        let query = event.target.value.trim();
        if (event.which === $faf64da9e05fa3b7$var$ESC_KEY) {
            event.target.value = '';
            query = '';
        }
        this.search(query);
    }, 50),
    search (query) {
        this.resetButton.classList.toggle('hidden', !query);
        if (this.parent && typeof this.parent.search === 'function') this.parent.search(query);
        this.trigger('search', query);
    },
    render () {
        this.renderWithTemplate(this);
        this.cacheElements({
            resetButton: '[data-hook="reset-search"] a',
            searchInput: '[data-hook="search-form"] input'
        });
        return this;
    }
});




var $gvQO6 = parcelRequire("gvQO6");
var $13d2dd924a971d28$require$isAdminProp = $gvQO6.isAdminProp;

var $8jWPf = parcelRequire("8jWPf");
var $bRFDG = parcelRequire("bRFDG");

var $4UX9c = parcelRequire("4UX9c");

var $gsMHG = parcelRequire("gsMHG");

var $kLOUX = parcelRequire("kLOUX");

var $348Te = parcelRequire("348Te");

var $1JrMM = parcelRequire("1JrMM");

const $13d2b3588949a352$var$ProductImport = (0, $gsMHG.lazy)(()=>(parcelRequire("jeTO2")));
function $13d2b3588949a352$var$ProductImportButton() {
    const [isOpen, setIsOpen] = (0, $kLOUX.useState)(false);
    const initialFocus = (0, $kLOUX.useRef)();
    function handleClose() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).products.fetch();
        setIsOpen(false);
    }
    return /*#__PURE__*/ (0, $8jWPf.jsxs)((0, $bRFDG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                type: "button",
                className: "pure-button btn-round dispatch",
                "data-title": "Produkte importieren",
                onClick: ()=>setIsOpen(true),
                children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                    className: "ion-ios-cloud-upload"
                })
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)((0, $348Te.Modal), {
                isOpen: isOpen,
                onClose: handleClose,
                children: /*#__PURE__*/ (0, $8jWPf.jsxs)((0, $348Te.ModalPanel), {
                    children: [
                        /*#__PURE__*/ (0, $8jWPf.jsx)((0, $348Te.ModalCloseButton), {
                            onClick: handleClose
                        }),
                        /*#__PURE__*/ (0, $8jWPf.jsx)("h1", {
                            children: "Produkte importieren"
                        }),
                        /*#__PURE__*/ (0, $8jWPf.jsx)((0, $gsMHG.Suspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $8jWPf.jsx)($13d2b3588949a352$var$ProductImport, {
                                onClose: handleClose,
                                initialFocus: initialFocus
                            })
                        })
                    ]
                })
            })
        ]
    });
}
const $13d2b3588949a352$export$432f8c5a0231092e = (0, $1JrMM.PreactView).extend({
    component: $13d2b3588949a352$var$ProductImportButton
});


var $13d2dd924a971d28$require$ProductImportButtonView = $13d2b3588949a352$export$432f8c5a0231092e;

const $13d2dd924a971d28$var$DeletedProductView = $dM6Pc.extend({
    template: (parcelRequire("2Ez8d")).default,
    events: {
        'click [data-hook=restore]': 'onRestore'
    },
    onRestore (event) {
        event.preventDefault();
        this.model.save({
            deletedAt: null
        });
    }
});

$13d2dd924a971d28$exports = $dM6Pc.extend({
    title: 'Produkte',
    template: (parcelRequire("ai8wC")).default,
    events: {
        'click [data-hook=add-product]': 'addProduct'
    },
    props: {
        hasNew: [
            'boolean',
            true,
            false
        ],
        isAdmin: $13d2dd924a971d28$require$isAdminProp
    },
    derived: {
        exportUrl: {
            cache: false,
            fn () {
                return `/api/events/${$4UX9c.me.currentEvent.slug}/products/export`;
            }
        }
    },
    subviews: {
        searchBar: {
            hook: 'search-bar',
            prepareView (el) {
                return new $faf64da9e05fa3b7$exports({
                    el: el,
                    parent: this
                });
            }
        },
        importProducts: {
            hook: 'import-products',
            prepareView (el) {
                return new $13d2dd924a971d28$require$ProductImportButtonView({
                    el: el
                });
            }
        },
        activeProducts: {
            container: '[data-hook=products]',
            prepareView (el) {
                // active products
                const activeProducts = new $83a891297e5a5907$exports(this.collection, {
                    filter (product) {
                        return !product.deletedAt;
                    },
                    watched: [
                        'deletedAt'
                    ]
                });
                return this.renderCollection(activeProducts, $fe9e2270b384e4c6$exports, el);
            }
        },
        deletedProducts: {
            container: '[data-hook=deleted-products]',
            prepareView (el) {
                // active products
                const deletedProducts = new $83a891297e5a5907$exports(this.collection, {
                    filter (product) {
                        return !!product.deletedAt;
                    },
                    watched: [
                        'deletedAt'
                    ]
                });
                return this.renderCollection(deletedProducts, $13d2dd924a971d28$var$DeletedProductView, el);
            }
        }
    },
    initialize () {
        // create new collection, since we don't want to manipulate our
        // global products collection during searches
        this.collection = new $36dc365827ae47b5$exports($4UX9c.products.models, {
            cache: false
        });
        // update our global products collection. this let's us render the page right away,
        // but still fetch updates in the background
        $4UX9c.products.fetch();
    },
    addProduct () {
        if (this.hasNew) return;
        this.renderSubview(new $95c38e113312ad56$exports({
            model: new $3c27fa7da8048484$exports(),
            parent: this
        }), '[data-hook=new-product]');
        this.hasNew = true;
    },
    // will be called by SearchBarView
    search (query) {
        this.collection.byName(query);
    },
    remove () {
        if (this.sortable) this.sortable.destroy();
        if (this.tooltips) for (const tip of this.tooltips)tip.destroy();
        return $dM6Pc.prototype.remove.call(this);
    },
    render () {
        const parent = this;
        this.renderWithTemplate(this);
        // add tooltips to the buttons
        if (!$4UX9c.isMobile) {
            if (this.tooltips) for (const tip of this.tooltips)tip.destroy();
            this.tooltips = $13d2dd924a971d28$require$tippy(this.queryAll('[data-hook="page-header"] [data-title]'));
        }
        // if we don't have any products, let the user create
        // one right away and return
        if (!this.collection.length) {
            this.addProduct();
            return this;
        }
        if (this.sortable) this.sortable.destroy();
        // create sortable
        this.sortable = $13d2dd924a971d28$require$Sortable.create(this.queryByHook('products'), {
            draggable: '.product-row',
            handle: '.ion-drag',
            animation: 150,
            onEnd () {
                this.toArray().forEach((id, i)=>{
                    const model = parent.collection.get(id);
                    const index = i + 1;
                    model.save({
                        sortPosition: index
                    });
                });
                $4UX9c.products.sort();
            }
        });
        return this;
    }
});


var $346d3b1e7ee8f2c1$exports = {};

var $4UX9c = parcelRequire("4UX9c");

var $dM6Pc = parcelRequire("dM6Pc");


var $4UX9c = parcelRequire("4UX9c");

var $kw3w9 = parcelRequire("kw3w9");

var $akRxj = parcelRequire("akRxj");


var $bd3QA = parcelRequire("bd3QA");

var $9c5La = parcelRequire("9c5La");

var $gvQO6 = parcelRequire("gvQO6");


var $4UX9c = parcelRequire("4UX9c");

var $bKnC7 = parcelRequire("bKnC7");

var $9c5La = parcelRequire("9c5La");

var $gvQO6 = parcelRequire("gvQO6");
var $2937b6842f5491f9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bKnC7))).extend({
    urlRoot () {
        return `/api/events/${(0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent.slug}/transactions`;
    },
    initialize () {
        this.on('change:inputPackages change:inputUnits', this.onAmountChange, this);
    },
    props: {
        id: [
            'string'
        ],
        createdAt: {
            type: 'date',
            required: true,
            default () {
                return new Date().toISOString();
            }
        },
        updatedAt: {
            type: 'date',
            required: true,
            default () {
                return new Date().toISOString();
            }
        },
        dispatchedAt: {
            type: 'date',
            required: true,
            default () {
                return new Date().toISOString();
            }
        },
        state: {
            type: 'string',
            values: [
                'transit',
                'complete',
                'cancelled',
                'accepted'
            ],
            default: 'transit'
        },
        sourceId: [
            'string',
            true
        ],
        targetId: [
            'string',
            true
        ],
        productId: [
            'string',
            true
        ],
        units: [
            'number',
            true,
            0
        ],
        isFree: [
            'boolean',
            true,
            false
        ],
        comment: [
            'string'
        ],
        userId: {
            type: 'string',
            required: true,
            setOnce: true,
            default () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.id;
            }
        },
        editedById: 'string',
        editedBy: 'object',
        user: 'object'
    },
    session: {
        inputPackages: [
            'number',
            false,
            0
        ],
        inputUnits: [
            'number',
            false,
            0
        ],
        // this is the "stock" for delivery transactions
        products: {
            type: 'object',
            default () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).products;
            }
        }
    },
    derived: {
        product: {
            deps: [
                'productId'
            ],
            fn () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).products.get(this.productId) || {};
            }
        },
        target: {
            deps: [
                'targetId'
            ],
            fn () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).locations.get(this.targetId) || {};
            }
        },
        source: {
            deps: [
                'sourceId'
            ],
            fn () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).locations.get(this.sourceId) || {};
            }
        },
        isEditableByMe: {
            deps: [
                'userId'
            ],
            fn () {
                // only the initiator and admins can change this transaction
                return this.userId === (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.id || (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.role === 'admin';
            }
        },
        unitsLocalized: (0, $gvQO6.unitsLocalized)('units'),
        packagesLocalized: (0, $gvQO6.packagesLocalized)('units'),
        // for backwards calculation from units -> inputUnits/inputPackges
        _inputUnits: {
            fn () {
                return this.units % this.product.packageSize;
            }
        },
        _inputPackages: {
            fn () {
                return Math.floor(this.units / this.product.packageSize);
            }
        },
        dateLocalized: {
            deps: [
                'createdAt'
            ],
            fn () {
                return (0, $9c5La.DateTime).fromJSDate(this.createdAt).toLocaleString((0, $9c5La.DateTime).DATETIME_SHORT);
            }
        },
        updatedAtLocalized: {
            deps: [
                'updatedAt'
            ],
            fn () {
                return (0, $9c5La.DateTime).fromJSDate(this.updatedAt).toLocaleString((0, $9c5La.DateTime).DATETIME_SHORT);
            }
        },
        dispatchedAtLocalized: {
            deps: [
                'dispatchedAt'
            ],
            fn () {
                return (0, $9c5La.DateTime).fromJSDate(this.dispatchedAt).toLocaleString((0, $9c5La.DateTime).DATETIME_SHORT);
            }
        },
        dateFromNow: {
            deps: [
                'createdAt'
            ],
            cache: false,
            fn () {
                return (0, $9c5La.DateTime).fromJSDate(this.createdAt).toRelative();
            }
        }
    },
    validate () {
        if (!this.sourceId) return 'Bitte Quelle angeben.';
        if (!this.targetId) return 'Bitte Ziel angeben.';
        if (!this.productId) return 'Bitte Produkt angeben.';
        if (!this.units) return 'Bitte Menge angeben.';
    },
    onAmountChange () {
        this.units = this.inputPackages * this.product.packageSize + this.inputUnits;
    }
});


const $33d99074a610f1d1$var$SearchState = (0, (/*@__PURE__*/$parcel$interopDefault($kw3w9))).extend({
    props: {
        q: [
            'string'
        ],
        source: [
            'string'
        ],
        target: [
            'string'
        ],
        product: [
            'string'
        ],
        start: [
            'date'
        ],
        end: [
            'date'
        ]
    },
    derived: {
        filtered: {
            deps: [
                'q',
                'source',
                'target',
                'product',
                'start',
                'end'
            ],
            fn () {
                return [
                    'q',
                    'source',
                    'target',
                    'product',
                    'start',
                    'end'
                ].map((prop)=>!!this[prop]).reduce((a, b)=>a || b);
            }
        },
        activeSource: {
            deps: [
                'source'
            ],
            fn () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).locations.get(this.source)?.name;
            }
        },
        activeTarget: {
            deps: [
                'target'
            ],
            fn () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).locations.get(this.target)?.name;
            }
        },
        activeProduct: {
            deps: [
                'product'
            ],
            fn () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).products.get(this.product)?.name;
            }
        },
        startLocalized: {
            deps: [
                'start'
            ],
            fn () {
                return (0, $9c5La.DateTime).fromJSDate(this.start).toLocaleString((0, $9c5La.DateTime).DATETIME_SHORT);
            }
        },
        endLocalized: {
            deps: [
                'end'
            ],
            fn () {
                return (0, $9c5La.DateTime).fromJSDate(this.end).toLocaleString((0, $9c5La.DateTime).DATETIME_SHORT);
            }
        }
    },
    parse (res) {
        if (!res) return res;
        // translate slugs to ids
        return (0, (/*@__PURE__*/$parcel$interopDefault($akRxj)))(res, {
            source: (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).locations.findWhere({
                slug: res.source
            })?.id,
            target: (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).locations.findWhere({
                slug: res.target
            })?.id,
            product: (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).products.findWhere({
                slug: res.product
            })?.id
        });
    }
});
const $33d99074a610f1d1$export$b08a9033b36413fb = (0, (/*@__PURE__*/$parcel$interopDefault($kw3w9))).extend({
    props: {
        start: 'date',
        end: 'date',
        count: [
            'number',
            false,
            0
        ]
    }
});
var $33d99074a610f1d1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8dd5675b2fc15f09$exports))).extend({
    url () {
        return `/api/events/${(0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent.slug}/transactions`;
    },
    model: (0, $2937b6842f5491f9$export$2e2bcd8739ae039),
    storageKey () {
        return `${(0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent.slug}-transactions`;
    },
    // Nach Zeit absteigend und dann Name aufsteigend sortieren
    comparator (a, b) {
        const diff = b.dispatchedAt.getTime() - a.dispatchedAt.getTime();
        if (diff === 0) return a.product.name > b.product.name ? 1 : -1;
        return diff;
    },
    initialize (data, options) {
        const opts = (0, (/*@__PURE__*/$parcel$interopDefault($akRxj)))({
            watch: true,
            cache: true
        }, options);
        // metadata model: need to init it before the storage mixin
        this.meta = new $33d99074a610f1d1$export$b08a9033b36413fb();
        // populate search state with query params
        this.state = new $33d99074a610f1d1$var$SearchState(opts.query, {
            parse: true
        });
        if (opts.cache) {
            this.initStorage();
            this.on('change sync', this.writeToStorage, this);
            this.on('stale empty', this.fetchWithParams, this);
        }
        if (opts.watch) this.listenTo((0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).changes, 'transactions', this.onChange);
        this.listenTo(this.state, 'change', this._fetchDebounced);
    },
    bulkSave () {
        const self = this;
        // only save transactions with units
        const toBeSaved = this.filter((transaction)=>!!transaction.units);
        const opts = {
            attrs: toBeSaved,
            success (res) {
                self.trigger('sync', self, res, opts);
            }
        };
        this.sync('create', this, opts);
    },
    allSaved () {
        return this.filter((model)=>!model.isNew()).length === this.length;
    },
    search (term) {
        this.state.q = term;
        // reset search
        if (!this.state.q) {
            this._fetchDebounced();
            return;
        }
        if (this.state.q.length < 2) return;
        // filter original (local) models
        const localQuery = (0, $gvQO6.indexify)(term);
        const filtered = this.filter((transaction)=>{
            const productMatches = transaction.product._nameIndex.indexOf(localQuery) > -1;
            const sourceMatches = transaction.source._nameIndex.indexOf(localQuery) > -1;
            const targetMatches = transaction.target._nameIndex.indexOf(localQuery) > -1;
            const userMatches = (0, $gvQO6.indexify)(transaction.user.name).indexOf(localQuery) > -1;
            return productMatches || sourceMatches || targetMatches || userMatches;
        });
        this.reset(filtered);
        // ask for more on the server
        this._fetchDebounced();
    },
    serializeToStorage () {
        return (0, (/*@__PURE__*/$parcel$interopDefault($akRxj)))({
            data: this.toJSON()
        }, this.meta.toJSON());
    },
    parseFromStorage (data) {
        return this.parse(data);
    },
    fetchWithParams () {
        const params = (0, (/*@__PURE__*/$parcel$interopDefault($bd3QA)))(this.state.toJSON(), 'q', 'source', 'target', 'product');
        if (this.state.start) params.start = this.state.start.toISOString();
        if (this.state.end) params.end = this.state.end.toISOString();
        this.fetch({
            data: params
        });
    },
    _fetchDebounced: (0, (/*@__PURE__*/$parcel$interopDefault($bb95e3b1ebc1adf7$exports)))(function() {
        this.fetchWithParams();
    }, 100),
    parse (res) {
        // set metadata
        if (!Array.isArray(res)) this.meta.set(res);
        // return transactions list
        return Array.isArray(res) ? res : res.data;
    },
    fetchMore () {
        this.fetch({
            remove: false,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($akRxj)))({
                offset: this.length
            }, this.state.toJSON())
        });
    },
    onChange (change) {
        if (change.type === 'delete') {
            this.remove(change.id);
            return;
        }
        if (change.type === 'insert' || change.type === 'update') this.set(change.row, {
            remove: false
        });
    }
});


var $346d3b1e7ee8f2c1$require$Transactions = $33d99074a610f1d1$export$2e2bcd8739ae039;

var $056e8f0f3486aaa9$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $056e8f0f3486aaa9$require$tippy = $6445619a88c9e457$export$2e2bcd8739ae039;

var $4UX9c = parcelRequire("4UX9c");
var $b5138b891f72fe07$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");


var $4UX9c = parcelRequire("4UX9c");
function $b5138b891f72fe07$var$hasStock(model) {
    return model.type === 'delivery' ? true : model.stock.length;
}

$b5138b891f72fe07$exports = $dM6Pc.extend({
    template: (parcelRequire("lGIqk")).default,
    events: {
        'change select': 'onSelect'
    },
    initialize () {
        this.collection = new $83a891297e5a5907$exports($4UX9c.locations, {
            filter (model) {
                // only display delivery and locations with stock
                return model.type !== 'crash' && $b5138b891f72fe07$var$hasStock(model);
            },
            watched: [
                'type'
            ]
        });
        // set initial source
        if (!this.model.sourceId) {
            const storage = this.collection.filter((location)=>location.type === 'storage');
            if (storage.length) this.model.set('sourceId', storage[0].id);
        }
        this.listenTo(this.collection, 'add remove change', this.render);
    },
    onSelect (evt) {
        this.model.set('sourceId', evt.target.value);
    }
});


var $021f193430451dc4$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");


var $4UX9c = parcelRequire("4UX9c");

$021f193430451dc4$exports = $dM6Pc.extend({
    template: (parcelRequire("hczrv")).default,
    events: {
        'change select': 'onSelect'
    },
    initialize () {
        const transaction = this.model;
        // exclude transaction source
        this._filter = (model)=>model.id !== transaction.sourceId;
        this.collection = new $83a891297e5a5907$exports($4UX9c.locations, {
            filter: this._filter,
            watched: [
                'type'
            ]
        });
        // do not set initial target, as per feature request from Björn
        // if (!this.model.targetId) this.model.set('targetId', this.collection.at(0).id)
        this.listenTo(this.collection, 'add remove change', this.render);
        this.listenTo(this.model, 'change:sourceId', this.onSourceChange);
    },
    onSourceChange (transaction, sourceId) {
        const filter = (model)=>model.id !== sourceId;
        this.collection.swapFilters(filter, this._filter);
        this._filter = filter;
        if (!this.model.targetId) this.model.set('targetId', this.collection.at(0).id);
    },
    onSelect (evt) {
        this.model.set('targetId', evt.target.value);
    }
});


var $bb0eb7f84d18deb3$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $9c5La = parcelRequire("9c5La");
var $bb0eb7f84d18deb3$require$DateTime = $9c5La.DateTime;

$bb0eb7f84d18deb3$exports = $dM6Pc.extend({
    template: (parcelRequire("6Ny93")).default,
    props: {
        inputValue: 'date'
    },
    derived: {
        formattedDate: {
            deps: [
                'inputValue'
            ],
            fn () {
                return this.inputValue ? $bb0eb7f84d18deb3$require$DateTime.fromJSDate(this.inputValue).toFormat("yyyy-LL-dd'T'HH:mm") : '';
            }
        }
    },
    events: {
        'change input': 'onChange'
    },
    initialize (opts = {}) {
        this.inputValue = opts.initialValue;
    },
    /**
   * @param {InputEvent} event
   */ onChange (event) {
        const el = /** @type {HTMLInputElement} */ event.target;
        this.inputValue = new Date(el.value);
    },
    render () {
        this.renderWithTemplate();
        return this;
    }
});



var $gvQO6 = parcelRequire("gvQO6");
var $056e8f0f3486aaa9$require$isAdminProp = $gvQO6.isAdminProp;



const $056e8f0f3486aaa9$var$EditView = $dM6Pc.extend({
    template: (parcelRequire("7RMJN")).default,
    events: {
        'click [data-hook=save]': 'onSave',
        'click [data-hook=cancel]': 'onCancel',
        'change [name=inputUnits]': 'onChange',
        'change [name=inputPackages]': 'onChange',
        'change [name=productId]': 'onChange'
    },
    subviews: {
        source: {
            hook: 'select-source',
            prepareView (el) {
                return new $b5138b891f72fe07$exports({
                    template: (parcelRequire("5ksgk")).default,
                    el: el,
                    model: this.model
                });
            }
        },
        target: {
            hook: 'select-target',
            prepareView (el) {
                return new $021f193430451dc4$exports({
                    template: (parcelRequire("fwSd6")).default,
                    el: el,
                    model: this.model
                });
            }
        },
        datePicker: {
            hook: 'date-picker',
            prepareView (el) {
                const view = new $bb0eb7f84d18deb3$exports({
                    el: el,
                    initialValue: this.model.dispatchedAt
                });
                this.listenTo(view, 'change:inputValue', this.onDateChange);
                return view;
            }
        }
    },
    onChange (evt) {
        const val = evt.target.type === 'number' ? +evt.target.value : evt.target.value;
        this.model.set(evt.target.name, val);
    },
    onSave (evt) {
        evt.preventDefault();
        this.model.save();
        this.parent.toggle('editable');
    },
    onCancel (evt) {
        evt.preventDefault();
        this.parent.editable = false;
    },
    onDateChange (view, date) {
        this.model.dispatchedAt = date;
    }
});

$056e8f0f3486aaa9$exports = $dM6Pc.extend({
    template: (parcelRequire("bRXhc")).default,
    events: {
        'click [data-hook=edit]': 'onEdit'
    },
    props: {
        editable: [
            'boolean',
            true,
            false
        ],
        isAdmin: $056e8f0f3486aaa9$require$isAdminProp
    },
    initialize () {
        this.me = $4UX9c.me;
        this.listenTo(this.model, 'change', this.render);
        this.on('change:editable', this.showEditView, this);
    },
    onEdit (evt) {
        evt.preventDefault();
        this.toggle('editable');
    },
    showEditView () {
        if (this.editable) {
            this.editView = this.registerSubview(new $056e8f0f3486aaa9$var$EditView({
                model: this.model
            }));
            this.el.parentNode.insertBefore(this.editView.render().el, this.el);
        } else this.editView.remove();
        this.el.classList.toggle('hidden', this.editable);
    },
    remove () {
        if (this.commentTooltip) this.commentTooltip.destroy();
        if (this.editedByTooltip) this.editedByTooltip.destroy();
        return $dM6Pc.prototype.remove.call(this);
    },
    render () {
        // don't render when in edit mode
        if (this.editable) return this;
        this.renderWithTemplate(this);
        if (this.model.comment) this.commentTooltip = $056e8f0f3486aaa9$require$tippy(this.queryByHook('show-comment'), {
            content: this.model.comment,
            delay: 100
        });
        if (this.model.editedById) {
            const i = this.queryByHook('edited');
            if (!i) return this;
            this.editedByTooltip = $056e8f0f3486aaa9$require$tippy(i, {
                content: i.dataset.title
            });
        }
        return this;
    }
});



var $dM6Pc = parcelRequire("dM6Pc");

var $9c5La = parcelRequire("9c5La");
var $5292d1218fad3197$exports = {};
/**
 * Slidy - customizable slider component.
 *
 * @module slidy
 */ var $82b34bb456cfa7b8$exports = {};
/**
 * Picker class.
 * A controller for draggable.
 * Because it has some intermediate API:
 * - update
 * - value
 *
 * Note that it’s not an extension of draggable due to method names conflict, like update.
 */ var $6172e0e421d1d549$exports = {};
/**
 * Simple draggable component
 *
 * @module draggy
 */ //work with css
var $28f4ea491130cc50$exports = {};
/**
 * Get or set element’s style, prefix-agnostic.
 *
 * @module  mucss/css
 */ var $590af9f8059ea925$exports = {};
/** Just a fake element to test styles
 * @module mucss/fake-element
 */ $590af9f8059ea925$exports = document.createElement('div');


var $28f4ea491130cc50$require$fakeStyle = $590af9f8059ea925$exports.style;
var $0ce9b839e11bcfa2$exports = {};
/**
 * Vendor prefixes
 * Method of http://davidwalsh.name/vendor-prefix
 * @module mucss/prefix
 */ var $0ce9b839e11bcfa2$var$styles = getComputedStyle(document.documentElement, '');
if (!$0ce9b839e11bcfa2$var$styles) $0ce9b839e11bcfa2$exports = {
    dom: '',
    lowercase: '',
    css: '',
    js: ''
};
else {
    var $0ce9b839e11bcfa2$var$pre = (Array.prototype.slice.call($0ce9b839e11bcfa2$var$styles).join('').match(/-(moz|webkit|ms)-/) || $0ce9b839e11bcfa2$var$styles.OLink === '' && [
        '',
        'o'
    ])[1];
    var $0ce9b839e11bcfa2$var$dom = 'WebKit|Moz|MS|O'.match(new RegExp('(' + $0ce9b839e11bcfa2$var$pre + ')', 'i'))[1];
    $0ce9b839e11bcfa2$exports = {
        dom: $0ce9b839e11bcfa2$var$dom,
        lowercase: $0ce9b839e11bcfa2$var$pre,
        css: '-' + $0ce9b839e11bcfa2$var$pre + '-',
        js: $0ce9b839e11bcfa2$var$pre[0].toUpperCase() + $0ce9b839e11bcfa2$var$pre.substr(1)
    };
}


var $28f4ea491130cc50$require$prefix = $0ce9b839e11bcfa2$exports.lowercase;
/**
 * Apply styles to an element.
 *
 * @param    {Element}   el   An element to apply styles.
 * @param    {Object|string}   obj   Set of style rules or string to get style rule.
 */ $28f4ea491130cc50$exports = function(el, obj) {
    if (!el || !obj) return;
    var name, value;
    //return value, if string passed
    if (typeof obj === 'string') {
        name = obj;
        //return value, if no value passed
        if (arguments.length < 3) return el.style[$28f4ea491130cc50$var$prefixize(name)];
        //set style, if value passed
        value = arguments[2] || '';
        obj = {};
        obj[name] = value;
    }
    for(name in obj){
        //convert numbers to px
        if (typeof obj[name] === 'number' && /left|right|bottom|top|width|height/i.test(name)) obj[name] += 'px';
        value = obj[name] || '';
        el.style[$28f4ea491130cc50$var$prefixize(name)] = value;
    }
};
/**
 * Return prefixized prop name, if needed.
 *
 * @param    {string}   name   A property name.
 * @return   {string}   Prefixed property name.
 */ function $28f4ea491130cc50$var$prefixize(name) {
    var uName = name[0].toUpperCase() + name.slice(1);
    if ($28f4ea491130cc50$require$fakeStyle[name] !== undefined) return name;
    if ($28f4ea491130cc50$require$fakeStyle[$28f4ea491130cc50$require$prefix + uName] !== undefined) return $28f4ea491130cc50$require$prefix + uName;
    return '';
}


var $271e553178948144$exports = {};
/**
 * Returns parsed css value.
 *
 * @module mucss/parse-value
 *
 * @param {string} str A string containing css units value
 *
 * @return {number} Parsed number value
 */ $271e553178948144$exports = function(str) {
    str += '';
    return parseFloat(str.slice(0, -2)) || 0;
}; //FIXME: add parsing units


/**
 * Enable/disable selectability of an element
 * @module mucss/selection
 */ /**
 * Disable or Enable any selection possibilities for an element.
 *
 * @param    {Element}   el   Target to make unselectable.
 */ var $8c4f1005b02524f0$export$e20fbacbb41798b;
var $8c4f1005b02524f0$export$d7c4a0dd6a4567e5;

$8c4f1005b02524f0$export$e20fbacbb41798b = function(el) {
    $28f4ea491130cc50$exports(el, {
        'user-select': 'none',
        'user-drag': 'none',
        'touch-callout': 'none'
    });
    el.setAttribute('unselectable', 'on');
    el.addEventListener('selectstart', $8c4f1005b02524f0$var$pd);
};
$8c4f1005b02524f0$export$d7c4a0dd6a4567e5 = function(el) {
    $28f4ea491130cc50$exports(el, {
        'user-select': null,
        'user-drag': null,
        'touch-callout': null
    });
    el.removeAttribute('unselectable');
    el.removeEventListener('selectstart', $8c4f1005b02524f0$var$pd);
};
/** Prevent you know what. */ function $8c4f1005b02524f0$var$pd(e) {
    e.preventDefault();
}


var $961f65bdbb29e89e$exports = {};
/**
 * Calculate absolute offsets of an element, relative to the document.
 *
 * @module mucss/offsets
 *
 */ var $961f65bdbb29e89e$var$win = window;
var $961f65bdbb29e89e$var$doc = document;
var $cde9a30136b65d24$exports = {};
/**
 * Simple rect constructor.
 * It is just faster and smaller than constructing an object.
 *
 * @module mucss/rect
 *
 * @param {number} l left
 * @param {number} t top
 * @param {number} r right
 * @param {number} b bottom
 *
 * @return {Rect} A rectangle object
 */ $cde9a30136b65d24$exports = function Rect(l, t, r, b) {
    if (!(this instanceof Rect)) return new Rect(l, t, r, b);
    this.left = l || 0;
    this.top = t || 0;
    this.right = r || 0;
    this.bottom = b || 0;
    this.width = Math.abs(this.right - this.left);
    this.height = Math.abs(this.bottom - this.top);
};


/**
 * Window scrollbar detector.
 *
 * @module mucss/has-scroll
 */ //TODO: detect any element scroll, not only the window
var $4adf26546ab29800$export$d141bba7fdc215a3;
var $4adf26546ab29800$export$4a5767248b18ef41;
$4adf26546ab29800$export$d141bba7fdc215a3 = function() {
    return window.innerHeight > document.documentElement.clientHeight;
};
$4adf26546ab29800$export$4a5767248b18ef41 = function() {
    return window.innerWidth > document.documentElement.clientWidth;
};


var $7e17008bdfcf8d6c$exports = {};
/**
 * Calculate scrollbar width.
 *
 * @module mucss/scrollbar
 */ // Create the measurement node
var $7e17008bdfcf8d6c$var$scrollDiv = document.createElement("div");
var $7e17008bdfcf8d6c$var$style = $7e17008bdfcf8d6c$var$scrollDiv.style;
$7e17008bdfcf8d6c$var$style.width = '100px';
$7e17008bdfcf8d6c$var$style.height = '100px';
$7e17008bdfcf8d6c$var$style.overflow = 'scroll';
$7e17008bdfcf8d6c$var$style.position = 'absolute';
$7e17008bdfcf8d6c$var$style.top = '-9999px';
document.documentElement.appendChild($7e17008bdfcf8d6c$var$scrollDiv);
// the scrollbar width
$7e17008bdfcf8d6c$exports = $7e17008bdfcf8d6c$var$scrollDiv.offsetWidth - $7e17008bdfcf8d6c$var$scrollDiv.clientWidth;
// Delete fake DIV
document.documentElement.removeChild($7e17008bdfcf8d6c$var$scrollDiv);


var $03be3eb5d227a2ea$exports = {};
/**
 * Detect whether element is placed to fixed container or is fixed itself.
 *
 * @module mucss/is-fixed
 *
 * @param {(Element|Object)} el Element to detect fixedness.
 *
 * @return {boolean} Whether element is nested.
 */ $03be3eb5d227a2ea$exports = function(el) {
    var parentEl = el;
    //window is fixed, btw
    if (el === window) return true;
    //unlike the doc
    if (el === document) return false;
    while(parentEl){
        if (getComputedStyle(parentEl).position === 'fixed') return true;
        parentEl = parentEl.offsetParent;
    }
    return false;
};


var $3a496b756ab62db1$exports = {};
/**
 * Parse translate3d
 *
 * @module mucss/translate
 */ 

$3a496b756ab62db1$exports = function(el) {
    var translateStr = $28f4ea491130cc50$exports(el, 'transform');
    //find translate token, retrieve comma-enclosed values
    //translate3d(1px, 2px, 2) → 1px, 2px, 2
    //FIXME: handle nested calcs
    var match = /translate(?:3d)?\s*\(([^\)]*)\)/.exec(translateStr);
    if (!match) return [
        0,
        0
    ];
    var values = match[1].split(/\s*,\s*/);
    //parse values
    //FIXME: nested values are not necessarily pixels
    return values.map(function(value) {
        return $271e553178948144$exports(value);
    });
};


/**
 * Return absolute offsets of any target passed
 *
 * @param    {Element|window}   el   A target. Pass window to calculate viewport offsets
 * @return   {Object}   Offsets object with trbl.
 */ $961f65bdbb29e89e$exports = $961f65bdbb29e89e$var$offsets;
function $961f65bdbb29e89e$var$offsets(el) {
    if (!el) throw Error('Bad argument');
    //calc client rect
    var cRect, result;
    //return vp offsets
    if (el === $961f65bdbb29e89e$var$win) {
        result = $cde9a30136b65d24$exports($961f65bdbb29e89e$var$win.pageXOffset, $961f65bdbb29e89e$var$win.pageYOffset);
        result.width = $961f65bdbb29e89e$var$win.innerWidth - ($4adf26546ab29800$export$4a5767248b18ef41() ? $7e17008bdfcf8d6c$exports : 0), result.height = $961f65bdbb29e89e$var$win.innerHeight - ($4adf26546ab29800$export$d141bba7fdc215a3() ? $7e17008bdfcf8d6c$exports : 0);
        result.right = result.left + result.width;
        result.bottom = result.top + result.height;
        return result;
    } else if (el === $961f65bdbb29e89e$var$doc) {
        var res = $961f65bdbb29e89e$var$offsets($961f65bdbb29e89e$var$doc.documentElement);
        res.bottom = Math.max(window.innerHeight, res.bottom);
        res.right = Math.max(window.innerWidth, res.right);
        res.height = Math.max(window.innerHeight, res.height);
        res.width = Math.max(window.innerHeight, res.width);
        if ($4adf26546ab29800$export$4a5767248b18ef41($961f65bdbb29e89e$var$doc.documentElement)) res.right -= $7e17008bdfcf8d6c$exports;
        if ($4adf26546ab29800$export$d141bba7fdc215a3($961f65bdbb29e89e$var$doc.documentElement)) res.bottom -= $7e17008bdfcf8d6c$exports;
        return res;
    }
    //FIXME: why not every element has getBoundingClientRect method?
    try {
        cRect = el.getBoundingClientRect();
    } catch (e) {
        cRect = $cde9a30136b65d24$exports(el.clientLeft, el.clientTop);
    }
    //whether element is or is in fixed
    var isFixed = $03be3eb5d227a2ea$exports(el);
    var xOffset = isFixed ? 0 : $961f65bdbb29e89e$var$win.pageXOffset;
    var yOffset = isFixed ? 0 : $961f65bdbb29e89e$var$win.pageYOffset;
    result = $cde9a30136b65d24$exports(cRect.left + xOffset, cRect.top + yOffset, cRect.left + xOffset + el.offsetWidth, cRect.top + yOffset + el.offsetHeight);
    return result;
}



var $c1e19f5177c63f8e$exports = {};
/** @module  intersects */ $c1e19f5177c63f8e$exports = $c1e19f5177c63f8e$var$intersects;
var $c1e19f5177c63f8e$var$min = Math.min, $c1e19f5177c63f8e$var$max = Math.max;
/**
 * Main intersection detector.
 *
 * @param {Rectangle} a Target
 * @param {Rectangle} b Container
 *
 * @return {bool} Whether target is within the container
 */ function $c1e19f5177c63f8e$var$intersects(a, b, tolerance) {
    //ignore definite disintersection
    if (a.right < b.left || a.left > b.right) return false;
    if (a.bottom < b.top || a.top > b.bottom) return false;
    //intersection values
    var iX = $c1e19f5177c63f8e$var$min(a.right - $c1e19f5177c63f8e$var$max(b.left, a.left), b.right - $c1e19f5177c63f8e$var$max(a.left, b.left));
    var iY = $c1e19f5177c63f8e$var$min(a.bottom - $c1e19f5177c63f8e$var$max(b.top, a.top), b.bottom - $c1e19f5177c63f8e$var$max(a.top, b.top));
    var iSquare = iX * iY;
    var bSquare = (b.bottom - b.top) * (b.right - b.left);
    var aSquare = (a.bottom - a.top) * (a.right - a.left);
    //measure square overlap relative to the min square
    var targetSquare = $c1e19f5177c63f8e$var$min(aSquare, bSquare);
    //minimal overlap ratio
    tolerance = tolerance !== undefined ? tolerance : 0.5;
    if (iSquare / targetSquare > tolerance) return true;
    return false;
}



var $cd96cea0cac21320$exports = {};
/**
 * @module emmy/on
 */ var $2478d9b7975c39e7$exports = {};
/**
 * @module Icicle
 */ $2478d9b7975c39e7$exports = {
    freeze: $2478d9b7975c39e7$var$lock,
    unfreeze: $2478d9b7975c39e7$var$unlock,
    isFrozen: $2478d9b7975c39e7$var$isLocked
};
/** Set of targets  */ var $2478d9b7975c39e7$var$lockCache = new WeakMap;
/**
 * Set flag on target with the name passed
 *
 * @return {bool} Whether lock succeeded
 */ function $2478d9b7975c39e7$var$lock(target, name) {
    var locks = $2478d9b7975c39e7$var$lockCache.get(target);
    if (locks && locks[name]) return false;
    //create lock set for a target, if none
    if (!locks) {
        locks = {};
        $2478d9b7975c39e7$var$lockCache.set(target, locks);
    }
    //set a new lock
    locks[name] = true;
    //return success
    return true;
}
/**
 * Unset flag on the target with the name passed.
 *
 * Note that if to return new value from the lock/unlock,
 * then unlock will always return false and lock will always return true,
 * which is useless for the user, though maybe intuitive.
 *
 * @param {*} target Any object
 * @param {string} name A flag name
 *
 * @return {bool} Whether unlock failed.
 */ function $2478d9b7975c39e7$var$unlock(target, name) {
    var locks = $2478d9b7975c39e7$var$lockCache.get(target);
    if (!locks || !locks[name]) return false;
    locks[name] = null;
    return true;
}
/**
 * Return whether flag is set
 *
 * @param {*} target Any object to associate lock with
 * @param {string} name A flag name
 *
 * @return {Boolean} Whether locked or not
 */ function $2478d9b7975c39e7$var$isLocked(target, name) {
    var locks = $2478d9b7975c39e7$var$lockCache.get(target);
    return locks && locks[name];
}


var $44e77696f5ea169c$exports = {};
/**
 * A storage of per-target callbacks.
 * WeakMap is the most safe solution.
 *
 * @module emmy/listeners
 */ /**
 * Property name to provide on targets.
 *
 * Can’t use global WeakMap -
 * it is impossible to provide singleton global cache of callbacks for targets
 * not polluting global scope. So it is better to pollute target scope than the global.
 *
 * Otherwise, each emmy instance will create it’s own cache, which leads to mess.
 *
 * Also can’t use `._events` property on targets, as it is done in `events` module,
 * because it is incompatible. Emmy targets universal events wrapper, not the native implementation.
 *
 */ //FIXME: new npm forces flat modules structure, so weakmaps are better providing that there’s the one emmy across the project.
var $44e77696f5ea169c$var$cbPropName = '_callbacks';
/**
 * Get listeners for the target/evt (optionally).
 *
 * @param {object} target a target object
 * @param {string}? evt an evt name, if undefined - return object with events
 *
 * @return {(object|array)} List/set of listeners
 */ function $44e77696f5ea169c$var$listeners(target, evt, tags) {
    var cbs = target[$44e77696f5ea169c$var$cbPropName];
    var result;
    if (!evt) {
        result = cbs || {};
        //filter cbs by tags
        if (tags) {
            var filteredResult = {};
            for(var evt in result)filteredResult[evt] = result[evt].filter(function(cb) {
                return $44e77696f5ea169c$var$hasTags(cb, tags);
            });
            result = filteredResult;
        }
        return result;
    }
    if (!cbs || !cbs[evt]) return [];
    result = cbs[evt];
    //if there are evt namespaces specified - filter callbacks
    if (tags && tags.length) result = result.filter(function(cb) {
        return $44e77696f5ea169c$var$hasTags(cb, tags);
    });
    return result;
}
/**
 * Remove listener, if any
 */ $44e77696f5ea169c$var$listeners.remove = function(target, evt, cb, tags) {
    //get callbacks for the evt
    var evtCallbacks = target[$44e77696f5ea169c$var$cbPropName];
    if (!evtCallbacks || !evtCallbacks[evt]) return false;
    var callbacks = evtCallbacks[evt];
    //if tags are passed - make sure callback has some tags before removing
    if (tags && tags.length && !$44e77696f5ea169c$var$hasTags(cb, tags)) return false;
    //remove specific handler
    for(var i = 0; i < callbacks.length; i++)//once method has original callback in .cb
    if (callbacks[i] === cb || callbacks[i].fn === cb) {
        callbacks.splice(i, 1);
        break;
    }
};
/**
 * Add a new listener
 */ $44e77696f5ea169c$var$listeners.add = function(target, evt, cb, tags) {
    if (!cb) return;
    var targetCallbacks = target[$44e77696f5ea169c$var$cbPropName];
    //ensure set of callbacks for the target exists
    if (!targetCallbacks) {
        targetCallbacks = {};
        Object.defineProperty(target, $44e77696f5ea169c$var$cbPropName, {
            value: targetCallbacks
        });
    }
    //save a new callback
    (targetCallbacks[evt] = targetCallbacks[evt] || []).push(cb);
    //save ns for a callback, if any
    if (tags && tags.length) cb._ns = tags;
};
/** Detect whether an cb has at least one tag from the list */ function $44e77696f5ea169c$var$hasTags(cb, tags) {
    if (cb._ns) //if cb is tagged with a ns and includes one of the ns passed - keep it
    for(var i = tags.length; i--;){
        if (cb._ns.indexOf(tags[i]) >= 0) return true;
    }
}
$44e77696f5ea169c$exports = $44e77696f5ea169c$var$listeners;


var $df0fec22a513d2ce$exports = {};
'use strict';
var $df0fec22a513d2ce$var$toString = Object.prototype.toString;
$df0fec22a513d2ce$exports = function(x) {
    var prototype;
    return $df0fec22a513d2ce$var$toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
};


$cd96cea0cac21320$exports = $cd96cea0cac21320$var$on;
/**
 * Bind fn to a target.
 *
 * @param {*} targte A single target to bind evt
 * @param {string} evt An event name
 * @param {Function} fn A callback
 * @param {Function}? condition An optional filtering fn for a callback
 *                              which accepts an event and returns callback
 *
 * @return {object} A target
 */ function $cd96cea0cac21320$var$on(target, evt, fn) {
    if (!target) return target;
    //consider object of events
    if ($df0fec22a513d2ce$exports(evt)) {
        for(var evtName in evt)$cd96cea0cac21320$var$on(target, evtName, evt[evtName]);
        return target;
    }
    //get target `on` method, if any
    //prefer native-like method name
    //user may occasionally expose `on` to the global, in case of browserify
    //but it is unlikely one would replace native `addEventListener`
    var onMethod = target['addEventListener'] || target['addListener'] || target['attachEvent'] || target['on'];
    var cb = fn;
    evt = '' + evt;
    //invoke method for each space-separated event from a list
    evt.split(/\s+/).forEach(function(evt) {
        var evtParts = evt.split('.');
        evt = evtParts.shift();
        //use target event system, if possible
        if (onMethod) {
            //avoid self-recursions
            //if it’s frozen - ignore call
            if ($2478d9b7975c39e7$exports.freeze(target, 'on' + evt)) {
                onMethod.call(target, evt, cb);
                $2478d9b7975c39e7$exports.unfreeze(target, 'on' + evt);
            } else return target;
        }
        //save the callback anyway
        $44e77696f5ea169c$exports.add(target, evt, cb, evtParts);
    });
    return target;
}
/**
 * Wrap an fn with condition passing
 */ $cd96cea0cac21320$var$on.wrap = function(target, evt, fn, condition) {
    var cb = function() {
        if (condition.apply(target, arguments)) return fn.apply(target, arguments);
    };
    cb.fn = fn;
    return cb;
};


var $3901a5159c6fac4b$exports = {};
/**
 * @module emmy/off
 */ $3901a5159c6fac4b$exports = $3901a5159c6fac4b$var$off;


var $5p9yL = parcelRequire("5p9yL");

/**
 * Remove listener[s] from the target
 *
 * @param {[type]} evt [description]
 * @param {Function} fn [description]
 *
 * @return {[type]} [description]
 */ function $3901a5159c6fac4b$var$off(target, evt, fn) {
    if (!target) return target;
    var callbacks, i;
    //unbind all listeners if no fn specified
    if (fn === undefined) {
        var args = $5p9yL(arguments, 1);
        //try to use target removeAll method, if any
        var allOff = target['removeAll'] || target['removeAllListeners'];
        //call target removeAll
        if (allOff) allOff.apply(target, args);
        //then forget own callbacks, if any
        //unbind all evts
        if (!evt) {
            callbacks = $44e77696f5ea169c$exports(target);
            for(evt in callbacks)$3901a5159c6fac4b$var$off(target, evt);
        } else {
            evt = '' + evt;
            //invoke method for each space-separated event from a list
            evt.split(/\s+/).forEach(function(evt) {
                var evtParts = evt.split('.');
                evt = evtParts.shift();
                callbacks = $44e77696f5ea169c$exports(target, evt, evtParts);
                //returned array of callbacks (as event is defined)
                if (evt) {
                    var obj = {};
                    obj[evt] = callbacks;
                    callbacks = obj;
                }
                //for each group of callbacks - unbind all
                for(var evtName in callbacks)$5p9yL(callbacks[evtName]).forEach(function(cb) {
                    $3901a5159c6fac4b$var$off(target, evtName, cb);
                });
            });
        }
        return target;
    }
    //target events (string notation to advanced_optimizations)
    var offMethod = target['removeEventListener'] || target['removeListener'] || target['detachEvent'] || target['off'];
    //invoke method for each space-separated event from a list
    evt.split(/\s+/).forEach(function(evt) {
        var evtParts = evt.split('.');
        evt = evtParts.shift();
        //use target `off`, if possible
        if (offMethod) {
            //avoid self-recursion from the outside
            if ($2478d9b7975c39e7$exports.freeze(target, 'off' + evt)) {
                offMethod.call(target, evt, fn);
                $2478d9b7975c39e7$exports.unfreeze(target, 'off' + evt);
            } else return target;
        }
        if (fn.closedCall) fn.closedCall = false;
        //forget callback
        $44e77696f5ea169c$exports.remove(target, evt, fn, evtParts);
    });
    return target;
}


var $efd77a5002f9972b$exports = {};
/**
 * @module emmy/emit
 */ 

var $5p9yL = parcelRequire("5p9yL");

var $28d093ceefbd7a9c$exports = {};
$28d093ceefbd7a9c$exports = true;


/**
 * A simple wrapper to handle stringy/plain events
 */ $efd77a5002f9972b$exports = function(target, evt) {
    if (!target) return;
    var args = arguments;
    if (typeof evt === 'string') {
        args = $5p9yL(arguments, 2);
        evt.split(/\s+/).forEach(function(evt) {
            evt = evt.split('.')[0];
            $efd77a5002f9972b$var$emit.apply(this, [
                target,
                evt
            ].concat(args));
        });
    } else return $efd77a5002f9972b$var$emit.apply(this, args);
};
/** detect env */ var $efd77a5002f9972b$var$$ = typeof jQuery === 'undefined' ? undefined : jQuery;
var $efd77a5002f9972b$var$doc = typeof document === 'undefined' ? undefined : document;
var $efd77a5002f9972b$var$win = typeof window === 'undefined' ? undefined : window;
/**
 * Emit an event, optionally with data or bubbling
 * Accept only single elements/events
 *
 * @param {string} eventName An event name, e. g. 'click'
 * @param {*} data Any data to pass to event.details (DOM) or event.data (elsewhere)
 * @param {bool} bubbles Whether to trigger bubbling event (DOM)
 *
 *
 * @return {target} a target
 */ function $efd77a5002f9972b$var$emit(target, eventName, data, bubbles) {
    var emitMethod, evt = eventName;
    //Create proper event for DOM objects
    if ($28d093ceefbd7a9c$exports && (target instanceof Node || target === $efd77a5002f9972b$var$win)) {
        //NOTE: this doesnot bubble on off-DOM elements
        if ($28d093ceefbd7a9c$exports && eventName instanceof Event) evt = eventName;
        else {
            //IE9-compliant constructor
            evt = $efd77a5002f9972b$var$doc.createEvent('CustomEvent');
            evt.initCustomEvent(eventName, bubbles, true, data);
        //a modern constructor would be:
        // var evt = new CustomEvent(eventName, { detail: data, bubbles: bubbles })
        }
        emitMethod = target.dispatchEvent;
    } else if ($efd77a5002f9972b$var$$ && target instanceof $efd77a5002f9972b$var$$) {
        //TODO: decide how to pass data
        evt = $efd77a5002f9972b$var$$.Event(eventName, data);
        evt.detail = data;
        //FIXME: reference case where triggerHandler needed (something with multiple calls)
        emitMethod = bubbles ? targte.trigger : target.triggerHandler;
    } else //emit - default
    //trigger - jquery
    //dispatchEvent - DOM
    //raise - node-state
    //fire - ???
    emitMethod = target['dispatchEvent'] || target['emit'] || target['trigger'] || target['fire'] || target['raise'];
    var args = $5p9yL(arguments, 2);
    //use locks to avoid self-recursion on objects wrapping this method
    if (emitMethod) {
        if ($2478d9b7975c39e7$exports.freeze(target, 'emit' + eventName)) {
            //use target event system, if possible
            emitMethod.apply(target, [
                evt
            ].concat(args));
            $2478d9b7975c39e7$exports.unfreeze(target, 'emit' + eventName);
            return target;
        }
    }
    //fall back to default event system
    var evtCallbacks = $44e77696f5ea169c$exports(target, evt);
    //copy callbacks to fire because list can be changed by some callback (like `off`)
    var fireList = $5p9yL(evtCallbacks);
    for(var i = 0; i < fireList.length; i++)fireList[i] && fireList[i].apply(target, args);
    return target;
}


var $f50e8fa8c10c9eff$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $f50e8fa8c10c9eff$var$R = typeof Reflect === 'object' ? Reflect : null;
var $f50e8fa8c10c9eff$var$ReflectApply = $f50e8fa8c10c9eff$var$R && typeof $f50e8fa8c10c9eff$var$R.apply === 'function' ? $f50e8fa8c10c9eff$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $f50e8fa8c10c9eff$var$ReflectOwnKeys;
if ($f50e8fa8c10c9eff$var$R && typeof $f50e8fa8c10c9eff$var$R.ownKeys === 'function') $f50e8fa8c10c9eff$var$ReflectOwnKeys = $f50e8fa8c10c9eff$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $f50e8fa8c10c9eff$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $f50e8fa8c10c9eff$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $f50e8fa8c10c9eff$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $f50e8fa8c10c9eff$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $f50e8fa8c10c9eff$var$EventEmitter() {
    $f50e8fa8c10c9eff$var$EventEmitter.init.call(this);
}
$f50e8fa8c10c9eff$exports = $f50e8fa8c10c9eff$var$EventEmitter;
$f50e8fa8c10c9eff$exports.once = $f50e8fa8c10c9eff$var$once;
// Backwards-compat with node 0.10.x
$f50e8fa8c10c9eff$var$EventEmitter.EventEmitter = $f50e8fa8c10c9eff$var$EventEmitter;
$f50e8fa8c10c9eff$var$EventEmitter.prototype._events = undefined;
$f50e8fa8c10c9eff$var$EventEmitter.prototype._eventsCount = 0;
$f50e8fa8c10c9eff$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $f50e8fa8c10c9eff$var$defaultMaxListeners = 10;
function $f50e8fa8c10c9eff$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($f50e8fa8c10c9eff$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $f50e8fa8c10c9eff$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $f50e8fa8c10c9eff$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $f50e8fa8c10c9eff$var$defaultMaxListeners = arg;
    }
});
$f50e8fa8c10c9eff$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$f50e8fa8c10c9eff$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $f50e8fa8c10c9eff$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $f50e8fa8c10c9eff$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $f50e8fa8c10c9eff$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$f50e8fa8c10c9eff$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $f50e8fa8c10c9eff$var$_getMaxListeners(this);
};
$f50e8fa8c10c9eff$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $f50e8fa8c10c9eff$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $f50e8fa8c10c9eff$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$f50e8fa8c10c9eff$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $f50e8fa8c10c9eff$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $f50e8fa8c10c9eff$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $f50e8fa8c10c9eff$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $f50e8fa8c10c9eff$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$f50e8fa8c10c9eff$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $f50e8fa8c10c9eff$var$_addListener(this, type, listener, false);
};
$f50e8fa8c10c9eff$var$EventEmitter.prototype.on = $f50e8fa8c10c9eff$var$EventEmitter.prototype.addListener;
$f50e8fa8c10c9eff$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $f50e8fa8c10c9eff$var$_addListener(this, type, listener, true);
};
function $f50e8fa8c10c9eff$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $f50e8fa8c10c9eff$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $f50e8fa8c10c9eff$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$f50e8fa8c10c9eff$var$EventEmitter.prototype.once = function once(type, listener) {
    $f50e8fa8c10c9eff$var$checkListener(listener);
    this.on(type, $f50e8fa8c10c9eff$var$_onceWrap(this, type, listener));
    return this;
};
$f50e8fa8c10c9eff$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $f50e8fa8c10c9eff$var$checkListener(listener);
    this.prependListener(type, $f50e8fa8c10c9eff$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$f50e8fa8c10c9eff$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $f50e8fa8c10c9eff$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $f50e8fa8c10c9eff$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$f50e8fa8c10c9eff$var$EventEmitter.prototype.off = $f50e8fa8c10c9eff$var$EventEmitter.prototype.removeListener;
$f50e8fa8c10c9eff$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $f50e8fa8c10c9eff$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $f50e8fa8c10c9eff$var$unwrapListeners(evlistener) : $f50e8fa8c10c9eff$var$arrayClone(evlistener, evlistener.length);
}
$f50e8fa8c10c9eff$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $f50e8fa8c10c9eff$var$_listeners(this, type, true);
};
$f50e8fa8c10c9eff$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $f50e8fa8c10c9eff$var$_listeners(this, type, false);
};
$f50e8fa8c10c9eff$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $f50e8fa8c10c9eff$var$listenerCount.call(emitter, type);
};
$f50e8fa8c10c9eff$var$EventEmitter.prototype.listenerCount = $f50e8fa8c10c9eff$var$listenerCount;
function $f50e8fa8c10c9eff$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$f50e8fa8c10c9eff$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $f50e8fa8c10c9eff$var$ReflectOwnKeys(this._events) : [];
};
function $f50e8fa8c10c9eff$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $f50e8fa8c10c9eff$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $f50e8fa8c10c9eff$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $f50e8fa8c10c9eff$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $f50e8fa8c10c9eff$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $f50e8fa8c10c9eff$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $f50e8fa8c10c9eff$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $f50e8fa8c10c9eff$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $f50e8fa8c10c9eff$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


var $370770ee1fd34d9f$exports = {};
/**
 * Get clientY/clientY from an event.
 * If index is passed, treat it as index of global touches, not the targetTouches.
 * Global touches include target touches.
 *
 * @module get-client-xy
 *
 * @param {Event} e Event raised, like mousemove
 *
 * @return {number} Coordinate relative to the screen
 */ function $370770ee1fd34d9f$var$getClientY(e, idx) {
    // touch event
    if (e.touches) {
        if (arguments.length > 1) return $370770ee1fd34d9f$var$findTouch(e.touches, idx).clientY;
        else return e.targetTouches[0].clientY;
    }
    // mouse event
    return e.clientY;
}
function $370770ee1fd34d9f$var$getClientX(e, idx) {
    // touch event
    if (e.touches) {
        if (arguments.length > idx) return $370770ee1fd34d9f$var$findTouch(e.touches, idx).clientX;
        else return e.targetTouches[0].clientX;
    }
    // mouse event
    return e.clientX;
}
function $370770ee1fd34d9f$var$getClientXY(e, idx) {
    return [
        $370770ee1fd34d9f$var$getClientX.apply(this, arguments),
        $370770ee1fd34d9f$var$getClientY.apply(this, arguments)
    ];
}
function $370770ee1fd34d9f$var$findTouch(touchList, idx) {
    for(var i = 0; i < touchList.length; i++){
        if (touchList[i].identifier === idx) return touchList[i];
    }
}
$370770ee1fd34d9f$var$getClientXY.x = $370770ee1fd34d9f$var$getClientX;
$370770ee1fd34d9f$var$getClientXY.y = $370770ee1fd34d9f$var$getClientY;
$370770ee1fd34d9f$var$getClientXY.findTouch = $370770ee1fd34d9f$var$findTouch;
$370770ee1fd34d9f$exports = $370770ee1fd34d9f$var$getClientXY;


var $6172e0e421d1d549$require$getClientX = $370770ee1fd34d9f$exports.x;

var $6172e0e421d1d549$require$getClientY = $370770ee1fd34d9f$exports.y;
var $6b441d0d894731d6$exports = {};
$6b441d0d894731d6$exports = function(a) {
    return a instanceof Array;
};


var $33dfdc247bd7b288$exports = {};
$33dfdc247bd7b288$exports = function(a) {
    return typeof a === 'number' || a instanceof Number;
};


var $5e422359e9e48099$exports = {};
$5e422359e9e48099$exports = function(a) {
    return typeof a === 'string' || a instanceof String;
};


var $867943181515e62b$exports = {};
$867943181515e62b$exports = function(a) {
    return !!(a && a.apply);
};


var $0b8087d3bbd8505a$exports = {};
/**
 * Define stateful property on an object
 */ $0b8087d3bbd8505a$exports = $0b8087d3bbd8505a$var$defineState;
var $de07c1c6c6bb9b2e$exports = {};
/**
 * @module  st8
 *
 * Micro state machine.
 */ 
var $8a91bddf3bd7e369$exports = {};
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
var $54fbf31756b42fcf$exports = {};
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ 'use strict';
$54fbf31756b42fcf$exports = function isObject(val) {
    return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


function $8a91bddf3bd7e369$var$isObjectObject(o) {
    return $54fbf31756b42fcf$exports(o) === true && Object.prototype.toString.call(o) === '[object Object]';
}
$8a91bddf3bd7e369$exports = function isPlainObject(o) {
    var ctor, prot;
    if ($8a91bddf3bd7e369$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (typeof ctor !== 'function') return false;
    // If has modified prototype
    prot = ctor.prototype;
    if ($8a91bddf3bd7e369$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
};


/** Defaults */ $de07c1c6c6bb9b2e$var$State.options = {
    leaveCallback: 'after',
    enterCallback: 'before',
    changeCallback: 'change',
    remainderState: '_'
};
/**
 * Create a new state controller based on states passed
 *
 * @constructor
 *
 * @param {object} settings Initial states
 */ function $de07c1c6c6bb9b2e$var$State(states, context) {
    //ignore existing state
    if (states instanceof $de07c1c6c6bb9b2e$var$State) return states;
    //ensure new state instance is created
    if (!(this instanceof $de07c1c6c6bb9b2e$var$State)) return new $de07c1c6c6bb9b2e$var$State(states);
    //save states object
    this.states = states || {};
    //save context
    this.context = context || this;
    //initedFlag
    this.isInit = false;
}
/** Inherit State from Emitter */ var $de07c1c6c6bb9b2e$var$proto = $de07c1c6c6bb9b2e$var$State.prototype = Object.create($f50e8fa8c10c9eff$exports.prototype);
/**
 * Go to a state
 *
 * @param {*} value Any new state to enter
 */ $de07c1c6c6bb9b2e$var$proto.set = function(value) {
    var oldValue = this.state, states = this.states;
    // console.group('set', value, oldValue);
    //leave old state
    var oldStateName = states[oldValue] !== undefined ? oldValue : $de07c1c6c6bb9b2e$var$State.options.remainderState;
    var oldState = states[oldStateName];
    var leaveResult, leaveFlag = $de07c1c6c6bb9b2e$var$State.options.leaveCallback + oldStateName;
    if (this.isInit) {
        if ($8a91bddf3bd7e369$exports(oldState)) {
            if (!this[leaveFlag]) {
                this[leaveFlag] = true;
                //if oldstate has after method - call it
                leaveResult = $de07c1c6c6bb9b2e$var$getValue(oldState, $de07c1c6c6bb9b2e$var$State.options.leaveCallback, this.context);
                //ignore changing if leave result is falsy
                if (leaveResult === false) {
                    this[leaveFlag] = false;
                    // console.groupEnd();
                    return false;
                } else if (leaveResult !== undefined && leaveResult !== value) {
                    this.set(leaveResult);
                    this[leaveFlag] = false;
                    // console.groupEnd();
                    return false;
                }
                this[leaveFlag] = false;
                //ignore redirect
                if (this.state !== oldValue) return;
            }
        }
        //ignore not changed value
        if (value === oldValue) return false;
    } else this.isInit = true;
    //set current value
    this.state = value;
    //try to enter new state
    var newStateName = states[value] !== undefined ? value : $de07c1c6c6bb9b2e$var$State.options.remainderState;
    var newState = states[newStateName];
    var enterFlag = $de07c1c6c6bb9b2e$var$State.options.enterCallback + newStateName;
    var enterResult;
    if (!this[enterFlag]) {
        this[enterFlag] = true;
        if ($8a91bddf3bd7e369$exports(newState)) enterResult = $de07c1c6c6bb9b2e$var$getValue(newState, $de07c1c6c6bb9b2e$var$State.options.enterCallback, this.context);
        else enterResult = $de07c1c6c6bb9b2e$var$getValue(states, newStateName, this.context);
        //ignore entering falsy state
        if (enterResult === false) {
            this.set(oldValue);
            this[enterFlag] = false;
            // console.groupEnd();
            return false;
        } else if (enterResult !== undefined && enterResult !== value) {
            this.set(enterResult);
            this[enterFlag] = false;
            // console.groupEnd();
            return false;
        }
        this[enterFlag] = false;
    }
    //notify change
    if (value !== oldValue) this.emit($de07c1c6c6bb9b2e$var$State.options.changeCallback, value, oldValue);
    // console.groupEnd();
    //return context to chain calls
    return this.context;
};
/** Get current state */ $de07c1c6c6bb9b2e$var$proto.get = function() {
    return this.state;
};
/** Return value or fn result */ function $de07c1c6c6bb9b2e$var$getValue(holder, meth, ctx) {
    if (typeof holder[meth] === 'function') return holder[meth].call(ctx);
    return holder[meth];
}
$de07c1c6c6bb9b2e$exports = $de07c1c6c6bb9b2e$var$State;


/**
 * Define stateful property on a target
 *
 * @param {object} target Any object
 * @param {string} property Property name
 * @param {object} descriptor State descriptor
 *
 * @return {object} target
 */ function $0b8087d3bbd8505a$var$defineState(target, property, descriptor, isFn) {
    //define accessor on a target
    if (isFn) target[property] = function() {
        if (arguments.length) return state.set(arguments[0]);
        else return state.get();
    };
    else Object.defineProperty(target, property, {
        set: function(value) {
            return state.set(value);
        },
        get: function() {
            return state.get();
        }
    });
    //define state controller
    var state = new $de07c1c6c6bb9b2e$exports(descriptor, target);
    return target;
}


var $c4df3b81eac1607d$exports = {};
$c4df3b81eac1607d$exports = $c4df3b81eac1607d$var$extend;
var $c4df3b81eac1607d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c4df3b81eac1607d$var$extend(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($c4df3b81eac1607d$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}


var $d853c262e9af9f9f$exports = {};
/**
 * Precision round
 *
 * @param {number} value
 * @param {number} step Minimal discrete to round
 *
 * @return {number}
 *
 * @example
 * toPrecision(213.34, 1) == 213
 * toPrecision(213.34, .1) == 213.3
 * toPrecision(213.34, 10) == 210
 */ var $1bc84fd82a6f729a$exports = {};
/**
 * @module  mumath/precision
 *
 * Get precision from float:
 *
 * @example
 * 1.1 → 1, 1234 → 0, .1234 → 4
 *
 * @param {number} n
 *
 * @return {number} decimap places
 */ 
$1bc84fd82a6f729a$exports = (parcelRequire("jDX6j"))(function(n) {
    var s = n + '', d = s.indexOf('.') + 1;
    return !d ? 0 : s.length - d;
});



$d853c262e9af9f9f$exports = (parcelRequire("jDX6j"))(function(value, step) {
    if (step === 0) return value;
    if (!step) return Math.round(value);
    step = parseFloat(step);
    value = Math.round(value / step) * step;
    return parseFloat(value.toFixed($1bc84fd82a6f729a$exports(step)));
});


var $27a8f87749bf0962$exports = {};
/**
 * Clamp value.
 * Detects proper clamp min/max.
 *
 * @param {number} a Current value to cut off
 * @param {number} min One side limit
 * @param {number} max Other side limit
 *
 * @return {number} Clamped value
 */ 
$27a8f87749bf0962$exports = (parcelRequire("jDX6j"))(function(a, min, max) {
    return max > min ? Math.max(Math.min(a, max), min) : Math.max(Math.min(a, min), max);
});


var $6f2f3a4b5cb53cba$exports = {};
/**
 * Looping function for any framesize.
 * Like fmod.
 *
 * @module  mumath/loop
 *
 */ 
$6f2f3a4b5cb53cba$exports = (parcelRequire("jDX6j"))(function(value, left, right) {
    //detect single-arg case, like mod-loop or fmod
    if (right === undefined) {
        right = left;
        left = 0;
    }
    //swap frame order
    if (left > right) {
        var tmp = right;
        right = left;
        left = tmp;
    }
    var frame = right - left;
    value = (value + left) % frame - left;
    if (value < left) value += frame;
    if (value > right) value -= frame;
    return value;
});


var $327f740a53faffcd$exports = {};
/** generate unique id for selector */ var $327f740a53faffcd$var$counter = Date.now() % 1e9;
$327f740a53faffcd$exports = function getUid() {
    return (Math.random() * 1e9 >>> 0) + $327f740a53faffcd$var$counter++;
};


var $63781c85fa40606c$exports = {};
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
$63781c85fa40606c$exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};
else // old school shim for old browsers
$63781c85fa40606c$exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
};


const $6172e0e421d1d549$var$win = window, $6172e0e421d1d549$var$doc = document, $6172e0e421d1d549$var$root = $6172e0e421d1d549$var$doc.documentElement;
/**
 * Draggable controllers associated with elements.
 *
 * Storing them on elements is
 * - leak-prone,
 * - pollutes element’s namespace,
 * - requires some artificial key to store,
 * - unable to retrieve controller easily.
 *
 * That is why weakmap.
 */ const $6172e0e421d1d549$var$draggableCache = $6172e0e421d1d549$var$Draggable.cache = new WeakMap;
/**
 * Make an element draggable.
 *
 * @constructor
 *
 * @param {HTMLElement} target An element whether in/out of DOM
 * @param {Object} options An draggable options
 *
 * @return {HTMLElement} Target element
 */ function $6172e0e421d1d549$var$Draggable(target, options) {
    if (!(this instanceof $6172e0e421d1d549$var$Draggable)) return new $6172e0e421d1d549$var$Draggable(target, options);
    var that = this;
    //ignore existing instance
    var instance = $6172e0e421d1d549$var$draggableCache.get(target);
    if (instance) {
        instance.state = 'reset';
        //take over options
        $c4df3b81eac1607d$exports(instance, options);
        instance.update();
        return instance;
    } else {
        //get unique id for instance
        //needed to track event binders
        that.id = $327f740a53faffcd$exports();
        that._ns = '.draggy_' + that.id;
        //save element passed
        that.element = target;
        $6172e0e421d1d549$var$draggableCache.set(target, that);
    }
    //define state behaviour
    $0b8087d3bbd8505a$exports(that, 'state', that.state);
    //preset handles
    that.currentHandles = [];
    //take over options
    $c4df3b81eac1607d$exports(that, options);
    //define handle
    if (that.handle === undefined) that.handle = that.element;
    //setup droppable
    if (that.droppable) that.initDroppable();
    //try to calc out basic limits
    that.update();
    //go to initial state
    that.state = 'idle';
}
/** Inherit draggable from Emitter */ $63781c85fa40606c$exports($6172e0e421d1d549$var$Draggable, $f50e8fa8c10c9eff$exports);
//enable css3 by default
$6172e0e421d1d549$var$Draggable.prototype.css3 = true;
//both axes by default
$6172e0e421d1d549$var$Draggable.prototype.axis = null;
/** Init droppable "plugin" */ $6172e0e421d1d549$var$Draggable.prototype.initDroppable = function() {
    var that = this;
    $cd96cea0cac21320$exports(that, 'dragstart', function() {
        var that = this;
        that.dropTargets = $6172e0e421d1d549$var$q(that.droppable);
    });
    $cd96cea0cac21320$exports(that, 'drag', function() {
        var that = this;
        if (!that.dropTargets) return;
        var thatRect = $961f65bdbb29e89e$exports(that.element);
        that.dropTargets.forEach(function(dropTarget) {
            var targetRect = $961f65bdbb29e89e$exports(dropTarget);
            if ($c1e19f5177c63f8e$exports(thatRect, targetRect, that.droppableTolerance)) {
                if (that.droppableClass) dropTarget.classList.add(that.droppableClass);
                if (!that.dropTarget) {
                    that.dropTarget = dropTarget;
                    $efd77a5002f9972b$exports(that, 'dragover', dropTarget);
                    $efd77a5002f9972b$exports(dropTarget, 'dragover', that);
                }
            } else {
                if (that.dropTarget) {
                    $efd77a5002f9972b$exports(that, 'dragout', dropTarget);
                    $efd77a5002f9972b$exports(dropTarget, 'dragout', that);
                    that.dropTarget = null;
                }
                if (that.droppableClass) dropTarget.classList.remove(that.droppableClass);
            }
        });
    });
    $cd96cea0cac21320$exports(that, 'dragend', function() {
        var that = this;
        //emit drop, if any
        if (that.dropTarget) {
            $efd77a5002f9972b$exports(that.dropTarget, 'drop', that);
            $efd77a5002f9972b$exports(that, 'drop', that.dropTarget);
            that.dropTarget.classList.remove(that.droppableClass);
            that.dropTarget = null;
        }
    });
};
/**
 * Draggable behaviour
 * @enum {string}
 * @default is 'idle'
 */ $6172e0e421d1d549$var$Draggable.prototype.state = {
    //idle
    _: {
        before: function() {
            var that = this;
            that.element.classList.add('draggy-idle');
            //emit drag evts on element
            $efd77a5002f9972b$exports(that.element, 'idle', null, true);
            that.emit('idle');
            //reset keys
            that.ctrlKey = false;
            that.shiftKey = false;
            that.metaKey = false;
            that.altKey = false;
            //reset movement params
            that.movementX = 0;
            that.movementY = 0;
            that.deltaX = 0;
            that.deltaY = 0;
            $cd96cea0cac21320$exports($6172e0e421d1d549$var$doc, 'mousedown' + that._ns + ' touchstart' + that._ns, function(e) {
                //ignore non-draggy events
                if (!e.draggies) return;
                //ignore dragstart for not registered draggies
                if (e.draggies.indexOf(that) < 0) return;
                //if target is focused - ignore drag
                //FIXME: detect focused by whitelist of tags, name supposition may be wrong (idk, form elements have names, so likely to be focused by click)
                if (e.target.name !== undefined) return;
                //multitouch has multiple starts
                that.setTouch(e);
                //update movement params
                that.update(e);
                //go to threshold state
                that.state = 'threshold';
            });
        },
        after: function() {
            var that = this;
            that.element.classList.remove('draggy-idle');
            $3901a5159c6fac4b$exports($6172e0e421d1d549$var$doc, that._ns);
            //set up tracking
            if (that.release) that._trackingInterval = setInterval(function(e) {
                var now = Date.now();
                var elapsed = now - that.timestamp;
                //get delta movement since the last track
                var dX = that.prevX - that.frame[0];
                var dY = that.prevY - that.frame[1];
                that.frame[0] = that.prevX;
                that.frame[1] = that.prevY;
                var delta = Math.sqrt(dX * dX + dY * dY);
                //get speed as average of prev and current (prevent div by zero)
                var v = Math.min(that.velocity * delta / (1 + elapsed), that.maxSpeed);
                that.speed = 0.8 * v + 0.2 * that.speed;
                //get new angle as a last diff
                //NOTE: vector average isn’t the same as speed scalar average
                that.angle = Math.atan2(dY, dX);
                that.emit('track');
                return that;
            }, that.framerate);
        }
    },
    threshold: {
        before: function() {
            var that = this;
            //ignore threshold state, if threshold is none
            if ($6172e0e421d1d549$var$isZeroArray(that.threshold)) {
                that.state = 'drag';
                return;
            }
            that.element.classList.add('draggy-threshold');
            //emit drag evts on element
            that.emit('threshold');
            $efd77a5002f9972b$exports(that.element, 'threshold');
            //listen to doc movement
            $cd96cea0cac21320$exports($6172e0e421d1d549$var$doc, 'touchmove' + that._ns + ' mousemove' + that._ns, function(e) {
                e.preventDefault();
                //compare movement to the threshold
                var clientX = $6172e0e421d1d549$require$getClientX(e, that.touchIdx);
                var clientY = $6172e0e421d1d549$require$getClientY(e, that.touchIdx);
                var difX = that.prevMouseX - clientX;
                var difY = that.prevMouseY - clientY;
                if (difX < that.threshold[0] || difX > that.threshold[2] || difY < that.threshold[1] || difY > that.threshold[3]) {
                    that.update(e);
                    that.state = 'drag';
                }
            });
            $cd96cea0cac21320$exports($6172e0e421d1d549$var$doc, 'mouseup' + that._ns + ' touchend' + that._ns + '', function(e) {
                e.preventDefault();
                //forget touches
                that.resetTouch();
                that.state = 'idle';
            });
        },
        after: function() {
            var that = this;
            that.element.classList.remove('draggy-threshold');
            $3901a5159c6fac4b$exports($6172e0e421d1d549$var$doc, that._ns);
        }
    },
    drag: {
        before: function() {
            var that = this;
            //reduce dragging clutter
            $8c4f1005b02524f0$export$e20fbacbb41798b($6172e0e421d1d549$var$root);
            that.element.classList.add('draggy-drag');
            //emit drag evts on element
            that.emit('dragstart');
            $efd77a5002f9972b$exports(that.element, 'dragstart', null, true);
            //emit drag events on that
            that.emit('drag');
            $efd77a5002f9972b$exports(that.element, 'drag', null, true);
            //stop drag on leave
            $cd96cea0cac21320$exports($6172e0e421d1d549$var$doc, 'touchend' + that._ns + ' mouseup' + that._ns + ' mouseleave' + that._ns, function(e) {
                e.preventDefault();
                //forget touches - dragend is called once
                that.resetTouch();
                //manage release movement
                if (that.speed > 1) that.state = 'release';
                else that.state = 'idle';
            });
            //move via transform
            $cd96cea0cac21320$exports($6172e0e421d1d549$var$doc, 'touchmove' + that._ns + ' mousemove' + that._ns, function(e) {
                that.drag(e);
            });
        },
        after: function() {
            var that = this;
            //enable document interactivity
            $8c4f1005b02524f0$export$d7c4a0dd6a4567e5($6172e0e421d1d549$var$root);
            that.element.classList.remove('draggy-drag');
            //emit dragend on element, this
            that.emit('dragend');
            $efd77a5002f9972b$exports(that.element, 'dragend', null, true);
            //unbind drag events
            $3901a5159c6fac4b$exports($6172e0e421d1d549$var$doc, that._ns);
            clearInterval(that._trackingInterval);
        }
    },
    release: {
        before: function() {
            var that = this;
            that.element.classList.add('draggy-release');
            //enter animation mode
            clearTimeout(that._animateTimeout);
            //set proper transition
            $28f4ea491130cc50$exports(that.element, {
                'transition': that.releaseDuration + 'ms ease-out ' + (that.css3 ? 'transform' : 'position')
            });
            //plan leaving anim mode
            that._animateTimeout = setTimeout(function() {
                that.state = 'idle';
            }, that.releaseDuration);
            //calc target point & animate to it
            that.move(that.prevX + that.speed * Math.cos(that.angle), that.prevY + that.speed * Math.sin(that.angle));
            that.speed = 0;
            that.emit('track');
        },
        after: function() {
            var that = this;
            that.element.classList.remove('draggy-release');
            $28f4ea491130cc50$exports(this.element, {
                'transition': null
            });
        }
    },
    reset: function() {
        var that = this;
        that.currentHandles.forEach(function(handle) {
            $3901a5159c6fac4b$exports(handle, that._ns);
        });
        clearTimeout(that._animateTimeout);
        $3901a5159c6fac4b$exports($6172e0e421d1d549$var$doc, that._ns);
        $3901a5159c6fac4b$exports(that.element, that._ns);
        return '_';
    }
};
/** Drag handler. Needed to provide drag movement emulation via API */ $6172e0e421d1d549$var$Draggable.prototype.drag = function(e) {
    var that = this;
    e.preventDefault();
    var mouseX = $6172e0e421d1d549$require$getClientX(e, that.touchIdx), mouseY = $6172e0e421d1d549$require$getClientY(e, that.touchIdx);
    //calc mouse movement diff
    var diffMouseX = mouseX - that.prevMouseX, diffMouseY = mouseY - that.prevMouseY;
    //absolute mouse coordinate
    var mouseAbsX = mouseX, mouseAbsY = mouseY;
    //if we are not fixed, our absolute position is relative to the doc
    if (!that._isFixed) {
        mouseAbsX += $6172e0e421d1d549$var$win.pageXOffset;
        mouseAbsY += $6172e0e421d1d549$var$win.pageYOffset;
    }
    //calc sniper offset, if any
    if (e.ctrlKey || e.metaKey) {
        that.sniperOffsetX += diffMouseX * that.sniperSlowdown;
        that.sniperOffsetY += diffMouseY * that.sniperSlowdown;
    }
    //save refs to the meta keys
    that.ctrlKey = e.ctrlKey;
    that.shiftKey = e.shiftKey;
    that.metaKey = e.metaKey;
    that.altKey = e.altKey;
    //calc movement x and y
    //take absolute placing as it is the only reliable way (2x proved)
    var x = mouseAbsX - that.initOffsetX - that.innerOffsetX - that.sniperOffsetX, y = mouseAbsY - that.initOffsetY - that.innerOffsetY - that.sniperOffsetY;
    //move element
    that.move(x, y);
    //save prevClientXY for calculating diff
    that.prevMouseX = mouseX;
    that.prevMouseY = mouseY;
    //emit drag
    that.emit('drag');
    $efd77a5002f9972b$exports(that.element, 'drag', null, true);
};
/** Current number of draggable touches */ var $6172e0e421d1d549$var$touches = 0;
/** Manage touches */ $6172e0e421d1d549$var$Draggable.prototype.setTouch = function(e) {
    if (!e.touches || this.isTouched()) return this;
    //current touch index
    this.touchIdx = $6172e0e421d1d549$var$touches;
    $6172e0e421d1d549$var$touches++;
    return this;
};
$6172e0e421d1d549$var$Draggable.prototype.resetTouch = function() {
    $6172e0e421d1d549$var$touches = 0;
    this.touchIdx = null;
    return this;
};
$6172e0e421d1d549$var$Draggable.prototype.isTouched = function() {
    return this.touchIdx !== null;
};
/** Index to fetch touch number from event */ $6172e0e421d1d549$var$Draggable.prototype.touchIdx = null;
/**
 * Update movement limits.
 * Refresh that.withinOffsets and that.limits.
 */ $6172e0e421d1d549$var$Draggable.prototype.update = function(e) {
    var that = this;
    that._isFixed = $03be3eb5d227a2ea$exports(that.element);
    //enforce abs position
    if (!that.css3) $28f4ea491130cc50$exports(this.element, 'position', 'absolute');
    //update handles
    that.currentHandles.forEach(function(handle) {
        $3901a5159c6fac4b$exports(handle, that._ns);
    });
    var cancelEls = $6172e0e421d1d549$var$q(that.cancel);
    that.currentHandles = $6172e0e421d1d549$var$q(that.handle);
    that.currentHandles.forEach(function(handle) {
        $cd96cea0cac21320$exports(handle, 'mousedown' + that._ns + ' touchstart' + that._ns, function(e) {
            //mark event as belonging to the draggy
            if (!e.draggies) e.draggies = [];
            //ignore draggies containing other draggies
            if (e.draggies.some(function(draggy) {
                return that.element.contains(draggy.element);
            })) return;
            //ignore events happened within cancelEls
            if (cancelEls.some(function(cancelEl) {
                return cancelEl.contains(e.target);
            })) return;
            //register draggy
            e.draggies.push(that);
        });
    });
    //update limits
    that.updateLimits();
    //preset inner offsets
    that.innerOffsetX = that.pin[0];
    that.innerOffsetY = that.pin[1];
    var thatClientRect = that.element.getBoundingClientRect();
    //if event passed - update acc to event
    if (e) {
        //take last mouse position from the event
        that.prevMouseX = $6172e0e421d1d549$require$getClientX(e, that.touchIdx);
        that.prevMouseY = $6172e0e421d1d549$require$getClientY(e, that.touchIdx);
        //if mouse is within the element - take offset normally as rel displacement
        that.innerOffsetX = -thatClientRect.left + $6172e0e421d1d549$require$getClientX(e, that.touchIdx);
        that.innerOffsetY = -thatClientRect.top + $6172e0e421d1d549$require$getClientY(e, that.touchIdx);
    } else {
        //take mouse position & inner offset as center of pin
        var pinX = (that.pin[0] + that.pin[2]) * 0.5;
        var pinY = (that.pin[1] + that.pin[3]) * 0.5;
        that.prevMouseX = thatClientRect.left + pinX;
        that.prevMouseY = thatClientRect.top + pinY;
        that.innerOffsetX = pinX;
        that.innerOffsetY = pinY;
    }
    //set initial kinetic props
    that.speed = 0;
    that.amplitude = 0;
    that.angle = 0;
    that.timestamp = +new Date();
    that.frame = [
        that.prevX,
        that.prevY
    ];
    //set sniper offset
    that.sniperOffsetX = 0;
    that.sniperOffsetY = 0;
};
/**
 * Update limits only from current position
 */ $6172e0e421d1d549$var$Draggable.prototype.updateLimits = function() {
    var that = this;
    //initial translation offsets
    var initXY = that.getCoords();
    //calc initial coords
    that.prevX = initXY[0];
    that.prevY = initXY[1];
    that.initX = initXY[0];
    that.initY = initXY[1];
    //container rect might be outside the vp, so calc absolute offsets
    //zero-position offsets, with translation(0,0)
    var thatOffsets = $961f65bdbb29e89e$exports(that.element);
    that.initOffsetX = thatOffsets.left - that.prevX;
    that.initOffsetY = thatOffsets.top - that.prevY;
    that.offsets = thatOffsets;
    //handle parent case
    var within = that.within;
    if (that.within === 'parent' || that.within === true) within = that.element.parentNode;
    within = within || $6172e0e421d1d549$var$doc;
    //absolute offsets of a container
    var withinOffsets = $961f65bdbb29e89e$exports(within);
    if (within === $6172e0e421d1d549$var$win && that._isFixed) {
        withinOffsets.top -= $6172e0e421d1d549$var$win.pageYOffset;
        withinOffsets.left -= $6172e0e421d1d549$var$win.pageXOffset;
        withinOffsets.bottom -= $6172e0e421d1d549$var$win.pageYOffset;
        withinOffsets.right -= $6172e0e421d1d549$var$win.pageXOffset;
    }
    that.withinOffsets = withinOffsets;
    //calculate movement limits - pin width might be wider than constraints
    that.overflowX = that.pin.width - withinOffsets.width;
    that.overflowY = that.pin.height - withinOffsets.height;
    that.limits = {
        left: withinOffsets.left - that.initOffsetX - that.pin[0] - (that.overflowX < 0 ? 0 : that.overflowX),
        top: withinOffsets.top - that.initOffsetY - that.pin[1] - (that.overflowY < 0 ? 0 : that.overflowY),
        right: that.overflowX > 0 ? 0 : withinOffsets.right - that.initOffsetX - that.pin[2],
        bottom: that.overflowY > 0 ? 0 : withinOffsets.bottom - that.initOffsetY - that.pin[3]
    };
};
/**
 * Update info regarding of movement
 */ $6172e0e421d1d549$var$Draggable.prototype.updateInfo = function(x, y) {
    var that = this;
    //provide delta from prev state
    that.deltaX = x - that.prevX;
    that.deltaY = y - that.prevY;
    //save prev coords to use as a start point next time
    that.prevX = x;
    that.prevY = y;
    //provide movement delta from initial state
    that.movementX = x - that.initX;
    that.movementY = y - that.initY;
};
/**
 * Way of placement:
 * - css3 === false (slower but more precise and cross-browser)
 * - css3 === true (faster but may cause blurs on linux systems)
 */ $6172e0e421d1d549$var$Draggable.prototype.getCoords = function() {
    if (!this.css3) // return [this.element.offsetLeft, this.element.offsetTop];
    return [
        $271e553178948144$exports($28f4ea491130cc50$exports(this.element, 'left')),
        $271e553178948144$exports($28f4ea491130cc50$exports(this.element, 'top'))
    ];
    else return $3a496b756ab62db1$exports(this.element).slice(0, 2) || [
        0,
        0
    ];
};
$6172e0e421d1d549$var$Draggable.prototype.setCoords = function(x, y) {
    if (this.css3) {
        if (x == null) x = this.prevX;
        if (y == null) y = this.prevY;
        x = $d853c262e9af9f9f$exports(x, this.precision);
        y = $d853c262e9af9f9f$exports(y, this.precision);
        $28f4ea491130cc50$exports(this.element, 'transform', [
            'translate3d(',
            x,
            'px,',
            y,
            'px, 0)'
        ].join(''));
        this.updateInfo(x, y);
    } else {
        if (x == null) x = this.prevX;
        if (y == null) y = this.prevY;
        x = $d853c262e9af9f9f$exports(x, this.precision);
        y = $d853c262e9af9f9f$exports(y, this.precision);
        $28f4ea491130cc50$exports(this.element, {
            left: x,
            top: y
        });
        //update movement info
        this.updateInfo(x, y);
    }
};
/**
 * Restricting container
 * @type {Element|object}
 * @default doc.documentElement
 */ $6172e0e421d1d549$var$Draggable.prototype.within = $6172e0e421d1d549$var$doc;
/** Handle to drag */ $6172e0e421d1d549$var$Draggable.prototype.handle;
Object.defineProperties($6172e0e421d1d549$var$Draggable.prototype, {
    /**
	 * Which area of draggable should not be outside the restriction area.
	 * @type {(Array|number)}
	 * @default [0,0,this.element.offsetWidth, this.element.offsetHeight]
	 */ pin: {
        set: function(value) {
            if ($6b441d0d894731d6$exports(value)) {
                if (value.length === 2) this._pin = [
                    value[0],
                    value[1],
                    value[0],
                    value[1]
                ];
                else if (value.length === 4) this._pin = value;
            } else if ($33dfdc247bd7b288$exports(value)) this._pin = [
                value,
                value,
                value,
                value
            ];
            else this._pin = value;
            //calc pin params
            this._pin.width = this._pin[2] - this._pin[0];
            this._pin.height = this._pin[3] - this._pin[1];
        },
        get: function() {
            if (this._pin) return this._pin;
            //returning autocalculated pin, if private pin is none
            var pin = [
                0,
                0,
                this.offsets.width,
                this.offsets.height
            ];
            pin.width = this.offsets.width;
            pin.height = this.offsets.height;
            return pin;
        }
    },
    /** Avoid initial mousemove */ threshold: {
        set: function(val) {
            if ($33dfdc247bd7b288$exports(val)) this._threshold = [
                -val * 0.5,
                -val * 0.5,
                val * 0.5,
                val * 0.5
            ];
            else if (val.length === 2) //Array(w,h)
            this._threshold = [
                -val[0] * 0.5,
                -val[1] * 0.5,
                val[0] * 0.5,
                val[1] * 0.5
            ];
            else if (val.length === 4) //Array(x1,y1,x2,y2)
            this._threshold = val;
            else if ($867943181515e62b$exports(val)) //custom val funciton
            this._threshold = val();
            else this._threshold = [
                0,
                0,
                0,
                0
            ];
        },
        get: function() {
            return this._threshold || [
                0,
                0,
                0,
                0
            ];
        }
    }
});
/**
 * For how long to release movement
 *
 * @type {(number|false)}
 * @default false
 * @todo
 */ $6172e0e421d1d549$var$Draggable.prototype.release = false;
$6172e0e421d1d549$var$Draggable.prototype.releaseDuration = 500;
$6172e0e421d1d549$var$Draggable.prototype.velocity = 1000;
$6172e0e421d1d549$var$Draggable.prototype.maxSpeed = 250;
$6172e0e421d1d549$var$Draggable.prototype.framerate = 50;
/** To what extent round position */ $6172e0e421d1d549$var$Draggable.prototype.precision = 1;
/** Droppable params */ $6172e0e421d1d549$var$Draggable.prototype.droppable = null;
$6172e0e421d1d549$var$Draggable.prototype.droppableTolerance = 0.5;
$6172e0e421d1d549$var$Draggable.prototype.droppableClass = null;
/** Slow down movement by pressing ctrl/cmd */ $6172e0e421d1d549$var$Draggable.prototype.sniper = true;
/** How much to slow sniper drag */ $6172e0e421d1d549$var$Draggable.prototype.sniperSlowdown = .85;
/**
 * Restrict movement by axis
 *
 * @default undefined
 * @enum {string}
 */ $6172e0e421d1d549$var$Draggable.prototype.move = function(x, y) {
    if (this.axis === 'x') {
        if (x == null) x = this.prevX;
        if (y == null) y = this.prevY;
        var limits = this.limits;
        if (this.repeat) {
            var w = limits.right - limits.left;
            var oX = -this.initOffsetX + this.withinOffsets.left - this.pin[0] - Math.max(0, this.overflowX);
            x = $6f2f3a4b5cb53cba$exports(x - oX, w) + oX;
        } else x = $27a8f87749bf0962$exports(x, limits.left, limits.right);
        this.setCoords(x);
    } else if (this.axis === 'y') {
        if (x == null) x = this.prevX;
        if (y == null) y = this.prevY;
        var limits = this.limits;
        if (this.repeat) {
            var h = limits.bottom - limits.top;
            var oY = -this.initOffsetY + this.withinOffsets.top - this.pin[1] - Math.max(0, this.overflowY);
            y = $6f2f3a4b5cb53cba$exports(y - oY, h) + oY;
        } else y = $27a8f87749bf0962$exports(y, limits.top, limits.bottom);
        this.setCoords(null, y);
    } else {
        if (x == null) x = this.prevX;
        if (y == null) y = this.prevY;
        var limits = this.limits;
        if (this.repeat) {
            var w = limits.right - limits.left;
            var h = limits.bottom - limits.top;
            var oX = -this.initOffsetX + this.withinOffsets.left - this.pin[0] - Math.max(0, this.overflowX);
            var oY = -this.initOffsetY + this.withinOffsets.top - this.pin[1] - Math.max(0, this.overflowY);
            if (this.repeat === 'x') x = $6f2f3a4b5cb53cba$exports(x - oX, w) + oX;
            else if (this.repeat === 'y') y = $6f2f3a4b5cb53cba$exports(y - oY, h) + oY;
            else {
                x = $6f2f3a4b5cb53cba$exports(x - oX, w) + oX;
                y = $6f2f3a4b5cb53cba$exports(y - oY, h) + oY;
            }
        }
        x = $27a8f87749bf0962$exports(x, limits.left, limits.right);
        y = $27a8f87749bf0962$exports(y, limits.top, limits.bottom);
        this.setCoords(x, y);
    }
};
/** Repeat movement by one of axises */ $6172e0e421d1d549$var$Draggable.prototype.repeat = false;
/** Check whether arr is filled with zeros */ function $6172e0e421d1d549$var$isZeroArray(arr) {
    if (!arr[0] && !arr[1] && !arr[2] && !arr[3]) return true;
}
/** Clean all memory-related things */ $6172e0e421d1d549$var$Draggable.prototype.destroy = function() {
    var that = this;
    that.currentHandles.forEach(function(handle) {
        $3901a5159c6fac4b$exports(handle, that._ns);
    });
    that.state = 'destroy';
    clearTimeout(that._animateTimeout);
    $3901a5159c6fac4b$exports($6172e0e421d1d549$var$doc, that._ns);
    $3901a5159c6fac4b$exports(that.element, that._ns);
    that.element = null;
    that.within = null;
};
//little helpers
function $6172e0e421d1d549$var$q(str) {
    if (Array.isArray(str)) return str.map($6172e0e421d1d549$var$q).reduce(function(prev, curr) {
        return prev.concat(curr);
    }, []);
    else if (str instanceof HTMLElement) return [
        str
    ];
    else return [].slice.call(document.querySelectorAll(str));
}
$6172e0e421d1d549$exports = $6172e0e421d1d549$var$Draggable;









var $56ab9b21e7acadd9$exports = {};
/**
 * Precision round
 *
 * @param {number} value
 * @param {number} step Minimal discrete to round
 *
 * @return {number}
 *
 * @example
 * toPrecision(213.34, 1) == 213
 * toPrecision(213.34, .1) == 213.3
 * toPrecision(213.34, 10) == 210
 */ var $a20da4ef680a1b1e$exports = {};
/**
 * @module  mumath/precision
 *
 * Get precision from float:
 *
 * @example
 * 1.1 → 1, 1234 → 0, .1234 → 4
 *
 * @param {number} n
 *
 * @return {number} decimap places
 */ 
$a20da4ef680a1b1e$exports = (parcelRequire("hgusk"))(function(n) {
    var s = n + '', d = s.indexOf('.') + 1;
    return !d ? 0 : s.length - d;
});



$56ab9b21e7acadd9$exports = (parcelRequire("hgusk"))(function(value, step) {
    if (step === 0) return value;
    if (!step) return Math.round(value);
    step = parseFloat(step);
    value = Math.round(value / step) * step;
    return parseFloat(value.toFixed($a20da4ef680a1b1e$exports(step)));
});


var $1260d8fab339ec10$exports = {};
/**
 * Clamper.
 * Detects proper clamp min/max.
 *
 * @param {number} a Current value to cut off
 * @param {number} min One side limit
 * @param {number} max Other side limit
 *
 * @return {number} Clamped value
 */ 
$1260d8fab339ec10$exports = (parcelRequire("hgusk"))(function(a, min, max) {
    return max > min ? Math.max(Math.min(a, max), min) : Math.max(Math.min(a, min), max);
});


var $968e98088b8becce$exports = {};
/**
 * @module  mumath/loop
 *
 * Looping function for any framesize
 */ 
$968e98088b8becce$exports = (parcelRequire("hgusk"))(function(value, left, right) {
    //detect single-arg case, like mod-loop
    if (right === undefined) {
        right = left;
        left = 0;
    }
    //swap frame order
    if (left > right) {
        var tmp = right;
        right = left;
        left = tmp;
    }
    var frame = right - left;
    value = (value + left) % frame - left;
    if (value < left) value += frame;
    if (value > right) value -= frame;
    return value;
});






var $5p9yL = parcelRequire("5p9yL");
$82b34bb456cfa7b8$exports = $82b34bb456cfa7b8$var$Picker;
var $82b34bb456cfa7b8$var$doc = document, $82b34bb456cfa7b8$var$root = document.documentElement;
/** The most precise step available. */ var $82b34bb456cfa7b8$var$MIN_STEP = 0.00001;
/** Default pageup/pagedown size, in steps */ var $82b34bb456cfa7b8$var$PAGE = 5;
/**
 * Picker instance
 *
 * @constructor
 */ function $82b34bb456cfa7b8$var$Picker(el, options) {
    if (!(this instanceof $82b34bb456cfa7b8$var$Picker)) return new $82b34bb456cfa7b8$var$Picker(el, options);
    var self = this;
    el.classList.add('slidy-picker');
    self.element = el;
    if (options.pickerClass) el.classList.add(options.pickerClass);
    //generate self id
    self.id = $327f740a53faffcd$exports();
    self.ns = 'slidy-picker-' + self.id;
    if (!self.element.id) self.element.id = self.ns;
    //init draggable
    self.draggable = new $6172e0e421d1d549$exports(el, {
        threshold: 0,
        within: options.within,
        sniperSlowdown: 0.85,
        repeat: options.repeat,
        releaseDuration: 80
    });
    //define orientation of picker
    $0b8087d3bbd8505a$exports(self, 'orientation', self.orientation);
    //adopt options
    //should go before enabled to set up proper flags
    $c4df3b81eac1607d$exports(self, options);
//NOTE: you have to enable picker manually
}
var $82b34bb456cfa7b8$var$proto = $82b34bb456cfa7b8$var$Picker.prototype = Object.create($f50e8fa8c10c9eff$exports.prototype);
/** Enable/disable picker */ $82b34bb456cfa7b8$var$proto.enable = function() {
    var self = this;
    if (self.isEnabled) return self;
    self.isEnabled = true;
    if (self.aria) //ARIAs
    self.element.removeAttribute('aria-disabled');
    self.element.removeAttribute('disabled');
    //events
    $cd96cea0cac21320$exports(self.element, 'resize.' + self.ns, function() {
        self.update();
    });
    $cd96cea0cac21320$exports(self.draggable, 'dragstart.' + self.ns, function() {
        //hide cursor
        $28f4ea491130cc50$exports($82b34bb456cfa7b8$var$root, 'cursor', 'none');
        $28f4ea491130cc50$exports(this.element, 'cursor', 'none');
    });
    $cd96cea0cac21320$exports(self.draggable, 'drag.' + self.ns, function() {
        //ignore animated state to avoid collisions of value
        if (self.release && self.draggable.state === 'release') return;
        var value = self.calcValue.apply(self, self.draggable.getCoords());
        var oldValue = self.value;
        //display snapping
        self.setValue(value, !self.snap);
        self.interaction(self.value, oldValue);
    });
    $cd96cea0cac21320$exports(self.draggable, 'dragend.' + self.ns, function() {
        if (self.release) //set animation flag
        self.draggable.state = 'release';
        //move to a new position
        self.renderValue(self.value);
        //get cursor back
        $28f4ea491130cc50$exports($82b34bb456cfa7b8$var$root, 'cursor', null);
        $28f4ea491130cc50$exports(this.element, 'cursor', null);
    });
    if (self.keyboard) {
        //make focusable
        self.element.setAttribute('tabindex', 0);
        //kbd events
        //borrowed from native input range mixed with multithumb range
        //@ref http://access.aol.com/dhtml-style-guide-working-group/#slidertwothumb
        self._pressedKeys = [];
        $cd96cea0cac21320$exports(self.element, 'keydown.' + self.ns, function(e) {
            //track pressed keys, to do diagonal movements
            self._pressedKeys[e.which] = true;
            if (e.which === 27) self.blur();
            if (e.which >= 33 && e.which <= 40) {
                e.preventDefault();
                var value = self.handleKeys(self._pressedKeys, self.value, self.step, self.min, self.max);
                var oldValue = self.value;
                //enable animation
                if (self.release) self.draggable.state = 'release';
                self.value = value;
                self.interaction(self.value, oldValue);
            }
        });
        $cd96cea0cac21320$exports(self.element, 'keyup.' + self.ns, function(e) {
            self._pressedKeys[e.which] = false;
        });
    }
    //emit duplicate change
    //as if change happens when picker is enabled
    self.emit('change', self.value);
    return self;
};
$82b34bb456cfa7b8$var$proto.disable = function() {
    var self = this;
    self.isEnabled = false;
    if (self.aria) //ARIAs
    self.element.setAttribute('aria-disabled', true);
    self.element.setAttribute('disabled', true);
    //unbind events
    $3901a5159c6fac4b$exports(self.element, 'resize.' + self.ns);
    $3901a5159c6fac4b$exports(self.element, 'dragstart.' + self.ns);
    $3901a5159c6fac4b$exports(self.draggable, 'dragstart.' + self.ns);
    $3901a5159c6fac4b$exports(self.element, 'drag.' + self.ns);
    $3901a5159c6fac4b$exports(self.draggable, 'drag.' + self.ns);
    $3901a5159c6fac4b$exports(self.element, 'dragend.' + self.ns);
    $3901a5159c6fac4b$exports(self.draggable, 'dragend.' + self.ns);
    if (self.keyboard) {
        //make unfocusable
        self.element.setAttribute('tabindex', -1);
        $3901a5159c6fac4b$exports(self.element, 'keydown.' + self.ns);
        $3901a5159c6fac4b$exports(self.element, 'keyup.' + self.ns);
    }
    return self;
};
$82b34bb456cfa7b8$var$proto.interaction = function(value, oldValue) {
    if (!$82b34bb456cfa7b8$var$eq(value, oldValue)) $efd77a5002f9972b$exports(this, 'input', value, oldValue);
};
/**
 * Default min/max values.
 * Copied from slidy container.
 */ $82b34bb456cfa7b8$var$proto.min = 0;
$82b34bb456cfa7b8$var$proto.max = 100;
/** Default step to bind value. It is automatically detected, if isn’t passed. */ $82b34bb456cfa7b8$var$proto.step = 1;
/** Loose snapping while drag */ $82b34bb456cfa7b8$var$proto.snap = true;
/** Animate release movement */ $82b34bb456cfa7b8$var$proto.release = false;
/** Point picker isn’t constrained by it’s shape */ $82b34bb456cfa7b8$var$proto.point = false;
/**
 * Picker alignment relative to the mouse.
 * Redefined by slidy, but to prevent empty value it is set to number.
 */ $82b34bb456cfa7b8$var$proto.align = 0.5;
/**
 * Set own value
 *
 * @param {number|Array} value A value to set
 */ $82b34bb456cfa7b8$var$proto.setValue = function(value, ignoreRelocation) {
    if (value === undefined) throw Error('Picker value cannot be undefined.');
    var self = this;
    //apply repeat
    if (self.repeat) {
        if (value.length === 2 && self.repeat === 'x') value[0] = $968e98088b8becce$exports(value[0], self.min[0], self.max[0]);
        else if (value.length === 2 && self.repeat === 'y') value[1] = $968e98088b8becce$exports(value[1], self.min[1], self.max[1]);
        else value = $968e98088b8becce$exports(value, self.min, self.max);
    }
    //apply limiting
    value = $1260d8fab339ec10$exports(value, self.min, self.max);
    //round value
    if (self.step) {
        if ($867943181515e62b$exports(self.step)) value = $56ab9b21e7acadd9$exports(value, self.step(value));
        else value = $56ab9b21e7acadd9$exports(value, self.step);
    }
    //update position
    if (!ignoreRelocation) self.renderValue(value);
    //check whether value is actually changed
    if (!$82b34bb456cfa7b8$var$eq(self._value, value)) {
        self._value = value;
        //trigger change event on self
        //not the same as native input change
        self.emit('change', value);
    }
    return value;
};
/** Current picker value wrapper */ Object.defineProperties($82b34bb456cfa7b8$var$proto, {
    value: {
        set: $82b34bb456cfa7b8$var$proto.setValue,
        get: function() {
            //keep immutability
            return $6b441d0d894731d6$exports(this._value) ? $5p9yL(this._value) : this._value;
        }
    }
});
/**
 * Move picker visually to the value passed.
 * Supposed to be redefined by type
 *
 * @param {number} value Value to render
 *
 * @return {Picker} Self instance
 */ $82b34bb456cfa7b8$var$proto.renderValue = function(value) {};
/**
 * Calc value from the picker position
 * Supposed to be redefined by type
 *
 * @return {number} Value, min..max
 */ $82b34bb456cfa7b8$var$proto.calcValue = function(x, y) {};
/**
 * Update value based on keypress. Supposed to be redefined in type of picker.
 */ $82b34bb456cfa7b8$var$proto.handleKeys = function(key, value, step) {};
/** Update self size, pin & position, according to the value */ $82b34bb456cfa7b8$var$proto.update = function() {
    var self = this;
    self.updatePin();
    //update draggable limits
    self.draggable.update();
    //update position according to the value
    self.renderValue(self.value);
    return self;
};
/** Update pin only */ $82b34bb456cfa7b8$var$proto.updatePin = function() {
    var self = this;
    //update pin - may depend on element’s size
    //can’t use `draggable.offsets` here as they might be undefined
    if (self.point) self.draggable.pin = [
        self.element.offsetWidth * self.align,
        self.element.offsetHeight * self.align
    ];
};
/** Move picker to the x, y relative coordinates */ $82b34bb456cfa7b8$var$proto.move = function(x, y) {
    var self = this;
    //correct point placement
    if (self.point) {
        var cx = self.draggable.pin.width * self.align;
        var cy = self.draggable.pin.height * self.align;
        x = x - self.draggable.pin[0] - cx;
        y = y - self.draggable.pin[1] - cy;
    }
    //if thumb is more than visible area - subtract overflow coord
    var overflowX = self.draggable.pin.width - self.element.parentNode.clientWidth;
    var overflowY = self.draggable.pin.height - self.element.parentNode.clientHeight;
    if (overflowX > 0) x -= overflowX;
    if (overflowY > 0) y -= overflowY;
    self.draggable.move(x, y);
    var value = self.calcValue(x, y);
    //set value
    self.setValue(value, true);
    return self;
};
/**
 * Move picker to the point of click with the centered drag point
 */ $82b34bb456cfa7b8$var$proto.startDrag = function(e) {
    var self = this;
    //update drag limits based off event passed
    self.draggable.setTouch(e).update(e);
    //start drag
    //ignore if already drags
    if (self.draggable.state !== 'drag') self.draggable.state = 'drag';
    //centrize picker
    self.draggable.innerOffsetX = self.draggable.pin[0] + self.draggable.pin.width * 0.5;
    self.draggable.innerOffsetY = self.draggable.pin[1] + self.draggable.pin.height * 0.5;
    //emulate move
    self.draggable.drag(e);
    return this;
};
/** Make it active. */ $82b34bb456cfa7b8$var$proto.focus = function() {
    var self = this;
    self.element.focus();
};
$82b34bb456cfa7b8$var$proto.blur = function() {
    var self = this;
    self.element.blur();
};
/**
 * Placing type
 * @enum {string}
 * @default 'horizontal'
 */ $82b34bb456cfa7b8$var$proto.orientation = {
    //default orientation is horizontal
    _: 'horizontal',
    horizontal: function() {
        var self = this;
        self.draggable.axis = 'x';
        //place pickers according to the value
        self.renderValue = function(value) {
            value = $82b34bb456cfa7b8$var$plainify(value);
            var max = $82b34bb456cfa7b8$var$plainify(self.max);
            var min = $82b34bb456cfa7b8$var$plainify(self.min);
            var lims = self.draggable.limits, scope = lims.right - lims.left, range = max - min, ratio = (value - min) / range || 0, x = ratio * scope;
            self.move(x);
            return self;
        };
        //round value on each drag
        self.calcValue = function(x) {
            var max = $82b34bb456cfa7b8$var$plainify(self.max);
            var min = $82b34bb456cfa7b8$var$plainify(self.min);
            var lims = self.draggable.limits, scope = lims.right - lims.left, normalValue = (x - lims.left) / scope;
            var value = normalValue * (max - min) + min;
            //keep user format of value
            if ($6b441d0d894731d6$exports(self.value)) value = [
                value
            ];
            return value;
        };
        self.handleKeys = $82b34bb456cfa7b8$var$handle1dkeys;
    },
    vertical: function() {
        var self = this;
        self.draggable.axis = 'y';
        //place pickers according to the value
        self.renderValue = function(value) {
            value = $82b34bb456cfa7b8$var$plainify(value);
            var max = $82b34bb456cfa7b8$var$plainify(self.max);
            var min = $82b34bb456cfa7b8$var$plainify(self.min);
            var lims = self.draggable.limits, scope = lims.bottom - lims.top, range = max - min, ratio = (-value + max) / range || 0, y = ratio * scope;
            self.move(null, y);
            return self;
        };
        //round value on each drag
        self.calcValue = function(x, y) {
            var max = $82b34bb456cfa7b8$var$plainify(self.max);
            var min = $82b34bb456cfa7b8$var$plainify(self.min);
            var lims = self.draggable.limits, scope = lims.bottom - lims.top, normalValue = (-y + lims.bottom) / scope;
            var value = normalValue * (max - min) + min;
            //keep user format of value
            if ($6b441d0d894731d6$exports(self.value)) value = [
                value
            ];
            return value;
        };
        self.handleKeys = $82b34bb456cfa7b8$var$handle1dkeys;
    },
    cartesian: function() {
        var self = this;
        self.draggable.axis = null;
        self.renderValue = function(value) {
            var lim = self.draggable.limits, hScope = lim.right - lim.left, vScope = lim.bottom - lim.top;
            var hRange = self.max[0] - self.min[0], vRange = self.max[1] - self.min[1], ratioX = (value[0] - self.min[0]) / hRange || 0, ratioY = (-value[1] + self.max[1]) / vRange || 0;
            self.move(ratioX * hScope, ratioY * vScope);
            return self;
        };
        self.calcValue = function(x, y) {
            var lim = self.draggable.limits, hScope = lim.right - lim.left, vScope = lim.bottom - lim.top;
            var normalValue = [
                (x - lim.left) / hScope,
                (-y + lim.bottom) / vScope
            ];
            return [
                normalValue[0] * (self.max[0] - self.min[0]) + self.min[0],
                normalValue[1] * (self.max[1] - self.min[1]) + self.min[1]
            ];
        };
        self.handleKeys = $82b34bb456cfa7b8$var$handle2dkeys;
    },
    circular: function() {
        var self = this;
        self.draggable.axis = null;
        //limit x/y by the circumference
        self.draggable.move = function(x, y) {
            var lim = this.limits;
            var hScope = lim.right - lim.left, vScope = lim.bottom - lim.top;
            var cx = hScope / 2 - this.pin[0], cy = vScope / 2 - this.pin[1];
            var angle = Math.atan2(y - cy, x - cx);
            this.setCoords(Math.cos(angle) * (cx + this.pin[0]) + cx, Math.sin(angle) * (cy + this.pin[1]) + cy);
        };
        self.renderValue = function(value) {
            value = $82b34bb456cfa7b8$var$plainify(value);
            var max = $82b34bb456cfa7b8$var$plainify(self.max);
            var min = $82b34bb456cfa7b8$var$plainify(self.min);
            var lim = self.draggable.limits, hScope = lim.right - lim.left, vScope = lim.bottom - lim.top, centerX = hScope * 0.5, centerY = vScope * 0.5;
            var range = max - min;
            var normalValue = (value - min) / range || 0;
            var angle = (normalValue - 0.5) * 2 * Math.PI;
            self.move(Math.cos(angle) * centerX + centerX, Math.sin(angle) * centerY + centerY);
        };
        self.calcValue = function(x, y) {
            var lim = self.draggable.limits, hScope = lim.right - lim.left, vScope = lim.bottom - lim.top;
            var max = $82b34bb456cfa7b8$var$plainify(self.max);
            var min = $82b34bb456cfa7b8$var$plainify(self.min);
            x = x - hScope * 0.5 + self.draggable.pin[0];
            y = y - vScope * 0.5 + self.draggable.pin[1];
            //get angle
            var angle = Math.atan2(y, x);
            //get normal value
            var normalValue = angle * 0.5 / Math.PI + 0.5;
            //get value from coords
            var value = normalValue * (max - min) + min;
            //keep user format of value
            if ($6b441d0d894731d6$exports(self.value)) value = [
                value
            ];
            return value;
        };
        self.handleKeys = $82b34bb456cfa7b8$var$handle1dkeys;
    },
    polar: function() {
        var self = this;
        self.draggable.axis = null;
        //limit x/y within the circle
        self.draggable.move = function(x, y) {
            var lim = this.limits;
            var hScope = lim.right - lim.left, vScope = lim.bottom - lim.top;
            var cx = hScope / 2 - this.pin[0], cy = vScope / 2 - this.pin[1];
            var dx = x - cx, dy = y - cy;
            var angle = Math.atan2(y - cy, x - cx);
            var r = Math.sqrt(dx * dx + dy * dy);
            //limit max radius as a circumference
            this.setCoords(r > hScope / 2 ? Math.cos(angle) * (cx + this.pin[0]) + cx : x, r > vScope / 2 ? Math.sin(angle) * (cy + this.pin[1]) + cy : y);
        };
        self.renderValue = function(value) {
            var lim = self.draggable.limits, hScope = lim.right - lim.left, vScope = lim.bottom - lim.top, centerX = hScope * 0.5, centerY = vScope * 0.5;
            //get angle normal value
            var aRange = self.max[0] - self.min[0];
            var normalAngleValue = (value[0] - self.min[0]) / aRange;
            var angle = (normalAngleValue - 0.5) * 2 * Math.PI;
            //get radius normal value
            var rRange = self.max[1] - self.min[1];
            var normalRadiusValue = (value[1] - self.min[1]) / rRange;
            var xRadius = centerX * normalRadiusValue;
            var yRadius = centerY * normalRadiusValue;
            self.move(Math.cos(angle) * xRadius + centerX, Math.sin(angle) * yRadius + centerY);
        };
        self.calcValue = function(x, y) {
            var lim = self.draggable.limits, hScope = lim.right - lim.left, vScope = lim.bottom - lim.top;
            x = x + self.draggable.pin[0] - hScope * 0.5;
            y = y + self.draggable.pin[1] - vScope * 0.5;
            //get angle
            var angle = Math.atan2(y, x);
            //get normal value
            var normalAngleValue = angle * 0.5 / Math.PI + 0.5;
            var normalRadiusValue = Math.sqrt(x * x + y * y) / hScope * 2;
            //get value from coords
            return [
                normalAngleValue * (self.max[0] - self.min[0]) + self.min[0],
                normalRadiusValue * (self.max[1] - self.min[1]) + self.min[1]
            ];
        };
        self.handleKeys = $82b34bb456cfa7b8$var$handle2dkeys;
    }
};
/** Increment / decrement API */ $82b34bb456cfa7b8$var$proto.inc = function(timesX, timesY) {
    if ($6b441d0d894731d6$exports(this.value) && this.value.length > 1) {
        var value = this.value;
        value[0] = $82b34bb456cfa7b8$var$inc(value[0], $82b34bb456cfa7b8$var$plainify(this.step, 0), timesX);
        value[1] = $82b34bb456cfa7b8$var$inc(value[1], $82b34bb456cfa7b8$var$plainify(this.step, 1), timesY);
        this.value = value;
    } else {
        var times = timesY || timesX;
        this.value = $82b34bb456cfa7b8$var$inc(this.value, this.step, times);
    }
};
/** Increment & decrement value by the step [N times] */ function $82b34bb456cfa7b8$var$inc(value, step, mult) {
    mult = mult || 0;
    var isArr = $6b441d0d894731d6$exports(value);
    value = $82b34bb456cfa7b8$var$plainify(value);
    if ($867943181515e62b$exports(step)) step = step(value + (mult > 0 ? +$82b34bb456cfa7b8$var$MIN_STEP : -$82b34bb456cfa7b8$var$MIN_STEP));
    value += step * mult;
    return isArr ? [
        value
    ] : value;
}
/** Apply pressed keys on the 2d value */ function $82b34bb456cfa7b8$var$handle2dkeys(keys, value, step, min, max) {
    //up and right - increase by one
    if (keys[38]) value[1] = $82b34bb456cfa7b8$var$inc(value[1], $82b34bb456cfa7b8$var$plainify(step, 1), 1);
    if (keys[39]) value[0] = $82b34bb456cfa7b8$var$inc(value[0], $82b34bb456cfa7b8$var$plainify(step, 0), 1);
    if (keys[40]) value[1] = $82b34bb456cfa7b8$var$inc(value[1], $82b34bb456cfa7b8$var$plainify(step, 1), -1);
    if (keys[37]) value[0] = $82b34bb456cfa7b8$var$inc(value[0], $82b34bb456cfa7b8$var$plainify(step, 0), -1);
    //meta
    var coordIdx = 1;
    if (keys[18] || keys[91] || keys[17] || keys[16]) coordIdx = 0;
    //home - min
    if (keys[36]) value[coordIdx] = min[coordIdx];
    //end - max
    if (keys[35]) value[coordIdx] = max[coordIdx];
    //pageup
    if (keys[33]) value[coordIdx] = $82b34bb456cfa7b8$var$inc(value[coordIdx], $82b34bb456cfa7b8$var$plainify(step, coordIdx), $82b34bb456cfa7b8$var$PAGE);
    //pagedown
    if (keys[34]) value[coordIdx] = $82b34bb456cfa7b8$var$inc(value[coordIdx], $82b34bb456cfa7b8$var$plainify(step, coordIdx), -$82b34bb456cfa7b8$var$PAGE);
    return value;
}
/** Apply pressed keys on the 1d value */ function $82b34bb456cfa7b8$var$handle1dkeys(keys, value, step, min, max) {
    step = step || 1;
    //up and right - increase by one
    if (keys[38] || keys[39]) value = $82b34bb456cfa7b8$var$inc(value, step, 1);
    //down and left - decrease by one
    if (keys[40] || keys[37]) value = $82b34bb456cfa7b8$var$inc(value, step, -1);
    //home - min
    if (keys[36]) value = min;
    //end - max
    if (keys[35]) value = max;
    //pageup
    if (keys[33]) value = $82b34bb456cfa7b8$var$inc(value, step, $82b34bb456cfa7b8$var$PAGE);
    //pagedown
    if (keys[34]) value = $82b34bb456cfa7b8$var$inc(value, step, -$82b34bb456cfa7b8$var$PAGE);
    return value;
}
/** If value is an array - return first value of it */ function $82b34bb456cfa7b8$var$plainify(value, i) {
    return value.length ? value[i || 0] : value;
}
/** Whether all inner a’s === b’s */ function $82b34bb456cfa7b8$var$eq(a, b) {
    if (a && a.length) return a[0] === b[0] && a[1] === b[1];
    return a === b;
}




var $f2df0afd414990f6$exports = {};



var $14d7033ef17c64c4$exports = {};
var $14d7033ef17c64c4$var$slice = [].slice;
$14d7033ef17c64c4$exports = function(selector, multiple) {
    var ctx = this === window ? document : this;
    return typeof selector == 'string' ? multiple ? $14d7033ef17c64c4$var$slice.call(ctx.querySelectorAll(selector), 0) : ctx.querySelector(selector) : selector instanceof Node || selector === window || !selector.length ? multiple ? [
        selector
    ] : selector : $14d7033ef17c64c4$var$slice.call(selector, 0);
};


var $f2df0afd414990f6$var$doc = document, $f2df0afd414990f6$var$win = window;
/**
 * @module lifecycle-events
 *
 * @todo  Work out tolerance issue (whether it needs to be passed as an option - sometimes useful, like to detect an element being fully visible)
 *
 * @todo  Optimize enabled selectors. For example, avoid extra enabling if you have '*' enabled. And so on.
 * @todo  Testling table.
 * @todo  Ignore native CustomElements lifecycle events
 *
 * @note  Nested queryselector ten times faster than doc.querySelector:
 *        http://jsperf.com/document-vs-element-queryselectorall-performance/2
 * @note  Multiple observations to an extent faster than one global observer:
 *        http://jsperf.com/mutation-observer-cases
 */ var $f2df0afd414990f6$var$lifecycle = $f2df0afd414990f6$exports = $f2df0afd414990f6$var$enable;
$f2df0afd414990f6$var$lifecycle.enable = $f2df0afd414990f6$var$enable;
$f2df0afd414990f6$var$lifecycle.disable = $f2df0afd414990f6$var$disable;
/** Defaults can be changed outside */ $f2df0afd414990f6$var$lifecycle.attachedCallbackName = 'attached';
$f2df0afd414990f6$var$lifecycle.detachedCallbackName = 'detached';
/** One observer to observe a lot of nodes  */ var $f2df0afd414990f6$var$MO = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
var $f2df0afd414990f6$var$observer = new $f2df0afd414990f6$var$MO($f2df0afd414990f6$var$mutationHandler);
/** Set of targets to observe */ var $f2df0afd414990f6$var$mTargets = [];
/** Attached items set */ var $f2df0afd414990f6$var$attachedItemsSet = new WeakSet;
/**
 * Observer targets
 *
 * @param {(string|Node|NodeList|document)} query Target pointer
 * @param {Object} within Settings for observer
 */ function $f2df0afd414990f6$var$enable(query, within) {
    if (!query) query = '*';
    within = $14d7033ef17c64c4$exports(within || $f2df0afd414990f6$var$doc);
    //save cached version of target
    $f2df0afd414990f6$var$mTargets.push(query);
    //make observer observe one more target
    $f2df0afd414990f6$var$observer.observe(within, {
        subtree: true,
        childList: true
    });
    //ignore not bound nodes
    if (query instanceof Node && !$f2df0afd414990f6$var$doc.contains(query)) return;
    //check initial nodes
    $f2df0afd414990f6$var$checkAddedNodes($14d7033ef17c64c4$exports.call(within, query, true));
}
/**
 * Stop observing items
 */ function $f2df0afd414990f6$var$disable(target) {
    var idx = $f2df0afd414990f6$var$mTargets.indexOf(target);
    if (idx >= 0) $f2df0afd414990f6$var$mTargets.splice(idx, 1);
}
/**
 * Handle a mutation passed
 */ function $f2df0afd414990f6$var$mutationHandler(mutations) {
    mutations.forEach(function(mutation) {
        $f2df0afd414990f6$var$checkAddedNodes(mutation.addedNodes);
        $f2df0afd414990f6$var$checkRemovedNodes(mutation.removedNodes);
    });
}
/**
 * Check nodes list to call attached
 */ function $f2df0afd414990f6$var$checkAddedNodes(nodes) {
    var newItems = false, node;
    //find attached evt targets
    for(var i = nodes.length; i--;){
        node = nodes[i];
        if (node.nodeType !== 1) continue;
        //find options corresponding to the node
        if (!$f2df0afd414990f6$var$attachedItemsSet.has(node)) {
            node = $f2df0afd414990f6$var$getObservee(node);
            //if observee found within attached items - add it to set
            if (node) {
                if (!newItems) newItems = true;
                $f2df0afd414990f6$var$attachedItemsSet.add(node);
                $efd77a5002f9972b$exports(node, $f2df0afd414990f6$var$lifecycle.attachedCallbackName, null, true);
            }
        }
    }
}
/**
 * Check nodes list to call detached
 */ function $f2df0afd414990f6$var$checkRemovedNodes(nodes) {
    //handle detached evt
    for(var i = nodes.length; i--;){
        var node = nodes[i];
        if (node.nodeType !== 1) continue;
        //find options corresponding to the node
        if ($f2df0afd414990f6$var$attachedItemsSet.has(node)) {
            $efd77a5002f9972b$exports(node, $f2df0afd414990f6$var$lifecycle.detachedCallbackName, null, true);
            $f2df0afd414990f6$var$attachedItemsSet.delete(node);
        }
    }
}
/**
 * Check whether node is observing
 *
 * @param {Node} node An element to check on inclusion to target list
 */ function $f2df0afd414990f6$var$getObservee(node) {
    //check queries
    for(var i = $f2df0afd414990f6$var$mTargets.length, target; i--;){
        target = $f2df0afd414990f6$var$mTargets[i];
        if (node === target) return node;
        if (typeof target === 'string' && node.matches(target)) return node;
        //return innermost target
        if (node.contains(target)) return target;
    }
}





var $dfc41bb9530f2614$exports = {};
/**
 * Throttle function call.
 *
 * @module emmy/throttle
 */ $dfc41bb9530f2614$exports = $dfc41bb9530f2614$var$throttle;


/**
 * Throttles call by rebinding event each N seconds
 *
 * @param {Object} target Any object to throttle
 * @param {string} evt An event name
 * @param {Function} fn A callback
 * @param {int} interval A minimum interval between calls
 *
 * @return {Function} A wrapped callback
 */ function $dfc41bb9530f2614$var$throttle(target, evt, fn, interval) {
    //FIXME: find cases where objects has own throttle method, then use target’s throttle
    //bind wrapper
    return $cd96cea0cac21320$exports(target, evt, $dfc41bb9530f2614$var$throttle.wrap(target, evt, fn, interval));
}
/** Return wrapped with interval fn */ $dfc41bb9530f2614$var$throttle.wrap = function(target, evt, fn, interval) {
    //swap params, if needed
    if (interval instanceof Function) {
        var tmp = interval;
        interval = fn;
        fn = tmp;
    }
    //wrap callback
    var cb = function() {
        //opened state
        if (!cb.closedInterval) {
            //clear closed call flag
            cb.closedCall = false;
            //do call
            fn.apply(target, arguments);
            //close till the interval is passed
            cb.closedInterval = setTimeout(function() {
                //reset interval
                cb.closedInterval = null;
                //do after-call
                if (cb.closedCall) cb.apply(target, arguments);
            }, interval);
        } else //if trigger happened during the pause - defer it’s call
        cb.closedCall = true;
    };
    cb.fn = fn;
    return cb;
};



var $5292d1218fad3197$require$getClientX = $370770ee1fd34d9f$exports.x;

var $5292d1218fad3197$require$getClientY = $370770ee1fd34d9f$exports.y;



var $hgusk = parcelRequire("hgusk");
var $5292d1218fad3197$var$win = window, $5292d1218fad3197$var$doc = document;
$5292d1218fad3197$exports = $5292d1218fad3197$var$Slidy;
/** Cache of instances. Just as it is safer than keeping them on targets. */ var $5292d1218fad3197$var$instancesCache = $5292d1218fad3197$var$Slidy.cache = new WeakMap();
/**
 * Create slider over a target
 * @constructor
 */ function $5292d1218fad3197$var$Slidy(target, options) {
    //force constructor
    if (!(this instanceof $5292d1218fad3197$var$Slidy)) return new $5292d1218fad3197$var$Slidy(target, options);
    var self = this;
    //ensure target & options
    if (!options) {
        if (target instanceof Element) options = {};
        else {
            options = target;
            target = $5292d1218fad3197$var$doc.createElement('div');
        }
    }
    //get preferred element
    self.element = target;
    //adopt options
    $c4df3b81eac1607d$exports(self, options);
    //calculate value & step
    //detect step automatically based on min/max range (1/100 by default)
    //native behaviour is always 1, so ignore it
    if (options.step === undefined) self.step = $5292d1218fad3197$var$detectStep(self.min, self.max);
    //calc undefined valuea as a middle of range
    if (options.value === undefined) self.value = $5292d1218fad3197$var$detectValue(self.min, self.max);
    //bind passed callbacks, if any
    if (options.created) $cd96cea0cac21320$exports(self, 'created', options.created);
    //save refrence
    $5292d1218fad3197$var$instancesCache.set(self.element, self);
    //generate id
    self.id = $327f740a53faffcd$exports();
    self.ns = 'slidy-' + self.id;
    if (!self.element.id) self.element.id = self.ns;
    //init instance
    self.element.classList.add('slidy');
    //create pickers, if passed a list
    self.pickers = [];
    if ($6b441d0d894731d6$exports(options.pickers) && options.pickers.length) options.pickers.forEach(function(opts) {
        self.addPicker(opts);
    });
    else if (!options.hasOwnProperty('pickers')) self.addPicker(options.pickers);
    // Define value as active picker value getter
    //FIXME: case of multiple pickers
    Object.defineProperty(self, 'value', {
        set: function(value) {
            var picker = this.getActivePicker();
            picker && (picker.value = value);
        },
        get: function() {
            var picker = this.getActivePicker();
            return picker && picker.value;
        }
    });
    if (self.aria) {
        //a11y
        //@ref http://www.w3.org/TR/wai-aria/roles#slider
        self.element.setAttribute('role', 'slider');
        target.setAttribute('aria-valuemax', self.max);
        target.setAttribute('aria-valuemin', self.min);
        target.setAttribute('aria-orientation', self.orientation);
        target.setAttribute('aria-atomic', true);
        //update controls
        target.setAttribute('aria-controls', self.pickers.map(function(item) {
            return item.element.id;
        }).join(' '));
    }
    //turn on events etc
    if (!self.element.hasAttribute('disabled')) self.enable();
    //emit callback
    self.emit('created');
}
var $5292d1218fad3197$var$proto = $5292d1218fad3197$var$Slidy.prototype = Object.create($f50e8fa8c10c9eff$exports.prototype);
/**
 * Default range
 */ $5292d1218fad3197$var$proto.min = 0;
$5292d1218fad3197$var$proto.max = 100;
$5292d1218fad3197$var$proto.value = 50;
/** Default placing type is horizontal */ $5292d1218fad3197$var$proto.orientation = 'horizontal';
/**
 * Repeat either by one or both axis
 *
 * @enum {bool}
 * @default true
 */ $5292d1218fad3197$var$proto.repeat = false;
/** Interaction settings */ $5292d1218fad3197$var$proto.keyboard = true;
$5292d1218fad3197$var$proto.aria = true;
$5292d1218fad3197$var$proto.wheel = true;
$5292d1218fad3197$var$proto.click = true;
$5292d1218fad3197$var$proto.point = false;
/** Picker alignment relative to the mouse */ $5292d1218fad3197$var$proto.align = 0.5;
/** Enable/disable */ $5292d1218fad3197$var$proto.enable = function() {
    var self = this;
    if (self.isEnabled) return self;
    self.isEnabled = true;
    if (self.aria) //ARIAs
    self.element.removeAttribute('aria-disabled');
    self.element.removeAttribute('disabled');
    //add change listenerw, if passed one
    if ($867943181515e62b$exports(self.change)) $cd96cea0cac21320$exports(self, 'change', self.change);
    if ($867943181515e62b$exports(self.input)) $cd96cea0cac21320$exports(self, 'input', self.input);
    //Events
    // Update pickers position on the first load and resize
    $dfc41bb9530f2614$exports($5292d1218fad3197$var$win, 'resize.' + self.ns, 20, function() {
        self.update();
    });
    //observe when slider is inserted
    $cd96cea0cac21320$exports(self.element, 'attached.' + self.ns, function(e) {
        self.update();
    });
    $f2df0afd414990f6$exports.enable(self.element);
    //distribute multitouch event to closest pickers
    if (self.click) $cd96cea0cac21320$exports(self.element, 'touchstart.' + self.ns + ' mousedown.' + self.ns, function(e) {
        e.preventDefault();
        //focus on container programmatically
        //in that case might be a multifocus
        self.element.focus();
        var selfClientRect = self.element.getBoundingClientRect();
        //list of active pickers
        var pickers = [], picker, x, y;
        if (e.touches) //get coords relative to the container (this)
        for(var i = 0, l = e.touches.length; i < l; i++){
            x = $5292d1218fad3197$require$getClientX(e, i) - selfClientRect.left;
            y = $5292d1218fad3197$require$getClientY(e, i) - selfClientRect.top;
            //find closest picker not taken already
            picker = self.getClosestPicker(self.pickers.filter(function(p) {
                return pickers.indexOf(p) < 0;
            }), x, y);
            pickers.push(picker);
            var oldValue = picker.value;
            //move picker to the point of click
            picker.move(x, y).startDrag(e);
            picker.interaction(picker.value, oldValue);
        }
        else {
            //get coords relative to the container (this)
            x = $5292d1218fad3197$require$getClientX(e) - selfClientRect.left;
            y = $5292d1218fad3197$require$getClientY(e) - selfClientRect.top;
            //make closest picker active
            picker = self.getClosestPicker(self.pickers, x, y);
            pickers.push(picker);
            var oldValue = picker.value;
            //move picker to the point of click
            picker.move(x, y).startDrag(e);
            picker.interaction(picker.value, oldValue);
            //focus picker (not always focusable)
            picker.focus();
        }
        //disable every picker except for the active one
        // - some other pickers might be clicked occasionally
        self.pickers.forEach(function(ipicker) {
            if (pickers.indexOf(ipicker) < 0) ipicker.draggable.state = 'idle';
        });
    });
    if (self.wheel) $cd96cea0cac21320$exports(self.element, 'wheel.' + self.ns + ' mousewheel' + self.ns, function(e) {
        //get focused element
        var focusEl = $5292d1218fad3197$var$doc.activeElement, picker;
        var selfClientRect = self.element.getBoundingClientRect();
        //detect picker closest to the place of wheel
        if (focusEl === self.element) {
            var x = $5292d1218fad3197$require$getClientX(e) - selfClientRect.left;
            var y = $5292d1218fad3197$require$getClientY(e) - selfClientRect.top;
            picker = self.getClosestPicker(self.pickers, x, y);
            picker.focus();
        } else if (focusEl.parentNode === self.element) picker = self.getActivePicker();
        else return;
        //ignore doc scroll
        e.preventDefault();
        //move it according to the wheel diff
        var stepX = 0, stepY = 0;
        if (e.deltaX !== 0) {
            stepX = e.deltaX * 2 / selfClientRect.width;
            stepX = stepX > 0 ? Math.ceil(stepX) : Math.floor(stepX);
            //invert x
            stepX = -stepX;
        }
        if (e.deltaY !== 0) {
            stepY = e.deltaY * 2 / selfClientRect.height;
            stepY = stepY > 0 ? Math.ceil(stepY) : Math.floor(stepY);
        }
        picker.inc(stepX, stepY);
        self.emit('input', picker.value);
    });
    if (self.keyboard) {
        //set unfocusable always (redirect to the first picker)
        self.element.setAttribute('tabindex', -1);
        //in case of focused multitouch unfocus by escape
        $cd96cea0cac21320$exports(self.element, 'keydown', function(e) {
            if (e.which === 27) self.element.blur();
        });
    }
    //enable pickers
    self.pickers.forEach(function(picker) {
        //enable picker - init value
        picker.enable();
    });
    return self;
};
/**
 * Disable interactivity
 *
 * @return {Slidy}
 */ $5292d1218fad3197$var$proto.disable = function() {
    var self = this;
    self.isEnabled = false;
    if (self.aria) //ARIAs
    self.element.setAttribute('aria-disabled', true);
    self.element.setAttribute('disabled', true);
    //unbind events
    $3901a5159c6fac4b$exports($5292d1218fad3197$var$win, 'resize.' + self.ns);
    $3901a5159c6fac4b$exports(self.element, 'attached.' + self.ns);
    $3901a5159c6fac4b$exports(self.element, 'mousedown.' + self.ns);
    $3901a5159c6fac4b$exports(self.element, 'touchstart.' + self.ns);
    //unbind pickers
    self.pickers.forEach(function(picker) {
        picker.disable();
    });
    return self;
};
/**
 * Update all pickers limits & position
 * according to values
 */ $5292d1218fad3197$var$proto.update = function() {
    //update pickers limits & placement
    //pickers size might depend on doc size
    this.pickers.forEach(function(picker) {
        picker.update();
    });
};
/**
 * Create a new picker.
 * It is better to keep it discrete, not as like `addPicker`
 * as it leaves controlling the list of pickers to user.
 *
 * @param {Object} options Options for draggable
 *
 * @return {Picker} New picker instance
 */ $5292d1218fad3197$var$proto.createPicker = function(el, options) {
    var self = this;
    if (!options) {
        options = el;
        el = null;
    }
    options = $c4df3b81eac1607d$exports({
        within: self.element,
        orientation: self.orientation,
        min: self.min,
        max: self.max,
        repeat: self.repeat,
        step: self.step,
        snap: self.snap,
        pickerClass: self.pickerClass,
        align: self.align,
        release: self.release,
        aria: self.aria,
        keyboard: self.keyboard,
        wheel: self.wheel,
        point: self.point,
        value: self.value
    }, options);
    el = el || document.createElement('div');
    if (self.aria) //add ARIA
    el.setAttribute('aria-describedby', self.element.id);
    //place picker to self
    //need to be appended before to bubble events
    self.element.appendChild(el);
    var picker = new $82b34bb456cfa7b8$exports(el, options);
    //on picker change trigger own change
    picker.on('change', function(value) {
        if (self.aria) {
            //set aria value
            self.element.setAttribute('aria-valuenow', value);
            self.element.setAttribute('aria-valuetext', value);
        }
        self.emit('change', value);
    })//observe drag, treat as user input
    .on('input', function(value, oldValue) {
        self.emit('input', value, oldValue);
    });
    return picker;
};
/**
 * Create & add picker.
 * A useful name convention for the API.
 */ $5292d1218fad3197$var$proto.addPicker = function(el, options) {
    var self = this;
    var picker = self.createPicker(el, options);
    self.pickers.push(picker);
    if (self.isEnabled) {
        picker.enable();
        self.update();
    }
    return self;
};
/**
 * Get closest picker to the place of event
 *
 * @param {number} x offsetLeft, relative to slidy
 * @param {number} y offsetTop, relative to slidy
 *
 * @return {Draggy} A picker instance
 */ $5292d1218fad3197$var$proto.getClosestPicker = function(pickers, x, y) {
    //between all pickers choose the one with closest x,y
    var minR = 9999, minPicker;
    pickers.forEach(function(picker) {
        var xy = picker.draggable.getCoords();
        var dx = x - xy[0] - picker.draggable.pin[0] - picker.draggable.pin.width * picker.align;
        var dy = y - xy[1] - picker.draggable.pin[1] - picker.draggable.pin.height * picker.align;
        var r = Math.sqrt(dx * dx + dy * dy);
        if (r < minR) {
            minR = r;
            minPicker = picker;
        }
    });
    return minPicker;
};
/**
 * Return active picker
 */ $5292d1218fad3197$var$proto.getActivePicker = function() {
    var focusEl = $5292d1218fad3197$var$doc.activeElement;
    var picker = this.pickers.filter(function(p) {
        return p.element === focusEl;
    })[0];
    return picker || this.pickers[0];
};
/**
 * Default step detector
 * Step is 0.1 or 1
 */ function $5292d1218fad3197$var$detectStep(min, max) {
    var range = $hgusk(function(a, b) {
        return Math.abs(a - b);
    })(max, min);
    var step = $hgusk(function(a) {
        return a < 100 ? 0.01 : 1;
    })(range);
    return step;
}
/**
 * Default value detector
 * Default value is half of range
 */ function $5292d1218fad3197$var$detectValue(min, max) {
    return $hgusk(function(a, b) {
        return (a + b) * 0.5;
    })(min, max);
}


function $67705e85d4f578a3$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    pug_html = pug_html + "\u003Cdiv class=\"pure-g\"\u003E\u003Cdiv class=\"pure-u-1\"\u003E\u003Cdiv data-hook=\"slider\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    return pug_html;
}
var $67705e85d4f578a3$export$2e2bcd8739ae039 = $67705e85d4f578a3$var$template;


var $6a95e0bd1c73842f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dM6Pc))).extend({
    template: $67705e85d4f578a3$export$2e2bcd8739ae039,
    initialize (opts) {
        // search-state
        this.state = opts.state;
        // reset slider on filter reset
        this.listenTo(this.state, 'change:filtered', (state, filtered)=>{
            if (!filtered) this.render();
        });
        this.listenTo(this.model, 'change:start change:end', this.render);
    },
    onChange () {
        const pickers = this.slidy.pickers;
        const start = (0, $9c5La.DateTime).fromMillis(pickers[0].value);
        const end = (0, $9c5La.DateTime).fromMillis(pickers[1].value);
        this.state.start = (0, $9c5La.DateTime).min(start, end).toMillis();
        this.state.end = (0, $9c5La.DateTime).max(start, end).toMillis();
    },
    remove () {
        if (this.slidy) this.slidy.disable();
        (0, (/*@__PURE__*/$parcel$interopDefault($dM6Pc))).prototype.remove.call(this);
    },
    renderSlidy () {
        if (this.slidy) this.slidy.disable();
        if (!this.model.start || !this.model.end) return;
        const start = this.model.start.getTime();
        const end = this.model.end.getTime();
        this.slidy = new (0, (/*@__PURE__*/$parcel$interopDefault($5292d1218fad3197$exports)))({
            min: start,
            max: end,
            step: (end - start) / 3600000,
            pickers: [
                {
                    value: start
                },
                {
                    value: end
                }
            ]
        });
        this.slidy.on('change', this.onChange.bind(this));
        this.queryByHook('slider').appendChild(this.slidy.element);
    },
    render () {
        this.renderWithTemplate(this);
        this.renderSlidy();
        return this;
    }
});


var $346d3b1e7ee8f2c1$require$Slider = $6a95e0bd1c73842f$export$2e2bcd8739ae039;
var $fba2c18b0b292ed3$exports = {};

var $bd3QA = parcelRequire("bd3QA");

var $akRxj = parcelRequire("akRxj");

var $dM6Pc = parcelRequire("dM6Pc");

var $kw3w9 = parcelRequire("kw3w9");

var $kbVTi = parcelRequire("kbVTi");

const $fba2c18b0b292ed3$var$Item = $kw3w9.extend({
    props: {
        id: 'string',
        name: 'string',
        selected: [
            'boolean',
            true,
            false
        ]
    }
});
const $fba2c18b0b292ed3$var$Items = $kbVTi.extend({
    model: $fba2c18b0b292ed3$var$Item
});

const $fba2c18b0b292ed3$var$ItemView = $dM6Pc.extend({
    template: (parcelRequire("74lK4")).default,
    events: {
        click: 'onClick'
    },
    bindings: {
        'model.selected': {
            type: 'booleanClass'
        }
    },
    onClick () {
        this.model.toggle('selected');
    }
});

$fba2c18b0b292ed3$exports = $dM6Pc.extend($789b1b5a0ac36af1$exports, {
    template: (parcelRequire("hNMpN")).default,
    initialize (opts) {
        this.setButton(opts.button);
        this.opts = opts;
        this.opts.position = 'bottom';
        this.state = opts.state;
        this.collection = new $fba2c18b0b292ed3$var$Items(this.collection.map((item)=>{
            return $akRxj($bd3QA(item, 'id', 'name'), {
                selected: this.state[opts.prop] === item.id
            });
        }));
        this.listenTo(this.collection, 'change:selected', this.onSelected);
    },
    onSelected (selectedModel, selected) {
        // de-select the rest
        for (const model of this.collection.models)if (model.id !== selectedModel.id) model.selected = false;
        this.parent.collection.state[this.opts.prop] = selected ? selectedModel.id : null;
        this.remove();
    },
    render (...args) {
        $789b1b5a0ac36af1$exports.render.apply(this, args);
        this.renderCollection(this.collection, $fba2c18b0b292ed3$var$ItemView, '[data-hook=list]');
        return this;
    }
});



// View displaying filter state
const $346d3b1e7ee8f2c1$var$SearchStateView = $dM6Pc.extend({
    template: (parcelRequire("1oZlT")).default,
    events: {
        'click [data-hook=remove-filter]': 'onRemoveFilter',
        'click [data-hook=reset-filters]': 'onResetFilter'
    },
    initialize () {
        this.listenTo(this.model, 'change', this.render);
    },
    onRemoveFilter (event) {
        this.model.set(event.target.dataset.prop, null);
    },
    onResetFilter (event) {
        event.preventDefault();
        this.model.clear();
    }
});

$346d3b1e7ee8f2c1$exports = $dM6Pc.extend({
    title: 'Transaktionen',
    template: (parcelRequire("gVe0D")).default,
    events: {
        'click [data-hook="filter-by-source"]': 'filterBySource',
        'click [data-hook="filter-by-target"]': 'filterByTarget',
        'click [data-hook="filter-by-product"]': 'filterByProduct'
    },
    props: {
        searchTerm: 'string',
        count: [
            'number',
            false,
            0
        ],
        displayCount: [
            'number',
            false,
            0
        ]
    },
    subviews: {
        searchBar: {
            hook: 'search-bar',
            prepareView (el) {
                return new $faf64da9e05fa3b7$exports({
                    placeholder: 'Produkt, Ort, Nutzer',
                    model: this.collection.state,
                    el: el,
                    parent: this
                });
            }
        },
        slider: {
            hook: 'slider',
            prepareView (el) {
                return new $346d3b1e7ee8f2c1$require$Slider({
                    model: this.collection.meta,
                    state: this.collection.state,
                    el: el,
                    parent: this
                });
            }
        },
        searchState: {
            hook: 'search-state',
            prepareView (el) {
                return new $346d3b1e7ee8f2c1$var$SearchStateView({
                    model: this.collection.state,
                    el: el,
                    parent: this
                });
            }
        }
    },
    bindings: {
        displayCount: {
            hook: 'displayCount'
        },
        count: {
            hook: 'count'
        }
    },
    initialize (opts) {
        // needed for admin check in template
        this.me = $4UX9c.me;
        this.collection = new $346d3b1e7ee8f2c1$require$Transactions(null, opts);
        this.on('change:searchTerm', this.triggerSearch, this);
        this.listenTo(this.collection.state, 'change', this.setQueryString);
        this.listenTo(this.collection, 'add remove', this.onAddRemove);
        this.on('change:displayCount', this.onLengthChange, this);
        this._scrollListener = this.infiniteScroll.bind(this);
        window.addEventListener('scroll', this._scrollListener, false);
    },
    infiniteScroll: $bb95e3b1ebc1adf7$exports(function() {
        if (window.scrollY >= document.body.offsetHeight - window.innerHeight - 200) this.collection.fetchMore();
    }, 50),
    setQueryString (state) {
        const params = new URLSearchParams();
        const opts = {
            q: state.q,
            source: $4UX9c.locations.get(state.source)?.slug,
            target: $4UX9c.locations.get(state.target)?.slug,
            product: $4UX9c.products.get(state.product)?.slug,
            start: state.start?.getTime(),
            end: state.end?.getTime()
        };
        for (const [key, value] of Object.entries(opts))if (value || value === 0) params.set(key, value);
        let qs = params.toString();
        if (qs.length) qs = `?${qs}`;
        history.replaceState(history.state, '', `${location.pathname}${qs}`);
    },
    filterBySource () {
        this.showAttributeFilter('source', 'Quelle', $4UX9c.locations);
    },
    filterByTarget () {
        this.showAttributeFilter('target', 'Ziel', $4UX9c.locations);
    },
    filterByProduct () {
        this.showAttributeFilter('product', 'Produkt', $4UX9c.products);
    },
    showAttributeFilter (prop, title, collection) {
        const button = this.queryByHook(`filter-by-${prop}`);
        // popover toggle behavior
        if (this.popover) this.popover.remove();
        this.popover = new $fba2c18b0b292ed3$exports({
            prop: prop,
            button: button,
            name: title,
            collection: collection,
            state: this.collection.state
        });
        this.registerSubview(this.popover.render());
    },
    onAddRemove () {
        this.count = this.collection.meta.count;
        this.displayCount = this.collection.length;
    },
    remove () {
        $dM6Pc.prototype.remove.call(this);
        window.removeEventListener('scroll', this._scrollListener, false);
        this.collection.stopListening();
        this.collection.off();
    },
    // will be called by SearchBarView
    search (query) {
        this.searchTerm = query;
    },
    triggerSearch () {
        this.collection.search(this.searchTerm);
    },
    render () {
        this.renderWithTemplate(this);
        this.renderCollection(this.collection, $056e8f0f3486aaa9$exports, '[data-hook=transaction-list]');
        return this;
    }
});


var $3f5c08d0f670e60f$exports = {};

var $4UX9c = parcelRequire("4UX9c");

var $dM6Pc = parcelRequire("dM6Pc");
var $139dd254a4734271$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $4UX9c = parcelRequire("4UX9c");

$139dd254a4734271$exports = $dM6Pc.extend({
    template: (parcelRequire("gc6JU")).default,
    events: {
        'click [data-hook=cancel]': 'onCancel',
        'keyup input[name=name]': 'onKeyup',
        submit: 'onSubmit'
    },
    initialize () {
        this.listenTo(this.model, 'sync', this.success);
    },
    onKeyup (e) {
        const val = (e.target.value || '').trim();
        this.model.name = val;
        this.query('button[type=submit]').disabled = !val.length;
    },
    onCancel (e) {
        e.preventDefault();
        if (this.parent) this.parent.createEvent = false;
    },
    onSubmit (e) {
        e.preventDefault();
        this.model.save();
    },
    success () {
        // only set the newly created event, if the user doesn't yet
        // have a current event selected
        if (!$4UX9c.me.currentEventId) {
            $4UX9c.me.once('sync', ()=>$4UX9c.navigate(''));
            $4UX9c.me.save({
                currentEventId: this.model.id
            });
        }
    },
    render () {
        this.renderWithTemplate(this);
        window.requestAnimationFrame(()=>this.query('input[name=name]').focus());
        return this;
    }
});


var $77fbf4d59f57bde4$exports = {};

var $bKnC7 = parcelRequire("bKnC7");

var $264826a651dea313$exports = {};

var $bKnC7 = parcelRequire("bKnC7");
$264826a651dea313$exports = $bKnC7.extend({
    props: {
        id: {
            type: 'string'
        },
        role: {
            type: 'string',
            default: 'dispatcher',
            values: [
                'dispatcher',
                'bar',
                'admin'
            ]
        },
        firstName: 'string',
        lastName: 'string',
        username: 'string',
        password: 'string'
    },
    session: {
        name: 'string'
    },
    derived: {
        roleLocalized: {
            deps: [
                'role'
            ],
            fn () {
                switch(this.role){
                    case 'admin':
                        return 'Administrator';
                    case 'dispatch':
                        return 'Dispatcher';
                    case 'bar':
                        return 'Barchef';
                    default:
                        return '';
                }
            }
        }
    }
});


const $77fbf4d59f57bde4$var$UsersCollection = $d09b7d770c5b7340$exports.extend({
    url () {
        return `/api/events/${this.parent.id}/users`;
    },
    model: $264826a651dea313$exports,
    comparator: 'name'
});
$77fbf4d59f57bde4$exports = $bKnC7.extend({
    urlRoot: '/api/events',
    props: {
        id: 'string',
        name: [
            'string',
            true
        ],
        vat: [
            'number',
            true,
            19
        ],
        spillage: [
            'number',
            true,
            3
        ],
        tokenValue: [
            'number',
            true,
            4
        ],
        slug: 'string',
        // role of the current user
        role: 'string',
        // clone param
        clone: 'string'
    },
    derived: {
        roleLocalized: {
            deps: [
                'role'
            ],
            fn () {
                switch(this.role){
                    case 'admin':
                        return 'Administrator';
                    case 'dispatcher':
                        return 'Dispatcher';
                    case 'bar':
                        return 'Barchef';
                    default:
                        return '';
                }
            }
        }
    },
    collections: {
        users: $77fbf4d59f57bde4$var$UsersCollection
    }
});


var $b5a41ababd8f2142$exports = {};

var $4UX9c = parcelRequire("4UX9c");

var $3c363cf591fb0d7f$exports = {};

var $4UX9c = parcelRequire("4UX9c");

$3c363cf591fb0d7f$exports = $77fbf4d59f57bde4$exports.extend({
    initialize () {
        this.listenTo($4UX9c.me, 'change:currentEventId', (me, currentEventId)=>{
            this.currentEventId = currentEventId;
        });
        // proxy changes to the user's currentEvent
        this.listenTo(this, 'sync', ()=>{
            if (this.isCurrentEvent) $4UX9c.me.currentEvent.set(this.toJSON());
        });
    },
    session: {
        currentEventId: {
            type: 'string',
            default () {
                return $4UX9c.me?.currentEventId;
            }
        }
    },
    derived: {
        isCurrentEvent: {
            deps: [
                'id',
                'currentEventId'
            ],
            fn () {
                return this.id === this.currentEventId;
            }
        }
    }
});


$b5a41ababd8f2142$exports = $8dd5675b2fc15f09$exports.extend({
    url: '/api/events',
    model: $3c363cf591fb0d7f$exports,
    // cache options
    storageKey () {
        return `${$4UX9c.me.currentEvent.slug}-events`;
    },
    comparator (event) {
        // sort current event first
        if (event.isCurrentEvent) return '0';
        return event.name;
    }
});



const $3f5c08d0f670e60f$var$EventSelector = $dM6Pc.extend({
    template: (parcelRequire("jedDj")).default,
    events: {
        'change [data-hook="event-selector"]': 'onChange'
    },
    initialize () {
        this.collection = new $b5a41ababd8f2142$exports();
        this.listenTo(this.collection, 'sync', this.render);
        this.collection.fetch();
    },
    onChange (event) {
        // wait for app sync to redirect, so we know everything is loaded
        $4UX9c.once('sync', ()=>$4UX9c.navigate('/'));
        $4UX9c.me.save({
            currentEventId: event.target.value
        }, {
            wait: true
        });
    }
});

$3f5c08d0f670e60f$exports = $dM6Pc.extend({
    title: 'Willkommen',
    template: (parcelRequire("7zo9Q")).default,
    subviews: {
        event: {
            hook: 'create-event',
            prepareView (el) {
                return new $139dd254a4734271$exports({
                    model: new $77fbf4d59f57bde4$exports(),
                    el: el
                });
            }
        },
        eventsList: {
            hook: 'events-list',
            prepareView (el) {
                return new $3f5c08d0f670e60f$var$EventSelector({
                    el: el
                });
            }
        }
    },
    initialize () {
        this.model = $4UX9c.me;
    }
});


var $3ae7e7dcf30cc4fb$exports = {};


var $akRxj = parcelRequire("akRxj");

var $4UX9c = parcelRequire("4UX9c");
var $bab3a19641c6d340$exports = {};


var $dM6Pc = parcelRequire("dM6Pc");

var $bab3a19641c6d340$require$Sortable = $96c85404d21524b4$export$2e2bcd8739ae039;

var $bab3a19641c6d340$require$tippy = $6445619a88c9e457$export$2e2bcd8739ae039;

var $4UX9c = parcelRequire("4UX9c");

var $gvQO6 = parcelRequire("gvQO6");
var $bab3a19641c6d340$require$isAdminProp = $gvQO6.isAdminProp;
var $e99c6ebc14d6ccf0$exports = {};

var $akRxj = parcelRequire("akRxj");
var $7ef03dbb91d443b3$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $4UX9c = parcelRequire("4UX9c");


var $023f4aec504704ff$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");


/**
 * Inventory Action Popover
 */ $023f4aec504704ff$exports = $dM6Pc.extend($789b1b5a0ac36af1$exports, {
    template: (parcelRequire("jVVS0")).default,
    initialize (opts) {
        this.setButton(opts.button);
        this.opts = opts;
    },
    render (...args) {
        $789b1b5a0ac36af1$exports.render.apply(this, args);
        return this;
    }
});



var $gvQO6 = parcelRequire("gvQO6");
var $7ef03dbb91d443b3$require$isAdminProp = $gvQO6.isAdminProp;
const $7ef03dbb91d443b3$var$ENTER_KEY = 13;
const $7ef03dbb91d443b3$var$ESC_KEY = 27;


/*
  Location Action Buttons
 */ const $7ef03dbb91d443b3$var$ButtonsView = $dM6Pc.extend({
    template: (parcelRequire("kY2Vr")).default,
    events: {
        'click [data-hook=cancel]': 'cancel',
        'click [data-hook=save]': 'save',
        'click [data-hook=delivery-button]': 'renderDeliveryModal'
    },
    props: {
        isAdmin: $7ef03dbb91d443b3$require$isAdminProp
    },
    derived: {
        isBarchef: {
            cache: false,
            fn () {
                return $4UX9c.me.role === 'bar';
            }
        },
        canStartDelivery: {
            cache: false,
            fn () {
                return $4UX9c.me.role === 'dispatcher' || $4UX9c.me.role === 'admin';
            }
        },
        exportUrl: {
            cache: false,
            fn () {
                return `/api/events/${$4UX9c.me.currentEvent.slug}/locations/${this.model.id}/inventories/export`;
            }
        },
        inventoryUrl: {
            cache: false,
            fn () {
                if (this.model.type === 'storage' || this.model.type === 'crash') return `/lager/${this.model.slug}/inventuren`;
                return `/bars/${this.model.slug}/inventuren`;
            }
        }
    },
    initialize () {
        this.listenTo(this.model, 'change:name', this.onChange);
    },
    cancel () {
        this.parent.cancel();
    },
    save () {
        $4UX9c.locations.create(this.model, {
            wait: true
        });
    },
    renderDeliveryModal () {
        (parcelRequire("eEa8p")).then((module1)=>{
            const DeliveryModalView = module1.default;
            this.deliveryView = new DeliveryModalView({
                props: {
                    targetId: this.model.id,
                    onClose: ()=>{
                        this.deliveryView.remove();
                    }
                }
            });
            this.renderSubview(this.deliveryView, $4UX9c.view.el);
        });
    },
    onChange (model, name) {
        (this.query('[data-hook=save]') || {}).disabled = !name;
    },
    render () {
        this.renderWithTemplate(this);
        if (this.isAdmin || this.isBarchef) this.renderSubview(new $d23b55c707a7112e$exports({
            el: this.queryByHook('inventory-button'),
            icon: 'ion-ios-paper',
            title: 'Inventuren verwalten...',
            Popover: $023f4aec504704ff$exports,
            popoverOpts: {
                model: this,
                position: 'bottom'
            }
        }));
        if (!this.model.isNew() && this.model.editable) this.renderSubview(new $d23b55c707a7112e$exports({
            el: this.queryByHook('delete-button'),
            icon: 'ion-ios-trash',
            title: `${this.model.name} l\xf6schen...`,
            classes: 'button-error',
            Popover: $3c03021769421268$exports,
            popoverOpts: {
                model: this.model,
                position: 'bottom'
            }
        }));
        return this;
    }
});

/*
  Location Header with title and buttons
 */ const $7ef03dbb91d443b3$var$HeaderView = $dM6Pc.extend({
    template: (parcelRequire("kaUCt")).default,
    events: {
        'blur .location-name': 'setName',
        'keyup .location-name': 'keyup'
    },
    props: {
        isAdmin: $7ef03dbb91d443b3$require$isAdminProp
    },
    initialize () {
        this.listenTo(this.model, 'change:editable', this.render);
        if (this.model.isNew()) this.listenToOnce(this.model, 'sync', this.cancel);
    },
    setName (event) {
        const val = event.target.value;
        if (val) this.model.set('name', val.trim());
    },
    cancel () {
        this.parent.remove();
    },
    keyup (event) {
        this.setName(event);
        if (event.which === $7ef03dbb91d443b3$var$ENTER_KEY) {
            event.preventDefault();
            if (event.target.value) $4UX9c.locations.create(this.model, {
                wait: true
            });
            return;
        }
        if (this.model.isNew() && event.which === $7ef03dbb91d443b3$var$ESC_KEY) this.cancel();
    },
    render () {
        this.renderWithTemplate(this.model);
        this.renderSubview(new $7ef03dbb91d443b3$var$ButtonsView({
            model: this.model
        }), this.query('[data-hook=buttons]'));
        if (this.model.isNew()) window.requestAnimationFrame(()=>this.query('.location-name').focus());
        return this;
    }
});
/*
  Location Base View
 */ $7ef03dbb91d443b3$exports = $dM6Pc.extend({
    subviews: {
        header: {
            hook: 'location-header',
            prepareView (el) {
                return new $7ef03dbb91d443b3$var$HeaderView({
                    el: el,
                    model: this.model
                });
            }
        }
    },
    props: {
        isAdmin: $7ef03dbb91d443b3$require$isAdminProp
    },
    events: {
        'click [data-hook="sort-name"]': 'sortByName',
        'click [data-hook="sort-units"]': 'sortByStock',
        'click [data-hook="sort-sortPosition"]': 'sortByPosition'
    },
    initialize () {
        this.listenTo(this.model.stock.state, 'change:comparator change:order', this.toggleIcon);
    },
    toggleIcon () {
        for (const el of this.queryAll('.sortable-column'))el.classList.remove('sorted');
        const column = this.queryByHook(`sort-${this.model.stock.state.comparator}`);
        column.classList.remove('desc', 'asc');
        column.classList.add('sorted', this.model.stock.state.order);
    },
    sortByName (evt) {
        evt.preventDefault();
        this.model.stock.setComparator('name');
    },
    sortByStock (evt) {
        evt.preventDefault();
        this.model.stock.setComparator('units');
    },
    sortByPosition (evt) {
        evt.preventDefault();
        this.model.stock.setComparator('sortPosition');
    },
    onEditable (model, isEditable) {
        if (!isEditable) model.save();
    },
    render () {
        // render storage shell
        this.renderWithTemplate(this);
        // render stock list
        this.renderCollection(this.model.stock, this.ItemView, this.queryByHook('item-list'));
        return this;
    }
});


var $6262c696c7e1ce59$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");
var $3ad8190958fb2c1a$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $f1cfaaaa4d39af0e$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

$f1cfaaaa4d39af0e$exports = $dM6Pc.extend({
    template: (parcelRequire("2fHAc")).default,
    events: {
        'change [name=productId]': 'onProductChange',
        'change [name=inputPackages]': 'onKeyup',
        'change [name=inputUnits]': 'onKeyup',
        'change [name=isFree]': 'onChangeIsFree',
        'keyup input': 'onKeyup',
        'click [data-hook=remove]': 'onRemove'
    },
    initialize () {
        this.listenTo(this.model, 'invalid error', this.handleError);
        this.listenTo(this.model, 'sync', this.remove);
        this.listenTo(this.model, 'change:product', this.render);
        this.listenTo(this.model, 'change:units change:targetId', this.clearError);
    },
    onKeyup (event) {
        event.stopPropagation();
        this.model.set(event.target.name, +event.target.value || 0);
    },
    onRemove (event) {
        event.preventDefault();
        this.model.collection.remove(this.model);
    },
    onProductChange (event) {
        event.stopPropagation();
        this.model.set('productId', event.target.value);
    },
    onChangeIsFree (event) {
        this.model.set('isFree', event.target.checked);
    },
    clearError () {
        this.errorItem.classList.toggle('hidden', this.model.isValid());
    },
    handleError (model, error) {
        this.errorText.textContent = error;
        this.errorItem.classList.remove('hidden');
    },
    render () {
        this.renderWithTemplate(this);
        this.cacheElements({
            errorItem: '[data-hook="error-item"]',
            errorText: '[data-hook="error-text"]'
        });
        return this;
    }
});



var $3ad8190958fb2c1a$require$Transaction = $2937b6842f5491f9$export$2e2bcd8739ae039;



$3ad8190958fb2c1a$exports = $dM6Pc.extend($789b1b5a0ac36af1$exports, {
    template: (parcelRequire("b0LoA")).default,
    events: {
        'change [data-hook=target]': 'onTargetChange',
        'click [data-hook=submit]': 'submit'
    },
    subviews: {
        target: {
            hook: 'select-target',
            prepareView (el) {
                return new $021f193430451dc4$exports({
                    el: el,
                    model: this.model
                });
            }
        },
        item: {
            hook: 'products',
            prepareView (el) {
                return new $f1cfaaaa4d39af0e$exports({
                    el: el,
                    model: this.model,
                    template: (parcelRequire("2uo5I")).default
                });
            }
        }
    },
    initialize (opts = {}) {
        this.setButton(opts.button);
        this.opts = opts;
        this.model = new $3ad8190958fb2c1a$require$Transaction({
            sourceId: opts.sourceId,
            productId: opts.productId
        });
        this.listenTo(this.model, 'sync', this.remove);
        this.listenTo(this.model, 'change:units', this.isValid);
    },
    /*
    Vollständigkeit prüfen und Button togglen
   */ isValid () {
        const isValid = this.model.isValid();
        if (this.btn) this.btn.disabled = !isValid;
        return isValid;
    },
    // set new target for all transactions
    onTargetChange (event) {
        event.preventDefault();
        this.model.targetId = event.target.value;
    },
    submit (event) {
        event.preventDefault();
        this.model.save();
    },
    render (...args) {
        $789b1b5a0ac36af1$exports.render.apply(this, args);
        window.requestAnimationFrame(()=>this.query('[name=target]').focus());
        this.cacheElements({
            btn: '[data-hook=submit]'
        });
        return this;
    }
});




var $gvQO6 = parcelRequire("gvQO6");
var $6262c696c7e1ce59$require$isAdminProp = $gvQO6.isAdminProp;


$6262c696c7e1ce59$exports = $dM6Pc.extend({
    template: (parcelRequire("axpyH")).default,
    crashTemplate: (parcelRequire("6Kql9")).default,
    props: {
        isAdmin: $6262c696c7e1ce59$require$isAdminProp
    },
    initialize () {
        this.listenTo(this.model, 'change', this.render);
    },
    render () {
        const type = this.parent.model.type;
        const template = type === 'crash' ? this.crashTemplate : this.template;
        this.renderWithTemplate(this, template);
        if (type !== 'crash') this.renderSubview(new $d23b55c707a7112e$exports({
            icon: 'ion-paper-airplane',
            title: `${this.model.product.name} dispatchen...`,
            classes: 'pure-button-primary',
            Popover: $3ad8190958fb2c1a$exports,
            popoverOpts: {
                sourceId: this.parent.model.id,
                productId: this.model.productId,
                position: 'bottom'
            }
        }), '[data-hook="dispatch-button"]');
        return this;
    }
});



/*
  View für ein einzelnes Lager
  Model ist Storage, mit Inventar als model.stock
 */ $e99c6ebc14d6ccf0$exports = $7ef03dbb91d443b3$exports.extend({
    template: (parcelRequire("6sOFj")).default,
    ItemView: $6262c696c7e1ce59$exports,
    events: $akRxj({
        'change [data-hook=is-crash]': 'isCrash'
    }, $7ef03dbb91d443b3$exports.prototype.events),
    initialize () {
        $7ef03dbb91d443b3$exports.prototype.initialize.apply(this);
        this.listenTo(this.model, 'sort', this.onSort);
        this.listenTo(this.model, 'change:editable', this.onEditable);
    },
    isCrash (event) {
        event.stopPropagation();
        const isCrash = event.target.checked;
        this.model.type = isCrash ? 'crash' : 'storage';
    }
});


var $7ab1c3f7c461e20b$exports = {};

var $4UX9c = parcelRequire("4UX9c");

var $dM6Pc = parcelRequire("dM6Pc");

var $akRxj = parcelRequire("akRxj");

var $357953ca2b3eb54c$exports = {};


$357953ca2b3eb54c$exports = $6262c696c7e1ce59$exports.extend({
    template: (parcelRequire("lLI8n")).default
});



const $7ab1c3f7c461e20b$var$BarFooter = $dM6Pc.extend({
    template: (parcelRequire("lFWZ8")).default,
    initialize () {
        this.listenTo(this.model.stock, 'change add remove', this.render);
        this.listenTo(this.model, 'change', this.render);
    }
});

/*
  View für eine einzelne Bar
  Model ist Bar, mit Inventar als model.stock
 */ $7ab1c3f7c461e20b$exports = $7ef03dbb91d443b3$exports.extend({
    template: (parcelRequire("btiHk")).default,
    ItemView: $357953ca2b3eb54c$exports,
    derived: {
        isBarchef: {
            cache: false,
            fn () {
                return $4UX9c.me.role === 'bar';
            }
        }
    },
    subviews: $akRxj({}, $7ef03dbb91d443b3$exports.prototype.subviews, {
        footer: {
            hook: 'bar-footer',
            prepareView (el) {
                return new $7ab1c3f7c461e20b$var$BarFooter({
                    el: el,
                    model: this.model
                });
            }
        }
    }),
    events: $akRxj({}, $7ef03dbb91d443b3$exports.prototype.events, {
        'click .dispatch-all': 'dispatchAll'
    }),
    initialize () {
        $7ef03dbb91d443b3$exports.prototype.initialize.apply(this);
        this.listenTo(this.model, 'sort', this.onSort);
        this.listenTo(this.model, 'change:editable', this.onEditable);
    },
    dispatchAll (evt) {
        evt.preventDefault();
        evt.stopPropagation();
    }
});




/**
 * Quick Select View
 *
 * - lists the locations
 * - filters by id
 * - re-renders on when collection changes
 */ const $bab3a19641c6d340$var$QuickSelectView = $dM6Pc.extend({
    template: (parcelRequire("cFIFy")).default,
    events: {
        'change [data-hook=quick-select]': 'quickSelect'
    },
    initialize () {
        this.collection = new $83a891297e5a5907$exports($4UX9c.locations, {
            filter: this.parent.collection.filterFn,
            watched: [
                'type'
            ]
        });
        this.listenTo(this.collection, 'add remove change', this.render);
    },
    quickSelect (event) {
        event.preventDefault();
        const val = event.target.value;
        if (val === 'all') this.parent.collection.removeFilter(this._filter);
        else {
            const filter = (model)=>model.id === val;
            this.parent.collection.swapFilters(filter, this._filter || []);
            this._filter = filter;
        }
    },
    render () {
        this.renderWithTemplate({
            collection: this.collection.toJSON()
        });
        return this;
    }
});
$bab3a19641c6d340$exports = $dM6Pc.extend({
    events: {
        'click [data-hook=add-location]': 'onNew',
        'click [data-hook=edit-location]': 'onEdit'
    },
    props: {
        editable: [
            'boolean',
            true,
            false
        ],
        showNew: [
            'boolean',
            true,
            false
        ],
        isAdmin: $bab3a19641c6d340$require$isAdminProp
    },
    subviews: {
        quickSelect: {
            hook: 'quick-select',
            prepareView (el) {
                return new $bab3a19641c6d340$var$QuickSelectView({
                    el: el,
                    parent: this
                });
            }
        },
        searchBar: {
            hook: 'search-bar',
            prepareView (el) {
                return new $faf64da9e05fa3b7$exports({
                    el: el,
                    parent: this
                });
            }
        },
        locationList: {
            hook: 'location-list',
            prepareView (el) {
                return this.renderCollection(this.collection, (opts)=>{
                    if (opts.model.type === 'storage' || opts.model.type === 'crash') return new $e99c6ebc14d6ccf0$exports({
                        model: opts.model,
                        parent: this
                    });
                    if (opts.model.type === 'bar') return new $7ab1c3f7c461e20b$exports({
                        model: opts.model,
                        parent: this
                    });
                }, el);
            }
        }
    },
    onEdit () {
        this.toggle('editable');
        this.collection.each((model)=>model.toggle('editable'));
        window.requestAnimationFrame(()=>{
            this.el.classList.toggle('location--edit', this.editable);
        });
        this.toggleEditMode();
    },
    toggleEditMode () {
        const isEditable = this.get('editable');
        if (isEditable) this.sortable = $bab3a19641c6d340$require$Sortable.create(this.query('[data-hook=location-list]'), {
            handle: '.drag-handle',
            animation: 150,
            onEnd () {
                this.toArray().forEach((id, index)=>{
                    const model = $4UX9c.locations.get(id);
                    if (index !== model.sortPosition) model.sortPosition = index;
                });
            }
        });
        else this.sortable.destroy();
    },
    // this will be called by SearchBarView
    search (query) {
        // search the stock of each location
        this.collection.each((location)=>location.stock.byName(query));
    },
    remove () {
        if (this.tooltips) for (const tip of this.tooltips)tip.destroy();
        return $dM6Pc.prototype.remove.call(this);
    },
    render () {
        // render page shell
        this.renderWithTemplate(this);
        // add tooltips to the buttons
        if (!$4UX9c.isMobile) this.tooltips = $bab3a19641c6d340$require$tippy(this.queryAll('button[data-title]'));
        // display input form if collection is empty
        this.listenTo(this.collection, 'sync reset remove', ()=>{
            if (!this.collection.length && !this.showNew) {
                this.showNew = true;
                this.onNew();
            }
        });
        return this;
    }
});



var $4bc923eea69c0571$exports = {};
var $c870001684b42152$exports = {};

var $bKnC7 = parcelRequire("bKnC7");

var $4UX9c = parcelRequire("4UX9c");

var $gvQO6 = parcelRequire("gvQO6");
var $c870001684b42152$require$indexify = $gvQO6.indexify;
var $c870001684b42152$require$slugify = $gvQO6.slugify;
var $ffe57d6fa9b030d1$exports = {};

var $kw3w9 = parcelRequire("kw3w9");


var $4UX9c = parcelRequire("4UX9c");


var $gvQO6 = parcelRequire("gvQO6");

var $4UX9c = parcelRequire("4UX9c");

var $kw3w9 = parcelRequire("kw3w9");

var $eSA5k = parcelRequire("eSA5k");
var $02b4208808d8caef$exports = {};

var $39TZG = parcelRequire("39TZG");

var $lIKbn = parcelRequire("lIKbn");
/** `Object#toString` result references. */ var $02b4208808d8caef$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $02b4208808d8caef$var$isNumber(value) {
    return typeof value == 'number' || $lIKbn(value) && $39TZG(value) == $02b4208808d8caef$var$numberTag;
}
$02b4208808d8caef$exports = $02b4208808d8caef$var$isNumber;



var $9c5La = parcelRequire("9c5La");

var $gvQO6 = parcelRequire("gvQO6");
function $bd70af13b522fb69$var$currency(key) {
    return {
        deps: [
            key
        ],
        fn () {
            return (0, $gvQO6.currency)(this[key]);
        }
    };
}
const $bd70af13b522fb69$export$5c09c303566d173e = (0, (/*@__PURE__*/$parcel$interopDefault($kw3w9))).extend({
    props: {
        units: [
            'number',
            false,
            0
        ],
        unitsSinceInventory: [
            'number',
            false,
            0
        ],
        unitsLastInventory: [
            'number',
            false,
            0
        ],
        unitsSold: [
            'number',
            false,
            0
        ],
        lastInventoryTime: [
            'date'
        ],
        lastInventoryId: [
            'string'
        ],
        productId: [
            'string'
        ],
        locationId: [
            'string'
        ]
    },
    session: {
        spillage: {
            type: 'number',
            default () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me?.currentEvent.spillage;
            }
        },
        eventVat: {
            type: 'number',
            default () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me?.currentEvent.vat;
            }
        }
    },
    initialize () {
        // proxy sortPosition change to collection
        this.listenTo(this.product, 'change:sortPosition', (product, position)=>{
            this.trigger('change:sortPosition', this, position);
        });
        this.listenTo((0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent, 'change:vat change:spillage', ()=>{
            this.set({
                spillage: (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent.spillage,
                eventVat: (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent.vat
            });
        });
    },
    derived: {
        product: {
            deps: [
                'productId'
            ],
            fn () {
                return (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).products?.get(this.productId);
            }
        },
        lastInventoryTimeLocalized: {
            deps: [
                'lastInventoryTime'
            ],
            fn () {
                return (0, $9c5La.DateTime).fromJSDate(this.lastInventoryTime).toLocaleString((0, $9c5La.DateTime).DATETIME_SHORT);
            }
        },
        lastInventoryUrl: {
            deps: [
                'lastInventoryId'
            ],
            fn () {
                const type = this.collection.parent.type === 'bar' ? 'bars' : 'lager';
                return `${type}/${this.collection.parent.slug}/inventuren/${this.lastInventoryId}`;
            }
        },
        unitsLocalized: (0, $gvQO6.unitsLocalized)('units'),
        packagesLocalized: (0, $gvQO6.packagesLocalized)('units'),
        unitsSoldLocalized: (0, $gvQO6.unitsLocalized)('unitsSold'),
        packagesSoldLocalized: (0, $gvQO6.packagesLocalized)('unitsSold'),
        unitsSinceInventoryLocalized: (0, $gvQO6.unitsLocalized)('unitsSinceInventory'),
        packagesSinceInventoryLocalized: (0, $gvQO6.packagesLocalized)('unitsSinceInventory'),
        stockNetValue: {
            deps: [
                'units'
            ],
            fn () {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($02b4208808d8caef$exports)))(this.units) || !(0, (/*@__PURE__*/$parcel$interopDefault($02b4208808d8caef$exports)))(this.product.costPerUnit)) return 0;
                return +new (0, (/*@__PURE__*/$parcel$interopDefault($eSA5k)))(this.units).times(this.product.costPerUnit);
            }
        },
        stockNetValueLocalized: $bd70af13b522fb69$var$currency('stockNetValue'),
        salesGross: {
            deps: [
                'unitsSold'
            ],
            fn () {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($02b4208808d8caef$exports)))(this.unitsSold) || !(0, (/*@__PURE__*/$parcel$interopDefault($02b4208808d8caef$exports)))(this.product.pricePerUnit)) return null;
                return +new (0, (/*@__PURE__*/$parcel$interopDefault($eSA5k)))(this.unitsSold).times(this.product.pricePerUnit);
            }
        },
        salesGrossLocalized: $bd70af13b522fb69$var$currency('salesGross'),
        salesNet: {
            deps: [
                'salesGross',
                'eventVat'
            ],
            fn () {
                if (!this.salesGross) return null;
                return (0, $gvQO6.net)(this.salesGross);
            }
        },
        salesNetLocalized: $bd70af13b522fb69$var$currency('salesNet'),
        vat: {
            deps: [
                'salesNet',
                'salesGross',
                'eventVat'
            ],
            fn () {
                return (0, $gvQO6.vat)(this.salesNet, this.salesGross);
            }
        },
        vatLocalized: $bd70af13b522fb69$var$currency('vat'),
        salesGrossAfterSpillage: {
            deps: [
                'salesGross',
                'spillage'
            ],
            fn () {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($02b4208808d8caef$exports)))(this.salesGross) || !(0, (/*@__PURE__*/$parcel$interopDefault($02b4208808d8caef$exports)))(this.spillage)) return null;
                if (!this.product.canSpill) return this.salesGross;
                const rate = new (0, (/*@__PURE__*/$parcel$interopDefault($eSA5k)))(100).minus(this.spillage).div(100);
                return +new (0, (/*@__PURE__*/$parcel$interopDefault($eSA5k)))(this.salesGross).times(rate);
            }
        }
    },
    update (transaction) {
        const locationId = this.collection.parent.id;
        const isComplete = transaction.state === 'complete';
        if (isComplete && transaction.sourceId === locationId) this.units = this.units - transaction.units;
        else if (isComplete && transaction.targetId === locationId) this.units = this.units + transaction.units;
        return this;
    }
});


var $ffe57d6fa9b030d1$require$StockItem = $bd70af13b522fb69$export$5c09c303566d173e;
const $ffe57d6fa9b030d1$var$SortState = $kw3w9.extend({
    props: {
        comparator: {
            type: 'string',
            values: [
                'name',
                'units',
                'sortPosition',
                'delivery',
                'ratio'
            ]
        },
        order: {
            type: 'string',
            required: true,
            values: [
                'asc',
                'desc'
            ],
            default: 'asc'
        }
    },
    derived: {
        comparatorFn: {
            deps: [
                'comparator',
                'order'
            ],
            fn () {
                switch(this.comparator){
                    case 'name':
                        if (this.order === 'desc') return $gvQO6.byStockNameDesc;
                        return $gvQO6.byStockNameAsc;
                    case 'units':
                    case 'delivery':
                    case 'ratio':
                        if (this.order === 'desc') return $gvQO6.byNumberDesc(this.comparator);
                        return $gvQO6.byNumberAsc(this.comparator);
                    default:
                        if (this.order === 'desc') return $gvQO6.byStockSortPositionDesc;
                        return $gvQO6.byStockSortPosition;
                }
            }
        }
    }
});
$ffe57d6fa9b030d1$exports = $d09b7d770c5b7340$exports.extend({
    model: $ffe57d6fa9b030d1$require$StockItem,
    initialize () {
        if ($4UX9c.changes) this.listenTo($4UX9c.changes, 'transactions', this.onTransaction);
        this.state = new $ffe57d6fa9b030d1$var$SortState();
        this.listenTo(this.state, 'change:comparatorFn', this.onComparatorChange);
        // listen for proxied sortPosition change and re-sort
        this.on('change:sortPosition', $bb95e3b1ebc1adf7$exports(()=>this.sort(), 100), this);
    },
    // so we can fetch stock by productId
    mainIndex: 'productId',
    /*
    Sort by sortPosition or name by default
   */ comparator: $gvQO6.byStockSortPosition,
    setComparator (prop) {
        // toggle ASC/DESC
        if (this.state.comparator === prop) this.state.toggle('order');
        this.state.comparator = prop;
    },
    onComparatorChange (state, comparator) {
        this.comparator = comparator;
        this.sort();
    },
    /*
    Filter by provided term (in product names)
   */ byName (searchTerm) {
        const term = $gvQO6.indexify(searchTerm);
        // save unfiltered models for later
        if (!this.filtered) this._originalModels = this.models;
        // reset search
        if (!term) {
            this.reset(this._originalModels);
            this.filtered = false;
            return;
        }
        if (term.length < 2) return;
        // filter original models
        const filtered = this._originalModels.filter((item)=>item.product._nameIndex.indexOf(term) > -1);
        this.reset(filtered);
        this.filtered = true;
    },
    /**
   * React to complete transactions
   * @param  {object} change Updated transaction
   */ onTransaction (change) {
        if (!this.shouldReact(change.row)) return;
        const stockItem = this.get(change.row.productId);
        if (stockItem) stockItem.update(change.row);
        else $4UX9c.locations.fetch();
    },
    /**
   * Check if we should react to this transaction
   *
   * @param  {object} transaction Transaction
   * @return {boolean}
   */ shouldReact (transaction) {
        const isSource = transaction.sourceId === this.parent.id;
        const isTarget = transaction.targetId === this.parent.id;
        const isComplete = transaction.state === 'complete';
        return isComplete && (isSource || isTarget);
    }
});


/*
  Model representing a location
 */ $c870001684b42152$exports = $bKnC7.extend({
    urlRoot () {
        return `/api/events/${$4UX9c.me.currentEvent.slug}/locations`;
    },
    props: {
        id: [
            'string'
        ],
        name: [
            'string',
            true
        ],
        type: {
            type: 'string',
            required: true,
            values: [
                'bar',
                'storage',
                'crash',
                'delivery'
            ]
        },
        sortPosition: [
            'number'
        ]
    },
    collections: {
        stock: $ffe57d6fa9b030d1$exports
    },
    session: {
        editable: [
            'boolean',
            true,
            false
        ]
    },
    derived: {
        slug: {
            deps: [
                'name'
            ],
            fn () {
                return $c870001684b42152$require$slugify(this.name);
            }
        },
        link: {
            deps: [
                'slug',
                'type'
            ],
            fn () {
                if (this.type === 'storage' || this.type === 'crash') return `/lager#${this.slug}`;
                if (this.type === 'bar') return `/bars#${this.slug}`;
            }
        },
        _nameIndex: {
            deps: [
                'name'
            ],
            fn () {
                return $c870001684b42152$require$indexify(this.name);
            }
        }
    }
});


/*
  Model representing a storage space
 */ $4bc923eea69c0571$exports = $c870001684b42152$exports.extend({
    props: {
        type: [
            'string',
            true,
            'storage'
        ]
    }
});



/*
  Seite - Lagerübersicht
 */ $3ae7e7dcf30cc4fb$exports = $bab3a19641c6d340$exports.extend({
    title: 'Lager',
    template: (parcelRequire("4FZ98")).default,
    events: $akRxj({}, $bab3a19641c6d340$exports.prototype.events, {}),
    initialize () {
        // render from cache and fetch updates in the background
        this.collection = new $83a891297e5a5907$exports($4UX9c.locations, {
            filter (model) {
                return model.type === 'storage' || model.type === 'crash';
            },
            watched: [
                'type'
            ]
        });
        this.collection.filterFn = (model)=>model.type === 'storage' || model.type === 'crash';
        $4UX9c.locations.fetch();
    },
    /**
   * Adds a new location to the collection
   * @param  {object} event DOM Event
   */ onNew () {
        this.renderSubview(new $e99c6ebc14d6ccf0$exports({
            model: new $4bc923eea69c0571$exports(),
            parent: this
        }), '[data-hook="new-location"]');
    }
});


var $2141ca89e74a77ba$exports = {};

var $akRxj = parcelRequire("akRxj");



var $4UX9c = parcelRequire("4UX9c");

var $f6ea85ea97c73a0a$exports = {};

var $4UX9c = parcelRequire("4UX9c");

var $gvQO6 = parcelRequire("gvQO6");
var $f6ea85ea97c73a0a$require$currency = $gvQO6.currency;
var $f6ea85ea97c73a0a$require$net = $gvQO6.net;
var $f6ea85ea97c73a0a$require$vat = $gvQO6.vat;

$f6ea85ea97c73a0a$exports = $c870001684b42152$exports.extend({
    initialize () {
        this.listenToAndRun(this.stock, 'change', this.onChange);
        this.listenTo($4UX9c.me.currentEvent, 'change:tokenValue', (event, tokenValue)=>{
            this.eventTokenValue = tokenValue;
        });
    },
    props: {
        type: [
            'string',
            true,
            'bar'
        ]
    },
    session: {
        sumSalesGrossValue: [
            'number'
        ],
        sumSalesGross: [
            'string'
        ],
        sumSalesNet: [
            'string'
        ],
        sumSalesGrossAfterSpillage: [
            'string'
        ],
        sumSalesGrossAfterSpillageValue: [
            'number'
        ],
        sumSalesNetAfterSpillage: [
            'string'
        ],
        vat: [
            'string'
        ],
        vatAfterSpillage: [
            'string'
        ],
        tokens: [
            'number',
            true,
            0
        ],
        eventTokenValue: {
            type: 'number',
            default () {
                return $4UX9c.me.currentEvent.tokenValue;
            }
        }
    },
    derived: {
        tokensValue: {
            deps: [
                'tokens',
                'eventTokenValue'
            ],
            fn () {
                return this.tokens * this.eventTokenValue;
            }
        },
        sumSalesGrossAfterSpillageWithoutTokens: {
            deps: [
                'sumSalesGrossAfterSpillageValue',
                'tokensValue'
            ],
            fn () {
                return $f6ea85ea97c73a0a$require$currency(this.sumSalesGrossAfterSpillageValue - this.tokensValue);
            }
        },
        sumSalesNetAfterSpillageWithoutTokens: {
            deps: [
                'sumSalesGrossAfterSpillageValue',
                'tokensValue'
            ],
            fn () {
                return $f6ea85ea97c73a0a$require$currency($f6ea85ea97c73a0a$require$net(this.sumSalesGrossAfterSpillageValue - this.tokensValue));
            }
        },
        vatAfterSpillageWithoutTokens: {
            deps: [
                'sumSalesGrossAfterSpillageValue',
                'tokensValue'
            ],
            fn () {
                const netValue = $f6ea85ea97c73a0a$require$net(this.sumSalesGrossAfterSpillageValue - this.tokensValue);
                return $f6ea85ea97c73a0a$require$currency($f6ea85ea97c73a0a$require$vat(netValue, this.sumSalesGrossAfterSpillageValue - this.tokensValue));
            }
        }
    },
    onChange () {
        this.sumSalesGrossValue = this.stock.map((item)=>item.salesGross).reduce((a, b)=>a + b, 0);
        this.sumSalesGross = $f6ea85ea97c73a0a$require$currency(this.sumSalesGrossValue);
        const sumSalesNet = $f6ea85ea97c73a0a$require$net(this.sumSalesGrossValue);
        this.sumSalesNet = $f6ea85ea97c73a0a$require$currency(sumSalesNet);
        this.vat = $f6ea85ea97c73a0a$require$currency($f6ea85ea97c73a0a$require$vat(sumSalesNet, this.sumSalesGrossValue));
        this.sumSalesGrossAfterSpillageValue = this.stock.map((item)=>item.salesGrossAfterSpillage).reduce((a, b)=>a + b, 0);
        this.sumSalesGrossAfterSpillage = $f6ea85ea97c73a0a$require$currency(this.sumSalesGrossAfterSpillageValue);
        const sumSalesNetAfterSpillage = $f6ea85ea97c73a0a$require$net(this.sumSalesGrossAfterSpillageValue);
        this.sumSalesNetAfterSpillage = $f6ea85ea97c73a0a$require$currency(sumSalesNetAfterSpillage);
        this.vatAfterSpillage = $f6ea85ea97c73a0a$require$currency($f6ea85ea97c73a0a$require$vat(sumSalesNetAfterSpillage, this.sumSalesGrossAfterSpillageValue));
    }
});



/*
  Seite - Barübersicht
 */ $2141ca89e74a77ba$exports = $bab3a19641c6d340$exports.extend({
    title: 'Bars',
    template: (parcelRequire("kPvmu")).default,
    events: $akRxj({}, $bab3a19641c6d340$exports.prototype.events, {}),
    derived: {
        isBarchef: {
            cache: false,
            fn () {
                return $4UX9c.me.role === 'bar';
            }
        }
    },
    initialize () {
        const where = {
            type: 'bar'
        };
        /**
     * The endpoint returns multiple locations even for barchefs based on the settings:
     * - defaultSourceLocationId
     * - defaultTargetLocationId
     * - assignedLocationId
     * ...we only want to display the assigned location, though.
     */ if ($4UX9c.me.assignedLocationId) where.id = $4UX9c.me.assignedLocationId;
        // render from cache and fetch updates in the background
        this.collection = new $83a891297e5a5907$exports($4UX9c.locations, {
            where: where
        });
        this.collection.filterFn = (model)=>model.type === 'bar';
        $4UX9c.locations.fetch();
    },
    /**
   * Adds a new location to the collection
   */ onNew () {
        this.renderSubview(new $7ab1c3f7c461e20b$exports({
            model: new $f6ea85ea97c73a0a$exports(),
            parent: this
        }), '[data-hook="new-location"]');
    }
});


var $f103575a91c00a11$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $4UX9c = parcelRequire("4UX9c");


var $28d0afe0d50c6d4b$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $4UX9c = parcelRequire("4UX9c");

var $gvQO6 = parcelRequire("gvQO6");
var $28d0afe0d50c6d4b$require$isAdminProp = $gvQO6.isAdminProp;

$28d0afe0d50c6d4b$exports = $dM6Pc.extend({
    template: (parcelRequire("kQ5h0")).default,
    events: {
        'click [data-hook=activate]': 'activate'
    },
    bindings: {
        'model.name': {
            hook: 'name'
        },
        'model.isCurrentEvent': [
            {
                type: 'booleanClass',
                hook: 'activate',
                name: 'hidden'
            },
            {
                type: 'booleanClass',
                hook: 'name',
                name: 'item-name'
            }
        ]
    },
    props: {
        isAdmin: $28d0afe0d50c6d4b$require$isAdminProp
    },
    activate (event) {
        event.preventDefault();
        $4UX9c.me.save({
            currentEventId: this.model.id
        }, {
            wait: true
        });
    },
    render () {
        this.renderWithTemplate(this);
        return this;
    }
});



var $f811a3a1a5995edf$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");
var $b4b9092253857fb9$exports = {};
function $b4b9092253857fb9$var$transitionEnd() {
    const el = document.createElement('bootstrap');
    const transEndEventNames = {
        transition: 'transitionend',
        WebkitTransition: 'webkitTransitionEnd',
        MozTransition: 'transitionend',
        OTransition: 'oTransitionEnd otransitionend'
    };
    for(const name in transEndEventNames){
        if (el.style[name] !== undefined) return transEndEventNames[name];
    }
    return false // explicit for ie8 (  ._.)
    ;
}
function $b4b9092253857fb9$var$animationEnd() {
    const el = document.createElement('bootstrap');
    const transEndEventNames = {
        animation: 'animationend',
        webkitAnimation: 'webkitAnimationEnd',
        MozAnimation: 'mozAnimationEnd',
        OAnimation: 'oAnimationEnd oanimationend'
    };
    for(const name in transEndEventNames){
        if (el.style[name] !== undefined) return transEndEventNames[name];
    }
    return false // explicit for ie8 (  ._.)
    ;
}
function $b4b9092253857fb9$var$onEnd(props) {
    return function(el, fn) {
        const self = this;
        function handler(event) {
            fn.call(self, event);
            el.removeEventListener(event.type, handler);
        }
        el.addEventListener(props, handler, false);
    };
}
$b4b9092253857fb9$exports = {
    onAnimationEnd: $b4b9092253857fb9$var$onEnd($b4b9092253857fb9$var$animationEnd()),
    onTransitionEnd: $b4b9092253857fb9$var$onEnd($b4b9092253857fb9$var$transitionEnd())
};


var $f811a3a1a5995edf$require$onAnimationEnd = $b4b9092253857fb9$exports.onAnimationEnd;
/*
  Basic Settings Form
 */ $f811a3a1a5995edf$exports = $dM6Pc.extend({
    events: {
        submit: 'submit',
        'keyup input': 'onKeyup',
        'change input': 'onKeyup'
    },
    submit (evt) {
        evt.preventDefault();
        this.model.save(this.toJSON());
    },
    onSuccess (model, res, opts) {
        const el = this.queryByHook(`checkmark-${opts.target.name}`);
        if (!el) return;
        $f811a3a1a5995edf$require$onAnimationEnd(el, ()=>el.classList.remove('fadeOutUp'));
        el.classList.add('fadeOutUp', 'animated');
    },
    onKeyup (evt) {
        const type = evt.target.type;
        const val = evt.target.value;
        this.set(evt.target.name, type === 'number' ? +val : val);
    }
});



var $8jWPf = parcelRequire("8jWPf");

var $h6tPy = parcelRequire("h6tPy");

var $1JrMM = parcelRequire("1JrMM");
const $fefb562abe7a31b0$export$cebefbf4af82e50c = (0, $1JrMM.PreactView).extend({
    component: $fefb562abe7a31b0$var$UserSettings
});
function $fefb562abe7a31b0$var$UserSettings({ model: model }) {
    const eventSlug = (0, $h6tPy.useCurrentEventSlug)();
    const role = (0, $h6tPy.useCurrentRole)();
    const { storage: storage, bars: bars } = (0, $h6tPy.useLocations)(eventSlug);
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("form", {
        class: "pure-form pure-form-stacked",
        onBlur: (event)=>{
            const data = Object.fromEntries(new FormData(event.currentTarget));
            model.save(data);
        },
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsxs)("fieldset", {
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("legend", {
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        style: {
                            display: 'grid',
                            gap: '2em',
                            gridTemplateColumns: '1fr 1fr'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                                        for: "firstName",
                                        children: "Vorname"
                                    }),
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                        class: "input-addon",
                                        children: /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                                            class: "input-addon-field",
                                            type: "text",
                                            name: "firstName",
                                            defaultValue: model.firstName
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                                        for: "lastName",
                                        children: "Nachname"
                                    }),
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                        class: "input-addon",
                                        children: /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                                            class: "input-addon-field",
                                            type: "text",
                                            name: "lastName",
                                            defaultValue: model.lastName
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                class: "pure-g",
                children: /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                    class: "pure-u-1",
                    children: /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                        class: "append",
                        children: "Gib deinen Namen an, damit andere dich besser erkennen k\xf6nnen. Er wird z.B. bei Transaktionen und Inventuren, die du erstellt hast, angezeigt."
                    })
                })
            }),
            (role === 'admin' || role === 'dispatcher') && /*#__PURE__*/ (0, $8jWPf.jsxs)("fieldset", {
                style: {
                    marginTop: '1em'
                },
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("legend", {
                        children: "Dispatch Einstellungen"
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        style: {
                            display: 'grid',
                            gap: '2em',
                            gridTemplateColumns: '1fr 1fr'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                                        for: "defaultSourceLocationId",
                                        children: "Standardquelle"
                                    }),
                                    /*#__PURE__*/ (0, $8jWPf.jsxs)("select", {
                                        class: "pure-u-1",
                                        name: "defaultSourceLocationId",
                                        value: model.defaultSourceLocationId || '',
                                        children: [
                                            /*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                value: "",
                                                disabled: true,
                                                children: "Quelle w\xe4hlen..."
                                            }),
                                            storage && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                                label: "Lager",
                                                children: storage.map((store)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                        value: store.id,
                                                        children: store.name
                                                    }, store.id))
                                            }),
                                            bars && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                                label: "Bars",
                                                children: bars.map((bar)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                        value: bar.id,
                                                        children: bar.name
                                                    }, bar.id))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                                        for: "defaultTargetLocationId",
                                        children: "Standardziel"
                                    }),
                                    /*#__PURE__*/ (0, $8jWPf.jsxs)("select", {
                                        class: "pure-u-1",
                                        name: "defaultTargetLocationId",
                                        value: model.defaultTargetLocationId || '',
                                        children: [
                                            /*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                value: "",
                                                disabled: true,
                                                children: "Ziel w\xe4hlen..."
                                            }),
                                            bars && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                                label: "Bars",
                                                children: bars.map((bar)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                        value: bar.id,
                                                        children: bar.name
                                                    }, bar.id))
                                            }),
                                            storage && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                                label: "Lager",
                                                children: storage.map((store)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                        value: store.id,
                                                        children: store.name
                                                    }, store.id))
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


var $f103575a91c00a11$require$UserSettingsView = $fefb562abe7a31b0$export$cebefbf4af82e50c;

const $f103575a91c00a11$var$CreateEventForm = $139dd254a4734271$exports.extend({
    template: (parcelRequire("5UVch")).default,
    initialize () {
        this.model = new $3c363cf591fb0d7f$exports();
        this.listenTo(this.model, 'sync', this.remove);
    }
});

/* Form for changing user's password */ const $f103575a91c00a11$var$PasswordForm = $f811a3a1a5995edf$exports.extend({
    template: (parcelRequire("bW6o6")).default,
    props: {
        oldPassword: [
            'string',
            true
        ],
        newPassword: [
            'string',
            true
        ],
        newPasswordConfirm: [
            'string',
            true
        ]
    },
    derived: {
        valid: {
            deps: [
                'newPassword',
                'newPasswordConfirm',
                'oldPassword'
            ],
            fn () {
                return this.oldPassword && this.newPassword && this.newPasswordConfirm && this.newPassword === this.newPasswordConfirm;
            }
        }
    },
    initialize () {
        this.on('change:valid', this.onValid, this);
        this.listenTo(this.model, 'sync', this.onSuccess);
        this.listenTo(this.model, 'error', this.onError);
    },
    onValid (model, isValid) {
        this.queryByHook('submit').disabled = !isValid;
    },
    onError (err) {
        this.queryByHook('error').textContent = err.message;
    },
    onSuccess () {
        this.queryByHook('error').textContent = '';
        this.el.reset();
    },
    submit (evt) {
        evt.preventDefault();
        this.model.changePassword(this.toJSON());
    }
});

/* Settings Page */ $f103575a91c00a11$exports = $dM6Pc.extend({
    title: 'Einstellungen',
    template: (parcelRequire("lymBd")).default,
    events: {
        'click [data-hook="add"]': 'onAddEvent'
    },
    subviews: {
        nameForm: {
            hook: 'username-form',
            prepareView (el) {
                return new $f103575a91c00a11$require$UserSettingsView({
                    el: el,
                    props: {
                        model: this.model
                    }
                });
            }
        },
        passwordForm: {
            hook: 'password-form',
            prepareView (el) {
                return new $f103575a91c00a11$var$PasswordForm({
                    el: el,
                    model: this.model
                });
            }
        },
        eventsList: {
            hook: 'event-list',
            prepareView (el) {
                return this.renderCollection(this.eventsCollection, $28d0afe0d50c6d4b$exports, el);
            }
        }
    },
    props: {
        createEvent: [
            'boolean',
            true,
            false
        ]
    },
    initialize () {
        this.model = $4UX9c.me;
        // collection fetches itself
        this.eventsCollection = new $b5a41ababd8f2142$exports();
        this.on('change:createEvent', this.toggleEventForm, this);
    },
    onAddEvent (event) {
        event.preventDefault();
        this.createEvent = true;
    },
    toggleEventForm (model, createEvent) {
        this.queryByHook('add').classList.toggle('hidden', createEvent);
        if (createEvent) {
            this.createEventForm = new $f103575a91c00a11$var$CreateEventForm({
                parent: this
            });
            this.listenToOnce(this.createEventForm.model, 'sync', (newEvent)=>{
                this.eventsCollection.add(newEvent);
                this.createEvent = false;
            });
            this.renderSubview(this.createEventForm, '[data-hook="create-event"]');
        } else this.createEventForm.remove();
    }
});


var $b6a623b54c5d5db8$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $akRxj = parcelRequire("akRxj");

var $gvQO6 = parcelRequire("gvQO6");
var $b6a623b54c5d5db8$require$isAdminProp = $gvQO6.isAdminProp;

var $58326cbefe1a452a$exports = {};
$58326cbefe1a452a$exports = {
    events: {
        'click [data-hook="sort-name"]': 'sortByName',
        'click [data-hook="sort-units"]': 'sortByStock',
        'click [data-hook="sort-sortPosition"]': 'sortByPosition'
    },
    initSortableTable (state) {
        this.sortState = state;
        this.listenTo(this.sortState, 'change:comparator change:order', this.toggleIcon);
    },
    setComparator (comparator) {
        this.model.stock.setComparator(comparator);
    },
    toggleIcon () {
        for (const el of this.queryAll('.sortable-column'))el.classList.remove('sorted');
        const column = this.queryByHook(`sort-${this.sortState.comparator}`);
        column.classList.remove('desc', 'asc');
        column.classList.add('sorted', this.sortState.order);
    },
    sortByName (evt) {
        evt.preventDefault();
        this.setComparator('name');
    },
    sortByStock (evt) {
        evt.preventDefault();
        this.setComparator('units');
    },
    sortByPosition (evt) {
        evt.preventDefault();
        this.setComparator('sortPosition');
    },
    sortByRatio (evt) {
        evt.preventDefault();
        this.setComparator('ratio');
    },
    sortByDelivery (evt) {
        evt.preventDefault();
        this.setComparator('delivery');
    }
};


var $f8d2d6515d3b54cf$exports = {};

var $4UX9c = parcelRequire("4UX9c");

var $eSA5k = parcelRequire("eSA5k");


var $gvQO6 = parcelRequire("gvQO6");
const { unitsLocalized: $f8d2d6515d3b54cf$var$unitsLocalized, packagesLocalized: $f8d2d6515d3b54cf$var$packagesLocalized } = $gvQO6;


var $f8d2d6515d3b54cf$require$StockItem = $bd70af13b522fb69$export$5c09c303566d173e;
const $f8d2d6515d3b54cf$var$DashboardItem = $f8d2d6515d3b54cf$require$StockItem.extend({
    props: {
        id: 'string',
        delivery: 'number',
        breakage: 'number',
        tokens: 'string',
        freeware: 'number',
        unitsSold: [
            'number',
            false,
            0
        ]
    },
    derived: {
        product: {
            deps: [
                'id'
            ],
            fn () {
                return $4UX9c.products?.get(this.id);
            }
        },
        freewareUnitsLocalized: $f8d2d6515d3b54cf$var$unitsLocalized('freeware'),
        freewarePackagesLocalized: $f8d2d6515d3b54cf$var$packagesLocalized('freeware'),
        unitsSoldLocalized: $f8d2d6515d3b54cf$var$unitsLocalized('unitsSold'),
        packagesSoldLocalized: $f8d2d6515d3b54cf$var$packagesLocalized('unitsSold'),
        deliveryUnitsLocalized: $f8d2d6515d3b54cf$var$unitsLocalized('delivery'),
        deliveryPackagesLocalized: $f8d2d6515d3b54cf$var$packagesLocalized('delivery'),
        ratio: {
            deps: [
                'delivery',
                'units'
            ],
            fn () {
                if (!this.delivery) return 0;
                return this.units / this.delivery;
            }
        },
        ratioLocalized: {
            deps: [
                'ratio'
            ],
            fn () {
                if (!$02b4208808d8caef$exports(this.ratio)) return null;
                return `${new $eSA5k(this.ratio).times(100).round(1)} %`.replace('.', ',');
            }
        }
    },
    initialize () {}
});
$f8d2d6515d3b54cf$exports = $ffe57d6fa9b030d1$exports.extend({
    url () {
        return `/api/events/${$4UX9c.me.currentEvent.slug}/dashboard/products`;
    },
    model: $f8d2d6515d3b54cf$var$DashboardItem,
    comparator: $gvQO6.byStockSortPosition,
    // override StockCollection
    mainIndex: 'id',
    // ttl: CachedCollection.prototype.ttl,
    // tts: CachedCollection.prototype.tts,
    // storageKey () {
    //   return `${app.me.currentEventId}-dashboard-products`
    // },
    initialize () {
        $ffe57d6fa9b030d1$exports.prototype.initialize.apply(this);
    },
    // override StockCollection
    onTransaction () {}
});



var $4UX9c = parcelRequire("4UX9c");


var $kw3w9 = parcelRequire("kw3w9");

var $dM6Pc = parcelRequire("dM6Pc");
var $2165df5d29a5d404$exports = {};
(function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function() {
        return root['Chartist'] = factory();
    });
    else // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    $2165df5d29a5d404$exports = factory();
})($2165df5d29a5d404$exports, function() {
    /* Chartist.js 0.9.8
 * Copyright © 2016 Gion Kunz
 * Free to use under either the WTFPL license or the MIT license.
 * https://raw.githubusercontent.com/gionkunz/chartist-js/master/LICENSE-WTFPL
 * https://raw.githubusercontent.com/gionkunz/chartist-js/master/LICENSE-MIT
 */ /**
 * The core module of Chartist that is mainly providing static functions and higher level functions for chart modules.
 *
 * @module Chartist.Core
 */ var Chartist = {
        version: '0.9.8'
    };
    (function(window1, document1, Chartist) {
        'use strict';
        /**
   * This object contains all namespaces used within Chartist.
   *
   * @memberof Chartist.Core
   * @type {{svg: string, xmlns: string, xhtml: string, xlink: string, ct: string}}
   */ Chartist.namespaces = {
            svg: 'http://www.w3.org/2000/svg',
            xmlns: 'http://www.w3.org/2000/xmlns/',
            xhtml: 'http://www.w3.org/1999/xhtml',
            xlink: 'http://www.w3.org/1999/xlink',
            ct: 'http://gionkunz.github.com/chartist-js/ct'
        };
        /**
   * Helps to simplify functional style code
   *
   * @memberof Chartist.Core
   * @param {*} n This exact value will be returned by the noop function
   * @return {*} The same value that was provided to the n parameter
   */ Chartist.noop = function(n) {
            return n;
        };
        /**
   * Generates a-z from a number 0 to 26
   *
   * @memberof Chartist.Core
   * @param {Number} n A number from 0 to 26 that will result in a letter a-z
   * @return {String} A character from a-z based on the input number n
   */ Chartist.alphaNumerate = function(n) {
            // Limit to a-z
            return String.fromCharCode(97 + n % 26);
        };
        /**
   * Simple recursive object extend
   *
   * @memberof Chartist.Core
   * @param {Object} target Target object where the source will be merged into
   * @param {Object...} sources This object (objects) will be merged into target and then target is returned
   * @return {Object} An object that has the same reference as target but is extended and merged with the properties of source
   */ Chartist.extend = function(target) {
            target = target || {};
            var sources = Array.prototype.slice.call(arguments, 1);
            sources.forEach(function(source) {
                for(var prop in source)if (typeof source[prop] === 'object' && source[prop] !== null && !(source[prop] instanceof Array)) target[prop] = Chartist.extend({}, target[prop], source[prop]);
                else target[prop] = source[prop];
            });
            return target;
        };
        /**
   * Replaces all occurrences of subStr in str with newSubStr and returns a new string.
   *
   * @memberof Chartist.Core
   * @param {String} str
   * @param {String} subStr
   * @param {String} newSubStr
   * @return {String}
   */ Chartist.replaceAll = function(str, subStr, newSubStr) {
            return str.replace(new RegExp(subStr, 'g'), newSubStr);
        };
        /**
   * Converts a number to a string with a unit. If a string is passed then this will be returned unmodified.
   *
   * @memberof Chartist.Core
   * @param {Number} value
   * @param {String} unit
   * @return {String} Returns the passed number value with unit.
   */ Chartist.ensureUnit = function(value, unit) {
            if (typeof value === 'number') value = value + unit;
            return value;
        };
        /**
   * Converts a number or string to a quantity object.
   *
   * @memberof Chartist.Core
   * @param {String|Number} input
   * @return {Object} Returns an object containing the value as number and the unit as string.
   */ Chartist.quantity = function(input) {
            if (typeof input === 'string') {
                var match = /^(\d+)\s*(.*)$/g.exec(input);
                return {
                    value: +match[1],
                    unit: match[2] || undefined
                };
            }
            return {
                value: input
            };
        };
        /**
   * This is a wrapper around document.querySelector that will return the query if it's already of type Node
   *
   * @memberof Chartist.Core
   * @param {String|Node} query The query to use for selecting a Node or a DOM node that will be returned directly
   * @return {Node}
   */ Chartist.querySelector = function(query) {
            return query instanceof Node ? query : document1.querySelector(query);
        };
        /**
   * Functional style helper to produce array with given length initialized with undefined values
   *
   * @memberof Chartist.Core
   * @param length
   * @return {Array}
   */ Chartist.times = function(length) {
            return Array.apply(null, new Array(length));
        };
        /**
   * Sum helper to be used in reduce functions
   *
   * @memberof Chartist.Core
   * @param previous
   * @param current
   * @return {*}
   */ Chartist.sum = function(previous, current) {
            return previous + (current ? current : 0);
        };
        /**
   * Multiply helper to be used in `Array.map` for multiplying each value of an array with a factor.
   *
   * @memberof Chartist.Core
   * @param {Number} factor
   * @returns {Function} Function that can be used in `Array.map` to multiply each value in an array
   */ Chartist.mapMultiply = function(factor) {
            return function(num) {
                return num * factor;
            };
        };
        /**
   * Add helper to be used in `Array.map` for adding a addend to each value of an array.
   *
   * @memberof Chartist.Core
   * @param {Number} addend
   * @returns {Function} Function that can be used in `Array.map` to add a addend to each value in an array
   */ Chartist.mapAdd = function(addend) {
            return function(num) {
                return num + addend;
            };
        };
        /**
   * Map for multi dimensional arrays where their nested arrays will be mapped in serial. The output array will have the length of the largest nested array. The callback function is called with variable arguments where each argument is the nested array value (or undefined if there are no more values).
   *
   * @memberof Chartist.Core
   * @param arr
   * @param cb
   * @return {Array}
   */ Chartist.serialMap = function(arr, cb) {
            var result = [], length = Math.max.apply(null, arr.map(function(e) {
                return e.length;
            }));
            Chartist.times(length).forEach(function(e, index) {
                var args = arr.map(function(e) {
                    return e[index];
                });
                result[index] = cb.apply(null, args);
            });
            return result;
        };
        /**
   * This helper function can be used to round values with certain precision level after decimal. This is used to prevent rounding errors near float point precision limit.
   *
   * @memberof Chartist.Core
   * @param {Number} value The value that should be rounded with precision
   * @param {Number} [digits] The number of digits after decimal used to do the rounding
   * @returns {number} Rounded value
   */ Chartist.roundWithPrecision = function(value, digits) {
            var precision = Math.pow(10, digits || Chartist.precision);
            return Math.round(value * precision) / precision;
        };
        /**
   * Precision level used internally in Chartist for rounding. If you require more decimal places you can increase this number.
   *
   * @memberof Chartist.Core
   * @type {number}
   */ Chartist.precision = 8;
        /**
   * A map with characters to escape for strings to be safely used as attribute values.
   *
   * @memberof Chartist.Core
   * @type {Object}
   */ Chartist.escapingMap = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            '\'': '&#039;'
        };
        /**
   * This function serializes arbitrary data to a string. In case of data that can't be easily converted to a string, this function will create a wrapper object and serialize the data using JSON.stringify. The outcoming string will always be escaped using Chartist.escapingMap.
   * If called with null or undefined the function will return immediately with null or undefined.
   *
   * @memberof Chartist.Core
   * @param {Number|String|Object} data
   * @return {String}
   */ Chartist.serialize = function(data) {
            if (data === null || data === undefined) return data;
            else if (typeof data === 'number') data = '' + data;
            else if (typeof data === 'object') data = JSON.stringify({
                data: data
            });
            return Object.keys(Chartist.escapingMap).reduce(function(result, key) {
                return Chartist.replaceAll(result, key, Chartist.escapingMap[key]);
            }, data);
        };
        /**
   * This function de-serializes a string previously serialized with Chartist.serialize. The string will always be unescaped using Chartist.escapingMap before it's returned. Based on the input value the return type can be Number, String or Object. JSON.parse is used with try / catch to see if the unescaped string can be parsed into an Object and this Object will be returned on success.
   *
   * @memberof Chartist.Core
   * @param {String} data
   * @return {String|Number|Object}
   */ Chartist.deserialize = function(data) {
            if (typeof data !== 'string') return data;
            data = Object.keys(Chartist.escapingMap).reduce(function(result, key) {
                return Chartist.replaceAll(result, Chartist.escapingMap[key], key);
            }, data);
            try {
                data = JSON.parse(data);
                data = data.data !== undefined ? data.data : data;
            } catch (e) {}
            return data;
        };
        /**
   * Create or reinitialize the SVG element for the chart
   *
   * @memberof Chartist.Core
   * @param {Node} container The containing DOM Node object that will be used to plant the SVG element
   * @param {String} width Set the width of the SVG element. Default is 100%
   * @param {String} height Set the height of the SVG element. Default is 100%
   * @param {String} className Specify a class to be added to the SVG element
   * @return {Object} The created/reinitialized SVG element
   */ Chartist.createSvg = function(container, width, height, className) {
            var svg;
            width = width || '100%';
            height = height || '100%';
            // Check if there is a previous SVG element in the container that contains the Chartist XML namespace and remove it
            // Since the DOM API does not support namespaces we need to manually search the returned list http://www.w3.org/TR/selectors-api/
            Array.prototype.slice.call(container.querySelectorAll('svg')).filter(function filterChartistSvgObjects(svg) {
                return svg.getAttributeNS(Chartist.namespaces.xmlns, 'ct');
            }).forEach(function removePreviousElement(svg) {
                container.removeChild(svg);
            });
            // Create svg object with width and height or use 100% as default
            svg = new Chartist.Svg('svg').attr({
                width: width,
                height: height
            }).addClass(className).attr({
                style: 'width: ' + width + '; height: ' + height + ';'
            });
            // Add the DOM node to our container
            container.appendChild(svg._node);
            return svg;
        };
        /**
   * Ensures that the data object passed as second argument to the charts is present and correctly initialized.
   *
   * @param  {Object} data The data object that is passed as second argument to the charts
   * @return {Object} The normalized data object
   */ Chartist.normalizeData = function(data) {
            // Ensure data is present otherwise enforce
            data = data || {
                series: [],
                labels: []
            };
            data.series = data.series || [];
            data.labels = data.labels || [];
            // Check if we should generate some labels based on existing series data
            if (data.series.length > 0 && data.labels.length === 0) {
                var normalized = Chartist.getDataArray(data), labelCount;
                // If all elements of the normalized data array are arrays we're dealing with
                // data from Bar or Line charts and we need to find the largest series if they are un-even
                if (normalized.every(function(value) {
                    return value instanceof Array;
                })) // Getting the series with the the most elements
                labelCount = Math.max.apply(null, normalized.map(function(series) {
                    return series.length;
                }));
                else // We're dealing with Pie data so we just take the normalized array length
                labelCount = normalized.length;
                // Setting labels to an array with emptry strings using our labelCount estimated above
                data.labels = Chartist.times(labelCount).map(function() {
                    return '';
                });
            }
            return data;
        };
        /**
   * Reverses the series, labels and series data arrays.
   *
   * @memberof Chartist.Core
   * @param data
   */ Chartist.reverseData = function(data) {
            data.labels.reverse();
            data.series.reverse();
            for(var i = 0; i < data.series.length; i++){
                if (typeof data.series[i] === 'object' && data.series[i].data !== undefined) data.series[i].data.reverse();
                else if (data.series[i] instanceof Array) data.series[i].reverse();
            }
        };
        /**
   * Convert data series into plain array
   *
   * @memberof Chartist.Core
   * @param {Object} data The series object that contains the data to be visualized in the chart
   * @param {Boolean} reverse If true the whole data is reversed by the getDataArray call. This will modify the data object passed as first parameter. The labels as well as the series order is reversed. The whole series data arrays are reversed too.
   * @param {Boolean} multi Create a multi dimensional array from a series data array where a value object with `x` and `y` values will be created.
   * @return {Array} A plain array that contains the data to be visualized in the chart
   */ Chartist.getDataArray = function(data, reverse, multi) {
            // If the data should be reversed but isn't we need to reverse it
            // If it's reversed but it shouldn't we need to reverse it back
            // That's required to handle data updates correctly and to reflect the responsive configurations
            if (reverse && !data.reversed || !reverse && data.reversed) {
                Chartist.reverseData(data);
                data.reversed = !data.reversed;
            }
            // Recursively walks through nested arrays and convert string values to numbers and objects with value properties
            // to values. Check the tests in data core -> data normalization for a detailed specification of expected values
            function recursiveConvert(value) {
                if (Chartist.isFalseyButZero(value)) // This is a hole in data and we should return undefined
                return undefined;
                else if ((value.data || value) instanceof Array) return (value.data || value).map(recursiveConvert);
                else if (value.hasOwnProperty('value')) return recursiveConvert(value.value);
                else {
                    if (multi) {
                        var multiValue = {};
                        // Single series value arrays are assumed to specify the Y-Axis value
                        // For example: [1, 2] => [{x: undefined, y: 1}, {x: undefined, y: 2}]
                        // If multi is a string then it's assumed that it specified which dimension should be filled as default
                        if (typeof multi === 'string') multiValue[multi] = Chartist.getNumberOrUndefined(value);
                        else multiValue.y = Chartist.getNumberOrUndefined(value);
                        multiValue.x = value.hasOwnProperty('x') ? Chartist.getNumberOrUndefined(value.x) : multiValue.x;
                        multiValue.y = value.hasOwnProperty('y') ? Chartist.getNumberOrUndefined(value.y) : multiValue.y;
                        return multiValue;
                    } else return Chartist.getNumberOrUndefined(value);
                }
            }
            return data.series.map(recursiveConvert);
        };
        /**
   * Converts a number into a padding object.
   *
   * @memberof Chartist.Core
   * @param {Object|Number} padding
   * @param {Number} [fallback] This value is used to fill missing values if a incomplete padding object was passed
   * @returns {Object} Returns a padding object containing top, right, bottom, left properties filled with the padding number passed in as argument. If the argument is something else than a number (presumably already a correct padding object) then this argument is directly returned.
   */ Chartist.normalizePadding = function(padding, fallback) {
            fallback = fallback || 0;
            return typeof padding === 'number' ? {
                top: padding,
                right: padding,
                bottom: padding,
                left: padding
            } : {
                top: typeof padding.top === 'number' ? padding.top : fallback,
                right: typeof padding.right === 'number' ? padding.right : fallback,
                bottom: typeof padding.bottom === 'number' ? padding.bottom : fallback,
                left: typeof padding.left === 'number' ? padding.left : fallback
            };
        };
        Chartist.getMetaData = function(series, index) {
            var value = series.data ? series.data[index] : series[index];
            return value ? Chartist.serialize(value.meta) : undefined;
        };
        /**
   * Calculate the order of magnitude for the chart scale
   *
   * @memberof Chartist.Core
   * @param {Number} value The value Range of the chart
   * @return {Number} The order of magnitude
   */ Chartist.orderOfMagnitude = function(value) {
            return Math.floor(Math.log(Math.abs(value)) / Math.LN10);
        };
        /**
   * Project a data length into screen coordinates (pixels)
   *
   * @memberof Chartist.Core
   * @param {Object} axisLength The svg element for the chart
   * @param {Number} length Single data value from a series array
   * @param {Object} bounds All the values to set the bounds of the chart
   * @return {Number} The projected data length in pixels
   */ Chartist.projectLength = function(axisLength, length, bounds) {
            return length / bounds.range * axisLength;
        };
        /**
   * Get the height of the area in the chart for the data series
   *
   * @memberof Chartist.Core
   * @param {Object} svg The svg element for the chart
   * @param {Object} options The Object that contains all the optional values for the chart
   * @return {Number} The height of the area in the chart for the data series
   */ Chartist.getAvailableHeight = function(svg, options) {
            return Math.max((Chartist.quantity(options.height).value || svg.height()) - (options.chartPadding.top + options.chartPadding.bottom) - options.axisX.offset, 0);
        };
        /**
   * Get highest and lowest value of data array. This Array contains the data that will be visualized in the chart.
   *
   * @memberof Chartist.Core
   * @param {Array} data The array that contains the data to be visualized in the chart
   * @param {Object} options The Object that contains the chart options
   * @param {String} dimension Axis dimension 'x' or 'y' used to access the correct value and high / low configuration
   * @return {Object} An object that contains the highest and lowest value that will be visualized on the chart.
   */ Chartist.getHighLow = function(data, options, dimension) {
            // TODO: Remove workaround for deprecated global high / low config. Axis high / low configuration is preferred
            options = Chartist.extend({}, options, dimension ? options['axis' + dimension.toUpperCase()] : {});
            var highLow = {
                high: options.high === undefined ? -Number.MAX_VALUE : +options.high,
                low: options.low === undefined ? Number.MAX_VALUE : +options.low
            };
            var findHigh = options.high === undefined;
            var findLow = options.low === undefined;
            // Function to recursively walk through arrays and find highest and lowest number
            function recursiveHighLow(data) {
                if (data === undefined) return undefined;
                else if (data instanceof Array) for(var i = 0; i < data.length; i++)recursiveHighLow(data[i]);
                else {
                    var value = dimension ? +data[dimension] : +data;
                    if (findHigh && value > highLow.high) highLow.high = value;
                    if (findLow && value < highLow.low) highLow.low = value;
                }
            }
            // Start to find highest and lowest number recursively
            if (findHigh || findLow) recursiveHighLow(data);
            // Overrides of high / low based on reference value, it will make sure that the invisible reference value is
            // used to generate the chart. This is useful when the chart always needs to contain the position of the
            // invisible reference value in the view i.e. for bipolar scales.
            if (options.referenceValue || options.referenceValue === 0) {
                highLow.high = Math.max(options.referenceValue, highLow.high);
                highLow.low = Math.min(options.referenceValue, highLow.low);
            }
            // If high and low are the same because of misconfiguration or flat data (only the same value) we need
            // to set the high or low to 0 depending on the polarity
            if (highLow.high <= highLow.low) {
                // If both values are 0 we set high to 1
                if (highLow.low === 0) highLow.high = 1;
                else if (highLow.low < 0) // If we have the same negative value for the bounds we set bounds.high to 0
                highLow.high = 0;
                else if (highLow.high > 0) // If we have the same positive value for the bounds we set bounds.low to 0
                highLow.low = 0;
                else {
                    // If data array was empty, values are Number.MAX_VALUE and -Number.MAX_VALUE. Set bounds to prevent errors
                    highLow.high = 1;
                    highLow.low = 0;
                }
            }
            return highLow;
        };
        /**
   * Checks if the value is a valid number or string with a number.
   *
   * @memberof Chartist.Core
   * @param value
   * @returns {Boolean}
   */ Chartist.isNum = function(value) {
            return !isNaN(value) && isFinite(value);
        };
        /**
   * Returns true on all falsey values except the numeric value 0.
   *
   * @memberof Chartist.Core
   * @param value
   * @returns {boolean}
   */ Chartist.isFalseyButZero = function(value) {
            return !value && value !== 0;
        };
        /**
   * Returns a number if the passed parameter is a valid number or the function will return undefined. On all other values than a valid number, this function will return undefined.
   *
   * @memberof Chartist.Core
   * @param value
   * @returns {*}
   */ Chartist.getNumberOrUndefined = function(value) {
            return isNaN(+value) ? undefined : +value;
        };
        /**
   * Gets a value from a dimension `value.x` or `value.y` while returning value directly if it's a valid numeric value. If the value is not numeric and it's falsey this function will return undefined.
   *
   * @param value
   * @param dimension
   * @returns {*}
   */ Chartist.getMultiValue = function(value, dimension) {
            if (Chartist.isNum(value)) return +value;
            else if (value) return value[dimension || 'y'] || 0;
            else return 0;
        };
        /**
   * Pollard Rho Algorithm to find smallest factor of an integer value. There are more efficient algorithms for factorization, but this one is quite efficient and not so complex.
   *
   * @memberof Chartist.Core
   * @param {Number} num An integer number where the smallest factor should be searched for
   * @returns {Number} The smallest integer factor of the parameter num.
   */ Chartist.rho = function(num) {
            if (num === 1) return num;
            function gcd(p, q) {
                if (p % q === 0) return q;
                else return gcd(q, p % q);
            }
            function f(x) {
                return x * x + 1;
            }
            var x1 = 2, x2 = 2, divisor;
            if (num % 2 === 0) return 2;
            do {
                x1 = f(x1) % num;
                x2 = f(f(x2)) % num;
                divisor = gcd(Math.abs(x1 - x2), num);
            }while (divisor === 1);
            return divisor;
        };
        /**
   * Calculate and retrieve all the bounds for the chart and return them in one array
   *
   * @memberof Chartist.Core
   * @param {Number} axisLength The length of the Axis used for
   * @param {Object} highLow An object containing a high and low property indicating the value range of the chart.
   * @param {Number} scaleMinSpace The minimum projected length a step should result in
   * @param {Boolean} onlyInteger
   * @return {Object} All the values to set the bounds of the chart
   */ Chartist.getBounds = function(axisLength, highLow, scaleMinSpace, onlyInteger) {
            var i, optimizationCounter = 0, newMin, newMax, bounds = {
                high: highLow.high,
                low: highLow.low
            };
            bounds.valueRange = bounds.high - bounds.low;
            bounds.oom = Chartist.orderOfMagnitude(bounds.valueRange);
            bounds.step = Math.pow(10, bounds.oom);
            bounds.min = Math.floor(bounds.low / bounds.step) * bounds.step;
            bounds.max = Math.ceil(bounds.high / bounds.step) * bounds.step;
            bounds.range = bounds.max - bounds.min;
            bounds.numberOfSteps = Math.round(bounds.range / bounds.step);
            // Optimize scale step by checking if subdivision is possible based on horizontalGridMinSpace
            // If we are already below the scaleMinSpace value we will scale up
            var length = Chartist.projectLength(axisLength, bounds.step, bounds);
            var scaleUp = length < scaleMinSpace;
            var smallestFactor = onlyInteger ? Chartist.rho(bounds.range) : 0;
            // First check if we should only use integer steps and if step 1 is still larger than scaleMinSpace so we can use 1
            if (onlyInteger && Chartist.projectLength(axisLength, 1, bounds) >= scaleMinSpace) bounds.step = 1;
            else if (onlyInteger && smallestFactor < bounds.step && Chartist.projectLength(axisLength, smallestFactor, bounds) >= scaleMinSpace) // If step 1 was too small, we can try the smallest factor of range
            // If the smallest factor is smaller than the current bounds.step and the projected length of smallest factor
            // is larger than the scaleMinSpace we should go for it.
            bounds.step = smallestFactor;
            else // Trying to divide or multiply by 2 and find the best step value
            while(true){
                if (scaleUp && Chartist.projectLength(axisLength, bounds.step, bounds) <= scaleMinSpace) bounds.step *= 2;
                else if (!scaleUp && Chartist.projectLength(axisLength, bounds.step / 2, bounds) >= scaleMinSpace) {
                    bounds.step /= 2;
                    if (onlyInteger && bounds.step % 1 !== 0) {
                        bounds.step *= 2;
                        break;
                    }
                } else break;
                if (optimizationCounter++ > 1000) throw new Error('Exceeded maximum number of iterations while optimizing scale step!');
            }
            // step must not be less than EPSILON to create values that can be represented as floating number.
            var EPSILON = 2.221E-16;
            bounds.step = Math.max(bounds.step, EPSILON);
            // Narrow min and max based on new step
            newMin = bounds.min;
            newMax = bounds.max;
            while(newMin + bounds.step <= bounds.low)newMin += bounds.step;
            while(newMax - bounds.step >= bounds.high)newMax -= bounds.step;
            bounds.min = newMin;
            bounds.max = newMax;
            bounds.range = bounds.max - bounds.min;
            var values = [];
            for(i = bounds.min; i <= bounds.max; i += bounds.step){
                var value = Chartist.roundWithPrecision(i);
                if (value !== values[values.length - 1]) values.push(i);
            }
            bounds.values = values;
            return bounds;
        };
        /**
   * Calculate cartesian coordinates of polar coordinates
   *
   * @memberof Chartist.Core
   * @param {Number} centerX X-axis coordinates of center point of circle segment
   * @param {Number} centerY X-axis coordinates of center point of circle segment
   * @param {Number} radius Radius of circle segment
   * @param {Number} angleInDegrees Angle of circle segment in degrees
   * @return {{x:Number, y:Number}} Coordinates of point on circumference
   */ Chartist.polarToCartesian = function(centerX, centerY, radius, angleInDegrees) {
            var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
            return {
                x: centerX + radius * Math.cos(angleInRadians),
                y: centerY + radius * Math.sin(angleInRadians)
            };
        };
        /**
   * Initialize chart drawing rectangle (area where chart is drawn) x1,y1 = bottom left / x2,y2 = top right
   *
   * @memberof Chartist.Core
   * @param {Object} svg The svg element for the chart
   * @param {Object} options The Object that contains all the optional values for the chart
   * @param {Number} [fallbackPadding] The fallback padding if partial padding objects are used
   * @return {Object} The chart rectangles coordinates inside the svg element plus the rectangles measurements
   */ Chartist.createChartRect = function(svg, options, fallbackPadding) {
            var hasAxis = !!(options.axisX || options.axisY);
            var yAxisOffset = hasAxis ? options.axisY.offset : 0;
            var xAxisOffset = hasAxis ? options.axisX.offset : 0;
            // If width or height results in invalid value (including 0) we fallback to the unitless settings or even 0
            var width = svg.width() || Chartist.quantity(options.width).value || 0;
            var height = svg.height() || Chartist.quantity(options.height).value || 0;
            var normalizedPadding = Chartist.normalizePadding(options.chartPadding, fallbackPadding);
            // If settings were to small to cope with offset (legacy) and padding, we'll adjust
            width = Math.max(width, yAxisOffset + normalizedPadding.left + normalizedPadding.right);
            height = Math.max(height, xAxisOffset + normalizedPadding.top + normalizedPadding.bottom);
            var chartRect = {
                padding: normalizedPadding,
                width: function() {
                    return this.x2 - this.x1;
                },
                height: function() {
                    return this.y1 - this.y2;
                }
            };
            if (hasAxis) {
                if (options.axisX.position === 'start') {
                    chartRect.y2 = normalizedPadding.top + xAxisOffset;
                    chartRect.y1 = Math.max(height - normalizedPadding.bottom, chartRect.y2 + 1);
                } else {
                    chartRect.y2 = normalizedPadding.top;
                    chartRect.y1 = Math.max(height - normalizedPadding.bottom - xAxisOffset, chartRect.y2 + 1);
                }
                if (options.axisY.position === 'start') {
                    chartRect.x1 = normalizedPadding.left + yAxisOffset;
                    chartRect.x2 = Math.max(width - normalizedPadding.right, chartRect.x1 + 1);
                } else {
                    chartRect.x1 = normalizedPadding.left;
                    chartRect.x2 = Math.max(width - normalizedPadding.right - yAxisOffset, chartRect.x1 + 1);
                }
            } else {
                chartRect.x1 = normalizedPadding.left;
                chartRect.x2 = Math.max(width - normalizedPadding.right, chartRect.x1 + 1);
                chartRect.y2 = normalizedPadding.top;
                chartRect.y1 = Math.max(height - normalizedPadding.bottom, chartRect.y2 + 1);
            }
            return chartRect;
        };
        /**
   * Creates a grid line based on a projected value.
   *
   * @memberof Chartist.Core
   * @param position
   * @param index
   * @param axis
   * @param offset
   * @param length
   * @param group
   * @param classes
   * @param eventEmitter
   */ Chartist.createGrid = function(position, index, axis, offset, length, group, classes, eventEmitter) {
            var positionalData = {};
            positionalData[axis.units.pos + '1'] = position;
            positionalData[axis.units.pos + '2'] = position;
            positionalData[axis.counterUnits.pos + '1'] = offset;
            positionalData[axis.counterUnits.pos + '2'] = offset + length;
            var gridElement = group.elem('line', positionalData, classes.join(' '));
            // Event for grid draw
            eventEmitter.emit('draw', Chartist.extend({
                type: 'grid',
                axis: axis,
                index: index,
                group: group,
                element: gridElement
            }, positionalData));
        };
        /**
   * Creates a label based on a projected value and an axis.
   *
   * @memberof Chartist.Core
   * @param position
   * @param length
   * @param index
   * @param labels
   * @param axis
   * @param axisOffset
   * @param labelOffset
   * @param group
   * @param classes
   * @param useForeignObject
   * @param eventEmitter
   */ Chartist.createLabel = function(position, length, index, labels, axis, axisOffset, labelOffset, group, classes, useForeignObject, eventEmitter) {
            var labelElement;
            var positionalData = {};
            positionalData[axis.units.pos] = position + labelOffset[axis.units.pos];
            positionalData[axis.counterUnits.pos] = labelOffset[axis.counterUnits.pos];
            positionalData[axis.units.len] = length;
            positionalData[axis.counterUnits.len] = Math.max(0, axisOffset - 10);
            if (useForeignObject) {
                // We need to set width and height explicitly to px as span will not expand with width and height being
                // 100% in all browsers
                var content = '<span class="' + classes.join(' ') + '" style="' + axis.units.len + ': ' + Math.round(positionalData[axis.units.len]) + 'px; ' + axis.counterUnits.len + ': ' + Math.round(positionalData[axis.counterUnits.len]) + 'px">' + labels[index] + '</span>';
                labelElement = group.foreignObject(content, Chartist.extend({
                    style: 'overflow: visible;'
                }, positionalData));
            } else labelElement = group.elem('text', positionalData, classes.join(' ')).text(labels[index]);
            eventEmitter.emit('draw', Chartist.extend({
                type: 'label',
                axis: axis,
                index: index,
                group: group,
                element: labelElement,
                text: labels[index]
            }, positionalData));
        };
        /**
   * Helper to read series specific options from options object. It automatically falls back to the global option if
   * there is no option in the series options.
   *
   * @param {Object} series Series object
   * @param {Object} options Chartist options object
   * @param {string} key The options key that should be used to obtain the options
   * @returns {*}
   */ Chartist.getSeriesOption = function(series, options, key) {
            if (series.name && options.series && options.series[series.name]) {
                var seriesOptions = options.series[series.name];
                return seriesOptions.hasOwnProperty(key) ? seriesOptions[key] : options[key];
            } else return options[key];
        };
        /**
   * Provides options handling functionality with callback for options changes triggered by responsive options and media query matches
   *
   * @memberof Chartist.Core
   * @param {Object} options Options set by user
   * @param {Array} responsiveOptions Optional functions to add responsive behavior to chart
   * @param {Object} eventEmitter The event emitter that will be used to emit the options changed events
   * @return {Object} The consolidated options object from the defaults, base and matching responsive options
   */ Chartist.optionsProvider = function(options, responsiveOptions, eventEmitter) {
            var baseOptions = Chartist.extend({}, options), currentOptions, mediaQueryListeners = [], i;
            function updateCurrentOptions(mediaEvent) {
                var previousOptions = currentOptions;
                currentOptions = Chartist.extend({}, baseOptions);
                if (responsiveOptions) for(i = 0; i < responsiveOptions.length; i++){
                    var mql = window1.matchMedia(responsiveOptions[i][0]);
                    if (mql.matches) currentOptions = Chartist.extend(currentOptions, responsiveOptions[i][1]);
                }
                if (eventEmitter && mediaEvent) eventEmitter.emit('optionsChanged', {
                    previousOptions: previousOptions,
                    currentOptions: currentOptions
                });
            }
            function removeMediaQueryListeners() {
                mediaQueryListeners.forEach(function(mql) {
                    mql.removeListener(updateCurrentOptions);
                });
            }
            if (!window1.matchMedia) throw 'window.matchMedia not found! Make sure you\'re using a polyfill.';
            else if (responsiveOptions) for(i = 0; i < responsiveOptions.length; i++){
                var mql = window1.matchMedia(responsiveOptions[i][0]);
                mql.addListener(updateCurrentOptions);
                mediaQueryListeners.push(mql);
            }
            // Execute initially without an event argument so we get the correct options
            updateCurrentOptions();
            return {
                removeMediaQueryListeners: removeMediaQueryListeners,
                getCurrentOptions: function getCurrentOptions() {
                    return Chartist.extend({}, currentOptions);
                }
            };
        };
        /**
   * Splits a list of coordinates and associated values into segments. Each returned segment contains a pathCoordinates
   * valueData property describing the segment.
   *
   * With the default options, segments consist of contiguous sets of points that do not have an undefined value. Any
   * points with undefined values are discarded.
   *
   * **Options**
   * The following options are used to determine how segments are formed
   * ```javascript
   * var options = {
   *   // If fillHoles is true, undefined values are simply discarded without creating a new segment. Assuming other options are default, this returns single segment.
   *   fillHoles: false,
   *   // If increasingX is true, the coordinates in all segments have strictly increasing x-values.
   *   increasingX: false
   * };
   * ```
   *
   * @memberof Chartist.Core
   * @param {Array} pathCoordinates List of point coordinates to be split in the form [x1, y1, x2, y2 ... xn, yn]
   * @param {Array} values List of associated point values in the form [v1, v2 .. vn]
   * @param {Object} options Options set by user
   * @return {Array} List of segments, each containing a pathCoordinates and valueData property.
   */ Chartist.splitIntoSegments = function(pathCoordinates, valueData, options) {
            var defaultOptions = {
                increasingX: false,
                fillHoles: false
            };
            options = Chartist.extend({}, defaultOptions, options);
            var segments = [];
            var hole = true;
            for(var i = 0; i < pathCoordinates.length; i += 2){
                // If this value is a "hole" we set the hole flag
                if (valueData[i / 2].value === undefined) {
                    if (!options.fillHoles) hole = true;
                } else {
                    if (options.increasingX && i >= 2 && pathCoordinates[i] <= pathCoordinates[i - 2]) // X is not increasing, so we need to make sure we start a new segment
                    hole = true;
                    // If it's a valid value we need to check if we're coming out of a hole and create a new empty segment
                    if (hole) {
                        segments.push({
                            pathCoordinates: [],
                            valueData: []
                        });
                        // As we have a valid value now, we are not in a "hole" anymore
                        hole = false;
                    }
                    // Add to the segment pathCoordinates and valueData
                    segments[segments.length - 1].pathCoordinates.push(pathCoordinates[i], pathCoordinates[i + 1]);
                    segments[segments.length - 1].valueData.push(valueData[i / 2]);
                }
            }
            return segments;
        };
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        Chartist.Interpolation = {};
        /**
   * This interpolation function does not smooth the path and the result is only containing lines and no curves.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.none({
   *     fillHoles: false
   *   })
   * });
   *
   *
   * @memberof Chartist.Interpolation
   * @return {Function}
   */ Chartist.Interpolation.none = function(options) {
            var defaultOptions = {
                fillHoles: false
            };
            options = Chartist.extend({}, defaultOptions, options);
            return function none(pathCoordinates, valueData) {
                var path = new Chartist.Svg.Path();
                var hole = true;
                for(var i = 0; i < pathCoordinates.length; i += 2){
                    var currX = pathCoordinates[i];
                    var currY = pathCoordinates[i + 1];
                    var currData = valueData[i / 2];
                    if (currData.value !== undefined) {
                        if (hole) path.move(currX, currY, false, currData);
                        else path.line(currX, currY, false, currData);
                        hole = false;
                    } else if (!options.fillHoles) hole = true;
                }
                return path;
            };
        };
        /**
   * Simple smoothing creates horizontal handles that are positioned with a fraction of the length between two data points. You can use the divisor option to specify the amount of smoothing.
   *
   * Simple smoothing can be used instead of `Chartist.Smoothing.cardinal` if you'd like to get rid of the artifacts it produces sometimes. Simple smoothing produces less flowing lines but is accurate by hitting the points and it also doesn't swing below or above the given data point.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter. The simple interpolation function accepts one configuration parameter `divisor`, between 1 and ∞, which controls the smoothing characteristics.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.simple({
   *     divisor: 2,
   *     fillHoles: false
   *   })
   * });
   *
   *
   * @memberof Chartist.Interpolation
   * @param {Object} options The options of the simple interpolation factory function.
   * @return {Function}
   */ Chartist.Interpolation.simple = function(options) {
            var defaultOptions = {
                divisor: 2,
                fillHoles: false
            };
            options = Chartist.extend({}, defaultOptions, options);
            var d = 1 / Math.max(1, options.divisor);
            return function simple(pathCoordinates, valueData) {
                var path = new Chartist.Svg.Path();
                var prevX, prevY, prevData;
                for(var i = 0; i < pathCoordinates.length; i += 2){
                    var currX = pathCoordinates[i];
                    var currY = pathCoordinates[i + 1];
                    var length = (currX - prevX) * d;
                    var currData = valueData[i / 2];
                    if (currData.value !== undefined) {
                        if (prevData === undefined) path.move(currX, currY, false, currData);
                        else path.curve(prevX + length, prevY, currX - length, currY, currX, currY, false, currData);
                        prevX = currX;
                        prevY = currY;
                        prevData = currData;
                    } else if (!options.fillHoles) prevX = currX = prevData = undefined;
                }
                return path;
            };
        };
        /**
   * Cardinal / Catmull-Rome spline interpolation is the default smoothing function in Chartist. It produces nice results where the splines will always meet the points. It produces some artifacts though when data values are increased or decreased rapidly. The line may not follow a very accurate path and if the line should be accurate this smoothing function does not produce the best results.
   *
   * Cardinal splines can only be created if there are more than two data points. If this is not the case this smoothing will fallback to `Chartist.Smoothing.none`.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter. The cardinal interpolation function accepts one configuration parameter `tension`, between 0 and 1, which controls the smoothing intensity.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.cardinal({
   *     tension: 1,
   *     fillHoles: false
   *   })
   * });
   *
   * @memberof Chartist.Interpolation
   * @param {Object} options The options of the cardinal factory function.
   * @return {Function}
   */ Chartist.Interpolation.cardinal = function(options) {
            var defaultOptions = {
                tension: 1,
                fillHoles: false
            };
            options = Chartist.extend({}, defaultOptions, options);
            var t = Math.min(1, Math.max(0, options.tension)), c = 1 - t;
            return function cardinal(pathCoordinates, valueData) {
                // First we try to split the coordinates into segments
                // This is necessary to treat "holes" in line charts
                var segments = Chartist.splitIntoSegments(pathCoordinates, valueData, {
                    fillHoles: options.fillHoles
                });
                if (!segments.length) // If there were no segments return 'Chartist.Interpolation.none'
                return Chartist.Interpolation.none()([]);
                else if (segments.length > 1) {
                    // If the split resulted in more that one segment we need to interpolate each segment individually and join them
                    // afterwards together into a single path.
                    var paths = [];
                    // For each segment we will recurse the cardinal function
                    segments.forEach(function(segment) {
                        paths.push(cardinal(segment.pathCoordinates, segment.valueData));
                    });
                    // Join the segment path data into a single path and return
                    return Chartist.Svg.Path.join(paths);
                } else {
                    // If there was only one segment we can proceed regularly by using pathCoordinates and valueData from the first
                    // segment
                    pathCoordinates = segments[0].pathCoordinates;
                    valueData = segments[0].valueData;
                    // If less than two points we need to fallback to no smoothing
                    if (pathCoordinates.length <= 4) return Chartist.Interpolation.none()(pathCoordinates, valueData);
                    var path = new Chartist.Svg.Path().move(pathCoordinates[0], pathCoordinates[1], false, valueData[0]), z;
                    for(var i = 0, iLen = pathCoordinates.length; iLen - 2 * !z > i; i += 2){
                        var p = [
                            {
                                x: +pathCoordinates[i - 2],
                                y: +pathCoordinates[i - 1]
                            },
                            {
                                x: +pathCoordinates[i],
                                y: +pathCoordinates[i + 1]
                            },
                            {
                                x: +pathCoordinates[i + 2],
                                y: +pathCoordinates[i + 3]
                            },
                            {
                                x: +pathCoordinates[i + 4],
                                y: +pathCoordinates[i + 5]
                            }
                        ];
                        if (z) {
                            if (!i) p[0] = {
                                x: +pathCoordinates[iLen - 2],
                                y: +pathCoordinates[iLen - 1]
                            };
                            else if (iLen - 4 === i) p[3] = {
                                x: +pathCoordinates[0],
                                y: +pathCoordinates[1]
                            };
                            else if (iLen - 2 === i) {
                                p[2] = {
                                    x: +pathCoordinates[0],
                                    y: +pathCoordinates[1]
                                };
                                p[3] = {
                                    x: +pathCoordinates[2],
                                    y: +pathCoordinates[3]
                                };
                            }
                        } else {
                            if (iLen - 4 === i) p[3] = p[2];
                            else if (!i) p[0] = {
                                x: +pathCoordinates[i],
                                y: +pathCoordinates[i + 1]
                            };
                        }
                        path.curve(t * (-p[0].x + 6 * p[1].x + p[2].x) / 6 + c * p[2].x, t * (-p[0].y + 6 * p[1].y + p[2].y) / 6 + c * p[2].y, t * (p[1].x + 6 * p[2].x - p[3].x) / 6 + c * p[2].x, t * (p[1].y + 6 * p[2].y - p[3].y) / 6 + c * p[2].y, p[2].x, p[2].y, false, valueData[(i + 2) / 2]);
                    }
                    return path;
                }
            };
        };
        /**
   * Monotone Cubic spline interpolation produces a smooth curve which preserves monotonicity. Unlike cardinal splines, the curve will not extend beyond the range of y-values of the original data points.
   *
   * Monotone Cubic splines can only be created if there are more than two data points. If this is not the case this smoothing will fallback to `Chartist.Smoothing.none`.
   *
   * The x-values of subsequent points must be increasing to fit a Monotone Cubic spline. If this condition is not met for a pair of adjacent points, then there will be a break in the curve between those data points.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.monotoneCubic({
   *     fillHoles: false
   *   })
   * });
   *
   * @memberof Chartist.Interpolation
   * @param {Object} options The options of the monotoneCubic factory function.
   * @return {Function}
   */ Chartist.Interpolation.monotoneCubic = function(options) {
            var defaultOptions = {
                fillHoles: false
            };
            options = Chartist.extend({}, defaultOptions, options);
            return function monotoneCubic(pathCoordinates, valueData) {
                // First we try to split the coordinates into segments
                // This is necessary to treat "holes" in line charts
                var segments = Chartist.splitIntoSegments(pathCoordinates, valueData, {
                    fillHoles: options.fillHoles,
                    increasingX: true
                });
                if (!segments.length) // If there were no segments return 'Chartist.Interpolation.none'
                return Chartist.Interpolation.none()([]);
                else if (segments.length > 1) {
                    // If the split resulted in more that one segment we need to interpolate each segment individually and join them
                    // afterwards together into a single path.
                    var paths = [];
                    // For each segment we will recurse the monotoneCubic fn function
                    segments.forEach(function(segment) {
                        paths.push(monotoneCubic(segment.pathCoordinates, segment.valueData));
                    });
                    // Join the segment path data into a single path and return
                    return Chartist.Svg.Path.join(paths);
                } else {
                    // If there was only one segment we can proceed regularly by using pathCoordinates and valueData from the first
                    // segment
                    pathCoordinates = segments[0].pathCoordinates;
                    valueData = segments[0].valueData;
                    // If less than three points we need to fallback to no smoothing
                    if (pathCoordinates.length <= 4) return Chartist.Interpolation.none()(pathCoordinates, valueData);
                    var xs = [], ys = [], i, n = pathCoordinates.length / 2, ms = [], ds = [], dys = [], dxs = [], path;
                    // Populate x and y coordinates into separate arrays, for readability
                    for(i = 0; i < n; i++){
                        xs[i] = pathCoordinates[i * 2];
                        ys[i] = pathCoordinates[i * 2 + 1];
                    }
                    // Calculate deltas and derivative
                    for(i = 0; i < n - 1; i++){
                        dys[i] = ys[i + 1] - ys[i];
                        dxs[i] = xs[i + 1] - xs[i];
                        ds[i] = dys[i] / dxs[i];
                    }
                    // Determine desired slope (m) at each point using Fritsch-Carlson method
                    // See: http://math.stackexchange.com/questions/45218/implementation-of-monotone-cubic-interpolation
                    ms[0] = ds[0];
                    ms[n - 1] = ds[n - 2];
                    for(i = 1; i < n - 1; i++)if (ds[i] === 0 || ds[i - 1] === 0 || ds[i - 1] > 0 !== ds[i] > 0) ms[i] = 0;
                    else {
                        ms[i] = 3 * (dxs[i - 1] + dxs[i]) / ((2 * dxs[i] + dxs[i - 1]) / ds[i - 1] + (dxs[i] + 2 * dxs[i - 1]) / ds[i]);
                        if (!isFinite(ms[i])) ms[i] = 0;
                    }
                    // Now build a path from the slopes
                    path = new Chartist.Svg.Path().move(xs[0], ys[0], false, valueData[0]);
                    for(i = 0; i < n - 1; i++)path.curve(// First control point
                    xs[i] + dxs[i] / 3, ys[i] + ms[i] * dxs[i] / 3, // Second control point
                    xs[i + 1] - dxs[i] / 3, ys[i + 1] - ms[i + 1] * dxs[i] / 3, // End point
                    xs[i + 1], ys[i + 1], false, valueData[i + 1]);
                    return path;
                }
            };
        };
        /**
   * Step interpolation will cause the line chart to move in steps rather than diagonal or smoothed lines. This interpolation will create additional points that will also be drawn when the `showPoint` option is enabled.
   *
   * All smoothing functions within Chartist are factory functions that accept an options parameter. The step interpolation function accepts one configuration parameter `postpone`, that can be `true` or `false`. The default value is `true` and will cause the step to occur where the value actually changes. If a different behaviour is needed where the step is shifted to the left and happens before the actual value, this option can be set to `false`.
   *
   * @example
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [[1, 2, 8, 1, 7]]
   * }, {
   *   lineSmooth: Chartist.Interpolation.step({
   *     postpone: true,
   *     fillHoles: false
   *   })
   * });
   *
   * @memberof Chartist.Interpolation
   * @param options
   * @returns {Function}
   */ Chartist.Interpolation.step = function(options) {
            var defaultOptions = {
                postpone: true,
                fillHoles: false
            };
            options = Chartist.extend({}, defaultOptions, options);
            return function step(pathCoordinates, valueData) {
                var path = new Chartist.Svg.Path();
                var prevX, prevY, prevData;
                for(var i = 0; i < pathCoordinates.length; i += 2){
                    var currX = pathCoordinates[i];
                    var currY = pathCoordinates[i + 1];
                    var currData = valueData[i / 2];
                    // If the current point is also not a hole we can draw the step lines
                    if (currData.value !== undefined) {
                        if (prevData === undefined) path.move(currX, currY, false, currData);
                        else {
                            if (options.postpone) // If postponed we should draw the step line with the value of the previous value
                            path.line(currX, prevY, false, prevData);
                            else // If not postponed we should draw the step line with the value of the current value
                            path.line(prevX, currY, false, currData);
                            // Line to the actual point (this should only be a Y-Axis movement
                            path.line(currX, currY, false, currData);
                        }
                        prevX = currX;
                        prevY = currY;
                        prevData = currData;
                    } else if (!options.fillHoles) prevX = prevY = prevData = undefined;
                }
                return path;
            };
        };
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        Chartist.EventEmitter = function() {
            var handlers = [];
            /**
     * Add an event handler for a specific event
     *
     * @memberof Chartist.Event
     * @param {String} event The event name
     * @param {Function} handler A event handler function
     */ function addEventHandler(event, handler) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            }
            /**
     * Remove an event handler of a specific event name or remove all event handlers for a specific event.
     *
     * @memberof Chartist.Event
     * @param {String} event The event name where a specific or all handlers should be removed
     * @param {Function} [handler] An optional event handler function. If specified only this specific handler will be removed and otherwise all handlers are removed.
     */ function removeEventHandler(event, handler) {
                // Only do something if there are event handlers with this name existing
                if (handlers[event]) {
                    // If handler is set we will look for a specific handler and only remove this
                    if (handler) {
                        handlers[event].splice(handlers[event].indexOf(handler), 1);
                        if (handlers[event].length === 0) delete handlers[event];
                    } else // If no handler is specified we remove all handlers for this event
                    delete handlers[event];
                }
            }
            /**
     * Use this function to emit an event. All handlers that are listening for this event will be triggered with the data parameter.
     *
     * @memberof Chartist.Event
     * @param {String} event The event name that should be triggered
     * @param {*} data Arbitrary data that will be passed to the event handler callback functions
     */ function emit(event, data) {
                // Only do something if there are event handlers with this name existing
                if (handlers[event]) handlers[event].forEach(function(handler) {
                    handler(data);
                });
                // Emit event to star event handlers
                if (handlers['*']) handlers['*'].forEach(function(starHandler) {
                    starHandler(event, data);
                });
            }
            return {
                addEventHandler: addEventHandler,
                removeEventHandler: removeEventHandler,
                emit: emit
            };
        };
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        function listToArray(list) {
            var arr = [];
            if (list.length) for(var i = 0; i < list.length; i++)arr.push(list[i]);
            return arr;
        }
        /**
   * Method to extend from current prototype.
   *
   * @memberof Chartist.Class
   * @param {Object} properties The object that serves as definition for the prototype that gets created for the new class. This object should always contain a constructor property that is the desired constructor for the newly created class.
   * @param {Object} [superProtoOverride] By default extens will use the current class prototype or Chartist.class. With this parameter you can specify any super prototype that will be used.
   * @return {Function} Constructor function of the new class
   *
   * @example
   * var Fruit = Class.extend({
     * color: undefined,
     *   sugar: undefined,
     *
     *   constructor: function(color, sugar) {
     *     this.color = color;
     *     this.sugar = sugar;
     *   },
     *
     *   eat: function() {
     *     this.sugar = 0;
     *     return this;
     *   }
     * });
   *
   * var Banana = Fruit.extend({
     *   length: undefined,
     *
     *   constructor: function(length, sugar) {
     *     Banana.super.constructor.call(this, 'Yellow', sugar);
     *     this.length = length;
     *   }
     * });
   *
   * var banana = new Banana(20, 40);
   * console.log('banana instanceof Fruit', banana instanceof Fruit);
   * console.log('Fruit is prototype of banana', Fruit.prototype.isPrototypeOf(banana));
   * console.log('bananas prototype is Fruit', Object.getPrototypeOf(banana) === Fruit.prototype);
   * console.log(banana.sugar);
   * console.log(banana.eat().sugar);
   * console.log(banana.color);
   */ function extend(properties, superProtoOverride) {
            var superProto = superProtoOverride || this.prototype || Chartist.Class;
            var proto = Object.create(superProto);
            Chartist.Class.cloneDefinitions(proto, properties);
            var constr = function() {
                var fn = proto.constructor || function() {}, instance;
                // If this is linked to the Chartist namespace the constructor was not called with new
                // To provide a fallback we will instantiate here and return the instance
                instance = this === Chartist ? Object.create(proto) : this;
                fn.apply(instance, Array.prototype.slice.call(arguments, 0));
                // If this constructor was not called with new we need to return the instance
                // This will not harm when the constructor has been called with new as the returned value is ignored
                return instance;
            };
            constr.prototype = proto;
            constr.super = superProto;
            constr.extend = this.extend;
            return constr;
        }
        // Variable argument list clones args > 0 into args[0] and retruns modified args[0]
        function cloneDefinitions() {
            var args = listToArray(arguments);
            var target = args[0];
            args.splice(1, args.length - 1).forEach(function(source) {
                Object.getOwnPropertyNames(source).forEach(function(propName) {
                    // If this property already exist in target we delete it first
                    delete target[propName];
                    // Define the property with the descriptor from source
                    Object.defineProperty(target, propName, Object.getOwnPropertyDescriptor(source, propName));
                });
            });
            return target;
        }
        Chartist.Class = {
            extend: extend,
            cloneDefinitions: cloneDefinitions
        };
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        // TODO: Currently we need to re-draw the chart on window resize. This is usually very bad and will affect performance.
        // This is done because we can't work with relative coordinates when drawing the chart because SVG Path does not
        // work with relative positions yet. We need to check if we can do a viewBox hack to switch to percentage.
        // See http://mozilla.6506.n7.nabble.com/Specyfing-paths-with-percentages-unit-td247474.html
        // Update: can be done using the above method tested here: http://codepen.io/gionkunz/pen/KDvLj
        // The problem is with the label offsets that can't be converted into percentage and affecting the chart container
        /**
   * Updates the chart which currently does a full reconstruction of the SVG DOM
   *
   * @param {Object} [data] Optional data you'd like to set for the chart before it will update. If not specified the update method will use the data that is already configured with the chart.
   * @param {Object} [options] Optional options you'd like to add to the previous options for the chart before it will update. If not specified the update method will use the options that have been already configured with the chart.
   * @param {Boolean} [override] If set to true, the passed options will be used to extend the options that have been configured already. Otherwise the chart default options will be used as the base
   * @memberof Chartist.Base
   */ function update(data, options, override) {
            if (data) {
                this.data = data;
                // Event for data transformation that allows to manipulate the data before it gets rendered in the charts
                this.eventEmitter.emit('data', {
                    type: 'update',
                    data: this.data
                });
            }
            if (options) {
                this.options = Chartist.extend({}, override ? this.options : this.defaultOptions, options);
                // If chartist was not initialized yet, we just set the options and leave the rest to the initialization
                // Otherwise we re-create the optionsProvider at this point
                if (!this.initializeTimeoutId) {
                    this.optionsProvider.removeMediaQueryListeners();
                    this.optionsProvider = Chartist.optionsProvider(this.options, this.responsiveOptions, this.eventEmitter);
                }
            }
            // Only re-created the chart if it has been initialized yet
            if (!this.initializeTimeoutId) this.createChart(this.optionsProvider.getCurrentOptions());
            // Return a reference to the chart object to chain up calls
            return this;
        }
        /**
   * This method can be called on the API object of each chart and will un-register all event listeners that were added to other components. This currently includes a window.resize listener as well as media query listeners if any responsive options have been provided. Use this function if you need to destroy and recreate Chartist charts dynamically.
   *
   * @memberof Chartist.Base
   */ function detach() {
            // Only detach if initialization already occurred on this chart. If this chart still hasn't initialized (therefore
            // the initializationTimeoutId is still a valid timeout reference, we will clear the timeout
            if (!this.initializeTimeoutId) {
                window1.removeEventListener('resize', this.resizeListener);
                this.optionsProvider.removeMediaQueryListeners();
            } else window1.clearTimeout(this.initializeTimeoutId);
            return this;
        }
        /**
   * Use this function to register event handlers. The handler callbacks are synchronous and will run in the main thread rather than the event loop.
   *
   * @memberof Chartist.Base
   * @param {String} event Name of the event. Check the examples for supported events.
   * @param {Function} handler The handler function that will be called when an event with the given name was emitted. This function will receive a data argument which contains event data. See the example for more details.
   */ function on(event, handler) {
            this.eventEmitter.addEventHandler(event, handler);
            return this;
        }
        /**
   * Use this function to un-register event handlers. If the handler function parameter is omitted all handlers for the given event will be un-registered.
   *
   * @memberof Chartist.Base
   * @param {String} event Name of the event for which a handler should be removed
   * @param {Function} [handler] The handler function that that was previously used to register a new event handler. This handler will be removed from the event handler list. If this parameter is omitted then all event handlers for the given event are removed from the list.
   */ function off(event, handler) {
            this.eventEmitter.removeEventHandler(event, handler);
            return this;
        }
        function initialize() {
            // Add window resize listener that re-creates the chart
            window1.addEventListener('resize', this.resizeListener);
            // Obtain current options based on matching media queries (if responsive options are given)
            // This will also register a listener that is re-creating the chart based on media changes
            this.optionsProvider = Chartist.optionsProvider(this.options, this.responsiveOptions, this.eventEmitter);
            // Register options change listener that will trigger a chart update
            this.eventEmitter.addEventHandler('optionsChanged', (function() {
                this.update();
            }).bind(this));
            // Before the first chart creation we need to register us with all plugins that are configured
            // Initialize all relevant plugins with our chart object and the plugin options specified in the config
            if (this.options.plugins) this.options.plugins.forEach((function(plugin) {
                if (plugin instanceof Array) plugin[0](this, plugin[1]);
                else plugin(this);
            }).bind(this));
            // Event for data transformation that allows to manipulate the data before it gets rendered in the charts
            this.eventEmitter.emit('data', {
                type: 'initial',
                data: this.data
            });
            // Create the first chart
            this.createChart(this.optionsProvider.getCurrentOptions());
            // As chart is initialized from the event loop now we can reset our timeout reference
            // This is important if the chart gets initialized on the same element twice
            this.initializeTimeoutId = undefined;
        }
        /**
   * Constructor of chart base class.
   *
   * @param query
   * @param data
   * @param defaultOptions
   * @param options
   * @param responsiveOptions
   * @constructor
   */ function Base(query, data, defaultOptions, options, responsiveOptions) {
            this.container = Chartist.querySelector(query);
            this.data = data;
            this.defaultOptions = defaultOptions;
            this.options = options;
            this.responsiveOptions = responsiveOptions;
            this.eventEmitter = Chartist.EventEmitter();
            this.supportsForeignObject = Chartist.Svg.isSupported('Extensibility');
            this.supportsAnimations = Chartist.Svg.isSupported('AnimationEventsAttribute');
            this.resizeListener = (function resizeListener() {
                this.update();
            }).bind(this);
            if (this.container) {
                // If chartist was already initialized in this container we are detaching all event listeners first
                if (this.container.__chartist__) this.container.__chartist__.detach();
                this.container.__chartist__ = this;
            }
            // Using event loop for first draw to make it possible to register event listeners in the same call stack where
            // the chart was created.
            this.initializeTimeoutId = setTimeout(initialize.bind(this), 0);
        }
        // Creating the chart base class
        Chartist.Base = Chartist.Class.extend({
            constructor: Base,
            optionsProvider: undefined,
            container: undefined,
            svg: undefined,
            eventEmitter: undefined,
            createChart: function() {
                throw new Error('Base chart type can\'t be instantiated!');
            },
            update: update,
            detach: detach,
            on: on,
            off: off,
            version: Chartist.version,
            supportsForeignObject: false
        });
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        /**
   * Chartist.Svg creates a new SVG object wrapper with a starting element. You can use the wrapper to fluently create sub-elements and modify them.
   *
   * @memberof Chartist.Svg
   * @constructor
   * @param {String|Element} name The name of the SVG element to create or an SVG dom element which should be wrapped into Chartist.Svg
   * @param {Object} attributes An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added.
   * @param {String} className This class or class list will be added to the SVG element
   * @param {Object} parent The parent SVG wrapper object where this newly created wrapper and it's element will be attached to as child
   * @param {Boolean} insertFirst If this param is set to true in conjunction with a parent element the newly created element will be added as first child element in the parent element
   */ function Svg(name, attributes, className, parent, insertFirst) {
            // If Svg is getting called with an SVG element we just return the wrapper
            if (name instanceof Element) this._node = name;
            else {
                this._node = document1.createElementNS(Chartist.namespaces.svg, name);
                // If this is an SVG element created then custom namespace
                if (name === 'svg') this.attr({
                    'xmlns:ct': Chartist.namespaces.ct
                });
            }
            if (attributes) this.attr(attributes);
            if (className) this.addClass(className);
            if (parent) {
                if (insertFirst && parent._node.firstChild) parent._node.insertBefore(this._node, parent._node.firstChild);
                else parent._node.appendChild(this._node);
            }
        }
        /**
   * Set attributes on the current SVG element of the wrapper you're currently working on.
   *
   * @memberof Chartist.Svg
   * @param {Object|String} attributes An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added. If this parameter is a String then the function is used as a getter and will return the attribute value.
   * @param {String} ns If specified, the attribute will be obtained using getAttributeNs. In order to write namepsaced attributes you can use the namespace:attribute notation within the attributes object.
   * @return {Object|String} The current wrapper object will be returned so it can be used for chaining or the attribute value if used as getter function.
   */ function attr(attributes, ns) {
            if (typeof attributes === 'string') {
                if (ns) return this._node.getAttributeNS(ns, attributes);
                else return this._node.getAttribute(attributes);
            }
            Object.keys(attributes).forEach((function(key) {
                // If the attribute value is undefined we can skip this one
                if (attributes[key] === undefined) return;
                if (key.indexOf(':') !== -1) {
                    var namespacedAttribute = key.split(':');
                    this._node.setAttributeNS(Chartist.namespaces[namespacedAttribute[0]], key, attributes[key]);
                } else this._node.setAttribute(key, attributes[key]);
            }).bind(this));
            return this;
        }
        /**
   * Create a new SVG element whose wrapper object will be selected for further operations. This way you can also create nested groups easily.
   *
   * @memberof Chartist.Svg
   * @param {String} name The name of the SVG element that should be created as child element of the currently selected element wrapper
   * @param {Object} [attributes] An object with properties that will be added as attributes to the SVG element that is created. Attributes with undefined values will not be added.
   * @param {String} [className] This class or class list will be added to the SVG element
   * @param {Boolean} [insertFirst] If this param is set to true in conjunction with a parent element the newly created element will be added as first child element in the parent element
   * @return {Chartist.Svg} Returns a Chartist.Svg wrapper object that can be used to modify the containing SVG data
   */ function elem(name, attributes, className, insertFirst) {
            return new Chartist.Svg(name, attributes, className, this, insertFirst);
        }
        /**
   * Returns the parent Chartist.SVG wrapper object
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} Returns a Chartist.Svg wrapper around the parent node of the current node. If the parent node is not existing or it's not an SVG node then this function will return null.
   */ function parent() {
            return this._node.parentNode instanceof SVGElement ? new Chartist.Svg(this._node.parentNode) : null;
        }
        /**
   * This method returns a Chartist.Svg wrapper around the root SVG element of the current tree.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The root SVG element wrapped in a Chartist.Svg element
   */ function root() {
            var node = this._node;
            while(node.nodeName !== 'svg')node = node.parentNode;
            return new Chartist.Svg(node);
        }
        /**
   * Find the first child SVG element of the current element that matches a CSS selector. The returned object is a Chartist.Svg wrapper.
   *
   * @memberof Chartist.Svg
   * @param {String} selector A CSS selector that is used to query for child SVG elements
   * @return {Chartist.Svg} The SVG wrapper for the element found or null if no element was found
   */ function querySelector(selector) {
            var foundNode = this._node.querySelector(selector);
            return foundNode ? new Chartist.Svg(foundNode) : null;
        }
        /**
   * Find the all child SVG elements of the current element that match a CSS selector. The returned object is a Chartist.Svg.List wrapper.
   *
   * @memberof Chartist.Svg
   * @param {String} selector A CSS selector that is used to query for child SVG elements
   * @return {Chartist.Svg.List} The SVG wrapper list for the element found or null if no element was found
   */ function querySelectorAll(selector) {
            var foundNodes = this._node.querySelectorAll(selector);
            return foundNodes.length ? new Chartist.Svg.List(foundNodes) : null;
        }
        /**
   * This method creates a foreignObject (see https://developer.mozilla.org/en-US/docs/Web/SVG/Element/foreignObject) that allows to embed HTML content into a SVG graphic. With the help of foreignObjects you can enable the usage of regular HTML elements inside of SVG where they are subject for SVG positioning and transformation but the Browser will use the HTML rendering capabilities for the containing DOM.
   *
   * @memberof Chartist.Svg
   * @param {Node|String} content The DOM Node, or HTML string that will be converted to a DOM Node, that is then placed into and wrapped by the foreignObject
   * @param {String} [attributes] An object with properties that will be added as attributes to the foreignObject element that is created. Attributes with undefined values will not be added.
   * @param {String} [className] This class or class list will be added to the SVG element
   * @param {Boolean} [insertFirst] Specifies if the foreignObject should be inserted as first child
   * @return {Chartist.Svg} New wrapper object that wraps the foreignObject element
   */ function foreignObject(content, attributes, className, insertFirst) {
            // If content is string then we convert it to DOM
            // TODO: Handle case where content is not a string nor a DOM Node
            if (typeof content === 'string') {
                var container = document1.createElement('div');
                container.innerHTML = content;
                content = container.firstChild;
            }
            // Adding namespace to content element
            content.setAttribute('xmlns', Chartist.namespaces.xmlns);
            // Creating the foreignObject without required extension attribute (as described here
            // http://www.w3.org/TR/SVG/extend.html#ForeignObjectElement)
            var fnObj = this.elem('foreignObject', attributes, className, insertFirst);
            // Add content to foreignObjectElement
            fnObj._node.appendChild(content);
            return fnObj;
        }
        /**
   * This method adds a new text element to the current Chartist.Svg wrapper.
   *
   * @memberof Chartist.Svg
   * @param {String} t The text that should be added to the text element that is created
   * @return {Chartist.Svg} The same wrapper object that was used to add the newly created element
   */ function text(t) {
            this._node.appendChild(document1.createTextNode(t));
            return this;
        }
        /**
   * This method will clear all child nodes of the current wrapper object.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The same wrapper object that got emptied
   */ function empty() {
            while(this._node.firstChild)this._node.removeChild(this._node.firstChild);
            return this;
        }
        /**
   * This method will cause the current wrapper to remove itself from its parent wrapper. Use this method if you'd like to get rid of an element in a given DOM structure.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The parent wrapper object of the element that got removed
   */ function remove() {
            this._node.parentNode.removeChild(this._node);
            return this.parent();
        }
        /**
   * This method will replace the element with a new element that can be created outside of the current DOM.
   *
   * @memberof Chartist.Svg
   * @param {Chartist.Svg} newElement The new Chartist.Svg object that will be used to replace the current wrapper object
   * @return {Chartist.Svg} The wrapper of the new element
   */ function replace(newElement) {
            this._node.parentNode.replaceChild(newElement._node, this._node);
            return newElement;
        }
        /**
   * This method will append an element to the current element as a child.
   *
   * @memberof Chartist.Svg
   * @param {Chartist.Svg} element The Chartist.Svg element that should be added as a child
   * @param {Boolean} [insertFirst] Specifies if the element should be inserted as first child
   * @return {Chartist.Svg} The wrapper of the appended object
   */ function append(element, insertFirst) {
            if (insertFirst && this._node.firstChild) this._node.insertBefore(element._node, this._node.firstChild);
            else this._node.appendChild(element._node);
            return this;
        }
        /**
   * Returns an array of class names that are attached to the current wrapper element. This method can not be chained further.
   *
   * @memberof Chartist.Svg
   * @return {Array} A list of classes or an empty array if there are no classes on the current element
   */ function classes() {
            return this._node.getAttribute('class') ? this._node.getAttribute('class').trim().split(/\s+/) : [];
        }
        /**
   * Adds one or a space separated list of classes to the current element and ensures the classes are only existing once.
   *
   * @memberof Chartist.Svg
   * @param {String} names A white space separated list of class names
   * @return {Chartist.Svg} The wrapper of the current element
   */ function addClass(names) {
            this._node.setAttribute('class', this.classes(this._node).concat(names.trim().split(/\s+/)).filter(function(elem, pos, self) {
                return self.indexOf(elem) === pos;
            }).join(' '));
            return this;
        }
        /**
   * Removes one or a space separated list of classes from the current element.
   *
   * @memberof Chartist.Svg
   * @param {String} names A white space separated list of class names
   * @return {Chartist.Svg} The wrapper of the current element
   */ function removeClass(names) {
            var removedClasses = names.trim().split(/\s+/);
            this._node.setAttribute('class', this.classes(this._node).filter(function(name) {
                return removedClasses.indexOf(name) === -1;
            }).join(' '));
            return this;
        }
        /**
   * Removes all classes from the current element.
   *
   * @memberof Chartist.Svg
   * @return {Chartist.Svg} The wrapper of the current element
   */ function removeAllClasses() {
            this._node.setAttribute('class', '');
            return this;
        }
        /**
   * Get element height using `getBoundingClientRect`
   *
   * @memberof Chartist.Svg
   * @return {Number} The elements height in pixels
   */ function height() {
            return this._node.getBoundingClientRect().height;
        }
        /**
   * Get element width using `getBoundingClientRect`
   *
   * @memberof Chartist.Core
   * @return {Number} The elements width in pixels
   */ function width() {
            return this._node.getBoundingClientRect().width;
        }
        /**
   * The animate function lets you animate the current element with SMIL animations. You can add animations for multiple attributes at the same time by using an animation definition object. This object should contain SMIL animation attributes. Please refer to http://www.w3.org/TR/SVG/animate.html for a detailed specification about the available animation attributes. Additionally an easing property can be passed in the animation definition object. This can be a string with a name of an easing function in `Chartist.Svg.Easing` or an array with four numbers specifying a cubic Bézier curve.
   * **An animations object could look like this:**
   * ```javascript
   * element.animate({
   *   opacity: {
   *     dur: 1000,
   *     from: 0,
   *     to: 1
   *   },
   *   x1: {
   *     dur: '1000ms',
   *     from: 100,
   *     to: 200,
   *     easing: 'easeOutQuart'
   *   },
   *   y1: {
   *     dur: '2s',
   *     from: 0,
   *     to: 100
   *   }
   * });
   * ```
   * **Automatic unit conversion**
   * For the `dur` and the `begin` animate attribute you can also omit a unit by passing a number. The number will automatically be converted to milli seconds.
   * **Guided mode**
   * The default behavior of SMIL animations with offset using the `begin` attribute is that the attribute will keep it's original value until the animation starts. Mostly this behavior is not desired as you'd like to have your element attributes already initialized with the animation `from` value even before the animation starts. Also if you don't specify `fill="freeze"` on an animate element or if you delete the animation after it's done (which is done in guided mode) the attribute will switch back to the initial value. This behavior is also not desired when performing simple one-time animations. For one-time animations you'd want to trigger animations immediately instead of relative to the document begin time. That's why in guided mode Chartist.Svg will also use the `begin` property to schedule a timeout and manually start the animation after the timeout. If you're using multiple SMIL definition objects for an attribute (in an array), guided mode will be disabled for this attribute, even if you explicitly enabled it.
   * If guided mode is enabled the following behavior is added:
   * - Before the animation starts (even when delayed with `begin`) the animated attribute will be set already to the `from` value of the animation
   * - `begin` is explicitly set to `indefinite` so it can be started manually without relying on document begin time (creation)
   * - The animate element will be forced to use `fill="freeze"`
   * - The animation will be triggered with `beginElement()` in a timeout where `begin` of the definition object is interpreted in milli seconds. If no `begin` was specified the timeout is triggered immediately.
   * - After the animation the element attribute value will be set to the `to` value of the animation
   * - The animate element is deleted from the DOM
   *
   * @memberof Chartist.Svg
   * @param {Object} animations An animations object where the property keys are the attributes you'd like to animate. The properties should be objects again that contain the SMIL animation attributes (usually begin, dur, from, and to). The property begin and dur is auto converted (see Automatic unit conversion). You can also schedule multiple animations for the same attribute by passing an Array of SMIL definition objects. Attributes that contain an array of SMIL definition objects will not be executed in guided mode.
   * @param {Boolean} guided Specify if guided mode should be activated for this animation (see Guided mode). If not otherwise specified, guided mode will be activated.
   * @param {Object} eventEmitter If specified, this event emitter will be notified when an animation starts or ends.
   * @return {Chartist.Svg} The current element where the animation was added
   */ function animate(animations, guided, eventEmitter) {
            if (guided === undefined) guided = true;
            Object.keys(animations).forEach((function createAnimateForAttributes(attribute) {
                function createAnimate(animationDefinition, guided) {
                    var attributeProperties = {}, animate, timeout, easing;
                    // Check if an easing is specified in the definition object and delete it from the object as it will not
                    // be part of the animate element attributes.
                    if (animationDefinition.easing) {
                        // If already an easing Bézier curve array we take it or we lookup a easing array in the Easing object
                        easing = animationDefinition.easing instanceof Array ? animationDefinition.easing : Chartist.Svg.Easing[animationDefinition.easing];
                        delete animationDefinition.easing;
                    }
                    // If numeric dur or begin was provided we assume milli seconds
                    animationDefinition.begin = Chartist.ensureUnit(animationDefinition.begin, 'ms');
                    animationDefinition.dur = Chartist.ensureUnit(animationDefinition.dur, 'ms');
                    if (easing) {
                        animationDefinition.calcMode = 'spline';
                        animationDefinition.keySplines = easing.join(' ');
                        animationDefinition.keyTimes = '0;1';
                    }
                    // Adding "fill: freeze" if we are in guided mode and set initial attribute values
                    if (guided) {
                        animationDefinition.fill = 'freeze';
                        // Animated property on our element should already be set to the animation from value in guided mode
                        attributeProperties[attribute] = animationDefinition.from;
                        this.attr(attributeProperties);
                        // In guided mode we also set begin to indefinite so we can trigger the start manually and put the begin
                        // which needs to be in ms aside
                        timeout = Chartist.quantity(animationDefinition.begin || 0).value;
                        animationDefinition.begin = 'indefinite';
                    }
                    animate = this.elem('animate', Chartist.extend({
                        attributeName: attribute
                    }, animationDefinition));
                    if (guided) // If guided we take the value that was put aside in timeout and trigger the animation manually with a timeout
                    setTimeout((function() {
                        // If beginElement fails we set the animated attribute to the end position and remove the animate element
                        // This happens if the SMIL ElementTimeControl interface is not supported or any other problems occured in
                        // the browser. (Currently FF 34 does not support animate elements in foreignObjects)
                        try {
                            animate._node.beginElement();
                        } catch (err) {
                            // Set animated attribute to current animated value
                            attributeProperties[attribute] = animationDefinition.to;
                            this.attr(attributeProperties);
                            // Remove the animate element as it's no longer required
                            animate.remove();
                        }
                    }).bind(this), timeout);
                    if (eventEmitter) animate._node.addEventListener('beginEvent', (function handleBeginEvent() {
                        eventEmitter.emit('animationBegin', {
                            element: this,
                            animate: animate._node,
                            params: animationDefinition
                        });
                    }).bind(this));
                    animate._node.addEventListener('endEvent', (function handleEndEvent() {
                        if (eventEmitter) eventEmitter.emit('animationEnd', {
                            element: this,
                            animate: animate._node,
                            params: animationDefinition
                        });
                        if (guided) {
                            // Set animated attribute to current animated value
                            attributeProperties[attribute] = animationDefinition.to;
                            this.attr(attributeProperties);
                            // Remove the animate element as it's no longer required
                            animate.remove();
                        }
                    }).bind(this));
                }
                // If current attribute is an array of definition objects we create an animate for each and disable guided mode
                if (animations[attribute] instanceof Array) animations[attribute].forEach((function(animationDefinition) {
                    createAnimate.bind(this)(animationDefinition, false);
                }).bind(this));
                else createAnimate.bind(this)(animations[attribute], guided);
            }).bind(this));
            return this;
        }
        Chartist.Svg = Chartist.Class.extend({
            constructor: Svg,
            attr: attr,
            elem: elem,
            parent: parent,
            root: root,
            querySelector: querySelector,
            querySelectorAll: querySelectorAll,
            foreignObject: foreignObject,
            text: text,
            empty: empty,
            remove: remove,
            replace: replace,
            append: append,
            classes: classes,
            addClass: addClass,
            removeClass: removeClass,
            removeAllClasses: removeAllClasses,
            height: height,
            width: width,
            animate: animate
        });
        /**
   * This method checks for support of a given SVG feature like Extensibility, SVG-animation or the like. Check http://www.w3.org/TR/SVG11/feature for a detailed list.
   *
   * @memberof Chartist.Svg
   * @param {String} feature The SVG 1.1 feature that should be checked for support.
   * @return {Boolean} True of false if the feature is supported or not
   */ Chartist.Svg.isSupported = function(feature) {
            return document1.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#' + feature, '1.1');
        };
        /**
   * This Object contains some standard easing cubic bezier curves. Then can be used with their name in the `Chartist.Svg.animate`. You can also extend the list and use your own name in the `animate` function. Click the show code button to see the available bezier functions.
   *
   * @memberof Chartist.Svg
   */ var easingCubicBeziers = {
            easeInSine: [
                0.47,
                0,
                0.745,
                0.715
            ],
            easeOutSine: [
                0.39,
                0.575,
                0.565,
                1
            ],
            easeInOutSine: [
                0.445,
                0.05,
                0.55,
                0.95
            ],
            easeInQuad: [
                0.55,
                0.085,
                0.68,
                0.53
            ],
            easeOutQuad: [
                0.25,
                0.46,
                0.45,
                0.94
            ],
            easeInOutQuad: [
                0.455,
                0.03,
                0.515,
                0.955
            ],
            easeInCubic: [
                0.55,
                0.055,
                0.675,
                0.19
            ],
            easeOutCubic: [
                0.215,
                0.61,
                0.355,
                1
            ],
            easeInOutCubic: [
                0.645,
                0.045,
                0.355,
                1
            ],
            easeInQuart: [
                0.895,
                0.03,
                0.685,
                0.22
            ],
            easeOutQuart: [
                0.165,
                0.84,
                0.44,
                1
            ],
            easeInOutQuart: [
                0.77,
                0,
                0.175,
                1
            ],
            easeInQuint: [
                0.755,
                0.05,
                0.855,
                0.06
            ],
            easeOutQuint: [
                0.23,
                1,
                0.32,
                1
            ],
            easeInOutQuint: [
                0.86,
                0,
                0.07,
                1
            ],
            easeInExpo: [
                0.95,
                0.05,
                0.795,
                0.035
            ],
            easeOutExpo: [
                0.19,
                1,
                0.22,
                1
            ],
            easeInOutExpo: [
                1,
                0,
                0,
                1
            ],
            easeInCirc: [
                0.6,
                0.04,
                0.98,
                0.335
            ],
            easeOutCirc: [
                0.075,
                0.82,
                0.165,
                1
            ],
            easeInOutCirc: [
                0.785,
                0.135,
                0.15,
                0.86
            ],
            easeInBack: [
                0.6,
                -0.28,
                0.735,
                0.045
            ],
            easeOutBack: [
                0.175,
                0.885,
                0.32,
                1.275
            ],
            easeInOutBack: [
                0.68,
                -0.55,
                0.265,
                1.55
            ]
        };
        Chartist.Svg.Easing = easingCubicBeziers;
        /**
   * This helper class is to wrap multiple `Chartist.Svg` elements into a list where you can call the `Chartist.Svg` functions on all elements in the list with one call. This is helpful when you'd like to perform calls with `Chartist.Svg` on multiple elements.
   * An instance of this class is also returned by `Chartist.Svg.querySelectorAll`.
   *
   * @memberof Chartist.Svg
   * @param {Array<Node>|NodeList} nodeList An Array of SVG DOM nodes or a SVG DOM NodeList (as returned by document.querySelectorAll)
   * @constructor
   */ function SvgList(nodeList) {
            var list = this;
            this.svgElements = [];
            for(var i = 0; i < nodeList.length; i++)this.svgElements.push(new Chartist.Svg(nodeList[i]));
            // Add delegation methods for Chartist.Svg
            Object.keys(Chartist.Svg.prototype).filter(function(prototypeProperty) {
                return [
                    'constructor',
                    'parent',
                    'querySelector',
                    'querySelectorAll',
                    'replace',
                    'append',
                    'classes',
                    'height',
                    'width'
                ].indexOf(prototypeProperty) === -1;
            }).forEach(function(prototypeProperty) {
                list[prototypeProperty] = function() {
                    var args = Array.prototype.slice.call(arguments, 0);
                    list.svgElements.forEach(function(element) {
                        Chartist.Svg.prototype[prototypeProperty].apply(element, args);
                    });
                    return list;
                };
            });
        }
        Chartist.Svg.List = Chartist.Class.extend({
            constructor: SvgList
        });
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        /**
   * Contains the descriptors of supported element types in a SVG path. Currently only move, line and curve are supported.
   *
   * @memberof Chartist.Svg.Path
   * @type {Object}
   */ var elementDescriptions = {
            m: [
                'x',
                'y'
            ],
            l: [
                'x',
                'y'
            ],
            c: [
                'x1',
                'y1',
                'x2',
                'y2',
                'x',
                'y'
            ],
            a: [
                'rx',
                'ry',
                'xAr',
                'lAf',
                'sf',
                'x',
                'y'
            ]
        };
        /**
   * Default options for newly created SVG path objects.
   *
   * @memberof Chartist.Svg.Path
   * @type {Object}
   */ var defaultOptions = {
            // The accuracy in digit count after the decimal point. This will be used to round numbers in the SVG path. If this option is set to false then no rounding will be performed.
            accuracy: 3
        };
        function element(command, params, pathElements, pos, relative, data) {
            var pathElement = Chartist.extend({
                command: relative ? command.toLowerCase() : command.toUpperCase()
            }, params, data ? {
                data: data
            } : {});
            pathElements.splice(pos, 0, pathElement);
        }
        function forEachParam(pathElements, cb) {
            pathElements.forEach(function(pathElement, pathElementIndex) {
                elementDescriptions[pathElement.command.toLowerCase()].forEach(function(paramName, paramIndex) {
                    cb(pathElement, paramName, pathElementIndex, paramIndex, pathElements);
                });
            });
        }
        /**
   * Used to construct a new path object.
   *
   * @memberof Chartist.Svg.Path
   * @param {Boolean} close If set to true then this path will be closed when stringified (with a Z at the end)
   * @param {Object} options Options object that overrides the default objects. See default options for more details.
   * @constructor
   */ function SvgPath(close, options) {
            this.pathElements = [];
            this.pos = 0;
            this.close = close;
            this.options = Chartist.extend({}, defaultOptions, options);
        }
        /**
   * Gets or sets the current position (cursor) inside of the path. You can move around the cursor freely but limited to 0 or the count of existing elements. All modifications with element functions will insert new elements at the position of this cursor.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} [pos] If a number is passed then the cursor is set to this position in the path element array.
   * @return {Chartist.Svg.Path|Number} If the position parameter was passed then the return value will be the path object for easy call chaining. If no position parameter was passed then the current position is returned.
   */ function position(pos) {
            if (pos !== undefined) {
                this.pos = Math.max(0, Math.min(this.pathElements.length, pos));
                return this;
            } else return this.pos;
        }
        /**
   * Removes elements from the path starting at the current position.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} count Number of path elements that should be removed from the current position.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */ function remove(count) {
            this.pathElements.splice(this.pos, count);
            return this;
        }
        /**
   * Use this function to add a new move SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The x coordinate for the move element.
   * @param {Number} y The y coordinate for the move element.
   * @param {Boolean} [relative] If set to true the move element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */ function move(x, y, relative, data) {
            element('M', {
                x: +x,
                y: +y
            }, this.pathElements, this.pos++, relative, data);
            return this;
        }
        /**
   * Use this function to add a new line SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The x coordinate for the line element.
   * @param {Number} y The y coordinate for the line element.
   * @param {Boolean} [relative] If set to true the line element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */ function line(x, y, relative, data) {
            element('L', {
                x: +x,
                y: +y
            }, this.pathElements, this.pos++, relative, data);
            return this;
        }
        /**
   * Use this function to add a new curve SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x1 The x coordinate for the first control point of the bezier curve.
   * @param {Number} y1 The y coordinate for the first control point of the bezier curve.
   * @param {Number} x2 The x coordinate for the second control point of the bezier curve.
   * @param {Number} y2 The y coordinate for the second control point of the bezier curve.
   * @param {Number} x The x coordinate for the target point of the curve element.
   * @param {Number} y The y coordinate for the target point of the curve element.
   * @param {Boolean} [relative] If set to true the curve element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */ function curve(x1, y1, x2, y2, x, y, relative, data) {
            element('C', {
                x1: +x1,
                y1: +y1,
                x2: +x2,
                y2: +y2,
                x: +x,
                y: +y
            }, this.pathElements, this.pos++, relative, data);
            return this;
        }
        /**
   * Use this function to add a new non-bezier curve SVG path element.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} rx The radius to be used for the x-axis of the arc.
   * @param {Number} ry The radius to be used for the y-axis of the arc.
   * @param {Number} xAr Defines the orientation of the arc
   * @param {Number} lAf Large arc flag
   * @param {Number} sf Sweep flag
   * @param {Number} x The x coordinate for the target point of the curve element.
   * @param {Number} y The y coordinate for the target point of the curve element.
   * @param {Boolean} [relative] If set to true the curve element will be created with relative coordinates (lowercase letter)
   * @param {*} [data] Any data that should be stored with the element object that will be accessible in pathElement
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */ function arc(rx, ry, xAr, lAf, sf, x, y, relative, data) {
            element('A', {
                rx: +rx,
                ry: +ry,
                xAr: +xAr,
                lAf: +lAf,
                sf: +sf,
                x: +x,
                y: +y
            }, this.pathElements, this.pos++, relative, data);
            return this;
        }
        /**
   * Parses an SVG path seen in the d attribute of path elements, and inserts the parsed elements into the existing path object at the current cursor position. Any closing path indicators (Z at the end of the path) will be ignored by the parser as this is provided by the close option in the options of the path object.
   *
   * @memberof Chartist.Svg.Path
   * @param {String} path Any SVG path that contains move (m), line (l) or curve (c) components.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */ function parse(path) {
            // Parsing the SVG path string into an array of arrays [['M', '10', '10'], ['L', '100', '100']]
            var chunks = path.replace(/([A-Za-z])([0-9])/g, '$1 $2').replace(/([0-9])([A-Za-z])/g, '$1 $2').split(/[\s,]+/).reduce(function(result, element) {
                if (element.match(/[A-Za-z]/)) result.push([]);
                result[result.length - 1].push(element);
                return result;
            }, []);
            // If this is a closed path we remove the Z at the end because this is determined by the close option
            if (chunks[chunks.length - 1][0].toUpperCase() === 'Z') chunks.pop();
            // Using svgPathElementDescriptions to map raw path arrays into objects that contain the command and the parameters
            // For example {command: 'M', x: '10', y: '10'}
            var elements = chunks.map(function(chunk) {
                var command = chunk.shift(), description = elementDescriptions[command.toLowerCase()];
                return Chartist.extend({
                    command: command
                }, description.reduce(function(result, paramName, index) {
                    result[paramName] = +chunk[index];
                    return result;
                }, {}));
            });
            // Preparing a splice call with the elements array as var arg params and insert the parsed elements at the current position
            var spliceArgs = [
                this.pos,
                0
            ];
            Array.prototype.push.apply(spliceArgs, elements);
            Array.prototype.splice.apply(this.pathElements, spliceArgs);
            // Increase the internal position by the element count
            this.pos += elements.length;
            return this;
        }
        /**
   * This function renders to current SVG path object into a final SVG string that can be used in the d attribute of SVG path elements. It uses the accuracy option to round big decimals. If the close parameter was set in the constructor of this path object then a path closing Z will be appended to the output string.
   *
   * @memberof Chartist.Svg.Path
   * @return {String}
   */ function stringify() {
            var accuracyMultiplier = Math.pow(10, this.options.accuracy);
            return this.pathElements.reduce((function(path, pathElement) {
                var params = elementDescriptions[pathElement.command.toLowerCase()].map((function(paramName) {
                    return this.options.accuracy ? Math.round(pathElement[paramName] * accuracyMultiplier) / accuracyMultiplier : pathElement[paramName];
                }).bind(this));
                return path + pathElement.command + params.join(',');
            }).bind(this), '') + (this.close ? 'Z' : '');
        }
        /**
   * Scales all elements in the current SVG path object. There is an individual parameter for each coordinate. Scaling will also be done for control points of curves, affecting the given coordinate.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The number which will be used to scale the x, x1 and x2 of all path elements.
   * @param {Number} y The number which will be used to scale the y, y1 and y2 of all path elements.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */ function scale(x, y) {
            forEachParam(this.pathElements, function(pathElement, paramName) {
                pathElement[paramName] *= paramName[0] === 'x' ? x : y;
            });
            return this;
        }
        /**
   * Translates all elements in the current SVG path object. The translation is relative and there is an individual parameter for each coordinate. Translation will also be done for control points of curves, affecting the given coordinate.
   *
   * @memberof Chartist.Svg.Path
   * @param {Number} x The number which will be used to translate the x, x1 and x2 of all path elements.
   * @param {Number} y The number which will be used to translate the y, y1 and y2 of all path elements.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */ function translate(x, y) {
            forEachParam(this.pathElements, function(pathElement, paramName) {
                pathElement[paramName] += paramName[0] === 'x' ? x : y;
            });
            return this;
        }
        /**
   * This function will run over all existing path elements and then loop over their attributes. The callback function will be called for every path element attribute that exists in the current path.
   * The method signature of the callback function looks like this:
   * ```javascript
   * function(pathElement, paramName, pathElementIndex, paramIndex, pathElements)
   * ```
   * If something else than undefined is returned by the callback function, this value will be used to replace the old value. This allows you to build custom transformations of path objects that can't be achieved using the basic transformation functions scale and translate.
   *
   * @memberof Chartist.Svg.Path
   * @param {Function} transformFnc The callback function for the transformation. Check the signature in the function description.
   * @return {Chartist.Svg.Path} The current path object for easy call chaining.
   */ function transform(transformFnc) {
            forEachParam(this.pathElements, function(pathElement, paramName, pathElementIndex, paramIndex, pathElements) {
                var transformed = transformFnc(pathElement, paramName, pathElementIndex, paramIndex, pathElements);
                if (transformed || transformed === 0) pathElement[paramName] = transformed;
            });
            return this;
        }
        /**
   * This function clones a whole path object with all its properties. This is a deep clone and path element objects will also be cloned.
   *
   * @memberof Chartist.Svg.Path
   * @param {Boolean} [close] Optional option to set the new cloned path to closed. If not specified or false, the original path close option will be used.
   * @return {Chartist.Svg.Path}
   */ function clone(close) {
            var c = new Chartist.Svg.Path(close || this.close);
            c.pos = this.pos;
            c.pathElements = this.pathElements.slice().map(function cloneElements(pathElement) {
                return Chartist.extend({}, pathElement);
            });
            c.options = Chartist.extend({}, this.options);
            return c;
        }
        /**
   * Split a Svg.Path object by a specific command in the path chain. The path chain will be split and an array of newly created paths objects will be returned. This is useful if you'd like to split an SVG path by it's move commands, for example, in order to isolate chunks of drawings.
   *
   * @memberof Chartist.Svg.Path
   * @param {String} command The command you'd like to use to split the path
   * @return {Array<Chartist.Svg.Path>}
   */ function splitByCommand(command) {
            var split = [
                new Chartist.Svg.Path()
            ];
            this.pathElements.forEach(function(pathElement) {
                if (pathElement.command === command.toUpperCase() && split[split.length - 1].pathElements.length !== 0) split.push(new Chartist.Svg.Path());
                split[split.length - 1].pathElements.push(pathElement);
            });
            return split;
        }
        /**
   * This static function on `Chartist.Svg.Path` is joining multiple paths together into one paths.
   *
   * @memberof Chartist.Svg.Path
   * @param {Array<Chartist.Svg.Path>} paths A list of paths to be joined together. The order is important.
   * @param {boolean} close If the newly created path should be a closed path
   * @param {Object} options Path options for the newly created path.
   * @return {Chartist.Svg.Path}
   */ function join(paths, close, options) {
            var joinedPath = new Chartist.Svg.Path(close, options);
            for(var i = 0; i < paths.length; i++){
                var path = paths[i];
                for(var j = 0; j < path.pathElements.length; j++)joinedPath.pathElements.push(path.pathElements[j]);
            }
            return joinedPath;
        }
        Chartist.Svg.Path = Chartist.Class.extend({
            constructor: SvgPath,
            position: position,
            remove: remove,
            move: move,
            line: line,
            curve: curve,
            arc: arc,
            scale: scale,
            translate: translate,
            transform: transform,
            parse: parse,
            stringify: stringify,
            clone: clone,
            splitByCommand: splitByCommand
        });
        Chartist.Svg.Path.elementDescriptions = elementDescriptions;
        Chartist.Svg.Path.join = join;
    })(window, document, Chartist);
    (function(window1, document1, Chartist) {
        'use strict';
        var axisUnits = {
            x: {
                pos: 'x',
                len: 'width',
                dir: 'horizontal',
                rectStart: 'x1',
                rectEnd: 'x2',
                rectOffset: 'y2'
            },
            y: {
                pos: 'y',
                len: 'height',
                dir: 'vertical',
                rectStart: 'y2',
                rectEnd: 'y1',
                rectOffset: 'x1'
            }
        };
        function Axis(units, chartRect, ticks, options) {
            this.units = units;
            this.counterUnits = units === axisUnits.x ? axisUnits.y : axisUnits.x;
            this.chartRect = chartRect;
            this.axisLength = chartRect[units.rectEnd] - chartRect[units.rectStart];
            this.gridOffset = chartRect[units.rectOffset];
            this.ticks = ticks;
            this.options = options;
        }
        function createGridAndLabels(gridGroup, labelGroup, useForeignObject, chartOptions, eventEmitter) {
            var axisOptions = chartOptions['axis' + this.units.pos.toUpperCase()];
            var projectedValues = this.ticks.map(this.projectValue.bind(this));
            var labelValues = this.ticks.map(axisOptions.labelInterpolationFnc);
            projectedValues.forEach((function(projectedValue, index) {
                var labelOffset = {
                    x: 0,
                    y: 0
                };
                // TODO: Find better solution for solving this problem
                // Calculate how much space we have available for the label
                var labelLength;
                if (projectedValues[index + 1]) // If we still have one label ahead, we can calculate the distance to the next tick / label
                labelLength = projectedValues[index + 1] - projectedValue;
                else // If we don't have a label ahead and we have only two labels in total, we just take the remaining distance to
                // on the whole axis length. We limit that to a minimum of 30 pixel, so that labels close to the border will
                // still be visible inside of the chart padding.
                labelLength = Math.max(this.axisLength - projectedValue, 30);
                // Skip grid lines and labels where interpolated label values are falsey (execpt for 0)
                if (Chartist.isFalseyButZero(labelValues[index]) && labelValues[index] !== '') return;
                // Transform to global coordinates using the chartRect
                // We also need to set the label offset for the createLabel function
                if (this.units.pos === 'x') {
                    projectedValue = this.chartRect.x1 + projectedValue;
                    labelOffset.x = chartOptions.axisX.labelOffset.x;
                    // If the labels should be positioned in start position (top side for vertical axis) we need to set a
                    // different offset as for positioned with end (bottom)
                    if (chartOptions.axisX.position === 'start') labelOffset.y = this.chartRect.padding.top + chartOptions.axisX.labelOffset.y + (useForeignObject ? 5 : 20);
                    else labelOffset.y = this.chartRect.y1 + chartOptions.axisX.labelOffset.y + (useForeignObject ? 5 : 20);
                } else {
                    projectedValue = this.chartRect.y1 - projectedValue;
                    labelOffset.y = chartOptions.axisY.labelOffset.y - (useForeignObject ? labelLength : 0);
                    // If the labels should be positioned in start position (left side for horizontal axis) we need to set a
                    // different offset as for positioned with end (right side)
                    if (chartOptions.axisY.position === 'start') labelOffset.x = useForeignObject ? this.chartRect.padding.left + chartOptions.axisY.labelOffset.x : this.chartRect.x1 - 10;
                    else labelOffset.x = this.chartRect.x2 + chartOptions.axisY.labelOffset.x + 10;
                }
                if (axisOptions.showGrid) Chartist.createGrid(projectedValue, index, this, this.gridOffset, this.chartRect[this.counterUnits.len](), gridGroup, [
                    chartOptions.classNames.grid,
                    chartOptions.classNames[this.units.dir]
                ], eventEmitter);
                if (axisOptions.showLabel) Chartist.createLabel(projectedValue, labelLength, index, labelValues, this, axisOptions.offset, labelOffset, labelGroup, [
                    chartOptions.classNames.label,
                    chartOptions.classNames[this.units.dir],
                    chartOptions.classNames[axisOptions.position]
                ], useForeignObject, eventEmitter);
            }).bind(this));
        }
        Chartist.Axis = Chartist.Class.extend({
            constructor: Axis,
            createGridAndLabels: createGridAndLabels,
            projectValue: function(value, index, data) {
                throw new Error('Base axis can\'t be instantiated!');
            }
        });
        Chartist.Axis.units = axisUnits;
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        function AutoScaleAxis(axisUnit, data, chartRect, options) {
            // Usually we calculate highLow based on the data but this can be overriden by a highLow object in the options
            var highLow = options.highLow || Chartist.getHighLow(data.normalized, options, axisUnit.pos);
            this.bounds = Chartist.getBounds(chartRect[axisUnit.rectEnd] - chartRect[axisUnit.rectStart], highLow, options.scaleMinSpace || 20, options.onlyInteger);
            this.range = {
                min: this.bounds.min,
                max: this.bounds.max
            };
            Chartist.AutoScaleAxis.super.constructor.call(this, axisUnit, chartRect, this.bounds.values, options);
        }
        function projectValue(value) {
            return this.axisLength * (+Chartist.getMultiValue(value, this.units.pos) - this.bounds.min) / this.bounds.range;
        }
        Chartist.AutoScaleAxis = Chartist.Axis.extend({
            constructor: AutoScaleAxis,
            projectValue: projectValue
        });
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        function FixedScaleAxis(axisUnit, data, chartRect, options) {
            var highLow = options.highLow || Chartist.getHighLow(data.normalized, options, axisUnit.pos);
            this.divisor = options.divisor || 1;
            this.ticks = options.ticks || Chartist.times(this.divisor).map((function(value, index) {
                return highLow.low + (highLow.high - highLow.low) / this.divisor * index;
            }).bind(this));
            this.ticks.sort(function(a, b) {
                return a - b;
            });
            this.range = {
                min: highLow.low,
                max: highLow.high
            };
            Chartist.FixedScaleAxis.super.constructor.call(this, axisUnit, chartRect, this.ticks, options);
            this.stepLength = this.axisLength / this.divisor;
        }
        function projectValue(value) {
            return this.axisLength * (+Chartist.getMultiValue(value, this.units.pos) - this.range.min) / (this.range.max - this.range.min);
        }
        Chartist.FixedScaleAxis = Chartist.Axis.extend({
            constructor: FixedScaleAxis,
            projectValue: projectValue
        });
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        function StepAxis(axisUnit, data, chartRect, options) {
            Chartist.StepAxis.super.constructor.call(this, axisUnit, chartRect, options.ticks, options);
            this.stepLength = this.axisLength / (options.ticks.length - (options.stretch ? 1 : 0));
        }
        function projectValue(value, index) {
            return this.stepLength * index;
        }
        Chartist.StepAxis = Chartist.Axis.extend({
            constructor: StepAxis,
            projectValue: projectValue
        });
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        /**
   * Default options in line charts. Expand the code view to see a detailed list of options with comments.
   *
   * @memberof Chartist.Line
   */ var defaultOptions = {
            // Options for X-Axis
            axisX: {
                // The offset of the labels to the chart area
                offset: 30,
                // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
                position: 'end',
                // Allows you to correct label positioning on this axis by positive or negative x and y offset.
                labelOffset: {
                    x: 0,
                    y: 0
                },
                // If labels should be shown or not
                showLabel: true,
                // If the axis grid should be drawn or not
                showGrid: true,
                // Interpolation function that allows you to intercept the value from the axis label
                labelInterpolationFnc: Chartist.noop,
                // Set the axis type to be used to project values on this axis. If not defined, Chartist.StepAxis will be used for the X-Axis, where the ticks option will be set to the labels in the data and the stretch option will be set to the global fullWidth option. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
                type: undefined
            },
            // Options for Y-Axis
            axisY: {
                // The offset of the labels to the chart area
                offset: 40,
                // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
                position: 'start',
                // Allows you to correct label positioning on this axis by positive or negative x and y offset.
                labelOffset: {
                    x: 0,
                    y: 0
                },
                // If labels should be shown or not
                showLabel: true,
                // If the axis grid should be drawn or not
                showGrid: true,
                // Interpolation function that allows you to intercept the value from the axis label
                labelInterpolationFnc: Chartist.noop,
                // Set the axis type to be used to project values on this axis. If not defined, Chartist.AutoScaleAxis will be used for the Y-Axis, where the high and low options will be set to the global high and low options. This type can be changed to any axis constructor available (e.g. Chartist.FixedScaleAxis), where all axis options should be present here.
                type: undefined,
                // This value specifies the minimum height in pixel of the scale steps
                scaleMinSpace: 20,
                // Use only integer values (whole numbers) for the scale steps
                onlyInteger: false
            },
            // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
            width: undefined,
            // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
            height: undefined,
            // If the line should be drawn or not
            showLine: true,
            // If dots should be drawn or not
            showPoint: true,
            // If the line chart should draw an area
            showArea: false,
            // The base for the area chart that will be used to close the area shape (is normally 0)
            areaBase: 0,
            // Specify if the lines should be smoothed. This value can be true or false where true will result in smoothing using the default smoothing interpolation function Chartist.Interpolation.cardinal and false results in Chartist.Interpolation.none. You can also choose other smoothing / interpolation functions available in the Chartist.Interpolation module, or write your own interpolation function. Check the examples for a brief description.
            lineSmooth: true,
            // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
            low: undefined,
            // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
            high: undefined,
            // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
            chartPadding: {
                top: 15,
                right: 15,
                bottom: 5,
                left: 10
            },
            // When set to true, the last grid line on the x-axis is not drawn and the chart elements will expand to the full available width of the chart. For the last label to be drawn correctly you might need to add chart padding or offset the last label with a draw event handler.
            fullWidth: false,
            // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
            reverseData: false,
            // Override the class names that get used to generate the SVG structure of the chart
            classNames: {
                chart: 'ct-chart-line',
                label: 'ct-label',
                labelGroup: 'ct-labels',
                series: 'ct-series',
                line: 'ct-line',
                point: 'ct-point',
                area: 'ct-area',
                grid: 'ct-grid',
                gridGroup: 'ct-grids',
                vertical: 'ct-vertical',
                horizontal: 'ct-horizontal',
                start: 'ct-start',
                end: 'ct-end'
            }
        };
        /**
   * Creates a new chart
   *
   */ function createChart(options) {
            this.data = Chartist.normalizeData(this.data);
            var data = {
                raw: this.data,
                normalized: Chartist.getDataArray(this.data, options.reverseData, true)
            };
            // Create new svg object
            this.svg = Chartist.createSvg(this.container, options.width, options.height, options.classNames.chart);
            // Create groups for labels, grid and series
            var gridGroup = this.svg.elem('g').addClass(options.classNames.gridGroup);
            var seriesGroup = this.svg.elem('g');
            var labelGroup = this.svg.elem('g').addClass(options.classNames.labelGroup);
            var chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);
            var axisX, axisY;
            if (options.axisX.type === undefined) axisX = new Chartist.StepAxis(Chartist.Axis.units.x, data, chartRect, Chartist.extend({}, options.axisX, {
                ticks: data.raw.labels,
                stretch: options.fullWidth
            }));
            else axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data, chartRect, options.axisX);
            if (options.axisY.type === undefined) axisY = new Chartist.AutoScaleAxis(Chartist.Axis.units.y, data, chartRect, Chartist.extend({}, options.axisY, {
                high: Chartist.isNum(options.high) ? options.high : options.axisY.high,
                low: Chartist.isNum(options.low) ? options.low : options.axisY.low
            }));
            else axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data, chartRect, options.axisY);
            axisX.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
            axisY.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
            // Draw the series
            data.raw.series.forEach((function(series, seriesIndex) {
                var seriesElement = seriesGroup.elem('g');
                // Write attributes to series group element. If series name or meta is undefined the attributes will not be written
                seriesElement.attr({
                    'ct:series-name': series.name,
                    'ct:meta': Chartist.serialize(series.meta)
                });
                // Use series class from series data or if not set generate one
                seriesElement.addClass([
                    options.classNames.series,
                    series.className || options.classNames.series + '-' + Chartist.alphaNumerate(seriesIndex)
                ].join(' '));
                var pathCoordinates = [], pathData = [];
                data.normalized[seriesIndex].forEach((function(value, valueIndex) {
                    var p = {
                        x: chartRect.x1 + axisX.projectValue(value, valueIndex, data.normalized[seriesIndex]),
                        y: chartRect.y1 - axisY.projectValue(value, valueIndex, data.normalized[seriesIndex])
                    };
                    pathCoordinates.push(p.x, p.y);
                    pathData.push({
                        value: value,
                        valueIndex: valueIndex,
                        meta: Chartist.getMetaData(series, valueIndex)
                    });
                }).bind(this));
                var seriesOptions = {
                    lineSmooth: Chartist.getSeriesOption(series, options, 'lineSmooth'),
                    showPoint: Chartist.getSeriesOption(series, options, 'showPoint'),
                    showLine: Chartist.getSeriesOption(series, options, 'showLine'),
                    showArea: Chartist.getSeriesOption(series, options, 'showArea'),
                    areaBase: Chartist.getSeriesOption(series, options, 'areaBase')
                };
                var smoothing = typeof seriesOptions.lineSmooth === 'function' ? seriesOptions.lineSmooth : seriesOptions.lineSmooth ? Chartist.Interpolation.monotoneCubic() : Chartist.Interpolation.none();
                // Interpolating path where pathData will be used to annotate each path element so we can trace back the original
                // index, value and meta data
                var path = smoothing(pathCoordinates, pathData);
                // If we should show points we need to create them now to avoid secondary loop
                // Points are drawn from the pathElements returned by the interpolation function
                // Small offset for Firefox to render squares correctly
                if (seriesOptions.showPoint) path.pathElements.forEach((function(pathElement) {
                    var point = seriesElement.elem('line', {
                        x1: pathElement.x,
                        y1: pathElement.y,
                        x2: pathElement.x + 0.01,
                        y2: pathElement.y
                    }, options.classNames.point).attr({
                        'ct:value': [
                            pathElement.data.value.x,
                            pathElement.data.value.y
                        ].filter(Chartist.isNum).join(','),
                        'ct:meta': pathElement.data.meta
                    });
                    this.eventEmitter.emit('draw', {
                        type: 'point',
                        value: pathElement.data.value,
                        index: pathElement.data.valueIndex,
                        meta: pathElement.data.meta,
                        series: series,
                        seriesIndex: seriesIndex,
                        axisX: axisX,
                        axisY: axisY,
                        group: seriesElement,
                        element: point,
                        x: pathElement.x,
                        y: pathElement.y
                    });
                }).bind(this));
                if (seriesOptions.showLine) {
                    var line = seriesElement.elem('path', {
                        d: path.stringify()
                    }, options.classNames.line, true);
                    this.eventEmitter.emit('draw', {
                        type: 'line',
                        values: data.normalized[seriesIndex],
                        path: path.clone(),
                        chartRect: chartRect,
                        index: seriesIndex,
                        series: series,
                        seriesIndex: seriesIndex,
                        axisX: axisX,
                        axisY: axisY,
                        group: seriesElement,
                        element: line
                    });
                }
                // Area currently only works with axes that support a range!
                if (seriesOptions.showArea && axisY.range) {
                    // If areaBase is outside the chart area (< min or > max) we need to set it respectively so that
                    // the area is not drawn outside the chart area.
                    var areaBase = Math.max(Math.min(seriesOptions.areaBase, axisY.range.max), axisY.range.min);
                    // We project the areaBase value into screen coordinates
                    var areaBaseProjected = chartRect.y1 - axisY.projectValue(areaBase);
                    // In order to form the area we'll first split the path by move commands so we can chunk it up into segments
                    path.splitByCommand('M').filter(function onlySolidSegments(pathSegment) {
                        // We filter only "solid" segments that contain more than one point. Otherwise there's no need for an area
                        return pathSegment.pathElements.length > 1;
                    }).map(function convertToArea(solidPathSegments) {
                        // Receiving the filtered solid path segments we can now convert those segments into fill areas
                        var firstElement = solidPathSegments.pathElements[0];
                        var lastElement = solidPathSegments.pathElements[solidPathSegments.pathElements.length - 1];
                        // Cloning the solid path segment with closing option and removing the first move command from the clone
                        // We then insert a new move that should start at the area base and draw a straight line up or down
                        // at the end of the path we add an additional straight line to the projected area base value
                        // As the closing option is set our path will be automatically closed
                        return solidPathSegments.clone(true).position(0).remove(1).move(firstElement.x, areaBaseProjected).line(firstElement.x, firstElement.y).position(solidPathSegments.pathElements.length + 1).line(lastElement.x, areaBaseProjected);
                    }).forEach((function createArea(areaPath) {
                        // For each of our newly created area paths, we'll now create path elements by stringifying our path objects
                        // and adding the created DOM elements to the correct series group
                        var area = seriesElement.elem('path', {
                            d: areaPath.stringify()
                        }, options.classNames.area, true);
                        // Emit an event for each area that was drawn
                        this.eventEmitter.emit('draw', {
                            type: 'area',
                            values: data.normalized[seriesIndex],
                            path: areaPath.clone(),
                            series: series,
                            seriesIndex: seriesIndex,
                            axisX: axisX,
                            axisY: axisY,
                            chartRect: chartRect,
                            index: seriesIndex,
                            group: seriesElement,
                            element: area
                        });
                    }).bind(this));
                }
            }).bind(this));
            this.eventEmitter.emit('created', {
                bounds: axisY.bounds,
                chartRect: chartRect,
                axisX: axisX,
                axisY: axisY,
                svg: this.svg,
                options: options
            });
        }
        /**
   * This method creates a new line chart.
   *
   * @memberof Chartist.Line
   * @param {String|Node} query A selector query string or directly a DOM element
   * @param {Object} data The data object that needs to consist of a labels and a series array
   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   * @return {Object} An object which exposes the API for the created chart
   *
   * @example
   * // Create a simple line chart
   * var data = {
   *   // A labels array that can contain any sort of values
   *   labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
   *   // Our series array that contains series objects or in this case series data arrays
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // As options we currently only set a static size of 300x200 px
   * var options = {
   *   width: '300px',
   *   height: '200px'
   * };
   *
   * // In the global name space Chartist we call the Line function to initialize a line chart. As a first parameter we pass in a selector where we would like to get our chart created. Second parameter is the actual data object and as a third parameter we pass in our options
   * new Chartist.Line('.ct-chart', data, options);
   *
   * @example
   * // Use specific interpolation function with configuration from the Chartist.Interpolation module
   *
   * var chart = new Chartist.Line('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5],
   *   series: [
   *     [1, 1, 8, 1, 7]
   *   ]
   * }, {
   *   lineSmooth: Chartist.Interpolation.cardinal({
   *     tension: 0.2
   *   })
   * });
   *
   * @example
   * // Create a line chart with responsive options
   *
   * var data = {
   *   // A labels array that can contain any sort of values
   *   labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
   *   // Our series array that contains series objects or in this case series data arrays
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // In addition to the regular options we specify responsive option overrides that will override the default configutation based on the matching media queries.
   * var responsiveOptions = [
   *   ['screen and (min-width: 641px) and (max-width: 1024px)', {
   *     showPoint: false,
   *     axisX: {
   *       labelInterpolationFnc: function(value) {
   *         // Will return Mon, Tue, Wed etc. on medium screens
   *         return value.slice(0, 3);
   *       }
   *     }
   *   }],
   *   ['screen and (max-width: 640px)', {
   *     showLine: false,
   *     axisX: {
   *       labelInterpolationFnc: function(value) {
   *         // Will return M, T, W etc. on small screens
   *         return value[0];
   *       }
   *     }
   *   }]
   * ];
   *
   * new Chartist.Line('.ct-chart', data, null, responsiveOptions);
   *
   */ function Line(query, data, options, responsiveOptions) {
            Chartist.Line.super.constructor.call(this, query, data, defaultOptions, Chartist.extend({}, defaultOptions, options), responsiveOptions);
        }
        // Creating line chart type in Chartist namespace
        Chartist.Line = Chartist.Base.extend({
            constructor: Line,
            createChart: createChart
        });
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        /**
   * Default options in bar charts. Expand the code view to see a detailed list of options with comments.
   *
   * @memberof Chartist.Bar
   */ var defaultOptions = {
            // Options for X-Axis
            axisX: {
                // The offset of the chart drawing area to the border of the container
                offset: 30,
                // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
                position: 'end',
                // Allows you to correct label positioning on this axis by positive or negative x and y offset.
                labelOffset: {
                    x: 0,
                    y: 0
                },
                // If labels should be shown or not
                showLabel: true,
                // If the axis grid should be drawn or not
                showGrid: true,
                // Interpolation function that allows you to intercept the value from the axis label
                labelInterpolationFnc: Chartist.noop,
                // This value specifies the minimum width in pixel of the scale steps
                scaleMinSpace: 30,
                // Use only integer values (whole numbers) for the scale steps
                onlyInteger: false
            },
            // Options for Y-Axis
            axisY: {
                // The offset of the chart drawing area to the border of the container
                offset: 40,
                // Position where labels are placed. Can be set to `start` or `end` where `start` is equivalent to left or top on vertical axis and `end` is equivalent to right or bottom on horizontal axis.
                position: 'start',
                // Allows you to correct label positioning on this axis by positive or negative x and y offset.
                labelOffset: {
                    x: 0,
                    y: 0
                },
                // If labels should be shown or not
                showLabel: true,
                // If the axis grid should be drawn or not
                showGrid: true,
                // Interpolation function that allows you to intercept the value from the axis label
                labelInterpolationFnc: Chartist.noop,
                // This value specifies the minimum height in pixel of the scale steps
                scaleMinSpace: 20,
                // Use only integer values (whole numbers) for the scale steps
                onlyInteger: false
            },
            // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
            width: undefined,
            // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
            height: undefined,
            // Overriding the natural high of the chart allows you to zoom in or limit the charts highest displayed value
            high: undefined,
            // Overriding the natural low of the chart allows you to zoom in or limit the charts lowest displayed value
            low: undefined,
            // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
            chartPadding: {
                top: 15,
                right: 15,
                bottom: 5,
                left: 10
            },
            // Specify the distance in pixel of bars in a group
            seriesBarDistance: 15,
            // If set to true this property will cause the series bars to be stacked. Check the `stackMode` option for further stacking options.
            stackBars: false,
            // If set to 'overlap' this property will force the stacked bars to draw from the zero line.
            // If set to 'accumulate' this property will form a total for each series point. This will also influence the y-axis and the overall bounds of the chart. In stacked mode the seriesBarDistance property will have no effect.
            stackMode: 'accumulate',
            // Inverts the axes of the bar chart in order to draw a horizontal bar chart. Be aware that you also need to invert your axis settings as the Y Axis will now display the labels and the X Axis the values.
            horizontalBars: false,
            // If set to true then each bar will represent a series and the data array is expected to be a one dimensional array of data values rather than a series array of series. This is useful if the bar chart should represent a profile rather than some data over time.
            distributeSeries: false,
            // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
            reverseData: false,
            // Override the class names that get used to generate the SVG structure of the chart
            classNames: {
                chart: 'ct-chart-bar',
                horizontalBars: 'ct-horizontal-bars',
                label: 'ct-label',
                labelGroup: 'ct-labels',
                series: 'ct-series',
                bar: 'ct-bar',
                grid: 'ct-grid',
                gridGroup: 'ct-grids',
                vertical: 'ct-vertical',
                horizontal: 'ct-horizontal',
                start: 'ct-start',
                end: 'ct-end'
            }
        };
        /**
   * Creates a new chart
   *
   */ function createChart(options) {
            this.data = Chartist.normalizeData(this.data);
            var data = {
                raw: this.data,
                normalized: options.distributeSeries ? Chartist.getDataArray(this.data, options.reverseData, options.horizontalBars ? 'x' : 'y').map(function(value) {
                    return [
                        value
                    ];
                }) : Chartist.getDataArray(this.data, options.reverseData, options.horizontalBars ? 'x' : 'y')
            };
            var highLow;
            // Create new svg element
            this.svg = Chartist.createSvg(this.container, options.width, options.height, options.classNames.chart + (options.horizontalBars ? ' ' + options.classNames.horizontalBars : ''));
            // Drawing groups in correct order
            var gridGroup = this.svg.elem('g').addClass(options.classNames.gridGroup);
            var seriesGroup = this.svg.elem('g');
            var labelGroup = this.svg.elem('g').addClass(options.classNames.labelGroup);
            if (options.stackBars && data.normalized.length !== 0) {
                // If stacked bars we need to calculate the high low from stacked values from each series
                var serialSums = Chartist.serialMap(data.normalized, function serialSums() {
                    return Array.prototype.slice.call(arguments).map(function(value) {
                        return value;
                    }).reduce(function(prev, curr) {
                        return {
                            x: prev.x + (curr && curr.x) || 0,
                            y: prev.y + (curr && curr.y) || 0
                        };
                    }, {
                        x: 0,
                        y: 0
                    });
                });
                highLow = Chartist.getHighLow([
                    serialSums
                ], Chartist.extend({}, options, {
                    referenceValue: 0
                }), options.horizontalBars ? 'x' : 'y');
            } else highLow = Chartist.getHighLow(data.normalized, Chartist.extend({}, options, {
                referenceValue: 0
            }), options.horizontalBars ? 'x' : 'y');
            // Overrides of high / low from settings
            highLow.high = +options.high || (options.high === 0 ? 0 : highLow.high);
            highLow.low = +options.low || (options.low === 0 ? 0 : highLow.low);
            var chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);
            var valueAxis, labelAxisTicks, labelAxis, axisX, axisY;
            // We need to set step count based on some options combinations
            if (options.distributeSeries && options.stackBars) // If distributed series are enabled and bars need to be stacked, we'll only have one bar and therefore should
            // use only the first label for the step axis
            labelAxisTicks = data.raw.labels.slice(0, 1);
            else // If distributed series are enabled but stacked bars aren't, we should use the series labels
            // If we are drawing a regular bar chart with two dimensional series data, we just use the labels array
            // as the bars are normalized
            labelAxisTicks = data.raw.labels;
            // Set labelAxis and valueAxis based on the horizontalBars setting. This setting will flip the axes if necessary.
            if (options.horizontalBars) {
                if (options.axisX.type === undefined) valueAxis = axisX = new Chartist.AutoScaleAxis(Chartist.Axis.units.x, data, chartRect, Chartist.extend({}, options.axisX, {
                    highLow: highLow,
                    referenceValue: 0
                }));
                else valueAxis = axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data, chartRect, Chartist.extend({}, options.axisX, {
                    highLow: highLow,
                    referenceValue: 0
                }));
                if (options.axisY.type === undefined) labelAxis = axisY = new Chartist.StepAxis(Chartist.Axis.units.y, data, chartRect, {
                    ticks: labelAxisTicks
                });
                else labelAxis = axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data, chartRect, options.axisY);
            } else {
                if (options.axisX.type === undefined) labelAxis = axisX = new Chartist.StepAxis(Chartist.Axis.units.x, data, chartRect, {
                    ticks: labelAxisTicks
                });
                else labelAxis = axisX = options.axisX.type.call(Chartist, Chartist.Axis.units.x, data, chartRect, options.axisX);
                if (options.axisY.type === undefined) valueAxis = axisY = new Chartist.AutoScaleAxis(Chartist.Axis.units.y, data, chartRect, Chartist.extend({}, options.axisY, {
                    highLow: highLow,
                    referenceValue: 0
                }));
                else valueAxis = axisY = options.axisY.type.call(Chartist, Chartist.Axis.units.y, data, chartRect, Chartist.extend({}, options.axisY, {
                    highLow: highLow,
                    referenceValue: 0
                }));
            }
            // Projected 0 point
            var zeroPoint = options.horizontalBars ? chartRect.x1 + valueAxis.projectValue(0) : chartRect.y1 - valueAxis.projectValue(0);
            // Used to track the screen coordinates of stacked bars
            var stackedBarValues = [];
            labelAxis.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
            valueAxis.createGridAndLabels(gridGroup, labelGroup, this.supportsForeignObject, options, this.eventEmitter);
            // Draw the series
            data.raw.series.forEach((function(series, seriesIndex) {
                // Calculating bi-polar value of index for seriesOffset. For i = 0..4 biPol will be -1.5, -0.5, 0.5, 1.5 etc.
                var biPol = seriesIndex - (data.raw.series.length - 1) / 2;
                // Half of the period width between vertical grid lines used to position bars
                var periodHalfLength;
                // Current series SVG element
                var seriesElement;
                // We need to set periodHalfLength based on some options combinations
                if (options.distributeSeries && !options.stackBars) // If distributed series are enabled but stacked bars aren't, we need to use the length of the normaizedData array
                // which is the series count and divide by 2
                periodHalfLength = labelAxis.axisLength / data.normalized.length / 2;
                else if (options.distributeSeries && options.stackBars) // If distributed series and stacked bars are enabled we'll only get one bar so we should just divide the axis
                // length by 2
                periodHalfLength = labelAxis.axisLength / 2;
                else // On regular bar charts we should just use the series length
                periodHalfLength = labelAxis.axisLength / data.normalized[seriesIndex].length / 2;
                // Adding the series group to the series element
                seriesElement = seriesGroup.elem('g');
                // Write attributes to series group element. If series name or meta is undefined the attributes will not be written
                seriesElement.attr({
                    'ct:series-name': series.name,
                    'ct:meta': Chartist.serialize(series.meta)
                });
                // Use series class from series data or if not set generate one
                seriesElement.addClass([
                    options.classNames.series,
                    series.className || options.classNames.series + '-' + Chartist.alphaNumerate(seriesIndex)
                ].join(' '));
                data.normalized[seriesIndex].forEach((function(value, valueIndex) {
                    var projected, bar, previousStack, labelAxisValueIndex;
                    // We need to set labelAxisValueIndex based on some options combinations
                    if (options.distributeSeries && !options.stackBars) // If distributed series are enabled but stacked bars aren't, we can use the seriesIndex for later projection
                    // on the step axis for label positioning
                    labelAxisValueIndex = seriesIndex;
                    else if (options.distributeSeries && options.stackBars) // If distributed series and stacked bars are enabled, we will only get one bar and therefore always use
                    // 0 for projection on the label step axis
                    labelAxisValueIndex = 0;
                    else // On regular bar charts we just use the value index to project on the label step axis
                    labelAxisValueIndex = valueIndex;
                    // We need to transform coordinates differently based on the chart layout
                    if (options.horizontalBars) projected = {
                        x: chartRect.x1 + valueAxis.projectValue(value && value.x ? value.x : 0, valueIndex, data.normalized[seriesIndex]),
                        y: chartRect.y1 - labelAxis.projectValue(value && value.y ? value.y : 0, labelAxisValueIndex, data.normalized[seriesIndex])
                    };
                    else projected = {
                        x: chartRect.x1 + labelAxis.projectValue(value && value.x ? value.x : 0, labelAxisValueIndex, data.normalized[seriesIndex]),
                        y: chartRect.y1 - valueAxis.projectValue(value && value.y ? value.y : 0, valueIndex, data.normalized[seriesIndex])
                    };
                    // If the label axis is a step based axis we will offset the bar into the middle of between two steps using
                    // the periodHalfLength value. Also we do arrange the different series so that they align up to each other using
                    // the seriesBarDistance. If we don't have a step axis, the bar positions can be chosen freely so we should not
                    // add any automated positioning.
                    if (labelAxis instanceof Chartist.StepAxis) {
                        // Offset to center bar between grid lines, but only if the step axis is not stretched
                        if (!labelAxis.options.stretch) projected[labelAxis.units.pos] += periodHalfLength * (options.horizontalBars ? -1 : 1);
                        // Using bi-polar offset for multiple series if no stacked bars or series distribution is used
                        projected[labelAxis.units.pos] += options.stackBars || options.distributeSeries ? 0 : biPol * options.seriesBarDistance * (options.horizontalBars ? -1 : 1);
                    }
                    // Enter value in stacked bar values used to remember previous screen value for stacking up bars
                    previousStack = stackedBarValues[valueIndex] || zeroPoint;
                    stackedBarValues[valueIndex] = previousStack - (zeroPoint - projected[labelAxis.counterUnits.pos]);
                    // Skip if value is undefined
                    if (value === undefined) return;
                    var positions = {};
                    positions[labelAxis.units.pos + '1'] = projected[labelAxis.units.pos];
                    positions[labelAxis.units.pos + '2'] = projected[labelAxis.units.pos];
                    if (options.stackBars && (options.stackMode === 'accumulate' || !options.stackMode)) {
                        // Stack mode: accumulate (default)
                        // If bars are stacked we use the stackedBarValues reference and otherwise base all bars off the zero line
                        // We want backwards compatibility, so the expected fallback without the 'stackMode' option
                        // to be the original behaviour (accumulate)
                        positions[labelAxis.counterUnits.pos + '1'] = previousStack;
                        positions[labelAxis.counterUnits.pos + '2'] = stackedBarValues[valueIndex];
                    } else {
                        // Draw from the zero line normally
                        // This is also the same code for Stack mode: overlap
                        positions[labelAxis.counterUnits.pos + '1'] = zeroPoint;
                        positions[labelAxis.counterUnits.pos + '2'] = projected[labelAxis.counterUnits.pos];
                    }
                    // Limit x and y so that they are within the chart rect
                    positions.x1 = Math.min(Math.max(positions.x1, chartRect.x1), chartRect.x2);
                    positions.x2 = Math.min(Math.max(positions.x2, chartRect.x1), chartRect.x2);
                    positions.y1 = Math.min(Math.max(positions.y1, chartRect.y2), chartRect.y1);
                    positions.y2 = Math.min(Math.max(positions.y2, chartRect.y2), chartRect.y1);
                    // Create bar element
                    bar = seriesElement.elem('line', positions, options.classNames.bar).attr({
                        'ct:value': [
                            value.x,
                            value.y
                        ].filter(Chartist.isNum).join(','),
                        'ct:meta': Chartist.getMetaData(series, valueIndex)
                    });
                    this.eventEmitter.emit('draw', Chartist.extend({
                        type: 'bar',
                        value: value,
                        index: valueIndex,
                        meta: Chartist.getMetaData(series, valueIndex),
                        series: series,
                        seriesIndex: seriesIndex,
                        axisX: axisX,
                        axisY: axisY,
                        chartRect: chartRect,
                        group: seriesElement,
                        element: bar
                    }, positions));
                }).bind(this));
            }).bind(this));
            this.eventEmitter.emit('created', {
                bounds: valueAxis.bounds,
                chartRect: chartRect,
                axisX: axisX,
                axisY: axisY,
                svg: this.svg,
                options: options
            });
        }
        /**
   * This method creates a new bar chart and returns API object that you can use for later changes.
   *
   * @memberof Chartist.Bar
   * @param {String|Node} query A selector query string or directly a DOM element
   * @param {Object} data The data object that needs to consist of a labels and a series array
   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   * @return {Object} An object which exposes the API for the created chart
   *
   * @example
   * // Create a simple bar chart
   * var data = {
   *   labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
   *   series: [
   *     [5, 2, 4, 2, 0]
   *   ]
   * };
   *
   * // In the global name space Chartist we call the Bar function to initialize a bar chart. As a first parameter we pass in a selector where we would like to get our chart created and as a second parameter we pass our data object.
   * new Chartist.Bar('.ct-chart', data);
   *
   * @example
   * // This example creates a bipolar grouped bar chart where the boundaries are limitted to -10 and 10
   * new Chartist.Bar('.ct-chart', {
   *   labels: [1, 2, 3, 4, 5, 6, 7],
   *   series: [
   *     [1, 3, 2, -5, -3, 1, -6],
   *     [-5, -2, -4, -1, 2, -3, 1]
   *   ]
   * }, {
   *   seriesBarDistance: 12,
   *   low: -10,
   *   high: 10
   * });
   *
   */ function Bar(query, data, options, responsiveOptions) {
            Chartist.Bar.super.constructor.call(this, query, data, defaultOptions, Chartist.extend({}, defaultOptions, options), responsiveOptions);
        }
        // Creating bar chart type in Chartist namespace
        Chartist.Bar = Chartist.Base.extend({
            constructor: Bar,
            createChart: createChart
        });
    })(window, document, Chartist);
    /* global Chartist */ (function(window1, document1, Chartist) {
        'use strict';
        /**
   * Default options in line charts. Expand the code view to see a detailed list of options with comments.
   *
   * @memberof Chartist.Pie
   */ var defaultOptions = {
            // Specify a fixed width for the chart as a string (i.e. '100px' or '50%')
            width: undefined,
            // Specify a fixed height for the chart as a string (i.e. '100px' or '50%')
            height: undefined,
            // Padding of the chart drawing area to the container element and labels as a number or padding object {top: 5, right: 5, bottom: 5, left: 5}
            chartPadding: 5,
            // Override the class names that are used to generate the SVG structure of the chart
            classNames: {
                chartPie: 'ct-chart-pie',
                chartDonut: 'ct-chart-donut',
                series: 'ct-series',
                slicePie: 'ct-slice-pie',
                sliceDonut: 'ct-slice-donut',
                label: 'ct-label'
            },
            // The start angle of the pie chart in degrees where 0 points north. A higher value offsets the start angle clockwise.
            startAngle: 0,
            // An optional total you can specify. By specifying a total value, the sum of the values in the series must be this total in order to draw a full pie. You can use this parameter to draw only parts of a pie or gauge charts.
            total: undefined,
            // If specified the donut CSS classes will be used and strokes will be drawn instead of pie slices.
            donut: false,
            // Specify the donut stroke width, currently done in javascript for convenience. May move to CSS styles in the future.
            // This option can be set as number or string to specify a relative width (i.e. 100 or '30%').
            donutWidth: 60,
            // If a label should be shown or not
            showLabel: true,
            // Label position offset from the standard position which is half distance of the radius. This value can be either positive or negative. Positive values will position the label away from the center.
            labelOffset: 0,
            // This option can be set to 'inside', 'outside' or 'center'. Positioned with 'inside' the labels will be placed on half the distance of the radius to the border of the Pie by respecting the 'labelOffset'. The 'outside' option will place the labels at the border of the pie and 'center' will place the labels in the absolute center point of the chart. The 'center' option only makes sense in conjunction with the 'labelOffset' option.
            labelPosition: 'inside',
            // An interpolation function for the label value
            labelInterpolationFnc: Chartist.noop,
            // Label direction can be 'neutral', 'explode' or 'implode'. The labels anchor will be positioned based on those settings as well as the fact if the labels are on the right or left side of the center of the chart. Usually explode is useful when labels are positioned far away from the center.
            labelDirection: 'neutral',
            // If true the whole data is reversed including labels, the series order as well as the whole series data arrays.
            reverseData: false,
            // If true empty values will be ignored to avoid drawing unncessary slices and labels
            ignoreEmptyValues: false
        };
        /**
   * Determines SVG anchor position based on direction and center parameter
   *
   * @param center
   * @param label
   * @param direction
   * @return {string}
   */ function determineAnchorPosition(center, label, direction) {
            var toTheRight = label.x > center.x;
            if (toTheRight && direction === 'explode' || !toTheRight && direction === 'implode') return 'start';
            else if (toTheRight && direction === 'implode' || !toTheRight && direction === 'explode') return 'end';
            else return 'middle';
        }
        /**
   * Creates the pie chart
   *
   * @param options
   */ function createChart(options) {
            this.data = Chartist.normalizeData(this.data);
            var seriesGroups = [], labelsGroup, chartRect, radius, labelRadius, totalDataSum, startAngle = options.startAngle, dataArray = Chartist.getDataArray(this.data, options.reverseData);
            // Create SVG.js draw
            this.svg = Chartist.createSvg(this.container, options.width, options.height, options.donut ? options.classNames.chartDonut : options.classNames.chartPie);
            // Calculate charting rect
            chartRect = Chartist.createChartRect(this.svg, options, defaultOptions.padding);
            // Get biggest circle radius possible within chartRect
            radius = Math.min(chartRect.width() / 2, chartRect.height() / 2);
            // Calculate total of all series to get reference value or use total reference from optional options
            totalDataSum = options.total || dataArray.reduce(function(previousValue, currentValue) {
                return previousValue + currentValue;
            }, 0);
            var donutWidth = Chartist.quantity(options.donutWidth);
            if (donutWidth.unit === '%') donutWidth.value *= radius / 100;
            // If this is a donut chart we need to adjust our radius to enable strokes to be drawn inside
            // Unfortunately this is not possible with the current SVG Spec
            // See this proposal for more details: http://lists.w3.org/Archives/Public/www-svg/2003Oct/0000.html
            radius -= options.donut ? donutWidth.value / 2 : 0;
            // If labelPosition is set to `outside` or a donut chart is drawn then the label position is at the radius,
            // if regular pie chart it's half of the radius
            if (options.labelPosition === 'outside' || options.donut) labelRadius = radius;
            else if (options.labelPosition === 'center') // If labelPosition is center we start with 0 and will later wait for the labelOffset
            labelRadius = 0;
            else // Default option is 'inside' where we use half the radius so the label will be placed in the center of the pie
            // slice
            labelRadius = radius / 2;
            // Add the offset to the labelRadius where a negative offset means closed to the center of the chart
            labelRadius += options.labelOffset;
            // Calculate end angle based on total sum and current data value and offset with padding
            var center = {
                x: chartRect.x1 + chartRect.width() / 2,
                y: chartRect.y2 + chartRect.height() / 2
            };
            // Check if there is only one non-zero value in the series array.
            var hasSingleValInSeries = this.data.series.filter(function(val) {
                return val.hasOwnProperty('value') ? val.value !== 0 : val !== 0;
            }).length === 1;
            //if we need to show labels we create the label group now
            if (options.showLabel) labelsGroup = this.svg.elem('g', null, null, true);
            // Draw the series
            // initialize series groups
            for(var i = 0; i < this.data.series.length; i++){
                // If current value is zero and we are ignoring empty values then skip to next value
                if (dataArray[i] === 0 && options.ignoreEmptyValues) continue;
                var series = this.data.series[i];
                seriesGroups[i] = this.svg.elem('g', null, null, true);
                // If the series is an object and contains a name or meta data we add a custom attribute
                seriesGroups[i].attr({
                    'ct:series-name': series.name
                });
                // Use series class from series data or if not set generate one
                seriesGroups[i].addClass([
                    options.classNames.series,
                    series.className || options.classNames.series + '-' + Chartist.alphaNumerate(i)
                ].join(' '));
                var endAngle = startAngle + dataArray[i] / totalDataSum * 360;
                // Use slight offset so there are no transparent hairline issues
                var overlappigStartAngle = Math.max(0, startAngle - (i === 0 || hasSingleValInSeries ? 0 : 0.2));
                // If we need to draw the arc for all 360 degrees we need to add a hack where we close the circle
                // with Z and use 359.99 degrees
                if (endAngle - overlappigStartAngle >= 359.99) endAngle = overlappigStartAngle + 359.99;
                var start = Chartist.polarToCartesian(center.x, center.y, radius, overlappigStartAngle), end = Chartist.polarToCartesian(center.x, center.y, radius, endAngle);
                // Create a new path element for the pie chart. If this isn't a donut chart we should close the path for a correct stroke
                var path = new Chartist.Svg.Path(!options.donut).move(end.x, end.y).arc(radius, radius, 0, endAngle - startAngle > 180, 0, start.x, start.y);
                // If regular pie chart (no donut) we add a line to the center of the circle for completing the pie
                if (!options.donut) path.line(center.x, center.y);
                // Create the SVG path
                // If this is a donut chart we add the donut class, otherwise just a regular slice
                var pathElement = seriesGroups[i].elem('path', {
                    d: path.stringify()
                }, options.donut ? options.classNames.sliceDonut : options.classNames.slicePie);
                // Adding the pie series value to the path
                pathElement.attr({
                    'ct:value': dataArray[i],
                    'ct:meta': Chartist.serialize(series.meta)
                });
                // If this is a donut, we add the stroke-width as style attribute
                if (options.donut) pathElement.attr({
                    'style': 'stroke-width: ' + donutWidth.value + 'px'
                });
                // Fire off draw event
                this.eventEmitter.emit('draw', {
                    type: 'slice',
                    value: dataArray[i],
                    totalDataSum: totalDataSum,
                    index: i,
                    meta: series.meta,
                    series: series,
                    group: seriesGroups[i],
                    element: pathElement,
                    path: path.clone(),
                    center: center,
                    radius: radius,
                    startAngle: startAngle,
                    endAngle: endAngle
                });
                // If we need to show labels we need to add the label for this slice now
                if (options.showLabel) {
                    // Position at the labelRadius distance from center and between start and end angle
                    var labelPosition = Chartist.polarToCartesian(center.x, center.y, labelRadius, startAngle + (endAngle - startAngle) / 2), interpolatedValue = options.labelInterpolationFnc(this.data.labels && !Chartist.isFalseyButZero(this.data.labels[i]) ? this.data.labels[i] : dataArray[i], i);
                    if (interpolatedValue || interpolatedValue === 0) {
                        var labelElement = labelsGroup.elem('text', {
                            dx: labelPosition.x,
                            dy: labelPosition.y,
                            'text-anchor': determineAnchorPosition(center, labelPosition, options.labelDirection)
                        }, options.classNames.label).text('' + interpolatedValue);
                        // Fire off draw event
                        this.eventEmitter.emit('draw', {
                            type: 'label',
                            index: i,
                            group: labelsGroup,
                            element: labelElement,
                            text: '' + interpolatedValue,
                            x: labelPosition.x,
                            y: labelPosition.y
                        });
                    }
                }
                // Set next startAngle to current endAngle.
                // (except for last slice)
                startAngle = endAngle;
            }
            this.eventEmitter.emit('created', {
                chartRect: chartRect,
                svg: this.svg,
                options: options
            });
        }
        /**
   * This method creates a new pie chart and returns an object that can be used to redraw the chart.
   *
   * @memberof Chartist.Pie
   * @param {String|Node} query A selector query string or directly a DOM element
   * @param {Object} data The data object in the pie chart needs to have a series property with a one dimensional data array. The values will be normalized against each other and don't necessarily need to be in percentage. The series property can also be an array of value objects that contain a value property and a className property to override the CSS class name for the series group.
   * @param {Object} [options] The options object with options that override the default options. Check the examples for a detailed list.
   * @param {Array} [responsiveOptions] Specify an array of responsive option arrays which are a media query and options object pair => [[mediaQueryString, optionsObject],[more...]]
   * @return {Object} An object with a version and an update method to manually redraw the chart
   *
   * @example
   * // Simple pie chart example with four series
   * new Chartist.Pie('.ct-chart', {
   *   series: [10, 2, 4, 3]
   * });
   *
   * @example
   * // Drawing a donut chart
   * new Chartist.Pie('.ct-chart', {
   *   series: [10, 2, 4, 3]
   * }, {
   *   donut: true
   * });
   *
   * @example
   * // Using donut, startAngle and total to draw a gauge chart
   * new Chartist.Pie('.ct-chart', {
   *   series: [20, 10, 30, 40]
   * }, {
   *   donut: true,
   *   donutWidth: 20,
   *   startAngle: 270,
   *   total: 200
   * });
   *
   * @example
   * // Drawing a pie chart with padding and labels that are outside the pie
   * new Chartist.Pie('.ct-chart', {
   *   series: [20, 10, 30, 40]
   * }, {
   *   chartPadding: 30,
   *   labelOffset: 50,
   *   labelDirection: 'explode'
   * });
   *
   * @example
   * // Overriding the class names for individual series as well as a name and meta data.
   * // The name will be written as ct:series-name attribute and the meta data will be serialized and written
   * // to a ct:meta attribute.
   * new Chartist.Pie('.ct-chart', {
   *   series: [{
   *     value: 20,
   *     name: 'Series 1',
   *     className: 'my-custom-class-one',
   *     meta: 'Meta One'
   *   }, {
   *     value: 10,
   *     name: 'Series 2',
   *     className: 'my-custom-class-two',
   *     meta: 'Meta Two'
   *   }, {
   *     value: 70,
   *     name: 'Series 3',
   *     className: 'my-custom-class-three',
   *     meta: 'Meta Three'
   *   }]
   * });
   */ function Pie(query, data, options, responsiveOptions) {
            Chartist.Pie.super.constructor.call(this, query, data, defaultOptions, Chartist.extend({}, defaultOptions, options), responsiveOptions);
        }
        // Creating pie chart type in Chartist namespace
        Chartist.Pie = Chartist.Base.extend({
            constructor: Pie,
            createChart: createChart,
            determineAnchorPosition: determineAnchorPosition
        });
    })(window, document, Chartist);
    return Chartist;
});



var $9c5La = parcelRequire("9c5La");

function $3e8a557931153bfc$var$template(locals) {
    var pug_html = "", pug_mixins = {}, pug_interp;
    var locals_for_with = locals || {};
    (function(transactions1) {
        pug_html = pug_html + "\u003Cdiv class=\"chart-overlay-wrapper\"\u003E\u003Cdiv class=\"chart-wrapper\"\u003E\u003Cdiv class=\"ct-chart transactions-chart\" data-hook=\"chart\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
        if (!transactions1.length) pug_html = pug_html + "\u003Cdiv class=\"chart-empty-overlay\"\u003ELeider sind noch keine Transaktionen vorhanden.\u003C\u002Fdiv\u003E";
        pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }).call(this, "transactions" in locals_for_with ? locals_for_with.transactions : typeof transactions !== 'undefined' ? transactions : undefined);
    return pug_html;
}
var $3e8a557931153bfc$export$2e2bcd8739ae039 = $3e8a557931153bfc$var$template;


const $0427a1eef35e6b20$var$Transactions = (0, (/*@__PURE__*/$parcel$interopDefault($d09b7d770c5b7340$exports))).extend({
    url () {
        return `/api/events/${(0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.currentEvent.slug}/dashboard/transactions`;
    },
    model: (0, (/*@__PURE__*/$parcel$interopDefault($kw3w9))).extend({
        props: {
            count: 'number',
            ivl: 'date'
        }
    })
});
var $0427a1eef35e6b20$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dM6Pc))).extend({
    template: $3e8a557931153bfc$export$2e2bcd8739ae039,
    events: {
        'mouseover .ct-point': 'showTooltip',
        'mouseout .ct-point': 'hideTooltip'
    },
    initialize () {
        this.transactions = new $0427a1eef35e6b20$var$Transactions();
        // delay re-rendering, becaus it takes a lot of compute time and
        // moving in the transit-bar takes precendence
        this.listenTo((0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).view, 'change:showTaskboard', ()=>{
            setTimeout(()=>this.render(), 2000);
        });
        this.listenTo(this.transactions, 'sync', this.render);
        this.transactions.fetch();
    },
    showTooltip (evt) {
        if (this.tooltip) return;
        const point = evt.target;
        this.tooltip = (0, $6445619a88c9e457$export$2e2bcd8739ae039)(evt.target, {
            trigger: 'manual',
            content: `${point.getAttribute('ct:value')} Transaktion(en)`
        });
        this.tooltip.show();
    },
    hideTooltip () {
        if (this.tooltip) {
            this.tooltip.destroy();
            this.tooltip = null;
        }
    },
    remove () {
        if (this.chart) this.chart.detach();
        return (0, (/*@__PURE__*/$parcel$interopDefault($dM6Pc))).prototype.remove.apply(this);
    },
    render () {
        this.renderWithTemplate();
        const chartEl = this.queryByHook('chart');
        chartEl.classList.toggle('chart-empty', !this.transactions.length);
        let labels = [];
        let values = [
            []
        ];
        if (this.transactions.length) {
            labels = this.transactions.map((t)=>{
                const ivl = (0, $9c5La.DateTime).fromJSDate(t.ivl);
                const end = (0, $9c5La.DateTime).fromJSDate(t.ivl).plus({
                    hours: 1
                }).toFormat('H');
                return `${ivl.toLocaleString({
                    day: 'numeric',
                    month: 'numeric'
                })}<br>${ivl.toFormat('H')} - ${end}h`;
            });
            if (labels.length > 20) labels = labels.map((label, i)=>i % 4 === 0 ? label : '');
            values = [
                this.transactions.map((t)=>t.count)
            ];
        } else for(let i = 0; i <= 10; i++){
            labels[i] = i;
            values[0][i] = Math.round(Math.random() * 100);
        }
        this.chart = new (0, (/*@__PURE__*/$parcel$interopDefault($2165df5d29a5d404$exports))).Line(chartEl, {
            labels: labels,
            series: values
        }, {
            height: 200,
            axisY: {
                low: 0
            },
            axisX: {
                showLabel: !!this.transactions.length
            },
            fullWidth: this.transactions.length > 1 || this.transactions.length === 0,
            chartPadding: {
                top: 15,
                right: 30,
                bottom: !this.transactions.length ? 0 : 20,
                left: 0
            }
        });
        return this;
    }
});


var $b6a623b54c5d5db8$require$TransactionsChart = $0427a1eef35e6b20$export$2e2bcd8739ae039;
var $9ed267afa873be1a$exports = {};

var $9ed267afa873be1a$require$tippy = $6445619a88c9e457$export$2e2bcd8739ae039;

var $dM6Pc = parcelRequire("dM6Pc");


$9ed267afa873be1a$exports = $dM6Pc.extend({
    template: (parcelRequire("bZdzP")).default,
    events: {
        'mouseover .ct-bar': 'showTooltip',
        'mouseout .ct-bar': 'hideTooltip'
    },
    initialize () {
        this.listenTo(this.collection, 'sync', this.render);
    },
    showTooltip (evt) {
        if (this.tooltip) return;
        const label = evt.target.getAttribute('label');
        const value = this.getValueById(evt.target.getAttribute('id'));
        this.tooltip = $9ed267afa873be1a$require$tippy(evt.target, {
            trigger: 'manual',
            content: `${label} ${value}%`,
            delay: 10
        });
        this.tooltip.show();
    },
    hideTooltip () {
        if (this.tooltip) {
            this.tooltip.destroy();
            this.tooltip = null;
        }
    },
    remove () {
        if (this.chart) this.chart.detach();
        return $dM6Pc.prototype.remove.apply(this);
    },
    getLabels () {
        return this.collection.map((item)=>item.product.name);
    },
    getValues () {
        return this.collection.map((item)=>{
            const value = Math.round(item.ratio * 100);
            // clip values
            if (value > 120) return 120;
            if (value < -20) return -20;
            return value;
        });
    },
    getValueById (id) {
        return Math.round(this.collection.get(id).ratio * 100);
    },
    renderChart () {
        const chartEl = this.queryByHook('chart');
        let labels = [];
        let values = [];
        chartEl.classList.toggle('chart-empty', !this.collection.length);
        if (this.collection.length) {
            labels = this.getLabels();
            values = this.getValues();
        } else for(let i = 0; i <= 20; i++){
            labels[i] = i;
            values[i] = Math.round(Math.random() * 100);
        }
        let i = 0;
        if (this.chart) this.chart.detach();
        // set width on element, otherwise firefox doesn't calculate the labels correctly
        const width = labels.length > 21 ? labels.length * 40 : undefined;
        if (width) chartEl.style.width = `${width}px`;
        this.chart = new $2165df5d29a5d404$exports.Bar(chartEl, {
            labels: labels,
            series: values
        }, {
            width: width,
            height: 250,
            chartPadding: {
                bottom: this.collection.length ? 35 : 0,
                left: 45,
                right: 45
            },
            axisX: {
                showGrid: false,
                showLabel: !!this.collection.length
            },
            axisY: {
                offset: 0,
                showLabel: false
            },
            high: 100,
            low: -20,
            distributeSeries: true
        }).on('draw', (ctx)=>{
            if (ctx.type === 'label') {
                // adjust label position for rotation
                const dX = ctx.width / 2 + (100 - ctx.width);
                ctx.element.attr({
                    x: ctx.element.attr('x') - dX
                });
            }
            if (ctx.type === 'bar') {
                // add corresponding labels for tooltips
                if (this.collection.length) ctx.element.attr({
                    id: this.collection.at(i).id,
                    label: labels[i]
                });
                // add warning classes
                const value = ctx.value.y;
                if (value <= 10 || value > 100) ctx.element.addClass('low');
                if (value > 10 && value < 25) ctx.element.addClass('warn');
                // reset counter when we're done, so it'll work on subsequent re-draws
                if (++i === labels.length) i = 0;
            }
        });
    },
    render () {
        this.renderWithTemplate();
        this.renderChart();
        return this;
    }
});


var $c1cb61f439d68010$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $4UX9c = parcelRequire("4UX9c");

$c1cb61f439d68010$exports = $dM6Pc.extend({
    template: (parcelRequire("h6NHq")).default,
    initialize () {
        this.bars = $4UX9c.locations.filter((location)=>location.type === 'bar').sort((a, b)=>b.sumSalesGrossValue - a.sumSalesGrossValue).slice(0, 10);
    }
});


var $3a48814d3ef8734b$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $lHBuJ = parcelRequire("lHBuJ");

var $56rtr = parcelRequire("56rtr");

var $4UX9c = parcelRequire("4UX9c");

var $gvQO6 = parcelRequire("gvQO6");
var $3a48814d3ef8734b$require$currency = $gvQO6.currency;
const $3a48814d3ef8734b$var$add = (a, b)=>a + b;

$3a48814d3ef8734b$exports = $dM6Pc.extend({
    template: (parcelRequire("fEqzj")).default,
    initialize () {
        const items = $lHBuJ($4UX9c.locations.filter((location)=>location.type === 'bar').map((location)=>location.stock.models));
        const groups = $56rtr(items, (item)=>item.product.id);
        this.products = Object.keys(groups).map((id)=>{
            const sum = groups[id].map((item)=>item.salesGross).reduce($3a48814d3ef8734b$var$add);
            return {
                id: id,
                name: $4UX9c.products.get(id).name,
                sumLocalized: $3a48814d3ef8734b$require$currency(sum),
                sum: sum
            };
        }).sort((a, b)=>b.sum - a.sum);
    }
});



const $b6a623b54c5d5db8$var$ItemView = $dM6Pc.extend({
    template: (parcelRequire("1d2Kg")).default
});

const $b6a623b54c5d5db8$var$ProductDetails = $dM6Pc.extend($58326cbefe1a452a$exports, {
    template: (parcelRequire("1O1OG")).default,
    subviews: {
        list: {
            hook: 'list',
            prepareView (el) {
                return this.renderCollection(this.collection, $b6a623b54c5d5db8$var$ItemView, el);
            }
        },
        searchBar: {
            hook: 'search-bar',
            prepareView (el) {
                return new $faf64da9e05fa3b7$exports({
                    el: el,
                    parent: this
                });
            }
        }
    },
    initialize () {
        this.initSortableTable(this.collection.state);
    },
    events: $akRxj({}, $58326cbefe1a452a$exports.events, {
        'click [data-hook="sort-ratio"]': 'sortByRatio',
        'click [data-hook="sort-delivery"]': 'sortByDelivery'
    }),
    setComparator (comparator) {
        this.collection.setComparator(comparator);
    },
    // this will be called by SearchBarView
    search (query) {
        this.collection.byName(query);
    }
});

$b6a623b54c5d5db8$exports = $dM6Pc.extend({
    title: "\xdcbersicht",
    template: (parcelRequire("6zQ33")).default,
    events: {
        'click [data-hook="toggle-product-details"]': 'toggleProductDetails'
    },
    props: {
        showProductDetails: [
            'boolean',
            true,
            false
        ],
        isAdmin: $b6a623b54c5d5db8$require$isAdminProp
    },
    derived: {
        buttonText: {
            deps: [
                'showProductDetails'
            ],
            fn () {
                return this.showProductDetails ? 'Details ausblenden...' : 'Details einblenden...';
            }
        }
    },
    bindings: {
        buttonText: {
            hook: 'toggle-product-details'
        }
    },
    subviews: {
        productsChart: {
            hook: 'products',
            prepareView (el) {
                return new $9ed267afa873be1a$exports({
                    el: el,
                    collection: this.products
                });
            }
        },
        bestBars: {
            hook: 'best-bars',
            constructor: $c1cb61f439d68010$exports
        },
        bestProducts: {
            hook: 'best-products',
            constructor: $3a48814d3ef8734b$exports
        },
        transactionsChart: {
            hook: 'transactions',
            constructor: $b6a623b54c5d5db8$require$TransactionsChart
        }
    },
    initialize () {
        this.products = new $f8d2d6515d3b54cf$exports();
        this.products.fetch();
    },
    toggleProductDetails (evt) {
        evt.preventDefault();
        this.toggle('showProductDetails');
        if (this.showProductDetails) {
            this.productDetails = new $b6a623b54c5d5db8$var$ProductDetails({
                collection: this.products
            });
            // this.productLocations = new ProductsLocations({ collection: this.products })
            this.renderSubview(this.productDetails, this.queryByHook('product-details'));
        // this.renderSubview(this.productLocations, this.queryByHook('product-locations'))
        } else {
            this.productDetails.remove();
            this.productLocations.remove();
        }
    }
});


var $4fce4e49c3e9d8e4$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $4UX9c = parcelRequire("4UX9c");

var $d2ceeb5ed897a9c6$exports = {};

var $4UX9c = parcelRequire("4UX9c");


var $gvQO6 = parcelRequire("gvQO6");
var $d2ceeb5ed897a9c6$require$indexify = $gvQO6.indexify;

$d2ceeb5ed897a9c6$exports = $d09b7d770c5b7340$exports.extend({
    url () {
        return `/api/events/${$4UX9c.me.currentEvent.slug}/locations/${this.location.id}/inventories`;
    },
    model: (parcelRequire("a3kEa")).default,
    comparator: 'shiftEndTime',
    ajaxConfig () {
        return {
            xhrFields: {
                timeout: 30000
            }
        };
    },
    initialize (data, opts) {
        this.filtered = false;
        this.location = opts.location;
    },
    serializeToStorage () {
        // serialize session props as well
        return this.map((model)=>model.getAttributes({
                props: true,
                session: true
            }));
    },
    byName (searchTerm) {
        const term = $d2ceeb5ed897a9c6$require$indexify(searchTerm);
        // save unfiltered models for later
        if (!this.filtered) this._originalModels = this.models;
        // reset search
        if (!term) {
            this.reset(this._originalModels);
            this.filtered = false;
            return;
        }
        if (term.length < 2) return;
        // filter original models
        const filtered = this._originalModels.filter((inv)=>inv._nameIndex.indexOf(term) > -1);
        this.reset(filtered);
        this.filtered = true;
    }
});



const $4fce4e49c3e9d8e4$var$ListItemView = $dM6Pc.extend({
    template: (parcelRequire("lW2Q8")).default,
    derived: {
        baseUrl: {
            cache: false,
            fn () {
                if (this.model.location.type === 'storage' || this.model.location.type === 'crash') return `/lager/${this.model.location.slug}/inventuren/${this.model.id}`;
                return `/bars/${this.model.location.slug}/inventuren/${this.model.id}`;
            }
        },
        editUrl: {
            cache: false,
            deps: [
                'baseUrl'
            ],
            fn () {
                return `${this.baseUrl}/edit`;
            }
        }
    }
});

$4fce4e49c3e9d8e4$exports = $dM6Pc.extend({
    template: (parcelRequire("gsfN1")).default,
    title () {
        return `Inventuren ${this.model.name}`;
    },
    derived: {
        exportUrl: {
            cache: false,
            fn () {
                return `/api/events/${$4UX9c.me.currentEvent.slug}/locations/${this.model.id}/inventories/export`;
            }
        }
    },
    events: {
        'click [data-hook=create-inventory]': 'createNew'
    },
    subviews: {
        searchBar: {
            hook: 'search-bar',
            prepareView (el) {
                return new $faf64da9e05fa3b7$exports({
                    el: el,
                    parent: this,
                    placeholder: 'Schichtname'
                });
            }
        },
        list: {
            hook: 'list',
            prepareView (el) {
                return this.renderCollection(this.collection, $4fce4e49c3e9d8e4$var$ListItemView, el);
            }
        }
    },
    initialize () {
        this.collection = new $d2ceeb5ed897a9c6$exports(null, {
            location: this.model
        });
        this.collection.fetch();
    },
    // will be called by SearchBarView
    search (query) {
        this.collection.byName(query);
    },
    createNew () {
        if (this.model.type === 'storage' || this.model.type === 'crash') $4UX9c.navigate(`/lager/${this.model.slug}/inventuren/neu`);
        else $4UX9c.navigate(`/bars/${this.model.slug}/inventuren/neu`);
    }
});


var $53d45143ddd13ce5$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $ab3a15abb20cc116$exports = {};

var $a3kEa = parcelRequire("a3kEa");
var $ab3a15abb20cc116$require$StockTaking = $a3kEa.default;
var $18a80c50f2b1a87e$exports = {};

var $kbVTi = parcelRequire("kbVTi");

var $4UX9c = parcelRequire("4UX9c");

var $gvQO6 = parcelRequire("gvQO6");
var $18a80c50f2b1a87e$require$byStockSortPosition = $gvQO6.byStockSortPosition;
var $18a80c50f2b1a87e$require$indexify = $gvQO6.indexify;
var $18a80c50f2b1a87e$require$byStockNameAsc = $gvQO6.byStockNameAsc;

$18a80c50f2b1a87e$exports = $kbVTi.extend({
    url () {
        return `/api/events/${$4UX9c.me.currentEvent.slug}/locations/${this.locationId}/inventories`;
    },
    model: (parcelRequire("hw8gc")),
    comparator: $18a80c50f2b1a87e$require$byStockNameAsc,
    mainIndex: 'productId',
    initialize () {
        this.filtered = false;
    },
    /**
   * @param {'sortPosition' | 'name'} prop
   */ sortBy (prop) {
        this.comparator = prop === 'sortPosition' ? $18a80c50f2b1a87e$require$byStockSortPosition : $18a80c50f2b1a87e$require$byStockNameAsc;
        this.sort();
    },
    byName (searchTerm) {
        const term = $18a80c50f2b1a87e$require$indexify(searchTerm);
        // save unfiltered models for later
        if (!this.filtered) this._originalModels = this.models;
        // reset search
        if (!term) {
            this.reset(this._originalModels);
            this.filtered = false;
            return;
        }
        if (term.length < 2) return;
        // filter original models
        const filtered = this._originalModels.filter((item)=>{
            return item.product._nameIndex.indexOf(term) > -1;
        });
        this.reset(filtered);
        this.filtered = true;
    }
});


$ab3a15abb20cc116$exports = $ab3a15abb20cc116$require$StockTaking.extend({
    collections: {
        items: $18a80c50f2b1a87e$exports
    },
    initialize () {
        this.listenToAndRun(this.items, 'change:unitsSold', this.onChange);
        this.listenToAndRun(this, 'change:tokens', this.onChange);
    },
    prefill (shiftName) {
        this.shiftName = shiftName;
        this.items.each((item)=>{
            item.inputUnits = Math.round(item.stockUnits % item.product.packageSize * 100) / 100;
            const packages = item.stockUnits / item.product.packageSize;
            item.inputPackages = item.stockUnits < 0 ? Math.ceil(packages) : Math.floor(packages);
        });
    },
    onChange () {
        this.sumSold = this.items.map((item)=>item.unitsSold * item.product.pricePerUnit).reduce((a, b)=>a + b, 0);
    }
});


var $3b40619e8fdf3abf$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");


$3b40619e8fdf3abf$exports = $dM6Pc.extend({
    template: (parcelRequire("imxrQ")).default,
    events: {
        'keyup input[name="shiftName"]': 'onKeyup'
    },
    bindings: {
        'model.shiftName': {
            type: 'value',
            selector: '[name=shiftName]'
        }
    },
    subviews: {
        datePicker: {
            hook: 'date-picker',
            prepareView (el) {
                const view = new $bb0eb7f84d18deb3$exports({
                    el: el,
                    initialValue: this.model.shiftEndTime
                });
                this.listenTo(view, 'change:inputValue', this.onDateChange);
                return view;
            }
        }
    },
    initialize () {
        this.listenTo(this.model, 'sync', this.resetDate);
    },
    onKeyup (evt) {
        this.model.shiftName = evt.target.value;
    },
    resetDate () {
        this.datePicker.inputValue = this.model.shiftEndTime;
    },
    onDateChange (view, date) {
        this.model.shiftEndTime = date;
    }
});


var $f6e210aabd38f794$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $4UX9c = parcelRequire("4UX9c");

$f6e210aabd38f794$exports = $dM6Pc.extend({
    template: (parcelRequire("gVm2J")).default,
    events: {
        'keyup input': 'onKeyup',
        'change input': 'onKeyup',
        'click [data-hook=cancel]': 'onCancel',
        'blur textarea': 'onBlur',
        submit: 'onSubmit'
    },
    bindings: {
        'model.tokens': {
            hook: 'tokens'
        },
        'model.tokensLocalized': {
            hook: 'tokens-localized'
        },
        'model.salesWithoutTokensLocalized': {
            hook: 'sales-without-tokens'
        },
        'model.sumSoldLocalized': {
            hook: 'sum-sold'
        },
        'model.differenceWithoutTokensLocalized': {
            hook: 'difference'
        },
        'model.isDifferenceNegative': {
            type: 'booleanClass',
            name: 'error',
            hook: 'difference'
        },
        'model.isSumSoldNegative': [
            {
                type: 'booleanClass',
                name: 'error',
                hook: 'sum-sold'
            },
            {
                type: 'booleanClass',
                name: 'error',
                hook: 'sales-without-tokens'
            }
        ]
    },
    derived: {
        isAdmin: {
            cache: false,
            fn () {
                return $4UX9c.me.role === 'admin';
            }
        }
    },
    initialize () {
        this.listenTo(this.model, 'sync', this.render);
        this.listenTo(this.model, 'change', this.onChange);
        this.listenTo(this.model, 'request', this.onRequest);
        this.listenTo(this.model, 'error', this.onError);
    },
    onChange (model) {
        this.queryByHook('submit').disabled = !model.isValid();
    },
    onKeyup (event) {
        const isNumber = event.target.type === 'number' && event.target.name !== 'amountGiven';
        const val = isNumber ? event.target.value - 0 : event.target.value;
        this.model.set(event.target.name, val);
    },
    onBlur (event) {
        this.model.set('comment', event.target.value);
    },
    onCancel (event) {
        event.preventDefault();
        $4UX9c.navigate(this.parent.backUrl);
    },
    remove () {
        clearTimeout(this.pulsing);
        return $dM6Pc.prototype.remove.apply(this);
    },
    onRequest () {
        this.pulsing = setTimeout(()=>{
            this.queryByHook('submit').classList.add('animated', 'pulse', 'infinite');
        }, 1000);
        this.queryByHook('submit').disabled = true;
        this.queryByHook('cancel').disabled = true;
    },
    onError (model, err) {
        clearTimeout(this.pulsing);
        console.error(err);
        this.queryByHook('submit').classList.remove('animated', 'pulse', 'infinite');
        this.queryByHook('submit').disabled = false;
        this.queryByHook('cancel').disabled = false;
    },
    onSubmit (event) {
        event.preventDefault();
        this.listenToOnce(this.model, 'sync', ()=>$4UX9c.navigate(this.parent.backUrl));
        this.model.save();
    }
});


var $959ec01bdc9006d9$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");
var $0cda192b820fed87$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");
var $7c434a0940cbcea1$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

$7c434a0940cbcea1$exports = $dM6Pc.extend({
    template: (parcelRequire("ijmVO")).default,
    events: {
        'keyup input': 'onKeyUp',
        'change input': 'onKeyUp',
        'click [data-hook="remove-weight"]': 'removeModel'
    },
    removeModel (evt) {
        evt.preventDefault();
        this.model.collection.remove(this.model);
    },
    onKeyUp (evt) {
        evt.stopPropagation();
        if (!evt.target.value) return;
        this.model.value = +evt.target.value;
    }
});


// parse and add up strings like "0.2 + 0,4 +  1,3"
function $0cda192b820fed87$var$calculator(str = '') {
    const sum = str.replace(/,/g, '.').replace(/\s*/g, '').split('+').map((v)=>+v).reduce((a, b)=>a + b, 0);
    return Math.round(sum * 100) / 100;
}

$0cda192b820fed87$exports = $dM6Pc.extend({
    template: (parcelRequire("cRxPS")).default,
    events: {
        'keyup input': 'onKeyUp',
        'change input': 'onKeyUp',
        'click [data-hook=add-weight]': 'addWeight'
    },
    bindings: {
        'model.unitsSoldLocalized': {
            hook: 'units-sold'
        },
        'model.packagesSoldLocalized': {
            hook: 'packages-sold'
        },
        'model.isUnitsSoldNegative': {
            type: 'booleanClass',
            name: 'error',
            hook: 'sales'
        },
        'model.inputPackages': {
            selector: 'input[name=inputPackages]',
            type: 'value'
        },
        'model.inputUnits': {
            selector: 'input[name=inputUnits]',
            type: 'value'
        }
    },
    subviews: {
        weightList: {
            hook: 'weights',
            prepareView (el) {
                return this.renderCollection(this.model.weight, $7c434a0940cbcea1$exports, el);
            }
        }
    },
    initialize () {},
    onKeyUp (event) {
        event.stopPropagation();
        const sum = $0cda192b820fed87$var$calculator(event.target.value);
        this.model.set(event.target.name, sum);
    },
    addWeight (event) {
        event.preventDefault();
        this.model.weight.add({
            productId: this.model.productId
        });
    }
});



$959ec01bdc9006d9$exports = $dM6Pc.extend({
    template: (parcelRequire("2CfSU")).default,
    subviews: {
        list: {
            hook: 'item-list',
            prepareView (el) {
                return this.renderCollection(this.model.items, $0cda192b820fed87$exports, el);
            }
        }
    }
});



var $8jWPf = parcelRequire("8jWPf");

var $kLOUX = parcelRequire("kLOUX");

var $8jWPf = parcelRequire("8jWPf");

var $kLOUX = parcelRequire("kLOUX");
var $b637e05b9eba8a18$export$2ba01fb71ed41cb6;
var $b637e05b9eba8a18$export$c4a068d767524312;
var $b637e05b9eba8a18$export$34e0f9847d4c02dd;
var $b637e05b9eba8a18$export$1237798dc640739a;
var $b637e05b9eba8a18$export$d90250155de6d7e7;
$b637e05b9eba8a18$export$2ba01fb71ed41cb6 = `-2JSxW_button`;
$b637e05b9eba8a18$export$c4a068d767524312 = `-2JSxW_buttonsContainer`;
$b637e05b9eba8a18$export$34e0f9847d4c02dd = `-2JSxW_container`;
$b637e05b9eba8a18$export$1237798dc640739a = `-2JSxW_label`;
$b637e05b9eba8a18$export$d90250155de6d7e7 = `-2JSxW_selected`;


const $ca3de27e0e219e5b$export$68c13de1abdfa2b3 = ({ label: label, options: options, value: value, onChange: onChange })=>{
    // Generate a unique ID for the label and group
    const groupId = (0, $kLOUX.useId)();
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
        class: $b637e05b9eba8a18$export$34e0f9847d4c02dd,
        role: "group",
        "aria-labelledby": `toggle-group-label-${groupId}`,
        children: [
            label && /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                id: `toggle-group-label-${groupId}`,
                class: $b637e05b9eba8a18$export$1237798dc640739a,
                children: label
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                class: $b637e05b9eba8a18$export$c4a068d767524312,
                children: options.map((option)=>{
                    const isSelected = value === option.value;
                    return /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                        type: "button",
                        role: "radio",
                        "aria-checked": isSelected,
                        onClick: ()=>onChange(option.value),
                        class: `${$b637e05b9eba8a18$export$2ba01fb71ed41cb6} ${isSelected ? $b637e05b9eba8a18$export$d90250155de6d7e7 : ''}`,
                        children: option.label
                    }, option.value);
                })
            })
        ]
    });
};



var $1JrMM = parcelRequire("1JrMM");
var $a67598382804d535$exports = {};

$parcel$export($a67598382804d535$exports, "filters", function () { return $a67598382804d535$export$82462a21aead86ed; }, function (v) { return $a67598382804d535$export$82462a21aead86ed = v; });
$parcel$export($a67598382804d535$exports, "resetSearchButton", function () { return $a67598382804d535$export$92ddd6250d45918d; }, function (v) { return $a67598382804d535$export$92ddd6250d45918d = v; });
$parcel$export($a67598382804d535$exports, "searchInput", function () { return $a67598382804d535$export$952af3258ed45903; }, function (v) { return $a67598382804d535$export$952af3258ed45903 = v; });
var $a67598382804d535$export$82462a21aead86ed;
var $a67598382804d535$export$92ddd6250d45918d;
var $a67598382804d535$export$952af3258ed45903;
$a67598382804d535$export$82462a21aead86ed = `V_yD-a_filters`;
$a67598382804d535$export$92ddd6250d45918d = `V_yD-a_resetSearchButton`;
$a67598382804d535$export$952af3258ed45903 = `V_yD-a_searchInput`;


const $c2ffbb2e82559025$export$b116cfd04b845e71 = (0, $1JrMM.PreactView).extend({
    component: $c2ffbb2e82559025$var$StockTakingItemsFilter
});
function $c2ffbb2e82559025$var$StockTakingItemsFilter({ model: model }) {
    const [sortOrder, setSortOrder] = (0, $kLOUX.useState)('name');
    const [query, setQuery] = (0, $kLOUX.useState)('');
    (0, $kLOUX.useEffect)(()=>{
        /** @file stock-taking-item-collection.js */ // @ts-expect-error
        model.items.sortBy(sortOrder);
    }, [
        sortOrder
    ]);
    (0, $kLOUX.useEffect)(()=>{
        /** @file stock-taking-item-collection.js */ // @ts-expect-error
        model.items.byName(query);
    }, [
        query
    ]);
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($a67598382804d535$exports))).filters,
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: "input-addon",
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                        class: "icon ion-ios-search-strong input-addon-item"
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($a67598382804d535$exports))).searchInput,
                        type: "text",
                        name: "product-search",
                        autoComplete: "off",
                        autoCorrect: "off",
                        autoCapitalize: "off",
                        enterKeyHint: "search",
                        placeholder: "Produkt suchen...",
                        value: query,
                        onKeyDown: (event)=>{
                            if (event.key === 'Escape' && query.length > 0) {
                                event.stopPropagation();
                                setQuery('');
                            }
                        },
                        onChange: (event)=>setQuery(event.currentTarget.value)
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                        type: "button",
                        class: (0, (/*@__PURE__*/$parcel$interopDefault($a67598382804d535$exports))).resetSearchButton,
                        onClick: ()=>setQuery(''),
                        children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                            class: "icon ion-close"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)((0, $ca3de27e0e219e5b$export$68c13de1abdfa2b3), {
                label: "Sortieren:",
                options: [
                    {
                        value: 'sortPosition',
                        label: 'Manuell'
                    },
                    {
                        value: 'name',
                        label: 'A-Z'
                    }
                ],
                value: sortOrder,
                onChange: setSortOrder
            })
        ]
    });
}


var $53d45143ddd13ce5$require$StockTakingItemsFilterView = $c2ffbb2e82559025$export$b116cfd04b845e71;
function $53d45143ddd13ce5$var$parseItems(item) {
    return {
        productId: item.productId,
        stockUnits: item.units
    };
}

$53d45143ddd13ce5$exports = $dM6Pc.extend({
    template: (parcelRequire("5TwzC")).default,
    title () {
        if (this.model.isNew()) return `Neue Inventur f\xfcr ${this.location.name}`;
        return `Inventur f\xfcr ${this.location.name}`;
    },
    derived: {
        backUrl: {
            cache: false,
            fn () {
                if (this.location.type === 'storage' || this.location.type === 'crash') return `/lager/${this.location.slug}/inventuren`;
                return `/bars/${this.location.slug}/inventuren`;
            }
        }
    },
    events: {
        'click [data-hook=prefill]': 'prefill'
    },
    subviews: {
        sortToggle: {
            hook: 'filters',
            prepareView (el) {
                return new $53d45143ddd13ce5$require$StockTakingItemsFilterView({
                    el: el,
                    props: {
                        model: this.model
                    }
                });
            }
        },
        shiftEndForm: {
            hook: 'shift-end-form',
            prepareView (el) {
                return new $3b40619e8fdf3abf$exports({
                    el: el,
                    model: this.model
                });
            }
        },
        entryForm: {
            hook: 'entry-form',
            prepareView (el) {
                return new $959ec01bdc9006d9$exports({
                    el: el,
                    model: this.model
                });
            }
        },
        metaForm: {
            hook: 'meta-form',
            prepareView (el) {
                return new $f6e210aabd38f794$exports({
                    el: el,
                    model: this.model
                });
            }
        }
    },
    initialize (opts = {}) {
        this.location = opts.location;
        if (opts.id) {
            // existing inventory
            this.model = new $ab3a15abb20cc116$exports({
                locationId: this.location.id,
                id: opts.id
            });
            this.model.once('sync', ()=>{
                this.listenTo(this.model, 'change:shiftEndTime', this.onTimeChange);
            });
            this.model.fetch();
        } else {
            // new inventory with current stock
            this.model = new $ab3a15abb20cc116$exports({
                locationId: this.location.id
            });
            // fetch latest location stock
            this.onTimeChange(this.model, this.model.shiftEndTime);
            this.listenTo(this.model, 'change:shiftEndTime', this.onTimeChange);
        }
    },
    onTimeChange (model, shiftEndTime) {
        const location = new $f6ea85ea97c73a0a$exports({
            id: this.location.id
        });
        location.fetch({
            data: {
                before: new Date(shiftEndTime).toISOString()
            }
        });
        location.once('sync', ()=>{
            this.model.items.set(location.stock.map($53d45143ddd13ce5$var$parseItems));
        });
    },
    prefill (evt) {
        evt.preventDefault();
        this.model.prefill("Erstbest\xfcckung");
    }
});


var $22e3b9e0ced63896$exports = {};

var $4UX9c = parcelRequire("4UX9c");

var $dM6Pc = parcelRequire("dM6Pc");





const $22e3b9e0ced63896$var$ItemView = $dM6Pc.extend({
    template: (parcelRequire("i2SG2")).default,
    derived: {
        // build link to transactions page
        transactionsLink: {
            cache: false,
            fn () {
                const inv = this.model.collection.parent;
                const params = {
                    q: inv.location.name,
                    product: this.model.product.slug,
                    end: inv.shiftEndTime.getTime()
                };
                if (this.model.lastInventoryTime) params.start = this.model.lastInventoryTime.getTime();
                return `/transaktionen?${new URLSearchParams(params)}`;
            }
        }
    }
});

$22e3b9e0ced63896$exports = $dM6Pc.extend({
    template: (parcelRequire("dA8je")).default,
    title () {
        return `Inventur f\xfcr ${this.location.name}`;
    },
    derived: {
        backUrl: {
            cache: false,
            fn () {
                if (this.location.type === 'storage' || this.location.type === 'crash') return `/lager/${this.location.slug}/inventuren`;
                return `/bars/${this.location.slug}/inventuren`;
            }
        },
        editUrl: {
            cache: false,
            deps: [
                'backUrl'
            ],
            fn () {
                return `${this.backUrl}/${this.model.id}/edit`;
            }
        },
        exportUrl: {
            cache: false,
            fn () {
                return `/api/events/${$4UX9c.me.currentEvent.slug}/locations/${this.location.id}/inventories/${this.model.id}/export`;
            }
        }
    },
    initialize (opts) {
        this.location = opts.location;
        this.model = new $ab3a15abb20cc116$exports({
            locationId: opts.location.id,
            id: opts.id
        });
        this.listenTo(this.model, 'sync', this.render);
        this.listenTo(this.model, 'destroy', this.onDestroy);
        this.model.fetch();
    },
    // will be called by SearchBarView
    search (query) {
        this.model.items.byName(query);
    },
    onDestroy () {
        $4UX9c.navigate(this.backUrl);
        this.remove();
    },
    renderDeleteButton () {
        this.deleteButton = new $d23b55c707a7112e$exports({
            el: this.queryByHook('delete'),
            icon: 'ion-ios-trash',
            title: "Inventur l\xf6schen...",
            classes: 'button-error',
            Popover: $3c03021769421268$exports,
            popoverOpts: {
                model: this.model,
                name: 'Inventur',
                position: 'bottom'
            }
        });
        this.registerSubview(this.deleteButton.render());
    },
    render () {
        this.renderWithTemplate();
        this.searchBar = new $faf64da9e05fa3b7$exports({
            el: this.queryByHook('search-bar'),
            parent: this
        });
        this.registerSubview(this.searchBar.render());
        this.renderDeleteButton();
        this.renderCollection(this.model.items, $22e3b9e0ced63896$var$ItemView, '[data-hook=item-list]');
        return this;
    }
});


var $dcae67f694def8b6$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

$dcae67f694def8b6$exports = $dM6Pc.extend({
    template: (parcelRequire("c87Yy")).default,
    title: ':-(',
    initialize (opts = {}) {
        this.path = opts.path;
    }
});



var $1JrMM = parcelRequire("1JrMM");

var $8jWPf = parcelRequire("8jWPf");

var $56rtr = parcelRequire("56rtr");

var $bRFDG = parcelRequire("bRFDG");

var $kLOUX = parcelRequire("kLOUX");

var $h6tPy = parcelRequire("h6tPy");

var $348Te = parcelRequire("348Te");

var $1JrMM = parcelRequire("1JrMM");
var $ebb13d168008f0a3$export$f2120bbfa5450bd2;
var $ebb13d168008f0a3$export$bbea856fdb3e3c5f;
var $ebb13d168008f0a3$export$60bb6c1f29b8a8cc;
var $ebb13d168008f0a3$export$efe229eab43a9869;
var $ebb13d168008f0a3$export$d008477d3e1d2feb;
var $ebb13d168008f0a3$export$285bd1d6c6bdf942;
var $ebb13d168008f0a3$export$a3bc9b8ed74fc;
var $ebb13d168008f0a3$export$d4f63cf0ebacf15f;
var $ebb13d168008f0a3$export$62bd5d1d7d32b664;
var $ebb13d168008f0a3$export$3c2ffd521ef26490;
var $ebb13d168008f0a3$export$73cd5f74c7c77f88;
var $ebb13d168008f0a3$export$bb2451df95f69d26;
var $ebb13d168008f0a3$export$f7fe31d4c40fb440;
var $ebb13d168008f0a3$export$d8d93c3954128e06;
var $ebb13d168008f0a3$export$2e0cf8e3959dcb8e;
var $ebb13d168008f0a3$export$24e68bf51801083d;
var $ebb13d168008f0a3$export$fb0eafe3ffec6351;
var $ebb13d168008f0a3$export$7df22de86f3190fb;
var $ebb13d168008f0a3$export$58f4db0ace00b542;
var $ebb13d168008f0a3$export$3bfe18c4a85be7ea;
var $ebb13d168008f0a3$export$c11f3c07d391dfe5;
var $ebb13d168008f0a3$export$a3574df893ffa88d;
var $ebb13d168008f0a3$export$5329fb5ecd7599;
var $ebb13d168008f0a3$export$41bc904b139d972e;
var $ebb13d168008f0a3$export$9197e7e354d054fd;
var $ebb13d168008f0a3$export$fa56a31c21a6edac;
var $ebb13d168008f0a3$export$b4cd064c16630a10;
var $ebb13d168008f0a3$export$a56bbfb78cb41005;
var $ebb13d168008f0a3$export$11a0a73b7f5c9856;
$ebb13d168008f0a3$export$f2120bbfa5450bd2 = `qZLaTG_arrow`;
$ebb13d168008f0a3$export$bbea856fdb3e3c5f = `qZLaTG_buttons`;
$ebb13d168008f0a3$export$60bb6c1f29b8a8cc = `qZLaTG_iconButton`;
$ebb13d168008f0a3$export$efe229eab43a9869 = `qZLaTG_closeButton ${$ebb13d168008f0a3$export$60bb6c1f29b8a8cc}`;
$ebb13d168008f0a3$export$d008477d3e1d2feb = `qZLaTG_commentBubble`;
$ebb13d168008f0a3$export$285bd1d6c6bdf942 = `qZLaTG_commentForm`;
$ebb13d168008f0a3$export$a3bc9b8ed74fc = `qZLaTG_error`;
$ebb13d168008f0a3$export$d4f63cf0ebacf15f = `qZLaTG_groupActions`;
$ebb13d168008f0a3$export$62bd5d1d7d32b664 = `qZLaTG_noItems`;
$ebb13d168008f0a3$export$3c2ffd521ef26490 = `qZLaTG_saveCommentButton`;
$ebb13d168008f0a3$export$73cd5f74c7c77f88 = `qZLaTG_taskboard`;
$ebb13d168008f0a3$export$bb2451df95f69d26 = `qZLaTG_taskboardGroup`;
$ebb13d168008f0a3$export$f7fe31d4c40fb440 = `qZLaTG_taskboardGroupComment`;
$ebb13d168008f0a3$export$d8d93c3954128e06 = `qZLaTG_taskboardGroupHeader`;
$ebb13d168008f0a3$export$2e0cf8e3959dcb8e = `qZLaTG_taskboardGroupRoute`;
$ebb13d168008f0a3$export$24e68bf51801083d = `qZLaTG_taskboardGroupToggleButton ${$ebb13d168008f0a3$export$60bb6c1f29b8a8cc}`;
$ebb13d168008f0a3$export$fb0eafe3ffec6351 = `qZLaTG_taskboardItem`;
$ebb13d168008f0a3$export$7df22de86f3190fb = `qZLaTG_taskboardMetadata`;
$ebb13d168008f0a3$export$58f4db0ace00b542 = `qZLaTG_taskboardItemFooter ${$ebb13d168008f0a3$export$7df22de86f3190fb}`;
$ebb13d168008f0a3$export$3bfe18c4a85be7ea = `qZLaTG_taskboardItemHeader ${$ebb13d168008f0a3$export$7df22de86f3190fb}`;
$ebb13d168008f0a3$export$c11f3c07d391dfe5 = `qZLaTG_taskboardSidebar ${$ebb13d168008f0a3$export$73cd5f74c7c77f88}`;
$ebb13d168008f0a3$export$a3574df893ffa88d = `qZLaTG_textarea`;
$ebb13d168008f0a3$export$5329fb5ecd7599 = `qZLaTG_textareaWrap`;
$ebb13d168008f0a3$export$41bc904b139d972e = `qZLaTG_transactionEditForm`;
$ebb13d168008f0a3$export$9197e7e354d054fd = `qZLaTG_transactionEditFormFooter`;
$ebb13d168008f0a3$export$fa56a31c21a6edac = `qZLaTG_transactionEditFormProduct`;
$ebb13d168008f0a3$export$b4cd064c16630a10 = `qZLaTG_transactionEditFormRoute`;
$ebb13d168008f0a3$export$a56bbfb78cb41005 = `qZLaTG_transactionSection`;
$ebb13d168008f0a3$export$11a0a73b7f5c9856 = `qZLaTG_userWrap`;



var $8jWPf = parcelRequire("8jWPf");

var $kLOUX = parcelRequire("kLOUX");

var $d0uB5 = parcelRequire("d0uB5");

var $h6tPy = parcelRequire("h6tPy");

/**
 * @param {import('../types').Transaction} tx
 */ function $5c275ac03fe3fd59$var$getInputUnits(tx) {
    return tx.units % tx.product.packageSize;
}
/**
 * @param {import('../types').Transaction} tx
 */ function $5c275ac03fe3fd59$var$getInputPackages(tx) {
    return Math.floor(tx.units / tx.product.packageSize);
}
function $5c275ac03fe3fd59$export$d2cf0f611fc63100({ transaction: transaction, onClose: onClose, onEditTransaction: onEditTransaction }) {
    const [inputPackages, setInputPackages] = (0, $kLOUX.useState)($5c275ac03fe3fd59$var$getInputPackages(transaction));
    const [inputUnits, setInputUnits] = (0, $kLOUX.useState)($5c275ac03fe3fd59$var$getInputUnits(transaction));
    const [sourceId, setSourceId] = (0, $kLOUX.useState)(transaction.sourceId);
    const [comment, setComment] = (0, $kLOUX.useState)(transaction.comment || '');
    const [error, setError] = (0, $kLOUX.useState)();
    const [isSubmitting, setIsSubmitting] = (0, $kLOUX.useState)(false);
    const eventSlug = (0, $h6tPy.useCurrentEventSlug)();
    const { bars: bars, storage: storage } = (0, $h6tPy.useLocations)(eventSlug);
    (0, $kLOUX.useEffect)(()=>{
        setInputPackages($5c275ac03fe3fd59$var$getInputPackages(transaction));
        setInputUnits($5c275ac03fe3fd59$var$getInputUnits(transaction));
        setSourceId(transaction.sourceId);
        setComment(transaction.comment || '');
    }, [
        transaction
    ]);
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("form", {
        class: `pure-form ${$ebb13d168008f0a3$export$41bc904b139d972e}`,
        onSubmit: async (event)=>{
            event.preventDefault();
            try {
                setError(undefined);
                setIsSubmitting(true);
                await onEditTransaction(transaction.id, {
                    sourceId: sourceId,
                    units: inputPackages * transaction.product.packageSize + inputUnits,
                    comment: comment
                });
                onClose();
            } catch (error) {
                console.error(error);
                setIsSubmitting(false);
                setError(error);
            }
        },
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsx)("fieldset", {
                children: /*#__PURE__*/ (0, $8jWPf.jsx)("legend", {
                    children: "Transaktion bearbeiten"
                })
            }),
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $ebb13d168008f0a3$export$b4cd064c16630a10,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        style: {
                            paddingRight: '2em'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                                for: "source",
                                children: "Von"
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("select", {
                                class: "pure-input-1",
                                name: "source",
                                value: sourceId,
                                onChange: (event)=>setSourceId(event.target.value),
                                required: true,
                                children: [
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                        disabled: true,
                                        value: "",
                                        children: "Quelle w\xe4hlen..."
                                    }),
                                    storage && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                        label: "Lager",
                                        children: storage.map((store)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                value: store.id,
                                                children: store.name
                                            }, store.id))
                                    }),
                                    bars && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                        label: "Bars",
                                        children: bars.map((bar)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                value: bar.id,
                                                children: bar.name
                                            }, bar.id))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                                for: "source",
                                children: "Nach"
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                children: transaction.target.name
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $ebb13d168008f0a3$export$fa56a31c21a6edac,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("b", {
                        children: transaction.product.name
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                                class: "pure-input-1",
                                name: "inputPackages",
                                type: "number",
                                min: "0",
                                placeholder: "0",
                                value: inputPackages || '',
                                onChange: (event)=>{
                                    setInputPackages(event.target.valueAsNumber);
                                }
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsx)("span", {
                                class: "append",
                                children: (0, $d0uB5.packaging).get(transaction.product.packageId).name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                                class: "pure-input-1",
                                name: "inputUnits",
                                type: "number",
                                min: "0",
                                step: "any",
                                placeholder: "0",
                                value: inputUnits || '',
                                onChange: (event)=>{
                                    setInputUnits(event.target.valueAsNumber);
                                }
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsx)("span", {
                                class: "append",
                                children: (0, $d0uB5.packaging).get(transaction.product.unitId).name
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                style: {
                    alignSelf: 'stretch'
                },
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                        htmlFor: "comment",
                        children: "Kommentar"
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("textarea", {
                        name: "comment",
                        rows: 3,
                        style: {
                            width: '100%'
                        },
                        value: comment,
                        onChange: (event)=>setComment(event.target.value)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8jWPf.jsxs)("footer", {
                class: $ebb13d168008f0a3$export$9197e7e354d054fd,
                children: [
                    error && /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        class: "error",
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)("b", {
                                children: "Error:"
                            }),
                            " ",
                            error.message
                        ]
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                        type: "submit",
                        class: "pure-button pure-button-primary",
                        disabled: isSubmitting,
                        children: "Speichern"
                    })
                ]
            })
        ]
    });
}



var $8jWPf = parcelRequire("8jWPf");

var $9c5La = parcelRequire("9c5La");

var $kLOUX = parcelRequire("kLOUX");


var $8jWPf = parcelRequire("8jWPf");

var $9c5La = parcelRequire("9c5La");

var $kLOUX = parcelRequire("kLOUX");

var $gvQO6 = parcelRequire("gvQO6");

function $4d1423625edcd5bf$export$61a2f4591b9f8c01({ source: source, target: target }) {
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
        class: $ebb13d168008f0a3$export$3bfe18c4a85be7ea,
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsx)("span", {
                children: source.name
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                class: "icon ion-arrow-right-c"
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)("span", {
                children: target.name
            })
        ]
    });
}
function $4d1423625edcd5bf$export$27ce468e7e307749({ role: role, transaction: transaction, isGrouped: isGrouped, onUpdateTransaction: onUpdateTransaction, onDeleteTransaction: onDeleteTransaction, onEditTransaction: onEditTransaction }) {
    const [showComment, setShowComment] = (0, $kLOUX.useState)(false);
    const units = (0, $gvQO6.i18nUnits)(transaction.units, transaction.product);
    const packages = (0, $gvQO6.i18nPackages)(transaction.units, transaction.product);
    const isBarOrder = transaction.user.currentEventSettings.role === 'bar';
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("li", {
        class: $ebb13d168008f0a3$export$fb0eafe3ffec6351,
        children: [
            !isGrouped && /*#__PURE__*/ (0, $8jWPf.jsx)($4d1423625edcd5bf$export$61a2f4591b9f8c01, {
                source: transaction.source,
                target: transaction.target
            }),
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: "pure-g",
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        class: "pure-u-1-2",
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                children: [
                                    packages && /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                        children: packages
                                    }),
                                    units && /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                        children: units
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                class: "item-name",
                                children: transaction.product.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                        class: "pure-u-1-2",
                        children: /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                            class: $ebb13d168008f0a3$export$bbea856fdb3e3c5f,
                            children: [
                                (role === 'admin' || role === 'dispatcher') && /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                                    type: "button",
                                    class: "btn-round-small btn-round pure-button",
                                    title: "Transaktion bearbeiten",
                                    onClick: ()=>onEditTransaction(transaction),
                                    children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                                        class: "ion-edit"
                                    })
                                }),
                                (role === 'admin' || role === 'dispatcher' || role === 'bar' && transaction.state === 'transit') && /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                                    type: "button",
                                    class: "btn-round-small btn-round pure-button",
                                    title: "Diese Transaktion stornieren?",
                                    onClick: ()=>{
                                        const ok = window.confirm('Diese Transaktion wirklich stornieren?');
                                        if (ok) onDeleteTransaction(transaction.id);
                                    },
                                    children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                                        class: "ion-close"
                                    })
                                }),
                                (role === 'admin' || role === 'dispatcher') && isBarOrder && transaction.state === 'transit' && /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                                    type: "button",
                                    class: "btn-round pure-button pure-button-primary",
                                    title: "Akzeptieren",
                                    onClick: ()=>onUpdateTransaction(transaction.id, {
                                            state: 'accepted'
                                        }),
                                    children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                                        class: "icon ion-thumbsup"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                                    type: "button",
                                    class: "btn-round button-success pure-button",
                                    title: "Best\xe4tigen",
                                    onClick: ()=>onUpdateTransaction(transaction.id, {
                                            state: 'complete'
                                        }),
                                    children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                                        class: "icon ion-checkmark"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            !isGrouped && /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $ebb13d168008f0a3$export$58f4db0ace00b542,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        class: $ebb13d168008f0a3$export$11a0a73b7f5c9856,
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("span", {
                                children: [
                                    "von ",
                                    transaction.user.name
                                ]
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                class: $ebb13d168008f0a3$export$d008477d3e1d2feb,
                                title: "Kommentar hinzuf\xfcgen/anzeigen...",
                                onClick: ()=>setShowComment(!showComment),
                                onKeyDown: (e)=>e.key === 'Enter' && setShowComment(!showComment),
                                role: "button",
                                tabIndex: 0,
                                children: transaction.comment ? /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                                    class: "ion-ios-chatbubble",
                                    style: {
                                        color: 'var(--button-blue)'
                                    }
                                }) : /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                                    class: "ion-ios-chatbubble-outline"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("time", {
                        dateTime: transaction.dispatchedAt,
                        children: (0, $9c5La.DateTime).fromISO(transaction.dispatchedAt).toRelative()
                    })
                ]
            }),
            !isGrouped && showComment && /*#__PURE__*/ (0, $8jWPf.jsxs)("form", {
                class: $ebb13d168008f0a3$export$285bd1d6c6bdf942,
                onSubmit: (event)=>{
                    event.preventDefault();
                    const data = new FormData(event.target);
                    onUpdateTransaction(transaction.id, {
                        comment: data.get('comment')?.toString()
                    });
                    setShowComment(false);
                },
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        class: $ebb13d168008f0a3$export$5329fb5ecd7599,
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                class: $ebb13d168008f0a3$export$f2120bbfa5450bd2
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsx)("textarea", {
                                class: $ebb13d168008f0a3$export$a3574df893ffa88d,
                                name: "comment",
                                placeholder: "Kommentar hinzuf\xfcgen...",
                                defaultValue: transaction.comment
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                        type: "submit",
                        class: $ebb13d168008f0a3$export$3c2ffd521ef26490,
                        children: "Kommentar speichern..."
                    })
                ]
            })
        ]
    });
}


function $16cd4acad36b1058$export$8d4517d05ebcf91({ transactions: transactions, children: children }) {
    const comments = Array.from(new Set(transactions.filter((tx)=>tx.comment).map((tx)=>tx.comment)));
    const { source: source, target: target, dispatchedAt: dispatchedAt, user: user } = transactions[0];
    const dispatchedDateTime = (0, $9c5La.DateTime).fromISO(dispatchedAt);
    const [isOpen, setIsOpen] = (0, $kLOUX.useState)(false);
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("li", {
        class: $ebb13d168008f0a3$export$bb2451df95f69d26,
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $ebb13d168008f0a3$export$d8d93c3954128e06,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)((0, $4d1423625edcd5bf$export$61a2f4591b9f8c01), {
                                source: source,
                                target: target
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                children: [
                                    transactions.length === 1 && '1 Produkt',
                                    transactions.length > 1 && `${transactions.length} Produkte`
                                ]
                            }),
                            comments.length > 0 && /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                class: $ebb13d168008f0a3$export$f7fe31d4c40fb440,
                                children: [
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                                        class: "ion-ios-chatbubble"
                                    }),
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                        children: comments.join(' ')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                class: $ebb13d168008f0a3$export$7df22de86f3190fb,
                                children: [
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("time", {
                                        title: dispatchedDateTime.toLocaleString((0, $9c5La.DateTime).DATETIME_FULL_WITH_SECONDS),
                                        dateTime: dispatchedAt,
                                        children: dispatchedDateTime.toRelative()
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $8jWPf.jsxs)("span", {
                                        children: [
                                            "von ",
                                            user.name
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                        type: "button",
                        class: $ebb13d168008f0a3$export$24e68bf51801083d,
                        title: "Gruppe \xf6ffnen",
                        onClick: ()=>setIsOpen((prev)=>!prev),
                        children: isOpen ? /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                            class: "ion-chevron-down"
                        }) : /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                            class: "ion-chevron-right"
                        })
                    })
                ]
            }),
            isOpen && children
        ]
    });
}



var $8jWPf = parcelRequire("8jWPf");

var $h6tPy = parcelRequire("h6tPy");

function $f9b177f3ae6803eb$export$a433c96e5af4a640({ ids: ids, show: show = [
    'accept',
    'complete'
], onRevalidate: onRevalidate }) {
    const eventSlug = (0, $h6tPy.useCurrentEventSlug)();
    const role = (0, $h6tPy.useCurrentRole)();
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
        class: $ebb13d168008f0a3$export$d4f63cf0ebacf15f,
        children: [
            show.includes('accept') && (role === 'admin' || role === 'dispatcher') && /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                type: "button",
                className: "pure-button",
                onClick: async ()=>{
                    const ok = window.confirm(`${ids.length} Transaktionen akzeptieren?`);
                    if (!ok) return;
                    try {
                        await (0, $h6tPy.api)(`/api/events/${eventSlug}/transactions`, {
                            method: 'PUT',
                            body: {
                                state: 'accepted',
                                ids: ids
                            }
                        });
                        await onRevalidate();
                    } catch (error) {
                        console.error(error);
                    }
                },
                children: "Alle akzeptieren"
            }),
            show.includes('complete') && /*#__PURE__*/ (0, $8jWPf.jsxs)("button", {
                type: "button",
                className: "pure-button",
                onClick: async ()=>{
                    const ok = window.confirm(`${ids.length} Transaktionen best\xe4tigen?`);
                    if (!ok) return;
                    try {
                        await (0, $h6tPy.api)(`/api/events/${eventSlug}/transactions`, {
                            method: 'PUT',
                            body: {
                                state: 'complete',
                                ids: ids
                            }
                        });
                        await onRevalidate();
                    } catch (error) {
                        console.error(error);
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                        class: "icon ion-checkmark",
                        style: {
                            marginRight: '0.5em'
                        }
                    }),
                    "Alle best\xe4tigen"
                ]
            })
        ]
    });
}



const $c5f992a5a27c6861$export$fb6bf807f167b5e8 = (0, $1JrMM.PreactView).extend({
    component: $c5f992a5a27c6861$export$bbbff42299d2551d
});
/** @param {import('../types').Transaction} tx */ const $c5f992a5a27c6861$var$onlyBarOrders = (tx)=>tx.user.currentEventSettings.role === 'bar';
/** @param {import('../types').Transaction} tx */ const $c5f992a5a27c6861$var$otherOrders = (tx)=>tx.user.currentEventSettings.role !== 'bar';
/** @param {import('../types').Transaction} tx */ const $c5f992a5a27c6861$var$getGroupKey = (tx)=>`${tx.createdAt}_${tx.sourceId}_${tx.targetId}`;
function $c5f992a5a27c6861$export$bbbff42299d2551d({ onClose: onClose }) {
    const eventSlug = (0, $h6tPy.useCurrentEventSlug)();
    const role = (0, $h6tPy.useCurrentRole)();
    const { data: transactions, mutate: mutate, error: error } = (0, $h6tPy.useTransactions)();
    const barOrders = transactions?.data.filter($c5f992a5a27c6861$var$onlyBarOrders);
    const barOrdersGroups = Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($56rtr)))(barOrders, $c5f992a5a27c6861$var$getGroupKey));
    const otherTransactions = transactions?.data.filter($c5f992a5a27c6861$var$otherOrders);
    const otherTransactionsGroups = Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($56rtr)))(otherTransactions, $c5f992a5a27c6861$var$getGroupKey));
    const [editTransaction, setEditTransaction] = (0, $kLOUX.useState)(/** @type {import('../types').Transaction | null} */ null);
    const [showEditTransactionModal, setShowEditTransactionModal] = (0, $kLOUX.useState)(false);
    const [rerender, setRerender] = (0, $kLOUX.useState)(0);
    // update the relative dispatch time every 10s
    (0, $kLOUX.useEffect)(()=>{
        const id = setTimeout(()=>{
            setRerender(rerender + 1);
        }, 10000);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        rerender
    ]);
    /**
   * @param {string} id
   * @param {{
   *   state?: import('../types').Transaction['state']
   *   comment?: string
   * }} payload
   */ async function saveTransaction(id, payload) {
        // remove completed transactions immediately
        if (payload.state === 'complete' && transactions) await mutate({
            ...transactions,
            data: transactions.data.filter((tx)=>tx.id !== id)
        }, {
            revalidate: false
        });
        await (0, $h6tPy.api)(`/api/events/${eventSlug}/transactions/${id}`, {
            method: 'PUT',
            body: payload
        });
        await mutate();
    }
    async function deleteTransaction(id) {
        if (transactions) await mutate({
            ...transactions,
            data: transactions.data.filter((tx)=>tx.id !== id)
        }, {
            revalidate: false
        });
        await (0, $h6tPy.api)(`/api/events/${eventSlug}/transactions/${id}`, {
            method: 'DELETE'
        });
        await mutate();
    }
    /**
   * @param {string} id
   * @param {Pick<
   *   import('../types').Transaction,
   *   'units' | 'sourceId' | 'comment'
   * >} payload
   */ async function handleEditTransaction(id, payload) {
        await (0, $h6tPy.api)(`/api/events/${eventSlug}/transactions/${id}`, {
            method: 'PUT',
            body: payload
        });
        await mutate();
    }
    /** @param {import('../types').Transaction} transaction */ function handleShowEditModal(transaction) {
        setEditTransaction(transaction);
        setShowEditTransactionModal(true);
    }
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
        class: onClose ? $ebb13d168008f0a3$export$c11f3c07d391dfe5 : $ebb13d168008f0a3$export$73cd5f74c7c77f88,
        children: [
            onClose && /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                type: "button",
                class: $ebb13d168008f0a3$export$efe229eab43a9869,
                "data-title": "Taskboard ausblenden",
                onClick: onClose,
                children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                    class: "ion-close-round"
                })
            }),
            error && !transactions && /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $ebb13d168008f0a3$export$a3bc9b8ed74fc,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("p", {
                        children: [
                            "Error: ",
                            error.message
                        ]
                    }),
                    !navigator.onLine && /*#__PURE__*/ (0, $8jWPf.jsx)("p", {
                        children: "Bist du mit dem Internet verbunden?"
                    })
                ]
            }),
            transactions && transactions.data.length === 0 && /*#__PURE__*/ (0, $8jWPf.jsx)("p", {
                class: $ebb13d168008f0a3$export$62bd5d1d7d32b664,
                children: "Keine offenen Auftr\xe4ge."
            }),
            barOrders && barOrders.length > 0 && /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $ebb13d168008f0a3$export$a56bbfb78cb41005,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("h3", {
                        children: role === 'bar' ? 'Deine Bestellungen' : 'Barbestellungen'
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("ul", {
                        children: barOrdersGroups.map(([key, transactions])=>/*#__PURE__*/ (0, $8jWPf.jsx)((0, $bRFDG.Fragment), {
                                children: transactions.length > 1 ? /*#__PURE__*/ (0, $8jWPf.jsxs)((0, $16cd4acad36b1058$export$8d4517d05ebcf91), {
                                    transactions: transactions,
                                    children: [
                                        /*#__PURE__*/ (0, $8jWPf.jsx)("ul", {
                                            children: transactions.map((transaction)=>/*#__PURE__*/ (0, $8jWPf.jsx)((0, $4d1423625edcd5bf$export$27ce468e7e307749), {
                                                    transaction: transaction,
                                                    isGrouped: true,
                                                    onUpdateTransaction: saveTransaction,
                                                    onDeleteTransaction: deleteTransaction,
                                                    onEditTransaction: handleShowEditModal,
                                                    role: role
                                                }, transaction.id))
                                        }),
                                        transactions && transactions.length > 1 && /*#__PURE__*/ (0, $8jWPf.jsx)((0, $f9b177f3ae6803eb$export$a433c96e5af4a640), {
                                            ids: transactions.map((transaction)=>transaction.id),
                                            onRevalidate: mutate
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $8jWPf.jsx)((0, $4d1423625edcd5bf$export$27ce468e7e307749), {
                                    transaction: transactions[0],
                                    onUpdateTransaction: saveTransaction,
                                    onDeleteTransaction: deleteTransaction,
                                    onEditTransaction: handleShowEditModal,
                                    role: role
                                })
                            }, key))
                    })
                ]
            }),
            otherTransactions && otherTransactions.length > 0 && /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $ebb13d168008f0a3$export$a56bbfb78cb41005,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("h3", {
                        children: "Andere Auftr\xe4ge"
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("ul", {
                        children: otherTransactionsGroups.map(([key, transactions])=>/*#__PURE__*/ (0, $8jWPf.jsx)((0, $bRFDG.Fragment), {
                                children: transactions.length > 1 ? /*#__PURE__*/ (0, $8jWPf.jsxs)((0, $16cd4acad36b1058$export$8d4517d05ebcf91), {
                                    transactions: transactions,
                                    children: [
                                        /*#__PURE__*/ (0, $8jWPf.jsx)("ul", {
                                            children: transactions.map((transaction)=>/*#__PURE__*/ (0, $8jWPf.jsx)((0, $4d1423625edcd5bf$export$27ce468e7e307749), {
                                                    transaction: transaction,
                                                    isGrouped: true,
                                                    onUpdateTransaction: saveTransaction,
                                                    onDeleteTransaction: deleteTransaction,
                                                    onEditTransaction: handleShowEditModal,
                                                    role: role
                                                }, transaction.id))
                                        }),
                                        transactions && transactions.length > 1 && /*#__PURE__*/ (0, $8jWPf.jsx)((0, $f9b177f3ae6803eb$export$a433c96e5af4a640), {
                                            show: [
                                                'complete'
                                            ],
                                            ids: transactions.map((transaction)=>transaction.id),
                                            onRevalidate: mutate
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $8jWPf.jsx)((0, $4d1423625edcd5bf$export$27ce468e7e307749), {
                                    transaction: transactions[0],
                                    onUpdateTransaction: saveTransaction,
                                    onDeleteTransaction: deleteTransaction,
                                    onEditTransaction: handleShowEditModal,
                                    role: role
                                })
                            }, key))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)((0, $348Te.Modal), {
                isOpen: showEditTransactionModal,
                onClose: ()=>setShowEditTransactionModal(false),
                children: editTransaction && /*#__PURE__*/ (0, $8jWPf.jsxs)((0, $348Te.ModalPanel), {
                    children: [
                        /*#__PURE__*/ (0, $8jWPf.jsx)((0, $348Te.ModalCloseButton), {
                            onClick: ()=>setShowEditTransactionModal(false)
                        }),
                        /*#__PURE__*/ (0, $8jWPf.jsx)((0, $5c275ac03fe3fd59$export$d2cf0f611fc63100), {
                            transaction: editTransaction,
                            onEditTransaction: handleEditTransaction,
                            onClose: ()=>setShowEditTransactionModal(false)
                        })
                    ]
                })
            })
        ]
    });
}


const $0d24046ab2058e8c$var$TaskboardPageView = (0, $1JrMM.PreactView).extend({
    title: 'Taskboard',
    component: (0, $c5f992a5a27c6861$export$bbbff42299d2551d)
});
var $0d24046ab2058e8c$export$2e2bcd8739ae039 = $0d24046ab2058e8c$var$TaskboardPageView;


var $215b1ea15fcc90c0$require$TaskboardPage = $0d24046ab2058e8c$export$2e2bcd8739ae039;
function $215b1ea15fcc90c0$var$isAdmin(name) {
    return function(...args) {
        if ($4UX9c.me.role === 'admin') this[name].apply(this, args);
        else this.redirectTo('/404');
    };
}
function $215b1ea15fcc90c0$var$redirectTo(routeName) {
    return function(...args) {
        if ($4UX9c.me.role === 'bar') this.redirectTo('/bars');
        else this[routeName].apply(this, args);
    };
}

$215b1ea15fcc90c0$exports = $c2965853847685d5$exports.extend({
    routes: {
        '': $215b1ea15fcc90c0$var$redirectTo('uebersicht'),
        bars: 'bars',
        lager: 'lager',
        'bars/:slug/inventuren': 'inventurListe',
        'lager/:slug/inventuren': $215b1ea15fcc90c0$var$isAdmin('inventurListe'),
        'bars/:slug/inventuren/neu': 'inventurNeu',
        'lager/:slug/inventuren/neu': $215b1ea15fcc90c0$var$isAdmin('inventurNeu'),
        'bars/:slug/inventuren/:id': 'inventurDetails',
        'lager/:slug/inventuren/:id': $215b1ea15fcc90c0$var$isAdmin('inventurDetails'),
        'bars/:slug/inventuren/:id/edit': 'inventur',
        'lager/:slug/inventuren/:id/edit': $215b1ea15fcc90c0$var$isAdmin('inventur'),
        transaktionen: 'transaktionen',
        taskboard: 'taskboard',
        uebersicht: 'uebersicht',
        produkte: 'produkte',
        einstellungen: 'einstellungen',
        'einstellungen/:id': $215b1ea15fcc90c0$var$isAdmin('eventEinstellungen'),
        welcome: 'welcome',
        logout: 'logout',
        '*path': 'notFound'
    },
    adminOnly () {
        if ($4UX9c.me.role !== 'admin') return this.notFound();
    },
    welcome () {
        this.trigger('page', new $3f5c08d0f670e60f$exports());
    },
    bars () {
        if (!$4UX9c.me.currentEventId) return this.redirectTo('welcome');
        this.trigger('page', new $2141ca89e74a77ba$exports());
    },
    lager () {
        if (!$4UX9c.me.currentEventId) return this.redirectTo('welcome');
        if ($4UX9c.me.role === 'bar') return this.notFound();
        this.trigger('page', new $3ae7e7dcf30cc4fb$exports());
    },
    transaktionen () {
        if (!$4UX9c.me.currentEventId) return this.redirectTo('welcome');
        if ($4UX9c.me.role === 'bar') return this.notFound();
        this.trigger('page', new $346d3b1e7ee8f2c1$exports({
            query: Object.fromEntries(new URLSearchParams(window.location.search))
        }));
    },
    taskboard () {
        if (!$4UX9c.me.currentEventId) return this.redirectTo('welcome');
        this.trigger('page', new $215b1ea15fcc90c0$require$TaskboardPage());
    },
    uebersicht () {
        if (!$4UX9c.me.currentEventId) return this.redirectTo('welcome');
        this.trigger('page', new $b6a623b54c5d5db8$exports());
    },
    produkte () {
        if (!$4UX9c.me.currentEventId) return this.redirectTo('welcome');
        if ($4UX9c.me.role === 'bar') return this.notFound();
        this.trigger('page', new $13d2dd924a971d28$exports());
    },
    inventurListe (slug) {
        const location = $4UX9c.locations.find({
            slug: slug
        });
        if (!location) return this.redirectTo('/404');
        if (!$4UX9c.me.currentEventId) return this.redirectTo('welcome');
        this.trigger('page', new $4fce4e49c3e9d8e4$exports({
            model: $4UX9c.locations.find({
                slug: slug
            })
        }));
    },
    inventurNeu (slug) {
        const location = $4UX9c.locations.find({
            slug: slug
        });
        if (!location) return this.redirectTo('/404');
        if (!$4UX9c.me.currentEventId) return this.redirectTo('welcome');
        this.trigger('page', new $53d45143ddd13ce5$exports({
            location: $4UX9c.locations.find({
                slug: slug
            })
        }));
    },
    inventur (slug, id) {
        const location = $4UX9c.locations.find({
            slug: slug
        });
        if (!location) return this.redirectTo('/404');
        if (!$4UX9c.me.currentEventId) return this.redirectTo('welcome');
        this.trigger('page', new $53d45143ddd13ce5$exports({
            location: $4UX9c.locations.find({
                slug: slug
            }),
            id: id
        }));
    },
    inventurDetails (slug, id) {
        const location = $4UX9c.locations.find({
            slug: slug
        });
        if (!location) return this.redirectTo('/404');
        if (!$4UX9c.me.currentEventId) return this.redirectTo('welcome');
        this.trigger('page', new $22e3b9e0ced63896$exports({
            location: $4UX9c.locations.find({
                slug: slug
            }),
            id: id
        }));
    },
    einstellungen () {
        this.trigger('page', new $f103575a91c00a11$exports());
    },
    eventEinstellungen (eventId) {
        (parcelRequire("aCsQD")).then((module1)=>{
            const EventSettingsPage = module1.default;
            this.trigger('page', new EventSettingsPage({
                props: {
                    eventId: eventId
                }
            }));
        });
    },
    logout () {
        $4UX9c.me.logout();
    },
    notFound (path) {
        this.trigger('page', new $dcae67f694def8b6$exports({
            path: path
        }));
    }
});


var $ffa163ac75b4b6aa$exports = {};



var $bd3QA = parcelRequire("bd3QA");

var $4UX9c = parcelRequire("4UX9c");
$ffa163ac75b4b6aa$exports = $264826a651dea313$exports.extend({
    url: '/api/user',
    props: {
        currentEventId: 'string',
        assignedLocationId: 'string',
        defaultSourceLocationId: 'string',
        defaultTargetLocationId: 'string'
    },
    children: {
        currentEvent: $77fbf4d59f57bde4$exports
    },
    async changePassword (data) {
        let json;
        try {
            json = JSON.stringify($bd3QA(data, 'oldPassword', 'newPassword', 'newPasswordConfirm'));
        } catch (err) {
            console.error(err);
            this.trigger('error', err);
        }
        try {
            const resp = await fetch(new URL(this.url, window.location.origin), {
                body: json,
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const body = await resp.json();
            if (!resp.ok) {
                this.trigger('error', body);
                return;
            }
            this.trigger('sync', this);
        } catch (err) {
            return this.trigger('error', err);
        }
    },
    async login (username, password) {
        try {
            const resp = await fetch(new URL('/api/login', window.location.origin), {
                body: JSON.stringify({
                    username: username,
                    password: password
                }),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const body = await resp.json();
            if (!resp.ok) {
                this.trigger('error', body);
                return;
            }
            this.set(body);
            this.trigger('sync', this);
        } catch (err) {
            return this.trigger('error', err);
        }
    },
    async signup (username, password) {
        try {
            const resp = await fetch(new URL('/api/signup', window.location.origin), {
                body: JSON.stringify({
                    username: username,
                    password: password
                }),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const body = await resp.json();
            if (!resp.ok) {
                this.trigger('error', body);
                return;
            }
            this.set(body);
            this.trigger('sync', this);
        } catch (err) {
            return this.trigger('error', err);
        }
    },
    async logout () {
        try {
            const resp = await fetch(new URL('/api/logout', window.location.origin));
            if (!resp.ok) {
                this.trigger('error', new Error('logout failed'));
                return;
            }
            $4UX9c.clear();
            window.location.href = '/';
        } catch (err) {
            return this.trigger('error', err);
        }
    }
});


var $94bf63d05476b712$exports = {};

var $kw3w9 = parcelRequire("kw3w9");
var $995d26fdcc5ff982$exports = {};
/**
 * Parses an URI
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ var $995d26fdcc5ff982$var$re = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
var $995d26fdcc5ff982$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
$995d26fdcc5ff982$exports = function parseuri(str) {
    var src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    var m = $995d26fdcc5ff982$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$995d26fdcc5ff982$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $995d26fdcc5ff982$var$pathNames(uri, uri['path']);
    uri.queryKey = $995d26fdcc5ff982$var$queryKey(uri, uri['query']);
    return uri;
};
function $995d26fdcc5ff982$var$pathNames(obj, path) {
    var regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.substr(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.substr(path.length - 1, 1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $995d26fdcc5ff982$var$queryKey(uri, query) {
    var data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}


function $583f8651fd1e8807$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, (/*@__PURE__*/$parcel$interopDefault($995d26fdcc5ff982$exports)))(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}


/* global attachEvent */ // browser shim for xmlhttprequest module
var $3eb8b6cb32f872c5$exports = {};
/**
 * Module exports.
 *
 * Logic borrowed from Modernizr:
 *
 *   - https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cors.js
 */ try {
    $3eb8b6cb32f872c5$exports = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
    // if XMLHttp support is disabled in IE then it will throw
    // when trying to create
    $3eb8b6cb32f872c5$exports = false;
}


var $8cc3a64afb6c9bbe$export$2e2bcd8739ae039 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();


function $e5c05c94907a71cb$export$2e2bcd8739ae039(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, (/*@__PURE__*/$parcel$interopDefault($3eb8b6cb32f872c5$exports))))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $8cc3a64afb6c9bbe$export$2e2bcd8739ae039)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}




function $9fe1b1696023312a$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $9fe1b1696023312a$var$NATIVE_SET_TIMEOUT = setTimeout;
const $9fe1b1696023312a$var$NATIVE_CLEAR_TIMEOUT = clearTimeout;
function $9fe1b1696023312a$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $9fe1b1696023312a$var$NATIVE_SET_TIMEOUT.bind((0, $8cc3a64afb6c9bbe$export$2e2bcd8739ae039));
        obj.clearTimeoutFn = $9fe1b1696023312a$var$NATIVE_CLEAR_TIMEOUT.bind((0, $8cc3a64afb6c9bbe$export$2e2bcd8739ae039));
    } else {
        obj.setTimeoutFn = setTimeout.bind((0, $8cc3a64afb6c9bbe$export$2e2bcd8739ae039));
        obj.clearTimeoutFn = clearTimeout.bind((0, $8cc3a64afb6c9bbe$export$2e2bcd8739ae039));
    }
}


/**
 * Expose `Emitter`.
 */ var $22a4be8a64e1d6f1$export$4293555f241ae35a;
$22a4be8a64e1d6f1$export$4293555f241ae35a = $22a4be8a64e1d6f1$var$Emitter;
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $22a4be8a64e1d6f1$var$Emitter(obj) {
    if (obj) return $22a4be8a64e1d6f1$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $22a4be8a64e1d6f1$var$mixin(obj) {
    for(var key in $22a4be8a64e1d6f1$var$Emitter.prototype)obj[key] = $22a4be8a64e1d6f1$var$Emitter.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $22a4be8a64e1d6f1$var$Emitter.prototype.on = $22a4be8a64e1d6f1$var$Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $22a4be8a64e1d6f1$var$Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $22a4be8a64e1d6f1$var$Emitter.prototype.off = $22a4be8a64e1d6f1$var$Emitter.prototype.removeListener = $22a4be8a64e1d6f1$var$Emitter.prototype.removeAllListeners = $22a4be8a64e1d6f1$var$Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $22a4be8a64e1d6f1$var$Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$22a4be8a64e1d6f1$var$Emitter.prototype.emitReserved = $22a4be8a64e1d6f1$var$Emitter.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $22a4be8a64e1d6f1$var$Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $22a4be8a64e1d6f1$var$Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $bcb3e3f083bf1815$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$bcb3e3f083bf1815$export$c169aefb7330cccb["open"] = "0";
$bcb3e3f083bf1815$export$c169aefb7330cccb["close"] = "1";
$bcb3e3f083bf1815$export$c169aefb7330cccb["ping"] = "2";
$bcb3e3f083bf1815$export$c169aefb7330cccb["pong"] = "3";
$bcb3e3f083bf1815$export$c169aefb7330cccb["message"] = "4";
$bcb3e3f083bf1815$export$c169aefb7330cccb["upgrade"] = "5";
$bcb3e3f083bf1815$export$c169aefb7330cccb["noop"] = "6";
const $bcb3e3f083bf1815$export$47791e8004edd485 = Object.create(null);
Object.keys($bcb3e3f083bf1815$export$c169aefb7330cccb).forEach((key)=>{
    $bcb3e3f083bf1815$export$47791e8004edd485[$bcb3e3f083bf1815$export$c169aefb7330cccb[key]] = key;
});
const $bcb3e3f083bf1815$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $f965d02599a5f6b9$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $f965d02599a5f6b9$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $f965d02599a5f6b9$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $f965d02599a5f6b9$var$encodePacket = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($f965d02599a5f6b9$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $f965d02599a5f6b9$var$encodeBlobAsBase64(data, callback);
    } else if ($f965d02599a5f6b9$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $f965d02599a5f6b9$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $f965d02599a5f6b9$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $bcb3e3f083bf1815$export$c169aefb7330cccb)[type] + (data || ""));
};
const $f965d02599a5f6b9$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + content);
    };
    return fileReader.readAsDataURL(data);
};
var $f965d02599a5f6b9$export$2e2bcd8739ae039 = $f965d02599a5f6b9$var$encodePacket;



/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var $b24c91e1d1d04ae3$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $b24c91e1d1d04ae3$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(var $b24c91e1d1d04ae3$var$i = 0; $b24c91e1d1d04ae3$var$i < $b24c91e1d1d04ae3$var$chars.length; $b24c91e1d1d04ae3$var$i++)$b24c91e1d1d04ae3$var$lookup[$b24c91e1d1d04ae3$var$chars.charCodeAt($b24c91e1d1d04ae3$var$i)] = $b24c91e1d1d04ae3$var$i;
var $b24c91e1d1d04ae3$export$c564cdbbe6da493 = function(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $b24c91e1d1d04ae3$var$chars[bytes[i] >> 2];
        base64 += $b24c91e1d1d04ae3$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $b24c91e1d1d04ae3$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $b24c91e1d1d04ae3$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
var $b24c91e1d1d04ae3$export$2f872c0f2117be69 = function(base64) {
    var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $b24c91e1d1d04ae3$var$lookup[base64.charCodeAt(i)];
        encoded2 = $b24c91e1d1d04ae3$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $b24c91e1d1d04ae3$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $b24c91e1d1d04ae3$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $f2c6992bc4118e88$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $f2c6992bc4118e88$var$decodePacket = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $f2c6992bc4118e88$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $f2c6992bc4118e88$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $bcb3e3f083bf1815$export$47791e8004edd485)[type];
    if (!packetType) return 0, $bcb3e3f083bf1815$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $bcb3e3f083bf1815$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $bcb3e3f083bf1815$export$47791e8004edd485)[type]
    };
};
const $f2c6992bc4118e88$var$decodeBase64Packet = (data, binaryType)=>{
    if ($f2c6992bc4118e88$var$withNativeArrayBuffer) {
        const decoded = (0, $b24c91e1d1d04ae3$export$2f872c0f2117be69)(data);
        return $f2c6992bc4118e88$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $f2c6992bc4118e88$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            return data instanceof ArrayBuffer ? new Blob([
                data
            ]) : data;
        case "arraybuffer":
        default:
            return data; // assuming the data is already an ArrayBuffer
    }
};
var $f2c6992bc4118e88$export$2e2bcd8739ae039 = $f2c6992bc4118e88$var$decodePacket;


const $acd790c235bda168$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $acd790c235bda168$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $f965d02599a5f6b9$export$2e2bcd8739ae039)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($acd790c235bda168$var$SEPARATOR));
        });
    });
};
const $acd790c235bda168$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($acd790c235bda168$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $f2c6992bc4118e88$export$2e2bcd8739ae039)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
const $acd790c235bda168$export$a51d6b395ff4c65a = 4;




class $6a86655b71c0dda6$export$86495b081fef8e52 extends (0, $22a4be8a64e1d6f1$export$4293555f241ae35a) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} options.
     * @api private
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $9fe1b1696023312a$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.readyState = "";
        this.socket = opts.socket;
    }
    /**
     * Emits an error.
     *
     * @param {String} str
     * @return {Transport} for chaining
     * @api protected
     */ onError(msg, desc) {
        const err = new Error(msg);
        // @ts-ignore
        err.type = "TransportError";
        // @ts-ignore
        err.description = desc;
        super.emit("error", err);
        return this;
    }
    /**
     * Opens the transport.
     *
     * @api public
     */ open() {
        if ("closed" === this.readyState || "" === this.readyState) {
            this.readyState = "opening";
            this.doOpen();
        }
        return this;
    }
    /**
     * Closes the transport.
     *
     * @api public
     */ close() {
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     * @api public
     */ send(packets) {
        if ("open" === this.readyState) this.write(packets);
    }
    /**
     * Called upon open
     *
     * @api protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emit("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @api protected
     */ onData(data) {
        const packet = (0, $f2c6992bc4118e88$export$2e2bcd8739ae039)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @api protected
     */ onPacket(packet) {
        super.emit("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @api protected
     */ onClose() {
        this.readyState = "closed";
        super.emit("close");
    }
}


var $4063261197f5ad90$exports = {};
'use strict';
var $4063261197f5ad90$var$alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''), $4063261197f5ad90$var$length = 64, $4063261197f5ad90$var$map = {}, $4063261197f5ad90$var$seed = 0, $4063261197f5ad90$var$i = 0, $4063261197f5ad90$var$prev;
/**
 * Return a string representing the specified number.
 *
 * @param {Number} num The number to convert.
 * @returns {String} The string representation of the number.
 * @api public
 */ function $4063261197f5ad90$var$encode(num) {
    var encoded = '';
    do {
        encoded = $4063261197f5ad90$var$alphabet[num % $4063261197f5ad90$var$length] + encoded;
        num = Math.floor(num / $4063261197f5ad90$var$length);
    }while (num > 0);
    return encoded;
}
/**
 * Return the integer value specified by the given string.
 *
 * @param {String} str The string to convert.
 * @returns {Number} The integer value represented by the string.
 * @api public
 */ function $4063261197f5ad90$var$decode(str) {
    var decoded = 0;
    for($4063261197f5ad90$var$i = 0; $4063261197f5ad90$var$i < str.length; $4063261197f5ad90$var$i++)decoded = decoded * $4063261197f5ad90$var$length + $4063261197f5ad90$var$map[str.charAt($4063261197f5ad90$var$i)];
    return decoded;
}
/**
 * Yeast: A tiny growing id generator.
 *
 * @returns {String} A unique id.
 * @api public
 */ function $4063261197f5ad90$var$yeast() {
    var now = $4063261197f5ad90$var$encode(+new Date());
    if (now !== $4063261197f5ad90$var$prev) return $4063261197f5ad90$var$seed = 0, $4063261197f5ad90$var$prev = now;
    return now + '.' + $4063261197f5ad90$var$encode($4063261197f5ad90$var$seed++);
}
//
// Map each character to its index.
//
for(; $4063261197f5ad90$var$i < $4063261197f5ad90$var$length; $4063261197f5ad90$var$i++)$4063261197f5ad90$var$map[$4063261197f5ad90$var$alphabet[$4063261197f5ad90$var$i]] = $4063261197f5ad90$var$i;
//
// Expose the `yeast`, `encode` and `decode` functions.
//
$4063261197f5ad90$var$yeast.encode = $4063261197f5ad90$var$encode;
$4063261197f5ad90$var$yeast.decode = $4063261197f5ad90$var$decode;
$4063261197f5ad90$exports = $4063261197f5ad90$var$yeast;


var $562bae8ce997b3b3$exports = {};

$parcel$export($562bae8ce997b3b3$exports, "encode", function () { return $562bae8ce997b3b3$export$c564cdbbe6da493; }, function (v) { return $562bae8ce997b3b3$export$c564cdbbe6da493 = v; });
$parcel$export($562bae8ce997b3b3$exports, "decode", function () { return $562bae8ce997b3b3$export$2f872c0f2117be69; }, function (v) { return $562bae8ce997b3b3$export$2f872c0f2117be69 = v; });
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ var $562bae8ce997b3b3$export$c564cdbbe6da493;
/**
 * Parses a simple querystring into an object
 *
 * @param {String} qs
 * @api private
 */ var $562bae8ce997b3b3$export$2f872c0f2117be69;
$562bae8ce997b3b3$export$c564cdbbe6da493 = function(obj) {
    var str = '';
    for(var i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
};
$562bae8ce997b3b3$export$2f872c0f2117be69 = function(qs) {
    var qry = {};
    var pairs = qs.split('&');
    for(var i = 0, l = pairs.length; i < l; i++){
        var pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
};



class $6ac1e02a5bbfee6b$export$265ee5eefd4c309b extends (0, $6a86655b71c0dda6$export$86495b081fef8e52) {
    constructor(){
        super(...arguments);
        this.polling = false;
    }
    /**
     * Transport name.
     */ get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @api private
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} callback upon buffers are flushed and transport is paused
     * @api private
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @api public
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emit("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @api private
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose();
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $acd790c235bda168$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emit("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @api private
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} data packets
     * @param {Function} drain callback
     * @api private
     */ write(packets) {
        this.writable = false;
        (0, $acd790c235bda168$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emit("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @api private
     */ uri() {
        let query = this.query || {};
        const schema = this.opts.secure ? "https" : "http";
        let port = "";
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, (/*@__PURE__*/$parcel$interopDefault($4063261197f5ad90$exports)))();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        // avoid port if default for schema
        if (this.opts.port && ("https" === schema && Number(this.opts.port) !== 443 || "http" === schema && Number(this.opts.port) !== 80)) port = ":" + this.opts.port;
        const encodedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($562bae8ce997b3b3$exports))).encode(query);
        const ipv6 = this.opts.hostname.indexOf(":") !== -1;
        return schema + "://" + (ipv6 ? "[" + this.opts.hostname + "]" : this.opts.hostname) + port + this.opts.path + (encodedQuery.length ? "?" + encodedQuery : "");
    }
}


/**
 * Empty function
 */ function $2d8a6eb64c797688$var$empty() {}
const $2d8a6eb64c797688$var$hasXHR2 = function() {
    const xhr = new (0, $e5c05c94907a71cb$export$2e2bcd8739ae039)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $2d8a6eb64c797688$export$a2d42eb087c10497 extends (0, $6ac1e02a5bbfee6b$export$265ee5eefd4c309b) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @api public
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
            this.xs = opts.secure !== isSSL;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $2d8a6eb64c797688$var$hasXHR2 && !forceBase64;
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @api private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            xs: this.xs
        }, this.opts);
        return new $2d8a6eb64c797688$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @api private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (err)=>{
            this.onError("xhr post error", err);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @api private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (err)=>{
            this.onError("xhr poll error", err);
        });
        this.pollXhr = req;
    }
}
class $2d8a6eb64c797688$export$7fa6c5b6f8193917 extends (0, $22a4be8a64e1d6f1$export$4293555f241ae35a) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @api public
     */ constructor(uri, opts){
        super();
        (0, $9fe1b1696023312a$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.async = false !== opts.async;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @api private
     */ create() {
        const opts = (0, $9fe1b1696023312a$export$357523c63a2253b9)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        opts.xscheme = !!this.opts.xs;
        const xhr = this.xhr = new (0, $e5c05c94907a71cb$export$2e2bcd8739ae039)(opts);
        try {
            xhr.open(this.method, this.uri, this.async);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $2d8a6eb64c797688$export$7fa6c5b6f8193917.requestsCount++;
            $2d8a6eb64c797688$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon successful response.
     *
     * @api private
     */ onSuccess() {
        this.emit("success");
        this.cleanup();
    }
    /**
     * Called if we have data.
     *
     * @api private
     */ onData(data) {
        this.emit("data", data);
        this.onSuccess();
    }
    /**
     * Called upon error.
     *
     * @api private
     */ onError(err) {
        this.emit("error", err);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @api private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $2d8a6eb64c797688$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $2d8a6eb64c797688$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @api private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) this.onData(data);
    }
    /**
     * Aborts the request.
     *
     * @api public
     */ abort() {
        this.cleanup();
    }
}
$2d8a6eb64c797688$export$7fa6c5b6f8193917.requestsCount = 0;
$2d8a6eb64c797688$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $2d8a6eb64c797688$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $8cc3a64afb6c9bbe$export$2e2bcd8739ae039) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $2d8a6eb64c797688$var$unloadHandler, false);
    }
}
function $2d8a6eb64c797688$var$unloadHandler() {
    for(let i in $2d8a6eb64c797688$export$7fa6c5b6f8193917.requests)if ($2d8a6eb64c797688$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $2d8a6eb64c797688$export$7fa6c5b6f8193917.requests[i].abort();
}







const $1e1671c7089eb90e$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $1e1671c7089eb90e$export$3909fb301d3dc8c9 = (0, $8cc3a64afb6c9bbe$export$2e2bcd8739ae039).WebSocket || (0, $8cc3a64afb6c9bbe$export$2e2bcd8739ae039).MozWebSocket;
const $1e1671c7089eb90e$export$3407ba5dfb7a683d = true;
const $1e1671c7089eb90e$export$790dcbc41e2d75d5 = "arraybuffer";



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f2d83661a175a8e2$export$a143d493d941bafc;
var $f2d83661a175a8e2$export$e4cf37d7f6fb9e0a;
var $f2d83661a175a8e2$export$f99ded8fe4b79145;
var $f2d83661a175a8e2$export$599f31c3813fae4d;
'use strict';
var $a4abb7dbbc24add6$export$a48f0734ac7c2329;
var $a4abb7dbbc24add6$export$d622b2ad8d90c771;
var $a4abb7dbbc24add6$export$6100ba28696e12de;
'use strict';
$a4abb7dbbc24add6$export$a48f0734ac7c2329 = $a4abb7dbbc24add6$var$byteLength;
$a4abb7dbbc24add6$export$d622b2ad8d90c771 = $a4abb7dbbc24add6$var$toByteArray;
$a4abb7dbbc24add6$export$6100ba28696e12de = $a4abb7dbbc24add6$var$fromByteArray;
var $a4abb7dbbc24add6$var$lookup = [];
var $a4abb7dbbc24add6$var$revLookup = [];
var $a4abb7dbbc24add6$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $a4abb7dbbc24add6$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $a4abb7dbbc24add6$var$i = 0, $a4abb7dbbc24add6$var$len = $a4abb7dbbc24add6$var$code.length; $a4abb7dbbc24add6$var$i < $a4abb7dbbc24add6$var$len; ++$a4abb7dbbc24add6$var$i){
    $a4abb7dbbc24add6$var$lookup[$a4abb7dbbc24add6$var$i] = $a4abb7dbbc24add6$var$code[$a4abb7dbbc24add6$var$i];
    $a4abb7dbbc24add6$var$revLookup[$a4abb7dbbc24add6$var$code.charCodeAt($a4abb7dbbc24add6$var$i)] = $a4abb7dbbc24add6$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$a4abb7dbbc24add6$var$revLookup['-'.charCodeAt(0)] = 62;
$a4abb7dbbc24add6$var$revLookup['_'.charCodeAt(0)] = 63;
function $a4abb7dbbc24add6$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $a4abb7dbbc24add6$var$byteLength(b64) {
    var lens = $a4abb7dbbc24add6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $a4abb7dbbc24add6$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $a4abb7dbbc24add6$var$toByteArray(b64) {
    var tmp;
    var lens = $a4abb7dbbc24add6$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $a4abb7dbbc24add6$var$Arr($a4abb7dbbc24add6$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $a4abb7dbbc24add6$var$revLookup[b64.charCodeAt(i)] << 18 | $a4abb7dbbc24add6$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $a4abb7dbbc24add6$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $a4abb7dbbc24add6$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $a4abb7dbbc24add6$var$revLookup[b64.charCodeAt(i)] << 2 | $a4abb7dbbc24add6$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $a4abb7dbbc24add6$var$revLookup[b64.charCodeAt(i)] << 10 | $a4abb7dbbc24add6$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $a4abb7dbbc24add6$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $a4abb7dbbc24add6$var$tripletToBase64(num) {
    return $a4abb7dbbc24add6$var$lookup[num >> 18 & 0x3F] + $a4abb7dbbc24add6$var$lookup[num >> 12 & 0x3F] + $a4abb7dbbc24add6$var$lookup[num >> 6 & 0x3F] + $a4abb7dbbc24add6$var$lookup[num & 0x3F];
}
function $a4abb7dbbc24add6$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($a4abb7dbbc24add6$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $a4abb7dbbc24add6$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($a4abb7dbbc24add6$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($a4abb7dbbc24add6$var$lookup[tmp >> 2] + $a4abb7dbbc24add6$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($a4abb7dbbc24add6$var$lookup[tmp >> 10] + $a4abb7dbbc24add6$var$lookup[tmp >> 4 & 0x3F] + $a4abb7dbbc24add6$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $bb7c7cf5a55e61b4$export$aafa59e2e03f2942;
var $bb7c7cf5a55e61b4$export$68d8715fc104d294;
$bb7c7cf5a55e61b4$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$bb7c7cf5a55e61b4$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


var $f2d83661a175a8e2$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f2d83661a175a8e2$export$a143d493d941bafc = $f2d83661a175a8e2$var$Buffer;
$f2d83661a175a8e2$export$e4cf37d7f6fb9e0a = $f2d83661a175a8e2$var$SlowBuffer;
$f2d83661a175a8e2$export$f99ded8fe4b79145 = 50;
var $f2d83661a175a8e2$var$K_MAX_LENGTH = 0x7fffffff;
$f2d83661a175a8e2$export$599f31c3813fae4d = $f2d83661a175a8e2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f2d83661a175a8e2$var$Buffer.TYPED_ARRAY_SUPPORT = $f2d83661a175a8e2$var$typedArraySupport();
if (!$f2d83661a175a8e2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f2d83661a175a8e2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f2d83661a175a8e2$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$f2d83661a175a8e2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f2d83661a175a8e2$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$f2d83661a175a8e2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f2d83661a175a8e2$var$createBuffer(length) {
    if (length > $f2d83661a175a8e2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f2d83661a175a8e2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f2d83661a175a8e2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f2d83661a175a8e2$var$allocUnsafe(arg);
    }
    return $f2d83661a175a8e2$var$from(arg, encodingOrOffset, length);
}
$f2d83661a175a8e2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f2d83661a175a8e2$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f2d83661a175a8e2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f2d83661a175a8e2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f2d83661a175a8e2$var$isInstance(value, ArrayBuffer) || value && $f2d83661a175a8e2$var$isInstance(value.buffer, ArrayBuffer)) return $f2d83661a175a8e2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f2d83661a175a8e2$var$isInstance(value, SharedArrayBuffer) || value && $f2d83661a175a8e2$var$isInstance(value.buffer, SharedArrayBuffer))) return $f2d83661a175a8e2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f2d83661a175a8e2$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $f2d83661a175a8e2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f2d83661a175a8e2$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f2d83661a175a8e2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f2d83661a175a8e2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f2d83661a175a8e2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f2d83661a175a8e2$var$Buffer, Uint8Array);
function $f2d83661a175a8e2$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f2d83661a175a8e2$var$alloc(size, fill, encoding) {
    $f2d83661a175a8e2$var$assertSize(size);
    if (size <= 0) return $f2d83661a175a8e2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f2d83661a175a8e2$var$createBuffer(size).fill(fill, encoding) : $f2d83661a175a8e2$var$createBuffer(size).fill(fill);
    return $f2d83661a175a8e2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f2d83661a175a8e2$var$Buffer.alloc = function(size, fill, encoding) {
    return $f2d83661a175a8e2$var$alloc(size, fill, encoding);
};
function $f2d83661a175a8e2$var$allocUnsafe(size) {
    $f2d83661a175a8e2$var$assertSize(size);
    return $f2d83661a175a8e2$var$createBuffer(size < 0 ? 0 : $f2d83661a175a8e2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f2d83661a175a8e2$var$Buffer.allocUnsafe = function(size) {
    return $f2d83661a175a8e2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f2d83661a175a8e2$var$Buffer.allocUnsafeSlow = function(size) {
    return $f2d83661a175a8e2$var$allocUnsafe(size);
};
function $f2d83661a175a8e2$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f2d83661a175a8e2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    var length = $f2d83661a175a8e2$var$byteLength(string, encoding) | 0;
    var buf = $f2d83661a175a8e2$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f2d83661a175a8e2$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $f2d83661a175a8e2$var$checked(array.length) | 0;
    var buf = $f2d83661a175a8e2$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f2d83661a175a8e2$var$fromArrayView(arrayView) {
    if ($f2d83661a175a8e2$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $f2d83661a175a8e2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f2d83661a175a8e2$var$fromArrayLike(arrayView);
}
function $f2d83661a175a8e2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f2d83661a175a8e2$var$Buffer.prototype);
    return buf;
}
function $f2d83661a175a8e2$var$fromObject(obj) {
    if ($f2d83661a175a8e2$var$Buffer.isBuffer(obj)) {
        var len = $f2d83661a175a8e2$var$checked(obj.length) | 0;
        var buf = $f2d83661a175a8e2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f2d83661a175a8e2$var$numberIsNaN(obj.length)) return $f2d83661a175a8e2$var$createBuffer(0);
        return $f2d83661a175a8e2$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f2d83661a175a8e2$var$fromArrayLike(obj.data);
}
function $f2d83661a175a8e2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f2d83661a175a8e2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f2d83661a175a8e2$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f2d83661a175a8e2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f2d83661a175a8e2$var$Buffer.alloc(+length);
}
$f2d83661a175a8e2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f2d83661a175a8e2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f2d83661a175a8e2$var$Buffer.compare = function compare(a, b) {
    if ($f2d83661a175a8e2$var$isInstance(a, Uint8Array)) a = $f2d83661a175a8e2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f2d83661a175a8e2$var$isInstance(b, Uint8Array)) b = $f2d83661a175a8e2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f2d83661a175a8e2$var$Buffer.isBuffer(a) || !$f2d83661a175a8e2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f2d83661a175a8e2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f2d83661a175a8e2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f2d83661a175a8e2$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $f2d83661a175a8e2$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($f2d83661a175a8e2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $f2d83661a175a8e2$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f2d83661a175a8e2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f2d83661a175a8e2$var$byteLength(string, encoding) {
    if ($f2d83661a175a8e2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f2d83661a175a8e2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f2d83661a175a8e2$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f2d83661a175a8e2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f2d83661a175a8e2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f2d83661a175a8e2$var$Buffer.byteLength = $f2d83661a175a8e2$var$byteLength;
function $f2d83661a175a8e2$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f2d83661a175a8e2$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f2d83661a175a8e2$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f2d83661a175a8e2$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f2d83661a175a8e2$var$latin1Slice(this, start, end);
        case 'base64':
            return $f2d83661a175a8e2$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f2d83661a175a8e2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f2d83661a175a8e2$var$Buffer.prototype._isBuffer = true;
function $f2d83661a175a8e2$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f2d83661a175a8e2$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(var i = 0; i < len; i += 2)$f2d83661a175a8e2$var$swap(this, i, i + 1);
    return this;
};
$f2d83661a175a8e2$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(var i = 0; i < len; i += 4){
        $f2d83661a175a8e2$var$swap(this, i, i + 3);
        $f2d83661a175a8e2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f2d83661a175a8e2$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(var i = 0; i < len; i += 8){
        $f2d83661a175a8e2$var$swap(this, i, i + 7);
        $f2d83661a175a8e2$var$swap(this, i + 1, i + 6);
        $f2d83661a175a8e2$var$swap(this, i + 2, i + 5);
        $f2d83661a175a8e2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f2d83661a175a8e2$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f2d83661a175a8e2$var$utf8Slice(this, 0, length);
    return $f2d83661a175a8e2$var$slowToString.apply(this, arguments);
};
$f2d83661a175a8e2$var$Buffer.prototype.toLocaleString = $f2d83661a175a8e2$var$Buffer.prototype.toString;
$f2d83661a175a8e2$var$Buffer.prototype.equals = function equals(b) {
    if (!$f2d83661a175a8e2$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f2d83661a175a8e2$var$Buffer.compare(this, b) === 0;
};
$f2d83661a175a8e2$var$Buffer.prototype.inspect = function inspect() {
    var str = '';
    var max = $f2d83661a175a8e2$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f2d83661a175a8e2$var$customInspectSymbol) $f2d83661a175a8e2$var$Buffer.prototype[$f2d83661a175a8e2$var$customInspectSymbol] = $f2d83661a175a8e2$var$Buffer.prototype.inspect;
$f2d83661a175a8e2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f2d83661a175a8e2$var$isInstance(target, Uint8Array)) target = $f2d83661a175a8e2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f2d83661a175a8e2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f2d83661a175a8e2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f2d83661a175a8e2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f2d83661a175a8e2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f2d83661a175a8e2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f2d83661a175a8e2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f2d83661a175a8e2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f2d83661a175a8e2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f2d83661a175a8e2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f2d83661a175a8e2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f2d83661a175a8e2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f2d83661a175a8e2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f2d83661a175a8e2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f2d83661a175a8e2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f2d83661a175a8e2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f2d83661a175a8e2$var$utf8Write(buf, string, offset, length) {
    return $f2d83661a175a8e2$var$blitBuffer($f2d83661a175a8e2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f2d83661a175a8e2$var$asciiWrite(buf, string, offset, length) {
    return $f2d83661a175a8e2$var$blitBuffer($f2d83661a175a8e2$var$asciiToBytes(string), buf, offset, length);
}
function $f2d83661a175a8e2$var$base64Write(buf, string, offset, length) {
    return $f2d83661a175a8e2$var$blitBuffer($f2d83661a175a8e2$var$base64ToBytes(string), buf, offset, length);
}
function $f2d83661a175a8e2$var$ucs2Write(buf, string, offset, length) {
    return $f2d83661a175a8e2$var$blitBuffer($f2d83661a175a8e2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f2d83661a175a8e2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    var loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f2d83661a175a8e2$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f2d83661a175a8e2$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f2d83661a175a8e2$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f2d83661a175a8e2$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f2d83661a175a8e2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f2d83661a175a8e2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f2d83661a175a8e2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $a4abb7dbbc24add6$export$6100ba28696e12de(buf);
    else return $a4abb7dbbc24add6$export$6100ba28696e12de(buf.slice(start, end));
}
function $f2d83661a175a8e2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f2d83661a175a8e2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $f2d83661a175a8e2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f2d83661a175a8e2$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $f2d83661a175a8e2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = '';
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f2d83661a175a8e2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f2d83661a175a8e2$var$asciiSlice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f2d83661a175a8e2$var$latin1Slice(buf, start, end) {
    var ret = '';
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f2d83661a175a8e2$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = '';
    for(var i = start; i < end; ++i)out += $f2d83661a175a8e2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f2d83661a175a8e2$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f2d83661a175a8e2$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f2d83661a175a8e2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f2d83661a175a8e2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f2d83661a175a8e2$var$Buffer.prototype.readUintLE = $f2d83661a175a8e2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f2d83661a175a8e2$var$Buffer.prototype.readUintBE = $f2d83661a175a8e2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f2d83661a175a8e2$var$Buffer.prototype.readUint8 = $f2d83661a175a8e2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f2d83661a175a8e2$var$Buffer.prototype.readUint16LE = $f2d83661a175a8e2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f2d83661a175a8e2$var$Buffer.prototype.readUint16BE = $f2d83661a175a8e2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f2d83661a175a8e2$var$Buffer.prototype.readUint32LE = $f2d83661a175a8e2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f2d83661a175a8e2$var$Buffer.prototype.readUint32BE = $f2d83661a175a8e2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f2d83661a175a8e2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f2d83661a175a8e2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f2d83661a175a8e2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f2d83661a175a8e2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f2d83661a175a8e2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f2d83661a175a8e2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f2d83661a175a8e2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f2d83661a175a8e2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 4, this.length);
    return $bb7c7cf5a55e61b4$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$f2d83661a175a8e2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 4, this.length);
    return $bb7c7cf5a55e61b4$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$f2d83661a175a8e2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 8, this.length);
    return $bb7c7cf5a55e61b4$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$f2d83661a175a8e2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkOffset(offset, 8, this.length);
    return $bb7c7cf5a55e61b4$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $f2d83661a175a8e2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f2d83661a175a8e2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f2d83661a175a8e2$var$Buffer.prototype.writeUintLE = $f2d83661a175a8e2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f2d83661a175a8e2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeUintBE = $f2d83661a175a8e2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f2d83661a175a8e2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeUint8 = $f2d83661a175a8e2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeUint16LE = $f2d83661a175a8e2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeUint16BE = $f2d83661a175a8e2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeUint32LE = $f2d83661a175a8e2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeUint32BE = $f2d83661a175a8e2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f2d83661a175a8e2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $f2d83661a175a8e2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f2d83661a175a8e2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f2d83661a175a8e2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f2d83661a175a8e2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $bb7c7cf5a55e61b4$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f2d83661a175a8e2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f2d83661a175a8e2$var$writeFloat(this, value, offset, true, noAssert);
};
$f2d83661a175a8e2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f2d83661a175a8e2$var$writeFloat(this, value, offset, false, noAssert);
};
function $f2d83661a175a8e2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f2d83661a175a8e2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $bb7c7cf5a55e61b4$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f2d83661a175a8e2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f2d83661a175a8e2$var$writeDouble(this, value, offset, true, noAssert);
};
$f2d83661a175a8e2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f2d83661a175a8e2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f2d83661a175a8e2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f2d83661a175a8e2$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f2d83661a175a8e2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f2d83661a175a8e2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $f2d83661a175a8e2$var$Buffer.isBuffer(val) ? val : $f2d83661a175a8e2$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $f2d83661a175a8e2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f2d83661a175a8e2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f2d83661a175a8e2$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f2d83661a175a8e2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f2d83661a175a8e2$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f2d83661a175a8e2$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f2d83661a175a8e2$var$base64ToBytes(str) {
    return $a4abb7dbbc24add6$export$d622b2ad8d90c771($f2d83661a175a8e2$var$base64clean(str));
}
function $f2d83661a175a8e2$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f2d83661a175a8e2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f2d83661a175a8e2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $f2d83661a175a8e2$var$hexSliceLookupTable = function() {
    var alphabet = '0123456789abcdef';
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();


var $c5fc61c2dd8abb4c$require$Buffer = $f2d83661a175a8e2$export$a143d493d941bafc;
// detect ReactNative environment
const $c5fc61c2dd8abb4c$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $c5fc61c2dd8abb4c$export$911baa0677ac404c extends (0, $6a86655b71c0dda6$export$86495b081fef8e52) {
    /**
     * WebSocket transport constructor.
     *
     * @api {Object} connection options
     * @api public
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Transport name.
     *
     * @api public
     */ get name() {
        return "websocket";
    }
    /**
     * Opens socket.
     *
     * @api private
     */ doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $c5fc61c2dd8abb4c$var$isReactNative ? {} : (0, $9fe1b1696023312a$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $1e1671c7089eb90e$export$3407ba5dfb7a683d) && !$c5fc61c2dd8abb4c$var$isReactNative ? protocols ? new (0, $1e1671c7089eb90e$export$3909fb301d3dc8c9)(uri, protocols) : new (0, $1e1671c7089eb90e$export$3909fb301d3dc8c9)(uri) : new (0, $1e1671c7089eb90e$export$3909fb301d3dc8c9)(uri, protocols, opts);
        } catch (err) {
            return this.emit("error", err);
        }
        this.ws.binaryType = this.socket.binaryType || (0, $1e1671c7089eb90e$export$790dcbc41e2d75d5);
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @api private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = this.onClose.bind(this);
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    /**
     * Writes data to socket.
     *
     * @param {Array} array of packets.
     * @api private
     */ write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $f965d02599a5f6b9$export$2e2bcd8739ae039)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $1e1671c7089eb90e$export$3407ba5dfb7a683d)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = "string" === typeof data ? $c5fc61c2dd8abb4c$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $1e1671c7089eb90e$export$3407ba5dfb7a683d) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $1e1671c7089eb90e$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emit("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    /**
     * Closes socket.
     *
     * @api private
     */ doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @api private
     */ uri() {
        let query = this.query || {};
        const schema = this.opts.secure ? "wss" : "ws";
        let port = "";
        // avoid port if default for schema
        if (this.opts.port && ("wss" === schema && Number(this.opts.port) !== 443 || "ws" === schema && Number(this.opts.port) !== 80)) port = ":" + this.opts.port;
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, (/*@__PURE__*/$parcel$interopDefault($4063261197f5ad90$exports)))();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        const encodedQuery = (0, (/*@__PURE__*/$parcel$interopDefault($562bae8ce997b3b3$exports))).encode(query);
        const ipv6 = this.opts.hostname.indexOf(":") !== -1;
        return schema + "://" + (ipv6 ? "[" + this.opts.hostname + "]" : this.opts.hostname) + port + this.opts.path + (encodedQuery.length ? "?" + encodedQuery : "");
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @api public
     */ check() {
        return !!(0, $1e1671c7089eb90e$export$3909fb301d3dc8c9) && !("__initialize" in (0, $1e1671c7089eb90e$export$3909fb301d3dc8c9) && this.name === $c5fc61c2dd8abb4c$export$911baa0677ac404c.prototype.name);
    }
}


const $34a26f1bf12bf06d$export$46dec00755c1153b = {
    websocket: (0, $c5fc61c2dd8abb4c$export$911baa0677ac404c),
    polling: (0, $2d8a6eb64c797688$export$a2d42eb087c10497)
};







class $e75ecc2d99c35f41$export$4798917dbf149b79 extends (0, $22a4be8a64e1d6f1$export$4293555f241ae35a) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri or options
     * @param {Object} opts - options
     * @api public
     */ constructor(uri, opts = {}){
        super();
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, (/*@__PURE__*/$parcel$interopDefault($995d26fdcc5ff982$exports)))(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, (/*@__PURE__*/$parcel$interopDefault($995d26fdcc5ff982$exports)))(opts.host).host;
        (0, $9fe1b1696023312a$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket"
        ];
        this.readyState = "";
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: true
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + "/";
        if (typeof this.opts.query === "string") this.opts.query = (0, (/*@__PURE__*/$parcel$interopDefault($562bae8ce997b3b3$exports))).decode(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
            // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
            // closed/reloaded)
            addEventListener("beforeunload", ()=>{
                if (this.transport) {
                    // silently close the transport
                    this.transport.removeAllListeners();
                    this.transport.close();
                }
            }, false);
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close");
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} transport name
     * @return {Transport}
     * @api private
     */ createTransport(name) {
        const query = $e75ecc2d99c35f41$var$clone(this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $acd790c235bda168$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts.transportOptions[name], this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        });
        return new (0, $34a26f1bf12bf06d$export$46dec00755c1153b)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @api private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $e75ecc2d99c35f41$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @api private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", ()=>{
            this.onClose("transport close");
        });
    }
    /**
     * Probes a transport.
     *
     * @param {String} transport name
     * @api private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $e75ecc2d99c35f41$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $e75ecc2d99c35f41$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @api private
     */ onOpen() {
        this.readyState = "open";
        $e75ecc2d99c35f41$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade && this.transport.pause) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @api private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.resetPingTimeout();
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @api private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @api private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @api private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @api private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            this.transport.send(this.writeBuffer);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = this.writeBuffer.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Sends a message.
     *
     * @param {String} message.
     * @param {Function} callback function.
     * @param {Object} options.
     * @return {Socket} for chaining.
     * @api public
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} callback function.
     * @api private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     *
     * @api public
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @api private
     */ onError(err) {
        $e75ecc2d99c35f41$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @api private
     */ onClose(reason, desc) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") removeEventListener("offline", this.offlineEventListener, false);
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, desc);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} server upgrades
     * @api private
     *
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
$e75ecc2d99c35f41$export$4798917dbf149b79.protocol = (0, $acd790c235bda168$export$a51d6b395ff4c65a);
function $e75ecc2d99c35f41$var$clone(obj) {
    const o = {};
    for(let i in obj)if (obj.hasOwnProperty(i)) o[i] = obj[i];
    return o;
}





const $2bd9e4447814113f$export$a51d6b395ff4c65a = (0, $e75ecc2d99c35f41$export$4798917dbf149b79).protocol;


var $0e4688061aaafbe2$exports = {};

$parcel$export($0e4688061aaafbe2$exports, "protocol", function () { return $0e4688061aaafbe2$export$a51d6b395ff4c65a; });
$parcel$export($0e4688061aaafbe2$exports, "PacketType", function () { return $0e4688061aaafbe2$export$84d4095e16c6fc19; });
$parcel$export($0e4688061aaafbe2$exports, "Encoder", function () { return $0e4688061aaafbe2$export$a50aceb0e02a00aa; });
$parcel$export($0e4688061aaafbe2$exports, "Decoder", function () { return $0e4688061aaafbe2$export$f9de6ca0bc043724; });

const $63bd28bf41239782$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $63bd28bf41239782$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $63bd28bf41239782$var$toString = Object.prototype.toString;
const $63bd28bf41239782$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $63bd28bf41239782$var$toString.call(Blob) === "[object BlobConstructor]";
const $63bd28bf41239782$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $63bd28bf41239782$var$toString.call(File) === "[object FileConstructor]";
function $63bd28bf41239782$export$37488ff1135b1696(obj) {
    return $63bd28bf41239782$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $63bd28bf41239782$var$isView(obj)) || $63bd28bf41239782$var$withNativeBlob && obj instanceof Blob || $63bd28bf41239782$var$withNativeFile && obj instanceof File;
}
function $63bd28bf41239782$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($63bd28bf41239782$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($63bd28bf41239782$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $63bd28bf41239782$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $63bd28bf41239782$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $4f26f1bad98f895b$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $4f26f1bad98f895b$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $4f26f1bad98f895b$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $63bd28bf41239782$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $4f26f1bad98f895b$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $4f26f1bad98f895b$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $4f26f1bad98f895b$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $4f26f1bad98f895b$var$_reconstructPacket(packet.data, buffers);
    packet.attachments = undefined; // no longer useful
    return packet;
}
function $4f26f1bad98f895b$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
    else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $4f26f1bad98f895b$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $4f26f1bad98f895b$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



const $0e4688061aaafbe2$export$a51d6b395ff4c65a = 5;
var $0e4688061aaafbe2$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($0e4688061aaafbe2$export$84d4095e16c6fc19 || ($0e4688061aaafbe2$export$84d4095e16c6fc19 = {}));
class $0e4688061aaafbe2$export$a50aceb0e02a00aa {
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $0e4688061aaafbe2$export$84d4095e16c6fc19.EVENT || obj.type === $0e4688061aaafbe2$export$84d4095e16c6fc19.ACK) {
            if ((0, $63bd28bf41239782$export$5234c529abdb5610)(obj)) {
                obj.type = obj.type === $0e4688061aaafbe2$export$84d4095e16c6fc19.EVENT ? $0e4688061aaafbe2$export$84d4095e16c6fc19.BINARY_EVENT : $0e4688061aaafbe2$export$84d4095e16c6fc19.BINARY_ACK;
                return this.encodeAsBinary(obj);
            }
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $0e4688061aaafbe2$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $0e4688061aaafbe2$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $4f26f1bad98f895b$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
class $0e4688061aaafbe2$export$f9de6ca0bc043724 extends (0, $22a4be8a64e1d6f1$export$4293555f241ae35a) {
    constructor(){
        super();
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            packet = this.decodeString(obj);
            if (packet.type === $0e4688061aaafbe2$export$84d4095e16c6fc19.BINARY_EVENT || packet.type === $0e4688061aaafbe2$export$84d4095e16c6fc19.BINARY_ACK) {
                // binary packet's json
                this.reconstructor = new $0e4688061aaafbe2$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $63bd28bf41239782$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($0e4688061aaafbe2$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $0e4688061aaafbe2$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $0e4688061aaafbe2$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = $0e4688061aaafbe2$var$tryParse(str.substr(i));
            if ($0e4688061aaafbe2$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $0e4688061aaafbe2$export$84d4095e16c6fc19.CONNECT:
                return typeof payload === "object";
            case $0e4688061aaafbe2$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $0e4688061aaafbe2$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || typeof payload === "object";
            case $0e4688061aaafbe2$export$84d4095e16c6fc19.EVENT:
            case $0e4688061aaafbe2$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && payload.length > 0;
            case $0e4688061aaafbe2$export$84d4095e16c6fc19.ACK:
            case $0e4688061aaafbe2$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) this.reconstructor.finishedReconstruction();
    }
}
function $0e4688061aaafbe2$var$tryParse(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return false;
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $0e4688061aaafbe2$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $4f26f1bad98f895b$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}


function $438b898b4746cc7d$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $5a813240b0fd33de$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $5a813240b0fd33de$export$4798917dbf149b79 extends (0, $22a4be8a64e1d6f1$export$4293555f241ae35a) {
    /**
     * `Socket` constructor.
     *
     * @public
     */ constructor(io, nsp, opts){
        super();
        this.connected = false;
        this.disconnected = true;
        this.receiveBuffer = [];
        this.sendBuffer = [];
        this.ids = 0;
        this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        if (this.io._autoConnect) this.open();
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $438b898b4746cc7d$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $438b898b4746cc7d$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $438b898b4746cc7d$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $438b898b4746cc7d$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @public
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for connect()
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * @return self
     * @public
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @return self
     * @public
     */ emit(ev, ...args) {
        if ($5a813240b0fd33de$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev + '" is a reserved event name');
        args.unshift(ev);
        const packet = {
            type: (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) this.packet(packet);
        else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        const timeout = this.flags.timeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        this.acks[id] = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, [
                null,
                ...args
            ]);
        };
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this.packet({
                type: (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).CONNECT,
                data: data
            });
        });
        else this.packet({
            type: (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).CONNECT,
            data: this.auth
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @private
     */ onclose(reason) {
        this.connected = false;
        this.disconnected = true;
        delete this.id;
        this.emitReserved("disconnect", reason);
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) {
                    const id = packet.data.sid;
                    this.onconnect(id);
                } else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).EVENT:
                this.onevent(packet);
                break;
            case (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).ACK:
                this.onack(packet);
                break;
            case (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowlegement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if ("function" === typeof ack) {
            ack.apply(this, packet.data);
            delete this.acks[packet.id];
        }
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id) {
        this.id = id;
        this.connected = true;
        this.disconnected = false;
        this.emitBuffered();
        this.emitReserved("connect");
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>this.packet(packet));
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually.
     *
     * @return self
     * @public
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $0e4688061aaafbe2$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for disconnect()
     *
     * @return self
     * @public
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     * @public
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @returns self
     * @public
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * ```
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     * ```
     *
     * @returns self
     * @public
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @param listener
     * @public
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @param listener
     * @public
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @param listener
     * @public
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     *
     * @public
     */ listenersAny() {
        return this._anyListeners || [];
    }
}




var $4a30f2e3639ae2c0$exports = {};
/**
 * Expose `Backoff`.
 */ $4a30f2e3639ae2c0$exports = $4a30f2e3639ae2c0$var$Backoff;
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $4a30f2e3639ae2c0$var$Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $4a30f2e3639ae2c0$var$Backoff.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $4a30f2e3639ae2c0$var$Backoff.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $4a30f2e3639ae2c0$var$Backoff.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $4a30f2e3639ae2c0$var$Backoff.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $4a30f2e3639ae2c0$var$Backoff.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $a7ac055fc34b4019$export$d0d38e7dec7a1a61 extends (0, $22a4be8a64e1d6f1$export$4293555f241ae35a) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $9fe1b1696023312a$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, (/*@__PURE__*/$parcel$interopDefault($4a30f2e3639ae2c0$exports)))({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $0e4688061aaafbe2$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $e75ecc2d99c35f41$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $438b898b4746cc7d$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        // emit `error`
        const errorSub = (0, $438b898b4746cc7d$export$af631764ddc44097)(socket, "error", (err)=>{
            self.cleanup();
            self._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            self.maybeReconnectOnOpen();
        });
        if (false !== this._timeout) {
            const timeout = this._timeout;
            if (timeout === 0) openSubDestroy(); // prevents a race condition with the 'open' event
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                socket.close();
                // @ts-ignore
                socket.emit("error", new Error("timeout"));
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(function subDestroy() {
                clearTimeout(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $438b898b4746cc7d$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $438b898b4746cc7d$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $438b898b4746cc7d$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $438b898b4746cc7d$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), (0, $438b898b4746cc7d$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        this.decoder.add(data);
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        this.emitReserved("packet", packet);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $5a813240b0fd33de$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        }
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(function subDestroy() {
                clearTimeout(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}




/**
 * Managers cache.
 */ const $e9b2362a230a4d0b$var$cache = {};
function $e9b2362a230a4d0b$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $583f8651fd1e8807$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $e9b2362a230a4d0b$var$cache[id] && path in $e9b2362a230a4d0b$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $a7ac055fc34b4019$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$e9b2362a230a4d0b$var$cache[id]) $e9b2362a230a4d0b$var$cache[id] = new (0, $a7ac055fc34b4019$export$d0d38e7dec7a1a61)(source, opts);
        io = $e9b2362a230a4d0b$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($e9b2362a230a4d0b$export$841407ceb083bd74, {
    Manager: $a7ac055fc34b4019$export$d0d38e7dec7a1a61,
    Socket: $5a813240b0fd33de$export$4798917dbf149b79,
    io: $e9b2362a230a4d0b$export$841407ceb083bd74,
    connect: $e9b2362a230a4d0b$export$841407ceb083bd74
});


var $94bf63d05476b712$require$io = $e9b2362a230a4d0b$export$841407ceb083bd74;

var $gvQO6 = parcelRequire("gvQO6");
var $94bf63d05476b712$require$logger = $gvQO6.logger;
const $94bf63d05476b712$var$log = $94bf63d05476b712$require$logger.extend('changes');
const $94bf63d05476b712$var$ENDPOINT = window.location.origin;
$94bf63d05476b712$exports = $kw3w9.extend({
    props: {
        eventId: [
            'string'
        ],
        online: [
            'boolean',
            true,
            false
        ]
    },
    initialize () {
        this.on('change:eventId', this.start, this);
    },
    start () {
        if (this.socket) this.socket.disconnect();
        const namespace = `${$94bf63d05476b712$var$ENDPOINT}/${this.eventId}`;
        $94bf63d05476b712$var$log(`connecting to ${namespace}`);
        this.socket = $94bf63d05476b712$require$io(namespace);
        this.socket.on('change', this.onChange.bind(this));
        this.socket.on('connect', this.onConnect.bind(this));
        this.socket.on('connect_error', this.onConnectError.bind(this));
    },
    onConnect () {
        const transport = this.socket.io.engine.transport.name // in most cases, "polling"
        ;
        $94bf63d05476b712$var$log(`connected (${transport})`);
        this.socket.io.engine.on('upgrade', ()=>{
            const upgradedTransport = this.socket.io.engine.transport.name // in most cases, "websocket"
            ;
            $94bf63d05476b712$var$log(`upgrade: ${transport} -> ${upgradedTransport}`);
        });
        this.online = true;
    },
    onConnectError (error) {
        $94bf63d05476b712$var$log(`error: ${error.message}`);
        this.online = false;
    },
    onChange (change) {
        $94bf63d05476b712$var$log('change: %o', change);
        this.trigger(change.table, change);
    }
});


var $74281df9c41952b9$exports = {};

var $4UX9c = parcelRequire("4UX9c");

var $gvQO6 = parcelRequire("gvQO6");
var $74281df9c41952b9$require$byLocationSortPosition = $gvQO6.byLocationSortPosition;




/*
 Collection representing a list of locations
 */ $74281df9c41952b9$exports = $8dd5675b2fc15f09$exports.extend({
    url () {
        return `/api/events/${$4UX9c.me.currentEvent.slug}/locations`;
    },
    model (attrs, opts) {
        switch(attrs.type){
            case 'storage':
            case 'crash':
                return new $4bc923eea69c0571$exports(attrs, opts);
            case 'bar':
                return new $f6ea85ea97c73a0a$exports(attrs, opts);
            default:
                return new $c870001684b42152$exports(attrs, opts);
        }
    },
    isModel (model) {
        return model instanceof $4bc923eea69c0571$exports || model instanceof $f6ea85ea97c73a0a$exports || model instanceof $c870001684b42152$exports;
    },
    // cache options
    storageKey () {
        return `${$4UX9c.me.currentEvent.slug}-locations`;
    },
    comparator: $74281df9c41952b9$require$byLocationSortPosition,
    initialize () {
        $8dd5675b2fc15f09$exports.prototype.initialize.apply(this);
        // listen to remote changes
        this.listenTo($4UX9c.changes, 'locations', this.onChange);
        this.on('change:sortPosition', this.onSortChange, this);
    },
    onSortChange () {
        // delay to nextTick, so all changes have been set
        setTimeout(()=>this.sort(), 0);
    },
    onChange (change) {
        // don't react to inserts to avoid github.com/klaemo/booze-boy-client/issues/14
        if (change.type === 'update' || change.type === 'insert') this.set(change.row, {
            remove: false
        });
        if (change.type === 'delete') this.remove(change.id);
    },
    onError (error) {
        console.error(error);
    }
});



var $9863202fb86dd559$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $4UX9c = parcelRequire("4UX9c");
var $6beb558f93ddfdf2$exports = {};
function $6beb558f93ddfdf2$var$isHTMLElement(obj) {
    return obj && typeof obj === 'object' && obj.nodeType === 1 && typeof obj.style === 'object' && typeof obj.ownerDocument === 'object';
}
function $6beb558f93ddfdf2$var$isA(obj) {
    return $6beb558f93ddfdf2$var$isHTMLElement(obj) && obj.tagName === 'A';
}
function $6beb558f93ddfdf2$var$closestA(checkNode) {
    do {
        if ($6beb558f93ddfdf2$var$isA(checkNode)) return checkNode;
    }while (checkNode = checkNode.parentNode);
}
function $6beb558f93ddfdf2$var$normalizeLeadingSlash(pathname) {
    if (pathname.charAt(0) !== '/') pathname = '/' + pathname;
    return pathname;
}
function $6beb558f93ddfdf2$var$isRelativeUrl(href) {
    var r = /^https?:\/\/|^\/\//i;
    return !r.test(href);
}
function $6beb558f93ddfdf2$var$isSecondaryButton(event) {
    return typeof event === 'object' && 'button' in event && event.button !== 0;
}
// [1] http://blogs.msdn.com/b/ieinternals/archive/2011/02/28/internet-explorer-window-location-pathname-missing-slash-and-host-has-port.aspx
// [2] https://github.com/substack/catch-links/blob/7aee219cdc2c845c78caad6070886a9380b90e4c/index.js#L13-L17
// [3] IE10 (and possibly later) report that anchor.port is the default port
//     but dont append it to the hostname, so if the host doesnt end with the port
//     append it to the anchor host as well
function $6beb558f93ddfdf2$var$isLocal(event, anchor, lookForHash) {
    event || (event = {});
    // Skip modifier events
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return null;
    // Skip non-primary clicks
    if ($6beb558f93ddfdf2$var$isSecondaryButton(event)) return null;
    // If we have an anchor but its not an A tag
    // try to find the closest one
    if (anchor && !$6beb558f93ddfdf2$var$isA(anchor)) anchor = $6beb558f93ddfdf2$var$closestA(anchor);
    // Only test anchor elements
    if (!anchor || !$6beb558f93ddfdf2$var$isA(anchor)) return null;
    // Dont test anchors with target=_blank
    if (anchor.target === '_blank') return null;
    // IE9 doesn't put a leading slash on anchor.pathname [1]
    var aPathname = $6beb558f93ddfdf2$var$normalizeLeadingSlash(anchor.pathname);
    var wPathname = $6beb558f93ddfdf2$var$normalizeLeadingSlash(window.location.pathname);
    var aHost = anchor.host;
    var aPort = anchor.port;
    var wHost = window.location.host;
    var wPort = window.location.port;
    // In some cases, IE will have a blank host property when the href
    // is a relative URL. We can check for relativeness via the achor's
    // href attribute and then set the anchor's host to the window's host.
    if (aHost === '' && 'attributes' in anchor && 'href' in anchor.attributes && 'value' in anchor.attributes.href && $6beb558f93ddfdf2$var$isRelativeUrl(anchor.attributes.href.value)) aHost = wHost;
    // Some browsers (Chrome 36) return an empty string for anchor.hash
    // even when href="#", so we also check the href
    var aHash = anchor.hash || (anchor.href.indexOf('#') > -1 ? '#' + anchor.href.split('#')[1] : null);
    var inPageHash;
    // Window has no port, but anchor has the default port
    if (!wPort && aPort && (aPort === '80' || aPort === '443')) {
        // IE9 sometimes includes the default port (80 or 443) on anchor.host
        // so we append the default port to the window host in this case
        // so they will match for the host equality check [1]
        wHost += ':' + aPort;
        aHost += aHost.indexOf(aPort, aHost.length - aPort.length) === -1 ? ':' + aPort : '' // [3]
        ;
    }
    // Hosts are the same, its a local link
    if (aHost === wHost) {
        // If everything else is the same
        // and hash exists, then it is an in-page hash [2]
        inPageHash = aPathname === wPathname && anchor.search === window.location.search && aHash;
        if (lookForHash === true) // If we are looking for the hash then this will
        // only return a truthy value if the link
        // is an *in-page* hash link
        return inPageHash;
        else // If this is an in page hash link
        // then ignore it because we werent looking for hash links
        return inPageHash ? null : aPathname + (anchor.search || '') + (aHash || '');
    }
    return null;
}
// Take two arguments and return an ordered array of [event, anchor]
function $6beb558f93ddfdf2$var$getEventAndAnchor(arg1, arg2) {
    var ev = null;
    var anchor = null;
    if (arguments.length === 2) {
        // Two arguments will come in this order
        ev = arg1;
        anchor = arg2;
    } else if ($6beb558f93ddfdf2$var$isHTMLElement(arg1)) // If our first arg is an element
    // then use that as our anchor
    anchor = arg1;
    else // Otherwise our argument is an event
    ev = arg1;
    // If there is no anchor, but we have an event
    // then use event.target
    if (!anchor && ev && ev.target) anchor = ev.target;
    // Return an array so that it can be used with Function.apply
    return [
        ev,
        anchor
    ];
}
// Functions to be used in exports. Defined here for alias purposes
function $6beb558f93ddfdf2$var$pathname() {
    return $6beb558f93ddfdf2$var$isLocal.apply(null, $6beb558f93ddfdf2$var$getEventAndAnchor.apply(null, arguments));
}
function $6beb558f93ddfdf2$var$hash() {
    return $6beb558f93ddfdf2$var$isLocal.apply(null, $6beb558f93ddfdf2$var$getEventAndAnchor.apply(null, arguments).concat(true));
}
function $6beb558f93ddfdf2$var$active() {
    var args = Array.prototype.slice.call(arguments);
    var last = args[args.length - 1];
    var checkPath = window.location.pathname;
    if (typeof last === 'string') {
        checkPath = last;
        args = args.slice(0, -1);
    }
    return $6beb558f93ddfdf2$var$pathname.apply(null, args) === $6beb558f93ddfdf2$var$normalizeLeadingSlash(checkPath);
}
$6beb558f93ddfdf2$exports = {
    isLocal: $6beb558f93ddfdf2$var$isLocal,
    pathname: $6beb558f93ddfdf2$var$pathname,
    getLocalPathname: $6beb558f93ddfdf2$var$pathname,
    hash: $6beb558f93ddfdf2$var$hash,
    getLocalHash: $6beb558f93ddfdf2$var$hash,
    active: $6beb558f93ddfdf2$var$active,
    isActive: $6beb558f93ddfdf2$var$active
};


var $f56df7df86436f25$exports = {};
/*$AMPERSAND_VERSION*/ function $f56df7df86436f25$var$ViewSwitcher(options) {
    options || (options = {});
    this.el = options.el;
    this.config = {
        hide: null,
        show: null,
        empty: null,
        prepend: false,
        waitForRemove: false,
        autoRender: true
    };
    for(var item in options)if (this.config.hasOwnProperty(item)) this.config[item] = options[item];
    this._setCurrent(options.view);
    if (this.config.autoRender) this.render();
}
$f56df7df86436f25$var$ViewSwitcher.prototype.set = function(view) {
    var self = this;
    var prev = this.previous = this.current;
    if (prev === view) return;
    if (this.config.waitForRemove) {
        this.next = view;
        this._hide(prev, function() {
            if (self.next === view) {
                delete self.next;
                self._show(view);
            }
        });
    } else {
        this._hide(prev);
        this._show(view);
    }
    return this;
};
$f56df7df86436f25$var$ViewSwitcher.prototype._setCurrent = function(view) {
    this.current = view;
    if (view) this._registerRemoveListener(view);
    var emptyCb = this.config.empty;
    if (emptyCb && !this.current) emptyCb();
    return view;
};
$f56df7df86436f25$var$ViewSwitcher.prototype.clear = function(cb) {
    this._hide(this.current, cb);
    return this;
};
// If the view switcher itself is removed, remove its child to avoid memory leaks
$f56df7df86436f25$var$ViewSwitcher.prototype.remove = function() {
    if (this.current) this.current.remove();
    if (this.previous) this.previous.remove();
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
    return this;
};
$f56df7df86436f25$var$ViewSwitcher.prototype._show = function(view) {
    var customShow = this.config.show;
    this._setCurrent(view);
    this._render(view);
    if (customShow) customShow(view);
};
$f56df7df86436f25$var$ViewSwitcher.prototype._registerRemoveListener = function(view) {
    if (view && view.once) view.once('remove', this._onViewRemove, this);
};
$f56df7df86436f25$var$ViewSwitcher.prototype._onViewRemove = function(view) {
    var emptyCb = this.config.empty;
    if (this.current === view) this.current = null;
    if (emptyCb && !this.current) emptyCb();
};
$f56df7df86436f25$var$ViewSwitcher.prototype._render = function(view) {
    if (!this.el) return;
    if (!view.rendered) view.render({
        containerEl: this.el
    });
    if (!view.insertSelf) {
        if (this.config.prepend) this.el.insertBefore(view.el, this.el.firstChild);
        else this.el.appendChild(view.el);
    }
};
$f56df7df86436f25$var$ViewSwitcher.prototype.render = function() {
    if (this.current && !this._rendered) this._render(this.current);
    //set rendered, el exists even if a current view was not inserted/appended
    this._rendered = true;
    return this;
};
$f56df7df86436f25$var$ViewSwitcher.prototype._hide = function(view, cb) {
    var customHide = this.config.hide;
    if (!view) return cb && cb();
    if (customHide) {
        if (customHide.length === 2) customHide(view, function() {
            view.remove();
            if (cb) cb();
        });
        else {
            customHide(view);
            view.remove();
            if (cb) cb();
        }
    } else {
        view.remove();
        if (cb) cb();
    }
};
$f56df7df86436f25$exports = $f56df7df86436f25$var$ViewSwitcher;



var $a0MTb = parcelRequire("a0MTb");
var $97aa60f1d12b888a$exports = {};

var $4UX9c = parcelRequire("4UX9c");

var $dM6Pc = parcelRequire("dM6Pc");

var $97aa60f1d12b888a$require$tippy = $6445619a88c9e457$export$2e2bcd8739ae039;

var $8jWPf = parcelRequire("8jWPf");
var $bRFDG = parcelRequire("bRFDG");

var $4UX9c = parcelRequire("4UX9c");

var $kLOUX = parcelRequire("kLOUX");

var $348Te = parcelRequire("348Te");

var $1JrMM = parcelRequire("1JrMM");

var $8jWPf = parcelRequire("8jWPf");

var $4UX9c = parcelRequire("4UX9c");

var $9zKvP = parcelRequire("9zKvP");

var $kLOUX = parcelRequire("kLOUX");

var $04t5A = parcelRequire("04t5A");

var $d0uB5 = parcelRequire("d0uB5");

var $gvQO6 = parcelRequire("gvQO6");

var $8jWPf = parcelRequire("8jWPf");
parcelRequire("gsMHG");
var $bRFDG = parcelRequire("bRFDG");
var $gsMHG = parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $frj70 = parcelRequire("frj70");

var $5Y7iv = parcelRequire("5Y7iv");
function $e2bf3c7d5da62f64$export$e3d20747ab930783(e, o) {
    let [u, t] = (0, $kLOUX.useState)(e), r = (0, $5Y7iv.useLatestValue)(e);
    return (0, $frj70.useIsoMorphicEffect)(()=>t(r.current), [
        r,
        t,
        ...o
    ]), u;
}



var $fczrW = parcelRequire("fczrW");

var $i4ILg = parcelRequire("i4ILg");

var $7yd0N = parcelRequire("7yd0N");

var $frj70 = parcelRequire("frj70");

var $5Y7iv = parcelRequire("5Y7iv");

var $efwez = parcelRequire("efwez");
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $frj70 = parcelRequire("frj70");
function $7d6482ea4a25dd49$var$i(t) {
    var n;
    if (t.type) return t.type;
    let e = (n = t.as) != null ? n : "button";
    if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function $7d6482ea4a25dd49$export$53652b2b272efe9c(t, e) {
    let [n, u] = (0, $kLOUX.useState)(()=>$7d6482ea4a25dd49$var$i(t));
    return (0, $frj70.useIsoMorphicEffect)(()=>{
        u($7d6482ea4a25dd49$var$i(t));
    }, [
        t.type,
        t.as
    ]), (0, $frj70.useIsoMorphicEffect)(()=>{
        n || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && u("button");
    }, [
        n,
        e
    ]), n;
}



var $8jGWf = parcelRequire("8jGWf");
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $frj70 = parcelRequire("frj70");

var $5I2Bs = parcelRequire("5I2Bs");
function $2368ac62a5c44270$export$b0abce39eb34b36({ container: e, accept: t, walk: r, enabled: c = !0 }) {
    let o = (0, $kLOUX.useRef)(t), l = (0, $kLOUX.useRef)(r);
    (0, $kLOUX.useEffect)(()=>{
        o.current = t, l.current = r;
    }, [
        t,
        r
    ]), (0, $frj70.useIsoMorphicEffect)(()=>{
        if (!e || !c) return;
        let n = (0, $5I2Bs.getOwnerDocument)(e);
        if (!n) return;
        let f = o.current, p = l.current, d = Object.assign((i)=>f(i), {
            acceptNode: f
        }), u = n.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, d, !1);
        for(; u.nextNode();)p(u.currentNode);
    }, [
        e,
        c,
        o,
        l
    ]);
}


function $a4cd8195dbc88ff4$var$f(r) {
    throw new Error("Unexpected object: " + r);
}
var $a4cd8195dbc88ff4$export$807a7eae502106e7 = ((e)=>(e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))($a4cd8195dbc88ff4$export$807a7eae502106e7 || {});
function $a4cd8195dbc88ff4$export$c6b4626b54936d5e(r, n) {
    let t = n.resolveItems();
    if (t.length <= 0) return null;
    let l = n.resolveActiveIndex(), s = l != null ? l : -1, d = (()=>{
        switch(r.focus){
            case 0:
                return t.findIndex((e)=>!n.resolveDisabled(e));
            case 1:
                {
                    let e = t.slice().reverse().findIndex((i, c, u)=>s !== -1 && u.length - c - 1 >= s ? !1 : !n.resolveDisabled(i));
                    return e === -1 ? e : t.length - 1 - e;
                }
            case 2:
                return t.findIndex((e, i)=>i <= s ? !1 : !n.resolveDisabled(e));
            case 3:
                {
                    let e = t.slice().reverse().findIndex((i)=>!n.resolveDisabled(i));
                    return e === -1 ? e : t.length - 1 - e;
                }
            case 4:
                return t.findIndex((e)=>n.resolveId(e) === r.id);
            case 5:
                return null;
            default:
                $a4cd8195dbc88ff4$var$f(r);
        }
    })();
    return d === -1 ? l : d;
}



var $lemPO = parcelRequire("lemPO");

var $ex6pY = parcelRequire("ex6pY");

var $2pqNO = parcelRequire("2pqNO");

var $7XYnx = parcelRequire("7XYnx");
function $201397131d446dde$export$bc22b3e852574dab(n = {}, r = null, t = []) {
    for (let [i, o] of Object.entries(n))$201397131d446dde$var$f(t, $201397131d446dde$var$s(r, i), o);
    return t;
}
function $201397131d446dde$var$s(n, r) {
    return n ? n + "[" + r + "]" : r;
}
function $201397131d446dde$var$f(n, r, t) {
    if (Array.isArray(t)) for (let [i, o] of t.entries())$201397131d446dde$var$f(n, $201397131d446dde$var$s(r, i.toString()), o);
    else t instanceof Date ? n.push([
        r,
        t.toISOString()
    ]) : typeof t == "boolean" ? n.push([
        r,
        t ? "1" : "0"
    ]) : typeof t == "string" ? n.push([
        r,
        t
    ]) : typeof t == "number" ? n.push([
        r,
        `${t}`
    ]) : t == null ? n.push([
        r,
        ""
    ]) : $201397131d446dde$export$bc22b3e852574dab(t, r, n);
}
function $201397131d446dde$export$ee02894bdc79dd36(n) {
    var t;
    let r = (t = n == null ? void 0 : n.form) != null ? t : n.closest("form");
    if (r) {
        for (let i of r.elements)if (i.tagName === "INPUT" && i.type === "submit" || i.tagName === "BUTTON" && i.type === "submit" || i.nodeName === "INPUT" && i.type === "image") {
            i.click();
            return;
        }
    }
}



var $37yyp = parcelRequire("37yyp");

var $kXStv = parcelRequire("kXStv");

var $6A6CF = parcelRequire("6A6CF");

var $aUAjX = parcelRequire("aUAjX");
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $i4ILg = parcelRequire("i4ILg");
function $85f81343a304f2e8$export$454217e89aea72b(l, r, c) {
    let [i, s] = (0, $kLOUX.useState)(c), e = l !== void 0, t = (0, $kLOUX.useRef)(e), u = (0, $kLOUX.useRef)(!1), d = (0, $kLOUX.useRef)(!1);
    return e && !t.current && !u.current ? (u.current = !0, t.current = e, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !e && t.current && !d.current && (d.current = !0, t.current = e, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        e ? l : i,
        (0, $i4ILg.useEvent)((n)=>(e || s(n), r == null ? void 0 : r(n)))
    ];
}



var $cLDcY = parcelRequire("cLDcY");
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");
function $4d67713d5d1a5bff$var$t(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function $4d67713d5d1a5bff$export$24ebee078bde85c3() {
    let e = (0, $kLOUX.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (r) {
            let n = $4d67713d5d1a5bff$var$t(r);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (r) {
            e.current = $4d67713d5d1a5bff$var$t(r);
        }
    };
}



var $aOCLc = parcelRequire("aOCLc");
var $dbe06488926fee5e$var$Be = ((e)=>(e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))($dbe06488926fee5e$var$Be || {}), $dbe06488926fee5e$var$ke = ((e)=>(e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))($dbe06488926fee5e$var$ke || {}), $dbe06488926fee5e$var$we = ((e)=>(e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))($dbe06488926fee5e$var$we || {}), $dbe06488926fee5e$var$Ue = ((n)=>(n[n.OpenCombobox = 0] = "OpenCombobox", n[n.CloseCombobox = 1] = "CloseCombobox", n[n.GoToOption = 2] = "GoToOption", n[n.RegisterOption = 3] = "RegisterOption", n[n.UnregisterOption = 4] = "UnregisterOption", n[n.RegisterLabel = 5] = "RegisterLabel", n))($dbe06488926fee5e$var$Ue || {});
function $dbe06488926fee5e$var$re(t, l = (e)=>e) {
    let e = t.activeOptionIndex !== null ? t.options[t.activeOptionIndex] : null, r = (0, $37yyp.sortByDomNode)(l(t.options.slice()), (s)=>s.dataRef.current.domRef.current), i = e ? r.indexOf(e) : null;
    return i === -1 && (i = null), {
        options: r,
        activeOptionIndex: i
    };
}
let $dbe06488926fee5e$var$He = {
    [1] (t) {
        var l;
        return (l = t.dataRef.current) != null && l.disabled || t.comboboxState === 1 ? t : {
            ...t,
            activeOptionIndex: null,
            comboboxState: 1
        };
    },
    [0] (t) {
        var e;
        if ((e = t.dataRef.current) != null && e.disabled || t.comboboxState === 0) return t;
        let l = t.activeOptionIndex;
        if (t.dataRef.current) {
            let { isSelected: r } = t.dataRef.current, i = t.options.findIndex((s)=>r(s.dataRef.current.value));
            i !== -1 && (l = i);
        }
        return {
            ...t,
            comboboxState: 0,
            activeOptionIndex: l
        };
    },
    [2] (t, l) {
        var i, s, n, d;
        if ((i = t.dataRef.current) != null && i.disabled || (s = t.dataRef.current) != null && s.optionsRef.current && !((n = t.dataRef.current) != null && n.optionsPropsRef.current.static) && t.comboboxState === 1) return t;
        let e = $dbe06488926fee5e$var$re(t);
        if (e.activeOptionIndex === null) {
            let o = e.options.findIndex((u)=>!u.dataRef.current.disabled);
            o !== -1 && (e.activeOptionIndex = o);
        }
        let r = (0, $a4cd8195dbc88ff4$export$c6b4626b54936d5e)(l, {
            resolveItems: ()=>e.options,
            resolveActiveIndex: ()=>e.activeOptionIndex,
            resolveId: (o)=>o.id,
            resolveDisabled: (o)=>o.dataRef.current.disabled
        });
        return {
            ...t,
            ...e,
            activeOptionIndex: r,
            activationTrigger: (d = l.trigger) != null ? d : 1
        };
    },
    [3]: (t, l)=>{
        var s, n;
        let e = {
            id: l.id,
            dataRef: l.dataRef
        }, r = $dbe06488926fee5e$var$re(t, (d)=>[
                ...d,
                e
            ]);
        t.activeOptionIndex === null && (s = t.dataRef.current) != null && s.isSelected(l.dataRef.current.value) && (r.activeOptionIndex = r.options.indexOf(e));
        let i = {
            ...t,
            ...r,
            activationTrigger: 1
        };
        return (n = t.dataRef.current) != null && n.__demoMode && t.dataRef.current.value === void 0 && (i.activeOptionIndex = 0), i;
    },
    [4]: (t, l)=>{
        let e = $dbe06488926fee5e$var$re(t, (r)=>{
            let i = r.findIndex((s)=>s.id === l.id);
            return i !== -1 && r.splice(i, 1), r;
        });
        return {
            ...t,
            ...e,
            activationTrigger: 1
        };
    },
    [5]: (t, l)=>({
            ...t,
            labelId: l.id
        })
}, $dbe06488926fee5e$var$ae = (0, $bRFDG.createContext)(null);
$dbe06488926fee5e$var$ae.displayName = "ComboboxActionsContext";
function $dbe06488926fee5e$var$$(t) {
    let l = (0, $kLOUX.useContext)($dbe06488926fee5e$var$ae);
    if (l === null) {
        let e = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $dbe06488926fee5e$var$$), e;
    }
    return l;
}
let $dbe06488926fee5e$var$le = (0, $bRFDG.createContext)(null);
$dbe06488926fee5e$var$le.displayName = "ComboboxDataContext";
function $dbe06488926fee5e$var$H(t) {
    let l = (0, $kLOUX.useContext)($dbe06488926fee5e$var$le);
    if (l === null) {
        let e = new Error(`<${t} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(e, $dbe06488926fee5e$var$H), e;
    }
    return l;
}
function $dbe06488926fee5e$var$Ne(t, l) {
    return (0, $7XYnx.match)(l.type, $dbe06488926fee5e$var$He, t, l);
}
let $dbe06488926fee5e$var$Ge = (0, $bRFDG.Fragment);
function $dbe06488926fee5e$var$Xe(t, l) {
    let { value: e, defaultValue: r, onChange: i, name: s, by: n = (p, T)=>p === T, disabled: d = !1, __demoMode: o = !1, nullable: u = !1, multiple: P = !1, ...f } = t, [O = P ? [] : void 0, m] = (0, $85f81343a304f2e8$export$454217e89aea72b)(e, i, r), [g, c] = (0, $kLOUX.useReducer)($dbe06488926fee5e$var$Ne, {
        dataRef: (0, $bRFDG.createRef)(),
        comboboxState: o ? 0 : 1,
        options: [],
        activeOptionIndex: null,
        activationTrigger: 1,
        labelId: null
    }), C = (0, $kLOUX.useRef)(!1), N = (0, $kLOUX.useRef)({
        static: !1,
        hold: !1
    }), F = (0, $kLOUX.useRef)(null), _ = (0, $kLOUX.useRef)(null), h = (0, $kLOUX.useRef)(null), B = (0, $kLOUX.useRef)(null), V = (0, $i4ILg.useEvent)(typeof n == "string" ? (p, T)=>{
        let v = n;
        return (p == null ? void 0 : p[v]) === (T == null ? void 0 : T[v]);
    } : n), G = (0, $kLOUX.useCallback)((p)=>(0, $7XYnx.match)(b.mode, {
            [1]: ()=>O.some((T)=>V(T, p)),
            [0]: ()=>V(O, p)
        }), [
        O
    ]), b = (0, $kLOUX.useMemo)(()=>({
            ...g,
            optionsPropsRef: N,
            labelRef: F,
            inputRef: _,
            buttonRef: h,
            optionsRef: B,
            value: O,
            defaultValue: r,
            disabled: d,
            mode: P ? 1 : 0,
            get activeOptionIndex () {
                if (C.current && g.activeOptionIndex === null && g.options.length > 0) {
                    let p = g.options.findIndex((T)=>!T.dataRef.current.disabled);
                    if (p !== -1) return p;
                }
                return g.activeOptionIndex;
            },
            compare: V,
            isSelected: G,
            nullable: u,
            __demoMode: o
        }), [
        O,
        r,
        d,
        P,
        u,
        o,
        g
    ]), L = (0, $kLOUX.useRef)(b.activeOptionIndex !== null ? b.options[b.activeOptionIndex] : null);
    (0, $kLOUX.useEffect)(()=>{
        let p = b.activeOptionIndex !== null ? b.options[b.activeOptionIndex] : null;
        L.current !== p && (L.current = p);
    }), (0, $frj70.useIsoMorphicEffect)(()=>{
        g.dataRef.current = b;
    }, [
        b
    ]), (0, $efwez.useOutsideClick)([
        b.buttonRef,
        b.inputRef,
        b.optionsRef
    ], ()=>oe.closeCombobox(), b.comboboxState === 0);
    let y = (0, $kLOUX.useMemo)(()=>({
            open: b.comboboxState === 0,
            disabled: d,
            activeIndex: b.activeOptionIndex,
            activeOption: b.activeOptionIndex === null ? null : b.options[b.activeOptionIndex].dataRef.current.value,
            value: O
        }), [
        b,
        d,
        O
    ]), a = (0, $i4ILg.useEvent)((p)=>{
        let T = b.options.find((v)=>v.id === p);
        T && j(T.dataRef.current.value);
    }), I = (0, $i4ILg.useEvent)(()=>{
        if (b.activeOptionIndex !== null) {
            let { dataRef: p, id: T } = b.options[b.activeOptionIndex];
            j(p.current.value), oe.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Specific, T);
        }
    }), S = (0, $i4ILg.useEvent)(()=>{
        c({
            type: 0
        }), C.current = !0;
    }), X = (0, $i4ILg.useEvent)(()=>{
        c({
            type: 1
        }), C.current = !1;
    }), q = (0, $i4ILg.useEvent)((p, T, v)=>(C.current = !1, p === (0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Specific ? c({
            type: 2,
            focus: (0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Specific,
            id: T,
            trigger: v
        }) : c({
            type: 2,
            focus: p,
            trigger: v
        }))), Q = (0, $i4ILg.useEvent)((p, T)=>(c({
            type: 3,
            id: p,
            dataRef: T
        }), ()=>{
            var v;
            ((v = L.current) == null ? void 0 : v.id) === p && (C.current = !0), c({
                type: 4,
                id: p
            });
        })), Y = (0, $i4ILg.useEvent)((p)=>(c({
            type: 5,
            id: p
        }), ()=>c({
                type: 5,
                id: null
            }))), j = (0, $i4ILg.useEvent)((p)=>(0, $7XYnx.match)(b.mode, {
            [0] () {
                return m == null ? void 0 : m(p);
            },
            [1] () {
                let T = b.value.slice(), v = T.findIndex((J)=>V(J, p));
                return v === -1 ? T.push(p) : T.splice(v, 1), m == null ? void 0 : m(T);
            }
        })), oe = (0, $kLOUX.useMemo)(()=>({
            onChange: j,
            registerOption: Q,
            registerLabel: Y,
            goToOption: q,
            closeCombobox: X,
            openCombobox: S,
            selectActiveOption: I,
            selectOption: a
        }), []), ce = l === null ? {} : {
        ref: l
    }, Z = (0, $kLOUX.useRef)(null), Te = (0, $fczrW.useDisposables)();
    return (0, $kLOUX.useEffect)(()=>{
        Z.current && r !== void 0 && Te.addEventListener(Z.current, "reset", ()=>{
            j(r);
        });
    }, [
        Z,
        j
    ]), (0, $gsMHG.default).createElement($dbe06488926fee5e$var$ae.Provider, {
        value: oe
    }, (0, $gsMHG.default).createElement($dbe06488926fee5e$var$le.Provider, {
        value: b
    }, (0, $gsMHG.default).createElement((0, $6A6CF.OpenClosedProvider), {
        value: (0, $7XYnx.match)(b.comboboxState, {
            [0]: (0, $6A6CF.State).Open,
            [1]: (0, $6A6CF.State).Closed
        })
    }, s != null && O != null && (0, $201397131d446dde$export$bc22b3e852574dab)({
        [s]: O
    }).map(([p, T], v)=>(0, $gsMHG.default).createElement((0, $kXStv.Hidden), {
            features: (0, $kXStv.Features).Hidden,
            ref: v === 0 ? (J)=>{
                var ie;
                Z.current = (ie = J == null ? void 0 : J.closest("form")) != null ? ie : null;
            } : void 0,
            ...(0, $ex6pY.compact)({
                key: p,
                as: "input",
                type: "hidden",
                hidden: !0,
                readOnly: !0,
                name: p,
                value: T
            })
        })), (0, $ex6pY.render)({
        ourProps: ce,
        theirProps: f,
        slot: y,
        defaultTag: $dbe06488926fee5e$var$Ge,
        name: "Combobox"
    }))));
}
let $dbe06488926fee5e$var$je = "input";
function $dbe06488926fee5e$var$Je(t, l) {
    var G, b, L, y;
    let e = (0, $7yd0N.useId)(), { id: r = `headlessui-combobox-input-${e}`, onChange: i, displayValue: s, type: n = "text", ...d } = t, o = $dbe06488926fee5e$var$H("Combobox.Input"), u = $dbe06488926fee5e$var$$("Combobox.Input"), P = (0, $8jGWf.useSyncRefs)(o.inputRef, l), f = (0, $kLOUX.useRef)(!1), O = (0, $fczrW.useDisposables)(), m = function() {
        var a;
        return typeof s == "function" && o.value !== void 0 ? (a = s(o.value)) != null ? a : "" : typeof o.value == "string" ? o.value : "";
    }();
    (0, $cLDcY.useWatch)(([a, I], [S, X])=>{
        f.current || o.inputRef.current && (X === 0 && I === 1 || a !== S) && (o.inputRef.current.value = a);
    }, [
        m,
        o.comboboxState
    ]), (0, $cLDcY.useWatch)(([a], [I])=>{
        if (a === 0 && I === 1) {
            let S = o.inputRef.current;
            if (!S) return;
            let X = S.value, { selectionStart: q, selectionEnd: Q, selectionDirection: Y } = S;
            S.value = "", S.value = X, Y !== null ? S.setSelectionRange(q, Q, Y) : S.setSelectionRange(q, Q);
        }
    }, [
        o.comboboxState
    ]);
    let g = (0, $kLOUX.useRef)(!1), c = (0, $i4ILg.useEvent)(()=>{
        g.current = !0;
    }), C = (0, $i4ILg.useEvent)(()=>{
        setTimeout(()=>{
            g.current = !1;
        });
    }), N = (0, $i4ILg.useEvent)((a)=>{
        switch(f.current = !0, a.key){
            case (0, $aUAjX.Keys).Backspace:
            case (0, $aUAjX.Keys).Delete:
                if (o.mode !== 0 || !o.nullable) return;
                let I = a.currentTarget;
                O.requestAnimationFrame(()=>{
                    I.value === "" && (u.onChange(null), o.optionsRef.current && (o.optionsRef.current.scrollTop = 0), u.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Nothing));
                });
                break;
            case (0, $aUAjX.Keys).Enter:
                if (f.current = !1, o.comboboxState !== 0 || g.current) return;
                if (a.preventDefault(), a.stopPropagation(), o.activeOptionIndex === null) {
                    u.closeCombobox();
                    return;
                }
                u.selectActiveOption(), o.mode === 0 && u.closeCombobox();
                break;
            case (0, $aUAjX.Keys).ArrowDown:
                return f.current = !1, a.preventDefault(), a.stopPropagation(), (0, $7XYnx.match)(o.comboboxState, {
                    [0]: ()=>{
                        u.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Next);
                    },
                    [1]: ()=>{
                        u.openCombobox();
                    }
                });
            case (0, $aUAjX.Keys).ArrowUp:
                return f.current = !1, a.preventDefault(), a.stopPropagation(), (0, $7XYnx.match)(o.comboboxState, {
                    [0]: ()=>{
                        u.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Previous);
                    },
                    [1]: ()=>{
                        u.openCombobox(), O.nextFrame(()=>{
                            o.value || u.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Last);
                        });
                    }
                });
            case (0, $aUAjX.Keys).Home:
                if (a.shiftKey) break;
                return f.current = !1, a.preventDefault(), a.stopPropagation(), u.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).First);
            case (0, $aUAjX.Keys).PageUp:
                return f.current = !1, a.preventDefault(), a.stopPropagation(), u.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).First);
            case (0, $aUAjX.Keys).End:
                if (a.shiftKey) break;
                return f.current = !1, a.preventDefault(), a.stopPropagation(), u.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Last);
            case (0, $aUAjX.Keys).PageDown:
                return f.current = !1, a.preventDefault(), a.stopPropagation(), u.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Last);
            case (0, $aUAjX.Keys).Escape:
                return f.current = !1, o.comboboxState !== 0 ? void 0 : (a.preventDefault(), o.optionsRef.current && !o.optionsPropsRef.current.static && a.stopPropagation(), u.closeCombobox());
            case (0, $aUAjX.Keys).Tab:
                if (f.current = !1, o.comboboxState !== 0) return;
                o.mode === 0 && u.selectActiveOption(), u.closeCombobox();
                break;
        }
    }), F = (0, $i4ILg.useEvent)((a)=>{
        u.openCombobox(), i == null || i(a);
    }), _ = (0, $i4ILg.useEvent)(()=>{
        f.current = !1;
    }), h = (0, $e2bf3c7d5da62f64$export$e3d20747ab930783)(()=>{
        if (o.labelId) return [
            o.labelId
        ].join(" ");
    }, [
        o.labelId
    ]), B = (0, $kLOUX.useMemo)(()=>({
            open: o.comboboxState === 0,
            disabled: o.disabled
        }), [
        o
    ]), V = {
        ref: P,
        id: r,
        role: "combobox",
        type: n,
        "aria-controls": (G = o.optionsRef.current) == null ? void 0 : G.id,
        "aria-expanded": o.disabled ? void 0 : o.comboboxState === 0,
        "aria-activedescendant": o.activeOptionIndex === null || (b = o.options[o.activeOptionIndex]) == null ? void 0 : b.id,
        "aria-labelledby": h,
        "aria-autocomplete": "list",
        defaultValue: (y = (L = t.defaultValue) != null ? L : o.defaultValue !== void 0 ? s == null ? void 0 : s(o.defaultValue) : null) != null ? y : o.defaultValue,
        disabled: o.disabled,
        onCompositionStart: c,
        onCompositionEnd: C,
        onKeyDown: N,
        onChange: F,
        onBlur: _
    };
    return (0, $ex6pY.render)({
        ourProps: V,
        theirProps: d,
        slot: B,
        defaultTag: $dbe06488926fee5e$var$je,
        name: "Combobox.Input"
    });
}
let $dbe06488926fee5e$var$Ke = "button";
function $dbe06488926fee5e$var$We(t, l) {
    var g;
    let e = $dbe06488926fee5e$var$H("Combobox.Button"), r = $dbe06488926fee5e$var$$("Combobox.Button"), i = (0, $8jGWf.useSyncRefs)(e.buttonRef, l), s = (0, $7yd0N.useId)(), { id: n = `headlessui-combobox-button-${s}`, ...d } = t, o = (0, $fczrW.useDisposables)(), u = (0, $i4ILg.useEvent)((c)=>{
        switch(c.key){
            case (0, $aUAjX.Keys).ArrowDown:
                return c.preventDefault(), c.stopPropagation(), e.comboboxState === 1 && r.openCombobox(), o.nextFrame(()=>{
                    var C;
                    return (C = e.inputRef.current) == null ? void 0 : C.focus({
                        preventScroll: !0
                    });
                });
            case (0, $aUAjX.Keys).ArrowUp:
                return c.preventDefault(), c.stopPropagation(), e.comboboxState === 1 && (r.openCombobox(), o.nextFrame(()=>{
                    e.value || r.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Last);
                })), o.nextFrame(()=>{
                    var C;
                    return (C = e.inputRef.current) == null ? void 0 : C.focus({
                        preventScroll: !0
                    });
                });
            case (0, $aUAjX.Keys).Escape:
                return e.comboboxState !== 0 ? void 0 : (c.preventDefault(), e.optionsRef.current && !e.optionsPropsRef.current.static && c.stopPropagation(), r.closeCombobox(), o.nextFrame(()=>{
                    var C;
                    return (C = e.inputRef.current) == null ? void 0 : C.focus({
                        preventScroll: !0
                    });
                }));
            default:
                return;
        }
    }), P = (0, $i4ILg.useEvent)((c)=>{
        if ((0, $2pqNO.isDisabledReactIssue7711)(c.currentTarget)) return c.preventDefault();
        e.comboboxState === 0 ? r.closeCombobox() : (c.preventDefault(), r.openCombobox()), o.nextFrame(()=>{
            var C;
            return (C = e.inputRef.current) == null ? void 0 : C.focus({
                preventScroll: !0
            });
        });
    }), f = (0, $e2bf3c7d5da62f64$export$e3d20747ab930783)(()=>{
        if (e.labelId) return [
            e.labelId,
            n
        ].join(" ");
    }, [
        e.labelId,
        n
    ]), O = (0, $kLOUX.useMemo)(()=>({
            open: e.comboboxState === 0,
            disabled: e.disabled,
            value: e.value
        }), [
        e
    ]), m = {
        ref: i,
        id: n,
        type: (0, $7d6482ea4a25dd49$export$53652b2b272efe9c)(t, e.buttonRef),
        tabIndex: -1,
        "aria-haspopup": "listbox",
        "aria-controls": (g = e.optionsRef.current) == null ? void 0 : g.id,
        "aria-expanded": e.disabled ? void 0 : e.comboboxState === 0,
        "aria-labelledby": f,
        disabled: e.disabled,
        onClick: P,
        onKeyDown: u
    };
    return (0, $ex6pY.render)({
        ourProps: m,
        theirProps: d,
        slot: O,
        defaultTag: $dbe06488926fee5e$var$Ke,
        name: "Combobox.Button"
    });
}
let $dbe06488926fee5e$var$$e = "label";
function $dbe06488926fee5e$var$qe(t, l) {
    let e = (0, $7yd0N.useId)(), { id: r = `headlessui-combobox-label-${e}`, ...i } = t, s = $dbe06488926fee5e$var$H("Combobox.Label"), n = $dbe06488926fee5e$var$$("Combobox.Label"), d = (0, $8jGWf.useSyncRefs)(s.labelRef, l);
    (0, $frj70.useIsoMorphicEffect)(()=>n.registerLabel(r), [
        r
    ]);
    let o = (0, $i4ILg.useEvent)(()=>{
        var f;
        return (f = s.inputRef.current) == null ? void 0 : f.focus({
            preventScroll: !0
        });
    }), u = (0, $kLOUX.useMemo)(()=>({
            open: s.comboboxState === 0,
            disabled: s.disabled
        }), [
        s
    ]);
    return (0, $ex6pY.render)({
        ourProps: {
            ref: d,
            id: r,
            onClick: o
        },
        theirProps: i,
        slot: u,
        defaultTag: $dbe06488926fee5e$var$$e,
        name: "Combobox.Label"
    });
}
let $dbe06488926fee5e$var$Qe = "ul", $dbe06488926fee5e$var$Ye = (0, $ex6pY.Features).RenderStrategy | (0, $ex6pY.Features).Static;
function $dbe06488926fee5e$var$Ze(t, l) {
    let e = (0, $7yd0N.useId)(), { id: r = `headlessui-combobox-options-${e}`, hold: i = !1, ...s } = t, n = $dbe06488926fee5e$var$H("Combobox.Options"), d = (0, $8jGWf.useSyncRefs)(n.optionsRef, l), o = (0, $6A6CF.useOpenClosed)(), u = (()=>o !== null ? (o & (0, $6A6CF.State).Open) === (0, $6A6CF.State).Open : n.comboboxState === 0)();
    (0, $frj70.useIsoMorphicEffect)(()=>{
        var m;
        n.optionsPropsRef.current.static = (m = t.static) != null ? m : !1;
    }, [
        n.optionsPropsRef,
        t.static
    ]), (0, $frj70.useIsoMorphicEffect)(()=>{
        n.optionsPropsRef.current.hold = i;
    }, [
        n.optionsPropsRef,
        i
    ]), (0, $2368ac62a5c44270$export$b0abce39eb34b36)({
        container: n.optionsRef.current,
        enabled: n.comboboxState === 0,
        accept (m) {
            return m.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : m.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (m) {
            m.setAttribute("role", "none");
        }
    });
    let P = (0, $e2bf3c7d5da62f64$export$e3d20747ab930783)(()=>{
        var m, g;
        return (g = n.labelId) != null ? g : (m = n.buttonRef.current) == null ? void 0 : m.id;
    }, [
        n.labelId,
        n.buttonRef.current
    ]), f = (0, $kLOUX.useMemo)(()=>({
            open: n.comboboxState === 0
        }), [
        n
    ]), O = {
        "aria-labelledby": P,
        role: "listbox",
        "aria-multiselectable": n.mode === 1 ? !0 : void 0,
        id: r,
        ref: d
    };
    return (0, $ex6pY.render)({
        ourProps: O,
        theirProps: s,
        slot: f,
        defaultTag: $dbe06488926fee5e$var$Qe,
        features: $dbe06488926fee5e$var$Ye,
        visible: u,
        name: "Combobox.Options"
    });
}
let $dbe06488926fee5e$var$ze = "li";
function $dbe06488926fee5e$var$eo(t, l) {
    var b, L;
    let e = (0, $7yd0N.useId)(), { id: r = `headlessui-combobox-option-${e}`, disabled: i = !1, value: s, ...n } = t, d = $dbe06488926fee5e$var$H("Combobox.Option"), o = $dbe06488926fee5e$var$$("Combobox.Option"), u = d.activeOptionIndex !== null ? d.options[d.activeOptionIndex].id === r : !1, P = d.isSelected(s), f = (0, $kLOUX.useRef)(null), O = (0, $5Y7iv.useLatestValue)({
        disabled: i,
        value: s,
        domRef: f,
        textValue: (L = (b = f.current) == null ? void 0 : b.textContent) == null ? void 0 : L.toLowerCase()
    }), m = (0, $8jGWf.useSyncRefs)(l, f), g = (0, $i4ILg.useEvent)(()=>o.selectOption(r));
    (0, $frj70.useIsoMorphicEffect)(()=>o.registerOption(r, O), [
        O,
        r
    ]);
    let c = (0, $kLOUX.useRef)(!d.__demoMode);
    (0, $frj70.useIsoMorphicEffect)(()=>{
        if (!d.__demoMode) return;
        let y = (0, $lemPO.disposables)();
        return y.requestAnimationFrame(()=>{
            c.current = !0;
        }), y.dispose;
    }, []), (0, $frj70.useIsoMorphicEffect)(()=>{
        if (d.comboboxState !== 0 || !u || !c.current || d.activationTrigger === 0) return;
        let y = (0, $lemPO.disposables)();
        return y.requestAnimationFrame(()=>{
            var a, I;
            (I = (a = f.current) == null ? void 0 : a.scrollIntoView) == null || I.call(a, {
                block: "nearest"
            });
        }), y.dispose;
    }, [
        f,
        u,
        d.comboboxState,
        d.activationTrigger,
        d.activeOptionIndex
    ]);
    let C = (0, $i4ILg.useEvent)((y)=>{
        if (i) return y.preventDefault();
        g(), d.mode === 0 && o.closeCombobox(), (0, $aOCLc.isMobile)() || requestAnimationFrame(()=>{
            var a;
            return (a = d.inputRef.current) == null ? void 0 : a.focus();
        });
    }), N = (0, $i4ILg.useEvent)(()=>{
        if (i) return o.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Nothing);
        o.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Specific, r);
    }), F = (0, $4d67713d5d1a5bff$export$24ebee078bde85c3)(), _ = (0, $i4ILg.useEvent)((y)=>F.update(y)), h = (0, $i4ILg.useEvent)((y)=>{
        F.wasMoved(y) && (i || u || o.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Specific, r, 0));
    }), B = (0, $i4ILg.useEvent)((y)=>{
        F.wasMoved(y) && (i || u && (d.optionsPropsRef.current.hold || o.goToOption((0, $a4cd8195dbc88ff4$export$807a7eae502106e7).Nothing)));
    }), V = (0, $kLOUX.useMemo)(()=>({
            active: u,
            selected: P,
            disabled: i
        }), [
        u,
        P,
        i
    ]);
    return (0, $ex6pY.render)({
        ourProps: {
            id: r,
            ref: m,
            role: "option",
            tabIndex: i === !0 ? void 0 : -1,
            "aria-disabled": i === !0 ? !0 : void 0,
            "aria-selected": P,
            disabled: void 0,
            onClick: C,
            onFocus: N,
            onPointerEnter: _,
            onMouseEnter: _,
            onPointerMove: h,
            onMouseMove: h,
            onPointerLeave: B,
            onMouseLeave: B
        },
        theirProps: n,
        slot: V,
        defaultTag: $dbe06488926fee5e$var$ze,
        name: "Combobox.Option"
    });
}
let $dbe06488926fee5e$var$oo = (0, $ex6pY.forwardRefWithAs)($dbe06488926fee5e$var$Xe), $dbe06488926fee5e$var$to = (0, $ex6pY.forwardRefWithAs)($dbe06488926fee5e$var$We), $dbe06488926fee5e$var$no = (0, $ex6pY.forwardRefWithAs)($dbe06488926fee5e$var$Je), $dbe06488926fee5e$var$ro = (0, $ex6pY.forwardRefWithAs)($dbe06488926fee5e$var$qe), $dbe06488926fee5e$var$ao = (0, $ex6pY.forwardRefWithAs)($dbe06488926fee5e$var$Ze), $dbe06488926fee5e$var$lo = (0, $ex6pY.forwardRefWithAs)($dbe06488926fee5e$var$eo), $dbe06488926fee5e$export$27957ad87354dd7e = Object.assign($dbe06488926fee5e$var$oo, {
    Input: $dbe06488926fee5e$var$no,
    Button: $dbe06488926fee5e$var$to,
    Label: $dbe06488926fee5e$var$ro,
    Options: $dbe06488926fee5e$var$ao,
    Option: $dbe06488926fee5e$var$lo
});



var $jDUXD = parcelRequire("jDUXD");

var $bRFDG = parcelRequire("bRFDG");

var $kLOUX = parcelRequire("kLOUX");
var $2beebd03a2583798$export$2ba01fb71ed41cb6;
var $2beebd03a2583798$export$da58ae6e4434453;
var $2beebd03a2583798$export$66cd3fca83bcd8fb;
var $2beebd03a2583798$export$b7e3ae3d7c15e42e;
var $2beebd03a2583798$export$a75d1723e6bda2ec;
var $2beebd03a2583798$export$7d7ba61f757457b;
var $2beebd03a2583798$export$245ad05b0468ea5e;
var $2beebd03a2583798$export$12afe09fc732f57b;
var $2beebd03a2583798$export$41c562ebe57d11e2;
$2beebd03a2583798$export$2ba01fb71ed41cb6 = `fhzN9W_button`;
$2beebd03a2583798$export$da58ae6e4434453 = `fhzN9W_combobox`;
$2beebd03a2583798$export$66cd3fca83bcd8fb = `fhzN9W_iconSelected`;
$2beebd03a2583798$export$b7e3ae3d7c15e42e = `fhzN9W_input`;
$2beebd03a2583798$export$a75d1723e6bda2ec = `fhzN9W_option`;
$2beebd03a2583798$export$7d7ba61f757457b = `fhzN9W_optionActive`;
$2beebd03a2583798$export$245ad05b0468ea5e = `fhzN9W_optionLabel`;
$2beebd03a2583798$export$12afe09fc732f57b = `fhzN9W_optionSelected`;
$2beebd03a2583798$export$41c562ebe57d11e2 = `fhzN9W_options`;


function $545dd39faa0aa189$export$27957ad87354dd7e({ name: name, placeholder: placeholder, options: options, value: value, onChange: onChange }) {
    const [query, setQuery] = (0, $kLOUX.useState)('');
    const fuse = (0, $kLOUX.useMemo)(()=>new (0, $jDUXD.default)(options, {
            keys: [
                'label'
            ],
            minMatchCharLength: 2,
            threshold: 0.2
        }), [
        options
    ]);
    const filteredOptions = query === '' || query.length < 2 ? options : fuse.search(query).map((result)=>result.item);
    return /*#__PURE__*/ (0, $8jWPf.jsx)((0, $dbe06488926fee5e$export$27957ad87354dd7e), {
        name: name,
        value: value,
        onChange: onChange,
        children: /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
            className: $2beebd03a2583798$export$da58ae6e4434453,
            children: [
                /*#__PURE__*/ (0, $8jWPf.jsx)((0, $dbe06488926fee5e$export$27957ad87354dd7e).Input, {
                    placeholder: placeholder,
                    spellcheck: false,
                    className: $2beebd03a2583798$export$b7e3ae3d7c15e42e,
                    onChange: (event)=>setQuery(event.target.value),
                    displayValue: ()=>options.find((option)=>option.value === value)?.label || ''
                }),
                /*#__PURE__*/ (0, $8jWPf.jsx)((0, $dbe06488926fee5e$export$27957ad87354dd7e).Button, {
                    className: $2beebd03a2583798$export$2ba01fb71ed41cb6,
                    children: /*#__PURE__*/ (0, $8jWPf.jsx)("span", {
                        hidden: true,
                        children: "Men\xfc offnen"
                    })
                }),
                filteredOptions.length > 0 && /*#__PURE__*/ (0, $8jWPf.jsx)((0, $dbe06488926fee5e$export$27957ad87354dd7e).Options, {
                    className: $2beebd03a2583798$export$41c562ebe57d11e2,
                    children: filteredOptions.map((option)=>/* Use the `active` state to conditionally style the active option. */ /* Use the `selected` state to conditionally style the selected option. */ /*#__PURE__*/ (0, $8jWPf.jsx)((0, $dbe06488926fee5e$export$27957ad87354dd7e).Option, {
                            as: (0, $bRFDG.Fragment),
                            value: option.value,
                            disabled: option.disabled,
                            children: ({ active: active, selected: selected })=>/*#__PURE__*/ (0, $8jWPf.jsxs)("li", {
                                    className: `${$2beebd03a2583798$export$a75d1723e6bda2ec} ${active ? $2beebd03a2583798$export$7d7ba61f757457b : ''} ${selected ? $2beebd03a2583798$export$12afe09fc732f57b : ''}`,
                                    children: [
                                        selected && /*#__PURE__*/ (0, $8jWPf.jsx)("span", {
                                            class: `${$2beebd03a2583798$export$66cd3fca83bcd8fb} ion-checkmark`
                                        }),
                                        /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                            class: $2beebd03a2583798$export$245ad05b0468ea5e,
                                            children: option.label
                                        })
                                    ]
                                })
                        }, option.value))
                })
            ]
        })
    });
}



var $h6tPy = parcelRequire("h6tPy");

var $2lFhQ = parcelRequire("2lFhQ");
var $c32f774ce4be7710$export$bbea856fdb3e3c5f;
var $c32f774ce4be7710$export$47b8a9da50e6548b;
var $c32f774ce4be7710$export$7704680374d20c41;
var $c32f774ce4be7710$export$b9508c5e7965e0a;
var $c32f774ce4be7710$export$89b6e287e113fda2;
var $c32f774ce4be7710$export$20b7a0551759468c;
var $c32f774ce4be7710$export$d7239d0d3eabfd08;
var $c32f774ce4be7710$export$a3b3dd91bb6e3e2e;
var $c32f774ce4be7710$export$ed525da08f7685d8;
var $c32f774ce4be7710$export$12badc1a4c058bdf;
var $c32f774ce4be7710$export$1a5522229f119385;
var $c32f774ce4be7710$export$75a30c72c46d1150;
var $c32f774ce4be7710$export$d9285f8c9af52c83;
var $c32f774ce4be7710$export$7aa0c83474a14c4f;
var $c32f774ce4be7710$export$c708e0ac0ddf067a;
var $c32f774ce4be7710$export$b6aad051bad07f12;
var $c32f774ce4be7710$export$f958ebe0160bc812;
var $c32f774ce4be7710$export$92ddd6250d45918d;
var $c32f774ce4be7710$export$4cb887bfde2d34ca;
var $c32f774ce4be7710$export$952af3258ed45903;
var $c32f774ce4be7710$export$c96a1e11704887e0;
var $c32f774ce4be7710$export$a6561da213d61175;
var $c32f774ce4be7710$export$f25deb47ca6d0fa1;
var $c32f774ce4be7710$export$e06a4d010de1aa71;
$c32f774ce4be7710$export$bbea856fdb3e3c5f = `_1jQToa_buttons`;
$c32f774ce4be7710$export$47b8a9da50e6548b = `_1jQToa_categoryFilter`;
$c32f774ce4be7710$export$7704680374d20c41 = `_1jQToa_categoryGroup`;
$c32f774ce4be7710$export$b9508c5e7965e0a = `_1jQToa_categoryHeadline`;
$c32f774ce4be7710$export$89b6e287e113fda2 = `_1jQToa_categoryProducts`;
$c32f774ce4be7710$export$20b7a0551759468c = `_1jQToa_clearButtonContainer`;
$c32f774ce4be7710$export$d7239d0d3eabfd08 = `_1jQToa_dispatchItemRow`;
$c32f774ce4be7710$export$a3b3dd91bb6e3e2e = `_1jQToa_formTablet`;
$c32f774ce4be7710$export$ed525da08f7685d8 = `_1jQToa_formTabletContent`;
$c32f774ce4be7710$export$12badc1a4c058bdf = `_1jQToa_inputRow`;
$c32f774ce4be7710$export$1a5522229f119385 = `_1jQToa_modalPanelTablet`;
$c32f774ce4be7710$export$75a30c72c46d1150 = `_1jQToa_productName`;
$c32f774ce4be7710$export$d9285f8c9af52c83 = `_1jQToa_productNameText`;
$c32f774ce4be7710$export$7aa0c83474a14c4f = `_1jQToa_productTile`;
$c32f774ce4be7710$export$c708e0ac0ddf067a = `_1jQToa_productTileWithInput ${$c32f774ce4be7710$export$7aa0c83474a14c4f}`;
$c32f774ce4be7710$export$b6aad051bad07f12 = `_1jQToa_products`;
$c32f774ce4be7710$export$f958ebe0160bc812 = `_1jQToa_productsHeader`;
$c32f774ce4be7710$export$92ddd6250d45918d = `_1jQToa_resetSearchButton`;
$c32f774ce4be7710$export$4cb887bfde2d34ca = `_1jQToa_route`;
$c32f774ce4be7710$export$952af3258ed45903 = `_1jQToa_searchInput`;
$c32f774ce4be7710$export$c96a1e11704887e0 = `_1jQToa_stepperButton`;
$c32f774ce4be7710$export$a6561da213d61175 = `_1jQToa_stepperButtonTouched ${$c32f774ce4be7710$export$c96a1e11704887e0}`;
$c32f774ce4be7710$export$f25deb47ca6d0fa1 = `_1jQToa_tabletFormSubmitButtons`;
$c32f774ce4be7710$export$e06a4d010de1aa71 = `_1jQToa_tabletFormSubmitSection`;



var $8jWPf = parcelRequire("8jWPf");

var $8tI2z = parcelRequire("8tI2z");

var $kLOUX = parcelRequire("kLOUX");
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");
var $e236c96a4a68e839$export$8793edee2d425525 = function() {};
function $e236c96a4a68e839$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $e236c96a4a68e839$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $e236c96a4a68e839$export$4e09c449d6c407f7 = typeof window !== 'undefined';
var $e236c96a4a68e839$export$42e7ac6120dd324e = typeof navigator !== 'undefined';


var $337c939e40d29a86$var$useLocalStorage = function(key, initialValue, options) {
    if (!(0, $e236c96a4a68e839$export$4e09c449d6c407f7)) return [
        initialValue,
        (0, $e236c96a4a68e839$export$8793edee2d425525),
        (0, $e236c96a4a68e839$export$8793edee2d425525)
    ];
    if (!key) throw new Error('useLocalStorage key may not be falsy');
    var deserializer = options ? options.raw ? function(value) {
        return value;
    } : options.deserializer : JSON.parse;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var initializer = (0, $kLOUX.useRef)(function(key) {
        try {
            var serializer = options ? options.raw ? String : options.serializer : JSON.stringify;
            var localStorageValue = localStorage.getItem(key);
            if (localStorageValue !== null) return deserializer(localStorageValue);
            else {
                initialValue && localStorage.setItem(key, serializer(initialValue));
                return initialValue;
            }
        } catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = (0, $kLOUX.useState)(function() {
        return initializer.current(key);
    }), state = _a[0], setState = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kLOUX.useLayoutEffect)(function() {
        return setState(initializer.current(key));
    }, [
        key
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var set = (0, $kLOUX.useCallback)(function(valOrFunc) {
        try {
            var newState = typeof valOrFunc === 'function' ? valOrFunc(state) : valOrFunc;
            if (typeof newState === 'undefined') return;
            var value = void 0;
            if (options) {
                if (options.raw) {
                    if (typeof newState === 'string') value = newState;
                    else value = JSON.stringify(newState);
                } else if (options.serializer) value = options.serializer(newState);
                else value = JSON.stringify(newState);
            } else value = JSON.stringify(newState);
            localStorage.setItem(key, value);
            setState(deserializer(value));
        } catch (_a) {
        // If user is in private mode or has storage restriction
        // localStorage can throw. Also JSON.stringify can throw.
        }
    }, [
        key,
        setState
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var remove = (0, $kLOUX.useCallback)(function() {
        try {
            localStorage.removeItem(key);
            setState(undefined);
        } catch (_a) {
        // If user is in private mode or has storage restriction
        // localStorage can throw.
        }
    }, [
        key,
        setState
    ]);
    return [
        state,
        set,
        remove
    ];
};
var $337c939e40d29a86$export$2e2bcd8739ae039 = $337c939e40d29a86$var$useLocalStorage;



var $h6tPy = parcelRequire("h6tPy");

var $2lFhQ = parcelRequire("2lFhQ");

var $8jWPf = parcelRequire("8jWPf");
parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $241f3096efdfec6e$var$getInitialState = function(query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) return defaultState;
    if (0, $e236c96a4a68e839$export$4e09c449d6c407f7) return window.matchMedia(query).matches;
    return false;
};
var $241f3096efdfec6e$var$useMedia = function(query, defaultState) {
    var _a = (0, $kLOUX.useState)($241f3096efdfec6e$var$getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    (0, $kLOUX.useEffect)(function() {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function() {
            if (!mounted) return;
            setState(!!mql.matches);
        };
        mql.addEventListener('change', onChange);
        setState(mql.matches);
        return function() {
            mounted = false;
            mql.removeEventListener('change', onChange);
        };
    }, [
        query
    ]);
    return state;
};
var $241f3096efdfec6e$export$2e2bcd8739ae039 = $241f3096efdfec6e$var$useMedia;


function $35afd694885b3f19$export$cd4068abab690d87(key) {
    const isTouchDevice = (0, $241f3096efdfec6e$export$2e2bcd8739ae039)('(pointer: coarse)');
    const [isTabletMode = false, setIsTabletMode] = (0, $337c939e40d29a86$export$2e2bcd8739ae039)(key, isTouchDevice);
    return [
        isTabletMode,
        setIsTabletMode
    ];
}
function $35afd694885b3f19$export$ebb9f705c3c57fce({ checked: checked, onChange: onChange }) {
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("label", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            margin: 0,
            fontSize: '1rem',
            lineHeight: 1,
            cursor: 'pointer'
        },
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                type: "checkbox",
                checked: checked,
                onChange: (event)=>onChange(event.currentTarget.checked)
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)("span", {
                children: "Tablet Modus"
            })
        ]
    });
}


function $a2facf4e6f195f22$export$a838703c75495005() {
    const [persistedState, setPersistedState] = (0, $337c939e40d29a86$export$2e2bcd8739ae039)('dispatch-form-state', {
        sourceId: '',
        targetId: '',
        comment: '',
        transactions: {}
    });
    const [sourceId, setSourceId] = (0, $kLOUX.useState)(persistedState?.sourceId ?? '');
    const [targetId, setTargetId] = (0, $kLOUX.useState)(persistedState?.targetId ?? '');
    const [comment, setComment] = (0, $kLOUX.useState)(persistedState?.comment ?? '');
    const [transactions, setTransactions] = (0, $kLOUX.useState)(persistedState?.transactions ?? {});
    const handleUpdateTransactions = (0, $kLOUX.useCallback)((update)=>{
        setTransactions((prev)=>{
            const newTransactions = {
                ...prev
            };
            if (update.inputPackages === 0 && update.inputUnits === 0) delete newTransactions[update.productId];
            else newTransactions[update.productId] = update;
            return newTransactions;
        });
    }, []);
    const resetFormState = (0, $kLOUX.useCallback)(()=>{
        setSourceId('');
        setTargetId('');
        setComment('');
        setTransactions({});
    }, []);
    const clearPersistedState = (0, $kLOUX.useCallback)(()=>{
        setPersistedState({
            sourceId: '',
            targetId: '',
            comment: '',
            transactions: {}
        });
    }, [
        setPersistedState
    ]);
    (0, $kLOUX.useEffect)(()=>{
        setPersistedState({
            sourceId: sourceId,
            targetId: targetId,
            comment: comment,
            transactions: transactions
        });
    }, [
        sourceId,
        targetId,
        comment,
        transactions,
        setPersistedState
    ]);
    return {
        sourceId: sourceId,
        setSourceId: setSourceId,
        targetId: targetId,
        setTargetId: setTargetId,
        comment: comment,
        setComment: setComment,
        transactions: transactions,
        handleUpdateTransactions: handleUpdateTransactions,
        resetFormState: resetFormState,
        clearPersistedState: clearPersistedState
    };
}
function $a2facf4e6f195f22$export$93fc5c51b255ac3f({ targetName: targetName, isTabletMode: isTabletMode, setIsTabletMode: setIsTabletMode, onClose: onClose }) {
    const role = (0, $h6tPy.useCurrentRole)();
    return /*#__PURE__*/ (0, $8jWPf.jsx)("fieldset", {
        style: {
            paddingBottom: 0
        },
        children: /*#__PURE__*/ (0, $8jWPf.jsxs)((0, $8tI2z.Dialog).Title, {
            as: "legend",
            style: {
                display: 'grid',
                gridTemplateColumns: 'auto max-content min-content',
                alignItems: 'center',
                gap: '1em'
            },
            children: [
                /*#__PURE__*/ (0, $8jWPf.jsx)("strong", {
                    children: role === 'bar' ? `Produkte anfordern f\xfcr ${targetName}` : 'Produkte dispatchen'
                }),
                /*#__PURE__*/ (0, $8jWPf.jsx)((0, $35afd694885b3f19$export$ebb9f705c3c57fce), {
                    checked: isTabletMode,
                    onChange: setIsTabletMode
                }),
                /*#__PURE__*/ (0, $8jWPf.jsx)((0, $2lFhQ.TextButton), {
                    onClick: onClose,
                    children: "Schlie\xdfen"
                })
            ]
        })
    });
}


const $6b311541957ec9d8$var$log = (0, $gvQO6.logger).extend('dispatch-form');
function $6b311541957ec9d8$export$981028df8fa8a579({ onClose: onClose, initialFocus: initialFocus, isTabletMode: isTabletMode, setIsTabletMode: setIsTabletMode }) {
    const eventSlug = (0, $h6tPy.useCurrentEventSlug)();
    const { mutate: mutateTransactions } = (0, $h6tPy.useTransactions)();
    const { locations: locations, storage: storage, bars: bars } = (0, $h6tPy.useLocations)(eventSlug);
    const { data: products } = (0, $04t5A.default)(`/api/events/${eventSlug}/products`);
    const productsById = (0, (/*@__PURE__*/$parcel$interopDefault($9zKvP)))(products || [], 'id');
    const productOptions = (0, $kLOUX.useMemo)(()=>products?.map((product)=>({
                value: product.id,
                label: product.name
            })).toSorted((a, b)=>a.label.localeCompare(b.label)) ?? [], [
        products
    ]);
    const [sourceId, setSourceId] = (0, $kLOUX.useState)('');
    const [targetId, setTargetId] = (0, $kLOUX.useState)('');
    const [comment, setComment] = (0, $kLOUX.useState)('');
    const [transactions, setTransactions] = (0, $kLOUX.useState)([
        {
            productId: '',
            inputPackages: 0,
            inputUnits: 0
        }
    ]);
    const [isSubmitting, setIsSubmitting] = (0, $kLOUX.useState)(false);
    (0, $kLOUX.useEffect)(function setInitialSource() {
        if (!sourceId && storage && locations) {
            const source = (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.defaultSourceLocationId ? locations.find((store)=>store.id === (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.defaultSourceLocationId) : storage[0];
            if (source) {
                setSourceId(source.id);
                $6b311541957ec9d8$var$log(`set initial source: ${source.name} (${source.id})`);
            }
        }
    }, [
        locations,
        storage,
        sourceId
    ]);
    // set target for user's with assigned location (e.g. bar bosses)
    (0, $kLOUX.useEffect)(function setInitialTarget() {
        const locationId = (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.defaultTargetLocationId || (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.assignedLocationId;
        if (!targetId && locations && locationId) {
            const target = locations.find((l)=>l.id === locationId);
            if (target) {
                setTargetId(target.id);
                $6b311541957ec9d8$var$log(`set initial target: ${target.name} (${target.id})`);
            }
        }
    }, [
        locations,
        targetId
    ]);
    const isValid = Boolean(sourceId && targetId && transactions.some((tx)=>tx.productId && (tx.inputPackages > 0 || tx.inputUnits > 0)));
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("form", {
        class: "pure-form",
        onSubmit: async (event)=>{
            event.preventDefault();
            setIsSubmitting(true);
            const payload = transactions.filter((tx)=>tx.productId && (tx.inputPackages > 0 || tx.inputUnits > 0)).map((tx)=>({
                    sourceId: sourceId,
                    targetId: targetId,
                    productId: tx.productId,
                    units: tx.inputPackages * productsById[tx.productId].packageSize + tx.inputUnits,
                    comment: comment
                }));
            try {
                await (0, $h6tPy.bulkCreateTransactions)(eventSlug, payload);
                await mutateTransactions();
                onClose();
            } catch (error) {
                console.error(error);
            } finally{
                setIsSubmitting(false);
            }
        },
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsx)((0, $a2facf4e6f195f22$export$93fc5c51b255ac3f), {
                targetName: locations?.find((l)=>l.id === targetId)?.name,
                isTabletMode: isTabletMode,
                setIsTabletMode: setIsTabletMode,
                onClose: onClose
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)("fieldset", {
                children: /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                    class: $c32f774ce4be7710$export$4cb887bfde2d34ca,
                    children: [
                        /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                                    for: "source",
                                    children: "Von"
                                }),
                                /*#__PURE__*/ (0, $8jWPf.jsxs)("select", {
                                    class: "pure-input-1",
                                    name: "source",
                                    value: sourceId,
                                    onChange: (event)=>setSourceId(event.currentTarget.value),
                                    ref: initialFocus,
                                    required: true,
                                    children: [
                                        storage && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                            label: "Lager",
                                            children: storage.map((store)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                    value: store.id,
                                                    children: store.name
                                                }, store.id))
                                        }),
                                        bars && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                            label: "Bars",
                                            children: bars.map((bar)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                    value: bar.id,
                                                    children: bar.name
                                                }, bar.id))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                                    for: "target",
                                    children: "Nach"
                                }),
                                /*#__PURE__*/ (0, $8jWPf.jsxs)("select", {
                                    class: "pure-input-1",
                                    name: "target",
                                    value: targetId,
                                    onChange: (event)=>setTargetId(event.currentTarget.value),
                                    required: true,
                                    children: [
                                        /*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                            disabled: true,
                                            value: "",
                                            children: "Ziel w\xe4hlen..."
                                        }),
                                        bars && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                            label: "Bars",
                                            children: bars.map((bar)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                    value: bar.id,
                                                    children: bar.name
                                                }, bar.id))
                                        }),
                                        storage && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                            label: "Lager",
                                            children: storage.map((store)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                                    value: store.id,
                                                    children: store.name
                                                }, store.id))
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)("fieldset", {
                children: transactions.map((tx, i)=>/*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        class: $c32f774ce4be7710$export$d7239d0d3eabfd08,
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)((0, $545dd39faa0aa189$export$27957ad87354dd7e), {
                                name: "productId",
                                placeholder: "Produkt ausw\xe4hlen...",
                                value: tx.productId,
                                options: productOptions,
                                onChange: (option)=>{
                                    const newTransactions = [
                                        ...transactions
                                    ];
                                    newTransactions[i] = {
                                        ...newTransactions[i],
                                        productId: option
                                    };
                                    setTransactions(newTransactions);
                                }
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                                        class: "pure-input-1",
                                        name: "inputPackages",
                                        type: "number",
                                        min: "0",
                                        placeholder: "0",
                                        value: tx.inputPackages || '',
                                        onChange: (event)=>{
                                            const newTransactions = [
                                                ...transactions
                                            ];
                                            newTransactions[i] = {
                                                ...newTransactions[i],
                                                inputPackages: event.currentTarget.valueAsNumber
                                            };
                                            setTransactions(newTransactions);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("span", {
                                        class: "append",
                                        children: productsById && tx.productId ? (0, $d0uB5.packaging).get(productsById[tx.productId].packageId).name : 'Kiste'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                                        class: "pure-input-1",
                                        name: "inputUnits",
                                        type: "number",
                                        min: "0",
                                        step: "any",
                                        placeholder: "0",
                                        value: tx.inputUnits || '',
                                        onChange: (event)=>{
                                            const newTransactions = [
                                                ...transactions
                                            ];
                                            newTransactions[i] = {
                                                ...newTransactions[i],
                                                inputUnits: event.currentTarget.valueAsNumber
                                            };
                                            setTransactions(newTransactions);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("span", {
                                        class: "append",
                                        children: productsById && tx.productId ? (0, $d0uB5.packaging).get(productsById[tx.productId].unitId).name : 'Flasche'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                                class: "dispatch-item-remove",
                                title: "Entfernen...",
                                type: "button",
                                tabIndex: -1,
                                onClick: (event)=>{
                                    event.preventDefault();
                                    setTransactions(transactions.filter((tx, index)=>index !== i));
                                },
                                children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                                    class: "ion-ios-minus-outline"
                                })
                            })
                        ]
                    }, `transaction-${tx.productId || tx.inputPackages || Math.random()}`))
            }),
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $c32f774ce4be7710$export$bbea856fdb3e3c5f,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)((0, $2lFhQ.TextButton), {
                        onClick: (event)=>{
                            event.preventDefault();
                            setTransactions([
                                ...transactions,
                                {
                                    productId: '',
                                    inputPackages: 0,
                                    inputUnits: 0
                                }
                            ]);
                        },
                        children: "Weiteres Produkt hinzuf\xfcgen..."
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                        style: {
                            alignSelf: 'stretch'
                        },
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                                htmlFor: "comment",
                                children: "Kommentar"
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsx)("textarea", {
                                name: "comment",
                                rows: 3,
                                style: {
                                    width: '100%'
                                },
                                value: comment,
                                onChange: (event)=>setComment(event.currentTarget.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                        class: "pure-button pure-button-primary",
                        type: "submit",
                        disabled: !isValid || isSubmitting,
                        children: "Abschicken"
                    })
                ]
            })
        ]
    });
}




var $8jWPf = parcelRequire("8jWPf");

var $4UX9c = parcelRequire("4UX9c");

var $jDUXD = parcelRequire("jDUXD");

var $9zKvP = parcelRequire("9zKvP");

var $gsMHG = parcelRequire("gsMHG");

var $kLOUX = parcelRequire("kLOUX");


var $04t5A = parcelRequire("04t5A");

var $gvQO6 = parcelRequire("gvQO6");

var $h6tPy = parcelRequire("h6tPy");

var $2lFhQ = parcelRequire("2lFhQ");



var $8jWPf = parcelRequire("8jWPf");

var $gsMHG = parcelRequire("gsMHG");
var $kLOUX = parcelRequire("kLOUX");

var $d0uB5 = parcelRequire("d0uB5");

var $2lFhQ = parcelRequire("2lFhQ");

function $15d55a3a05681783$var$StepperButton({ children: children, onClick: onClick, disabled: disabled }) {
    const [touched, setTouched] = (0, $kLOUX.useState)(false);
    return /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
        class: touched ? $c32f774ce4be7710$export$a6561da213d61175 : $c32f774ce4be7710$export$c96a1e11704887e0,
        type: "button",
        disabled: disabled,
        onClick: onClick,
        onTouchStart: ()=>setTouched(true),
        onTouchEnd: ()=>setTouched(false),
        children: children
    });
}
function $15d55a3a05681783$var$ProductTileClearButton({ transaction: transaction, onUpdate: onUpdate }) {
    return /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
        class: $c32f774ce4be7710$export$20b7a0551759468c,
        children: /*#__PURE__*/ (0, $8jWPf.jsx)((0, $2lFhQ.TextButton), {
            variant: "error",
            onClick: ()=>onUpdate({
                    ...transaction,
                    inputPackages: 0,
                    inputUnits: 0
                }),
            "aria-label": "Produkt entfernen",
            children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                class: "icon ion-close-round"
            })
        })
    });
}
const $15d55a3a05681783$export$eb3ef33bb691e32f = (0, $gsMHG.memo)(function ProductTile({ product: product, transaction: transaction = {
    productId: product.id,
    inputPackages: 0,
    inputUnits: 0
}, onUpdate: onUpdate }) {
    const hasInput = transaction.inputPackages > 0 || transaction.inputUnits > 0;
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
        class: hasInput ? $c32f774ce4be7710$export$c708e0ac0ddf067a : $c32f774ce4be7710$export$7aa0c83474a14c4f,
        style: {
            '--category-color': product.color
        },
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $c32f774ce4be7710$export$75a30c72c46d1150,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                        class: $c32f774ce4be7710$export$d9285f8c9af52c83,
                        children: product.name
                    }),
                    hasInput && /*#__PURE__*/ (0, $8jWPf.jsx)($15d55a3a05681783$var$ProductTileClearButton, {
                        transaction: transaction,
                        onUpdate: onUpdate
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $c32f774ce4be7710$export$12badc1a4c058bdf,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)($15d55a3a05681783$var$StepperButton, {
                        disabled: transaction.inputPackages === 0,
                        onClick: ()=>{
                            onUpdate({
                                ...transaction,
                                inputPackages: Math.max(0, transaction.inputPackages - 1)
                            });
                        },
                        children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                            class: "icon ion-minus-round"
                        })
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                                class: "pure-input-1",
                                name: "inputPackages",
                                type: "text",
                                inputMode: "numeric",
                                placeholder: "0",
                                value: transaction.inputPackages || '',
                                onChange: (event)=>{
                                    let inputPackages = Number.parseInt(event.currentTarget.value);
                                    if (inputPackages < 0) inputPackages = 0;
                                    if (Number.isNaN(inputPackages)) inputPackages = transaction.inputPackages;
                                    onUpdate({
                                        ...transaction,
                                        inputPackages: inputPackages
                                    });
                                }
                            }),
                            (0, $d0uB5.packaging).get(product.packageId).name
                        ]
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)($15d55a3a05681783$var$StepperButton, {
                        onClick: ()=>{
                            onUpdate({
                                ...transaction,
                                inputPackages: transaction.inputPackages + 1
                            });
                        },
                        children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                            class: "icon ion-plus-round"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $c32f774ce4be7710$export$12badc1a4c058bdf,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)($15d55a3a05681783$var$StepperButton, {
                        disabled: transaction.inputUnits === 0,
                        onClick: ()=>{
                            onUpdate({
                                ...transaction,
                                inputUnits: Math.max(0, transaction.inputUnits - 1)
                            });
                        },
                        children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                            class: "icon ion-minus-round"
                        })
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("label", {
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                                class: "pure-input-1",
                                name: "inputUnits",
                                type: "text",
                                inputMode: "numeric",
                                placeholder: "0",
                                value: transaction.inputUnits || '',
                                onChange: (event)=>{
                                    let inputUnits = Number.parseFloat(event.currentTarget.value);
                                    if (inputUnits < 0) inputUnits = 0;
                                    if (Number.isNaN(inputUnits)) inputUnits = transaction.inputUnits;
                                    onUpdate({
                                        ...transaction,
                                        inputUnits: inputUnits
                                    });
                                }
                            }),
                            (0, $d0uB5.packaging).get(product.unitId).name
                        ]
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)($15d55a3a05681783$var$StepperButton, {
                        onClick: ()=>{
                            onUpdate({
                                ...transaction,
                                inputUnits: transaction.inputUnits + 1
                            });
                        },
                        children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                            class: "icon ion-plus-round"
                        })
                    })
                ]
            })
        ]
    });
});



const $4ac8a87582efc7ba$var$log = (0, $gvQO6.logger).extend('dispatch-form');
const $4ac8a87582efc7ba$var$SONSTIGE_CATEGORY = 'Sonstige';
const $4ac8a87582efc7ba$var$DispatchRouteMemo = (0, $gsMHG.memo)(function DispatchRoute({ sourceId: sourceId, setSourceId: setSourceId, targetId: targetId, setTargetId: setTargetId, storage: storage, bars: bars }) {
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
        class: $c32f774ce4be7710$export$4cb887bfde2d34ca,
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                        for: "source",
                        children: "Von"
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("select", {
                        class: "pure-input-1",
                        name: "source",
                        value: sourceId,
                        onChange: (event)=>setSourceId(event.currentTarget.value),
                        required: true,
                        children: [
                            storage && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                label: "Lager",
                                children: storage.map((store)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                        value: store.id,
                                        children: store.name
                                    }, store.id))
                            }),
                            bars && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                label: "Bars",
                                children: bars.map((bar)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                        value: bar.id,
                                        children: bar.name
                                    }, bar.id))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                        for: "target",
                        children: "Nach"
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("select", {
                        class: "pure-input-1",
                        name: "target",
                        value: targetId,
                        onChange: (event)=>setTargetId(event.currentTarget.value),
                        required: true,
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                disabled: true,
                                value: "",
                                children: "Ziel w\xe4hlen..."
                            }),
                            bars && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                label: "Bars",
                                children: bars.map((bar)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                        value: bar.id,
                                        children: bar.name
                                    }, bar.id))
                            }),
                            storage && /*#__PURE__*/ (0, $8jWPf.jsx)("optgroup", {
                                label: "Lager",
                                children: storage.map((store)=>/*#__PURE__*/ (0, $8jWPf.jsx)("option", {
                                        value: store.id,
                                        children: store.name
                                    }, store.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
function $4ac8a87582efc7ba$var$SubmitButton({ disabled: disabled, itemsCount: itemsCount }) {
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("button", {
        class: "pure-button pure-button-primary",
        type: "submit",
        disabled: disabled,
        children: [
            itemsCount === 0 && 'Abschicken',
            itemsCount === 1 && `${itemsCount} Produkt dispatchen`,
            itemsCount > 1 && `${itemsCount} Produkte dispatchen`
        ]
    });
}
function $4ac8a87582efc7ba$export$14ce3106fdf9d377({ onClose: onClose, isTabletMode: isTabletMode, setIsTabletMode: setIsTabletMode }) {
    const eventSlug = (0, $h6tPy.useCurrentEventSlug)();
    const { mutate: mutateTransactions } = (0, $h6tPy.useTransactions)();
    const { locations: locations, storage: storage, bars: bars } = (0, $h6tPy.useLocations)(eventSlug);
    const { data: products } = (0, $04t5A.default)(`/api/events/${eventSlug}/products`);
    const productsById = (0, (/*@__PURE__*/$parcel$interopDefault($9zKvP)))(products || [], 'id');
    const { sourceId: sourceId, setSourceId: setSourceId, targetId: targetId, setTargetId: setTargetId, comment: comment, setComment: setComment, transactions: transactions, handleUpdateTransactions: handleUpdateTransactions, resetFormState: resetFormState, clearPersistedState: clearPersistedState } = (0, $a2facf4e6f195f22$export$a838703c75495005)();
    const [sortOrder = 'sortPosition', setSortOrder] = (0, $337c939e40d29a86$export$2e2bcd8739ae039)('dispatch-form-sort-order', 'sortPosition');
    const [categoryFilter, setCategoryFilter] = (0, $kLOUX.useState)('all');
    const isBigScreen = (0, $241f3096efdfec6e$export$2e2bcd8739ae039)('(min-width: 1024px)');
    const [showComment, setShowComment] = (0, $kLOUX.useState)(isBigScreen);
    const [isSubmitting, setIsSubmitting] = (0, $kLOUX.useState)(false);
    // set source for user's with assigned location
    (0, $kLOUX.useEffect)(()=>{
        if (!sourceId && storage && locations) {
            const source = (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.defaultSourceLocationId ? locations.find((store)=>store.id === (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.defaultSourceLocationId) : storage[0];
            if (source) {
                setSourceId(source.id);
                $4ac8a87582efc7ba$var$log(`set initial source: ${source.name} (${source.id})`);
            }
        }
    }, [
        locations,
        storage,
        sourceId,
        setSourceId
    ]);
    // set target for user's with assigned location (e.g. bar bosses)
    (0, $kLOUX.useEffect)(()=>{
        const locationId = (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.defaultTargetLocationId || (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).me.assignedLocationId;
        if (!targetId && locations && locationId) {
            const target = locations.find((l)=>l.id === locationId);
            if (target) {
                setTargetId(target.id);
                $4ac8a87582efc7ba$var$log(`set initial target: ${target.name} (${target.id})`);
            }
        }
    }, [
        locations,
        targetId,
        setTargetId
    ]);
    const [query, setQuery] = (0, $kLOUX.useState)('');
    const fuse = (0, $kLOUX.useMemo)(()=>new (0, $jDUXD.default)(products ?? [], {
            keys: [
                'name'
            ],
            minMatchCharLength: 2,
            threshold: 0.25
        }), [
        products
    ]);
    const allCategories = (0, $kLOUX.useMemo)(()=>{
        return Array.from(new Set(products?.map((product)=>product.categoryName).filter((category)=>category !== null))).sort((a, b)=>a.localeCompare(b));
    }, [
        products
    ]);
    const filteredAndSortedProducts = (0, $kLOUX.useMemo)(()=>{
        let filteredProducts = query.length < 2 ? products : fuse.search(query).map((result)=>result.item);
        if (!filteredProducts) return null;
        if (categoryFilter !== 'all') filteredProducts = filteredProducts.filter((product)=>{
            if (categoryFilter === $4ac8a87582efc7ba$var$SONSTIGE_CATEGORY) return product.categoryName === null;
            return product.categoryName === categoryFilter;
        });
        // Sort products first
        const sortedProducts = sortOrder === 'name' ? filteredProducts.toSorted((a, b)=>a.name.localeCompare(b.name)) : filteredProducts;
        // Group products by category
        const groupedProducts = sortedProducts.reduce((groups, product)=>{
            const category = product.categoryName || $4ac8a87582efc7ba$var$SONSTIGE_CATEGORY;
            if (!groups[category]) groups[category] = [];
            groups[category].push(product);
            return groups;
        }, {});
        // Sort categories alphabetically, with "Sonstige" always last
        const sortedGroupedProducts = Object.entries(groupedProducts).sort((a, b)=>{
            if (a[0] === $4ac8a87582efc7ba$var$SONSTIGE_CATEGORY) return 1;
            if (b[0] === $4ac8a87582efc7ba$var$SONSTIGE_CATEGORY) return -1;
            return a[0].localeCompare(b[0]);
        });
        return sortedGroupedProducts;
    }, [
        products,
        sortOrder,
        query,
        fuse,
        categoryFilter
    ]);
    const isValid = Boolean(sourceId && targetId && Object.values(transactions).some((tx)=>tx.productId && (tx.inputPackages > 0 || tx.inputUnits > 0)));
    if (!filteredAndSortedProducts) return null;
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("form", {
        class: `pure-form ${$c32f774ce4be7710$export$a3b3dd91bb6e3e2e}`,
        onSubmit: async (event)=>{
            event.preventDefault();
            setIsSubmitting(true);
            const payload = Object.values(transactions).filter((tx)=>tx.productId && (tx.inputPackages > 0 || tx.inputUnits > 0)).map((tx)=>({
                    sourceId: sourceId,
                    targetId: targetId,
                    productId: tx.productId,
                    units: tx.inputPackages * productsById[tx.productId].packageSize + tx.inputUnits,
                    comment: comment
                }));
            try {
                await (0, $h6tPy.bulkCreateTransactions)(eventSlug, payload);
                await mutateTransactions();
                clearPersistedState();
                onClose();
            } catch (error) {
                console.error(error);
            } finally{
                setIsSubmitting(false);
            }
        },
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsx)((0, $a2facf4e6f195f22$export$93fc5c51b255ac3f), {
                targetName: locations?.find((l)=>l.id === targetId)?.name,
                isTabletMode: isTabletMode,
                setIsTabletMode: setIsTabletMode,
                onClose: onClose
            }),
            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $c32f774ce4be7710$export$ed525da08f7685d8,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("section", {
                        "aria-label": "Produkte",
                        "data-slot": "products",
                        children: [
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("header", {
                                class: $c32f774ce4be7710$export$f958ebe0160bc812,
                                children: [
                                    /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                        class: "input-addon",
                                        children: [
                                            /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                                                class: "icon ion-ios-search-strong input-addon-item"
                                            }),
                                            /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                                                className: $c32f774ce4be7710$export$952af3258ed45903,
                                                type: "text",
                                                name: "product-search",
                                                autoComplete: "off",
                                                autoCorrect: "off",
                                                autoCapitalize: "off",
                                                enterKeyHint: "search",
                                                placeholder: "Produkt suchen...",
                                                value: query,
                                                onKeyDown: (event)=>{
                                                    if (event.key === 'Escape' && query.length > 0) {
                                                        event.stopPropagation();
                                                        setQuery('');
                                                    }
                                                },
                                                onChange: (event)=>setQuery(event.currentTarget.value)
                                            }),
                                            /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                                                type: "button",
                                                class: $c32f774ce4be7710$export$92ddd6250d45918d,
                                                onClick: ()=>setQuery(''),
                                                children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                                                    class: "icon ion-close"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8jWPf.jsx)((0, $ca3de27e0e219e5b$export$68c13de1abdfa2b3), {
                                        label: "Sortieren:",
                                        options: [
                                            {
                                                value: 'sortPosition',
                                                label: 'Manuell'
                                            },
                                            {
                                                value: 'name',
                                                label: 'A-Z'
                                            }
                                        ],
                                        value: sortOrder,
                                        onChange: setSortOrder
                                    }),
                                    allCategories.length > 0 && /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                        class: $c32f774ce4be7710$export$47b8a9da50e6548b,
                                        children: /*#__PURE__*/ (0, $8jWPf.jsx)((0, $ca3de27e0e219e5b$export$68c13de1abdfa2b3), {
                                            options: [
                                                {
                                                    value: 'all',
                                                    label: 'Alle'
                                                },
                                                ...allCategories.map((category)=>({
                                                        value: category,
                                                        label: category
                                                    })),
                                                {
                                                    value: $4ac8a87582efc7ba$var$SONSTIGE_CATEGORY,
                                                    label: 'Sonstige'
                                                }
                                            ],
                                            value: categoryFilter,
                                            onChange: setCategoryFilter
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                class: $c32f774ce4be7710$export$b6aad051bad07f12,
                                children: filteredAndSortedProducts.map(([category, categoryProducts])=>/*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                        class: $c32f774ce4be7710$export$7704680374d20c41,
                                        children: [
                                            /*#__PURE__*/ (0, $8jWPf.jsx)("h3", {
                                                class: $c32f774ce4be7710$export$b9508c5e7965e0a,
                                                children: category
                                            }),
                                            /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                                                class: $c32f774ce4be7710$export$89b6e287e113fda2,
                                                children: categoryProducts.map((product)=>/*#__PURE__*/ (0, $8jWPf.jsx)((0, $15d55a3a05681783$export$eb3ef33bb691e32f), {
                                                        transaction: transactions[product.id],
                                                        product: product,
                                                        onUpdate: handleUpdateTransactions
                                                    }, product.id))
                                            })
                                        ]
                                    }, category))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("section", {
                        "aria-label": "Route",
                        "data-slot": "route",
                        children: /*#__PURE__*/ (0, $8jWPf.jsx)($4ac8a87582efc7ba$var$DispatchRouteMemo, {
                            sourceId: sourceId,
                            setSourceId: setSourceId,
                            targetId: targetId,
                            setTargetId: setTargetId,
                            storage: storage,
                            bars: bars
                        })
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("section", {
                        "aria-label": "Abschlie\xdfen",
                        class: $c32f774ce4be7710$export$e06a4d010de1aa71,
                        children: [
                            (showComment || isBigScreen) && /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                style: {
                                    alignSelf: 'stretch'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("label", {
                                        htmlFor: "comment",
                                        children: "Kommentar"
                                    }),
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("textarea", {
                                        name: "comment",
                                        rows: 3,
                                        style: {
                                            width: '100%'
                                        },
                                        value: comment,
                                        onChange: (event)=>setComment(event.currentTarget.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                                class: $c32f774ce4be7710$export$f25deb47ca6d0fa1,
                                children: [
                                    !isBigScreen && /*#__PURE__*/ (0, $8jWPf.jsx)((0, $2lFhQ.TextButton), {
                                        onClick: ()=>setShowComment(!showComment),
                                        children: showComment ? 'Kommentar ausblenden' : 'Kommentar einblenden'
                                    }),
                                    /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                                        type: "button",
                                        class: "pure-button",
                                        disabled: isSubmitting,
                                        onClick: ()=>{
                                            resetFormState();
                                        },
                                        children: "Zur\xfccksetzen"
                                    }),
                                    /*#__PURE__*/ (0, $8jWPf.jsx)($4ac8a87582efc7ba$var$SubmitButton, {
                                        disabled: !isValid || isSubmitting,
                                        itemsCount: Object.keys(transactions).length
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



function $b77c05d3f95c1bf4$var$DispatchButton() {
    const [isOpen, setIsOpen] = (0, $kLOUX.useState)(false);
    const initialFocus = (0, $kLOUX.useRef)(null);
    const [isTabletMode, setIsTabletMode] = (0, $35afd694885b3f19$export$cd4068abab690d87)('enable-touch-dispatch-form');
    return /*#__PURE__*/ (0, $8jWPf.jsxs)((0, $bRFDG.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                type: "button",
                className: "pure-button pure-button-primary btn-round dispatch",
                onClick: ()=>setIsOpen(true),
                children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                    className: "ion-paper-airplane"
                })
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)((0, $348Te.Modal), {
                isOpen: isOpen,
                onClose: ()=>setIsOpen(false),
                initialFocus: !(0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).isMobile ? initialFocus : undefined,
                children: isTabletMode ? /*#__PURE__*/ (0, $8jWPf.jsx)((0, $348Te.ModalPanel), {
                    className: $c32f774ce4be7710$export$1a5522229f119385,
                    children: /*#__PURE__*/ (0, $8jWPf.jsx)((0, $4ac8a87582efc7ba$export$14ce3106fdf9d377), {
                        onClose: ()=>setIsOpen(false),
                        isTabletMode: isTabletMode,
                        setIsTabletMode: setIsTabletMode
                    })
                }) : /*#__PURE__*/ (0, $8jWPf.jsx)((0, $348Te.ModalPanel), {
                    children: /*#__PURE__*/ (0, $8jWPf.jsx)((0, $6b311541957ec9d8$export$981028df8fa8a579), {
                        onClose: ()=>setIsOpen(false),
                        initialFocus: initialFocus,
                        isTabletMode: isTabletMode,
                        setIsTabletMode: setIsTabletMode
                    })
                })
            })
        ]
    });
}
const $b77c05d3f95c1bf4$export$a878aa2bffbff9b4 = (0, $1JrMM.PreactView).extend({
    component: $b77c05d3f95c1bf4$var$DispatchButton
});


var $97aa60f1d12b888a$require$DispatchButtonView = $b77c05d3f95c1bf4$export$a878aa2bffbff9b4;

var $8jWPf = parcelRequire("8jWPf");

var $4UX9c = parcelRequire("4UX9c");

var $kLOUX = parcelRequire("kLOUX");

var $1JrMM = parcelRequire("1JrMM");
const $e76a5774624d040b$export$dea1c06bc507e99a = (0, $1JrMM.PreactView).extend({
    component: $e76a5774624d040b$var$TaskboardCheckbox
});
function $e76a5774624d040b$var$TaskboardCheckbox() {
    const [checked, setShowTaskboard] = (0, $kLOUX.useState)((0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).view.showTaskboard);
    (0, $kLOUX.useEffect)(()=>{
        function onShowTaskboardChange(view, showTaskboard) {
            setShowTaskboard(showTaskboard);
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).view.on('change:showTaskboard', onShowTaskboardChange, this);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).view.off('change:showTaskboard', onShowTaskboardChange);
        };
    }, []);
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("label", {
        class: "taskboard-toggle",
        children: [
            /*#__PURE__*/ (0, $8jWPf.jsx)("input", {
                type: "checkbox",
                name: "toggle-taskboard",
                checked: checked,
                onChange: (event)=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($4UX9c))).view.toggleTaskboard(event);
                }
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)("div", {
                children: "Taskboard"
            })
        ]
    });
}


var $97aa60f1d12b888a$require$TaskboardCheckboxView = $e76a5774624d040b$export$dea1c06bc507e99a;

$97aa60f1d12b888a$exports = $dM6Pc.extend({
    template: (parcelRequire("7PP8M")).default,
    subviews: {
        dispatchButton: {
            hook: 'dispatch-button-placeholder',
            prepareView (el) {
                return new $97aa60f1d12b888a$require$DispatchButtonView({
                    el: el
                });
            }
        },
        taskboardToggle: {
            hook: 'taskboard-toggle',
            prepareView (el) {
                return new $97aa60f1d12b888a$require$TaskboardCheckboxView({
                    el: el
                });
            }
        }
    },
    bindings: {
        // toggle nav-buttons based on currentEventId
        'model.currentEventId': {
            selector: 'a.toggleable',
            type: 'booleanAttribute',
            no: 'disabled'
        }
    },
    initialize () {
        this.listenTo($4UX9c.changes, 'change:online', this.onConnectionChange);
    },
    onConnectionChange (changes, isOnline) {
        this.queryByHook('sync-indicator').classList.toggle('ok', isOnline);
    },
    remove () {
        if (this.tooltips) for (const tip of this.tooltips)tip.destroy();
        return $dM6Pc.prototype.remove.call(this);
    },
    render () {
        this.renderWithTemplate(this);
        if (!$4UX9c.isMobile) this.tooltips = $97aa60f1d12b888a$require$tippy(this.queryAll('a[data-title]'), {
            placement: 'right'
        });
        return this;
    }
});



var $8jWPf = parcelRequire("8jWPf");

var $56rtr = parcelRequire("56rtr");

var $bRFDG = parcelRequire("bRFDG");

var $kLOUX = parcelRequire("kLOUX");

var $h6tPy = parcelRequire("h6tPy");

var $348Te = parcelRequire("348Te");

var $1JrMM = parcelRequire("1JrMM");





const $8af62c69d7ffa439$export$fb6bf807f167b5e8 = (0, $1JrMM.PreactView).extend({
    component: $8af62c69d7ffa439$export$bbbff42299d2551d
});
/** @param {import('../types').Transaction} tx */ const $8af62c69d7ffa439$var$onlyBarOrders = (tx)=>tx.user.currentEventSettings.role === 'bar';
/** @param {import('../types').Transaction} tx */ const $8af62c69d7ffa439$var$otherOrders = (tx)=>tx.user.currentEventSettings.role !== 'bar';
/** @param {import('../types').Transaction} tx */ const $8af62c69d7ffa439$var$getGroupKey = (tx)=>`${tx.createdAt}_${tx.sourceId}_${tx.targetId}`;
function $8af62c69d7ffa439$export$bbbff42299d2551d({ onClose: onClose }) {
    const eventSlug = (0, $h6tPy.useCurrentEventSlug)();
    const role = (0, $h6tPy.useCurrentRole)();
    const { data: transactions, mutate: mutate, error: error } = (0, $h6tPy.useTransactions)();
    const barOrders = transactions?.data.filter($8af62c69d7ffa439$var$onlyBarOrders);
    const barOrdersGroups = Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($56rtr)))(barOrders, $8af62c69d7ffa439$var$getGroupKey));
    const otherTransactions = transactions?.data.filter($8af62c69d7ffa439$var$otherOrders);
    const otherTransactionsGroups = Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($56rtr)))(otherTransactions, $8af62c69d7ffa439$var$getGroupKey));
    const [editTransaction, setEditTransaction] = (0, $kLOUX.useState)(/** @type {import('../types').Transaction | null} */ null);
    const [showEditTransactionModal, setShowEditTransactionModal] = (0, $kLOUX.useState)(false);
    const [rerender, setRerender] = (0, $kLOUX.useState)(0);
    // update the relative dispatch time every 10s
    (0, $kLOUX.useEffect)(()=>{
        const id = setTimeout(()=>{
            setRerender(rerender + 1);
        }, 10000);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        rerender
    ]);
    /**
   * @param {string} id
   * @param {{
   *   state?: import('../types').Transaction['state']
   *   comment?: string
   * }} payload
   */ async function saveTransaction(id, payload) {
        // remove completed transactions immediately
        if (payload.state === 'complete' && transactions) await mutate({
            ...transactions,
            data: transactions.data.filter((tx)=>tx.id !== id)
        }, {
            revalidate: false
        });
        await (0, $h6tPy.api)(`/api/events/${eventSlug}/transactions/${id}`, {
            method: 'PUT',
            body: payload
        });
        await mutate();
    }
    async function deleteTransaction(id) {
        if (transactions) await mutate({
            ...transactions,
            data: transactions.data.filter((tx)=>tx.id !== id)
        }, {
            revalidate: false
        });
        await (0, $h6tPy.api)(`/api/events/${eventSlug}/transactions/${id}`, {
            method: 'DELETE'
        });
        await mutate();
    }
    /**
   * @param {string} id
   * @param {Pick<
   *   import('../types').Transaction,
   *   'units' | 'sourceId' | 'comment'
   * >} payload
   */ async function handleEditTransaction(id, payload) {
        await (0, $h6tPy.api)(`/api/events/${eventSlug}/transactions/${id}`, {
            method: 'PUT',
            body: payload
        });
        await mutate();
    }
    /** @param {import('../types').Transaction} transaction */ function handleShowEditModal(transaction) {
        setEditTransaction(transaction);
        setShowEditTransactionModal(true);
    }
    return /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
        class: onClose ? $ebb13d168008f0a3$export$c11f3c07d391dfe5 : $ebb13d168008f0a3$export$73cd5f74c7c77f88,
        children: [
            onClose && /*#__PURE__*/ (0, $8jWPf.jsx)("button", {
                type: "button",
                class: $ebb13d168008f0a3$export$efe229eab43a9869,
                "data-title": "Taskboard ausblenden",
                onClick: onClose,
                children: /*#__PURE__*/ (0, $8jWPf.jsx)("i", {
                    class: "ion-close-round"
                })
            }),
            error && !transactions && /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $ebb13d168008f0a3$export$a3bc9b8ed74fc,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsxs)("p", {
                        children: [
                            "Error: ",
                            error.message
                        ]
                    }),
                    !navigator.onLine && /*#__PURE__*/ (0, $8jWPf.jsx)("p", {
                        children: "Bist du mit dem Internet verbunden?"
                    })
                ]
            }),
            transactions && transactions.data.length === 0 && /*#__PURE__*/ (0, $8jWPf.jsx)("p", {
                class: $ebb13d168008f0a3$export$62bd5d1d7d32b664,
                children: "Keine offenen Auftr\xe4ge."
            }),
            barOrders && barOrders.length > 0 && /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $ebb13d168008f0a3$export$a56bbfb78cb41005,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("h3", {
                        children: role === 'bar' ? 'Deine Bestellungen' : 'Barbestellungen'
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("ul", {
                        children: barOrdersGroups.map(([key, transactions])=>/*#__PURE__*/ (0, $8jWPf.jsx)((0, $bRFDG.Fragment), {
                                children: transactions.length > 1 ? /*#__PURE__*/ (0, $8jWPf.jsxs)((0, $16cd4acad36b1058$export$8d4517d05ebcf91), {
                                    transactions: transactions,
                                    children: [
                                        /*#__PURE__*/ (0, $8jWPf.jsx)("ul", {
                                            children: transactions.map((transaction)=>/*#__PURE__*/ (0, $8jWPf.jsx)((0, $4d1423625edcd5bf$export$27ce468e7e307749), {
                                                    transaction: transaction,
                                                    isGrouped: true,
                                                    onUpdateTransaction: saveTransaction,
                                                    onDeleteTransaction: deleteTransaction,
                                                    onEditTransaction: handleShowEditModal,
                                                    role: role
                                                }, transaction.id))
                                        }),
                                        transactions && transactions.length > 1 && /*#__PURE__*/ (0, $8jWPf.jsx)((0, $f9b177f3ae6803eb$export$a433c96e5af4a640), {
                                            ids: transactions.map((transaction)=>transaction.id),
                                            onRevalidate: mutate
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $8jWPf.jsx)((0, $4d1423625edcd5bf$export$27ce468e7e307749), {
                                    transaction: transactions[0],
                                    onUpdateTransaction: saveTransaction,
                                    onDeleteTransaction: deleteTransaction,
                                    onEditTransaction: handleShowEditModal,
                                    role: role
                                })
                            }, key))
                    })
                ]
            }),
            otherTransactions && otherTransactions.length > 0 && /*#__PURE__*/ (0, $8jWPf.jsxs)("div", {
                class: $ebb13d168008f0a3$export$a56bbfb78cb41005,
                children: [
                    /*#__PURE__*/ (0, $8jWPf.jsx)("h3", {
                        children: "Andere Auftr\xe4ge"
                    }),
                    /*#__PURE__*/ (0, $8jWPf.jsx)("ul", {
                        children: otherTransactionsGroups.map(([key, transactions])=>/*#__PURE__*/ (0, $8jWPf.jsx)((0, $bRFDG.Fragment), {
                                children: transactions.length > 1 ? /*#__PURE__*/ (0, $8jWPf.jsxs)((0, $16cd4acad36b1058$export$8d4517d05ebcf91), {
                                    transactions: transactions,
                                    children: [
                                        /*#__PURE__*/ (0, $8jWPf.jsx)("ul", {
                                            children: transactions.map((transaction)=>/*#__PURE__*/ (0, $8jWPf.jsx)((0, $4d1423625edcd5bf$export$27ce468e7e307749), {
                                                    transaction: transaction,
                                                    isGrouped: true,
                                                    onUpdateTransaction: saveTransaction,
                                                    onDeleteTransaction: deleteTransaction,
                                                    onEditTransaction: handleShowEditModal,
                                                    role: role
                                                }, transaction.id))
                                        }),
                                        transactions && transactions.length > 1 && /*#__PURE__*/ (0, $8jWPf.jsx)((0, $f9b177f3ae6803eb$export$a433c96e5af4a640), {
                                            show: [
                                                'complete'
                                            ],
                                            ids: transactions.map((transaction)=>transaction.id),
                                            onRevalidate: mutate
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $8jWPf.jsx)((0, $4d1423625edcd5bf$export$27ce468e7e307749), {
                                    transaction: transactions[0],
                                    onUpdateTransaction: saveTransaction,
                                    onDeleteTransaction: deleteTransaction,
                                    onEditTransaction: handleShowEditModal,
                                    role: role
                                })
                            }, key))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8jWPf.jsx)((0, $348Te.Modal), {
                isOpen: showEditTransactionModal,
                onClose: ()=>setShowEditTransactionModal(false),
                children: editTransaction && /*#__PURE__*/ (0, $8jWPf.jsxs)((0, $348Te.ModalPanel), {
                    children: [
                        /*#__PURE__*/ (0, $8jWPf.jsx)((0, $348Te.ModalCloseButton), {
                            onClick: ()=>setShowEditTransactionModal(false)
                        }),
                        /*#__PURE__*/ (0, $8jWPf.jsx)((0, $5c275ac03fe3fd59$export$d2cf0f611fc63100), {
                            transaction: editTransaction,
                            onEditTransaction: handleEditTransaction,
                            onClose: ()=>setShowEditTransactionModal(false)
                        })
                    ]
                })
            })
        ]
    });
}


var $9863202fb86dd559$require$TaskboardView = $8af62c69d7ffa439$export$fb6bf807f167b5e8;
const $9863202fb86dd559$var$mq = window.matchMedia('(min-width: 1025px)');

$9863202fb86dd559$exports = $dM6Pc.extend({
    template: (parcelRequire("iQ95b")).default,
    events: {
        'click a[href]': 'handleLinkClick'
    },
    props: {
        isTaskboardEnabled: [
            'boolean',
            true,
            $9863202fb86dd559$var$mq.matches
        ],
        canRenderTaskboardSidebar: [
            'boolean',
            true,
            $9863202fb86dd559$var$mq.matches
        ]
    },
    derived: {
        showTaskboard: {
            deps: [
                'isTaskboardEnabled',
                'canRenderTaskboardSidebar'
            ],
            fn () {
                return this.isTaskboardEnabled && this.canRenderTaskboardSidebar;
            }
        }
    },
    bindings: {
        showTaskboard: {
            type: 'booleanClass',
            yes: '',
            no: 'transit-bar-hidden'
        }
    },
    subviews: {
        sidebar: {
            hook: 'sidebar',
            prepareView (el) {
                return new $97aa60f1d12b888a$exports({
                    el: el,
                    model: $4UX9c.me
                });
            }
        },
        transitBar: {
            hook: 'transit-bar',
            waitFor: 'showTaskboard',
            prepareView (el) {
                return new $9863202fb86dd559$require$TaskboardView({
                    el: el,
                    props: {
                        onClose: this.toggleTaskboard.bind(this)
                    }
                });
            }
        }
    },
    initialize () {
        this.listenTo($4UX9c.router, 'page', this.handleNewPage);
        this.listenTo($4UX9c.me, 'change:currentEventId', this.setTitle);
        this.listenTo($4UX9c.me, 'change:currentEvent.name', this.setTitle);
        this.on('change:showTaskboard', this.toggleTaskboardView, this);
        $9863202fb86dd559$var$mq.addEventListener('change', this.onScreenSizeChange.bind(this));
    },
    /**
   * @param {MediaQueryListEvent} event
   */ onScreenSizeChange (event) {
        this.canRenderTaskboardSidebar = event.matches;
    },
    toggleTaskboard (evt) {
        evt.preventDefault();
        this.toggle('isTaskboardEnabled');
    },
    toggleTaskboardView (view, showTaskboard) {
        if (!showTaskboard) {
            if (this.transitBar) {
                this.transitBar.remove();
                this.transitBar = undefined;
            }
        } else if (!this.transitBar) {
            this.transitBar = this.registerSubview(new $9863202fb86dd559$require$TaskboardView({
                props: {
                    onClose: this.toggleTaskboard.bind(this)
                }
            }));
            this.el.appendChild(this.transitBar.render().el);
        }
    },
    handleLinkClick (e) {
        // This module determines whether a click event is
        // a local click (making sure the for modifier keys, etc)
        // and dealing with browser quirks to determine if this
        // event was from clicking an internal link. That we should
        // treat like local navigation.
        const localPath = $6beb558f93ddfdf2$exports.pathname(e);
        if (localPath) {
            e.preventDefault();
            $4UX9c.navigate(localPath);
        }
    },
    handleNewPage (view) {
        // tell the view switcher to render the new one
        this.pageSwitcher.set(view);
        // mark the correct nav item selected
        this.updateActiveNav();
    },
    updateActiveNav () {
        const path = window.location.pathname.slice(1);
        for (const aTag of this.queryAll('.sidebar a[href]')){
            const aPath = aTag.pathname.slice(1);
            if (!aPath && !path || aPath && path.indexOf(aPath) === 0) aTag.classList.add('active');
            else aTag.classList.remove('active');
        }
    },
    setTitle (view) {
        const newView = view.title ? view : $4UX9c.currentPage;
        const eventName = $4UX9c.me.currentEvent?.name;
        document.title = `${$a0MTb(newView, 'title')} \xb7 ${eventName} \xb7 BoozeBoy` || 'BoozeBoy';
    },
    render () {
        const self = this;
        // some additional stuff we want to add to the document head
        document.title = 'BoozeBoy';
        // main renderer
        this.renderWithTemplate();
        // add class indicating user role
        this.el.classList.add($4UX9c.me.role);
        // init and configure our page switcher
        this.pageSwitcher = new $f56df7df86436f25$exports({
            el: this.query('main'),
            show (newView) {
                // it's inserted and rendered for me
                self.setTitle(newView);
                document.scrollingElement.scrollTop = 0;
                // add a class specifying it's active
                newView.el.classList.add('active');
                // force setting of location hash to trigger scrolling
                window.requestAnimationFrame(()=>{
                    const hash = window.location.hash;
                    if (!hash) return;
                    document.scrollingElement.scrollTo({
                        top: newView.query(hash).offsetTop,
                        behavior: 'smooth'
                    });
                });
                // don't keep a reference of the previous page around
                // should help reduce memory usage
                self.pageSwitcher.previous = null;
                $4UX9c.currentPage = newView;
            }
        });
        return this;
    }
});


var $af661292b0be9da9$exports = {};

var $dM6Pc = parcelRequire("dM6Pc");

var $af661292b0be9da9$require$tippy = $6445619a88c9e457$export$2e2bcd8739ae039;

var $af661292b0be9da9$require$onAnimationEnd = $b4b9092253857fb9$exports.onAnimationEnd;
const $af661292b0be9da9$var$Form = $dM6Pc.extend({
    events: {
        'keyup input': 'onKeyup',
        'submit form': 'submit'
    },
    props: {
        username: [
            'string',
            true,
            ''
        ],
        password: [
            'string',
            true,
            ''
        ]
    },
    derived: {
        isUsernameValid: {
            deps: [
                'username'
            ],
            fn () {
                const isLowerCase = this.username.toLowerCase() === this.username;
                const hasSpaces = this.username.search(/\s+/g) > -1;
                return isLowerCase && !hasSpaces;
            }
        },
        isPasswordValid: {
            deps: [
                'password'
            ],
            fn () {
                return !!this.password;
            }
        },
        isValid: {
            deps: [
                'isUsernameValid',
                'isPasswordValid'
            ],
            fn () {
                return this.isUsernameValid && this.isPasswordValid;
            }
        }
    },
    initialize () {
        this.listenTo(this, 'change:isValid', this.onValidation);
        this.listenTo(this, 'change:isUsernameValid', this.onUsernameValidation);
    },
    onValidation () {
        this.query('button').disabled = !this.isValid;
    },
    onUsernameValidation (view, isUsernameValid) {
        if (!isUsernameValid) {
            this.tip = $af661292b0be9da9$require$tippy(this.usernameEl, {
                trigger: 'manual',
                content: "Dein Benutzername sollte keine Gro\xdfbuchstaben und keine Leerzeichen enthalten."
            });
            this.tip.show();
        } else if (this.tip) this.tip.destroy();
    },
    onKeyup (e) {
        this[e.target.name] = e.target.value;
    },
    onError () {
        this.query('.error').textContent = 'Da hat was nicht geklappt...';
    },
    render () {
        this.renderWithTemplate();
        this.cacheElements({
            usernameEl: this.queryByHook('username'),
            passwordEl: this.queryByHook('password')
        });
        return this;
    }
});

const $af661292b0be9da9$var$LoginForm = $af661292b0be9da9$var$Form.extend({
    template: (parcelRequire("1ghuY")).default,
    submit (e) {
        e.preventDefault();
        this.model.login(this.username, this.password);
    }
});

const $af661292b0be9da9$var$SignUpForm = $af661292b0be9da9$var$Form.extend({
    template: (parcelRequire("adc34")).default,
    submit (e) {
        e.preventDefault();
        this.model.signup(this.username, this.password);
    }
});

/*
  Auth Page View
 */ $af661292b0be9da9$exports = $dM6Pc.extend({
    template: (parcelRequire("6F4FQ")).default,
    events: {
        'click [data-hook=flip]': 'flip'
    },
    subviews: {
        login: {
            container: '[data-hook=login-form]',
            prepareView (el) {
                return new $af661292b0be9da9$var$LoginForm({
                    el: el,
                    model: this.model
                });
            }
        },
        signup: {
            container: '[data-hook=signup-form]',
            prepareView (el) {
                return new $af661292b0be9da9$var$SignUpForm({
                    el: el,
                    model: this.model
                });
            }
        }
    },
    initialize () {
        this.listenTo(this.model, 'sync', this.hide);
        // delay listening so we don't shake on initial error
        setTimeout(()=>{
            this.listenTo(this.model, 'error', this.onError);
        }, 0);
    },
    onError () {
        const el = this.query('.auth-wrap');
        $af661292b0be9da9$require$onAnimationEnd(el, ()=>el.classList.remove('shake'));
        el.classList.add('shake');
    },
    hide () {
        const container = this.query('.auth-container');
        $af661292b0be9da9$require$onAnimationEnd(container, ()=>this.remove());
        this.el.classList.add('fadeOut');
        container.classList.add('slideOutUp');
    },
    flip (e) {
        e.preventDefault();
        this.el.classList.toggle('flipped');
    }
});



var $gvQO6 = parcelRequire("gvQO6");
var $adb0503b084cff6f$require$logger = $gvQO6.logger;
// Set default tippy props for convenience. We take the tooltip content from the `data-title` attribute
$adb0503b084cff6f$require$tippy.setDefaultProps({
    delay: [
        500,
        null
    ],
    placement: 'bottom',
    content: (el)=>el.dataset.title
});
const $adb0503b084cff6f$var$log = $adb0503b084cff6f$require$logger.extend('init');
$4UX9c.extend({
    isMobile: $adb0503b084cff6f$require$isMobile({
        tablet: true,
        featureDetect: true
    }),
    init () {
        this._start = Date.now();
        this.router = new $215b1ea15fcc90c0$exports();
        $adb0503b084cff6f$var$log(`detected mobile device: ${$4UX9c.isMobile}`);
        this.me = new $ffa163ac75b4b6aa$exports();
        this.me.once('sync', this.bootstrap, this);
        this.me.once('error', this.onError, this);
        this.me.fetch();
    },
    onError () {
        if (this.view) this.view.remove();
        this.clear();
        this.authPage = new $af661292b0be9da9$exports({
            model: this.me
        });
        document.body.appendChild(this.authPage.render().el);
    },
    bootstrap () {
        $adb0503b084cff6f$var$log('fetched user');
        this.changes = new $94bf63d05476b712$exports({
            eventId: $4UX9c.me.currentEventId
        });
        this.products = new $36dc365827ae47b5$exports();
        this.locations = new $74281df9c41952b9$exports();
        // proxy event switch to changes-feed
        this.me.on('change:currentEventId', function(me, currentEventId) {
            this.changes.eventId = currentEventId;
            this.fetch();
        }, this);
        // clear localstorage if we don't have a current event assigned
        // because maybe it was revoked by the server
        if (!this.me.currentEventId) this.clear();
        // ensure we have everything up front
        if (this.me.currentEventId && (!this.products.length || !this.locations.length)) this.fetch(()=>this.render());
        else {
            $adb0503b084cff6f$var$log('had cached locations');
            this.render();
        }
    },
    // fetch products first, then locations, because location's stock depends on products
    fetch (done = ()=>{}) {
        this.products.once('sync', ()=>this.locations.fetch(), this);
        this.locations.once('sync', ()=>{
            // emit app-wide "sync" event, so we know when it's save to re-render etc
            this.trigger('sync');
            done();
        }, this);
        this.products.fetch();
        $adb0503b084cff6f$var$log('fetching products and locations');
    },
    render () {
        // render AppView
        this.view = new $9863202fb86dd559$exports();
        document.body.appendChild(this.view.render().el);
        $adb0503b084cff6f$var$log('rendered app view');
        $adb0503b084cff6f$var$log(`start up time ${Date.now() - this._start}ms`);
        // start router
        this.router.history.start();
        // init and start changes feed listener
        this.changes.start();
    },
    navigate (page) {
        const url = page.charAt(0) === '/' ? page.slice(1) : page;
        this.router.navigate(url, {
            trigger: true
        });
    },
    clear () {
        for (const key of Object.keys(window.localStorage))if (key !== 'debug') window.localStorage.removeItem(key);
    }
});
$4UX9c.init();
// const ENABLE_SERVICE_WORKER = process.env.NODE_ENV === 'production'
const $adb0503b084cff6f$var$ENABLE_SERVICE_WORKER = false;
// if (ENABLE_SERVICE_WORKER) {
//   if ('serviceWorker' in navigator) {
//     // Use the window load event to keep the page load performant
//     window.addEventListener('load', () => {
//       navigator.serviceWorker
//         .register(new URL('service-worker.js', import.meta.url), {
//           type: 'module'
//         })
//         .then(() => log('registered service worker'))
//     })
//   }
// }
/**
 * Clean up service workers if ever needed
 * Also: https://developer.chrome.com/docs/workbox/remove-buggy-service-workers/
 */ if (!$adb0503b084cff6f$var$ENABLE_SERVICE_WORKER) {
    if ('serviceWorker' in navigator) navigator.serviceWorker.getRegistrations().then((registrations)=>{
        for (const registration of registrations)registration.unregister().then(()=>$adb0503b084cff6f$var$log('unregistered service worker'));
    });
}


//# sourceMappingURL=booze-boy-client.9feb3b2b.js.map
